import * as React from 'react';
import React__default, { useRef, useState, useEffect, useCallback, Fragment, useMemo, useLayoutEffect, forwardRef, useContext, memo, createContext, createElement, Component, cloneElement, Children, isValidElement, PureComponent, createRef } from 'react';
import PropTypes from 'prop-types';
import styled, { css, keyframes, ThemeProvider as ThemeProvider$1 } from 'styled-components';
import { jsxs, jsx, Fragment as Fragment$1 } from 'react/jsx-runtime';
import * as ReactDOM from 'react-dom';
import ReactDOM__default, { unstable_batchedUpdates, createPortal } from 'react-dom';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject$Z;
var StyledActionText = styled.button(_templateObject$Z || (_templateObject$Z = _taggedTemplateLiteral(["\n  background: transparent;\n  border-radius: none;\n  border: none;\n  color: ", ";\n  cursor: pointer;\n  font-size: 1em;\n  margin: 0;\n  outline: none;\n  padding: 0;\n  position: relative;\n\n  &:active {\n    color: ", ";\n  }\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  &:focus{\n    text-decoration: underline;\n  }\n  \n  &:disabled {\n    color: ", ";\n    cursor: not-allowed;\n    pointer-events: none;\n  }\n"])), function (_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'primary' : _ref$color,
    theme = _ref.theme;
  return theme.palette[color].main;
}, function (_ref2) {
  var _ref2$color = _ref2.color,
    color = _ref2$color === void 0 ? 'primary' : _ref2$color,
    theme = _ref2.theme;
  return theme.palette[color].darker;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.disabled.contrast;
});

var AVAILABLE_COLORS$3 = ['primary', 'info', 'warning', 'danger'];
var ActionText = function ActionText(props) {
  var children = props.children,
    className = props.className,
    color = props.color,
    disabled = props.disabled,
    id = props.id,
    name = props.name,
    onClick = props.onClick,
    type = props.type;
  return /*#__PURE__*/React__default.createElement(StyledActionText, {
    className: className,
    color: color,
    disabled: disabled,
    id: id,
    name: name,
    onClick: onClick,
    type: type
  }, children);
};
ActionText.propTypes = {
  /**
  * This is the content to be displayed inside actionText
  */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
  /**
   * Override or extend the styles applied to the component
   */
  className: PropTypes.string,
  /**
   * The color of the component is a method of communicating severity level information to users.
   */
  color: PropTypes.oneOf(AVAILABLE_COLORS$3),
  /**
  * Apply styles to the actionText to display it as unusable and unclickable
  */
  disabled: PropTypes.bool,
  /**
   * Id assigned to ActionText.
   */
  id: PropTypes.string,
  /**
   * Name of ActionText
   */
  name: PropTypes.string,
  /**
   * Function to execute when the actionText was clicked
   */
  onClick: PropTypes.func,
  /**
   * Define type of actionText
  */
  type: PropTypes.oneOf(['submit', 'button'])
};
ActionText.defaultProps = {
  id: '',
  className: '',
  color: 'primary',
  disabled: false,
  name: '',
  onClick: undefined,
  type: 'button'
};

var colors$4 = {
  turquoise: '#13CFC0',
  turquoiseLight: '#63E1DB',
  turquoiseDark: '#04ADA5',
  pink: '#F99B9B',
  pinkLight: '#FBDCDC',
  pinkDark: '#DC5151',
  blue: '#0178DD',
  blueLight: '#9AC9F1',
  blueDark: '#00569F',
  green: '#E7FBFA',
  greenLight: '#F1FBFA',
  greenDark: '#E2EAE9',
  blueLink: '#138DCF',
  blueLinkLight: '#A5D9EA',
  white: '#FFFFFF',
  grayA: '#F8F8F8',
  grayB: '#F3F3F3',
  grayC: '#CBCBCB',
  grayD: '#A6A6A6',
  grayE: '#7E7C7C',
  grayF: '#3E3E3E',
  blueGray: '#21282D',
  red: '#A1062C',
  redLight: '#FFF2F3',
  redDark: '#820605',
  ambar: '#F5A623'
};

var theme$2 = {
  palette: {
    primary: {
      main: colors$4.turquoise,
      light: colors$4.turquoiseLight,
      dark: colors$4.turquoiseDark,
      contrastText: colors$4.white
    },
    secondary: {
      main: colors$4.turquoise,
      light: colors$4.turquoiseLight,
      dark: colors$4.turquoiseDark,
      contrastText: colors$4.white
    },
    info: {
      main: colors$4.turquoise,
      light: colors$4.turquoiseLight,
      dark: colors$4.turquoiseDark,
      contrastText: colors$4.white
    },
    warning: {
      main: colors$4.turquoise,
      light: colors$4.turquoiseLight,
      dark: colors$4.turquoiseDark,
      contrastText: colors$4.white
    },
    danger: {
      main: colors$4.turquoise,
      light: colors$4.turquoiseLight,
      dark: colors$4.turquoiseDark,
      contrastText: colors$4.white
    },
    background: {
      hbBackgroundA: colors$4.white,
      hbBackgroundB: colors$4.grayA,
      modal: colors$4.blueGray,
      none: 'transparent'
    },
    disabled: {
      button: {
        background: colors$4.grayC,
        text: colors$4.white,
        border: 'none'
      },
      input: {
        background: colors$4.grayB,
        text: colors$4.grayC,
        border: colors$4.blue
      },
      background: colors$4.grayB,
      text: colors$4.grayF,
      border: colors$4.grayC
    }
  }
};

var fonts = {
  roboto: {
    fontFamily: 'Roboto, arial, sans-serif',
    fontWeight: 400,
    fontStyle: 'normal'
  },
  robotoItalic: {
    fontFamily: 'RobotoItalic, arial, sans-serif',
    fontWeight: 400,
    fontStyle: 'italic'
  },
  robotoMedium: {
    fontFamily: 'RobotoMedium, arial, sans-serif',
    fontWeight: 500,
    fontStyle: 'normal'
  },
  robotoMediumItalic: {
    fontFamily: 'RobotoMediumItalic, arial, sans-serif',
    fontWeight: 500,
    fontStyle: 'italic'
  },
  robotoBold: {
    fontFamily: 'RobotoBold, arial, sans-serif',
    fontWeight: 700,
    fontStyle: 'normal'
  },
  robotoBoldItalic: {
    fontFamily: 'RobotoBoldItalic, arial, sans-serif',
    fontWeight: 700,
    fontStyle: 'italic'
  },
  robotoCondensed: {
    fontFamily: 'RobotoCondensed, arial, sans-serif',
    fontWeight: 400,
    fontStyle: 'normal'
  },
  robotoCondensedItalic: {
    fontFamily: 'RobotoCondensedItalic, arial, sans-serif',
    fontWeight: 400,
    fontStyle: 'italic'
  },
  robotoCondensedBold: {
    fontFamily: 'RobotoCondensedBold, arial, sans-serif',
    fontWeight: 700,
    fontStyle: 'normal'
  },
  robotoCondensedBoldItalic: {
    fontFamily: 'RobotoCondensedBoldItalic, arial, sans-serif',
    fontWeight: 700,
    fontStyle: 'italic'
  }
};

var colors$3 = {
  ambarDarker: '#CD8306',
  ambarDark: '#E59206',
  ambar: '#F5A623',
  ambarLight: '#FCB33B',
  ambarLighter: '#FFC15B',
  caribbeanDarker: '#0C9A56',
  caribbeanDark: '#22B76F',
  caribbean: '#36CC84',
  caribbeanLight: '#52DC9A',
  caribbeanLighter: '#74E4AF',
  coralPinkDarker: '#CE2E33',
  coralPinkDark: '#F03C43',
  coralPink: '#FF5A60',
  coralPinkLight: '#FE8084',
  coralPinkLighter: '#FC9699',
  white: '#FFFFFF',
  black: '#000000',
  greenyDarker: '#0E9C94',
  greenyDark: '#29B1A9',
  greeny: '#47CBC3',
  greenyLight: '#84E1DC',
  greenyLighter: '#A3F0EB',
  blueDarker: '#034D8C',
  blueDark: '#0267BD',
  blue: '#0178DD',
  blueLight: '#3CA4FC',
  blueLighter: '#77c1ff',
  blueLightest: '#CFE9FF',
  pinkDarker: '#F8A3A6',
  pinkDark: '#FFC4C4',
  pink: '#FFDADA',
  pinkLight: '#FEEAEA',
  pinkLighter: '#FFF9F9',
  blueLinkLighter: '#387CFB',
  blueLinkLight: '#1C64EB',
  blueLink: '#0751BF',
  blueLinkDark: '#071EBF',
  blueLinkDarker: '#062F95',
  redDarker: '#A00000',
  redDark: '#B40707',
  red: '#E90B0B',
  redLight: '#FB2B2B',
  redLighter: '#FF4F4F',
  jadeLighter: '#ECFFF6',
  jadeLight: '#D7F5E6',
  jade: '#B5EBD0',
  jadeDark: '#96DFBA',
  jadeDarker: '#75D2A3',
  crimsonLighter: '#E59B9B',
  crimsonLight: '#E47D7D',
  crimson: '#E06262',
  crimsonDark: '#BC5C5C',
  crimsonDarker: '#924A4C',
  grayA: '#F8F8F8',
  grayB: '#F3F3F3',
  grayC: '#EAEAEA',
  grayD: '#CBCBCB',
  grayE: '#BDBCBC',
  grayF: '#A6A6A6',
  grayG: '#747373',
  grayH: '#5C5C5C',
  grayI: '#3E3E3E',
  grayJ: '#21282D',
  green: '#74CC15'
};

var addLeadingZero = function addLeadingZero(value) {
  return "0".concat(value);
};

function _typeof$1(o) {
  "@babel/helpers - typeof";

  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof$1(o);
}

var removeDiacritics = function removeDiacritics(text) {
  var diacritics = [{
    "char": 'A',
    base: /[\300-\306]/g
  }, {
    "char": 'a',
    base: /[\340-\346]/g
  }, {
    "char": 'E',
    base: /[\310-\313]/g
  }, {
    "char": 'e',
    base: /[\350-\353]/g
  }, {
    "char": 'I',
    base: /[\314-\317]/g
  }, {
    "char": 'i',
    base: /[\354-\357]/g
  }, {
    "char": 'O',
    base: /[\322-\330]/g
  }, {
    "char": 'o',
    base: /[\362-\370]/g
  }, {
    "char": 'U',
    base: /[\331-\334]/g
  }, {
    "char": 'u',
    base: /[\371-\374]/g
  }, {
    "char": 'N',
    base: /[\321]/g
  }, {
    "char": 'n',
    base: /[\361]/g
  }, {
    "char": 'C',
    base: /[\307]/g
  }, {
    "char": 'c',
    base: /[\347]/g
  }];
  var textCleaned = text;
  diacritics.forEach(function (letter) {
    textCleaned = textCleaned.replace(letter.base, letter["char"]);
  });
  return textCleaned;
};

var regexMap = {
  onlyLettersAndNumbers: /[^A-Za-z0-9]+$/g
};

var cleanText = function cleanText(text) {
  return removeDiacritics(text.replace(regexMap.onlyLettersAndNumbers, '').toLowerCase().trim().normalize());
};

var formatOptions = function formatOptions(id, label) {
  return {
    id: id,
    label: label.toString()
  };
};

// eslint-disable-next-line max-len
var format$2 = function format(color) {
  return "".concat(parseInt(color[1], 16), ", ").concat(parseInt(color[2], 16), ", ").concat(parseInt(color[3], 16));
};
var getRgbColor = function getRgbColor(hexadecimalColor) {
  var color = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexadecimalColor);
  return color ? format$2(color) : null;
};

var range = function range(start, end) {
  if (start > end) {
    throw new Error('Start must be less than end');
  }
  return Array.from({
    length: end - start + 1
  }, function (_, index) {
    return start + index;
  });
};

var SIZING_UNIT_BASE = 16;
var toRem = function toRem(value) {
  var sizingUnit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SIZING_UNIT_BASE;
  return value / sizingUnit;
};

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

function _arrayLikeToArray$3(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

function _unsupportedIterableToArray$3(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$3(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$3(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray$3(arr, i) || _nonIterableRest();
}

var useControlled = function useControlled(_ref) {
  var controlled = _ref.controlled,
    defaultProp = _ref["default"],
    name = _ref.name,
    _ref$state = _ref.state,
    state = _ref$state === void 0 ? 'value' : _ref$state;
  var _useRef = useRef(controlled !== undefined),
    isControlled = _useRef.current;
  var _useState = useState(defaultProp),
    _useState2 = _slicedToArray(_useState, 2),
    valueState = _useState2[0],
    setValue = _useState2[1];
  var value = isControlled ? controlled : valueState;
  useEffect(function () {
    if (process.env.NODE_ENV !== 'production' && isControlled !== (controlled !== undefined)) {
      // eslint-disable-next-line no-console
      console.error(["A component is changing the ".concat(isControlled ? '' : 'un', "controlled ").concat(state, " state of ").concat(name, " to be ").concat(isControlled ? 'un' : '', "controlled."), 'Elements should not switch from uncontrolled to controlled (or vice versa).', "Decide between using a controlled or uncontrolled ".concat(name, " ") + 'element for the lifetime of the component.', 'The nature of the state is determined during the first render.', "It's considered controlled if the value is not `undefined`.", 'More info: https://fb.me/react-controlled-components'].join('\n'));
    }
  }, [state, name, controlled]);
  var _useRef2 = useRef(defaultProp),
    defaultValue = _useRef2.current;
  useEffect(function () {
    if (process.env.NODE_ENV !== 'production' && !isControlled && defaultValue !== defaultProp) {
      // eslint-disable-next-line no-console
      console.error(["A component is changing the default ".concat(state, "\n          state of an uncontrolled ").concat(name, " after being initialized. ") + "To suppress this warning opt to use a controlled ".concat(name, ".")].join('\n'));
    }
  }, [JSON.stringify(defaultProp)]);
  var setValueIfControlled = useCallback(function (newValue) {
    if (!isControlled) {
      setValue(newValue);
    }
  }, []);
  return [value, setValueIfControlled];
};

var withUnits = function withUnits(base) {
  return function (value) {
    if (value % 0.5 !== 0) {
      throw new Error('Spacing values should be in increments of 0.5');
    }
    return base * value;
  };
};

var borderRadius = function borderRadius(base) {
  var units = withUnits(base);
  return function () {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    return "".concat(toRem(units(value)), "rem");
  };
};

function toPrimitive(t, r) {
  if ("object" != _typeof$1(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof$1(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof$1(i) ? i : String(i);
}

function _defineProperty$1(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var _templateObject$Y;
var flexAsColumn = function flexAsColumn() {
  var gapSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return function (_ref) {
    var theme = _ref.theme;
    var gap = gapSize ? "gap: ".concat(theme.spacing(gapSize), ";") : null;
    return css(_templateObject$Y || (_templateObject$Y = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    ", "\n  "])), gap);
  };
};

var _templateObject$X;
var flexAsRow = function flexAsRow() {
  var gapSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return function (_ref) {
    var theme = _ref.theme;
    var gap = gapSize ? "gap: ".concat(theme.spacing(gapSize), ";") : '';
    return css(_templateObject$X || (_templateObject$X = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: row;\n    ", "\n  "])), gap);
  };
};

var _templateObject$W;
var focusShadow = function focusShadow(base, defaultColor) {
  return function (color) {
    return css(_templateObject$W || (_templateObject$W = _taggedTemplateLiteral(["\n    box-shadow: 0 0 0 ", "rem ", ";\n  "])), toRem(base), color || defaultColor);
  };
};

var _templateObject$V;
var focus = function focus(base, defaultBorderColor, defaultShadowColor) {
  var boxShadow = focusShadow(base, defaultShadowColor);
  return function (borderColor, shadowColor) {
    return css(_templateObject$V || (_templateObject$V = _taggedTemplateLiteral(["\n    ", ";\n\n    border: 1px solid ", ";\n    outline: 0;\n  "])), boxShadow(shadowColor), borderColor || defaultBorderColor);
  };
};

var _templateObject$U;
var font = function font(config) {
  return css(_templateObject$U || (_templateObject$U = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), config.color && "color: ".concat(config.color, ";"), config.fontFamily && "font-family: ".concat(config.fontFamily, ";"), config.fontSize && "font-size: ".concat(config.fontSize, ";"), config.fontStyle && "font-style: ".concat(config.fontStyle, ";"), config.fontWeight && "font-weight: ".concat(config.fontWeight, ";"), config.letterSpacing && "letter-spacing: ".concat(config.letterSpacing, ";"), config.lineHeight && "line-height: ".concat(config.lineHeight, ";"));
};

var _templateObject$T;
var grid = function grid() {
  var gapSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return function (_ref) {
    var theme = _ref.theme;
    var gap = gapSize ? "gap: ".concat(theme.spacing(gapSize), ";") : '';
    return css(_templateObject$T || (_templateObject$T = _taggedTemplateLiteral(["\n    display: grid;\n    ", "\n  "])), gap);
  };
};

function ownKeys$8(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$8(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$8(Object(t), !0).forEach(function (r) { _defineProperty$1(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$8(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var mergeFont = function mergeFont(base, overrides) {
  var properties = ['color', 'fontFamily', 'fontStyle', 'fontSize', 'fontWeight', 'letterSpacing', 'margin', 'marginTop', 'marginBottom'];
  var fontConf = Object.keys(overrides).filter(function (key) {
    return properties.includes(key);
  }).reduce(function (result, key) {
    // eslint-disable-next-line no-param-reassign
    result[key] = overrides[key];
    return result;
  }, {});
  return _objectSpread$8(_objectSpread$8({}, base), fontConf);
};
var withFont = function withFont() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var base = args.reduce(function (result, item) {
    return mergeFont(result, item);
  }, {});
  return function () {
    var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function () {
      return font(mergeFont(base, overrides));
    };
  };
};

var configureFocus = function configureFocus(config) {
  return focus(config.size, config.borderColor, config.shadowColor);
};
var form = function form(theme, config) {
  var result = theme.form;
  var font = withFont(theme.typography.font, config.font, theme.form);
  result.focus = configureFocus(config.form.focus);
  result.font = font();
  ['input', 'label', 'code', 'button', 'helper'].forEach(function (key) {
    if (!result[key]) {
      result[key] = {};
    }
    result[key].font = font(result[key]);
  });
  return result;
};

var spacing = function spacing(base) {
  var units = withUnits(base);
  return function () {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    return "".concat(toRem(units(value)), "rem");
  };
};

var DISABLED_MAIN_COLOR = colors$3.grayC;
var DISABLED_CONTRAST_COLOR = colors$3.grayG;
var theme$1 = {
  breakpoints: {
    small: 480,
    medium: 769,
    large: 1023,
    extraLarge: 1440
  },
  zIndex: {
    modal: 1000,
    dropdown: 1100,
    tooltip: 1200,
    toast: 1300
  },
  palette: {
    primary: {
      main: colors$3.coralPink,
      light: colors$3.coralPinkLight,
      lighter: colors$3.coralPinkLighter,
      dark: colors$3.coralPinkDark,
      darker: colors$3.coralPinkDarker,
      contrastText: colors$3.white,
      contrastTextDark: colors$3.white
    },
    secondary: {
      main: colors$3.pink,
      light: colors$3.pinkLight,
      lighter: colors$3.pinkLighter,
      dark: colors$3.pinkDark,
      darker: colors$3.pinkDarker,
      contrastText: colors$3.coralPink,
      contrastTextDark: colors$3.coralPink
    },
    info: {
      main: colors$3.blue,
      light: colors$3.blueLight,
      lighter: colors$3.blueLighter,
      lightest: colors$3.blueLightest,
      dark: colors$3.blueDark,
      darker: colors$3.blueDarker,
      contrastText: colors$3.white,
      contrastTextDark: colors$3.white
    },
    warning: {
      main: colors$3.ambar,
      light: colors$3.ambarLight,
      lighter: colors$3.ambarLighter,
      dark: colors$3.ambarDark,
      darker: colors$3.ambarDarker,
      contrastText: colors$3.white,
      contrastTextDark: colors$3.white
    },
    danger: {
      main: colors$3.red,
      light: colors$3.redLight,
      lighter: colors$3.redLighter,
      dark: colors$3.redDark,
      darker: colors$3.redDarker,
      contrastText: colors$3.white,
      contrastTextDark: colors$3.white
    },
    background: {
      hbBackgroundA: colors$3.white,
      hbBackgroundB: colors$3.grayA
    },
    disabled: {
      main: DISABLED_MAIN_COLOR,
      contrast: DISABLED_CONTRAST_COLOR
    },
    icon: {
      "default": colors$3.grayI,
      disabled: colors$3.grayG
    },
    alternative1: {
      main: colors$3.greeny,
      light: colors$3.greenyLight,
      lighter: colors$3.greenyLighter,
      dark: colors$3.greenyDark,
      darker: colors$3.greenyDarker,
      contrastText: colors$3.white,
      contrastTextDark: colors$3.white
    },
    alternative5: {
      main: colors$3.blueLink,
      light: colors$3.blueLinkLight,
      lighter: colors$3.blueLinkLighter,
      dark: colors$3.blueLinkDark,
      darker: colors$3.blueLinkDarker
    },
    alternative6: {
      main: colors$3.caribbean,
      light: colors$3.caribbeanLight,
      lighter: colors$3.caribbeanLighter,
      dark: colors$3.caribbeanDark,
      darker: colors$3.caribbeanDarker
    },
    alternative7: {
      main: colors$3.jade,
      light: colors$3.jadeLight,
      lighter: colors$3.jadeLighter,
      dark: colors$3.jadeDark,
      darker: colors$3.jadeDarker
    },
    alternative8: {
      main: colors$3.crimson,
      light: colors$3.crimsonLight,
      lighter: colors$3.crimsonLighter,
      dark: colors$3.crimsonDark,
      darker: colors$3.crimsonDarker
    },
    white: colors$3.white,
    grayA: colors$3.grayA,
    grayB: colors$3.grayB,
    grayC: colors$3.grayC,
    grayD: colors$3.grayD,
    grayE: colors$3.grayE,
    grayF: colors$3.grayF,
    grayG: colors$3.grayG,
    grayH: colors$3.grayH,
    grayI: colors$3.grayI,
    grayJ: colors$3.grayJ,
    green: colors$3.green
  },
  form: {
    fontWeight: 400,
    color: colors$3.grayI,
    button: {
      fontFamily: fonts.robotoCondensed.fontFamily,
      fontSize: "".concat(toRem(16), "rem"),
      letterSpacing: 'unset'
    },
    code: {
      fontFamily: fonts.robotoBold.fontFamily,
      fontWeight: fonts.robotoBold.fontWeight,
      fontSize: '2.25rem'
    },
    helper: {
      color: colors$3.grayH
    }
  },
  typography: {
    font: {
      fontFamily: fonts.roboto.fontFamily,
      fontSize: "".concat(toRem(14), "rem"),
      letterSpacing: '0.01em',
      color: colors$3.grayI
    },
    paragraph: {
      fontSize: "".concat(toRem(14), "rem"),
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '1.6em'
    },
    title: {
      h1: {
        fontSize: "".concat(toRem(22), "rem"),
        fontWeight: 400,
        letterSpacing: '0.02rem',
        margin: '2em 0 1.5em 0'
      },
      h2: {
        fontSize: "".concat(toRem(20), "rem"),
        fontWeight: 700,
        letterSpacing: '0.02em',
        margin: '1.5rem 0 1rem'
      },
      h3: {
        fontFamily: fonts.robotoMedium.fontFamily,
        fontSize: "".concat(toRem(18), "rem"),
        fontWeight: 500,
        letterSpacing: '0.02em',
        margin: '1.5rem 0 1rem'
      }
    }
  },
  getRgbColor: getRgbColor,
  toRem: function toRem$1(value) {
    return "".concat(toRem(value), "rem");
  }
};

var heading = function heading(font, titles) {
  return function (level) {
    return font(titles["h".concat(level)]);
  };
};
var typography = function typography(theme, config) {
  var result = theme.typography;
  var font = withFont(theme.typography.font, config.font);
  result.font = font();
  result.paragraph = font(result.paragraph);
  result.heading = heading(font, theme.typography.title);
  return result;
};

var DEFAULT_THEME_CONFIG = {
  font: {
    fontFamily: fonts.roboto.fontFamily,
    fontSize: "".concat(toRem(14), "rem"),
    letterSpacing: '0.01em',
    color: colors$3.grayI
  },
  form: {
    focus: {
      borderColor: colors$3.blue,
      shadowColor: colors$3.blueLighter,
      size: 4 // px
    }
  },
  borderRadius: 4,
  // px
  spacing: 8 // px
};
var createTheme = function createTheme() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_THEME_CONFIG;
  var result = theme$1;
  result.spacing = spacing(result.spacing || config.spacing);
  result.borderRadius = borderRadius(result.borderRadius || config.borderRadius);
  result.form = form(result, config);
  result.typography = typography(result, config);
  return result;
};

var theme = createTheme({
  font: {
    fontFamily: fonts.roboto.fontFamily,
    fontSize: "".concat(toRem(14), "rem"),
    letterSpacing: '0.01em',
    color: colors$3.grayI
  },
  form: {
    focus: {
      borderColor: colors$3.blue,
      shadowColor: colors$3.blueLighter,
      size: 4 // px
    }
  },
  borderRadius: 4,
  // px
  spacing: 8 // px
});

// eslint-disable-next-line import/no-anonymous-default-export
var styles = {
  admin: theme$2,
  marketplace: theme
};

var marketplace$1 = styles.marketplace;
var breakpoints = marketplace$1.breakpoints;
var device = {
  mobile: "(min-width: ".concat(breakpoints.small, "px)"),
  tablet: "(min-width: ".concat(breakpoints.medium, "px)"),
  desktop: "(min-width: ".concat(breakpoints.large, "px)"),
  desktopLarge: "(min-width: ".concat(breakpoints.extraLarge, "px)")
};

var _templateObject$S, _templateObject2$v;
var StyledAdaptiveArea = styled.div(_templateObject$S || (_templateObject$S = _taggedTemplateLiteral(["\n  display: flex;\n  position: fixed;\n  flex-direction: row;\n  gap: ", ";\n  left: 0;\n  right: 0;\n  bottom: 0;\n  padding: ", ";\n  border-top: 1px solid ", ";\n  z-index: 100;\n\n  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.78) 0%, rgba(255, 255, 255, 1) 25%);\n\n  ", "\n\n  *, * > button {\n    width: 100%;\n  }\n\n  @media screen and ", " {\n    position: relative;\n    padding: 0;\n\n    border: none;\n    box-shadow: none;\n    background-image: none;\n\n    *, * > button {\n      width: initial;\n    }\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.spacing(2);
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.spacing(2);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.grayC;
}, function (_ref4) {
  var shadow = _ref4.shadow;
  return shadow && css(_templateObject2$v || (_templateObject2$v = _taggedTemplateLiteral(["\n    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);\n  "])));
}, device.desktop);

var AdaptiveArea = function AdaptiveArea(_ref) {
  var className = _ref.className,
    shadow = _ref.shadow,
    children = _ref.children;
  return /*#__PURE__*/React__default.createElement(StyledAdaptiveArea, {
    className: className,
    shadow: shadow,
    "data-testid": "adaptive-area"
  }, children);
};
AdaptiveArea.propTypes = {
  /**
   * Class to apply to AdaptiveArea
   */
  className: PropTypes.string,
  /**
   * Wheter a shadow effect should be added to the top border of the area on mobile
   */
  shadow: PropTypes.bool,
  /**
   * The content of the component
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired
};
AdaptiveArea.defaultProps = {
  className: '',
  shadow: false
};

function _extends$3() {
  _extends$3 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$3.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$1(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

var _templateObject$R, _templateObject2$u, _templateObject3$n, _templateObject4$j, _templateObject5$f, _templateObject6$9, _templateObject7$6, _templateObject8$5, _templateObject9$4, _templateObject10$3, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24;
var rotate$1 = keyframes(_templateObject$R || (_templateObject$R = _taggedTemplateLiteral(["\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n"])));
var StyledButton = styled.button(_templateObject2$u || (_templateObject2$u = _taggedTemplateLiteral(["\n  ", "\n\n  background: transparent;\n  border-radius: ", ";\n  cursor: pointer;\n  outline: none;\n  position: relative;\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  &:disabled {\n    ", ";\n\n    pointer-events: none;\n  }\n\n  &:hover {\n    ", ";\n  }\n\n  &:active {\n    ", "\n  }\n\n  &:focus {\n    ", ";\n  }\n\n  ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.form.button.font();
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.borderRadius();
}, function (_ref3) {
  var fullWidth = _ref3.fullWidth;
  return fullWidth && 'width: 100%';
}, function (_ref4) {
  var _ref4$size = _ref4.size,
    size = _ref4$size === void 0 ? 'regular' : _ref4$size;
  if (size === 'big') {
    return css(_templateObject3$n || (_templateObject3$n = _taggedTemplateLiteral(["\n        height: 3em;\n        min-width: 6em;\n        padding: 0 2em;\n      "])));
  }
  if (size === 'small') {
    return css(_templateObject4$j || (_templateObject4$j = _taggedTemplateLiteral(["\n        height: 2em;\n        min-width: 4em;\n        padding: 0 0.5em;\n      "])));
  }
  return css(_templateObject5$f || (_templateObject5$f = _taggedTemplateLiteral(["\n      height: 2.5em;\n      min-width: 5em;\n      padding: 0 1.5em;\n    "])));
}, function (_ref5) {
  var _ref5$variant = _ref5.variant,
    variant = _ref5$variant === void 0 ? 'solid' : _ref5$variant,
    rounded = _ref5.rounded;
  return variant === 'solid' && rounded && css(_templateObject6$9 || (_templateObject6$9 = _taggedTemplateLiteral(["\n    border-radius: 2em;\n  "])));
}, function (_ref6) {
  var _ref6$variant = _ref6.variant,
    variant = _ref6$variant === void 0 ? 'solid' : _ref6$variant,
    _ref6$color = _ref6.color,
    color = _ref6$color === void 0 ? 'primary' : _ref6$color,
    theme = _ref6.theme;
  if (variant === 'solid' && color === 'secondary') {
    return css(_templateObject7$6 || (_templateObject7$6 = _taggedTemplateLiteral(["\n        background: ", ";\n        border: 1px solid ", ";\n        color: ", ";\n      "])), theme.palette[color].lighter, theme.palette[color].main, theme.palette[color].contrastText);
  }
  if (variant === 'solid') {
    return css(_templateObject8$5 || (_templateObject8$5 = _taggedTemplateLiteral(["\n        background: ", ";\n        border: 1px solid ", ";\n        color: ", ";\n      "])), theme.palette[color].main, theme.palette[color].main, theme.palette[color].contrastText);
  }
  if (variant === 'outlined' && color === 'secondary') {
    return css(_templateObject9$4 || (_templateObject9$4 = _taggedTemplateLiteral(["\n        border: 1px solid ", ";\n        color: ", ";\n      "])), theme.palette[color].darker, theme.palette[color].darker);
  }
  if (variant === 'outlined') {
    return css(_templateObject10$3 || (_templateObject10$3 = _taggedTemplateLiteral(["\n        background: transparent;\n        border: 1px solid ", ";\n        color: ", ";\n      "])), theme.palette[color].main, theme.palette[color].main);
  }
  if (variant === 'text' && color === 'secondary') {
    return css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n        background: transparent;\n        border: none;\n        color: ", ";\n        font-weight: bold;\n      "])), theme.palette[color].darker);
  }
  if (variant === 'text') {
    return css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n        background: transparent;\n        border: none;\n        color: ", ";\n        font-family: 'RobotoCondensedBold';\n        font-weight: bold;\n      "])), theme.palette[color].main);
  }
  return '';
}, function (_ref7) {
  var _ref7$variant = _ref7.variant,
    variant = _ref7$variant === void 0 ? 'solid' : _ref7$variant,
    theme = _ref7.theme,
    isLoading = _ref7.isLoading;
  if (!isLoading && variant !== 'text') {
    return css(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n          background: ", ";\n          border-color: ", ";\n          color: ", ";\n        "])), theme.palette.disabled.main, theme.palette.disabled.main, theme.palette.disabled.contrast);
  }
  if (!isLoading) {
    return css(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n          border-color: ", ";\n          color: ", ";\n        "])), theme.palette.disabled.main, theme.palette.disabled.contrast);
  }
  return '';
}, function (_ref8) {
  var _ref8$variant = _ref8.variant,
    variant = _ref8$variant === void 0 ? 'solid' : _ref8$variant,
    _ref8$color = _ref8.color,
    color = _ref8$color === void 0 ? 'primary' : _ref8$color,
    theme = _ref8.theme;
  if (variant === 'solid' && color === 'secondary') {
    return css(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n          background: ", ";\n        "])), theme.palette[color].main);
  }
  if (variant === 'solid') {
    return css(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n          background: ", ";\n          border: 1px solid ", ";\n          color: ", ";\n        "])), theme.palette[color].darker, theme.palette[color].darker, theme.palette[color].contrastTextDark);
  }
  if (variant === 'outlined') {
    var borderColor = theme.palette[color].lighter;
    var shadowColorRgb = theme.getRgbColor(theme.palette[color].main);
    if (color === 'secondary') {
      borderColor = theme.palette[color].dark;
      shadowColorRgb = theme.getRgbColor(theme.palette[color].darker);
    }
    return css(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n          border-color: ", ";\n          box-shadow: 0 0 0px 1px rgba(", ", 0.2),\n            2px 2px 6px rgba(", ", 0.2),\n            -2px -2px 6px rgba(", ", 0.2);\n        "])), borderColor, shadowColorRgb, shadowColorRgb, shadowColorRgb);
  }
  if (variant === 'text') {
    return css(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n          background: ", "\n        "])), theme.palette.grayB);
  }
}, function (_ref9) {
  var _ref9$variant = _ref9.variant,
    variant = _ref9$variant === void 0 ? 'solid' : _ref9$variant,
    _ref9$color = _ref9.color,
    color = _ref9$color === void 0 ? 'primary' : _ref9$color,
    theme = _ref9.theme;
  if (variant === 'solid') {
    var colorVariant = color === 'secondary' ? 'lighter' : 'main';
    return css(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n        background: ", ";\n        border: 1px solid ", ";\n        color: ", ";\n      "])), theme.palette[color][colorVariant], theme.palette[color][colorVariant], theme.palette[color].contrastText);
  }
  if (variant === 'outlined') {
    var _colorVariant = color === 'secondary' ? 'darker' : 'main';
    return css(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n        background: transparent;\n        border: 1px solid ", ";\n        color: ", ";\n      "])), theme.palette[color][_colorVariant], theme.palette[color][_colorVariant]);
  }
  return css(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n      background: transparent;\n      border: none;\n      color: ", ";\n      font-family: 'RobotoCondensedBold';\n      font-weight: bold;\n    "])), theme.palette[color].main);
}, function (_ref10) {
  var theme = _ref10.theme,
    color = _ref10.color;
  return theme.form.focus(theme.palette[color].darker, color === 'secondary' ? theme.palette[color].main : theme.palette[color].light);
}, function (_ref11) {
  var isLoading = _ref11.isLoading,
    theme = _ref11.theme,
    _ref11$color = _ref11.color,
    color = _ref11$color === void 0 ? 'primary' : _ref11$color;
  return isLoading && css(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n    color: transparent;\n    pointer-events: none;\n\n    .loader {\n      animation: ", " 1s linear infinite;\n      border-radius: 50%;\n      border: 3px solid ", ";\n      bottom: 0;\n      height: 16px;\n      left: 0;\n      margin: auto;\n      position: absolute;\n      right: 0;\n      top: 0;\n      width: 16px;\n\n      ", ";\n\n      ", ";\n\n      border-top-color: transparent;\n    }\n  "])), rotate$1, theme.palette[color].contrastText, function (_ref12) {
    var _ref12$variant = _ref12.variant,
      variant = _ref12$variant === void 0 ? 'solid' : _ref12$variant,
      _ref12$color = _ref12.color,
      color = _ref12$color === void 0 ? 'primary' : _ref12$color,
      theme = _ref12.theme;
    if (color !== 'secondary' && variant !== 'solid') {
      return css(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n            border-color: ", ";\n          "])), theme.palette[color].main);
    }
    return '';
  }, function (_ref13) {
    var _ref13$size = _ref13.size,
      size = _ref13$size === void 0 ? 'regular' : _ref13$size;
    return size === 'small' && css(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n        width: 8px;\n        height: 8px;\n      "])));
  });
});

var _excluded$y = ["children", "isLoading"];
var AVAILABLE_COLORS$2 = ['primary', 'secondary', 'info', 'warning', 'danger'];
var AVAILABLE_VARIANTS = ['solid', 'outlined', 'text'];
var AVAILABLE_SIZES$1 = ['small', 'regular', 'big'];
var Button = function Button(_ref) {
  var children = _ref.children,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    props = _objectWithoutProperties(_ref, _excluded$y);
  return /*#__PURE__*/React__default.createElement(StyledButton, _extends$3({
    isLoading: isLoading
  }, props), children, isLoading && /*#__PURE__*/React__default.createElement("div", {
    className: "loader"
  }));
};
Button.propTypes = {
  /**
   * The color of the component. It supports five colors according with semantic purposes
   */
  color: PropTypes.oneOf(AVAILABLE_COLORS$2),
  /**
   * Define the variant of the button
   */
  variant: PropTypes.oneOf(AVAILABLE_VARIANTS),
  /**
   * Define the dimensions of the button
   */
  size: PropTypes.oneOf(AVAILABLE_SIZES$1),
  /**
   * Define the shape of button rounded or regular square (for solid buttons only)
   */
  rounded: PropTypes.bool,
  /**
  * Apply styles to the button to display it as unusable and unclickable
  */
  disabled: PropTypes.bool,
  /**
   * The button takes all the space available in the container
   */
  fullWidth: PropTypes.bool,
  /**
   * Function to execute when the button was clicked
   */
  onClick: PropTypes.func,
  /**
  * This attribute hides the button text and displays a loading spinner instead. When this
  * attribute is true the onClick handler will not be executed.
  */
  isLoading: PropTypes.bool,
  /**
   * Define type of button
  */
  type: PropTypes.oneOf(['submit', 'button', 'file']),
  /**
  * This is the content to be displayed inside button
  */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)])
};
Button.defaultProps = {
  color: 'primary',
  variant: 'solid',
  size: 'regular',
  rounded: false,
  disabled: false,
  fullWidth: false,
  onClick: undefined,
  isLoading: false,
  type: 'button',
  children: null
};

var RenderIf = function RenderIf(_ref) {
  var condition = _ref.condition,
    children = _ref.children;
  if (!condition) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement(Fragment, null, children);
};
RenderIf.propTypes = {
  condition: PropTypes.bool.isRequired,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)])
};
RenderIf.defaultProps = {
  children: null
};

var _templateObject$Q, _templateObject2$t, _templateObject3$m, _templateObject4$i, _templateObject5$e;
var AVAILABLE_COLORS$1 = {
  blue: 'info',
  yellow: 'warning',
  red: 'danger',
  'soft-red': 'primary',
  'soft-green': 'alternative1',
  'hard-blue': 'alternative5'
};
var CalloutContainer = styled.div(_templateObject$Q || (_templateObject$Q = _taggedTemplateLiteral(["\n  ", "\n\n  align-items: center;\n  background-color: white;\n  border-left: 5px solid ", ";\n  border-radius: ", " 0 0 ", ";\n  box-sizing: border-box;\n  color: ", ";\n  display: flex;\n  justify-content: space-between;\n  min-height: ", ";\n  padding: ", ";\n  position: relative;\n  width: 100%;\n  z-index: 0;\n\n  &::before {\n    background-color: ", ";\n    content: \"\";\n    height: 100%;\n    left: 0;\n    opacity: 0.1;\n    position: absolute;\n    width: 100%;\n    z-index: -1;\n  }\n\n  @media screen and (min-width: ", "px) {\n    max-width: ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.typography.font();
}, function (_ref2) {
  var theme = _ref2.theme,
    color = _ref2.color;
  return theme.palette[AVAILABLE_COLORS$1[color]].main;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.borderRadius();
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.borderRadius();
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.palette.grayI;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.spacing(11);
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.spacing(2);
}, function (_ref8) {
  var theme = _ref8.theme,
    color = _ref8.color;
  return theme.palette[AVAILABLE_COLORS$1[color]].main;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.breakpoints.medium;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.spacing(42);
});
var Heading = styled.div(_templateObject2$t || (_templateObject2$t = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n  justify-content: center;\n\n  > * {\n    margin: 0;\n  }\n"])), function (_ref11) {
  var theme = _ref11.theme;
  return theme.spacing(2);
});
var Title = styled.p(_templateObject3$m || (_templateObject3$m = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: ", ";\n"])), function (_ref12) {
  var theme = _ref12.theme;
  return theme.palette.grayH;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.typography.title.h1.fontWeight;
});
var Content = styled.p(_templateObject4$i || (_templateObject4$i = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: ", ";\n"])), function (_ref14) {
  var theme = _ref14.theme;
  return theme.typography.title.h2.fontSize;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.typography.title.h3.fontWeight;
});
var Informative = styled.p(_templateObject5$e || (_templateObject5$e = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: ", ";\n  text-align: right;\n  margin: 0;\n"])), function (_ref16) {
  var theme = _ref16.theme;
  return theme.typography.title.h2.fontSize;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.typography.title.h3.fontWeight;
});

var _excluded$x = ["color", "content", "informativeContent", "title"];
var AVAILABLE_COLORS = ['blue', 'hard-blue', 'red', 'soft-green', 'soft-red', 'yellow'];
var Callout = function Callout(props) {
  var color = props.color,
    content = props.content,
    informativeContent = props.informativeContent,
    title = props.title,
    restProps = _objectWithoutProperties(props, _excluded$x);
  return /*#__PURE__*/React__default.createElement(CalloutContainer, _extends$3({
    color: color
  }, restProps), /*#__PURE__*/React__default.createElement(Heading, null, /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: Boolean(title)
  }, /*#__PURE__*/React__default.createElement(Title, null, title)), /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: Boolean(content)
  }, /*#__PURE__*/React__default.createElement(Content, null, content))), /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: Boolean(informativeContent)
  }, /*#__PURE__*/React__default.createElement(Informative, null, informativeContent)));
};
Callout.propTypes = {
  /**
   * The color of the component. It supports five colors according with semantic purposes
   */
  color: PropTypes.oneOf(AVAILABLE_COLORS),
  /**
   * The title of the Callout
   */
  title: PropTypes.string,
  /**
   * The text content of the Callout
   */
  content: PropTypes.string,
  /**
   * The informative part that complements the content
   */
  informativeContent: PropTypes.string
};
Callout.defaultProps = {
  color: 'blue',
  content: '',
  informativeContent: '',
  title: ''
};

var _templateObject$P;
var StyledCard = styled.div(_templateObject$P || (_templateObject$P = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  box-sizing: border-box;\n  box-shadow: 0 0 6px 0 rgba(", ", 0.05);\n  max-width: 100%;\n  position: relative;\n\n  & > div {\n    &:not(:first-child) {\n      padding-top: 0\n    }\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.background.hbBackgroundA;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.grayC;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.borderRadius();
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.getRgbColor(theme.palette.grayB);
});

var _excluded$w = ["children"];
var Card = function Card(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$w);
  return /*#__PURE__*/React__default.createElement(StyledCard, _extends$3({
    "data-testid": "card"
  }, props), children);
};
Card.propTypes = {
  /**
   *The content of the component
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired
};

var _templateObject$O;
var ACTIONS_ALIGNMENT$1 = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end',
  between: 'space-between'
};
var StyledCardActions = styled.div(_templateObject$O || (_templateObject$O = _taggedTemplateLiteral(["\n  display: flex;\n  padding: ", ";\n  justify-content: ", ";\n\n  button {\n    &:not(:first-child) {\n      margin-left: ", ";\n    }\n  }\n\n  @media ", " {\n    padding: ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.spacing(2);
}, function (_ref2) {
  var alignment = _ref2.alignment;
  return ACTIONS_ALIGNMENT$1[alignment];
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.spacing(1);
}, device.tablet, function (_ref4) {
  var theme = _ref4.theme;
  return "".concat(theme.spacing(3), " ").concat(theme.spacing(4));
});

var _excluded$v = ["children", "alignment"];
var CardActions = function CardActions(_ref) {
  var children = _ref.children,
    alignment = _ref.alignment,
    props = _objectWithoutProperties(_ref, _excluded$v);
  return /*#__PURE__*/React__default.createElement(StyledCardActions, _extends$3({
    "data-testid": "card-actions",
    alignment: alignment
  }, props), children);
};
CardActions.propTypes = {
  /**
   *The content of the component
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
  /**
   * To especify alignment of the buttons
   */
  alignment: PropTypes.oneOf(['left', 'right', 'center', 'between'])
};
CardActions.defaultProps = {
  alignment: 'left'
};

var _templateObject$N;
var StyledCardContent = styled.div(_templateObject$N || (_templateObject$N = _taggedTemplateLiteral(["\n  padding: ", ";\n\n  @media ", " {\n    padding: ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.spacing(2);
}, device.tablet, function (_ref2) {
  var theme = _ref2.theme;
  return "".concat(theme.spacing(3), " ").concat(theme.spacing(4));
});

var _excluded$u = ["children"];
var CardContent = function CardContent(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$u);
  return /*#__PURE__*/React__default.createElement(StyledCardContent, _extends$3({
    "data-testid": "card-content"
  }, props), children);
};
CardContent.propTypes = {
  /**
   *The content of the component
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired
};

var _templateObject$M, _templateObject2$s;
var TITLE_ALIGNMENT = {
  left: 'left',
  center: 'center',
  right: 'right'
};
var StyledCardHeader = styled.div(_templateObject$M || (_templateObject$M = _taggedTemplateLiteral(["\n  padding: ", ";\n\n  @media ", " {\n    padding: ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.spacing(2);
}, device.tablet, function (_ref2) {
  var theme = _ref2.theme;
  return "".concat(theme.spacing(3), " ").concat(theme.spacing(4));
});
var StyledTitleCard = styled.h2(_templateObject2$s || (_templateObject2$s = _taggedTemplateLiteral(["\n  ", ";\n\n  margin: 0;\n  padding: 0;\n  text-align: ", "\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.typography.heading(2);
}, function (_ref4) {
  var titleAlignment = _ref4.titleAlignment;
  return TITLE_ALIGNMENT[titleAlignment];
});

var _excluded$t = ["children", "title", "titleAlignment", "titleElement"];
var ALIGNMENTS$2 = {
  left: 'left',
  center: 'center',
  right: 'right'
};
var CardHeader = function CardHeader(props) {
  var children = props.children,
    title = props.title,
    titleAlignment = props.titleAlignment,
    titleElement = props.titleElement,
    restProps = _objectWithoutProperties(props, _excluded$t);
  return /*#__PURE__*/React__default.createElement(StyledCardHeader, _extends$3({}, restProps, {
    "data-testid": "card-header"
  }), /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: Boolean(title)
  }, /*#__PURE__*/React__default.createElement(StyledTitleCard, {
    titleAlignment: titleAlignment,
    as: titleElement
  }, title)), /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: Boolean(children)
  }, children));
};
CardHeader.propTypes = {
  /**
   * The content of the component
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  /**
   * The title of the Card
   */
  title: PropTypes.string,
  /**
   * Set title alignment
   */
  titleAlignment: PropTypes.oneOf(Object.keys(ALIGNMENTS$2)),
  /**
   * The html element that would be used in the title
   */
  titleElement: PropTypes.string
};
CardHeader.defaultProps = {
  title: '',
  children: null,
  titleAlignment: 'left',
  titleElement: 'h2'
};

var img$1 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='118' height='72' viewBox='0 0 118 72'%3e %3cg fill='none' fill-rule='evenodd'%3e %3cg%3e %3cg%3e %3cg opacity='.657'%3e %3cg%3e %3cg transform='translate(-228 -275) translate(228 275)'%3e %3cellipse cx='27.244' cy='45.222' fill='%23FFEBEC' rx='22.819' ry='22.811'/%3e %3cpath fill='%23E8E8E8' d='M56.886 0L61.035 0 61.035 4.147 56.886 4.147z'/%3e %3cpath fill='%234D4D4D' d='M5.715 9.677v2.761l2.757.001v2.771H5.715v2.762H2.95v-2.763l-2.757.001v-2.77l2.757-.002v-2.76h2.766z'/%3e %3cpath fill='%23B1B1B1' d='M110.545 63.6v2.761l2.757.001v2.771h-2.757v2.762h-2.766v-2.763l-2.757.001v-2.77l2.757-.002v-2.76h2.766z'/%3e %3cpath fill='%23CACACA' d='M114.972 0v2.761l2.757.001v2.77h-2.757v2.763h-2.766V5.532h-2.757v-2.77l2.757-.001V0h2.766z'/%3e %3cg fill='%2300CED3'%3e %3cpath d='M5.57 0v2.761l2.757.001v2.77H5.57v2.763H2.804V5.532H.047v-2.77l2.757-.001V0H5.57z' transform='translate(102.487 13.825)'/%3e %3c/g%3e %3cellipse cx='88.004' cy='31.105' fill='%23FFEBEC' rx='29.734' ry='29.723'/%3e %3c/g%3e %3c/g%3e %3c/g%3e %3cg transform='translate(-228 -275) translate(228 275) translate(39.118 19.276)'%3e %3cpath fill='%23B1B1B1' fill-rule='nonzero' d='M1.331 30.962h32.847c.734 0 1.33-.594 1.33-1.322V1.321C35.508.592 34.91 0 34.178 0H1.331C.597 0 0 .594 0 1.321v28.32c0 .728.597 1.32 1.331 1.32zm32.813-29.64v28.286l-32.782.034L1.33 1.354l32.813-.033z'/%3e %3cpath fill='%23B1B1B1' fill-rule='nonzero' d='M35.677 5.461l2.685-.033.033 28.327-32.896.033v-2.21c0-.367-.298-.666-.661-.666-.363 0-.66.3-.66.667v2.21c0 .718.58 1.3 1.29 1.3h32.927c.712 0 1.29-.584 1.29-1.3V5.428c0-.718-.58-1.3-1.29-1.3h-2.718c-.365 0-.66.3-.66.666 0 .366.295.666.66.666z'/%3e %3cpath fill='%23B1B1B1' fill-rule='nonzero' d='M3.137 22.821l10.131-6.885 7.844 7.612c.13.126.3.19.47.19.169 0 .34-.066.47-.192.26-.252.258-.662-.002-.914l-2.163-2.099 5.471-3.653 5.96 4.207c.119.084.255.124.392.124.204 0 .407-.094.537-.267.216-.29.151-.695-.146-.904l-6.342-4.476c-.231-.165-.537-.165-.768-.011L18.926 19.6l-5.115-4.964c-.23-.222-.59-.25-.852-.073L2.373 21.76c-.301.205-.374.608-.165.903.212.293.626.364.929.158z'/%3e %3cellipse cx='30.808' cy='26.317' fill='%23B1B1B1' rx='6.788' ry='6.708'/%3e %3cpath fill='%23B1B1B1' fill-rule='nonzero' d='M10.966 14.449c2.015 0 3.655-1.62 3.655-3.612s-1.642-3.613-3.655-3.613c-2.014 0-3.656 1.622-3.656 3.613 0 1.99 1.64 3.612 3.656 3.612zm0-5.78c1.208 0 2.192.973 2.192 2.168 0 1.194-.984 2.167-2.192 2.167-1.21 0-2.193-.973-2.193-2.167 0-1.195.984-2.167 2.193-2.167zM19.49 9.288c.195 0 .391-.07.528-.204.243-.236.545-.486.746-.62.17.136.414.37.61.59.018.02.044.03.065.047.015.015.024.032.041.045.009.006.021.005.032.01.114.076.248.117.388.122.01 0 .02.01.031.01.026 0 .05-.011.078-.014.047-.004.094-.012.143-.025.041-.011.08-.027.12-.048.024-.011.05-.014.072-.028.024-.015.037-.037.057-.054.018-.013.039-.019.054-.035.243-.236.545-.486.746-.62.17.136.415.37.61.59.231.258.665.308.974.117.307-.191.37-.554.142-.812-.984-1.103-1.468-1.123-1.65-1.13-.158-.015-.544-.016-1.313.603-.635-.573-.98-.598-1.126-.603-.196-.018-.716-.032-1.873 1.101-.25.244-.215.61.076.816.129.096.29.142.45.142zM24.709 6.192c.194 0 .39-.07.527-.204.243-.236.545-.485.746-.62.17.136.415.37.61.59.018.02.044.03.065.047.016.015.024.032.042.045.008.006.02.003.03.01.117.076.249.118.393.122.01 0 .019.009.03.009.024 0 .048-.012.072-.013.052-.005.1-.013.151-.028.042-.011.078-.027.116-.046.025-.012.05-.015.075-.029.024-.015.036-.036.057-.054.017-.013.038-.018.054-.034.243-.237.545-.486.746-.62.17.136.414.37.61.59.231.257.665.31.973.117.307-.192.372-.554.143-.812-.984-1.103-1.468-1.123-1.65-1.13-.163-.013-.546-.016-1.313.603-.635-.573-.98-.597-1.126-.603-.194-.016-.716-.032-1.873 1.101-.25.244-.215.609.076.816.125.097.286.143.446.143z'/%3e %3cpath fill='white' d='M30.286 22.705H31.330000000000002V29.929H30.286z'/%3e %3cpath fill='white' d='M30.292 22.662L31.324 22.662 31.324 29.973 30.292 29.973z' transform='rotate(90 30.808 26.317)'/%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var _templateObject$L;
var StyledCardImage = styled.div(_templateObject$L || (_templateObject$L = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  margin-bottom: ", ";\n  min-height: 180px;\n\n  img {\n    display: block;\n    width: 100%;\n    height: 100%\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.spacing(3);
});

var _excluded$s = ["imageSrc", "alt"];
var CardImage = function CardImage(_ref) {
  var imageSrc = _ref.imageSrc,
    alt = _ref.alt,
    props = _objectWithoutProperties(_ref, _excluded$s);
  var _useState = useState(img$1),
    _useState2 = _slicedToArray(_useState, 2),
    image = _useState2[0],
    setImage = _useState2[1];
  useEffect(function () {
    var handleOnLoad = function handleOnLoad() {
      setImage(imageSrc);
    };
    var img = new Image();
    img.onload = handleOnLoad;
    img.src = imageSrc;
  }, [imageSrc]);
  return /*#__PURE__*/React__default.createElement(StyledCardImage, _extends$3({
    "data-testid": "card-image"
  }, props), /*#__PURE__*/React__default.createElement("img", {
    src: image,
    alt: alt,
    "data-testid": "img"
  }));
};
CardImage.propTypes = {
  /**
   * The url of the image to display
   */
  imageSrc: PropTypes.string.isRequired,
  /**
   * Alternate text to image when image cannot be displayed
   */
  alt: PropTypes.string
};
CardImage.defaultProps = {
  alt: ''
};

var _templateObject$K, _templateObject2$r;
var StyledCardLeftContent = styled.div(_templateObject$K || (_templateObject$K = _taggedTemplateLiteral(["\n  min-width: auto;\n  max-width: 100%;\n  min-height: auto;\n  max-height: 100%;\n\n  @media ", " {\n    ", ";\n  }\n"])), device.tablet, function (_ref) {
  var height = _ref.height;
  return height && css(_templateObject2$r || (_templateObject2$r = _taggedTemplateLiteral(["\n      min-height: ", "px;\n      max-height: ", "px;\n      min-width: ", "px;\n      max-width: ", "px;\n    "])), height, height, height / 2 * 3, height / 2 * 3);
});

var _excluded$r = ["children"];
var CardLeftContent = function CardLeftContent(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$r);
  return /*#__PURE__*/React__default.createElement(StyledCardLeftContent, _extends$3({
    "data-testid": "card-left-content"
  }, props), children);
};
CardLeftContent.propTypes = {
  /**
   *The content of the component
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
  /**
   *The content of the component
   */
  height: PropTypes.number
};
CardLeftContent.defaultProps = {
  height: 264
};

var ICON_SIZES$1 = {
  extraSmall: 8,
  small: 16,
  medium: 24,
  large: 40
};
var DEFAULT_COLOR = '#3E3E3E';
var DISABLED_COLOR = '#8C8C8C';
var SvgIcon = function SvgIcon(props) {
  var children = props.children,
    color = props.color,
    disabled = props.disabled,
    size = props.size,
    titleAccess = props.titleAccess,
    padding = props.padding;
  var iconColor = disabled ? DISABLED_COLOR : color;
  var style = {
    padding: padding ? 4 : 0
  };
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: ICON_SIZES$1[size],
    height: ICON_SIZES$1[size],
    viewBox: "0 0 24 24",
    fill: iconColor,
    style: style
  }, titleAccess && /*#__PURE__*/React__default.createElement("title", null, titleAccess), children);
};
SvgIcon.defaultProps = {
  color: DEFAULT_COLOR,
  disabled: false,
  size: 'medium',
  titleAccess: '',
  padding: true
};
SvgIcon.propTypes = {
  /**
  * The icon content, this is going to be displayed inside svg HTML tag
  */
  children: PropTypes.node.isRequired,
  /**
  * Define the dimensions of the icon
  */
  size: PropTypes.oneOf(Object.keys(ICON_SIZES$1)),
  /**
  * The color of the component
  */
  color: PropTypes.string,
  /**
  * The value assigned in the SVG accessible name element (\<title\>).
  */
  titleAccess: PropTypes.string,
  /**
  * Apply styles in the icon to display it as unusable and unclickable
  */
  disabled: PropTypes.bool,
  /**
  * If false, the space around the icon will be removed
  */
  padding: PropTypes.bool
};

var CheckIcon = function CheckIcon(props) {
  return /*#__PURE__*/React__default.createElement(SvgIcon, props, /*#__PURE__*/React__default.createElement("path", {
    d: "M19.756 7.13101C20.5776 6.25222 19.1899 3.97272 17.5955 5.5317L9.48302 14.3199C8.22472 12.8733 7.41349 12.0948 6.85725 11.5C5.26274 9.9416 3.10457 11.7468 4.39291 13.125C4.97554 13.748 8.29401 17.2803 8.67854 17.6915C9.06305 18.1028 9.8321 18.1028 10.2166 17.6915C10.6011 17.2803 19.756 7.13101 19.756 7.13101Z "
  }));
};

var _templateObject$J;
var StyledCheckBox = styled.label(_templateObject$J || (_templateObject$J = _taggedTemplateLiteral(["\n  ", "\n\n  display: flex;\n  flex-direction: row;\n  vertical-align: middle;\n  align-items: center;\n\n  .checkbox-icon {\n    display: flex;\n    place-items: center;\n    width: 1.1428em;\n    height: 1.1428em;\n    background-color: ", ";\n    border: 1px solid ", ";\n    border-radius: 0.2857em;\n  }\n\n  .checkbox-tick {\n    display: none;\n  }\n\n  .checkbox {\n    border-radius: 0.4286em;\n    height: 1.7143em;\n    display: grid;\n    place-items: center;\n    justify-content: start;\n\n    &:nth-child(1) {\n      align-self: flex-start;\n    }\n  }\n\n  .label {\n    color: ", ";\n    margin-left: 0.5714em;\n  }\n\n  input {\n    position: absolute;\n    transform: scale(0);\n\n    &:hover ~ .checkbox-icon {\n      display: flex;\n      background-color: ", ";\n      border: 1px solid ", ";\n    }\n\n    &:hover ~ .checkbox-icon:hover {\n      box-shadow: 0 0 0 0.3em rgba(", ",0.5);\n    }\n\n    &:focus ~ .checkbox-icon {\n      ", ";\n    }\n\n    &:active ~ .checkbox-icon {\n      border: 2px solid ", ";\n      width: 1em;\n      height: 1em;\n    }\n\n    &:checked ~ .checkbox-icon {\n      background-color: ", ";\n      border: 1px solid ", ";\n      width: 1.1428em;\n      height: 1.1428em;\n    }\n\n    &:checked ~ .checkbox-icon .checkbox-tick {\n      display: block;\n      margin-top: 0.2857em;\n    }\n\n    &:disabled ~ .checkbox-icon {\n      background-color: rgba(", ",0.5);\n      border: 1px solid ", ";\n      width: 16px;\n      height: 16px;\n    }\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.form.label.font();
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.primary.contrastText;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.grayD;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.palette.grayI;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.palette.primary.contrastText;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.palette.grayD;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.getRgbColor(theme.palette.grayD);
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.form.focus();
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.palette.grayE;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.palette.info.main;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.palette.info.lighter;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.getRgbColor(theme.palette.grayD);
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.palette.grayD;
});

var CheckBox = function CheckBox(props) {
  var id = props.id,
    name = props.name,
    label = props.label,
    checked = props.checked,
    required = props.required,
    disabled = props.disabled,
    inputProps = props.inputProps,
    className = props.className,
    onChange = props.onChange,
    onBlur = props.onBlur;
  return /*#__PURE__*/React__default.createElement(StyledCheckBox, {
    "data-testid": "checkbox",
    "aria-label": "checkbox",
    htmlFor: id,
    className: className
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "checkbox"
  }, /*#__PURE__*/React__default.createElement("input", _extends$3({
    type: "checkbox",
    id: id,
    name: name,
    required: required,
    disabled: disabled,
    checked: checked,
    onChange: onChange,
    onBlur: onBlur
  }, inputProps)), /*#__PURE__*/React__default.createElement("span", {
    className: "checkbox-icon"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "checkbox-tick"
  }, /*#__PURE__*/React__default.createElement(CheckIcon, {
    size: "small",
    padding: false,
    color: "#FFFFFF"
  })))), /*#__PURE__*/React__default.createElement("span", {
    className: "label"
  }, label));
};
CheckBox.propTypes = {
  /**
   * Id assigned to checkbox. This id is also used to make accessible the label and helperText.
   */
  id: PropTypes.string,
  /**
   * The name of the checkbox
   */
  name: PropTypes.string,
  /**
   * The label text of the checkbox
   */
  label: PropTypes.string,
  /**
   * If true the checkbox element would be required
   */
  required: PropTypes.bool,
  /**
   * Apply styles to the checkbox to display it as unusable and unclickable
   */
  disabled: PropTypes.bool,
  /**
   *  The checked is use when element is controlled
   */
  checked: PropTypes.bool,
  /**
   * Class to apply on input container
   */
  className: PropTypes.string,
  /**
   * Function to execute when the value has changed
   */
  onChange: PropTypes.func,
  /**
   * Function to execute when input is blurred
   */
  onBlur: PropTypes.func,
  /**
   * Props applied on HTML input element
   */
  inputProps: PropTypes.shape({})
};
CheckBox.defaultProps = {
  id: 'checkbox-id',
  name: '',
  label: '',
  required: false,
  disabled: false,
  checked: null,
  className: '',
  onChange: function onChange() {},
  onBlur: function onBlur() {},
  inputProps: {}
};

var _templateObject$I, _templateObject2$q, _templateObject3$l, _templateObject4$h, _templateObject5$d, _templateObject6$8, _templateObject7$5, _templateObject8$4, _templateObject9$3;
var IconContainer = styled.div(_templateObject$I || (_templateObject$I = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var StyledChip = styled.button(_templateObject2$q || (_templateObject2$q = _taggedTemplateLiteral(["\n  ", ";\n\n  border-radius: 2.3em;\n  cursor: pointer;\n  min-height: 2.3em;\n  margin: 0;\n  padding: ", " ", ";\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n\n  min-width: ", ";\n  max-width: ", ";\n\n  color: ", ";\n\n  ", ";\n\n  &:hover {\n    background: ", ";\n  }\n\n  &:focus {\n    ", "\n  }\n\n  &:active {\n    ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.form.font();
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.spacing(1);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.spacing(2);
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.spacing(5);
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.spacing(36);
}, function (_ref6) {
  var theme = _ref6.theme,
    disabled = _ref6.disabled;
  return disabled && theme.palette.grayG;
}, function (_ref7) {
  var isActive = _ref7.isActive,
    disabled = _ref7.disabled,
    theme = _ref7.theme;
  if (disabled) {
    return css(_templateObject3$l || (_templateObject3$l = _taggedTemplateLiteral(["\n        border: 1px solid ", ";\n        background: ", ";\n        cursor: not-allowed;\n        pointer-events: none;\n\n        > div {\n          filter: grayscale(1);\n        }\n      "])), theme.palette.grayC, theme.palette.grayC);
  }
  if (isActive) {
    return css(_templateObject4$h || (_templateObject4$h = _taggedTemplateLiteral(["\n        border: 1px solid ", ";\n        background: ", ";\n      "])), theme.palette.secondary.dark, theme.palette.secondary.main);
  }
  return css(_templateObject5$d || (_templateObject5$d = _taggedTemplateLiteral(["\n      border: 1px solid ", ";\n      background: ", ";\n    "])), theme.palette.secondary.dark, theme.palette.secondary.lighter);
}, function (_ref8) {
  var theme = _ref8.theme,
    isActive = _ref8.isActive;
  return isActive ? theme.palette.secondary.dark : theme.palette.secondary.light;
}, function (_ref9) {
  var isActive = _ref9.isActive,
    disabled = _ref9.disabled,
    theme = _ref9.theme;
  if (!disabled) {
    if (isActive) {
      return css(_templateObject6$8 || (_templateObject6$8 = _taggedTemplateLiteral(["\n            background: ", ";\n            box-shadow: 0 0 0 0.25rem ", ";\n            outline: 0;\n          "])), theme.palette.secondary.main, theme.palette.secondary.dark);
    }
    return css(_templateObject7$5 || (_templateObject7$5 = _taggedTemplateLiteral(["\n          box-shadow: 0 0 0 0.25rem ", ";\n          outline: 0;\n        "])), theme.palette.secondary.dark);
  }
  return '';
}, function (_ref10) {
  var isActive = _ref10.isActive,
    disabled = _ref10.disabled,
    theme = _ref10.theme;
  if (!isActive) {
    return css(_templateObject8$4 || (_templateObject8$4 = _taggedTemplateLiteral(["\n          border: 1px solid ", ";\n          background: ", ";\n        "])), theme.palette.secondary.dark, theme.palette.secondary.main);
  }
  if (!disabled) {
    return css(_templateObject9$3 || (_templateObject9$3 = _taggedTemplateLiteral(["\n          border: 1px solid ", ";\n          background: ", ";\n        "])), theme.palette.secondary.dark, theme.palette.secondary.lighter);
  }
  return '';
});

var AVAILABLE_ICON_SIZES = {
  small: 'small',
  regular: 'medium',
  big: 'large'
};
var Chip = function Chip(props) {
  var id = props.id,
    name = props.name,
    label = props.label,
    Icon = props.icon,
    iconSize = props.iconSize,
    disabled = props.disabled,
    onClick = props.onClick,
    onBlur = props.onBlur,
    value = props.value;
  var _useControlled = useControlled({
      controlled: value,
      name: 'Chip'
    }),
    _useControlled2 = _slicedToArray(_useControlled, 2),
    isActive = _useControlled2[0],
    setIsActive = _useControlled2[1];
  var createEvent = function createEvent(event) {
    var nativeEvent = event.nativeEvent || event;
    var clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
    Object.defineProperty(clonedEvent, 'target', {
      writable: true,
      value: {
        value: !isActive,
        name: name
      }
    });
    return clonedEvent;
  };
  var chipOnClick = function chipOnClick(event) {
    var newEvent = createEvent(event);
    setIsActive(newEvent.target.value);
    onClick(newEvent);
  };
  var chipOnBlur = function chipOnBlur(event) {
    var newEvent = createEvent(event);
    onBlur(newEvent);
  };
  var iconProps = {
    padding: false,
    size: AVAILABLE_ICON_SIZES[iconSize]
  };
  var IconWithCustomProps = Icon ? /*#__PURE__*/React__default.cloneElement(Icon, iconProps) : null;
  return /*#__PURE__*/React__default.createElement(StyledChip, {
    id: id,
    name: name,
    type: "button",
    isActive: isActive,
    disabled: disabled,
    onClick: chipOnClick,
    onBlur: chipOnBlur,
    iconSize: iconSize
  }, label, /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: Boolean(IconWithCustomProps)
  }, /*#__PURE__*/React__default.createElement(IconContainer, null, IconWithCustomProps)));
};
Chip.propTypes = {
  /**
   * Id assigned to Chip. This id is also used to make accessible the label.
   */
  id: PropTypes.string.isRequired,
  /**
   * Name of the `Chip` element.
    */
  name: PropTypes.string.isRequired,
  /**
   * Text to be displayed into the chip
  */
  label: PropTypes.string.isRequired,
  /**
   *  Icon that may be displayed into the chip
   */
  icon: PropTypes.node,
  /**
   *  Icon that may be displayed into the chip
   */
  iconSize: PropTypes.oneOf(Object.keys(AVAILABLE_ICON_SIZES)),
  /**
   * Value of the Chip, Should be True or False
  */
  value: PropTypes.bool,
  /**
   * Apply styles to the Chip to display it as unusable and unclickable
  */
  disabled: PropTypes.bool,
  /**
   * Function to execute when the Chip was clicked
   */
  onClick: PropTypes.func,
  /**
  * Function to execute when Chip is blurred
  */
  onBlur: PropTypes.func
};
Chip.defaultProps = {
  icon: undefined,
  iconSize: 'regular',
  value: false,
  disabled: false,
  onClick: function onClick() {},
  onBlur: function onBlur() {}
};

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$3(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray$3(arr) || _nonIterableSpread();
}

var _templateObject$H;
var StyledInputLabel = styled.label(_templateObject$H || (_templateObject$H = _taggedTemplateLiteral(["\n  ", "\n\n  padding-bottom: ", ";\n\n  .asterisk-indicator {\n    color: ", ";\n    margin-left: ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.form.label.font();
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.spacing(1);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.primary.main;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.spacing(0.5);
});

var _excluded$q = ["required", "children"];
var REQUIRED_INDICATOR = ['asterisk', 'optional'];
var InputLabel = function InputLabel(_ref) {
  var required = _ref.required,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$q);
  var getRequiredIndicator = function getRequiredIndicator() {
    var requiredIndicator = props.requiredIndicator;
    if (requiredIndicator === 'optional') {
      return required ? '' : ' (Opcional)';
    }
    return required ? /*#__PURE__*/React__default.createElement("span", {
      className: "asterisk-indicator"
    }, "*") : '';
  };
  return /*#__PURE__*/React__default.createElement(StyledInputLabel, _extends$3({}, props, {
    required: required
  }), children, getRequiredIndicator());
};
InputLabel.defaultProps = {
  children: '',
  required: false,
  requiredIndicator: 'optional'
};
InputLabel.propTypes = {
  /**
  * This is the content to be displayed inside the label
  */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  /**
   * Defines when to display the label indicator
   */
  required: PropTypes.bool,
  /**
   * Defines which label indicator display
   */
  requiredIndicator: PropTypes.oneOf(REQUIRED_INDICATOR)
};

var _templateObject$G;
var FormFieldHelperText$1 = styled.p(_templateObject$G || (_templateObject$G = _taggedTemplateLiteral(["\n  ", "\n\n  color: ", ";\n\n  margin: 0;\n  padding: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.form.helper.font();
}, function (_ref2) {
  var theme = _ref2.theme,
    error = _ref2.error;
  return error ? theme.palette.danger.main : theme.form.helper.color;
}, function (_ref3) {
  var theme = _ref3.theme;
  return "".concat(theme.spacing(1), " 0 0");
});

var _excluded$p = ["children"];
var FormFieldHelperText = function FormFieldHelperText(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$p);
  return /*#__PURE__*/React__default.createElement(FormFieldHelperText$1, props, children);
};
FormFieldHelperText.defaultProps = {
  children: '',
  error: false
};
FormFieldHelperText.propTypes = {
  /**
   * This is the content to be displayed inside helper text
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  /**
   * Whether this field should be displayed in error state
   */
  error: PropTypes.bool
};

var _templateObject$F, _templateObject2$p;
var ChipGroupWrapper = styled.div(_templateObject$F || (_templateObject$F = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.spacing(1);
});
var StyledChipGroup = styled.div(_templateObject2$p || (_templateObject2$p = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  column-gap: ", ";\n  row-gap: ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.spacing(1);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.spacing(1.5);
});

var _excluded$o = ["name"];
function ownKeys$7(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$7(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$7(Object(t), !0).forEach(function (r) { _defineProperty$1(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$7(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var areChildrenChips = function areChildrenChips(children) {
  var childrenAsArray = React__default.Children.toArray(children);
  return childrenAsArray.every(function (child) {
    return child.type.name === Chip.name;
  });
};
var ChipGroup = function ChipGroup(props) {
  var children = props.children,
    error = props.error,
    helperText = props.helperText,
    id = props.id,
    _props$label = props.label,
    label = _props$label === void 0 ? '' : _props$label,
    _props$name = props.name,
    name = _props$name === void 0 ? '' : _props$name,
    required = props.required,
    selectionLimit = props.selectionLimit,
    alternativeOption = props.alternativeOption,
    onChange = props.onChange,
    onBlur = props.onBlur,
    controlledValue = props.value;
  if (!areChildrenChips(children)) {
    throw new Error('`ChipGroup` only accepts children of type `Chip`.');
  }
  var _useControlled = useControlled({
      controlled: controlledValue,
      name: name
    }),
    _useControlled2 = _slicedToArray(_useControlled, 2),
    selected = _useControlled2[0],
    setSelected = _useControlled2[1];
  var createSelectedListItems = function createSelectedListItems(newSelectedOption) {
    var newSelected = selected ? _toConsumableArray(selected) : [];
    if (newSelected.includes(newSelectedOption)) {
      var listWithoutDeselectedItem = newSelected.filter(function (deselectedItem) {
        return deselectedItem !== newSelectedOption;
      });
      return listWithoutDeselectedItem.length > 0 ? _toConsumableArray(listWithoutDeselectedItem) : null;
    }
    if (!selectionLimit || newSelected.length < selectionLimit) {
      return [].concat(_toConsumableArray(newSelected), [newSelectedOption]);
    }
    newSelected.shift();
    var newListItem = [].concat(_toConsumableArray(newSelected), [newSelectedOption]);
    return newListItem;
  };
  var createEvent = function createEvent(event, value) {
    var nativeEvent = event.nativeEvent || event;
    var clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
    Object.defineProperty(clonedEvent, 'target', {
      writable: true,
      value: {
        name: name,
        value: value
      }
    });
    return clonedEvent;
  };
  var callOnChange = function callOnChange(event, newSelected) {
    var changeEvent = createEvent(event, newSelected);
    onChange(changeEvent);
  };
  var handleBlur = function handleBlur(event) {
    var blurEvent = createEvent(event, selected);
    onBlur(blurEvent);
  };
  var handleSelect = function handleSelect(event) {
    var selectedName = event.target.name;
    var selectedListItems = createSelectedListItems(selectedName);
    setSelected(selectedListItems);
    callOnChange(event, selectedListItems);
  };
  var handleAlternativeOptionSelect = function handleAlternativeOptionSelect(event) {
    handleSelect(event);
    if (alternativeOption !== null && alternativeOption !== void 0 && alternativeOption.onClick) {
      alternativeOption.onClick();
    }
  };
  var getGroupControl = function getGroupControl(component) {
    var _component$props = component.props,
      selectedName = _component$props.name,
      restProps = _objectWithoutProperties(_component$props, _excluded$o);
    return _objectSpread$7(_objectSpread$7({}, restProps), {}, {
      value: (selected === null || selected === void 0 ? void 0 : selected.includes(selectedName)) || false,
      onBlur: handleBlur,
      onClick: handleSelect
    });
  };
  var childrenWithGroupControl = React__default.Children.map(children, function (child) {
    if ( /*#__PURE__*/React__default.isValidElement(child)) {
      return /*#__PURE__*/React__default.cloneElement(child, getGroupControl(child));
    }
    return child;
  });
  var renderAlternativeOption = useCallback(function () {
    var _ref = alternativeOption || {},
      _ref$label = _ref.label,
      alternativeLabel = _ref$label === void 0 ? 'Otro' : _ref$label,
      _ref$name = _ref.name,
      selectedName = _ref$name === void 0 ? 'other' : _ref$name;
    var value = (selected === null || selected === void 0 ? void 0 : selected.includes(selectedName)) || false;
    return /*#__PURE__*/React__default.createElement(Chip, {
      id: "other",
      label: alternativeLabel,
      name: selectedName,
      value: value,
      onClick: handleAlternativeOptionSelect
    });
  }, [alternativeOption, selected]);
  return /*#__PURE__*/React__default.createElement(ChipGroupWrapper, null, /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: Boolean(label)
  }, /*#__PURE__*/React__default.createElement(InputLabel, {
    htmlFor: id,
    required: required
  }, label)), /*#__PURE__*/React__default.createElement(StyledChipGroup, {
    id: id
  }, childrenWithGroupControl, /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: Boolean(alternativeOption)
  }, renderAlternativeOption())), /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: Boolean(helperText)
  }, /*#__PURE__*/React__default.createElement(FormFieldHelperText, {
    error: error
  }, helperText)));
};
ChipGroup.propTypes = {
  /**
  * The content of the component, which need to be of type `Chip`.
  */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
  /**
  * Whether the error helper text should be displayed.
  */
  error: PropTypes.bool,
  /**
  * Provides additional information about the field or error text.
  */
  helperText: PropTypes.string,
  /**
  * Id assigned to input. This id is also used to make accessible the label and helperText.
  */
  id: PropTypes.string.isRequired,
  /**
  * The text to display as the label associated with input control.
  */
  label: PropTypes.string,
  /**
  * Name attribute of this field, it is used for form control.
  */
  name: PropTypes.string,
  /**
   * If true there should be at least one selection.
   */
  required: PropTypes.bool,
  /**
   * The number of selected chips allowed. Its default value is undefined, which means
   * that infinite selecions can be made.
   */
  selectionLimit: PropTypes.number,
  /**
   * An array with the `name` value of the selected chips.
   */
  value: PropTypes.arrayOf(PropTypes.string),
  /**
   * Configuration for alternative option. It is not attributed a name, but rather
   * it can receive an `onClick` action.
   */
  alternativeOption: PropTypes.shape({
    label: PropTypes.string,
    name: PropTypes.string,
    onClick: PropTypes.func
  }),
  /**
   * Function to execute when component is blurred.
   */
  onBlur: PropTypes.func,
  /**
  * Callback fired when the state is changed.
  *
  * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
  * You can pull out the new value by accessing `event.target.value`.
  */
  onChange: PropTypes.func
};
ChipGroup.defaultProps = {
  error: false,
  helperText: '',
  label: '',
  name: '',
  required: false,
  selectionLimit: undefined,
  value: undefined,
  alternativeOption: undefined,
  onBlur: function onBlur() {},
  onChange: function onChange() {}
};

var _templateObject$E, _templateObject2$o, _templateObject3$k, _templateObject4$g, _templateObject5$c, _templateObject6$7;
var CodeFieldWrapper = styled.div(_templateObject$E || (_templateObject$E = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n"])));
var SeparatorToCodeInputs = styled.span(_templateObject2$o || (_templateObject2$o = _taggedTemplateLiteral(["\n  height: 2px;\n  width: 12px;\n  background: ", ";\n  margin-right: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.grayE;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.spacing(1);
});
var InputsWrapper = styled.div(_templateObject3$k || (_templateObject3$k = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));
var StyledCodeInput = styled.input(_templateObject4$g || (_templateObject4$g = _taggedTemplateLiteral(["\n  ", "\n\n  width: 1.75ch;\n  height: 1.35em;\n  border-radius: ", ";\n  border: 1px solid ", ";\n  text-align: center;\n  padding: 0;\n\n  &:not(:last-of-type) {\n    margin-right: ", ";\n  }\n\n  &:hover {\n    cursor: ", ";\n  }\n\n  &:focus {\n    ", ";\n  }\n\n  ", ";\n\n  ", ";\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.form.code.font();
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.borderRadius();
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.palette.grayE;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.spacing(1);
}, function (_ref7) {
  var disabled = _ref7.disabled;
  return !disabled && 'pointer';
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.form.focus();
}, function (_ref9) {
  var disabled = _ref9.disabled;
  return disabled && css(_templateObject5$c || (_templateObject5$c = _taggedTemplateLiteral(["\n    color: ", ";\n    border: 1px solid ", ";\n    background: ", ";\n    cursor: not-allowed;\n  "])), function (_ref10) {
    var theme = _ref10.theme;
    return theme.palette.disabled.contrast;
  }, function (_ref11) {
    var theme = _ref11.theme;
    return theme.palette.disabled.contrast;
  }, function (_ref12) {
    var theme = _ref12.theme;
    return theme.palette.disabled.main;
  });
}, function (_ref13) {
  var error = _ref13.error;
  return error && css(_templateObject6$7 || (_templateObject6$7 = _taggedTemplateLiteral(["\n    border: 2px solid ", ";\n    box-shadow: none;\n  "])), function (_ref14) {
    var theme = _ref14.theme;
    return theme.palette.danger.main;
  });
});

var findIndexInputPosition = function findIndexInputPosition(codeLength) {
  var findNextInputIndex = function findNextInputIndex(currentFocusedInputIndex) {
    var isLatestIndex = currentFocusedInputIndex === codeLength - 1;
    return isLatestIndex ? currentFocusedInputIndex : currentFocusedInputIndex + 1;
  };
  var findPreviousInputIndex = function findPreviousInputIndex(currentFocusedInputIndex) {
    var isFirstIndex = currentFocusedInputIndex === 0;
    return isFirstIndex ? currentFocusedInputIndex : currentFocusedInputIndex - 1;
  };
  return {
    findNextInputIndex: findNextInputIndex,
    findPreviousInputIndex: findPreviousInputIndex
  };
};

var pasteToCodeField = function pasteToCodeField(pastedValue, codeFieldListValues, codeLength, indexFocusedInput) {
  var newCodeListValues = _toConsumableArray(codeFieldListValues);
  var currentIndexAfterPaste = codeLength - 1;
  if (!/[0-9]/g.test(pastedValue)) return {};
  if (pastedValue.length === codeLength) {
    pastedValue.split('').forEach(function (value, indexValue) {
      newCodeListValues[indexValue] = value;
    });
  } else {
    pastedValue.split('').forEach(function (value, indexInput) {
      if (indexFocusedInput + indexInput < codeLength) {
        newCodeListValues[indexFocusedInput + indexInput] = value;
      }
    });
  }
  return {
    newCodeListValues: newCodeListValues,
    currentIndexAfterPaste: currentIndexAfterPaste
  };
};

var KEY_VALUES$1 = {
  arrowRight: 'ArrowRight',
  arrowLeft: 'ArrowLeft',
  backspace: 'Backspace'
};
var INITIAL_FOCUSED_INPUT_INDEX = -1;
var CodeInputField = function CodeInputField(props) {
  var name = props.name,
    disabled = props.disabled,
    error = props.error,
    focus = props.focus,
    codeLength = props.codeLength,
    onChange = props.onChange,
    groupEvery = props.groupEvery;
  var inputRef = useRef([]);
  var _findIndexInputPositi = findIndexInputPosition(codeLength),
    findNextInputIndex = _findIndexInputPositi.findNextInputIndex,
    findPreviousInputIndex = _findIndexInputPositi.findPreviousInputIndex;
  var _useState = useState(INITIAL_FOCUSED_INPUT_INDEX),
    _useState2 = _slicedToArray(_useState, 2),
    focusedInputIndex = _useState2[0],
    setFocusedInputIndex = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    codeFieldListValues = _useState4[0],
    setCodeFieldListValues = _useState4[1];
  var createEvent = function createEvent(event, value) {
    var nativeEvent = event.nativeEvent || event;
    var clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
    Object.defineProperty(clonedEvent, 'target', {
      writable: true,
      value: {
        value: value,
        name: name
      }
    });
    return clonedEvent;
  };
  var getNewFocusedInputValue = function getNewFocusedInputValue(newValue) {
    var currentValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var newFocusedInputValue = currentValue !== newValue.charAt(0) ? newValue.charAt(0) : newValue.charAt(1);
    return Number.isNaN(Number(newFocusedInputValue)) ? currentValue : newFocusedInputValue;
  };
  var handleChange = function handleChange(event) {
    var _event$target = event.target,
      id = _event$target.id,
      value = _event$target.value;
    var currentInputValue = codeFieldListValues[id];
    var newCodeValue = getNewFocusedInputValue(value, currentInputValue);
    var newCodeListValues = _toConsumableArray(codeFieldListValues);
    if (value.match(/[0-9]{1}/)) {
      newCodeListValues[id] = newCodeValue;
      inputRef.current[findNextInputIndex(focusedInputIndex)].focus();
    }
    setCodeFieldListValues(newCodeListValues);
    onChange(createEvent(event, newCodeListValues === null || newCodeListValues === void 0 ? void 0 : newCodeListValues.join('')));
  };
  var handleOnKeyDown = function handleOnKeyDown(event) {
    var key = event.key;
    switch (key) {
      case KEY_VALUES$1.backspace:
        {
          event.preventDefault();
          var hasValuefocusedInput = codeFieldListValues[focusedInputIndex];
          var newCodeListValues = _toConsumableArray(codeFieldListValues);
          if (hasValuefocusedInput) {
            newCodeListValues[focusedInputIndex] = '';
          } else {
            newCodeListValues[findPreviousInputIndex(focusedInputIndex)] = '';
            inputRef.current[findPreviousInputIndex(focusedInputIndex)].focus();
          }
          setCodeFieldListValues(newCodeListValues);
          onChange(createEvent(event, newCodeListValues === null || newCodeListValues === void 0 ? void 0 : newCodeListValues.join('')));
          break;
        }
      case KEY_VALUES$1.arrowLeft:
        {
          event.preventDefault();
          inputRef.current[findPreviousInputIndex(focusedInputIndex)].focus();
          break;
        }
      case KEY_VALUES$1.arrowRight:
        {
          event.preventDefault();
          inputRef.current[findNextInputIndex(focusedInputIndex)].focus();
          break;
        }
    }
  };
  var handleOnPaste = function handleOnPaste(event) {
    var _event$clipboardData$;
    event.preventDefault();
    var pastedValue = (_event$clipboardData$ = event.clipboardData.getData('Text').match(/[0-9]/g)) === null || _event$clipboardData$ === void 0 ? void 0 : _event$clipboardData$.join('');
    if (!pastedValue) return;
    var _pasteToCodeField = pasteToCodeField(pastedValue, codeFieldListValues, codeLength, focusedInputIndex),
      newCodeListValues = _pasteToCodeField.newCodeListValues;
    if (focusedInputIndex + pastedValue.length < codeLength) {
      inputRef.current[focusedInputIndex + pastedValue.length].focus();
    } else {
      inputRef.current[codeLength - 1].focus();
    }
    setCodeFieldListValues(newCodeListValues);
    onChange(createEvent(event, newCodeListValues === null || newCodeListValues === void 0 ? void 0 : newCodeListValues.join('')));
  };
  var createCodeInputs = function createCodeInputs(numberInputs) {
    var ListCodeInput = [];
    var _loop = function _loop(inputIndex) {
      if (groupEvery && inputIndex && inputIndex % groupEvery === 0) {
        ListCodeInput.push( /*#__PURE__*/React__default.createElement(SeparatorToCodeInputs, {
          key: "separator".concat(inputIndex),
          "data-testid": "separator"
        }));
      }
      var setInputRef = function setInputRef(element) {
        inputRef.current[inputIndex] = element;
      };
      var handleFocus = function handleFocus() {
        setFocusedInputIndex(inputIndex);
      };
      var inputProps = {
        id: inputIndex,
        ref: setInputRef,
        key: "codeDigit".concat(inputIndex),
        value: codeFieldListValues[inputIndex] || '',
        inputMode: 'numeric',
        type: 'text',
        autoComplete: 'off',
        disabled: disabled,
        error: error,
        onChange: handleChange,
        onFocus: handleFocus,
        onKeyDown: handleOnKeyDown,
        onPaste: handleOnPaste
      };
      if (inputIndex === 0 && focus) {
        inputProps.autoFocus = true;
      }
      ListCodeInput.push( /*#__PURE__*/React__default.createElement(StyledCodeInput, _extends$3({
        "aria-label": "Campo de c\xF3digo"
      }, inputProps)));
    };
    for (var inputIndex = 0; inputIndex < numberInputs; inputIndex += 1) {
      _loop(inputIndex);
    }
    return ListCodeInput;
  };
  return createCodeInputs(codeLength);
};
CodeInputField.propTypes = {
  name: PropTypes.string,
  focus: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  codeLength: PropTypes.number.isRequired,
  groupEvery: PropTypes.number,
  onChange: PropTypes.func.isRequired
};
CodeInputField.defaultProps = {
  name: '',
  focus: false,
  disabled: false,
  error: false,
  groupEvery: 0
};

var CodeField = function CodeField(props) {
  var id = props.id,
    name = props.name,
    label = props.label,
    disabled = props.disabled,
    error = props.error,
    focus = props.focus,
    helperText = props.helperText,
    codeLength = props.codeLength,
    onChange = props.onChange,
    groupEvery = props.groupEvery;
  return /*#__PURE__*/React__default.createElement(CodeFieldWrapper, {
    "data-testid": "code-field"
  }, /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: Boolean(label)
  }, /*#__PURE__*/React__default.createElement(InputLabel, {
    htmlFor: id,
    required: true
  }, label)), /*#__PURE__*/React__default.createElement(InputsWrapper, {
    id: id
  }, /*#__PURE__*/React__default.createElement(CodeInputField, {
    name: name,
    label: label,
    disabled: disabled,
    error: error,
    focus: focus,
    codeLength: codeLength,
    onChange: onChange,
    groupEvery: groupEvery
  })), /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: Boolean(helperText)
  }, /*#__PURE__*/React__default.createElement(FormFieldHelperText, {
    error: error
  }, helperText)));
};
CodeField.defaultProps = {
  id: '',
  name: '',
  label: '',
  focus: false,
  disabled: false,
  error: false,
  codeLength: 6,
  helperText: '',
  groupEvery: 0,
  onChange: function onChange() {}
};
CodeField.propTypes = {
  /**
    * Id assigned to codeField. This id is also used to make accessible the label and helperText.
  */
  id: PropTypes.string,
  /**
    * Name to controlle codeField.
  */
  name: PropTypes.string,
  /**
    * The text to display as the label associated with input control
  */
  label: PropTypes.string,
  /**
    * Function to execute when input was required initial focus
  */
  focus: PropTypes.bool,
  /**
    * Apply styles to the field to display it as unusable and unclickable
  */
  disabled: PropTypes.bool,
  /**
    * Provides additional information about the field
  */
  helperText: PropTypes.string,
  /**
    * Whether this field should be displayed in error state
  */
  error: PropTypes.bool,
  /**
   * Number of digits that make up the code
  */
  codeLength: PropTypes.number,
  /**
    * A number that specify how many inputs should be in a group before add a dash to separate them
  */
  groupEvery: PropTypes.number,
  /**
    * Function to execute when code has changed, it receives the new code as a parameter
  */
  onChange: PropTypes.func
};

var img = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='173' height='106'%3e%3cg fill='none' fill-rule='evenodd' opacity='.657'%3e%3ccircle cx='39.825' cy='66.577' r='33.582' fill='%23FFEBEC'/%3e%3cpath fill='%23E8E8E8' d='M83.447 0h6.106v6.106h-6.106z'/%3e%3cpath fill='%234D4D4D' d='M8.141 14.247v4.07h4.07v4.071h-4.07v4.07h-4.07l-.001-4.07H0v-4.07h4.07v-4.07h4.071z'/%3e%3cpath fill='%23B1B1B1' d='M162.414 93.634v4.07h4.071v4.071h-4.07v4.07h-4.071v-4.07h-4.07v-4.07l4.07-.001v-4.07h4.07z'/%3e%3cpath fill='%23CACACA' d='M168.93 0v4.07H173v4.071h-4.07v4.07h-4.071v-4.07h-4.07v-4.07l4.07-.001V0h4.07z'/%3e%3cpath fill='%2300CED3' d='M158.753 20.353v4.07h4.07v4.071h-4.07v4.07h-4.07l-.001-4.07h-4.07v-4.07l4.07-.001v-4.07h4.07z'/%3e%3ccircle cx='129.241' cy='45.794' r='43.759' fill='%23FFEBEC'/%3e%3cpath fill='%23A6A6A6' fill-rule='nonzero' d='M116.967 44.358c-.003-.012-.01-.022-.014-.033a.983.983 0 00-.086-.203c-.015-.027-.037-.048-.055-.074-.032-.044-.063-.089-.102-.128-.026-.025-.057-.046-.086-.068-.032-.026-.061-.055-.097-.078-.008-.005-.018-.007-.026-.011-.008-.005-.014-.012-.023-.017l-18-9.626a1.017 1.017 0 00-.938-.01l-40 20.213c-.014.006-.024.018-.037.026-.016.009-.035.014-.051.024-.03.02-.054.045-.081.068-.027.022-.055.042-.08.067a.926.926 0 00-.105.128c-.017.025-.037.048-.053.074a.961.961 0 00-.08.186c-.006.018-.015.033-.02.05a.98.98 0 00-.033.248v16.363c0 .384.229.733.586.891l19 8.464c.015.007.032.004.047.01A.994.994 0 0077 81c.088 0 .175-.014.26-.036.028-.008.053-.02.081-.03.041-.015.084-.026.123-.047l39-20.014a.974.974 0 00.536-.867v-15.4a.939.939 0 00-.033-.248zM98.013 36L114 44.405 76.81 62 60 54.884 98.013 36zM59 56l17 7.789V78l-17-7.652V56zm19 22V64.197L115 46v13.132L78 78z'/%3e%3c/g%3e%3c/svg%3e";

var _templateObject$D;
var DataNotFoundContainer = styled.div(_templateObject$D || (_templateObject$D = _taggedTemplateLiteral(["\n  ", ";\n\n  align-items: center;\n  padding: ", " ", ";\n\n  p {\n    color: ", ";\n  }\n\n  @media screen and (max-width: ", "px) {\n    border: 1px solid ", ";\n    border-radius: ", ";\n\n    img {\n      height: ", "; ;\n    }\n  }\n"])), flexAsColumn(2), function (_ref) {
  var theme = _ref.theme;
  return theme.spacing(2);
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.spacing(2);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.grayG;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.medium;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.palette.grayB;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.spacing(1);
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.toRem(100);
});

var DataNotFoundContent = function DataNotFoundContent() {
  return jsxs(DataNotFoundContainer, {
    children: [jsx("img", {
      src: img,
      alt: "Sin registros para mostrar.",
      height: 200
    }), jsx("p", {
      children: "Sin registros para mostrar."
    })]
  });
};

var _templateObject$C, _templateObject2$n, _templateObject3$j, _templateObject4$f;
var MobileWrapper = styled.section(_templateObject$C || (_templateObject$C = _taggedTemplateLiteral(["\n  ", ";\n\n  overflow: hidden;\n\n  @media screen and (min-width: ", "px) {\n    display: none;\n  }\n"])), grid(2), function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.medium;
});
var MobileView = styled.div(_templateObject2$n || (_templateObject2$n = _taggedTemplateLiteral(["\n  ", ";\n\n  background-color: white;\n  border: 1px solid ", ";\n  border-radius: ", ";\n\n  &:hover{\n    background-color: ", ";\n  }\n"])), grid(), function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.grayC;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.spacing(0.5);
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.palette.grayA;
});
var MobileRow = styled.div(_templateObject3$j || (_templateObject3$j = _taggedTemplateLiteral(["\n  ", ";\n\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  text-align: right;\n  padding: 1.14em;\n  position: relative;\n\n  &:not(:last-of-type) {\n    border-bottom: 1px solid ", ";\n  }\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.typography.paragraph;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.palette.grayC;
});
var MobileViewTitle = styled.span(_templateObject4$f || (_templateObject4$f = _taggedTemplateLiteral(["\n  font-weight: bold;\n  text-align: left;\n  white-space: wrap;\n"])));

var MobileTableView = function MobileTableView(props) {
  var columns = props.columns,
    rows = props.rows,
    _props$mobileLayout = props.mobileLayout,
    mobileLayout = _props$mobileLayout === void 0 ? undefined : _props$mobileLayout;
  var renderCellContent = function renderCellContent(row, column) {
    var _a;
    if (column.render) {
      return column.render(row);
    }
    return (_a = row[column.field]) !== null && _a !== void 0 ? _a : '';
  };
  var areRowsEmpty = rows.length === 0;
  return jsx(MobileWrapper, {
    children: areRowsEmpty ? jsx(DataNotFoundContent, {}) : rows.map(function (row) {
      return mobileLayout ? mobileLayout(row) : jsx(MobileView, {
        children: columns.map(function (column) {
          return jsxs(MobileRow, {
            children: [jsx(MobileViewTitle, {
              children: column.label
            }), jsx("div", {
              children: renderCellContent(row, column)
            })]
          }, String(row[column.field]));
        })
      }, JSON.stringify(row));
    })
  });
};

var _templateObject$B, _templateObject2$m, _templateObject3$i, _templateObject4$e;
var PaginationContainer = styled.div(_templateObject$B || (_templateObject$B = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n\n  align-items: center;\n\n  @media screen and (min-width: ", "px) {\n    ", ";\n\n    justify-content: space-between;\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.typography.paragraph;
}, flexAsColumn(2), function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.medium;
}, flexAsRow());
var PageLimiter = styled.div(_templateObject2$m || (_templateObject2$m = _taggedTemplateLiteral(["\n  ", ";\n\n  align-items: center;\n\n  div:first-child {\n    width: auto;\n  }\n\n  input {\n    font-weight: bold;\n    width: 2em;\n  }\n\n  svg {\n    height: ", ";\n    width: ", ";\n  }\n"])), flexAsRow(1), function (_ref3) {
  var theme = _ref3.theme;
  return theme.spacing(2);
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.spacing(2);
});
var PaginationButtonsContainer = styled.div(_templateObject3$i || (_templateObject3$i = _taggedTemplateLiteral(["\n  ", ";\n\n  align-items: center;\n"])), flexAsRow(1));
var PaginationButton = styled.button(_templateObject4$e || (_templateObject4$e = _taggedTemplateLiteral(["\n  all: unset;\n  align-items: center;\n  aspect-ratio: 1;\n  border-radius: ", ";\n  color: ", ";\n  cursor: pointer;\n  display: flex;\n  height: ", ";\n  justify-content: center;\n  width: ", ";\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &.activeButton {\n    color: ", ";\n    background-color: ", ";\n    cursor: pointer;\n    font-weight: bold;\n  }\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.spacing(0.5);
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.palette.grayG;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.spacing(4);
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.spacing(4);
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.palette.grayC;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.palette.white;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.palette.primary.main;
});

var VISIBLE_BUTTONS = 4;
var Pagination = function Pagination(props) {
  var limit = props.limit,
    onPageChange = props.onPageChange,
    page = props.page,
    total = props.total;
  var pages = Array.from({
    length: Math.ceil(total / limit)
  }, function (_, index) {
    return index + 1;
  });
  var isPageInFirstPositions = page <= VISIBLE_BUTTONS;
  var isPageInLastPositions = page > pages.length - VISIBLE_BUTTONS;
  var onNewPage = function onNewPage(newPage) {
    if (newPage >= 1 && newPage <= pages.length && onPageChange) {
      onPageChange(newPage);
    }
  };
  var pagesLimit = function pagesLimit() {
    if (page <= VISIBLE_BUTTONS) {
      return pages.slice(0, VISIBLE_BUTTONS);
    }
    if (page >= pages.length - 3) {
      return pages.slice(-VISIBLE_BUTTONS);
    }
    var start = page - 2;
    var end = page + 1;
    return pages.slice(start, end);
  };
  return jsxs(PaginationButtonsContainer, {
    children: [jsx(PaginationButton, {
      onClick: function onClick() {
        return onNewPage(page - 1);
      },
      children: '<'
    }), pages.length <= 5 ? pages.map(function (pageNumber) {
      return jsx(PaginationButton, {
        className: pageNumber === page ? 'activeButton' : '',
        onClick: function onClick() {
          return onNewPage(pageNumber);
        },
        children: pageNumber
      }, pageNumber);
    }) : jsxs(Fragment, {
      children: [jsxs(RenderIf, {
        condition: !isPageInFirstPositions,
        children: [jsx(PaginationButton, {
          className: pages[0] === page ? 'activeButton' : '',
          onClick: function onClick() {
            return onNewPage(pages[0]);
          },
          children: pages[0]
        }), jsx("span", {
          children: "..."
        })]
      }), pagesLimit().map(function (pageNumber) {
        return jsx(PaginationButton, {
          className: pageNumber === page ? 'activeButton' : '',
          onClick: function onClick() {
            return onNewPage(pageNumber);
          },
          children: pageNumber
        }, pageNumber);
      }), jsxs(RenderIf, {
        condition: !isPageInLastPositions,
        children: [jsx("span", {
          children: "..."
        }), jsx(PaginationButton, {
          className: pages[pages.length - 1] === page ? 'activeButton' : '',
          onClick: function onClick() {
            return onNewPage(pages[pages.length - 1]);
          },
          children: pages[pages.length - 1]
        })]
      })]
    }), jsx(PaginationButton, {
      onClick: function onClick() {
        return onNewPage(page + 1);
      },
      children: '>'
    })]
  });
};

var ArrowIcon = function ArrowIcon(props) {
  return /*#__PURE__*/React__default.createElement(SvgIcon, props, /*#__PURE__*/React__default.createElement("path", {
    d: "M3.5 6.866c-.428-.447-1.425-.615-2 0-.5.5-.27 1.485-.075 1.73l8.45 8.324c1.206 1.262 3.152 1.262 4.358 0l8.447-8.747c.428-.448.245-1.384-.18-1.807-.596-.593-1.65-.387-2.078.06l-7.668 8.06c-.389.408-1.011.408-1.44 0L3.5 6.867z"
  }));
};

var CrossIcon = function CrossIcon(props) {
  return /*#__PURE__*/React__default.createElement(SvgIcon, props, /*#__PURE__*/React__default.createElement("path", {
    d: "M21.632 4.168c.49-.496.49-1.3 0-1.796s-1.286-.496-1.777 0l-7.906 7.99-7.804-7.887c-.49-.496-1.286-.496-1.777 0-.49.495-.49 1.3 0 1.795l7.805 7.888L2.68 19.73c-.49.496-.49 1.3 0 1.795.49.496 1.286.496 1.777 0l7.492-7.572 7.594 7.675c.49.496 1.286.496 1.777 0 .49-.496.49-1.3 0-1.796l-7.594-7.674 7.906-7.99z"
  }));
};

var KebabMenuIcon = function KebabMenuIcon(props) {
  return /*#__PURE__*/React__default.createElement(SvgIcon, props, /*#__PURE__*/React__default.createElement("path", {
    d: "M12 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4z M12 20a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
  }));
};

var LeftArrowIcon = function LeftArrowIcon(props) {
  return /*#__PURE__*/React__default.createElement(SvgIcon, props, /*#__PURE__*/React__default.createElement("path", {
    d: "M20.1 9.695c.33-.316.453-1.05 0-1.473-.368-.368-1.094-.199-1.273-.056l-6.13 6.223a2.197 2.197 0 0 0 0 3.21l6.441 6.221c.33.316 1.02.18 1.33-.132.437-.44.286-1.215-.044-1.53l-5.936-5.648c-.3-.286-.3-.745 0-1.06L20.1 9.695z"
  }));
};

var RightArrowIcon = function RightArrowIcon(props) {
  return /*#__PURE__*/React__default.createElement(SvgIcon, props, /*#__PURE__*/React__default.createElement("path", {
    d: "M9.615 18.305c-.33.316-.453 1.05 0 1.473.368.369 1.093.199 1.273.056l6.13-6.223c.93-.889.93-2.322 0-3.21L10.578 4.18c-.33-.316-1.02-.18-1.33.132-.437.44-.286 1.215.044 1.53l5.936 5.648c.3.286.3.745 0 1.06l-5.612 5.755z"
  }));
};

var TurnLeftIcon$1 = function TurnLeftIcon(props) {
  return /*#__PURE__*/React__default.createElement(SvgIcon, props, /*#__PURE__*/React__default.createElement("path", {
    clipRule: "evenodd",
    d: "M3 12.9C3 11.0775 4.26639 9.6 5.82857 9.6H13.3714C14.9336 9.6 16.2 11.0775 16.2 12.9V19.5C16.2 21.3225 14.9336 22.8 13.3714 22.8H5.82857C4.26639 22.8 3 21.3225 3 19.5V12.9ZM5.82857 11.8C5.30785 11.8 4.88571 12.2925 4.88571 12.9V19.5C4.88571 20.1075 5.30785 20.6 5.82857 20.6H13.3714C13.8922 20.6 14.3143 20.1075 14.3143 19.5V12.9C14.3143 12.2925 13.8922 11.8 13.3714 11.8H5.82857Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React__default.createElement("path", {
    clipRule: "evenodd",
    d: "M11.8274 1.50404C12.0991 1.85337 12.044 2.36309 11.7044 2.64253L11.1117 3.13018C12.0832 3.1988 13.1501 3.43231 14.2289 3.91251C16.5155 4.93038 18.7992 7.03145 20.3405 10.8814C20.5061 11.295 20.3143 11.7685 19.9121 11.9388C19.51 12.1091 19.0497 11.9119 18.8841 11.4982C17.4854 8.00424 15.4817 6.23535 13.6034 5.39924C12.5103 4.91265 11.4404 4.73336 10.5263 4.72802L11.7044 5.69749C12.044 5.97695 12.0991 6.48667 11.8274 6.83598C11.5557 7.1853 11.0601 7.24192 10.7205 6.96245L8.09553 4.80236C7.90873 4.64864 7.79999 4.41592 7.8 4.16986C7.80001 3.9238 7.90876 3.69108 8.09556 3.53737L10.7205 1.37751C11.0601 1.09807 11.5557 1.15472 11.8274 1.50404Z",
    fillRule: "evenodd"
  }));
};

var TurnLeftIcon = function TurnLeftIcon(props) {
  return /*#__PURE__*/React__default.createElement(SvgIcon, props, /*#__PURE__*/React__default.createElement("path", {
    clipRule: "evenodd",
    d: "M7.2 12.9C7.2 11.0775 8.4664 9.6 10.0286 9.6H17.5714C19.1336 9.6 20.4 11.0775 20.4 12.9V19.5C20.4 21.3225 19.1336 22.8 17.5714 22.8H10.0286C8.4664 22.8 7.2 21.3225 7.2 19.5V12.9ZM10.0286 11.8C9.50785 11.8 9.08572 12.2925 9.08572 12.9V19.5C9.08572 20.1075 9.50785 20.6 10.0286 20.6H17.5714C18.0922 20.6 18.5143 20.1075 18.5143 19.5V12.9C18.5143 12.2925 18.0922 11.8 17.5714 11.8H10.0286Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React__default.createElement("path", {
    clipRule: "evenodd",
    d: "M11.5726 1.50404C11.3009 1.85337 11.356 2.36309 11.6956 2.64253L12.2883 3.13018C11.3168 3.1988 10.2499 3.43231 9.17108 3.91251C6.88446 4.93038 4.60075 7.03145 3.05952 10.8814C2.89393 11.295 3.0857 11.7685 3.48786 11.9388C3.89002 12.1091 4.35027 11.9119 4.51587 11.4982C5.91459 8.00424 7.9183 6.23535 9.79662 5.39924C10.8897 4.91265 11.9596 4.73336 12.8737 4.72802L11.6956 5.69749C11.356 5.97695 11.3009 6.48667 11.5726 6.83598C11.8443 7.1853 12.3399 7.24192 12.6795 6.96245L15.3045 4.80236C15.4913 4.64864 15.6 4.41592 15.6 4.16986C15.6 3.9238 15.4912 3.69108 15.3044 3.53737L12.6795 1.37751C12.3399 1.09807 11.8443 1.15472 11.5726 1.50404Z",
    fillRule: "evenodd"
  }));
};

var UploadIcon = function UploadIcon(props) {
  return /*#__PURE__*/React__default.createElement(SvgIcon, props, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
    d: "m19.45763,6.14849c-0.2557,-1.5244 -1.00843,-2.91562 -2.15967,-3.97136c-1.27923, -1.17414 -2.94207,-1.82041 -4.67384,-1.82041c-1.33818,0 -2.64192,0.3848 -3.7587, 1.11001c-0.92984,0.60187 -1.70224,1.41587 -2.24834,2.37296c-0.23615,-0.04441 -0.48213, -0.06907 -0.72812,-0.06907c-2.0909,0 -3.79315,1.70695 -3.79315,3.80363c0,0.27132 0.02952, 0.53279 0.07873,0.78934c-1.35294,0.98666 -2.17454,2.57521 -2.17454,4.26735c0,1.36654 0.50673,2.69361 1.43165,3.74451c0.94952,1.07542 2.20406,1.71182 3.54224,1.78584c0.01476,0 0.0246,0 0.03936,0l4.231,0c0.36898,0 0.66417,-0.29607 0.66417,-0.66601c0,-0.37009 -0.29519,-0.66601 -0.66417,-0.66601l-4.21133,0c-2.01218,-0.12336 -3.70458,-2.04245 -3.70458,-4.20327c0,-1.39613 0.7478,-2.69854 1.95315,-3.40403c0.28043,-0.16279 0.3985, -0.5032 0.29027,-0.80906c-0.09839,-0.2664 -0.1476,-0.54761 -0.1476,-0.84854c0,-1.36161 1.10696,-2.47162 2.46481,-2.47162c0.29027,0 0.57562,0.04933 0.84129,0.14799c0.32471, 0.1184 0.68385,-0.02959 0.83143,-0.34041c0.92,-1.95855 2.90759,-3.22148 5.06737, -3.22148c2.90265,0 5.29858,2.18054 5.57416,5.0715c0.02946,0.30094 0.2557,0.54268 0.55102, 0.59201c2.18927,0.37493 3.84233,2.40255 3.84233,4.7163c0,2.45189 -1.92371,4.58309 -4.29496,4.76566l-3.62593,0c-0.36898,0 -0.66417,0.29592 -0.66417,0.66601c0,0.36994 0.29519,0.66601 0.66417,0.66601l3.65045,0c0.0148,0 0.02946,0 0.0492,0c1.50054,-0.10856 2.90268,-0.79924 3.94566,-1.95361c1.03804,-1.14458 1.60386,-2.61472 1.60386, -4.14407c-0.00493,-2.76763 -1.88917,-5.22937 -4.46722,-5.91018z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "m15.94262,13.36149c0.26018,-0.26098 0.26018,-0.6795 0,-0.94046l-3.51123, -3.52053c-0.12276,-0.12311 -0.29465,-0.19696 -0.46652,-0.19696c-0.17189,0 -0.34376, 0.06893 -0.46653,0.19696l-3.51121,3.52053c-0.26027,0.26096 -0.26027,0.67948 0, 0.94046c0.12768,0.12801 0.29955,0.19695 0.46653,0.19695c0.16697,0 0.33884,-0.06401 0.46652,-0.19695l2.38173,-2.38806l0,10.97516c0,0.36934 0.29463,0.66481 0.66296, 0.66481c0.36831,0 0.66294,-0.29547 0.66294,-0.66481l0,-10.97516l2.38173,2.38806c0.2554, 0.26096 0.67274,0.26096 0.93307,0z"
  })));
};

var _templateObject$A, _templateObject2$l, _templateObject3$h, _templateObject4$d, _templateObject5$b;
var StyledInputContainer = styled.div(_templateObject$A || (_templateObject$A = _taggedTemplateLiteral(["\n  ", "\n\n  align-items: center;\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  display: flex;\n  margin: 0;\n  padding: ", ";\n  transition: border-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s;\n\n  & > input {\n    color: inherit;\n    font-family: inherit;\n    font-size: inherit;\n    font-style: inherit;\n    font-weight: inherit;\n    letter-spacing: inherit;\n  }\n\n  &:focus-within {\n    ", ";\n  }\n\n  ", ";\n\n  ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.form.font();
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.primary.contrastText;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.grayE;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.borderRadius();
}, function (_ref5) {
  var theme = _ref5.theme;
  return "0 ".concat(theme.spacing(1));
}, function (_ref6) {
  var error = _ref6.error;
  return !error && css(_templateObject2$l || (_templateObject2$l = _taggedTemplateLiteral(["\n      ", ";\n    "])), function (_ref7) {
    var theme = _ref7.theme;
    return theme.form.focus();
  });
}, function (_ref8) {
  var disabled = _ref8.disabled;
  return disabled && css(_templateObject3$h || (_templateObject3$h = _taggedTemplateLiteral(["\n    color: ", ";\n    border: 1px solid ", ";\n    background: ", ";\n  "])), function (_ref9) {
    var theme = _ref9.theme;
    return theme.palette.disabled.contrast;
  }, function (_ref10) {
    var theme = _ref10.theme;
    return theme.palette.disabled.contrast;
  }, function (_ref11) {
    var theme = _ref11.theme;
    return theme.palette.disabled.main;
  });
}, function (_ref12) {
  var error = _ref12.error;
  return error && css(_templateObject4$d || (_templateObject4$d = _taggedTemplateLiteral(["\n    border: 2px solid ", ";\n    box-shadow: none;\n  "])), function (_ref13) {
    var theme = _ref13.theme;
    return theme.palette.danger.main;
  });
});
var StyledInput = styled.input(_templateObject5$b || (_templateObject5$b = _taggedTemplateLiteral(["\n  border: none;\n  height: 2.5em;\n  outline: none;\n  padding: 0;\n  width: 100%;\n"])));

var _excluded$n = ["id", "name", "value", "type", "disabled", "placeholder", "required", "className", "onChange", "onBlur", "focus", "startAdornment", "endAdornment", "inputProps"];
var Input = function Input(props) {
  var id = props.id,
    name = props.name,
    value = props.value,
    type = props.type,
    disabled = props.disabled,
    placeholder = props.placeholder,
    required = props.required,
    className = props.className,
    onChange = props.onChange,
    onBlur = props.onBlur,
    focus = props.focus,
    startAdornment = props.startAdornment,
    endAdornment = props.endAdornment,
    inputProps = props.inputProps,
    restProps = _objectWithoutProperties(props, _excluded$n);
  return /*#__PURE__*/React__default.createElement(StyledInputContainer, _extends$3({}, restProps, {
    disabled: disabled,
    className: className
  }), /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: Boolean(startAdornment)
  }, startAdornment), /*#__PURE__*/React__default.createElement(StyledInput, _extends$3({
    id: id,
    name: name,
    value: value,
    type: type,
    disabled: disabled,
    placeholder: placeholder,
    required: required,
    onChange: onChange,
    onBlur: onBlur,
    autoFocus: focus
  }, inputProps)), /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: Boolean(endAdornment)
  }, endAdornment));
};
Input.defaultProps = {
  id: '',
  name: '',
  value: undefined,
  type: 'text',
  disabled: false,
  placeholder: '',
  required: false,
  className: '',
  onChange: function onChange() {},
  onBlur: function onBlur() {},
  focus: false,
  error: false,
  startAdornment: null,
  endAdornment: null,
  inputProps: {}
};
Input.propTypes = {
  /**
   * Id assigned to input.
   */
  id: PropTypes.string,
  /**
   * Name attribute of the `input` element.
  */
  name: PropTypes.string,
  /**
   * The value of the input
   */
  value: PropTypes.string,
  /**
   * This is any valid HTML input type
   */
  type: PropTypes.string,
  /**
  * Apply styles to the input to display it as unusable and unclickable
  */
  disabled: PropTypes.bool,
  /**
   * Brief description about the expected value
   */
  placeholder: PropTypes.string,
  /**
   * If true the input element would be required
   */
  required: PropTypes.bool,
  /**
   * Whether this field should be displayed in error state
   */
  error: PropTypes.bool,
  /**
   * Class to apply on input container
   */
  className: PropTypes.string,
  /**
   * Function to execute when the value has changed
   */
  onChange: PropTypes.func,
  /**
   * Function to execute when input is blurred
   */
  onBlur: PropTypes.func,
  /**
   * Function to execute when input was required initial focus
   */
  focus: PropTypes.bool,
  /**
   * This will be display at the left side of the input
   */
  startAdornment: PropTypes.node,
  /**
   * This will be display at the right side of the input
   */
  endAdornment: PropTypes.node,
  /**
   * Attributtes applied to the HTML input element
   */
  inputProps: PropTypes.shape({})
};

var _templateObject$z, _templateObject2$k, _templateObject3$g;
var StyledInputAdornment = styled.span(_templateObject$z || (_templateObject$z = _taggedTemplateLiteral(["\n  ", ";\n\n  ", ";\n\n  ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.form.font();
}, function (_ref2) {
  var position = _ref2.position,
    theme = _ref2.theme;
  return position === 'start' && css(_templateObject2$k || (_templateObject2$k = _taggedTemplateLiteral(["\n    margin-right: ", ";\n  "])), theme.spacing(1));
}, function (_ref3) {
  var position = _ref3.position,
    theme = _ref3.theme;
  return position === 'end' && css(_templateObject3$g || (_templateObject3$g = _taggedTemplateLiteral(["\n    margin-left: ", ";\n  "])), theme.spacing(1));
});

var _excluded$m = ["children"];
var POSITIONS = ['start', 'end'];
var InputAdornment = function InputAdornment(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$m);
  return /*#__PURE__*/React__default.createElement(StyledInputAdornment, props, children);
};
InputAdornment.defaultProps = {
  position: '',
  children: null
};
InputAdornment.propTypes = {
  /**
   * This is the content to be displayed inside button
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  /**
   * The position to take according to the input
   */
  position: PropTypes.oneOf(POSITIONS)
};

var _templateObject$y, _templateObject2$j, _templateObject3$f, _templateObject4$c, _templateObject5$a, _templateObject6$6, _templateObject7$4;
var rotate = keyframes(_templateObject$y || (_templateObject$y = _taggedTemplateLiteral(["\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n"])));
var StyledIconButton = styled.button(_templateObject2$j || (_templateObject2$j = _taggedTemplateLiteral(["\n  background: transparent;\n  border: 1px solid transparent;\n  border-radius: ", ";\n  box-sizing: border-box;\n  cursor: pointer;\n  outline: none;\n  padding: 0;\n  position: relative;\n\n  ", ";\n\n  &:hover {\n    background: ", ";\n  }\n\n  &:focus {\n    ", ";\n  }\n\n  &:active {\n    background: transparent;\n\n    ", ";\n  }\n\n  &:disabled {\n    pointer-events: none;\n  }\n\n  ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.borderRadius();
}, function (_ref2) {
  var bordered = _ref2.bordered,
    theme = _ref2.theme;
  return bordered && css(_templateObject3$f || (_templateObject3$f = _taggedTemplateLiteral(["\n    border: 1px solid ", ";\n  "])), theme.palette.grayC);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.grayC;
}, function (_ref4) {
  var disableFocus = _ref4.disableFocus,
    theme = _ref4.theme;
  return !disableFocus && css(_templateObject4$c || (_templateObject4$c = _taggedTemplateLiteral(["\n      ", ";\n    "])), theme.form.focus());
}, function (_ref5) {
  var disableFocus = _ref5.disableFocus,
    theme = _ref5.theme;
  return disableFocus && css(_templateObject5$a || (_templateObject5$a = _taggedTemplateLiteral(["\n      background: ", ";\n    "])), theme.palette.grayC);
}, function (_ref6) {
  var isLoading = _ref6.isLoading,
    theme = _ref6.theme,
    _ref6$color = _ref6.color,
    color = _ref6$color === void 0 ? '' : _ref6$color;
  return isLoading && css(_templateObject6$6 || (_templateObject6$6 = _taggedTemplateLiteral(["\n    color: transparent;\n    pointer-events: none;\n\n    & > * {\n      &:not(.loader) {\n        visibility: hidden;\n      }\n    }\n\n    .loader {\n      animation: ", " 1s linear infinite;\n      border-radius: 50%;\n      border: 3px solid;\n      bottom: 0;\n      height: 1em;\n      left: 0;\n      margin: auto;\n      position: absolute;\n      right: 0;\n      top: 0;\n      width: 1em;\n      border-color: ", "\n\n      ", ";\n\n      border-top-color: transparent;\n    }\n  "])), rotate, color ? theme.palette[color].main : theme.palette.icon["default"], function (_ref7) {
    var _ref7$size = _ref7.size,
      size = _ref7$size === void 0 ? 'regular' : _ref7$size;
    return size === 'small' && css(_templateObject7$4 || (_templateObject7$4 = _taggedTemplateLiteral(["\n        width: 0.5em;\n        height: 0.5em;\n      "])));
  });
});

var _excluded$l = ["children", "disabled", "id", "isLoading", "color", "size", "disableFocus"];
var marketplace = styles.marketplace;
var ICON_SIZES = ['extraSmall', 'small', 'medium', 'large'];
var IconButton = function IconButton(props) {
  var children = props.children,
    disabled = props.disabled,
    _props$id = props.id,
    id = _props$id === void 0 ? '' : _props$id,
    isLoading = props.isLoading,
    color = props.color,
    size = props.size,
    disableFocus = props.disableFocus,
    restProps = _objectWithoutProperties(props, _excluded$l);
  var buttonProps = {};
  if (disableFocus) {
    buttonProps.tabIndex = '-1';
  }
  var getChildrenWithProps = function getChildrenWithProps() {
    var themeColor = marketplace.palette[color] || '';
    var childrenProps = {
      disabled: disabled,
      color: color ? themeColor.main : '',
      size: size
    };
    return React__default.Children.map(children, function (child) {
      if ( /*#__PURE__*/React__default.isValidElement(child)) {
        return /*#__PURE__*/React__default.cloneElement(child, childrenProps);
      }
      return child;
    });
  };
  return /*#__PURE__*/React__default.createElement(StyledIconButton, _extends$3({}, restProps, buttonProps, {
    disabled: disabled,
    id: id,
    isLoading: isLoading,
    color: color,
    disableFocus: disableFocus
  }), getChildrenWithProps(), isLoading && /*#__PURE__*/React__default.createElement("div", {
    className: "loader",
    role: "status"
  }));
};
IconButton.propTypes = {
  /**
   * This is the content to be displayed inside icon button
   */
  children: PropTypes.node,
  /**
   * Define type of button
   */
  type: PropTypes.string,
  /**
   * Apply styles to the button to display it as unusable and unclickable
   */
  disabled: PropTypes.bool,
  /**
   * The color to display on the icon. The value should be a string with the name
   * of a valid color in the theme palette.
   */
  color: PropTypes.string,
  /**
   * Identifier for semantical purposes
   * */
  id: PropTypes.string,
  /**
   * This attribute hides the button text and displays a loading spinner instead. When this
   * attribute is true the onClick handler will not be executed.
   */
  isLoading: PropTypes.bool,
  /**
   * Function to execute when the button is clicked
   */
  onClick: PropTypes.func,
  /**
   * Define the dimensions of the button
   */
  size: PropTypes.oneOf(ICON_SIZES),
  /**
   * If true, the button would have a grey border
   */
  bordered: PropTypes.bool,
  /**
   * If true, set the attribute tabIndex to -1 and focus styles are removed
   */
  disableFocus: PropTypes.bool
};
IconButton.defaultProps = {
  type: 'button',
  children: null,
  disabled: false,
  color: '',
  id: '',
  isLoading: false,
  onClick: function onClick() {},
  size: 'medium',
  bordered: false,
  disableFocus: false
};

var OutsideClickHandler = function OutsideClickHandler(props) {
  var children = props.children,
    handleOutsideClick = props.handleOutsideClick;
  var ref = useRef(null);
  useEffect(function () {
    var handleClickOutside = function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        handleOutsideClick();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, handleOutsideClick]);
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.cloneElement(children, {
    ref: ref
  }));
};
OutsideClickHandler.defaultProps = {
  children: null,
  handleOutsideClick: function handleOutsideClick() {}
};
OutsideClickHandler.propTypes = {
  /**
  * This is the content to be wrapped by the component
  */
  children: PropTypes.node,
  /**
  * Callback to execute when click outside the component
  */
  handleOutsideClick: PropTypes.func
};

var _templateObject$x, _templateObject2$i, _templateObject3$e, _templateObject4$b, _templateObject5$9, _templateObject6$5, _templateObject7$3, _templateObject8$3, _templateObject9$2, _templateObject10$2;
var StyledSelectField = styled.div(_templateObject$x || (_templateObject$x = _taggedTemplateLiteral(["\n  ", ";\n\n  display: flex;\n  flex-direction: column;\n\n  width: 100%;\n  position: relative;\n\n  & * {\n    box-sizing: border-box;\n  }\n\n  .input {\n    background-color: ", ";\n\n    &.disabled {\n      color: ", ";\n      border: 1px solid ", ";\n      background: ", ";\n    }\n  }\n\n  ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.form.font();
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.background.hbBackgroundA;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.disabled.contrast;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.palette.disabled.contrast;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.palette.disabled.main;
}, function (_ref6) {
  var searchable = _ref6.searchable;
  return !searchable && css(_templateObject2$i || (_templateObject2$i = _taggedTemplateLiteral(["\n    cursor: pointer;\n\n    .read-only-field {\n      pointer-events: none;\n    }\n  "])));
});
var StyledDropdown = styled.div(_templateObject3$e || (_templateObject3$e = _taggedTemplateLiteral(["\n  position: relative;\n"])));
var StyledOptionList = styled.ol(_templateObject4$b || (_templateObject4$b = _taggedTemplateLiteral(["\n  position: absolute;\n  top: ", ";\n\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  box-shadow: 0 0 6px 0 rgba(61, 61, 61, 0.1);\n  list-style: none;\n  margin: 8px 0;\n  max-height: 240px;\n  overflow: auto;\n  padding: ", " 0;\n  width: 100%;\n  z-index: 999999;\n\n  ", ";\n"])), function (_ref7) {
  var theme = _ref7.theme;
  return theme.spacing(5);
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.palette.background.hbBackgroundA;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.palette.grayC;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.borderRadius();
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.spacing(1);
}, function (_ref12) {
  var theme = _ref12.theme,
    placement = _ref12.placement,
    helperText = _ref12.helperText;
  return placement === 'top' && css(_templateObject5$9 || (_templateObject5$9 = _taggedTemplateLiteral(["\n    top: inherit;\n    bottom: ", ";\n  "])), helperText.length > 0 ? theme.spacing(8) : theme.spacing(5));
});
var StyledOptionListItem = styled.li(_templateObject6$5 || (_templateObject6$5 = _taggedTemplateLiteral(["\n  padding: ", ";\n  cursor: pointer;\n\n  ", ";\n\n  ", ";\n"])), function (_ref13) {
  var theme = _ref13.theme;
  return "".concat(theme.spacing(1), " ").concat(theme.spacing(3));
}, function (_ref14) {
  var highlighted = _ref14.highlighted;
  return highlighted && css(_templateObject7$3 || (_templateObject7$3 = _taggedTemplateLiteral(["\n    background: ", ";\n  "])), function (_ref15) {
    var theme = _ref15.theme;
    return theme.palette.info.lightest;
  });
}, function (_ref16) {
  var selected = _ref16.selected;
  return selected && css(_templateObject8$3 || (_templateObject8$3 = _taggedTemplateLiteral(["\n    background: ", ";\n    color: ", ";\n  "])), function (_ref17) {
    var theme = _ref17.theme;
    return theme.palette.info.main;
  }, function (_ref18) {
    var theme = _ref18.theme;
    return theme.palette.info.contrastText;
  });
});
var StyledEmptyList = styled.li(_templateObject9$2 || (_templateObject9$2 = _taggedTemplateLiteral(["\n  padding: ", ";\n  color: ", ";\n"])), function (_ref19) {
  var theme = _ref19.theme;
  return "".concat(theme.spacing(1), " ").concat(theme.spacing(3));
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.palette.disabled.contrast;
});
var ContainerIcons = styled.div(_templateObject10$2 || (_templateObject10$2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));

function ownKeys$6(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$6(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$6(Object(t), !0).forEach(function (r) { _defineProperty$1(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$6(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var KEY_VALUES = {
  arrowDown: 'ArrowDown',
  arrowUp: 'ArrowUp',
  end: 'End',
  enter: 'Enter',
  esc: 'Escape',
  home: 'Home',
  pageDown: 'PageDown',
  pageUp: 'PageUp',
  tab: 'Tab'
};
var OPTION_LIST_PLACEMENTS = ['top', 'bottom'];
var searchOption = function searchOption() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return options.filter(function (option) {
    var label = option.label;
    var cleanedValue = cleanText(value);
    var cleanedLabel = cleanText(String(label));
    return cleanedLabel.startsWith(cleanedValue) || cleanedLabel.includes(cleanedValue);
  });
};
var SelectField = function SelectField(props) {
  var id = props.id,
    name = props.name,
    label = props.label,
    options = props.options,
    disabled = props.disabled,
    placeholder = props.placeholder,
    required = props.required,
    className = props.className,
    error = props.error,
    searchable = props.searchable,
    helperText = props.helperText,
    selectedOption = props.selectedOption,
    optionListPlacement = props.optionListPlacement,
    filterOptions = props.filterOptions,
    onChange = props.onChange,
    onBlur = props.onBlur,
    focus = props.focus,
    handleOptionClick = props.handleOptionClick,
    InputLabelProps = props.InputLabelProps,
    InputProps = props.InputProps,
    inputProps = props.inputProps,
    FormFieldHelperTextProps = props.FormFieldHelperTextProps;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFocused = _useState2[0],
    setIsFocused = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isOptionListOpen = _useState4[0],
    setIsOptionListOpen = _useState4[1];
  var _useState5 = useState(-1),
    _useState6 = _slicedToArray(_useState5, 2),
    optionIndex = _useState6[0],
    setOptionIndex = _useState6[1];
  var _useState7 = useState(selectedOption.label || ''),
    _useState8 = _slicedToArray(_useState7, 2),
    inputValue = _useState8[0],
    setInputValue = _useState8[1];
  var _useState9 = useState(options),
    _useState10 = _slicedToArray(_useState9, 2),
    filteredOptions = _useState10[0],
    setFilteredOptions = _useState10[1];
  var inputRef = useRef(null);
  var optionListRef = useRef(null);
  useEffect(function () {
    setFilteredOptions(options);
  }, [options]);
  var helperTextId = error ? "".concat(id, "-error-text") : "".concat(id, "-helper-text");
  var scrollToListOption = useCallback(function (nextOptionIndex) {
    var list = optionListRef.current;
    if (!list) {
      return;
    }
    var option = optionListRef.current.querySelector("[data-option-index=\"".concat(nextOptionIndex, "\"]"));
    if (!option) {
      return;
    }
    var isListScrollable = list.scrollHeight > list.clientHeight;
    if (!isListScrollable) {
      return;
    }
    var listHeight = list.clientHeight + list.scrollTop;
    var optionBottom = option.offsetTop + option.offsetHeight;
    var isOptionBottomHidden = optionBottom > listHeight;
    var isOptionTopHidden = option.offsetTop - option.offsetHeight < list.scrollTop;
    if (isOptionBottomHidden) {
      list.scrollTop = optionBottom - list.clientHeight;
    } else if (isOptionTopHidden) {
      list.scrollTop = option.offsetTop - option.offsetHeight;
    }
  }, []);
  var openOptionList = function openOptionList() {
    setIsOptionListOpen(true);
    inputRef.current.focus();
    var isSelectedOptionEmpty = !Object.keys(selectedOption).length;
    if (isSelectedOptionEmpty && !searchable) {
      setInputValue('');
    }
  };
  var closeOptionList = function closeOptionList() {
    if (!filteredOptions.length) {
      setInputValue('');
    }
    setIsOptionListOpen(false);
    setOptionIndex(-1);
    setFilteredOptions(options);
  };
  var selectOption = function selectOption(option) {
    if (!isFocused && searchable) {
      setIsFocused(true);
    }
    setInputValue(option.label);
    if (handleOptionClick) {
      handleOptionClick(option);
    }
    closeOptionList();
    inputRef.current.focus();
  };
  var createOnChangeEvent = function createOnChangeEvent(event, option) {
    var nativeEvent = event.nativeEvent || event;
    var clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
    Object.defineProperty(clonedEvent, 'target', {
      writable: true,
      value: {
        value: option,
        name: name
      }
    });
    onChange(clonedEvent);
  };
  var createOnBlurEvent = function createOnBlurEvent(event) {
    var nativeEvent = event.nativeEvent || event;
    var clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
    if (options[optionIndex]) {
      Object.defineProperty(clonedEvent, 'target', {
        writable: true,
        value: {
          value: options[optionIndex],
          name: name
        }
      });
      onBlur(clonedEvent);
    }
  };
  var getNewOptionIndex = function getNewOptionIndex(direction) {
    if (direction === 'next') {
      return optionIndex === filteredOptions.length - 1 ? 0 : optionIndex + 1;
    }
    return optionIndex === 0 ? filteredOptions.length - 1 : optionIndex - 1;
  };
  var handleOnKeyDownInOpenedList = function handleOnKeyDownInOpenedList(event) {
    var key = event.key;
    switch (key) {
      case KEY_VALUES.enter:
        {
          event.preventDefault();
          selectOption(filteredOptions[optionIndex]);
          createOnChangeEvent(event, filteredOptions[optionIndex]);
          break;
        }
      case KEY_VALUES.arrowDown:
        {
          event.preventDefault();
          var newOptionIndex = getNewOptionIndex('next');
          setOptionIndex(newOptionIndex);
          scrollToListOption(newOptionIndex);
          break;
        }
      case KEY_VALUES.arrowUp:
        {
          event.preventDefault();
          var _newOptionIndex = getNewOptionIndex('previous');
          setOptionIndex(_newOptionIndex);
          scrollToListOption(_newOptionIndex);
          break;
        }
      case KEY_VALUES.esc:
        {
          closeOptionList();
          inputRef.current.focus();
          break;
        }
      case KEY_VALUES.home:
        {
          event.preventDefault();
          setOptionIndex(0);
          scrollToListOption(0);
          break;
        }
      case KEY_VALUES.end:
        {
          event.preventDefault();
          setOptionIndex(filteredOptions.length - 1);
          scrollToListOption(filteredOptions.length - 1);
          break;
        }
      case KEY_VALUES.pageUp:
        {
          event.preventDefault();
          var scrollingDistance = 5;
          var isBeforeFirstIndex = optionIndex - scrollingDistance > 0;
          var nextIndex = isBeforeFirstIndex ? optionIndex - scrollingDistance : 0;
          setOptionIndex(nextIndex);
          scrollToListOption(nextIndex);
          break;
        }
      case KEY_VALUES.pageDown:
        {
          event.preventDefault();
          var _scrollingDistance = 5;
          var lastIndex = filteredOptions.length - 1;
          var isAfterLastIndex = optionIndex + _scrollingDistance < lastIndex;
          var _nextIndex = isAfterLastIndex ? optionIndex + _scrollingDistance : lastIndex;
          setOptionIndex(_nextIndex);
          scrollToListOption(_nextIndex);
          break;
        }
      case KEY_VALUES.tab:
        {
          closeOptionList();
          break;
        }
    }
  };
  var handleOnKeyDownInClosedList = function handleOnKeyDownInClosedList(event) {
    var key = event.key;
    if (KEY_VALUES.enter === key || KEY_VALUES.arrowDown === key) {
      event.preventDefault();
      openOptionList();
    }
  };
  var handleOnKeyDownInput = function handleOnKeyDownInput(event) {
    if (isOptionListOpen) {
      handleOnKeyDownInOpenedList(event);
      return;
    }
    handleOnKeyDownInClosedList(event);
  };
  var handleButtonClick = function handleButtonClick() {
    inputRef.current.focus();
  };
  var handleMouseOver = function handleMouseOver(event) {
    var index = Number(event.currentTarget.getAttribute('data-option-index'));
    setOptionIndex(index);
  };
  var handleClick = function handleClick(option) {
    return function (event) {
      event.stopPropagation();
      selectOption(option);
      createOnChangeEvent(event, option);
    };
  };
  var handleSelectFieldClick = function handleSelectFieldClick() {
    if (isOptionListOpen) {
      closeOptionList();
      inputRef.current.focus();
      return;
    }
    openOptionList();
  };
  var handleInputChange = function handleInputChange(event) {
    var value = event.target.value;
    setInputValue(value);
    if (filterOptions) {
      setFilteredOptions(filterOptions(value));
    } else {
      setFilteredOptions(searchOption(options, value));
    }
    if (!isOptionListOpen) {
      openOptionList();
    }
    if (!isFocused) {
      setIsFocused(true);
    }
  };
  var handleClearText = function handleClearText(event) {
    setInputValue('');
    setFilteredOptions(options);
    if (!isOptionListOpen) {
      setIsOptionListOpen(true);
    }
    inputRef.current.focus();
    event.stopPropagation();
  };
  var handleOutside = function handleOutside() {
    if (isFocused) {
      setIsFocused(false);
    }
    closeOptionList();
  };
  var handleFocus = function handleFocus() {
    if (!isFocused) {
      setIsFocused(true);
    }
  };
  var getInputProps = function getInputProps() {
    var propertiess = {
      id: id,
      name: name,
      value: inputValue,
      placeholder: placeholder,
      disabled: disabled,
      error: error,
      required: required,
      inputProps: _objectSpread$6({
        ref: inputRef,
        readOnly: !searchable,
        onKeyDown: handleOnKeyDownInput,
        onFocus: handleFocus,
        autoComplete: 'off'
      }, inputProps)
    };
    var inputClassName = 'input';
    if (disabled) {
      inputClassName += ' disabled';
    }
    if (searchable) {
      propertiess.onChange = handleInputChange;
    } else {
      inputClassName += ' read-only-field';
    }
    propertiess.className = inputClassName;
    if (helperText) {
      propertiess['aria-describedby'] = helperTextId;
    }
    return propertiess;
  };
  var getButtonProps = function getButtonProps() {
    var propertiess = {
      disableFocus: true,
      disabled: disabled,
      'aria-label': 'arrow-icon-button'
    };
    if (searchable) {
      propertiess.onClick = handleButtonClick;
    }
    return propertiess;
  };
  var getSelectFieldProps = function getSelectFieldProps() {
    var propertiess = {
      role: 'combobox',
      searchable: searchable,
      'aria-expanded': isOptionListOpen,
      'aria-controls': 'list-option'
    };
    if (!disabled) {
      propertiess.onClick = handleSelectFieldClick;
    }
    return propertiess;
  };
  useEffect(function () {
    var getSelectedOptionIndex = function getSelectedOptionIndex() {
      return options.findIndex(function (option) {
        return option.id === selectedOption.id;
      });
    };
    if (isOptionListOpen) {
      var index = selectedOption.id ? getSelectedOptionIndex() : 0;
      setOptionIndex(index);
      if (index) {
        scrollToListOption(index);
      }
    }
    if (!isOptionListOpen && filterOptions) {
      setFilteredOptions(options);
    }
    if (selectedOption.id) {
      setInputValue(selectedOption.label);
    }
    if (!selectedOption.id && !isOptionListOpen && filterOptions) {
      setInputValue('');
    }
  }, [isOptionListOpen, scrollToListOption, selectedOption, options, filterOptions]);
  var isVisible = searchable && inputValue !== '' && isFocused;
  return /*#__PURE__*/React__default.createElement(OutsideClickHandler, {
    handleOutsideClick: handleOutside
  }, /*#__PURE__*/React__default.createElement(StyledSelectField, _extends$3({}, getSelectFieldProps(), {
    className: className
  }), /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: Boolean(label)
  }, /*#__PURE__*/React__default.createElement(InputLabel, _extends$3({
    htmlFor: id
  }, InputLabelProps, {
    required: required
  }), label)), /*#__PURE__*/React__default.createElement(StyledDropdown, {
    disabled: disabled
  }, /*#__PURE__*/React__default.createElement(Input, _extends$3({
    onBlur: createOnBlurEvent,
    focus: focus
  }, getInputProps(), InputProps, {
    endAdornment: /*#__PURE__*/React__default.createElement(InputAdornment, {
      position: "end"
    }, /*#__PURE__*/React__default.createElement(ContainerIcons, null, /*#__PURE__*/React__default.createElement(RenderIf, {
      condition: isVisible
    }, /*#__PURE__*/React__default.createElement(IconButton, {
      disableFocus: true,
      "aria-label": "Borrar",
      onClick: handleClearText
    }, /*#__PURE__*/React__default.createElement(CrossIcon, null))), /*#__PURE__*/React__default.createElement(IconButton, getButtonProps(), /*#__PURE__*/React__default.createElement(ArrowIcon, null))))
  })), /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: Boolean(helperText)
  }, /*#__PURE__*/React__default.createElement(FormFieldHelperText, _extends$3({
    error: error
  }, FormFieldHelperTextProps, {
    id: helperTextId
  }), helperText)), /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: isOptionListOpen
  }, /*#__PURE__*/React__default.createElement(StyledOptionList, {
    role: "listbox",
    ref: optionListRef,
    placement: optionListPlacement,
    id: "list-option",
    label: label,
    helperText: helperText
  }, /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: filteredOptions.length > 0
  }, filteredOptions.map(function (option, index) {
    return /*#__PURE__*/React__default.createElement(StyledOptionListItem, {
      key: option.id,
      highlighted: optionIndex === index,
      selected: selectedOption.id === option.id,
      role: "option",
      "data-option-index": index,
      onClick: handleClick(option),
      onMouseOver: handleMouseOver
    }, option.label);
  })), /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: !filteredOptions.length > 0
  }, /*#__PURE__*/React__default.createElement(StyledEmptyList, null, "Sin opciones para mostrar")))))));
};
SelectField.defaultProps = {
  id: '',
  name: '',
  label: '',
  options: [],
  selectedOption: {},
  optionListPlacement: 'bottom',
  disabled: false,
  placeholder: '',
  searchable: false,
  helperText: '',
  required: false,
  error: false,
  className: '',
  filterOptions: null,
  handleOptionClick: null,
  onChange: function onChange() {},
  onBlur: function onBlur() {},
  focus: false,
  InputLabelProps: {},
  InputProps: {},
  inputProps: {},
  FormFieldHelperTextProps: {}
};
SelectField.propTypes = {
  /**
   * Id assigned to input. This id is also used to make accessible the label and helperText.
   */
  id: PropTypes.string,
  /**
   * Name attribute of the `input` element.
    */
  name: PropTypes.string,
  /**
   * The text to display as the label associated with input control
   */
  label: PropTypes.string,
  /**
    * All options that user can select
    */
  options: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string
  })),
  /**
   * Option to be displayed as selected, must be one element of options.
   */
  selectedOption: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string
  }),
  /**
   * Position where the option list will be displayed
   */
  optionListPlacement: PropTypes.oneOf(OPTION_LIST_PLACEMENTS),
  /**
  * Apply styles to the input to display it as unusable and unclickable
  */
  disabled: PropTypes.bool,
  /**
   * Brief description about the expected value
   */
  placeholder: PropTypes.string,
  /**
    * If true, the user will be able to search for matching options
    */
  searchable: PropTypes.bool,
  /**
   * Provides additional information about the field
   */
  helperText: PropTypes.string,
  /**
   * If true the input element would be required
   */
  required: PropTypes.bool,
  /**
   * Whether this field should be displayed in error state
   */
  error: PropTypes.bool,
  /**
   * Class to apply on input container
   */
  className: PropTypes.string,
  /**
   * Function to filter options that match the search
   */
  filterOptions: PropTypes.func,
  /**
   * function to be called when an option is clicked
   */
  handleOptionClick: PropTypes.func,
  /**
   * Function to execute when the value has changed
    * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * Function to execute when input is blurred
   */
  onBlur: PropTypes.func,
  /**
   * Function to execute when input was required initial focus
   */
  focus: PropTypes.bool,
  /**
   * Props applied on InputLabel component
   */
  InputLabelProps: PropTypes.shape({}),
  /**
   * Props applied on Input component
   */
  InputProps: PropTypes.shape({}),
  /**
   * Props applied on HTML input element
   */
  inputProps: PropTypes.shape({}),
  /**
   * Props applied on InputLabel component
   */
  FormFieldHelperTextProps: PropTypes.shape({})
};

var _templateObject$w, _templateObject2$h, _templateObject3$d, _templateObject4$a, _templateObject5$8, _templateObject6$4;
var DataTableContainer = styled.div(_templateObject$w || (_templateObject$w = _taggedTemplateLiteral(["\n  ", ";\n\n  @media screen and (min-width: ", "px) {\n    gap: ", ";\n  }\n"])), grid(2), function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.medium;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.spacing(2);
});
var TableContainer = styled.div(_templateObject2$h || (_templateObject2$h = _taggedTemplateLiteral(["\n  ", ";\n\n  @media screen and (min-width: ", "px) {\n    border: 1px solid ", ";\n    border-radius: ", ";\n    overflow: hidden;\n  }\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.typography.paragraph;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.medium;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.palette.grayC;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.spacing(0.5);
});
var Table = styled.table(_templateObject3$d || (_templateObject3$d = _taggedTemplateLiteral(["\n  display: none;\n  border-collapse: collapse;\n  border-spacing: 0;\n  width: 100%;\n\n  @media screen and (min-width: ", "px) {\n    display: table;\n  }\n"])), function (_ref7) {
  var theme = _ref7.theme;
  return theme.breakpoints.medium;
});
var TableHead = styled.thead(_templateObject4$a || (_templateObject4$a = _taggedTemplateLiteral(["\n  background-color: ", ";\n\n  > tr {\n    > th {\n      font-family: ", ";\n      padding: ", " ", ";\n    }\n  }\n"])), function (_ref8) {
  var theme = _ref8.theme;
  return theme.palette.grayB;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.typography.title.h3.fontFamily;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.spacing(2);
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.spacing(1);
});
var TableBody = styled.tbody(_templateObject5$8 || (_templateObject5$8 = _taggedTemplateLiteral(["\n  background-color: white;\n"])));
var TableRow = styled.tr(_templateObject6$4 || (_templateObject6$4 = _taggedTemplateLiteral(["\n  &:has(> td):hover {\n    background-color: ", ";\n  }\n\n  &:not(:last-of-type) {\n    border-bottom: 1px solid ", ";\n  }\n\n  > td {\n    padding: 1.14em 0.57em;\n    white-space: nowrap;\n  }\n\n  [data-align=\"left\"] {\n    text-align: left;\n  }\n\n  [data-align=\"center\"] {\n    text-align: center;\n  }\n\n  [data-align=\"right\"] {\n    text-align: right;\n  }\n"])), function (_ref12) {
  var theme = _ref12.theme;
  return theme.palette.grayA;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.palette.grayC;
});

var TableColumns = function TableColumns(_ref) {
  var columns = _ref.columns;
  return jsx(TableHead, {
    children: jsx(TableRow, {
      children: columns === null || columns === void 0 ? void 0 : columns.map(function (_ref2) {
        var align = _ref2.align,
          label = _ref2.label;
        return jsx("th", {
          "data-align": align !== null && align !== void 0 ? align : 'left',
          children: label
        }, label);
      })
    })
  });
};

var TableContent = function TableContent(_ref) {
  var columns = _ref.columns,
    rows = _ref.rows;
  var renderCellContent = function renderCellContent(row, column) {
    var _a;
    if (column.render) {
      return column.render(row);
    }
    return (_a = row[column.field]) !== null && _a !== void 0 ? _a : '';
  };
  return jsxs(TableBody, {
    children: [jsx(RenderIf, {
      condition: rows.length === 0,
      children: jsx(TableRow, {
        children: jsx("td", {
          colSpan: columns.length,
          children: jsx(DataNotFoundContent, {})
        })
      })
    }), rows.map(function (row) {
      return jsx(TableRow, {
        children: columns.map(function (column) {
          var _a;
          return jsx("td", {
            "data-align": (_a = column.align) !== null && _a !== void 0 ? _a : 'left',
            children: renderCellContent(row, column)
          }, column.label);
        })
      }, JSON.stringify(row));
    })]
  });
};

var PAGE_LIMITS = [10, 20, 50, 100];
var DataTable = function DataTable(props) {
  var _a;
  var className = props.className,
    columns = props.columns,
    mobileLayout = props.mobileLayout,
    pagination = props.pagination,
    rows = props.rows;
  return jsxs(DataTableContainer, {
    className: className,
    children: [jsxs(TableContainer, {
      children: [jsx(MobileTableView, {
        columns: columns,
        rows: rows,
        mobileLayout: mobileLayout
      }), jsxs(Table, {
        children: [jsx(TableColumns, {
          columns: columns
        }), jsx(TableContent, {
          columns: columns,
          rows: rows
        })]
      })]
    }), pagination && jsxs(PaginationContainer, {
      children: [jsxs(PageLimiter, {
        children: [jsx(SelectField, {
          onChange: function onChange(_ref) {
            var value = _ref.target.value;
            return pagination.onLimitChange(value.id);
          },
          options: PAGE_LIMITS.map(function (optionNumber) {
            return {
              id: optionNumber,
              label: optionNumber.toString()
            };
          }),
          optionListPlacement: "top",
          selectedOption: {
            id: pagination.limit,
            label: (_a = pagination.limit) === null || _a === void 0 ? void 0 : _a.toString()
          }
        }), ' ', jsx("p", {
          children: "elementos por p\xE1gina."
        })]
      }), jsx(Pagination, {
        page: Number(pagination.page),
        total: Number(pagination.total),
        limit: Number(pagination.limit),
        onPageChange: pagination.onPageChange
      })]
    })]
  });
};

var TOTAL_DAYS_OF_MONTH = 31;
var monthsOptions = [{
  id: '01',
  label: 'Enero'
}, {
  id: '02',
  label: 'Febrero'
}, {
  id: '03',
  label: 'Marzo'
}, {
  id: '04',
  label: 'Abril'
}, {
  id: '05',
  label: 'Mayo'
}, {
  id: '06',
  label: 'Junio'
}, {
  id: '07',
  label: 'Julio'
}, {
  id: '08',
  label: 'Agosto'
}, {
  id: '09',
  label: 'Septiembre'
}, {
  id: '10',
  label: 'Octubre'
}, {
  id: '11',
  label: 'Noviembre'
}, {
  id: '12',
  label: 'Diciembre'
}];
var isDate$1 = function isDate(date) {
  return date instanceof Date || _typeof$1(date) === 'object' && Object.prototype.toString.call(date) === '[object Date]';
};
var isDateValid = function isDateValid(date) {
  return isDate$1(date) && !Number.isNaN(Number(date));
};
var getCurrentYear = function getCurrentYear() {
  return new Date().getFullYear();
};
var convertMonthDaysToList = function convertMonthDaysToList() {
  var totalDaysOfMonth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : TOTAL_DAYS_OF_MONTH;
  return range(1, totalDaysOfMonth);
};
var getDaysSelectedMonth = function getDaysSelectedMonth(year, month) {
  return new Date(year, month, 0).getDate().toString();
};
var formatDateToYearMonthAndDay = function formatDateToYearMonthAndDay(date) {
  if (!isDateValid(date)) {
    throw new Error('Invalid date');
  }
  return date.toJSON().slice(0, 10);
};
var hasDateFormatValid = function hasDateFormatValid(date) {
  return /^(\d){4}-(\d){1,2}-(\d){1,2}$/.test(date);
};
var toDate = function toDate() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (typeof date !== 'string') {
    return date;
  }
  var _date$split = date.split('-'),
    _date$split2 = _slicedToArray(_date$split, 3),
    year = _date$split2[0],
    month = _date$split2[1],
    day = _date$split2[2];
  if (Number.isNaN(Number(year))) {
    throw new Error('The year is not an number');
  }
  if (Number.isNaN(Number(month))) {
    throw new Error('The month is not an number');
  }
  if (Number.isNaN(Number(day))) {
    throw new Error('The day is not an number');
  }
  return new Date(parseInt(year, 10), parseInt(month - 1, 10), parseInt(day, 10));
};
var formatDefaultDate = function formatDefaultDate(defaultDate) {
  if (!defaultDate) {
    return {};
  }
  var date = defaultDate;
  if (typeof defaultDate === 'string' && !hasDateFormatValid(defaultDate)) {
    return {};
  }
  if (!isDate$1(defaultDate)) {
    date = toDate(defaultDate);
  }
  if (!isDateValid(date)) {
    return {};
  }
  var _formatDateToYearMont = formatDateToYearMonthAndDay(date).split('-'),
    _formatDateToYearMont2 = _slicedToArray(_formatDateToYearMont, 3),
    selectedYear = _formatDateToYearMont2[0],
    selectedMonth = _formatDateToYearMont2[1],
    selectedDay = _formatDateToYearMont2[2];
  return {
    selectedDay: selectedDay,
    selectedMonth: selectedMonth,
    selectedYear: selectedYear
  };
};

var _templateObject$v, _templateObject2$g, _templateObject3$c;
var DatePickerWrapper = styled.div(_templateObject$v || (_templateObject$v = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"])));
var StyledDatePicker = styled.div(_templateObject2$g || (_templateObject2$g = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 80px auto 90px;\n  column-gap: ", ";\n  max-width: 366px;\n\n  @media ", " {\n    column-gap: ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.spacing(1);
}, device.mobile, function (_ref2) {
  var theme = _ref2.theme;
  return theme.spacing(2);
});
var StyledHelperText = styled(FormFieldHelperText)(_templateObject3$c || (_templateObject3$c = _taggedTemplateLiteral(["\n  grid-row: 2;\n  grid-column: 1/4;\n"])));

var _excluded$k = ["id", "name", "label", "disabled", "defaultDate", "required", "helperText", "error", "minYear", "maxYear", "earliestDateFirst", "onChange", "onChangeDay", "onChangeMonth", "onChangeYear", "onBlur", "onBlurDay", "onBlurMonth", "onBlurYear", "InputLabelProps", "FormFieldHelperTextProps"];
var MINIMUM_AGE = 18;
var MAXIMUM_AGE = 100;
var currentYear = getCurrentYear();
var endYear = currentYear - MINIMUM_AGE;
var startYear = endYear - MAXIMUM_AGE;
var formatMonthDays = function formatMonthDays(days) {
  return days.map(function (value) {
    return formatOptions(addLeadingZero(value).slice(-2), value);
  });
};
var findOptionSelected = function findOptionSelected(options, term) {
  return options.find(function (option) {
    return option.id.toString() === term;
  }) || {};
};
var DatePicker = function DatePicker(props) {
  var id = props.id,
    name = props.name,
    label = props.label,
    disabled = props.disabled,
    defaultDate = props.defaultDate,
    required = props.required,
    helperText = props.helperText,
    error = props.error,
    minYear = props.minYear,
    maxYear = props.maxYear,
    earliestDateFirst = props.earliestDateFirst,
    onChange = props.onChange,
    onChangeDay = props.onChangeDay,
    onChangeMonth = props.onChangeMonth,
    onChangeYear = props.onChangeYear,
    onBlur = props.onBlur,
    onBlurDay = props.onBlurDay,
    onBlurMonth = props.onBlurMonth,
    onBlurYear = props.onBlurYear,
    InputLabelProps = props.InputLabelProps,
    FormFieldHelperTextProps = props.FormFieldHelperTextProps,
    rest = _objectWithoutProperties(props, _excluded$k);
  var _formatDefaultDate = formatDefaultDate(defaultDate),
    selectedYear = _formatDefaultDate.selectedYear,
    selectedMonth = _formatDefaultDate.selectedMonth,
    selectedDay = _formatDefaultDate.selectedDay;
  var years = useMemo(function () {
    try {
      var yearsOption = range(minYear, maxYear).map(function (value) {
        return formatOptions(value, value);
      });
      if (earliestDateFirst) {
        yearsOption = yearsOption.reverse();
      }
      return yearsOption;
    } catch (_) {
      return [];
    }
  }, [minYear, maxYear]);
  var _useState = useState(formatMonthDays(convertMonthDaysToList())),
    _useState2 = _slicedToArray(_useState, 2),
    days = _useState2[0],
    setDays = _useState2[1];
  var _useState3 = useState(function () {
      return findOptionSelected(days, selectedDay);
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    day = _useState4[0],
    setDay = _useState4[1];
  var _useState5 = useState(function () {
      return findOptionSelected(monthsOptions, selectedMonth);
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    month = _useState6[0],
    setMonth = _useState6[1];
  var _useState7 = useState(function () {
      return findOptionSelected(years, selectedYear);
    }),
    _useState8 = _slicedToArray(_useState7, 2),
    year = _useState8[0],
    setYear = _useState8[1];
  var handleChangeDay = function handleChangeDay(toChangeDay) {
    onChangeDay(toChangeDay);
    setDay(toChangeDay);
  };
  var handleChangeMonth = function handleChangeMonth(toChangeMonth) {
    onChangeMonth(toChangeMonth);
    setMonth(toChangeMonth);
  };
  var handleChangeYear = function handleChangeYear(toChangeYear) {
    onChangeYear(toChangeYear);
    setYear(toChangeYear);
  };
  var handleBlurDay = function handleBlurDay(toBlurDay) {
    onBlurDay(toBlurDay);
    setDay(toBlurDay);
  };
  var handleBlurMonth = function handleBlurMonth(toBlurMonth) {
    onBlurMonth(toBlurMonth);
    setMonth(toBlurMonth);
  };
  var handleBlurYear = function handleBlurYear(toBlurYear) {
    onBlurYear(toBlurYear);
    setYear(toBlurYear);
  };
  var createEvent = function createEvent(data) {
    var event = new CustomEvent('click');
    Object.defineProperty(event, 'target', {
      writable: true,
      value: {
        value: data,
        name: name
      }
    });
    return event;
  };
  var handleChange = function handleChange(event) {
    onChange(createEvent(event));
  };
  var handleBlur = function handleBlur(event) {
    onBlur(createEvent(event));
  };
  useEffect(function () {
    if (month.id && year.id) {
      var totalMonthDays = getDaysSelectedMonth(year.id, month.id);
      var formatedMonthDays = formatMonthDays(convertMonthDaysToList(totalMonthDays));
      setDays(formatedMonthDays);
      if (totalMonthDays < day.id) {
        var currentSelectedDay = findOptionSelected(days, totalMonthDays);
        setDay(currentSelectedDay);
      }
    }
  }, [month.id, year.id]);
  useEffect(function () {
    if (year.id && day.id && month.id) {
      var date = toDate([year.id, month.id, day.id].join('-'));
      var isValid = isDateValid(date);
      if (isValid) {
        handleChange(date);
        handleBlur(date);
      }
    }
  }, [year.id, month.id, day.id]);
  return /*#__PURE__*/React__default.createElement(DatePickerWrapper, null, /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: Boolean(label)
  }, /*#__PURE__*/React__default.createElement(InputLabel, _extends$3({
    htmlFor: id,
    required: required
  }, InputLabelProps), label)), /*#__PURE__*/React__default.createElement(StyledDatePicker, _extends$3({}, rest, {
    "aria-label": "date picker",
    id: id
  }), /*#__PURE__*/React__default.createElement(SelectField, {
    id: "day-".concat(id),
    name: "day",
    label: "D\xEDa",
    placeholder: "D\xEDa",
    options: days,
    selectedOption: day,
    handleOptionClick: handleChangeDay,
    onBlur: handleBlurDay,
    disabled: disabled,
    error: error,
    required: true
  }), /*#__PURE__*/React__default.createElement(SelectField, {
    id: "month-".concat(id),
    name: "month",
    label: "Mes",
    placeholder: "Mes",
    options: monthsOptions,
    selectedOption: month,
    handleOptionClick: handleChangeMonth,
    onBlur: handleBlurMonth,
    disabled: disabled,
    error: error,
    required: true
  }), /*#__PURE__*/React__default.createElement(SelectField, {
    id: "year-".concat(id),
    name: "year",
    label: "A\xF1o",
    placeholder: "A\xF1o",
    options: years,
    selectedOption: year,
    handleOptionClick: handleChangeYear,
    onBlur: handleBlurYear,
    disabled: disabled,
    error: error,
    required: true
  }), /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: Boolean(helperText)
  }, /*#__PURE__*/React__default.createElement(StyledHelperText, _extends$3({
    error: error
  }, FormFieldHelperTextProps), helperText))));
};
DatePicker.propTypes = {
  /**
   * Id assigned to input.
   */
  id: PropTypes.string,
  /**
  * Name attribute of the `input` element.
  */
  name: PropTypes.string,
  /**
  * The text to display as the label associated with input control
  */
  label: PropTypes.string,
  /**
  * Apply styles to the button to display it as unusable and unclickable
  */
  disabled: PropTypes.bool,
  /**
   * Provides additional information about datePicker
   */
  helperText: PropTypes.string,
  /**
  * To set date by default with this format `YYYY-MM-DD` or current date `new Date()`
  */
  defaultDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  /**
  * If true the input element would be required
  */
  required: PropTypes.bool,
  /**
   * Whether this field should be displayed in error state
   */
  error: PropTypes.bool,
  /**
  * Minimum year to display
  */
  minYear: PropTypes.number,
  /**
  * Maximum year to display
  */
  maxYear: PropTypes.number,
  /**
  * Set Maximun year first in year select
  */
  earliestDateFirst: PropTypes.bool,
  /**
  * Callback fired when selected a year
  * @param Date The param source of the callback.
  */
  onChange: PropTypes.func,
  /**
  * Callback fired when selected a day
  *
  * @param {React.ChangeEvent<HTMLInputElement>} option The event source of the callback.
  * You can pull out the value by accessing `option.id` (string | number).
  * You can pull out the label by accessing `option.label` (string).
  */
  onChangeDay: PropTypes.func,
  /**
  * Callback fired when selected a month
  * @param {React.ChangeEvent<HTMLInputElement>} option The event source of the callback.
  * You can pull out the value by accessing `option.id` (string | number).
  * You can pull out the label by accessing `option.label` (string).
  */
  onChangeMonth: PropTypes.func,
  /**
  * Callback fired when selected a year
  * @param {React.ChangeEvent<HTMLInputElement>} option The event source of the callback.
  * You can pull out the value by accessing `option.id` (string | number).
  * You can pull out the label by accessing `option.label` (string).
  */
  onChangeYear: PropTypes.func,
  /**
  * Callback fired when selected a year
  * @param Date The param source of the callback.
  */
  onBlur: PropTypes.func,
  /**
  * Callback fired when selected a day
  *
  * @param {React.ChangeEvent<HTMLInputElement>} option The event source of the callback.
  * You can pull out the value by accessing `option.id` (string | number).
  * You can pull out the label by accessing `option.label` (string).
  */
  onBlurDay: PropTypes.func,
  /**
  * Callback fired when selected a month
  * @param {React.ChangeEvent<HTMLInputElement>} option The event source of the callback.
  * You can pull out the value by accessing `option.id` (string | number).
  * You can pull out the label by accessing `option.label` (string).
  */
  onBlurMonth: PropTypes.func,
  /**
  * Callback fired when selected a year
  * @param {React.ChangeEvent<HTMLInputElement>} option The event source of the callback.
  * You can pull out the value by accessing `option.id` (string | number).
  * You can pull out the label by accessing `option.label` (string).
  */
  onBlurYear: PropTypes.func,
  /**
  * Props applied on InputLabel component
  */
  InputLabelProps: PropTypes.shape({}),
  /**
  * Props applied on InputLabel component
  */
  FormFieldHelperTextProps: PropTypes.shape({})
};
DatePicker.defaultProps = {
  id: undefined,
  name: '',
  label: '',
  disabled: false,
  helperText: '',
  defaultDate: '',
  required: false,
  error: false,
  minYear: startYear,
  maxYear: endYear,
  earliestDateFirst: false,
  onChange: function onChange() {},
  onChangeDay: function onChangeDay() {},
  onChangeMonth: function onChangeMonth() {},
  onChangeYear: function onChangeYear() {},
  onBlur: function onBlur() {},
  onBlurDay: function onBlurDay() {},
  onBlurMonth: function onBlurMonth() {},
  onBlurYear: function onBlurYear() {},
  InputLabelProps: {},
  FormFieldHelperTextProps: {}
};

var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/globals.ts
var globals_exports = {};
__export(globals_exports, {
  assign: () => assign,
  colors: () => colors$2,
  createStringInterpolator: () => createStringInterpolator,
  skipAnimation: () => skipAnimation,
  to: () => to$1,
  willAdvance: () => willAdvance
});

// ../rafz/dist/react-spring_rafz.modern.mjs
var updateQueue = makeQueue();
var raf = (fn) => schedule(fn, updateQueue);
var writeQueue = makeQueue();
raf.write = (fn) => schedule(fn, writeQueue);
var onStartQueue = makeQueue();
raf.onStart = (fn) => schedule(fn, onStartQueue);
var onFrameQueue = makeQueue();
raf.onFrame = (fn) => schedule(fn, onFrameQueue);
var onFinishQueue = makeQueue();
raf.onFinish = (fn) => schedule(fn, onFinishQueue);
var timeouts = [];
raf.setTimeout = (handler, ms) => {
  const time = raf.now() + ms;
  const cancel = () => {
    const i = timeouts.findIndex((t) => t.cancel == cancel);
    if (~i)
      timeouts.splice(i, 1);
    pendingCount -= ~i ? 1 : 0;
  };
  const timeout = { time, handler, cancel };
  timeouts.splice(findTimeout(time), 0, timeout);
  pendingCount += 1;
  start();
  return timeout;
};
var findTimeout = (time) => ~(~timeouts.findIndex((t) => t.time > time) || ~timeouts.length);
raf.cancel = (fn) => {
  onStartQueue.delete(fn);
  onFrameQueue.delete(fn);
  onFinishQueue.delete(fn);
  updateQueue.delete(fn);
  writeQueue.delete(fn);
};
raf.sync = (fn) => {
  sync = true;
  raf.batchedUpdates(fn);
  sync = false;
};
raf.throttle = (fn) => {
  let lastArgs;
  function queuedFn() {
    try {
      fn(...lastArgs);
    } finally {
      lastArgs = null;
    }
  }
  function throttled(...args) {
    lastArgs = args;
    raf.onStart(queuedFn);
  }
  throttled.handler = fn;
  throttled.cancel = () => {
    onStartQueue.delete(queuedFn);
    lastArgs = null;
  };
  return throttled;
};
var nativeRaf = typeof window != "undefined" ? window.requestAnimationFrame : (
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  () => {
  }
);
raf.use = (impl) => nativeRaf = impl;
raf.now = typeof performance != "undefined" ? () => performance.now() : Date.now;
raf.batchedUpdates = (fn) => fn();
raf.catch = console.error;
raf.frameLoop = "always";
raf.advance = () => {
  if (raf.frameLoop !== "demand") {
    console.warn(
      "Cannot call the manual advancement of rafz whilst frameLoop is not set as demand"
    );
  } else {
    update();
  }
};
var ts = -1;
var pendingCount = 0;
var sync = false;
function schedule(fn, queue) {
  if (sync) {
    queue.delete(fn);
    fn(0);
  } else {
    queue.add(fn);
    start();
  }
}
function start() {
  if (ts < 0) {
    ts = 0;
    if (raf.frameLoop !== "demand") {
      nativeRaf(loop);
    }
  }
}
function stop() {
  ts = -1;
}
function loop() {
  if (~ts) {
    nativeRaf(loop);
    raf.batchedUpdates(update);
  }
}
function update() {
  const prevTs = ts;
  ts = raf.now();
  const count = findTimeout(ts);
  if (count) {
    eachSafely(timeouts.splice(0, count), (t) => t.handler());
    pendingCount -= count;
  }
  if (!pendingCount) {
    stop();
    return;
  }
  onStartQueue.flush();
  updateQueue.flush(prevTs ? Math.min(64, ts - prevTs) : 16.667);
  onFrameQueue.flush();
  writeQueue.flush();
  onFinishQueue.flush();
}
function makeQueue() {
  let next = /* @__PURE__ */ new Set();
  let current = next;
  return {
    add(fn) {
      pendingCount += current == next && !next.has(fn) ? 1 : 0;
      next.add(fn);
    },
    delete(fn) {
      pendingCount -= current == next && next.has(fn) ? 1 : 0;
      return next.delete(fn);
    },
    flush(arg) {
      if (current.size) {
        next = /* @__PURE__ */ new Set();
        pendingCount -= current.size;
        eachSafely(current, (fn) => fn(arg) && next.add(fn));
        pendingCount += next.size;
        current = next;
      }
    }
  };
}
function eachSafely(values, each2) {
  values.forEach((value) => {
    try {
      each2(value);
    } catch (e) {
      raf.catch(e);
    }
  });
}

// src/helpers.ts
function noop$4() {
}
var defineHidden = (obj, key, value) => Object.defineProperty(obj, key, { value, writable: true, configurable: true });
var is = {
  arr: Array.isArray,
  obj: (a) => !!a && a.constructor.name === "Object",
  fun: (a) => typeof a === "function",
  str: (a) => typeof a === "string",
  num: (a) => typeof a === "number",
  und: (a) => a === void 0
};
function isEqual$1(a, b) {
  if (is.arr(a)) {
    if (!is.arr(b) || a.length !== b.length)
      return false;
    for (let i = 0; i < a.length; i++) {
      if (a[i] !== b[i])
        return false;
    }
    return true;
  }
  return a === b;
}
var each = (obj, fn) => obj.forEach(fn);
function eachProp(obj, fn, ctx) {
  if (is.arr(obj)) {
    for (let i = 0; i < obj.length; i++) {
      fn.call(ctx, obj[i], `${i}`);
    }
    return;
  }
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      fn.call(ctx, obj[key], key);
    }
  }
}
var toArray = (a) => is.und(a) ? [] : is.arr(a) ? a : [a];
function flush(queue, iterator) {
  if (queue.size) {
    const items = Array.from(queue);
    queue.clear();
    each(items, iterator);
  }
}
var flushCalls = (queue, ...args) => flush(queue, (fn) => fn(...args));
var isSSR = () => typeof window === "undefined" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);

// src/globals.ts
var createStringInterpolator;
var to$1;
var colors$2 = null;
var skipAnimation = false;
var willAdvance = noop$4;
var assign = (globals) => {
  if (globals.to)
    to$1 = globals.to;
  if (globals.now)
    raf.now = globals.now;
  if (globals.colors !== void 0)
    colors$2 = globals.colors;
  if (globals.skipAnimation != null)
    skipAnimation = globals.skipAnimation;
  if (globals.createStringInterpolator)
    createStringInterpolator = globals.createStringInterpolator;
  if (globals.requestAnimationFrame)
    raf.use(globals.requestAnimationFrame);
  if (globals.batchedUpdates)
    raf.batchedUpdates = globals.batchedUpdates;
  if (globals.willAdvance)
    willAdvance = globals.willAdvance;
  if (globals.frameLoop)
    raf.frameLoop = globals.frameLoop;
};

// src/FrameLoop.ts
var startQueue = /* @__PURE__ */ new Set();
var currentFrame = [];
var prevFrame = [];
var priority = 0;
var frameLoop = {
  get idle() {
    return !startQueue.size && !currentFrame.length;
  },
  /** Advance the given animation on every frame until idle. */
  start(animation) {
    if (priority > animation.priority) {
      startQueue.add(animation);
      raf.onStart(flushStartQueue);
    } else {
      startSafely(animation);
      raf(advance);
    }
  },
  /** Advance all animations by the given time. */
  advance,
  /** Call this when an animation's priority changes. */
  sort(animation) {
    if (priority) {
      raf.onFrame(() => frameLoop.sort(animation));
    } else {
      const prevIndex = currentFrame.indexOf(animation);
      if (~prevIndex) {
        currentFrame.splice(prevIndex, 1);
        startUnsafely(animation);
      }
    }
  },
  /**
   * Clear all animations. For testing purposes.
   *
   * ☠️ Never call this from within the frameloop.
   */
  clear() {
    currentFrame = [];
    startQueue.clear();
  }
};
function flushStartQueue() {
  startQueue.forEach(startSafely);
  startQueue.clear();
  raf(advance);
}
function startSafely(animation) {
  if (!currentFrame.includes(animation))
    startUnsafely(animation);
}
function startUnsafely(animation) {
  currentFrame.splice(
    findIndex(currentFrame, (other) => other.priority > animation.priority),
    0,
    animation
  );
}
function advance(dt) {
  const nextFrame = prevFrame;
  for (let i = 0; i < currentFrame.length; i++) {
    const animation = currentFrame[i];
    priority = animation.priority;
    if (!animation.idle) {
      willAdvance(animation);
      animation.advance(dt);
      if (!animation.idle) {
        nextFrame.push(animation);
      }
    }
  }
  priority = 0;
  prevFrame = currentFrame;
  prevFrame.length = 0;
  currentFrame = nextFrame;
  return currentFrame.length > 0;
}
function findIndex(arr, test) {
  const index = arr.findIndex(test);
  return index < 0 ? arr.length : index;
}

// src/clamp.ts
var clamp = (min, max, v) => Math.min(Math.max(v, min), max);

// src/colors.ts
var colors2 = {
  transparent: 0,
  aliceblue: 4042850303,
  antiquewhite: 4209760255,
  aqua: 16777215,
  aquamarine: 2147472639,
  azure: 4043309055,
  beige: 4126530815,
  bisque: 4293182719,
  black: 255,
  blanchedalmond: 4293643775,
  blue: 65535,
  blueviolet: 2318131967,
  brown: 2771004159,
  burlywood: 3736635391,
  burntsienna: 3934150143,
  cadetblue: 1604231423,
  chartreuse: 2147418367,
  chocolate: 3530104575,
  coral: 4286533887,
  cornflowerblue: 1687547391,
  cornsilk: 4294499583,
  crimson: 3692313855,
  cyan: 16777215,
  darkblue: 35839,
  darkcyan: 9145343,
  darkgoldenrod: 3095792639,
  darkgray: 2846468607,
  darkgreen: 6553855,
  darkgrey: 2846468607,
  darkkhaki: 3182914559,
  darkmagenta: 2332068863,
  darkolivegreen: 1433087999,
  darkorange: 4287365375,
  darkorchid: 2570243327,
  darkred: 2332033279,
  darksalmon: 3918953215,
  darkseagreen: 2411499519,
  darkslateblue: 1211993087,
  darkslategray: 793726975,
  darkslategrey: 793726975,
  darkturquoise: 13554175,
  darkviolet: 2483082239,
  deeppink: 4279538687,
  deepskyblue: 12582911,
  dimgray: 1768516095,
  dimgrey: 1768516095,
  dodgerblue: 512819199,
  firebrick: 2988581631,
  floralwhite: 4294635775,
  forestgreen: 579543807,
  fuchsia: 4278255615,
  gainsboro: 3705462015,
  ghostwhite: 4177068031,
  gold: 4292280575,
  goldenrod: 3668254975,
  gray: 2155905279,
  green: 8388863,
  greenyellow: 2919182335,
  grey: 2155905279,
  honeydew: 4043305215,
  hotpink: 4285117695,
  indianred: 3445382399,
  indigo: 1258324735,
  ivory: 4294963455,
  khaki: 4041641215,
  lavender: 3873897215,
  lavenderblush: 4293981695,
  lawngreen: 2096890111,
  lemonchiffon: 4294626815,
  lightblue: 2916673279,
  lightcoral: 4034953471,
  lightcyan: 3774873599,
  lightgoldenrodyellow: 4210742015,
  lightgray: 3553874943,
  lightgreen: 2431553791,
  lightgrey: 3553874943,
  lightpink: 4290167295,
  lightsalmon: 4288707327,
  lightseagreen: 548580095,
  lightskyblue: 2278488831,
  lightslategray: 2005441023,
  lightslategrey: 2005441023,
  lightsteelblue: 2965692159,
  lightyellow: 4294959359,
  lime: 16711935,
  limegreen: 852308735,
  linen: 4210091775,
  magenta: 4278255615,
  maroon: 2147483903,
  mediumaquamarine: 1724754687,
  mediumblue: 52735,
  mediumorchid: 3126187007,
  mediumpurple: 2473647103,
  mediumseagreen: 1018393087,
  mediumslateblue: 2070474495,
  mediumspringgreen: 16423679,
  mediumturquoise: 1221709055,
  mediumvioletred: 3340076543,
  midnightblue: 421097727,
  mintcream: 4127193855,
  mistyrose: 4293190143,
  moccasin: 4293178879,
  navajowhite: 4292783615,
  navy: 33023,
  oldlace: 4260751103,
  olive: 2155872511,
  olivedrab: 1804477439,
  orange: 4289003775,
  orangered: 4282712319,
  orchid: 3664828159,
  palegoldenrod: 4008225535,
  palegreen: 2566625535,
  paleturquoise: 2951671551,
  palevioletred: 3681588223,
  papayawhip: 4293907967,
  peachpuff: 4292524543,
  peru: 3448061951,
  pink: 4290825215,
  plum: 3718307327,
  powderblue: 2967529215,
  purple: 2147516671,
  rebeccapurple: 1714657791,
  red: 4278190335,
  rosybrown: 3163525119,
  royalblue: 1097458175,
  saddlebrown: 2336560127,
  salmon: 4202722047,
  sandybrown: 4104413439,
  seagreen: 780883967,
  seashell: 4294307583,
  sienna: 2689740287,
  silver: 3233857791,
  skyblue: 2278484991,
  slateblue: 1784335871,
  slategray: 1887473919,
  slategrey: 1887473919,
  snow: 4294638335,
  springgreen: 16744447,
  steelblue: 1182971135,
  tan: 3535047935,
  teal: 8421631,
  thistle: 3636451583,
  tomato: 4284696575,
  turquoise: 1088475391,
  violet: 4001558271,
  wheat: 4125012991,
  white: 4294967295,
  whitesmoke: 4126537215,
  yellow: 4294902015,
  yellowgreen: 2597139199
};

// src/colorMatchers.ts
var NUMBER = "[-+]?\\d*\\.?\\d+";
var PERCENTAGE = NUMBER + "%";
function call(...parts) {
  return "\\(\\s*(" + parts.join(")\\s*,\\s*(") + ")\\s*\\)";
}
var rgb$4 = new RegExp("rgb" + call(NUMBER, NUMBER, NUMBER));
var rgba$3 = new RegExp("rgba" + call(NUMBER, NUMBER, NUMBER, NUMBER));
var hsl$3 = new RegExp("hsl" + call(NUMBER, PERCENTAGE, PERCENTAGE));
var hsla$3 = new RegExp(
  "hsla" + call(NUMBER, PERCENTAGE, PERCENTAGE, NUMBER)
);
var hex3 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var hex4 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var hex6 = /^#([0-9a-fA-F]{6})$/;
var hex8 = /^#([0-9a-fA-F]{8})$/;

// src/normalizeColor.ts
function normalizeColor(color) {
  let match;
  if (typeof color === "number") {
    return color >>> 0 === color && color >= 0 && color <= 4294967295 ? color : null;
  }
  if (match = hex6.exec(color))
    return parseInt(match[1] + "ff", 16) >>> 0;
  if (colors$2 && colors$2[color] !== void 0) {
    return colors$2[color];
  }
  if (match = rgb$4.exec(color)) {
    return (parse255(match[1]) << 24 | // r
    parse255(match[2]) << 16 | // g
    parse255(match[3]) << 8 | // b
    255) >>> // a
    0;
  }
  if (match = rgba$3.exec(color)) {
    return (parse255(match[1]) << 24 | // r
    parse255(match[2]) << 16 | // g
    parse255(match[3]) << 8 | // b
    parse1(match[4])) >>> // a
    0;
  }
  if (match = hex3.exec(color)) {
    return parseInt(
      match[1] + match[1] + // r
      match[2] + match[2] + // g
      match[3] + match[3] + // b
      "ff",
      // a
      16
    ) >>> 0;
  }
  if (match = hex8.exec(color))
    return parseInt(match[1], 16) >>> 0;
  if (match = hex4.exec(color)) {
    return parseInt(
      match[1] + match[1] + // r
      match[2] + match[2] + // g
      match[3] + match[3] + // b
      match[4] + match[4],
      // a
      16
    ) >>> 0;
  }
  if (match = hsl$3.exec(color)) {
    return (hslToRgb(
      parse360(match[1]),
      // h
      parsePercentage(match[2]),
      // s
      parsePercentage(match[3])
      // l
    ) | 255) >>> // a
    0;
  }
  if (match = hsla$3.exec(color)) {
    return (hslToRgb(
      parse360(match[1]),
      // h
      parsePercentage(match[2]),
      // s
      parsePercentage(match[3])
      // l
    ) | parse1(match[4])) >>> // a
    0;
  }
  return null;
}
function hue2rgb(p, q, t) {
  if (t < 0)
    t += 1;
  if (t > 1)
    t -= 1;
  if (t < 1 / 6)
    return p + (q - p) * 6 * t;
  if (t < 1 / 2)
    return q;
  if (t < 2 / 3)
    return p + (q - p) * (2 / 3 - t) * 6;
  return p;
}
function hslToRgb(h, s, l) {
  const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
  const p = 2 * l - q;
  const r = hue2rgb(p, q, h + 1 / 3);
  const g = hue2rgb(p, q, h);
  const b = hue2rgb(p, q, h - 1 / 3);
  return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}
function parse255(str) {
  const int = parseInt(str, 10);
  if (int < 0)
    return 0;
  if (int > 255)
    return 255;
  return int;
}
function parse360(str) {
  const int = parseFloat(str);
  return (int % 360 + 360) % 360 / 360;
}
function parse1(str) {
  const num = parseFloat(str);
  if (num < 0)
    return 0;
  if (num > 1)
    return 255;
  return Math.round(num * 255);
}
function parsePercentage(str) {
  const int = parseFloat(str);
  if (int < 0)
    return 0;
  if (int > 100)
    return 1;
  return int / 100;
}

// src/colorToRgba.ts
function colorToRgba(input) {
  let int32Color = normalizeColor(input);
  if (int32Color === null)
    return input;
  int32Color = int32Color || 0;
  const r = (int32Color & 4278190080) >>> 24;
  const g = (int32Color & 16711680) >>> 16;
  const b = (int32Color & 65280) >>> 8;
  const a = (int32Color & 255) / 255;
  return `rgba(${r}, ${g}, ${b}, ${a})`;
}

// src/createInterpolator.ts
var createInterpolator = (range, output, extrapolate) => {
  if (is.fun(range)) {
    return range;
  }
  if (is.arr(range)) {
    return createInterpolator({
      range,
      output,
      extrapolate
    });
  }
  if (is.str(range.output[0])) {
    return createStringInterpolator(range);
  }
  const config = range;
  const outputRange = config.output;
  const inputRange = config.range || [0, 1];
  const extrapolateLeft = config.extrapolateLeft || config.extrapolate || "extend";
  const extrapolateRight = config.extrapolateRight || config.extrapolate || "extend";
  const easing = config.easing || ((t) => t);
  return (input) => {
    const range2 = findRange(input, inputRange);
    return interpolate$1(
      input,
      inputRange[range2],
      inputRange[range2 + 1],
      outputRange[range2],
      outputRange[range2 + 1],
      easing,
      extrapolateLeft,
      extrapolateRight,
      config.map
    );
  };
};
function interpolate$1(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
  let result = map ? map(input) : input;
  if (result < inputMin) {
    if (extrapolateLeft === "identity")
      return result;
    else if (extrapolateLeft === "clamp")
      result = inputMin;
  }
  if (result > inputMax) {
    if (extrapolateRight === "identity")
      return result;
    else if (extrapolateRight === "clamp")
      result = inputMax;
  }
  if (outputMin === outputMax)
    return outputMin;
  if (inputMin === inputMax)
    return input <= inputMin ? outputMin : outputMax;
  if (inputMin === -Infinity)
    result = -result;
  else if (inputMax === Infinity)
    result = result - inputMin;
  else
    result = (result - inputMin) / (inputMax - inputMin);
  result = easing(result);
  if (outputMin === -Infinity)
    result = -result;
  else if (outputMax === Infinity)
    result = result + outputMin;
  else
    result = result * (outputMax - outputMin) + outputMin;
  return result;
}
function findRange(input, inputRange) {
  for (var i = 1; i < inputRange.length - 1; ++i)
    if (inputRange[i] >= input)
      break;
  return i - 1;
}

// src/easings.ts
var steps = (steps2, direction = "end") => (progress2) => {
  progress2 = direction === "end" ? Math.min(progress2, 0.999) : Math.max(progress2, 1e-3);
  const expanded = progress2 * steps2;
  const rounded = direction === "end" ? Math.floor(expanded) : Math.ceil(expanded);
  return clamp(0, 1, rounded / steps2);
};
var c1 = 1.70158;
var c2 = c1 * 1.525;
var c3 = c1 + 1;
var c4 = 2 * Math.PI / 3;
var c5 = 2 * Math.PI / 4.5;
var bounceOut = (x) => {
  const n1 = 7.5625;
  const d1 = 2.75;
  if (x < 1 / d1) {
    return n1 * x * x;
  } else if (x < 2 / d1) {
    return n1 * (x -= 1.5 / d1) * x + 0.75;
  } else if (x < 2.5 / d1) {
    return n1 * (x -= 2.25 / d1) * x + 0.9375;
  } else {
    return n1 * (x -= 2.625 / d1) * x + 0.984375;
  }
};
var easings = {
  linear: (x) => x,
  easeInQuad: (x) => x * x,
  easeOutQuad: (x) => 1 - (1 - x) * (1 - x),
  easeInOutQuad: (x) => x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2,
  easeInCubic: (x) => x * x * x,
  easeOutCubic: (x) => 1 - Math.pow(1 - x, 3),
  easeInOutCubic: (x) => x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2,
  easeInQuart: (x) => x * x * x * x,
  easeOutQuart: (x) => 1 - Math.pow(1 - x, 4),
  easeInOutQuart: (x) => x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2,
  easeInQuint: (x) => x * x * x * x * x,
  easeOutQuint: (x) => 1 - Math.pow(1 - x, 5),
  easeInOutQuint: (x) => x < 0.5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2,
  easeInSine: (x) => 1 - Math.cos(x * Math.PI / 2),
  easeOutSine: (x) => Math.sin(x * Math.PI / 2),
  easeInOutSine: (x) => -(Math.cos(Math.PI * x) - 1) / 2,
  easeInExpo: (x) => x === 0 ? 0 : Math.pow(2, 10 * x - 10),
  easeOutExpo: (x) => x === 1 ? 1 : 1 - Math.pow(2, -10 * x),
  easeInOutExpo: (x) => x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2 : (2 - Math.pow(2, -20 * x + 10)) / 2,
  easeInCirc: (x) => 1 - Math.sqrt(1 - Math.pow(x, 2)),
  easeOutCirc: (x) => Math.sqrt(1 - Math.pow(x - 1, 2)),
  easeInOutCirc: (x) => x < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2,
  easeInBack: (x) => c3 * x * x * x - c1 * x * x,
  easeOutBack: (x) => 1 + c3 * Math.pow(x - 1, 3) + c1 * Math.pow(x - 1, 2),
  easeInOutBack: (x) => x < 0.5 ? Math.pow(2 * x, 2) * ((c2 + 1) * 2 * x - c2) / 2 : (Math.pow(2 * x - 2, 2) * ((c2 + 1) * (x * 2 - 2) + c2) + 2) / 2,
  easeInElastic: (x) => x === 0 ? 0 : x === 1 ? 1 : -Math.pow(2, 10 * x - 10) * Math.sin((x * 10 - 10.75) * c4),
  easeOutElastic: (x) => x === 0 ? 0 : x === 1 ? 1 : Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * c4) + 1,
  easeInOutElastic: (x) => x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? -(Math.pow(2, 20 * x - 10) * Math.sin((20 * x - 11.125) * c5)) / 2 : Math.pow(2, -20 * x + 10) * Math.sin((20 * x - 11.125) * c5) / 2 + 1,
  easeInBounce: (x) => 1 - bounceOut(1 - x),
  easeOutBounce: bounceOut,
  easeInOutBounce: (x) => x < 0.5 ? (1 - bounceOut(1 - 2 * x)) / 2 : (1 + bounceOut(2 * x - 1)) / 2,
  steps
};

// src/fluids.ts
var $get = Symbol.for("FluidValue.get");
var $observers = Symbol.for("FluidValue.observers");
var hasFluidValue = (arg) => Boolean(arg && arg[$get]);
var getFluidValue = (arg) => arg && arg[$get] ? arg[$get]() : arg;
var getFluidObservers = (target) => target[$observers] || null;
function callFluidObserver(observer2, event) {
  if (observer2.eventObserved) {
    observer2.eventObserved(event);
  } else {
    observer2(event);
  }
}
function callFluidObservers(target, event) {
  const observers = target[$observers];
  if (observers) {
    observers.forEach((observer2) => {
      callFluidObserver(observer2, event);
    });
  }
}
var FluidValue = class {
  constructor(get) {
    if (!get && !(get = this.get)) {
      throw Error("Unknown getter");
    }
    setFluidGetter(this, get);
  }
};
var setFluidGetter = (target, get) => setHidden(target, $get, get);
function addFluidObserver(target, observer2) {
  if (target[$get]) {
    let observers = target[$observers];
    if (!observers) {
      setHidden(target, $observers, observers = /* @__PURE__ */ new Set());
    }
    if (!observers.has(observer2)) {
      observers.add(observer2);
      if (target.observerAdded) {
        target.observerAdded(observers.size, observer2);
      }
    }
  }
  return observer2;
}
function removeFluidObserver(target, observer2) {
  const observers = target[$observers];
  if (observers && observers.has(observer2)) {
    const count = observers.size - 1;
    if (count) {
      observers.delete(observer2);
    } else {
      target[$observers] = null;
    }
    if (target.observerRemoved) {
      target.observerRemoved(count, observer2);
    }
  }
}
var setHidden = (target, key, value) => Object.defineProperty(target, key, {
  value,
  writable: true,
  configurable: true
});

// src/regexs.ts
var numberRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
var colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
var unitRegex = new RegExp(`(${numberRegex.source})(%|[a-z]+)`, "i");
var rgbaRegex = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi;
var cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;

// src/variableToRgba.ts
var variableToRgba = (input) => {
  const [token, fallback] = parseCSSVariable(input);
  if (!token || isSSR()) {
    return input;
  }
  const value = window.getComputedStyle(document.documentElement).getPropertyValue(token);
  if (value) {
    return value.trim();
  } else if (fallback && fallback.startsWith("--")) {
    const value2 = window.getComputedStyle(document.documentElement).getPropertyValue(fallback);
    if (value2) {
      return value2;
    } else {
      return input;
    }
  } else if (fallback && cssVariableRegex.test(fallback)) {
    return variableToRgba(fallback);
  } else if (fallback) {
    return fallback;
  }
  return input;
};
var parseCSSVariable = (current) => {
  const match = cssVariableRegex.exec(current);
  if (!match)
    return [,];
  const [, token, fallback] = match;
  return [token, fallback];
};

// src/stringInterpolation.ts
var namedColorRegex;
var rgbaRound = (_, p1, p2, p3, p4) => `rgba(${Math.round(p1)}, ${Math.round(p2)}, ${Math.round(p3)}, ${p4})`;
var createStringInterpolator2 = (config) => {
  if (!namedColorRegex)
    namedColorRegex = colors$2 ? (
      // match color names, ignore partial matches
      new RegExp(`(${Object.keys(colors$2).join("|")})(?!\\w)`, "g")
    ) : (
      // never match
      /^\b$/
    );
  const output = config.output.map((value) => {
    return getFluidValue(value).replace(cssVariableRegex, variableToRgba).replace(colorRegex, colorToRgba).replace(namedColorRegex, colorToRgba);
  });
  const keyframes = output.map((value) => value.match(numberRegex).map(Number));
  const outputRanges = keyframes[0].map(
    (_, i) => keyframes.map((values) => {
      if (!(i in values)) {
        throw Error('The arity of each "output" value must be equal');
      }
      return values[i];
    })
  );
  const interpolators = outputRanges.map(
    (output2) => createInterpolator({ ...config, output: output2 })
  );
  return (input) => {
    const missingUnit = !unitRegex.test(output[0]) && output.find((value) => unitRegex.test(value))?.replace(numberRegex, "");
    let i = 0;
    return output[0].replace(
      numberRegex,
      () => `${interpolators[i++](input)}${missingUnit || ""}`
    ).replace(rgbaRegex, rgbaRound);
  };
};

// src/deprecations.ts
var prefix = "react-spring: ";
var once = (fn) => {
  const func = fn;
  let called = false;
  if (typeof func != "function") {
    throw new TypeError(`${prefix}once requires a function parameter`);
  }
  return (...args) => {
    if (!called) {
      func(...args);
      called = true;
    }
  };
};
var warnInterpolate = once(console.warn);
function deprecateInterpolate() {
  warnInterpolate(
    `${prefix}The "interpolate" function is deprecated in v9 (use "to" instead)`
  );
}
var warnDirectCall = once(console.warn);
function deprecateDirectCall() {
  warnDirectCall(
    `${prefix}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`
  );
}

// src/isAnimatedString.ts
function isAnimatedString(value) {
  return is.str(value) && (value[0] == "#" || /\d/.test(value) || // Do not identify a CSS variable as an AnimatedString if its SSR
  !isSSR() && cssVariableRegex.test(value) || value in (colors$2 || {}));
}
var useIsomorphicLayoutEffect$1 = isSSR() ? useEffect : useLayoutEffect;

// src/hooks/useIsMounted.ts
var useIsMounted = () => {
  const isMounted = useRef(false);
  useIsomorphicLayoutEffect$1(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);
  return isMounted;
};

// src/hooks/useForceUpdate.ts
function useForceUpdate() {
  const update2 = useState()[1];
  const isMounted = useIsMounted();
  return () => {
    if (isMounted.current) {
      update2(Math.random());
    }
  };
}
function useMemoOne(getResult, inputs) {
  const [initial] = useState(
    () => ({
      inputs,
      result: getResult()
    })
  );
  const committed = useRef();
  const prevCache = committed.current;
  let cache = prevCache;
  if (cache) {
    const useCache = Boolean(
      inputs && cache.inputs && areInputsEqual(inputs, cache.inputs)
    );
    if (!useCache) {
      cache = {
        inputs,
        result: getResult()
      };
    }
  } else {
    cache = initial;
  }
  useEffect(() => {
    committed.current = cache;
    if (prevCache == initial) {
      initial.inputs = initial.result = void 0;
    }
  }, [cache]);
  return cache.result;
}
function areInputsEqual(next, prev) {
  if (next.length !== prev.length) {
    return false;
  }
  for (let i = 0; i < next.length; i++) {
    if (next[i] !== prev[i]) {
      return false;
    }
  }
  return true;
}
var useOnce = (effect) => useEffect(effect, emptyDeps);
var emptyDeps = [];
function usePrev(value) {
  const prevRef = useRef();
  useEffect(() => {
    prevRef.current = value;
  });
  return prevRef.current;
}

// src/Animated.ts
var $node = Symbol.for("Animated:node");
var isAnimated = (value) => !!value && value[$node] === value;
var getAnimated = (owner) => owner && owner[$node];
var setAnimated = (owner, node) => defineHidden(owner, $node, node);
var getPayload = (owner) => owner && owner[$node] && owner[$node].getPayload();
var Animated = class {
  constructor() {
    setAnimated(this, this);
  }
  /** Get every `AnimatedValue` used by this node. */
  getPayload() {
    return this.payload || [];
  }
};
var AnimatedValue = class extends Animated {
  constructor(_value) {
    super();
    this._value = _value;
    this.done = true;
    this.durationProgress = 0;
    if (is.num(this._value)) {
      this.lastPosition = this._value;
    }
  }
  /** @internal */
  static create(value) {
    return new AnimatedValue(value);
  }
  getPayload() {
    return [this];
  }
  getValue() {
    return this._value;
  }
  setValue(value, step) {
    if (is.num(value)) {
      this.lastPosition = value;
      if (step) {
        value = Math.round(value / step) * step;
        if (this.done) {
          this.lastPosition = value;
        }
      }
    }
    if (this._value === value) {
      return false;
    }
    this._value = value;
    return true;
  }
  reset() {
    const { done } = this;
    this.done = false;
    if (is.num(this._value)) {
      this.elapsedTime = 0;
      this.durationProgress = 0;
      this.lastPosition = this._value;
      if (done)
        this.lastVelocity = null;
      this.v0 = null;
    }
  }
};
var AnimatedString = class extends AnimatedValue {
  constructor(value) {
    super(0);
    this._string = null;
    this._toString = createInterpolator({
      output: [value, value]
    });
  }
  /** @internal */
  static create(value) {
    return new AnimatedString(value);
  }
  getValue() {
    const value = this._string;
    return value == null ? this._string = this._toString(this._value) : value;
  }
  setValue(value) {
    if (is.str(value)) {
      if (value == this._string) {
        return false;
      }
      this._string = value;
      this._value = 1;
    } else if (super.setValue(value)) {
      this._string = null;
    } else {
      return false;
    }
    return true;
  }
  reset(goal) {
    if (goal) {
      this._toString = createInterpolator({
        output: [this.getValue(), goal]
      });
    }
    this._value = 0;
    super.reset();
  }
};

// src/context.ts
var TreeContext = { dependencies: null };

// src/AnimatedObject.ts
var AnimatedObject = class extends Animated {
  constructor(source) {
    super();
    this.source = source;
    this.setValue(source);
  }
  getValue(animated) {
    const values = {};
    eachProp(this.source, (source, key) => {
      if (isAnimated(source)) {
        values[key] = source.getValue(animated);
      } else if (hasFluidValue(source)) {
        values[key] = getFluidValue(source);
      } else if (!animated) {
        values[key] = source;
      }
    });
    return values;
  }
  /** Replace the raw object data */
  setValue(source) {
    this.source = source;
    this.payload = this._makePayload(source);
  }
  reset() {
    if (this.payload) {
      each(this.payload, (node) => node.reset());
    }
  }
  /** Create a payload set. */
  _makePayload(source) {
    if (source) {
      const payload = /* @__PURE__ */ new Set();
      eachProp(source, this._addToPayload, payload);
      return Array.from(payload);
    }
  }
  /** Add to a payload set. */
  _addToPayload(source) {
    if (TreeContext.dependencies && hasFluidValue(source)) {
      TreeContext.dependencies.add(source);
    }
    const payload = getPayload(source);
    if (payload) {
      each(payload, (node) => this.add(node));
    }
  }
};

// src/AnimatedArray.ts
var AnimatedArray = class extends AnimatedObject {
  constructor(source) {
    super(source);
  }
  /** @internal */
  static create(source) {
    return new AnimatedArray(source);
  }
  getValue() {
    return this.source.map((node) => node.getValue());
  }
  setValue(source) {
    const payload = this.getPayload();
    if (source.length == payload.length) {
      return payload.map((node, i) => node.setValue(source[i])).some(Boolean);
    }
    super.setValue(source.map(makeAnimated));
    return true;
  }
};
function makeAnimated(value) {
  const nodeType = isAnimatedString(value) ? AnimatedString : AnimatedValue;
  return nodeType.create(value);
}
function getAnimatedType(value) {
  const parentNode = getAnimated(value);
  return parentNode ? parentNode.constructor : is.arr(value) ? AnimatedArray : isAnimatedString(value) ? AnimatedString : AnimatedValue;
}
var withAnimated = (Component, host) => {
  const hasInstance = (
    // Function components must use "forwardRef" to avoid being
    // re-rendered on every animation frame.
    !is.fun(Component) || Component.prototype && Component.prototype.isReactComponent
  );
  return forwardRef((givenProps, givenRef) => {
    const instanceRef = useRef(null);
    const ref = hasInstance && // eslint-disable-next-line react-hooks/rules-of-hooks
    useCallback(
      (value) => {
        instanceRef.current = updateRef(givenRef, value);
      },
      [givenRef]
    );
    const [props, deps] = getAnimatedState(givenProps, host);
    const forceUpdate = useForceUpdate();
    const callback = () => {
      const instance = instanceRef.current;
      if (hasInstance && !instance) {
        return;
      }
      const didUpdate = instance ? host.applyAnimatedValues(instance, props.getValue(true)) : false;
      if (didUpdate === false) {
        forceUpdate();
      }
    };
    const observer = new PropsObserver(callback, deps);
    const observerRef = useRef();
    useIsomorphicLayoutEffect$1(() => {
      observerRef.current = observer;
      each(deps, (dep) => addFluidObserver(dep, observer));
      return () => {
        if (observerRef.current) {
          each(
            observerRef.current.deps,
            (dep) => removeFluidObserver(dep, observerRef.current)
          );
          raf.cancel(observerRef.current.update);
        }
      };
    });
    useEffect(callback, []);
    useOnce(() => () => {
      const observer2 = observerRef.current;
      each(observer2.deps, (dep) => removeFluidObserver(dep, observer2));
    });
    const usedProps = host.getComponentProps(props.getValue());
    return /* @__PURE__ */ React.createElement(Component, { ...usedProps, ref });
  });
};
var PropsObserver = class {
  constructor(update, deps) {
    this.update = update;
    this.deps = deps;
  }
  eventObserved(event) {
    if (event.type == "change") {
      raf.write(this.update);
    }
  }
};
function getAnimatedState(props, host) {
  const dependencies = /* @__PURE__ */ new Set();
  TreeContext.dependencies = dependencies;
  if (props.style)
    props = {
      ...props,
      style: host.createAnimatedStyle(props.style)
    };
  props = new AnimatedObject(props);
  TreeContext.dependencies = null;
  return [props, dependencies];
}
function updateRef(ref, value) {
  if (ref) {
    if (is.fun(ref))
      ref(value);
    else
      ref.current = value;
  }
  return value;
}

// src/createHost.ts
var cacheKey = Symbol.for("AnimatedComponent");
var createHost = (components, {
  applyAnimatedValues = () => false,
  createAnimatedStyle = (style) => new AnimatedObject(style),
  getComponentProps = (props) => props
} = {}) => {
  const hostConfig = {
    applyAnimatedValues,
    createAnimatedStyle,
    getComponentProps
  };
  const animated = (Component) => {
    const displayName = getDisplayName(Component) || "Anonymous";
    if (is.str(Component)) {
      Component = animated[Component] || (animated[Component] = withAnimated(Component, hostConfig));
    } else {
      Component = Component[cacheKey] || (Component[cacheKey] = withAnimated(Component, hostConfig));
    }
    Component.displayName = `Animated(${displayName})`;
    return Component;
  };
  eachProp(components, (Component, key) => {
    if (is.arr(components)) {
      key = getDisplayName(Component);
    }
    animated[key] = animated(Component);
  });
  return {
    animated
  };
};
var getDisplayName = (arg) => is.str(arg) ? arg : arg && is.str(arg.displayName) ? arg.displayName : is.fun(arg) && arg.name || null;

// src/hooks/useChain.ts
function callProp(value, ...args) {
  return is.fun(value) ? value(...args) : value;
}
var matchProp = (value, key) => value === true || !!(key && value && (is.fun(value) ? value(key) : toArray(value).includes(key)));
var resolveProp = (prop, key) => is.obj(prop) ? key && prop[key] : prop;
var getDefaultProp = (props, key) => props.default === true ? props[key] : props.default ? props.default[key] : void 0;
var noopTransform = (value) => value;
var getDefaultProps = (props, transform = noopTransform) => {
  let keys = DEFAULT_PROPS;
  if (props.default && props.default !== true) {
    props = props.default;
    keys = Object.keys(props);
  }
  const defaults2 = {};
  for (const key of keys) {
    const value = transform(props[key], key);
    if (!is.und(value)) {
      defaults2[key] = value;
    }
  }
  return defaults2;
};
var DEFAULT_PROPS = [
  "config",
  "onProps",
  "onStart",
  "onChange",
  "onPause",
  "onResume",
  "onRest"
];
var RESERVED_PROPS = {
  config: 1,
  from: 1,
  to: 1,
  ref: 1,
  loop: 1,
  reset: 1,
  pause: 1,
  cancel: 1,
  reverse: 1,
  immediate: 1,
  default: 1,
  delay: 1,
  onProps: 1,
  onStart: 1,
  onChange: 1,
  onPause: 1,
  onResume: 1,
  onRest: 1,
  onResolve: 1,
  // Transition props
  items: 1,
  trail: 1,
  sort: 1,
  expires: 1,
  initial: 1,
  enter: 1,
  update: 1,
  leave: 1,
  children: 1,
  onDestroyed: 1,
  // Internal props
  keys: 1,
  callId: 1,
  parentId: 1
};
function getForwardProps(props) {
  const forward = {};
  let count = 0;
  eachProp(props, (value, prop) => {
    if (!RESERVED_PROPS[prop]) {
      forward[prop] = value;
      count++;
    }
  });
  if (count) {
    return forward;
  }
}
function inferTo(props) {
  const to2 = getForwardProps(props);
  if (to2) {
    const out = { to: to2 };
    eachProp(props, (val, key) => key in to2 || (out[key] = val));
    return out;
  }
  return { ...props };
}
function computeGoal(value) {
  value = getFluidValue(value);
  return is.arr(value) ? value.map(computeGoal) : isAnimatedString(value) ? globals_exports.createStringInterpolator({
    range: [0, 1],
    output: [value, value]
  })(1) : value;
}
function hasProps(props) {
  for (const _ in props)
    return true;
  return false;
}
function isAsyncTo(to2) {
  return is.fun(to2) || is.arr(to2) && is.obj(to2[0]);
}
function detachRefs(ctrl, ref) {
  ctrl.ref?.delete(ctrl);
  ref?.delete(ctrl);
}
function replaceRef(ctrl, ref) {
  if (ref && ctrl.ref !== ref) {
    ctrl.ref?.delete(ctrl);
    ref.add(ctrl);
    ctrl.ref = ref;
  }
}

// src/constants.ts
var config = {
  default: { tension: 170, friction: 26 },
  gentle: { tension: 120, friction: 14 },
  wobbly: { tension: 180, friction: 12 },
  stiff: { tension: 210, friction: 20 },
  slow: { tension: 280, friction: 60 },
  molasses: { tension: 280, friction: 120 }
};

// src/AnimationConfig.ts
var defaults = {
  ...config.default,
  mass: 1,
  damping: 1,
  easing: easings.linear,
  clamp: false
};
var AnimationConfig = class {
  constructor() {
    /**
     * The initial velocity of one or more values.
     *
     * @default 0
     */
    this.velocity = 0;
    Object.assign(this, defaults);
  }
};
function mergeConfig(config2, newConfig, defaultConfig) {
  if (defaultConfig) {
    defaultConfig = { ...defaultConfig };
    sanitizeConfig(defaultConfig, newConfig);
    newConfig = { ...defaultConfig, ...newConfig };
  }
  sanitizeConfig(config2, newConfig);
  Object.assign(config2, newConfig);
  for (const key in defaults) {
    if (config2[key] == null) {
      config2[key] = defaults[key];
    }
  }
  let { frequency, damping } = config2;
  const { mass } = config2;
  if (!is.und(frequency)) {
    if (frequency < 0.01)
      frequency = 0.01;
    if (damping < 0)
      damping = 0;
    config2.tension = Math.pow(2 * Math.PI / frequency, 2) * mass;
    config2.friction = 4 * Math.PI * damping * mass / frequency;
  }
  return config2;
}
function sanitizeConfig(config2, props) {
  if (!is.und(props.decay)) {
    config2.duration = void 0;
  } else {
    const isTensionConfig = !is.und(props.tension) || !is.und(props.friction);
    if (isTensionConfig || !is.und(props.frequency) || !is.und(props.damping) || !is.und(props.mass)) {
      config2.duration = void 0;
      config2.decay = void 0;
    }
    if (isTensionConfig) {
      config2.frequency = void 0;
    }
  }
}

// src/Animation.ts
var emptyArray = [];
var Animation = class {
  constructor() {
    this.changed = false;
    this.values = emptyArray;
    this.toValues = null;
    this.fromValues = emptyArray;
    this.config = new AnimationConfig();
    this.immediate = false;
  }
};
function scheduleProps(callId, { key, props, defaultProps, state, actions }) {
  return new Promise((resolve, reject) => {
    let delay;
    let timeout;
    let cancel = matchProp(props.cancel ?? defaultProps?.cancel, key);
    if (cancel) {
      onStart();
    } else {
      if (!is.und(props.pause)) {
        state.paused = matchProp(props.pause, key);
      }
      let pause = defaultProps?.pause;
      if (pause !== true) {
        pause = state.paused || matchProp(pause, key);
      }
      delay = callProp(props.delay || 0, key);
      if (pause) {
        state.resumeQueue.add(onResume);
        actions.pause();
      } else {
        actions.resume();
        onResume();
      }
    }
    function onPause() {
      state.resumeQueue.add(onResume);
      state.timeouts.delete(timeout);
      timeout.cancel();
      delay = timeout.time - raf.now();
    }
    function onResume() {
      if (delay > 0 && !globals_exports.skipAnimation) {
        state.delayed = true;
        timeout = raf.setTimeout(onStart, delay);
        state.pauseQueue.add(onPause);
        state.timeouts.add(timeout);
      } else {
        onStart();
      }
    }
    function onStart() {
      if (state.delayed) {
        state.delayed = false;
      }
      state.pauseQueue.delete(onPause);
      state.timeouts.delete(timeout);
      if (callId <= (state.cancelId || 0)) {
        cancel = true;
      }
      try {
        actions.start({ ...props, callId, cancel }, resolve);
      } catch (err) {
        reject(err);
      }
    }
  });
}

// src/AnimationResult.ts
var getCombinedResult = (target, results) => results.length == 1 ? results[0] : results.some((result) => result.cancelled) ? getCancelledResult(target.get()) : results.every((result) => result.noop) ? getNoopResult(target.get()) : getFinishedResult(
  target.get(),
  results.every((result) => result.finished)
);
var getNoopResult = (value) => ({
  value,
  noop: true,
  finished: true,
  cancelled: false
});
var getFinishedResult = (value, finished, cancelled = false) => ({
  value,
  finished,
  cancelled
});
var getCancelledResult = (value) => ({
  value,
  cancelled: true,
  finished: false
});

// src/runAsync.ts
function runAsync(to2, props, state, target) {
  const { callId, parentId, onRest } = props;
  const { asyncTo: prevTo, promise: prevPromise } = state;
  if (!parentId && to2 === prevTo && !props.reset) {
    return prevPromise;
  }
  return state.promise = (async () => {
    state.asyncId = callId;
    state.asyncTo = to2;
    const defaultProps = getDefaultProps(
      props,
      (value, key) => (
        // The `onRest` prop is only called when the `runAsync` promise is resolved.
        key === "onRest" ? void 0 : value
      )
    );
    let preventBail;
    let bail;
    const bailPromise = new Promise(
      (resolve, reject) => (preventBail = resolve, bail = reject)
    );
    const bailIfEnded = (bailSignal) => {
      const bailResult = (
        // The `cancel` prop or `stop` method was used.
        callId <= (state.cancelId || 0) && getCancelledResult(target) || // The async `to` prop was replaced.
        callId !== state.asyncId && getFinishedResult(target, false)
      );
      if (bailResult) {
        bailSignal.result = bailResult;
        bail(bailSignal);
        throw bailSignal;
      }
    };
    const animate = (arg1, arg2) => {
      const bailSignal = new BailSignal();
      const skipAnimationSignal = new SkipAnimationSignal();
      return (async () => {
        if (globals_exports.skipAnimation) {
          stopAsync(state);
          skipAnimationSignal.result = getFinishedResult(target, false);
          bail(skipAnimationSignal);
          throw skipAnimationSignal;
        }
        bailIfEnded(bailSignal);
        const props2 = is.obj(arg1) ? { ...arg1 } : { ...arg2, to: arg1 };
        props2.parentId = callId;
        eachProp(defaultProps, (value, key) => {
          if (is.und(props2[key])) {
            props2[key] = value;
          }
        });
        const result2 = await target.start(props2);
        bailIfEnded(bailSignal);
        if (state.paused) {
          await new Promise((resume) => {
            state.resumeQueue.add(resume);
          });
        }
        return result2;
      })();
    };
    let result;
    if (globals_exports.skipAnimation) {
      stopAsync(state);
      return getFinishedResult(target, false);
    }
    try {
      let animating;
      if (is.arr(to2)) {
        animating = (async (queue) => {
          for (const props2 of queue) {
            await animate(props2);
          }
        })(to2);
      } else {
        animating = Promise.resolve(to2(animate, target.stop.bind(target)));
      }
      await Promise.all([animating.then(preventBail), bailPromise]);
      result = getFinishedResult(target.get(), true, false);
    } catch (err) {
      if (err instanceof BailSignal) {
        result = err.result;
      } else if (err instanceof SkipAnimationSignal) {
        result = err.result;
      } else {
        throw err;
      }
    } finally {
      if (callId == state.asyncId) {
        state.asyncId = parentId;
        state.asyncTo = parentId ? prevTo : void 0;
        state.promise = parentId ? prevPromise : void 0;
      }
    }
    if (is.fun(onRest)) {
      raf.batchedUpdates(() => {
        onRest(result, target, target.item);
      });
    }
    return result;
  })();
}
function stopAsync(state, cancelId) {
  flush(state.timeouts, (t) => t.cancel());
  state.pauseQueue.clear();
  state.resumeQueue.clear();
  state.asyncId = state.asyncTo = state.promise = void 0;
  if (cancelId)
    state.cancelId = cancelId;
}
var BailSignal = class extends Error {
  constructor() {
    super(
      "An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise."
    );
  }
};
var SkipAnimationSignal = class extends Error {
  constructor() {
    super("SkipAnimationSignal");
  }
};
var isFrameValue = (value) => value instanceof FrameValue;
var nextId = 1;
var FrameValue = class extends FluidValue {
  constructor() {
    super(...arguments);
    this.id = nextId++;
    this._priority = 0;
  }
  get priority() {
    return this._priority;
  }
  set priority(priority) {
    if (this._priority != priority) {
      this._priority = priority;
      this._onPriorityChange(priority);
    }
  }
  /** Get the current value */
  get() {
    const node = getAnimated(this);
    return node && node.getValue();
  }
  /** Create a spring that maps our value to another value */
  to(...args) {
    return globals_exports.to(this, args);
  }
  /** @deprecated Use the `to` method instead. */
  interpolate(...args) {
    deprecateInterpolate();
    return globals_exports.to(this, args);
  }
  toJSON() {
    return this.get();
  }
  observerAdded(count) {
    if (count == 1)
      this._attach();
  }
  observerRemoved(count) {
    if (count == 0)
      this._detach();
  }
  /** Called when the first child is added. */
  _attach() {
  }
  /** Called when the last child is removed. */
  _detach() {
  }
  /** Tell our children about our new value */
  _onChange(value, idle = false) {
    callFluidObservers(this, {
      type: "change",
      parent: this,
      value,
      idle
    });
  }
  /** Tell our children about our new priority */
  _onPriorityChange(priority) {
    if (!this.idle) {
      frameLoop.sort(this);
    }
    callFluidObservers(this, {
      type: "priority",
      parent: this,
      priority
    });
  }
};

// src/SpringPhase.ts
var $P = Symbol.for("SpringPhase");
var HAS_ANIMATED = 1;
var IS_ANIMATING = 2;
var IS_PAUSED = 4;
var hasAnimated = (target) => (target[$P] & HAS_ANIMATED) > 0;
var isAnimating = (target) => (target[$P] & IS_ANIMATING) > 0;
var isPaused = (target) => (target[$P] & IS_PAUSED) > 0;
var setActiveBit = (target, active) => active ? target[$P] |= IS_ANIMATING | HAS_ANIMATED : target[$P] &= ~IS_ANIMATING;
var setPausedBit = (target, paused) => paused ? target[$P] |= IS_PAUSED : target[$P] &= ~IS_PAUSED;

// src/SpringValue.ts
var SpringValue = class extends FrameValue {
  constructor(arg1, arg2) {
    super();
    /** The animation state */
    this.animation = new Animation();
    /** Some props have customizable default values */
    this.defaultProps = {};
    /** The state for `runAsync` calls */
    this._state = {
      paused: false,
      delayed: false,
      pauseQueue: /* @__PURE__ */ new Set(),
      resumeQueue: /* @__PURE__ */ new Set(),
      timeouts: /* @__PURE__ */ new Set()
    };
    /** The promise resolvers of pending `start` calls */
    this._pendingCalls = /* @__PURE__ */ new Set();
    /** The counter for tracking `scheduleProps` calls */
    this._lastCallId = 0;
    /** The last `scheduleProps` call that changed the `to` prop */
    this._lastToId = 0;
    this._memoizedDuration = 0;
    if (!is.und(arg1) || !is.und(arg2)) {
      const props = is.obj(arg1) ? { ...arg1 } : { ...arg2, from: arg1 };
      if (is.und(props.default)) {
        props.default = true;
      }
      this.start(props);
    }
  }
  /** Equals true when not advancing on each frame. */
  get idle() {
    return !(isAnimating(this) || this._state.asyncTo) || isPaused(this);
  }
  get goal() {
    return getFluidValue(this.animation.to);
  }
  get velocity() {
    const node = getAnimated(this);
    return node instanceof AnimatedValue ? node.lastVelocity || 0 : node.getPayload().map((node2) => node2.lastVelocity || 0);
  }
  /**
   * When true, this value has been animated at least once.
   */
  get hasAnimated() {
    return hasAnimated(this);
  }
  /**
   * When true, this value has an unfinished animation,
   * which is either active or paused.
   */
  get isAnimating() {
    return isAnimating(this);
  }
  /**
   * When true, all current and future animations are paused.
   */
  get isPaused() {
    return isPaused(this);
  }
  /**
   *
   *
   */
  get isDelayed() {
    return this._state.delayed;
  }
  /** Advance the current animation by a number of milliseconds */
  advance(dt) {
    let idle = true;
    let changed = false;
    const anim = this.animation;
    let { toValues } = anim;
    const { config: config2 } = anim;
    const payload = getPayload(anim.to);
    if (!payload && hasFluidValue(anim.to)) {
      toValues = toArray(getFluidValue(anim.to));
    }
    anim.values.forEach((node2, i) => {
      if (node2.done)
        return;
      const to2 = (
        // Animated strings always go from 0 to 1.
        node2.constructor == AnimatedString ? 1 : payload ? payload[i].lastPosition : toValues[i]
      );
      let finished = anim.immediate;
      let position = to2;
      if (!finished) {
        position = node2.lastPosition;
        if (config2.tension <= 0) {
          node2.done = true;
          return;
        }
        let elapsed = node2.elapsedTime += dt;
        const from = anim.fromValues[i];
        const v0 = node2.v0 != null ? node2.v0 : node2.v0 = is.arr(config2.velocity) ? config2.velocity[i] : config2.velocity;
        let velocity;
        const precision = config2.precision || (from == to2 ? 5e-3 : Math.min(1, Math.abs(to2 - from) * 1e-3));
        if (!is.und(config2.duration)) {
          let p = 1;
          if (config2.duration > 0) {
            if (this._memoizedDuration !== config2.duration) {
              this._memoizedDuration = config2.duration;
              if (node2.durationProgress > 0) {
                node2.elapsedTime = config2.duration * node2.durationProgress;
                elapsed = node2.elapsedTime += dt;
              }
            }
            p = (config2.progress || 0) + elapsed / this._memoizedDuration;
            p = p > 1 ? 1 : p < 0 ? 0 : p;
            node2.durationProgress = p;
          }
          position = from + config2.easing(p) * (to2 - from);
          velocity = (position - node2.lastPosition) / dt;
          finished = p == 1;
        } else if (config2.decay) {
          const decay = config2.decay === true ? 0.998 : config2.decay;
          const e = Math.exp(-(1 - decay) * elapsed);
          position = from + v0 / (1 - decay) * (1 - e);
          finished = Math.abs(node2.lastPosition - position) <= precision;
          velocity = v0 * e;
        } else {
          velocity = node2.lastVelocity == null ? v0 : node2.lastVelocity;
          const restVelocity = config2.restVelocity || precision / 10;
          const bounceFactor = config2.clamp ? 0 : config2.bounce;
          const canBounce = !is.und(bounceFactor);
          const isGrowing = from == to2 ? node2.v0 > 0 : from < to2;
          let isMoving;
          let isBouncing = false;
          const step = 1;
          const numSteps = Math.ceil(dt / step);
          for (let n = 0; n < numSteps; ++n) {
            isMoving = Math.abs(velocity) > restVelocity;
            if (!isMoving) {
              finished = Math.abs(to2 - position) <= precision;
              if (finished) {
                break;
              }
            }
            if (canBounce) {
              isBouncing = position == to2 || position > to2 == isGrowing;
              if (isBouncing) {
                velocity = -velocity * bounceFactor;
                position = to2;
              }
            }
            const springForce = -config2.tension * 1e-6 * (position - to2);
            const dampingForce = -config2.friction * 1e-3 * velocity;
            const acceleration = (springForce + dampingForce) / config2.mass;
            velocity = velocity + acceleration * step;
            position = position + velocity * step;
          }
        }
        node2.lastVelocity = velocity;
        if (Number.isNaN(position)) {
          console.warn(`Got NaN while animating:`, this);
          finished = true;
        }
      }
      if (payload && !payload[i].done) {
        finished = false;
      }
      if (finished) {
        node2.done = true;
      } else {
        idle = false;
      }
      if (node2.setValue(position, config2.round)) {
        changed = true;
      }
    });
    const node = getAnimated(this);
    const currVal = node.getValue();
    if (idle) {
      const finalVal = getFluidValue(anim.to);
      if ((currVal !== finalVal || changed) && !config2.decay) {
        node.setValue(finalVal);
        this._onChange(finalVal);
      } else if (changed && config2.decay) {
        this._onChange(currVal);
      }
      this._stop();
    } else if (changed) {
      this._onChange(currVal);
    }
  }
  /** Set the current value, while stopping the current animation */
  set(value) {
    raf.batchedUpdates(() => {
      this._stop();
      this._focus(value);
      this._set(value);
    });
    return this;
  }
  /**
   * Freeze the active animation in time, as well as any updates merged
   * before `resume` is called.
   */
  pause() {
    this._update({ pause: true });
  }
  /** Resume the animation if paused. */
  resume() {
    this._update({ pause: false });
  }
  /** Skip to the end of the current animation. */
  finish() {
    if (isAnimating(this)) {
      const { to: to2, config: config2 } = this.animation;
      raf.batchedUpdates(() => {
        this._onStart();
        if (!config2.decay) {
          this._set(to2, false);
        }
        this._stop();
      });
    }
    return this;
  }
  /** Push props into the pending queue. */
  update(props) {
    const queue = this.queue || (this.queue = []);
    queue.push(props);
    return this;
  }
  start(to2, arg2) {
    let queue;
    if (!is.und(to2)) {
      queue = [is.obj(to2) ? to2 : { ...arg2, to: to2 }];
    } else {
      queue = this.queue || [];
      this.queue = [];
    }
    return Promise.all(
      queue.map((props) => {
        const up = this._update(props);
        return up;
      })
    ).then((results) => getCombinedResult(this, results));
  }
  /**
   * Stop the current animation, and cancel any delayed updates.
   *
   * Pass `true` to call `onRest` with `cancelled: true`.
   */
  stop(cancel) {
    const { to: to2 } = this.animation;
    this._focus(this.get());
    stopAsync(this._state, cancel && this._lastCallId);
    raf.batchedUpdates(() => this._stop(to2, cancel));
    return this;
  }
  /** Restart the animation. */
  reset() {
    this._update({ reset: true });
  }
  /** @internal */
  eventObserved(event) {
    if (event.type == "change") {
      this._start();
    } else if (event.type == "priority") {
      this.priority = event.priority + 1;
    }
  }
  /**
   * Parse the `to` and `from` range from the given `props` object.
   *
   * This also ensures the initial value is available to animated components
   * during the render phase.
   */
  _prepareNode(props) {
    const key = this.key || "";
    let { to: to2, from } = props;
    to2 = is.obj(to2) ? to2[key] : to2;
    if (to2 == null || isAsyncTo(to2)) {
      to2 = void 0;
    }
    from = is.obj(from) ? from[key] : from;
    if (from == null) {
      from = void 0;
    }
    const range = { to: to2, from };
    if (!hasAnimated(this)) {
      if (props.reverse)
        [to2, from] = [from, to2];
      from = getFluidValue(from);
      if (!is.und(from)) {
        this._set(from);
      } else if (!getAnimated(this)) {
        this._set(to2);
      }
    }
    return range;
  }
  /** Every update is processed by this method before merging. */
  _update({ ...props }, isLoop) {
    const { key, defaultProps } = this;
    if (props.default)
      Object.assign(
        defaultProps,
        getDefaultProps(
          props,
          (value, prop) => /^on/.test(prop) ? resolveProp(value, key) : value
        )
      );
    mergeActiveFn(this, props, "onProps");
    sendEvent(this, "onProps", props, this);
    const range = this._prepareNode(props);
    if (Object.isFrozen(this)) {
      throw Error(
        "Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?"
      );
    }
    const state = this._state;
    return scheduleProps(++this._lastCallId, {
      key,
      props,
      defaultProps,
      state,
      actions: {
        pause: () => {
          if (!isPaused(this)) {
            setPausedBit(this, true);
            flushCalls(state.pauseQueue);
            sendEvent(
              this,
              "onPause",
              getFinishedResult(this, checkFinished(this, this.animation.to)),
              this
            );
          }
        },
        resume: () => {
          if (isPaused(this)) {
            setPausedBit(this, false);
            if (isAnimating(this)) {
              this._resume();
            }
            flushCalls(state.resumeQueue);
            sendEvent(
              this,
              "onResume",
              getFinishedResult(this, checkFinished(this, this.animation.to)),
              this
            );
          }
        },
        start: this._merge.bind(this, range)
      }
    }).then((result) => {
      if (props.loop && result.finished && !(isLoop && result.noop)) {
        const nextProps = createLoopUpdate(props);
        if (nextProps) {
          return this._update(nextProps, true);
        }
      }
      return result;
    });
  }
  /** Merge props into the current animation */
  _merge(range, props, resolve) {
    if (props.cancel) {
      this.stop(true);
      return resolve(getCancelledResult(this));
    }
    const hasToProp = !is.und(range.to);
    const hasFromProp = !is.und(range.from);
    if (hasToProp || hasFromProp) {
      if (props.callId > this._lastToId) {
        this._lastToId = props.callId;
      } else {
        return resolve(getCancelledResult(this));
      }
    }
    const { key, defaultProps, animation: anim } = this;
    const { to: prevTo, from: prevFrom } = anim;
    let { to: to2 = prevTo, from = prevFrom } = range;
    if (hasFromProp && !hasToProp && (!props.default || is.und(to2))) {
      to2 = from;
    }
    if (props.reverse)
      [to2, from] = [from, to2];
    const hasFromChanged = !isEqual$1(from, prevFrom);
    if (hasFromChanged) {
      anim.from = from;
    }
    from = getFluidValue(from);
    const hasToChanged = !isEqual$1(to2, prevTo);
    if (hasToChanged) {
      this._focus(to2);
    }
    const hasAsyncTo = isAsyncTo(props.to);
    const { config: config2 } = anim;
    const { decay, velocity } = config2;
    if (hasToProp || hasFromProp) {
      config2.velocity = 0;
    }
    if (props.config && !hasAsyncTo) {
      mergeConfig(
        config2,
        callProp(props.config, key),
        // Avoid calling the same "config" prop twice.
        props.config !== defaultProps.config ? callProp(defaultProps.config, key) : void 0
      );
    }
    let node = getAnimated(this);
    if (!node || is.und(to2)) {
      return resolve(getFinishedResult(this, true));
    }
    const reset = (
      // When `reset` is undefined, the `from` prop implies `reset: true`,
      // except for declarative updates. When `reset` is defined, there
      // must exist a value to animate from.
      is.und(props.reset) ? hasFromProp && !props.default : !is.und(from) && matchProp(props.reset, key)
    );
    const value = reset ? from : this.get();
    const goal = computeGoal(to2);
    const isAnimatable = is.num(goal) || is.arr(goal) || isAnimatedString(goal);
    const immediate = !hasAsyncTo && (!isAnimatable || matchProp(defaultProps.immediate || props.immediate, key));
    if (hasToChanged) {
      const nodeType = getAnimatedType(to2);
      if (nodeType !== node.constructor) {
        if (immediate) {
          node = this._set(goal);
        } else
          throw Error(
            `Cannot animate between ${node.constructor.name} and ${nodeType.name}, as the "to" prop suggests`
          );
      }
    }
    const goalType = node.constructor;
    let started = hasFluidValue(to2);
    let finished = false;
    if (!started) {
      const hasValueChanged = reset || !hasAnimated(this) && hasFromChanged;
      if (hasToChanged || hasValueChanged) {
        finished = isEqual$1(computeGoal(value), goal);
        started = !finished;
      }
      if (!isEqual$1(anim.immediate, immediate) && !immediate || !isEqual$1(config2.decay, decay) || !isEqual$1(config2.velocity, velocity)) {
        started = true;
      }
    }
    if (finished && isAnimating(this)) {
      if (anim.changed && !reset) {
        started = true;
      } else if (!started) {
        this._stop(prevTo);
      }
    }
    if (!hasAsyncTo) {
      if (started || hasFluidValue(prevTo)) {
        anim.values = node.getPayload();
        anim.toValues = hasFluidValue(to2) ? null : goalType == AnimatedString ? [1] : toArray(goal);
      }
      if (anim.immediate != immediate) {
        anim.immediate = immediate;
        if (!immediate && !reset) {
          this._set(prevTo);
        }
      }
      if (started) {
        const { onRest } = anim;
        each(ACTIVE_EVENTS, (type) => mergeActiveFn(this, props, type));
        const result = getFinishedResult(this, checkFinished(this, prevTo));
        flushCalls(this._pendingCalls, result);
        this._pendingCalls.add(resolve);
        if (anim.changed)
          raf.batchedUpdates(() => {
            anim.changed = !reset;
            onRest?.(result, this);
            if (reset) {
              callProp(defaultProps.onRest, result);
            } else {
              anim.onStart?.(result, this);
            }
          });
      }
    }
    if (reset) {
      this._set(value);
    }
    if (hasAsyncTo) {
      resolve(runAsync(props.to, props, this._state, this));
    } else if (started) {
      this._start();
    } else if (isAnimating(this) && !hasToChanged) {
      this._pendingCalls.add(resolve);
    } else {
      resolve(getNoopResult(value));
    }
  }
  /** Update the `animation.to` value, which might be a `FluidValue` */
  _focus(value) {
    const anim = this.animation;
    if (value !== anim.to) {
      if (getFluidObservers(this)) {
        this._detach();
      }
      anim.to = value;
      if (getFluidObservers(this)) {
        this._attach();
      }
    }
  }
  _attach() {
    let priority = 0;
    const { to: to2 } = this.animation;
    if (hasFluidValue(to2)) {
      addFluidObserver(to2, this);
      if (isFrameValue(to2)) {
        priority = to2.priority + 1;
      }
    }
    this.priority = priority;
  }
  _detach() {
    const { to: to2 } = this.animation;
    if (hasFluidValue(to2)) {
      removeFluidObserver(to2, this);
    }
  }
  /**
   * Update the current value from outside the frameloop,
   * and return the `Animated` node.
   */
  _set(arg, idle = true) {
    const value = getFluidValue(arg);
    if (!is.und(value)) {
      const oldNode = getAnimated(this);
      if (!oldNode || !isEqual$1(value, oldNode.getValue())) {
        const nodeType = getAnimatedType(value);
        if (!oldNode || oldNode.constructor != nodeType) {
          setAnimated(this, nodeType.create(value));
        } else {
          oldNode.setValue(value);
        }
        if (oldNode) {
          raf.batchedUpdates(() => {
            this._onChange(value, idle);
          });
        }
      }
    }
    return getAnimated(this);
  }
  _onStart() {
    const anim = this.animation;
    if (!anim.changed) {
      anim.changed = true;
      sendEvent(
        this,
        "onStart",
        getFinishedResult(this, checkFinished(this, anim.to)),
        this
      );
    }
  }
  _onChange(value, idle) {
    if (!idle) {
      this._onStart();
      callProp(this.animation.onChange, value, this);
    }
    callProp(this.defaultProps.onChange, value, this);
    super._onChange(value, idle);
  }
  // This method resets the animation state (even if already animating) to
  // ensure the latest from/to range is used, and it also ensures this spring
  // is added to the frameloop.
  _start() {
    const anim = this.animation;
    getAnimated(this).reset(getFluidValue(anim.to));
    if (!anim.immediate) {
      anim.fromValues = anim.values.map((node) => node.lastPosition);
    }
    if (!isAnimating(this)) {
      setActiveBit(this, true);
      if (!isPaused(this)) {
        this._resume();
      }
    }
  }
  _resume() {
    if (globals_exports.skipAnimation) {
      this.finish();
    } else {
      frameLoop.start(this);
    }
  }
  /**
   * Exit the frameloop and notify `onRest` listeners.
   *
   * Always wrap `_stop` calls with `batchedUpdates`.
   */
  _stop(goal, cancel) {
    if (isAnimating(this)) {
      setActiveBit(this, false);
      const anim = this.animation;
      each(anim.values, (node) => {
        node.done = true;
      });
      if (anim.toValues) {
        anim.onChange = anim.onPause = anim.onResume = void 0;
      }
      callFluidObservers(this, {
        type: "idle",
        parent: this
      });
      const result = cancel ? getCancelledResult(this.get()) : getFinishedResult(this.get(), checkFinished(this, goal ?? anim.to));
      flushCalls(this._pendingCalls, result);
      if (anim.changed) {
        anim.changed = false;
        sendEvent(this, "onRest", result, this);
      }
    }
  }
};
function checkFinished(target, to2) {
  const goal = computeGoal(to2);
  const value = computeGoal(target.get());
  return isEqual$1(value, goal);
}
function createLoopUpdate(props, loop = props.loop, to2 = props.to) {
  const loopRet = callProp(loop);
  if (loopRet) {
    const overrides = loopRet !== true && inferTo(loopRet);
    const reverse = (overrides || props).reverse;
    const reset = !overrides || overrides.reset;
    return createUpdate({
      ...props,
      loop,
      // Avoid updating default props when looping.
      default: false,
      // Never loop the `pause` prop.
      pause: void 0,
      // For the "reverse" prop to loop as expected, the "to" prop
      // must be undefined. The "reverse" prop is ignored when the
      // "to" prop is an array or function.
      to: !reverse || isAsyncTo(to2) ? to2 : void 0,
      // Ignore the "from" prop except on reset.
      from: reset ? props.from : void 0,
      reset,
      // The "loop" prop can return a "useSpring" props object to
      // override any of the original props.
      ...overrides
    });
  }
}
function createUpdate(props) {
  const { to: to2, from } = props = inferTo(props);
  const keys = /* @__PURE__ */ new Set();
  if (is.obj(to2))
    findDefined(to2, keys);
  if (is.obj(from))
    findDefined(from, keys);
  props.keys = keys.size ? Array.from(keys) : null;
  return props;
}
function declareUpdate(props) {
  const update2 = createUpdate(props);
  if (is.und(update2.default)) {
    update2.default = getDefaultProps(update2);
  }
  return update2;
}
function findDefined(values, keys) {
  eachProp(values, (value, key) => value != null && keys.add(key));
}
var ACTIVE_EVENTS = [
  "onStart",
  "onRest",
  "onChange",
  "onPause",
  "onResume"
];
function mergeActiveFn(target, props, type) {
  target.animation[type] = props[type] !== getDefaultProp(props, type) ? resolveProp(props[type], target.key) : void 0;
}
function sendEvent(target, type, ...args) {
  target.animation[type]?.(...args);
  target.defaultProps[type]?.(...args);
}
var BATCHED_EVENTS = ["onStart", "onChange", "onRest"];
var nextId2 = 1;
var Controller = class {
  constructor(props, flush3) {
    this.id = nextId2++;
    /** The animated values */
    this.springs = {};
    /** The queue of props passed to the `update` method. */
    this.queue = [];
    /** The counter for tracking `scheduleProps` calls */
    this._lastAsyncId = 0;
    /** The values currently being animated */
    this._active = /* @__PURE__ */ new Set();
    /** The values that changed recently */
    this._changed = /* @__PURE__ */ new Set();
    /** Equals false when `onStart` listeners can be called */
    this._started = false;
    /** State used by the `runAsync` function */
    this._state = {
      paused: false,
      pauseQueue: /* @__PURE__ */ new Set(),
      resumeQueue: /* @__PURE__ */ new Set(),
      timeouts: /* @__PURE__ */ new Set()
    };
    /** The event queues that are flushed once per frame maximum */
    this._events = {
      onStart: /* @__PURE__ */ new Map(),
      onChange: /* @__PURE__ */ new Map(),
      onRest: /* @__PURE__ */ new Map()
    };
    this._onFrame = this._onFrame.bind(this);
    if (flush3) {
      this._flush = flush3;
    }
    if (props) {
      this.start({ default: true, ...props });
    }
  }
  /**
   * Equals `true` when no spring values are in the frameloop, and
   * no async animation is currently active.
   */
  get idle() {
    return !this._state.asyncTo && Object.values(this.springs).every((spring) => {
      return spring.idle && !spring.isDelayed && !spring.isPaused;
    });
  }
  get item() {
    return this._item;
  }
  set item(item) {
    this._item = item;
  }
  /** Get the current values of our springs */
  get() {
    const values = {};
    this.each((spring, key) => values[key] = spring.get());
    return values;
  }
  /** Set the current values without animating. */
  set(values) {
    for (const key in values) {
      const value = values[key];
      if (!is.und(value)) {
        this.springs[key].set(value);
      }
    }
  }
  /** Push an update onto the queue of each value. */
  update(props) {
    if (props) {
      this.queue.push(createUpdate(props));
    }
    return this;
  }
  /**
   * Start the queued animations for every spring, and resolve the returned
   * promise once all queued animations have finished or been cancelled.
   *
   * When you pass a queue (instead of nothing), that queue is used instead of
   * the queued animations added with the `update` method, which are left alone.
   */
  start(props) {
    let { queue } = this;
    if (props) {
      queue = toArray(props).map(createUpdate);
    } else {
      this.queue = [];
    }
    if (this._flush) {
      return this._flush(this, queue);
    }
    prepareKeys(this, queue);
    return flushUpdateQueue(this, queue);
  }
  /** @internal */
  stop(arg, keys) {
    if (arg !== !!arg) {
      keys = arg;
    }
    if (keys) {
      const springs = this.springs;
      each(toArray(keys), (key) => springs[key].stop(!!arg));
    } else {
      stopAsync(this._state, this._lastAsyncId);
      this.each((spring) => spring.stop(!!arg));
    }
    return this;
  }
  /** Freeze the active animation in time */
  pause(keys) {
    if (is.und(keys)) {
      this.start({ pause: true });
    } else {
      const springs = this.springs;
      each(toArray(keys), (key) => springs[key].pause());
    }
    return this;
  }
  /** Resume the animation if paused. */
  resume(keys) {
    if (is.und(keys)) {
      this.start({ pause: false });
    } else {
      const springs = this.springs;
      each(toArray(keys), (key) => springs[key].resume());
    }
    return this;
  }
  /** Call a function once per spring value */
  each(iterator) {
    eachProp(this.springs, iterator);
  }
  /** @internal Called at the end of every animation frame */
  _onFrame() {
    const { onStart, onChange, onRest } = this._events;
    const active = this._active.size > 0;
    const changed = this._changed.size > 0;
    if (active && !this._started || changed && !this._started) {
      this._started = true;
      flush(onStart, ([onStart2, result]) => {
        result.value = this.get();
        onStart2(result, this, this._item);
      });
    }
    const idle = !active && this._started;
    const values = changed || idle && onRest.size ? this.get() : null;
    if (changed && onChange.size) {
      flush(onChange, ([onChange2, result]) => {
        result.value = values;
        onChange2(result, this, this._item);
      });
    }
    if (idle) {
      this._started = false;
      flush(onRest, ([onRest2, result]) => {
        result.value = values;
        onRest2(result, this, this._item);
      });
    }
  }
  /** @internal */
  eventObserved(event) {
    if (event.type == "change") {
      this._changed.add(event.parent);
      if (!event.idle) {
        this._active.add(event.parent);
      }
    } else if (event.type == "idle") {
      this._active.delete(event.parent);
    } else
      return;
    raf.onFrame(this._onFrame);
  }
};
function flushUpdateQueue(ctrl, queue) {
  return Promise.all(queue.map((props) => flushUpdate(ctrl, props))).then(
    (results) => getCombinedResult(ctrl, results)
  );
}
async function flushUpdate(ctrl, props, isLoop) {
  const { keys, to: to2, from, loop, onRest, onResolve } = props;
  const defaults2 = is.obj(props.default) && props.default;
  if (loop) {
    props.loop = false;
  }
  if (to2 === false)
    props.to = null;
  if (from === false)
    props.from = null;
  const asyncTo = is.arr(to2) || is.fun(to2) ? to2 : void 0;
  if (asyncTo) {
    props.to = void 0;
    props.onRest = void 0;
    if (defaults2) {
      defaults2.onRest = void 0;
    }
  } else {
    each(BATCHED_EVENTS, (key) => {
      const handler = props[key];
      if (is.fun(handler)) {
        const queue = ctrl["_events"][key];
        props[key] = ({ finished, cancelled }) => {
          const result2 = queue.get(handler);
          if (result2) {
            if (!finished)
              result2.finished = false;
            if (cancelled)
              result2.cancelled = true;
          } else {
            queue.set(handler, {
              value: null,
              finished: finished || false,
              cancelled: cancelled || false
            });
          }
        };
        if (defaults2) {
          defaults2[key] = props[key];
        }
      }
    });
  }
  const state = ctrl["_state"];
  if (props.pause === !state.paused) {
    state.paused = props.pause;
    flushCalls(props.pause ? state.pauseQueue : state.resumeQueue);
  } else if (state.paused) {
    props.pause = true;
  }
  const promises = (keys || Object.keys(ctrl.springs)).map(
    (key) => ctrl.springs[key].start(props)
  );
  const cancel = props.cancel === true || getDefaultProp(props, "cancel") === true;
  if (asyncTo || cancel && state.asyncId) {
    promises.push(
      scheduleProps(++ctrl["_lastAsyncId"], {
        props,
        state,
        actions: {
          pause: noop$4,
          resume: noop$4,
          start(props2, resolve) {
            if (cancel) {
              stopAsync(state, ctrl["_lastAsyncId"]);
              resolve(getCancelledResult(ctrl));
            } else {
              props2.onRest = onRest;
              resolve(
                runAsync(
                  asyncTo,
                  props2,
                  state,
                  ctrl
                )
              );
            }
          }
        }
      })
    );
  }
  if (state.paused) {
    await new Promise((resume) => {
      state.resumeQueue.add(resume);
    });
  }
  const result = getCombinedResult(ctrl, await Promise.all(promises));
  if (loop && result.finished && !(isLoop && result.noop)) {
    const nextProps = createLoopUpdate(props, loop, to2);
    if (nextProps) {
      prepareKeys(ctrl, [nextProps]);
      return flushUpdate(ctrl, nextProps, true);
    }
  }
  if (onResolve) {
    raf.batchedUpdates(() => onResolve(result, ctrl, ctrl.item));
  }
  return result;
}
function getSprings(ctrl, props) {
  const springs = { ...ctrl.springs };
  if (props) {
    each(toArray(props), (props2) => {
      if (is.und(props2.keys)) {
        props2 = createUpdate(props2);
      }
      if (!is.obj(props2.to)) {
        props2 = { ...props2, to: void 0 };
      }
      prepareSprings(springs, props2, (key) => {
        return createSpring(key);
      });
    });
  }
  setSprings(ctrl, springs);
  return springs;
}
function setSprings(ctrl, springs) {
  eachProp(springs, (spring, key) => {
    if (!ctrl.springs[key]) {
      ctrl.springs[key] = spring;
      addFluidObserver(spring, ctrl);
    }
  });
}
function createSpring(key, observer) {
  const spring = new SpringValue();
  spring.key = key;
  if (observer) {
    addFluidObserver(spring, observer);
  }
  return spring;
}
function prepareSprings(springs, props, create) {
  if (props.keys) {
    each(props.keys, (key) => {
      const spring = springs[key] || (springs[key] = create(key));
      spring["_prepareNode"](props);
    });
  }
}
function prepareKeys(ctrl, queue) {
  each(queue, (props) => {
    prepareSprings(ctrl.springs, props, (key) => {
      return createSpring(key, ctrl);
    });
  });
}
var SpringContext = ({
  children,
  ...props
}) => {
  const inherited = useContext(ctx);
  const pause = props.pause || !!inherited.pause, immediate = props.immediate || !!inherited.immediate;
  props = useMemoOne(() => ({ pause, immediate }), [pause, immediate]);
  const { Provider } = ctx;
  return /* @__PURE__ */ React.createElement(Provider, { value: props }, children);
};
var ctx = makeContext(SpringContext, {});
SpringContext.Provider = ctx.Provider;
SpringContext.Consumer = ctx.Consumer;
function makeContext(target, init) {
  Object.assign(target, React.createContext(init));
  target.Provider._context = target;
  target.Consumer._context = target;
  return target;
}
var SpringRef = () => {
  const current = [];
  const SpringRef2 = function(props) {
    deprecateDirectCall();
    const results = [];
    each(current, (ctrl, i) => {
      if (is.und(props)) {
        results.push(ctrl.start());
      } else {
        const update2 = _getProps(props, ctrl, i);
        if (update2) {
          results.push(ctrl.start(update2));
        }
      }
    });
    return results;
  };
  SpringRef2.current = current;
  SpringRef2.add = function(ctrl) {
    if (!current.includes(ctrl)) {
      current.push(ctrl);
    }
  };
  SpringRef2.delete = function(ctrl) {
    const i = current.indexOf(ctrl);
    if (~i)
      current.splice(i, 1);
  };
  SpringRef2.pause = function() {
    each(current, (ctrl) => ctrl.pause(...arguments));
    return this;
  };
  SpringRef2.resume = function() {
    each(current, (ctrl) => ctrl.resume(...arguments));
    return this;
  };
  SpringRef2.set = function(values) {
    each(current, (ctrl, i) => {
      const update2 = is.fun(values) ? values(i, ctrl) : values;
      if (update2) {
        ctrl.set(update2);
      }
    });
  };
  SpringRef2.start = function(props) {
    const results = [];
    each(current, (ctrl, i) => {
      if (is.und(props)) {
        results.push(ctrl.start());
      } else {
        const update2 = this._getProps(props, ctrl, i);
        if (update2) {
          results.push(ctrl.start(update2));
        }
      }
    });
    return results;
  };
  SpringRef2.stop = function() {
    each(current, (ctrl) => ctrl.stop(...arguments));
    return this;
  };
  SpringRef2.update = function(props) {
    each(current, (ctrl, i) => ctrl.update(this._getProps(props, ctrl, i)));
    return this;
  };
  const _getProps = function(arg, ctrl, index) {
    return is.fun(arg) ? arg(index, ctrl) : arg;
  };
  SpringRef2._getProps = _getProps;
  return SpringRef2;
};

// src/hooks/useSprings.ts
function useSprings(length, props, deps) {
  const propsFn = is.fun(props) && props;
  if (propsFn && !deps)
    deps = [];
  const ref = useMemo(
    () => propsFn || arguments.length == 3 ? SpringRef() : void 0,
    []
  );
  const layoutId = useRef(0);
  const forceUpdate = useForceUpdate();
  const state = useMemo(
    () => ({
      ctrls: [],
      queue: [],
      flush(ctrl, updates2) {
        const springs2 = getSprings(ctrl, updates2);
        const canFlushSync = layoutId.current > 0 && !state.queue.length && !Object.keys(springs2).some((key) => !ctrl.springs[key]);
        return canFlushSync ? flushUpdateQueue(ctrl, updates2) : new Promise((resolve) => {
          setSprings(ctrl, springs2);
          state.queue.push(() => {
            resolve(flushUpdateQueue(ctrl, updates2));
          });
          forceUpdate();
        });
      }
    }),
    []
  );
  const ctrls = useRef([...state.ctrls]);
  const updates = [];
  const prevLength = usePrev(length) || 0;
  useMemo(() => {
    each(ctrls.current.slice(length, prevLength), (ctrl) => {
      detachRefs(ctrl, ref);
      ctrl.stop(true);
    });
    ctrls.current.length = length;
    declareUpdates(prevLength, length);
  }, [length]);
  useMemo(() => {
    declareUpdates(0, Math.min(prevLength, length));
  }, deps);
  function declareUpdates(startIndex, endIndex) {
    for (let i = startIndex; i < endIndex; i++) {
      const ctrl = ctrls.current[i] || (ctrls.current[i] = new Controller(null, state.flush));
      const update2 = propsFn ? propsFn(i, ctrl) : props[i];
      if (update2) {
        updates[i] = declareUpdate(update2);
      }
    }
  }
  const springs = ctrls.current.map((ctrl, i) => getSprings(ctrl, updates[i]));
  const context = useContext(SpringContext);
  const prevContext = usePrev(context);
  const hasContext = context !== prevContext && hasProps(context);
  useIsomorphicLayoutEffect$1(() => {
    layoutId.current++;
    state.ctrls = ctrls.current;
    const { queue } = state;
    if (queue.length) {
      state.queue = [];
      each(queue, (cb) => cb());
    }
    each(ctrls.current, (ctrl, i) => {
      ref?.add(ctrl);
      if (hasContext) {
        ctrl.start({ default: context });
      }
      const update2 = updates[i];
      if (update2) {
        replaceRef(ctrl, update2.ref);
        if (ctrl.ref) {
          ctrl.queue.push(update2);
        } else {
          ctrl.start(update2);
        }
      }
    });
  });
  useOnce(() => () => {
    each(state.ctrls, (ctrl) => ctrl.stop(true));
  });
  const values = springs.map((x) => ({ ...x }));
  return ref ? [values, ref] : values;
}

// src/hooks/useSpring.ts
function useSpring(props, deps) {
  const isFn = is.fun(props);
  const [[values], ref] = useSprings(
    1,
    isFn ? props : [props],
    isFn ? deps || [] : deps
  );
  return isFn || arguments.length == 2 ? [values, ref] : values;
}
function useTransition(data, props, deps) {
  const propsFn = is.fun(props) && props;
  const {
    reset,
    sort,
    trail = 0,
    expires = true,
    exitBeforeEnter = false,
    onDestroyed,
    ref: propsRef,
    config: propsConfig
  } = propsFn ? propsFn() : props;
  const ref = useMemo(
    () => propsFn || arguments.length == 3 ? SpringRef() : void 0,
    []
  );
  const items = toArray(data);
  const transitions = [];
  const usedTransitions = useRef(null);
  const prevTransitions = reset ? null : usedTransitions.current;
  useIsomorphicLayoutEffect$1(() => {
    usedTransitions.current = transitions;
  });
  useOnce(() => {
    each(transitions, (t) => {
      ref?.add(t.ctrl);
      t.ctrl.ref = ref;
    });
    return () => {
      each(usedTransitions.current, (t) => {
        if (t.expired) {
          clearTimeout(t.expirationId);
        }
        detachRefs(t.ctrl, ref);
        t.ctrl.stop(true);
      });
    };
  });
  const keys = getKeys(items, propsFn ? propsFn() : props, prevTransitions);
  const expired = reset && usedTransitions.current || [];
  useIsomorphicLayoutEffect$1(
    () => each(expired, ({ ctrl, item, key }) => {
      detachRefs(ctrl, ref);
      callProp(onDestroyed, item, key);
    })
  );
  const reused = [];
  if (prevTransitions)
    each(prevTransitions, (t, i) => {
      if (t.expired) {
        clearTimeout(t.expirationId);
        expired.push(t);
      } else {
        i = reused[i] = keys.indexOf(t.key);
        if (~i)
          transitions[i] = t;
      }
    });
  each(items, (item, i) => {
    if (!transitions[i]) {
      transitions[i] = {
        key: keys[i],
        item,
        phase: "mount" /* MOUNT */,
        ctrl: new Controller()
      };
      transitions[i].ctrl.item = item;
    }
  });
  if (reused.length) {
    let i = -1;
    const { leave } = propsFn ? propsFn() : props;
    each(reused, (keyIndex, prevIndex) => {
      const t = prevTransitions[prevIndex];
      if (~keyIndex) {
        i = transitions.indexOf(t);
        transitions[i] = { ...t, item: items[keyIndex] };
      } else if (leave) {
        transitions.splice(++i, 0, t);
      }
    });
  }
  if (is.fun(sort)) {
    transitions.sort((a, b) => sort(a.item, b.item));
  }
  let delay = -trail;
  const forceUpdate = useForceUpdate();
  const defaultProps = getDefaultProps(props);
  const changes = /* @__PURE__ */ new Map();
  const exitingTransitions = useRef(/* @__PURE__ */ new Map());
  const forceChange = useRef(false);
  each(transitions, (t, i) => {
    const key = t.key;
    const prevPhase = t.phase;
    const p = propsFn ? propsFn() : props;
    let to2;
    let phase;
    const propsDelay = callProp(p.delay || 0, key);
    if (prevPhase == "mount" /* MOUNT */) {
      to2 = p.enter;
      phase = "enter" /* ENTER */;
    } else {
      const isLeave = keys.indexOf(key) < 0;
      if (prevPhase != "leave" /* LEAVE */) {
        if (isLeave) {
          to2 = p.leave;
          phase = "leave" /* LEAVE */;
        } else if (to2 = p.update) {
          phase = "update" /* UPDATE */;
        } else
          return;
      } else if (!isLeave) {
        to2 = p.enter;
        phase = "enter" /* ENTER */;
      } else
        return;
    }
    to2 = callProp(to2, t.item, i);
    to2 = is.obj(to2) ? inferTo(to2) : { to: to2 };
    if (!to2.config) {
      const config2 = propsConfig || defaultProps.config;
      to2.config = callProp(config2, t.item, i, phase);
    }
    delay += trail;
    const payload = {
      ...defaultProps,
      // we need to add our props.delay value you here.
      delay: propsDelay + delay,
      ref: propsRef,
      immediate: p.immediate,
      // This prevents implied resets.
      reset: false,
      // Merge any phase-specific props.
      ...to2
    };
    if (phase == "enter" /* ENTER */ && is.und(payload.from)) {
      const p2 = propsFn ? propsFn() : props;
      const from = is.und(p2.initial) || prevTransitions ? p2.from : p2.initial;
      payload.from = callProp(from, t.item, i);
    }
    const { onResolve } = payload;
    payload.onResolve = (result) => {
      callProp(onResolve, result);
      const transitions2 = usedTransitions.current;
      const t2 = transitions2.find((t3) => t3.key === key);
      if (!t2)
        return;
      if (result.cancelled && t2.phase != "update" /* UPDATE */) {
        return;
      }
      if (t2.ctrl.idle) {
        const idle = transitions2.every((t3) => t3.ctrl.idle);
        if (t2.phase == "leave" /* LEAVE */) {
          const expiry = callProp(expires, t2.item);
          if (expiry !== false) {
            const expiryMs = expiry === true ? 0 : expiry;
            t2.expired = true;
            if (!idle && expiryMs > 0) {
              if (expiryMs <= 2147483647)
                t2.expirationId = setTimeout(forceUpdate, expiryMs);
              return;
            }
          }
        }
        if (idle && transitions2.some((t3) => t3.expired)) {
          exitingTransitions.current.delete(t2);
          if (exitBeforeEnter) {
            forceChange.current = true;
          }
          forceUpdate();
        }
      }
    };
    const springs = getSprings(t.ctrl, payload);
    if (phase === "leave" /* LEAVE */ && exitBeforeEnter) {
      exitingTransitions.current.set(t, { phase, springs, payload });
    } else {
      changes.set(t, { phase, springs, payload });
    }
  });
  const context = useContext(SpringContext);
  const prevContext = usePrev(context);
  const hasContext = context !== prevContext && hasProps(context);
  useIsomorphicLayoutEffect$1(() => {
    if (hasContext) {
      each(transitions, (t) => {
        t.ctrl.start({ default: context });
      });
    }
  }, [context]);
  each(changes, (_, t) => {
    if (exitingTransitions.current.size) {
      const ind = transitions.findIndex((state) => state.key === t.key);
      transitions.splice(ind, 1);
    }
  });
  useIsomorphicLayoutEffect$1(
    () => {
      each(
        exitingTransitions.current.size ? exitingTransitions.current : changes,
        ({ phase, payload }, t) => {
          const { ctrl } = t;
          t.phase = phase;
          ref?.add(ctrl);
          if (hasContext && phase == "enter" /* ENTER */) {
            ctrl.start({ default: context });
          }
          if (payload) {
            replaceRef(ctrl, payload.ref);
            if ((ctrl.ref || ref) && !forceChange.current) {
              ctrl.update(payload);
            } else {
              ctrl.start(payload);
              if (forceChange.current) {
                forceChange.current = false;
              }
            }
          }
        }
      );
    },
    reset ? void 0 : deps
  );
  const renderTransitions = (render) => /* @__PURE__ */ React.createElement(React.Fragment, null, transitions.map((t, i) => {
    const { springs } = changes.get(t) || t.ctrl;
    const elem = render({ ...springs }, t.item, t, i);
    return elem && elem.type ? /* @__PURE__ */ React.createElement(
      elem.type,
      {
        ...elem.props,
        key: is.str(t.key) || is.num(t.key) ? t.key : t.ctrl.id,
        ref: elem.ref
      }
    ) : elem;
  }));
  return ref ? [renderTransitions, ref] : renderTransitions;
}
var nextKey = 1;
function getKeys(items, { key, keys = key }, prevTransitions) {
  if (keys === null) {
    const reused = /* @__PURE__ */ new Set();
    return items.map((item) => {
      const t = prevTransitions && prevTransitions.find(
        (t2) => t2.item === item && t2.phase !== "leave" /* LEAVE */ && !reused.has(t2)
      );
      if (t) {
        reused.add(t);
        return t.key;
      }
      return nextKey++;
    });
  }
  return is.und(keys) ? items : is.fun(keys) ? items.map(keys) : toArray(keys);
}
var Interpolation = class extends FrameValue {
  constructor(source, args) {
    super();
    this.source = source;
    /** Equals false when in the frameloop */
    this.idle = true;
    /** The inputs which are currently animating */
    this._active = /* @__PURE__ */ new Set();
    this.calc = createInterpolator(...args);
    const value = this._get();
    const nodeType = getAnimatedType(value);
    setAnimated(this, nodeType.create(value));
  }
  advance(_dt) {
    const value = this._get();
    const oldValue = this.get();
    if (!isEqual$1(value, oldValue)) {
      getAnimated(this).setValue(value);
      this._onChange(value, this.idle);
    }
    if (!this.idle && checkIdle(this._active)) {
      becomeIdle(this);
    }
  }
  _get() {
    const inputs = is.arr(this.source) ? this.source.map(getFluidValue) : toArray(getFluidValue(this.source));
    return this.calc(...inputs);
  }
  _start() {
    if (this.idle && !checkIdle(this._active)) {
      this.idle = false;
      each(getPayload(this), (node) => {
        node.done = false;
      });
      if (globals_exports.skipAnimation) {
        raf.batchedUpdates(() => this.advance());
        becomeIdle(this);
      } else {
        frameLoop.start(this);
      }
    }
  }
  // Observe our sources only when we're observed.
  _attach() {
    let priority = 1;
    each(toArray(this.source), (source) => {
      if (hasFluidValue(source)) {
        addFluidObserver(source, this);
      }
      if (isFrameValue(source)) {
        if (!source.idle) {
          this._active.add(source);
        }
        priority = Math.max(priority, source.priority + 1);
      }
    });
    this.priority = priority;
    this._start();
  }
  // Stop observing our sources once we have no observers.
  _detach() {
    each(toArray(this.source), (source) => {
      if (hasFluidValue(source)) {
        removeFluidObserver(source, this);
      }
    });
    this._active.clear();
    becomeIdle(this);
  }
  /** @internal */
  eventObserved(event) {
    if (event.type == "change") {
      if (event.idle) {
        this.advance();
      } else {
        this._active.add(event.parent);
        this._start();
      }
    } else if (event.type == "idle") {
      this._active.delete(event.parent);
    } else if (event.type == "priority") {
      this.priority = toArray(this.source).reduce(
        (highest, parent) => Math.max(highest, (isFrameValue(parent) ? parent.priority : 0) + 1),
        0
      );
    }
  }
};
function isIdle(source) {
  return source.idle !== false;
}
function checkIdle(active) {
  return !active.size || Array.from(active).every(isIdle);
}
function becomeIdle(self) {
  if (!self.idle) {
    self.idle = true;
    each(getPayload(self), (node) => {
      node.done = true;
    });
    callFluidObservers(self, {
      type: "idle",
      parent: self
    });
  }
}

// src/interpolate.ts
var to = (source, ...args) => new Interpolation(source, args);
globals_exports.assign({
  createStringInterpolator: createStringInterpolator2,
  to: (source, args) => new Interpolation(source, args)
});

// src/index.ts

// src/applyAnimatedValues.ts
var isCustomPropRE = /^--/;
function dangerousStyleValue(name, value) {
  if (value == null || typeof value === "boolean" || value === "")
    return "";
  if (typeof value === "number" && value !== 0 && !isCustomPropRE.test(name) && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]))
    return value + "px";
  return ("" + value).trim();
}
var attributeCache = {};
function applyAnimatedValues(instance, props) {
  if (!instance.nodeType || !instance.setAttribute) {
    return false;
  }
  const isFilterElement = instance.nodeName === "filter" || instance.parentNode && instance.parentNode.nodeName === "filter";
  const { style, children, scrollTop, scrollLeft, viewBox, ...attributes } = props;
  const values = Object.values(attributes);
  const names = Object.keys(attributes).map(
    (name) => isFilterElement || instance.hasAttribute(name) ? name : attributeCache[name] || (attributeCache[name] = name.replace(
      /([A-Z])/g,
      // Attributes are written in dash case
      (n) => "-" + n.toLowerCase()
    ))
  );
  if (children !== void 0) {
    instance.textContent = children;
  }
  for (const name in style) {
    if (style.hasOwnProperty(name)) {
      const value = dangerousStyleValue(name, style[name]);
      if (isCustomPropRE.test(name)) {
        instance.style.setProperty(name, value);
      } else {
        instance.style[name] = value;
      }
    }
  }
  names.forEach((name, i) => {
    instance.setAttribute(name, values[i]);
  });
  if (scrollTop !== void 0) {
    instance.scrollTop = scrollTop;
  }
  if (scrollLeft !== void 0) {
    instance.scrollLeft = scrollLeft;
  }
  if (viewBox !== void 0) {
    instance.setAttribute("viewBox", viewBox);
  }
}
var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,
  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};
var prefixKey = (prefix, key) => prefix + key.charAt(0).toUpperCase() + key.substring(1);
var prefixes$2 = ["Webkit", "Ms", "Moz", "O"];
isUnitlessNumber = Object.keys(isUnitlessNumber).reduce((acc, prop) => {
  prefixes$2.forEach((prefix) => acc[prefixKey(prefix, prop)] = acc[prop]);
  return acc;
}, isUnitlessNumber);
var domTransforms = /^(matrix|translate|scale|rotate|skew)/;
var pxTransforms = /^(translate)/;
var degTransforms = /^(rotate|skew)/;
var addUnit = (value, unit) => is.num(value) && value !== 0 ? value + unit : value;
var isValueIdentity = (value, id) => is.arr(value) ? value.every((v) => isValueIdentity(v, id)) : is.num(value) ? value === id : parseFloat(value) === id;
var AnimatedStyle = class extends AnimatedObject {
  constructor({ x, y, z, ...style }) {
    const inputs = [];
    const transforms = [];
    if (x || y || z) {
      inputs.push([x || 0, y || 0, z || 0]);
      transforms.push((xyz) => [
        `translate3d(${xyz.map((v) => addUnit(v, "px")).join(",")})`,
        // prettier-ignore
        isValueIdentity(xyz, 0)
      ]);
    }
    eachProp(style, (value, key) => {
      if (key === "transform") {
        inputs.push([value || ""]);
        transforms.push((transform) => [transform, transform === ""]);
      } else if (domTransforms.test(key)) {
        delete style[key];
        if (is.und(value))
          return;
        const unit = pxTransforms.test(key) ? "px" : degTransforms.test(key) ? "deg" : "";
        inputs.push(toArray(value));
        transforms.push(
          key === "rotate3d" ? ([x2, y2, z2, deg]) => [
            `rotate3d(${x2},${y2},${z2},${addUnit(deg, unit)})`,
            isValueIdentity(deg, 0)
          ] : (input) => [
            `${key}(${input.map((v) => addUnit(v, unit)).join(",")})`,
            isValueIdentity(input, key.startsWith("scale") ? 1 : 0)
          ]
        );
      }
    });
    if (inputs.length) {
      style.transform = new FluidTransform(inputs, transforms);
    }
    super(style);
  }
};
var FluidTransform = class extends FluidValue {
  constructor(inputs, transforms) {
    super();
    this.inputs = inputs;
    this.transforms = transforms;
    this._value = null;
  }
  get() {
    return this._value || (this._value = this._get());
  }
  _get() {
    let transform = "";
    let identity = true;
    each(this.inputs, (input, i) => {
      const arg1 = getFluidValue(input[0]);
      const [t, id] = this.transforms[i](
        is.arr(arg1) ? arg1 : input.map(getFluidValue)
      );
      transform += " " + t;
      identity = identity && id;
    });
    return identity ? "none" : transform;
  }
  // Start observing our inputs once we have an observer.
  observerAdded(count) {
    if (count == 1)
      each(
        this.inputs,
        (input) => each(
          input,
          (value) => hasFluidValue(value) && addFluidObserver(value, this)
        )
      );
  }
  // Stop observing our inputs once we have no observers.
  observerRemoved(count) {
    if (count == 0)
      each(
        this.inputs,
        (input) => each(
          input,
          (value) => hasFluidValue(value) && removeFluidObserver(value, this)
        )
      );
  }
  eventObserved(event) {
    if (event.type == "change") {
      this._value = null;
    }
    callFluidObservers(this, event);
  }
};

// src/primitives.ts
var primitives = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
];
globals_exports.assign({
  batchedUpdates: unstable_batchedUpdates,
  createStringInterpolator: createStringInterpolator2,
  colors: colors2
});
var host = createHost(primitives, {
  applyAnimatedValues,
  createAnimatedStyle: (style) => new AnimatedStyle(style),
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getComponentProps: ({ scrollTop, scrollLeft, ...props }) => props
});
var animated = host.animated;

function v$4() {
  return v$4 = Object.assign ? Object.assign.bind() : function (t) {
    for (var i = 1; i < arguments.length; i++) {
      var o = arguments[i];
      for (var n in o) Object.prototype.hasOwnProperty.call(o, n) && (t[n] = o[n]);
    }
    return t;
  }, v$4.apply(this, arguments);
}
var x$5 = {
    pointerEvents: "none",
    position: "absolute",
    zIndex: 10,
    top: 0,
    left: 0
  },
  m$2 = function m(t, i) {
    return "translate(" + t + "px, " + i + "px)";
  },
  b$7 = /*#__PURE__*/memo(function (t) {
    var o,
      n = t.position,
      r = t.anchor,
      e = t.children,
      l = Et(),
      u = Zr(),
      p = u.animate,
      f = u.config,
      b = Gt(),
      g = b[0],
      w = b[1],
      T = useRef(!1),
      C = void 0,
      E = !1,
      P = w.width > 0 && w.height > 0,
      j = Math.round(n[0]),
      N = Math.round(n[1]);
    P && ("top" === r ? (j -= w.width / 2, N -= w.height + 14) : "right" === r ? (j += 14, N -= w.height / 2) : "bottom" === r ? (j -= w.width / 2, N += 14) : "left" === r ? (j -= w.width + 14, N -= w.height / 2) : "center" === r && (j -= w.width / 2, N -= w.height / 2), C = {
      transform: m$2(j, N)
    }, T.current || (E = !0), T.current = [j, N]);
    var O = useSpring({
        to: C,
        config: f,
        immediate: !p || E
      }),
      V = v$4({}, x$5, l.tooltip, {
        transform: null != (o = O.transform) ? o : m$2(j, N)
      });
    return jsx(animated.div, {
      ref: g,
      style: V,
      children: e
    });
  });
b$7.displayName = "TooltipWrapper";
var g$2 = /*#__PURE__*/memo(function (t) {
    var i = t.size,
      o = void 0 === i ? 12 : i,
      n = t.color,
      r = t.style;
    return jsx("span", {
      style: v$4({
        display: "block",
        width: o,
        height: o,
        background: n
      }, void 0 === r ? {} : r)
    });
  }),
  w$3 = /*#__PURE__*/memo(function (t) {
    var i,
      o = t.id,
      n = t.value,
      r = t.format,
      e = t.enableChip,
      l = void 0 !== e && e,
      a = t.color,
      c = t.renderContent,
      h = Et(),
      d = Dt(r);
    if ("function" == typeof c) i = c();else {
      var f = n;
      void 0 !== d && void 0 !== f && (f = d(f)), i = jsxs("div", {
        style: h.tooltip.basic,
        children: [l && jsx(g$2, {
          color: a,
          style: h.tooltip.chip
        }), void 0 !== f ? jsxs("span", {
          children: [o, ": ", jsx("strong", {
            children: "" + f
          })]
        }) : o]
      });
    }
    return jsx("div", {
      style: h.tooltip.container,
      children: i
    });
  }),
  T$5 = {
    width: "100%",
    borderCollapse: "collapse"
  },
  C$5 = /*#__PURE__*/memo(function (t) {
    var i,
      o = t.title,
      n = t.rows,
      r = void 0 === n ? [] : n,
      e = t.renderContent,
      l = Et();
    return r.length ? (i = "function" == typeof e ? e() : jsxs("div", {
      children: [o && o, jsx("table", {
        style: v$4({}, T$5, l.tooltip.table),
        children: jsx("tbody", {
          children: r.map(function (t, i) {
            return jsx("tr", {
              children: t.map(function (t, i) {
                return jsx("td", {
                  style: l.tooltip.tableCell,
                  children: t
                }, i);
              })
            }, i);
          })
        })
      })]
    }), jsx("div", {
      style: l.tooltip.container,
      children: i
    })) : null;
  });
C$5.displayName = "TableTooltip";
var E$3 = /*#__PURE__*/memo(function (t) {
  var i = t.x0,
    n = t.x1,
    r = t.y0,
    e = t.y1,
    l = Et(),
    d = Zr(),
    u = d.animate,
    p = d.config,
    f = useMemo(function () {
      return v$4({}, l.crosshair.line, {
        pointerEvents: "none"
      });
    }, [l.crosshair.line]),
    x = useSpring({
      x1: i,
      x2: n,
      y1: r,
      y2: e,
      config: p,
      immediate: !u
    });
  return jsx(animated.line, v$4({}, x, {
    fill: "none",
    style: f
  }));
});
E$3.displayName = "CrosshairLine";
var P$5 = /*#__PURE__*/memo(function (t) {
  var i,
    o,
    n = t.width,
    r = t.height,
    e = t.type,
    l = t.x,
    a = t.y;
  return "cross" === e ? (i = {
    x0: l,
    x1: l,
    y0: 0,
    y1: r
  }, o = {
    x0: 0,
    x1: n,
    y0: a,
    y1: a
  }) : "top-left" === e ? (i = {
    x0: l,
    x1: l,
    y0: 0,
    y1: a
  }, o = {
    x0: 0,
    x1: l,
    y0: a,
    y1: a
  }) : "top" === e ? i = {
    x0: l,
    x1: l,
    y0: 0,
    y1: a
  } : "top-right" === e ? (i = {
    x0: l,
    x1: l,
    y0: 0,
    y1: a
  }, o = {
    x0: l,
    x1: n,
    y0: a,
    y1: a
  }) : "right" === e ? o = {
    x0: l,
    x1: n,
    y0: a,
    y1: a
  } : "bottom-right" === e ? (i = {
    x0: l,
    x1: l,
    y0: a,
    y1: r
  }, o = {
    x0: l,
    x1: n,
    y0: a,
    y1: a
  }) : "bottom" === e ? i = {
    x0: l,
    x1: l,
    y0: a,
    y1: r
  } : "bottom-left" === e ? (i = {
    x0: l,
    x1: l,
    y0: a,
    y1: r
  }, o = {
    x0: 0,
    x1: l,
    y0: a,
    y1: a
  }) : "left" === e ? o = {
    x0: 0,
    x1: l,
    y0: a,
    y1: a
  } : "x" === e ? i = {
    x0: l,
    x1: l,
    y0: 0,
    y1: r
  } : "y" === e && (o = {
    x0: 0,
    x1: n,
    y0: a,
    y1: a
  }), jsxs(Fragment$1, {
    children: [i && jsx(E$3, {
      x0: i.x0,
      x1: i.x1,
      y0: i.y0,
      y1: i.y1
    }), o && jsx(E$3, {
      x0: o.x0,
      x1: o.x1,
      y0: o.y0,
      y1: o.y1
    })]
  });
});
P$5.displayName = "Crosshair";
var j$5 = /*#__PURE__*/createContext({
    showTooltipAt: function showTooltipAt() {},
    showTooltipFromEvent: function showTooltipFromEvent() {},
    hideTooltip: function hideTooltip() {}
  }),
  N$5 = {
    isVisible: !1,
    position: [null, null],
    content: null,
    anchor: null
  },
  O$3 = /*#__PURE__*/createContext(N$5),
  V$1 = function V(t) {
    var i = useState(N$5),
      n = i[0],
      l = i[1],
      a = useCallback(function (t, i, o) {
        var n = i[0],
          r = i[1];
        void 0 === o && (o = "top"), l({
          isVisible: !0,
          position: [n, r],
          anchor: o,
          content: t
        });
      }, [l]),
      c = useCallback(function (i, o, n) {
        void 0 === n && (n = "top");
        var r = t.current.getBoundingClientRect(),
          e = t.current.offsetWidth,
          a = e === r.width ? 1 : e / r.width,
          c = (o.clientX - r.left) * a,
          s = (o.clientY - r.top) * a;
        "left" !== n && "right" !== n || (n = c < r.width / 2 ? "right" : "left"), l({
          isVisible: !0,
          position: [c, s],
          anchor: n,
          content: i
        });
      }, [t, l]),
      s = useCallback(function () {
        l(N$5);
      }, [l]);
    return {
      actions: useMemo(function () {
        return {
          showTooltipAt: a,
          showTooltipFromEvent: c,
          hideTooltip: s
        };
      }, [a, c, s]),
      state: n
    };
  },
  k$5 = function k() {
    var t = useContext(j$5);
    if (void 0 === t) throw new Error("useTooltip must be used within a TooltipProvider");
    return t;
  },
  z$3 = function z() {
    var t = useContext(O$3);
    if (void 0 === t) throw new Error("useTooltipState must be used within a TooltipProvider");
    return t;
  },
  A$4 = function A(t) {
    return t.isVisible;
  },
  F$1 = function F() {
    var t = z$3();
    return A$4(t) ? jsx(b$7, {
      position: t.position,
      anchor: t.anchor,
      children: t.content
    }) : null;
  },
  M$2 = function M(t) {
    var i = t.container,
      o = t.children,
      n = V$1(i),
      r = n.actions,
      e = n.state;
    return jsx(j$5.Provider, {
      value: r,
      children: jsx(O$3.Provider, {
        value: e,
        children: o
      })
    });
  };

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs$1 (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear$1() {
  this.__data__ = [];
  this.size = 0;
}
var _listCacheClear = listCacheClear$1;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq$5(value, other) {
  return value === other || value !== value && other !== other;
}
var eq_1 = eq$5;

var eq$4 = eq_1;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf$4(array, key) {
  var length = array.length;
  while (length--) {
    if (eq$4(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}
var _assocIndexOf = assocIndexOf$4;

var assocIndexOf$3 = _assocIndexOf;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete$1(key) {
  var data = this.__data__,
    index = assocIndexOf$3(data, key);
  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}
var _listCacheDelete = listCacheDelete$1;

var assocIndexOf$2 = _assocIndexOf;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet$1(key) {
  var data = this.__data__,
    index = assocIndexOf$2(data, key);
  return index < 0 ? undefined : data[index][1];
}
var _listCacheGet = listCacheGet$1;

var assocIndexOf$1 = _assocIndexOf;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas$1(key) {
  return assocIndexOf$1(this.__data__, key) > -1;
}
var _listCacheHas = listCacheHas$1;

var assocIndexOf = _assocIndexOf;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet$1(key, value) {
  var data = this.__data__,
    index = assocIndexOf(data, key);
  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}
var _listCacheSet = listCacheSet$1;

var listCacheClear = _listCacheClear,
  listCacheDelete = _listCacheDelete,
  listCacheGet = _listCacheGet,
  listCacheHas = _listCacheHas,
  listCacheSet = _listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache$4(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache$4.prototype.clear = listCacheClear;
ListCache$4.prototype['delete'] = listCacheDelete;
ListCache$4.prototype.get = listCacheGet;
ListCache$4.prototype.has = listCacheHas;
ListCache$4.prototype.set = listCacheSet;
var _ListCache = ListCache$4;

var ListCache$3 = _ListCache;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear$1() {
  this.__data__ = new ListCache$3();
  this.size = 0;
}
var _stackClear = stackClear$1;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete$1(key) {
  var data = this.__data__,
    result = data['delete'](key);
  this.size = data.size;
  return result;
}
var _stackDelete = stackDelete$1;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet$1(key) {
  return this.__data__.get(key);
}
var _stackGet = stackGet$1;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas$1(key) {
  return this.__data__.has(key);
}
var _stackHas = stackHas$1;

var freeGlobal$1 = _typeof$1(commonjsGlobal) == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal$1;

var freeGlobal = _freeGlobal;

/** Detect free variable `self`. */
var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof$1(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$8 = freeGlobal || freeSelf || Function('return this')();
var _root = root$8;

var root$7 = _root;

/** Built-in value references. */
var _Symbol2 = root$7.Symbol;
var _Symbol$5 = _Symbol2;

var _Symbol$4 = _Symbol$5;

/** Used for built-in method references. */
var objectProto$e = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$b = objectProto$e.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$e.toString;

/** Built-in value references. */
var symToStringTag$1 = _Symbol$4 ? _Symbol$4.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$b.call(value, symToStringTag$1),
    tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}
  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}
var _getRawTag = getRawTag$1;

/** Used for built-in method references. */
var objectProto$d = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$d.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString$1(value) {
  return nativeObjectToString.call(value);
}
var _objectToString = objectToString$1;

var _Symbol$3 = _Symbol$5,
  getRawTag = _getRawTag,
  objectToString = _objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
  undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = _Symbol$3 ? _Symbol$3.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag$8(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
var _baseGetTag = baseGetTag$8;

function isObject$9(value) {
  var type = _typeof$1(value);
  return value != null && (type == 'object' || type == 'function');
}
var isObject_1 = isObject$9;

var baseGetTag$7 = _baseGetTag,
  isObject$8 = isObject_1;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
  funcTag$1 = '[object Function]',
  genTag = '[object GeneratorFunction]',
  proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$3(value) {
  if (!isObject$8(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag$7(value);
  return tag == funcTag$1 || tag == genTag || tag == asyncTag || tag == proxyTag;
}
var isFunction_1 = isFunction$3;
var Qe$1 = /*@__PURE__*/getDefaultExportFromCjs$1(isFunction_1);

var root$6 = _root;

/** Used to detect overreaching core-js shims. */
var coreJsData$1 = root$6['__core-js_shared__'];
var _coreJsData = coreJsData$1;

var coreJsData = _coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked$1(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var _isMasked = isMasked$1;

/** Used for built-in method references. */
var funcProto$2 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$2 = funcProto$2.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource$2(func) {
  if (func != null) {
    try {
      return funcToString$2.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}
var _toSource = toSource$2;

var isFunction$2 = isFunction_1,
  isMasked = _isMasked,
  isObject$7 = isObject_1,
  toSource$1 = _toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype,
  objectProto$c = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$a = objectProto$c.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + funcToString$1.call(hasOwnProperty$a).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative$1(value) {
  if (!isObject$7(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction$2(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource$1(value));
}
var _baseIsNative = baseIsNative$1;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue$1(object, key) {
  return object == null ? undefined : object[key];
}
var _getValue = getValue$1;

var baseIsNative = _baseIsNative,
  getValue = _getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative$7(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}
var _getNative = getNative$7;

var getNative$6 = _getNative,
  root$5 = _root;

/* Built-in method references that are verified to be native. */
var Map$4 = getNative$6(root$5, 'Map');
var _Map = Map$4;

var getNative$5 = _getNative;

/* Built-in method references that are verified to be native. */
var nativeCreate$4 = getNative$5(Object, 'create');
var _nativeCreate = nativeCreate$4;

var nativeCreate$3 = _nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {};
  this.size = 0;
}
var _hashClear = hashClear$1;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete$1(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}
var _hashDelete = hashDelete$1;

var nativeCreate$2 = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$b = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$b.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet$1(key) {
  var data = this.__data__;
  if (nativeCreate$2) {
    var result = data[key];
    return result === HASH_UNDEFINED$2 ? undefined : result;
  }
  return hasOwnProperty$9.call(data, key) ? data[key] : undefined;
}
var _hashGet = hashGet$1;

var nativeCreate$1 = _nativeCreate;

/** Used for built-in method references. */
var objectProto$a = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$a.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas$1(key) {
  var data = this.__data__;
  return nativeCreate$1 ? data[key] !== undefined : hasOwnProperty$8.call(data, key);
}
var _hashHas = hashHas$1;

var nativeCreate = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet$1(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED$1 : value;
  return this;
}
var _hashSet = hashSet$1;

var hashClear = _hashClear,
  hashDelete = _hashDelete,
  hashGet = _hashGet,
  hashHas = _hashHas,
  hashSet = _hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash$1(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash$1.prototype.clear = hashClear;
Hash$1.prototype['delete'] = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;
var _Hash = Hash$1;

var Hash = _Hash,
  ListCache$2 = _ListCache,
  Map$3 = _Map;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear$1() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map$3 || ListCache$2)(),
    'string': new Hash()
  };
}
var _mapCacheClear = mapCacheClear$1;

function isKeyable$1(value) {
  var type = _typeof$1(value);
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var _isKeyable = isKeyable$1;

var isKeyable = _isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData$4(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var _getMapData = getMapData$4;

var getMapData$3 = _getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete$1(key) {
  var result = getMapData$3(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}
var _mapCacheDelete = mapCacheDelete$1;

var getMapData$2 = _getMapData;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet$1(key) {
  return getMapData$2(this, key).get(key);
}
var _mapCacheGet = mapCacheGet$1;

var getMapData$1 = _getMapData;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas$1(key) {
  return getMapData$1(this, key).has(key);
}
var _mapCacheHas = mapCacheHas$1;

var getMapData = _getMapData;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet$1(key, value) {
  var data = getMapData(this, key),
    size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}
var _mapCacheSet = mapCacheSet$1;

var mapCacheClear = _mapCacheClear,
  mapCacheDelete = _mapCacheDelete,
  mapCacheGet = _mapCacheGet,
  mapCacheHas = _mapCacheHas,
  mapCacheSet = _mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache$3(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache$3.prototype.clear = mapCacheClear;
MapCache$3.prototype['delete'] = mapCacheDelete;
MapCache$3.prototype.get = mapCacheGet;
MapCache$3.prototype.has = mapCacheHas;
MapCache$3.prototype.set = mapCacheSet;
var _MapCache = MapCache$3;

var ListCache$1 = _ListCache,
  Map$2 = _Map,
  MapCache$2 = _MapCache;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE$2 = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet$1(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache$1) {
    var pairs = data.__data__;
    if (!Map$2 || pairs.length < LARGE_ARRAY_SIZE$2 - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache$2(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}
var _stackSet = stackSet$1;

var ListCache = _ListCache,
  stackClear = _stackClear,
  stackDelete = _stackDelete,
  stackGet = _stackGet,
  stackHas = _stackHas,
  stackSet = _stackSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack$3(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack$3.prototype.clear = stackClear;
Stack$3.prototype['delete'] = stackDelete;
Stack$3.prototype.get = stackGet;
Stack$3.prototype.has = stackHas;
Stack$3.prototype.set = stackSet;
var _Stack = Stack$3;

var getNative$4 = _getNative;
var defineProperty$2 = function () {
  try {
    var func = getNative$4(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}();
var _defineProperty = defineProperty$2;

var defineProperty$1 = _defineProperty;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue$3(object, key, value) {
  if (key == '__proto__' && defineProperty$1) {
    defineProperty$1(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}
var _baseAssignValue = baseAssignValue$3;

var baseAssignValue$2 = _baseAssignValue,
  eq$3 = eq_1;

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue$2(object, key, value) {
  if (value !== undefined && !eq$3(object[key], value) || value === undefined && !(key in object)) {
    baseAssignValue$2(object, key, value);
  }
}
var _assignMergeValue = assignMergeValue$2;

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor$1(fromRight) {
  return function (object, iteratee, keysFunc) {
    var index = -1,
      iterable = Object(object),
      props = keysFunc(object),
      length = props.length;
    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}
var _createBaseFor = createBaseFor$1;

var createBaseFor = _createBaseFor;

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor$2 = createBaseFor();
var _baseFor = baseFor$2;

var _cloneBuffer = {exports: {}};

_cloneBuffer.exports;
(function (module, exports) {
  var root = _root;

  /** Detect free variable `exports`. */
  var freeExports = exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Built-in value references. */
  var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

  /**
   * Creates a clone of  `buffer`.
   *
   * @private
   * @param {Buffer} buffer The buffer to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Buffer} Returns the cloned buffer.
   */
  function cloneBuffer(buffer, isDeep) {
    if (isDeep) {
      return buffer.slice();
    }
    var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
  }
  module.exports = cloneBuffer;
})(_cloneBuffer, _cloneBuffer.exports);
var _cloneBufferExports = _cloneBuffer.exports;

var root$4 = _root;

/** Built-in value references. */
var Uint8Array$2 = root$4.Uint8Array;
var _Uint8Array = Uint8Array$2;

var Uint8Array$1 = _Uint8Array;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer$1(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$1(result).set(new Uint8Array$1(arrayBuffer));
  return result;
}
var _cloneArrayBuffer = cloneArrayBuffer$1;

var cloneArrayBuffer = _cloneArrayBuffer;

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray$1(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var _cloneTypedArray = cloneTypedArray$1;

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray$1(source, array) {
  var index = -1,
    length = source.length;
  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}
var _copyArray = copyArray$1;

var isObject$6 = isObject_1;

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate$1 = function () {
  function object() {}
  return function (proto) {
    if (!isObject$6(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object();
    object.prototype = undefined;
    return result;
  };
}();
var _baseCreate = baseCreate$1;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg$2(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}
var _overArg = overArg$2;

var overArg$1 = _overArg;

/** Built-in value references. */
var getPrototype$2 = overArg$1(Object.getPrototypeOf, Object);
var _getPrototype = getPrototype$2;

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype$3(value) {
  var Ctor = value && value.constructor,
    proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$9;
  return value === proto;
}
var _isPrototype = isPrototype$3;

var baseCreate = _baseCreate,
  getPrototype$1 = _getPrototype,
  isPrototype$2 = _isPrototype;

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject$1(object) {
  return typeof object.constructor == 'function' && !isPrototype$2(object) ? baseCreate(getPrototype$1(object)) : {};
}
var _initCloneObject = initCloneObject$1;

function isObjectLike$9(value) {
  return value != null && _typeof$1(value) == 'object';
}
var isObjectLike_1 = isObjectLike$9;

var baseGetTag$6 = _baseGetTag,
  isObjectLike$8 = isObjectLike_1;

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments$1(value) {
  return isObjectLike$8(value) && baseGetTag$6(value) == argsTag$2;
}
var _baseIsArguments = baseIsArguments$1;

var baseIsArguments = _baseIsArguments,
  isObjectLike$7 = isObjectLike_1;

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$8.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$8.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments$4 = baseIsArguments(function () {
  return arguments;
}()) ? baseIsArguments : function (value) {
  return isObjectLike$7(value) && hasOwnProperty$7.call(value, 'callee') && !propertyIsEnumerable$1.call(value, 'callee');
};
var isArguments_1 = isArguments$4;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray$c = Array.isArray;
var isArray_1 = isArray$c;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength$3(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
}
var isLength_1 = isLength$3;

var isFunction$1 = isFunction_1,
  isLength$2 = isLength_1;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike$6(value) {
  return value != null && isLength$2(value.length) && !isFunction$1(value);
}
var isArrayLike_1 = isArrayLike$6;

var isArrayLike$5 = isArrayLike_1,
  isObjectLike$6 = isObjectLike_1;

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject$2(value) {
  return isObjectLike$6(value) && isArrayLike$5(value);
}
var isArrayLikeObject_1 = isArrayLikeObject$2;

var isBuffer$3 = {exports: {}};

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}
var stubFalse_1 = stubFalse;

isBuffer$3.exports;
(function (module, exports) {
  var root = _root,
    stubFalse = stubFalse_1;

  /** Detect free variable `exports`. */
  var freeExports = exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Built-in value references. */
  var Buffer = moduleExports ? root.Buffer : undefined;

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

  /**
   * Checks if `value` is a buffer.
   *
   * @static
   * @memberOf _
   * @since 4.3.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
   * @example
   *
   * _.isBuffer(new Buffer(2));
   * // => true
   *
   * _.isBuffer(new Uint8Array(2));
   * // => false
   */
  var isBuffer = nativeIsBuffer || stubFalse;
  module.exports = isBuffer;
})(isBuffer$3, isBuffer$3.exports);
var isBufferExports = isBuffer$3.exports;

var baseGetTag$5 = _baseGetTag,
  getPrototype = _getPrototype,
  isObjectLike$5 = isObjectLike_1;

/** `Object#toString` result references. */
var objectTag$3 = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
  objectProto$7 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$7.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject$1(value) {
  if (!isObjectLike$5(value) || baseGetTag$5(value) != objectTag$3) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$6.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
var isPlainObject_1 = isPlainObject$1;
var Oe$1 = /*@__PURE__*/getDefaultExportFromCjs$1(isPlainObject_1);

var baseGetTag$4 = _baseGetTag,
  isLength$1 = isLength_1,
  isObjectLike$4 = isObjectLike_1;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
  arrayTag$1 = '[object Array]',
  boolTag$1 = '[object Boolean]',
  dateTag$2 = '[object Date]',
  errorTag$1 = '[object Error]',
  funcTag = '[object Function]',
  mapTag$2 = '[object Map]',
  numberTag$1 = '[object Number]',
  objectTag$2 = '[object Object]',
  regexpTag$1 = '[object RegExp]',
  setTag$2 = '[object Set]',
  stringTag$2 = '[object String]',
  weakMapTag$1 = '[object WeakMap]';
var arrayBufferTag$1 = '[object ArrayBuffer]',
  dataViewTag$2 = '[object DataView]',
  float32Tag = '[object Float32Array]',
  float64Tag = '[object Float64Array]',
  int8Tag = '[object Int8Array]',
  int16Tag = '[object Int16Array]',
  int32Tag = '[object Int32Array]',
  uint8Tag = '[object Uint8Array]',
  uint8ClampedTag = '[object Uint8ClampedArray]',
  uint16Tag = '[object Uint16Array]',
  uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] = typedArrayTags[arrayBufferTag$1] = typedArrayTags[boolTag$1] = typedArrayTags[dataViewTag$2] = typedArrayTags[dateTag$2] = typedArrayTags[errorTag$1] = typedArrayTags[funcTag] = typedArrayTags[mapTag$2] = typedArrayTags[numberTag$1] = typedArrayTags[objectTag$2] = typedArrayTags[regexpTag$1] = typedArrayTags[setTag$2] = typedArrayTags[stringTag$2] = typedArrayTags[weakMapTag$1] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray$1(value) {
  return isObjectLike$4(value) && isLength$1(value.length) && !!typedArrayTags[baseGetTag$4(value)];
}
var _baseIsTypedArray = baseIsTypedArray$1;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary$4(func) {
  return function (value) {
    return func(value);
  };
}
var _baseUnary = baseUnary$4;

var _nodeUtil = {exports: {}};

_nodeUtil.exports;
(function (module, exports) {
  var freeGlobal = _freeGlobal;

  /** Detect free variable `exports`. */
  var freeExports = exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = function () {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;
      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }();
  module.exports = nodeUtil;
})(_nodeUtil, _nodeUtil.exports);
var _nodeUtilExports = _nodeUtil.exports;

var baseIsTypedArray = _baseIsTypedArray,
  baseUnary$3 = _baseUnary,
  nodeUtil$1 = _nodeUtilExports;

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil$1 && nodeUtil$1.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray$3 = nodeIsTypedArray ? baseUnary$3(nodeIsTypedArray) : baseIsTypedArray;
var isTypedArray_1 = isTypedArray$3;

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet$2(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }
  if (key == '__proto__') {
    return;
  }
  return object[key];
}
var _safeGet = safeGet$2;

var baseAssignValue$1 = _baseAssignValue,
  eq$2 = eq_1;

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$6.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue$2(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$5.call(object, key) && eq$2(objValue, value)) || value === undefined && !(key in object)) {
    baseAssignValue$1(object, key, value);
  }
}
var _assignValue = assignValue$2;

var assignValue$1 = _assignValue,
  baseAssignValue = _baseAssignValue;

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject$1(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});
  var index = -1,
    length = props.length;
  while (++index < length) {
    var key = props[index];
    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue$1(object, key, newValue);
    }
  }
  return object;
}
var _copyObject = copyObject$1;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes$1(n, iteratee) {
  var index = -1,
    result = Array(n);
  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}
var _baseTimes = baseTimes$1;

var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex$4(value, length) {
  var type = _typeof$1(value);
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var _isIndex = isIndex$4;

var baseTimes = _baseTimes,
  isArguments$3 = isArguments_1,
  isArray$b = isArray_1,
  isBuffer$2 = isBufferExports,
  isIndex$3 = _isIndex,
  isTypedArray$2 = isTypedArray_1;

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$5.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys$2(value, inherited) {
  var isArr = isArray$b(value),
    isArg = !isArr && isArguments$3(value),
    isBuff = !isArr && !isArg && isBuffer$2(value),
    isType = !isArr && !isArg && !isBuff && isTypedArray$2(value),
    skipIndexes = isArr || isArg || isBuff || isType,
    result = skipIndexes ? baseTimes(value.length, String) : [],
    length = result.length;
  for (var key in value) {
    if ((inherited || hasOwnProperty$4.call(value, key)) && !(skipIndexes && (
    // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' ||
    // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') ||
    // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
    // Skip index properties.
    isIndex$3(key, length)))) {
      result.push(key);
    }
  }
  return result;
}
var _arrayLikeKeys = arrayLikeKeys$2;

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn$1(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}
var _nativeKeysIn = nativeKeysIn$1;

var isObject$5 = isObject_1,
  isPrototype$1 = _isPrototype,
  nativeKeysIn = _nativeKeysIn;

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn$1(object) {
  if (!isObject$5(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype$1(object),
    result = [];
  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$3.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}
var _baseKeysIn = baseKeysIn$1;

var arrayLikeKeys$1 = _arrayLikeKeys,
  baseKeysIn = _baseKeysIn,
  isArrayLike$4 = isArrayLike_1;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn$2(object) {
  return isArrayLike$4(object) ? arrayLikeKeys$1(object, true) : baseKeysIn(object);
}
var keysIn_1 = keysIn$2;

var copyObject = _copyObject,
  keysIn$1 = keysIn_1;

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject$1(value) {
  return copyObject(value, keysIn$1(value));
}
var toPlainObject_1 = toPlainObject$1;

var assignMergeValue$1 = _assignMergeValue,
  cloneBuffer = _cloneBufferExports,
  cloneTypedArray = _cloneTypedArray,
  copyArray = _copyArray,
  initCloneObject = _initCloneObject,
  isArguments$2 = isArguments_1,
  isArray$a = isArray_1,
  isArrayLikeObject$1 = isArrayLikeObject_1,
  isBuffer$1 = isBufferExports,
  isFunction = isFunction_1,
  isObject$4 = isObject_1,
  isPlainObject = isPlainObject_1,
  isTypedArray$1 = isTypedArray_1,
  safeGet$1 = _safeGet,
  toPlainObject = toPlainObject_1;

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep$1(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet$1(object, key),
    srcValue = safeGet$1(source, key),
    stacked = stack.get(srcValue);
  if (stacked) {
    assignMergeValue$1(object, key, stacked);
    return;
  }
  var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
  var isCommon = newValue === undefined;
  if (isCommon) {
    var isArr = isArray$a(srcValue),
      isBuff = !isArr && isBuffer$1(srcValue),
      isTyped = !isArr && !isBuff && isTypedArray$1(srcValue);
    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray$a(objValue)) {
        newValue = objValue;
      } else if (isArrayLikeObject$1(objValue)) {
        newValue = copyArray(objValue);
      } else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      } else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      } else {
        newValue = [];
      }
    } else if (isPlainObject(srcValue) || isArguments$2(srcValue)) {
      newValue = objValue;
      if (isArguments$2(objValue)) {
        newValue = toPlainObject(objValue);
      } else if (!isObject$4(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    } else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue$1(object, key, newValue);
}
var _baseMergeDeep = baseMergeDeep$1;

var Stack$2 = _Stack,
  assignMergeValue = _assignMergeValue,
  baseFor$1 = _baseFor,
  baseMergeDeep = _baseMergeDeep,
  isObject$3 = isObject_1,
  keysIn = keysIn_1,
  safeGet = _safeGet;

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge$1(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor$1(source, function (srcValue, key) {
    stack || (stack = new Stack$2());
    if (isObject$3(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge$1, customizer, stack);
    } else {
      var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}
var _baseMerge = baseMerge$1;

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity$8(value) {
  return value;
}
var identity_1 = identity$8;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply$1(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}
var _apply = apply$1;

var apply = _apply;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest$2(func, start, transform) {
  start = nativeMax(start === undefined ? func.length - 1 : start, 0);
  return function () {
    var args = arguments,
      index = -1,
      length = nativeMax(args.length - start, 0),
      array = Array(length);
    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}
var _overRest = overRest$2;

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant$4(value) {
  return function () {
    return value;
  };
}
var constant_1 = constant$4;

var constant$3 = constant_1,
  defineProperty = _defineProperty,
  identity$7 = identity_1;

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString$1 = !defineProperty ? identity$7 : function (func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant$3(string),
    'writable': true
  });
};
var _baseSetToString = baseSetToString$1;

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
  HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut$1(func) {
  var count = 0,
    lastCalled = 0;
  return function () {
    var stamp = nativeNow(),
      remaining = HOT_SPAN - (stamp - lastCalled);
    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}
var _shortOut = shortOut$1;

var baseSetToString = _baseSetToString,
  shortOut = _shortOut;

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString$2 = shortOut(baseSetToString);
var _setToString = setToString$2;

var identity$6 = identity_1,
  overRest$1 = _overRest,
  setToString$1 = _setToString;

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest$3(func, start) {
  return setToString$1(overRest$1(func, start, identity$6), func + '');
}
var _baseRest = baseRest$3;

var eq$1 = eq_1,
  isArrayLike$3 = isArrayLike_1,
  isIndex$2 = _isIndex,
  isObject$2 = isObject_1;

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall$2(value, index, object) {
  if (!isObject$2(object)) {
    return false;
  }
  var type = _typeof$1(index);
  if (type == 'number' ? isArrayLike$3(object) && isIndex$2(index, object.length) : type == 'string' && index in object) {
    return eq$1(object[index], value);
  }
  return false;
}
var _isIterateeCall = isIterateeCall$2;

var baseRest$2 = _baseRest,
  isIterateeCall$1 = _isIterateeCall;

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner$1(assigner) {
  return baseRest$2(function (object, sources) {
    var index = -1,
      length = sources.length,
      customizer = length > 1 ? sources[length - 1] : undefined,
      guard = length > 2 ? sources[2] : undefined;
    customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
    if (guard && isIterateeCall$1(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}
var _createAssigner = createAssigner$1;

var baseMerge = _baseMerge,
  createAssigner = _createAssigner;

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function (object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});
var merge_1 = merge;
var m$1 = /*@__PURE__*/getDefaultExportFromCjs$1(merge_1);

var baseGetTag$3 = _baseGetTag,
  isObjectLike$3 = isObjectLike_1;

/** `Object#toString` result references. */
var symbolTag$1 = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$4(value) {
  return _typeof$1(value) == 'symbol' || isObjectLike$3(value) && baseGetTag$3(value) == symbolTag$1;
}
var isSymbol_1 = isSymbol$4;

var isArray$9 = isArray_1,
  isSymbol$3 = isSymbol_1;

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
  reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey$3(value, object) {
  if (isArray$9(value)) {
    return false;
  }
  var type = _typeof$1(value);
  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol$3(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
var _isKey = isKey$3;

var MapCache$1 = _MapCache;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize$1(func, resolver) {
  if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function memoized() {
    var args = arguments,
      key = resolver ? resolver.apply(this, args) : args[0],
      cache = memoized.cache;
    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize$1.Cache || MapCache$1)();
  return memoized;
}

// Expose `MapCache`.
memoize$1.Cache = MapCache$1;
var memoize_1 = memoize$1;

var memoize = memoize_1;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped$1(func) {
  var result = memoize(func, function (key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });
  var cache = result.cache;
  return result;
}
var _memoizeCapped = memoizeCapped$1;

var memoizeCapped = _memoizeCapped;

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath$1 = memoizeCapped(function (string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function (match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
  });
  return result;
});
var _stringToPath = stringToPath$1;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap$3(array, iteratee) {
  var index = -1,
    length = array == null ? 0 : array.length,
    result = Array(length);
  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}
var _arrayMap = arrayMap$3;

var _Symbol$2 = _Symbol$5,
  arrayMap$2 = _arrayMap,
  isArray$8 = isArray_1,
  isSymbol$2 = isSymbol_1;

/** Used as references for various `Number` constants. */
var INFINITY$2 = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = _Symbol$2 ? _Symbol$2.prototype : undefined,
  symbolToString = symbolProto$1 ? symbolProto$1.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString$1(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray$8(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap$2(value, baseToString$1) + '';
  }
  if (isSymbol$2(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$2 ? '-0' : result;
}
var _baseToString = baseToString$1;

var baseToString = _baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$1(value) {
  return value == null ? '' : baseToString(value);
}
var toString_1 = toString$1;

var isArray$7 = isArray_1,
  isKey$2 = _isKey,
  stringToPath = _stringToPath,
  toString = toString_1;

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath$4(value, object) {
  if (isArray$7(value)) {
    return value;
  }
  return isKey$2(value, object) ? [value] : stringToPath(toString(value));
}
var _castPath = castPath$4;

var isSymbol$1 = isSymbol_1;

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey$5(value) {
  if (typeof value == 'string' || isSymbol$1(value)) {
    return value;
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$1 ? '-0' : result;
}
var _toKey = toKey$5;

var castPath$3 = _castPath,
  toKey$4 = _toKey;

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet$4(object, path) {
  path = castPath$3(path, object);
  var index = 0,
    length = path.length;
  while (object != null && index < length) {
    object = object[toKey$4(path[index++])];
  }
  return index && index == length ? object : undefined;
}
var _baseGet = baseGet$4;

var baseGet$3 = _baseGet;

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get$1(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet$3(object, path);
  return result === undefined ? defaultValue : result;
}
var get_1 = get$1;
var we$1 = /*@__PURE__*/getDefaultExportFromCjs$1(get_1);

var assignValue = _assignValue,
  castPath$2 = _castPath,
  isIndex$1 = _isIndex,
  isObject$1 = isObject_1,
  toKey$3 = _toKey;

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet$2(object, path, value, customizer) {
  if (!isObject$1(object)) {
    return object;
  }
  path = castPath$2(path, object);
  var index = -1,
    length = path.length,
    lastIndex = length - 1,
    nested = object;
  while (nested != null && ++index < length) {
    var key = toKey$3(path[index]),
      newValue = value;
    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }
    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject$1(objValue) ? objValue : isIndex$1(path[index + 1]) ? [] : {};
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}
var _baseSet = baseSet$2;

var baseSet$1 = _baseSet;

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet$1(object, path, value);
}
var set_1 = set;
var v$3 = /*@__PURE__*/getDefaultExportFromCjs$1(set_1);

function define$2 (constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
}
function extend$2(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}

function Color$2() {}
var _darker$2 = 0.7;
var _brighter$2 = 1 / _darker$2;
var reI$2 = "\\s*([+-]?\\d+)\\s*",
  reN$2 = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*",
  reP$2 = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
  reHex$2 = /^#([0-9a-f]{3,8})$/,
  reRgbInteger$2 = new RegExp("^rgb\\(".concat(reI$2, ",").concat(reI$2, ",").concat(reI$2, "\\)$")),
  reRgbPercent$2 = new RegExp("^rgb\\(".concat(reP$2, ",").concat(reP$2, ",").concat(reP$2, "\\)$")),
  reRgbaInteger$2 = new RegExp("^rgba\\(".concat(reI$2, ",").concat(reI$2, ",").concat(reI$2, ",").concat(reN$2, "\\)$")),
  reRgbaPercent$2 = new RegExp("^rgba\\(".concat(reP$2, ",").concat(reP$2, ",").concat(reP$2, ",").concat(reN$2, "\\)$")),
  reHslPercent$2 = new RegExp("^hsl\\(".concat(reN$2, ",").concat(reP$2, ",").concat(reP$2, "\\)$")),
  reHslaPercent$2 = new RegExp("^hsla\\(".concat(reN$2, ",").concat(reP$2, ",").concat(reP$2, ",").concat(reN$2, "\\)$"));
var named$2 = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};
define$2(Color$2, color$2, {
  copy: function copy(channels) {
    return Object.assign(new this.constructor(), this, channels);
  },
  displayable: function displayable() {
    return this.rgb().displayable();
  },
  hex: color_formatHex$2,
  // Deprecated! Use color.formatHex.
  formatHex: color_formatHex$2,
  formatHex8: color_formatHex8,
  formatHsl: color_formatHsl$2,
  formatRgb: color_formatRgb$2,
  toString: color_formatRgb$2
});
function color_formatHex$2() {
  return this.rgb().formatHex();
}
function color_formatHex8() {
  return this.rgb().formatHex8();
}
function color_formatHsl$2() {
  return hslConvert$2(this).formatHsl();
}
function color_formatRgb$2() {
  return this.rgb().formatRgb();
}
function color$2(format) {
  var m, l;
  format = (format + "").trim().toLowerCase();
  return (m = reHex$2.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn$2(m) // #ff0000
  : l === 3 ? new Rgb$2(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
  : l === 8 ? rgba$2(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
  : l === 4 ? rgba$2(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
  : null // invalid hex
  ) : (m = reRgbInteger$2.exec(format)) ? new Rgb$2(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
  : (m = reRgbPercent$2.exec(format)) ? new Rgb$2(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
  : (m = reRgbaInteger$2.exec(format)) ? rgba$2(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
  : (m = reRgbaPercent$2.exec(format)) ? rgba$2(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
  : (m = reHslPercent$2.exec(format)) ? hsla$2(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
  : (m = reHslaPercent$2.exec(format)) ? hsla$2(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
  : named$2.hasOwnProperty(format) ? rgbn$2(named$2[format]) // eslint-disable-line no-prototype-builtins
  : format === "transparent" ? new Rgb$2(NaN, NaN, NaN, 0) : null;
}
function rgbn$2(n) {
  return new Rgb$2(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba$2(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb$2(r, g, b, a);
}
function rgbConvert$2(o) {
  if (!(o instanceof Color$2)) o = color$2(o);
  if (!o) return new Rgb$2();
  o = o.rgb();
  return new Rgb$2(o.r, o.g, o.b, o.opacity);
}
function rgb$3(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert$2(r) : new Rgb$2(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb$2(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}
define$2(Rgb$2, rgb$3, extend$2(Color$2, {
  brighter: function brighter(k) {
    k = k == null ? _brighter$2 : Math.pow(_brighter$2, k);
    return new Rgb$2(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function darker(k) {
    k = k == null ? _darker$2 : Math.pow(_darker$2, k);
    return new Rgb$2(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function rgb() {
    return this;
  },
  clamp: function clamp() {
    return new Rgb$2(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
  },
  displayable: function displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: rgb_formatHex$2,
  // Deprecated! Use color.formatHex.
  formatHex: rgb_formatHex$2,
  formatHex8: rgb_formatHex8,
  formatRgb: rgb_formatRgb$2,
  toString: rgb_formatRgb$2
}));
function rgb_formatHex$2() {
  return "#".concat(hex$2(this.r)).concat(hex$2(this.g)).concat(hex$2(this.b));
}
function rgb_formatHex8() {
  return "#".concat(hex$2(this.r)).concat(hex$2(this.g)).concat(hex$2(this.b)).concat(hex$2((isNaN(this.opacity) ? 1 : this.opacity) * 255));
}
function rgb_formatRgb$2() {
  var a = clampa(this.opacity);
  return "".concat(a === 1 ? "rgb(" : "rgba(").concat(clampi(this.r), ", ").concat(clampi(this.g), ", ").concat(clampi(this.b)).concat(a === 1 ? ")" : ", ".concat(a, ")"));
}
function clampa(opacity) {
  return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
  return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex$2(value) {
  value = clampi(value);
  return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla$2(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;else if (l <= 0 || l >= 1) h = s = NaN;else if (s <= 0) h = NaN;
  return new Hsl$2(h, s, l, a);
}
function hslConvert$2(o) {
  if (o instanceof Hsl$2) return new Hsl$2(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color$2)) o = color$2(o);
  if (!o) return new Hsl$2();
  if (o instanceof Hsl$2) return o;
  o = o.rgb();
  var r = o.r / 255,
    g = o.g / 255,
    b = o.b / 255,
    min = Math.min(r, g, b),
    max = Math.max(r, g, b),
    h = NaN,
    s = max - min,
    l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;else if (g === max) h = (b - r) / s + 2;else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl$2(h, s, l, o.opacity);
}
function hsl$2(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert$2(h) : new Hsl$2(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl$2(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}
define$2(Hsl$2, hsl$2, extend$2(Color$2, {
  brighter: function brighter(k) {
    k = k == null ? _brighter$2 : Math.pow(_brighter$2, k);
    return new Hsl$2(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function darker(k) {
    k = k == null ? _darker$2 : Math.pow(_darker$2, k);
    return new Hsl$2(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function rgb() {
    var h = this.h % 360 + (this.h < 0) * 360,
      s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
      l = this.l,
      m2 = l + (l < 0.5 ? l : 1 - l) * s,
      m1 = 2 * l - m2;
    return new Rgb$2(hsl2rgb$2(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb$2(h, m1, m2), hsl2rgb$2(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
  },
  clamp: function clamp() {
    return new Hsl$2(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
  },
  displayable: function displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl: function formatHsl() {
    var a = clampa(this.opacity);
    return "".concat(a === 1 ? "hsl(" : "hsla(").concat(clamph(this.h), ", ").concat(clampt(this.s) * 100, "%, ").concat(clampt(this.l) * 100, "%").concat(a === 1 ? ")" : ", ".concat(a, ")"));
  }
}));
function clamph(value) {
  value = (value || 0) % 360;
  return value < 0 ? value + 360 : value;
}
function clampt(value) {
  return Math.max(0, Math.min(1, value || 0));
}

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb$2(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

function number$3 (a, b) {
  return a = +a, b = +b, function (t) {
    return a * (1 - t) + b * t;
  };
}

var reA$1 = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
  reB$1 = new RegExp(reA$1.source, "g");
function zero$1(b) {
  return function () {
    return b;
  };
}
function one$1(b) {
  return function (t) {
    return b(t) + "";
  };
}
function R (a, b) {
  var bi = reA$1.lastIndex = reB$1.lastIndex = 0,
    // scan index for next number in b
    am,
    // current match in a
    bm,
    // current match in b
    bs,
    // string preceding current number in b, if any
    i = -1,
    // index in s
    s = [],
    // string constants and placeholders
    q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA$1.exec(a)) && (bm = reB$1.exec(b))) {
    if ((bs = bm.index) > bi) {
      // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) {
      // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else {
      // interpolate non-matching numbers
      s[++i] = null;
      q.push({
        i: i,
        x: number$3(am, bm)
      });
    }
    bi = reB$1.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? q[0] ? one$1(q[0].x) : zero$1(b) : (b = q.length, function (t) {
    for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
    return s.join("");
  });
}

var baseGetTag$2 = _baseGetTag,
  isArray$6 = isArray_1,
  isObjectLike$2 = isObjectLike_1;

/** `Object#toString` result references. */
var stringTag$1 = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' || !isArray$6(value) && isObjectLike$2(value) && baseGetTag$2(value) == stringTag$1;
}
var isString_1 = isString;
var x$4 = /*@__PURE__*/getDefaultExportFromCjs$1(isString_1);

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}
var last_1 = last;
var e$1 = /*@__PURE__*/getDefaultExportFromCjs$1(last_1);

function ascending (a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

function bisector (f) {
  var delta = f;
  var compare = f;
  if (f.length === 1) {
    delta = function delta(d, x) {
      return f(d) - x;
    };
    compare = ascendingComparator(f);
  }
  function left(a, x, lo, hi) {
    if (lo == null) lo = 0;
    if (hi == null) hi = a.length;
    while (lo < hi) {
      var mid = lo + hi >>> 1;
      if (compare(a[mid], x) < 0) lo = mid + 1;else hi = mid;
    }
    return lo;
  }
  function right(a, x, lo, hi) {
    if (lo == null) lo = 0;
    if (hi == null) hi = a.length;
    while (lo < hi) {
      var mid = lo + hi >>> 1;
      if (compare(a[mid], x) > 0) hi = mid;else lo = mid + 1;
    }
    return lo;
  }
  function center(a, x, lo, hi) {
    if (lo == null) lo = 0;
    if (hi == null) hi = a.length;
    var i = left(a, x, lo, hi - 1);
    return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
  }
  return {
    left: left,
    center: center,
    right: right
  };
}
function ascendingComparator(f) {
  return function (d, x) {
    return ascending(f(d), x);
  };
}

var regeneratorRuntime$1 = {exports: {}};

var _typeof = {exports: {}};

(function (module) {
  function _typeof(o) {
    "@babel/helpers - typeof";

    return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
      return typeof o;
    } : function (o) {
      return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(o);
  }
  module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(_typeof);
var _typeofExports = _typeof.exports;

(function (module) {
  var _typeof = _typeofExports["default"];
  function _regeneratorRuntime() {

    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
    module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
      return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t,
      e = {},
      r = Object.prototype,
      n = r.hasOwnProperty,
      o = Object.defineProperty || function (t, e, r) {
        t[e] = r.value;
      },
      i = "function" == typeof Symbol ? Symbol : {},
      a = i.iterator || "@@iterator",
      c = i.asyncIterator || "@@asyncIterator",
      u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
      return Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }), t[e];
    }
    try {
      define({}, "");
    } catch (t) {
      define = function define(t, e, r) {
        return t[e] = r;
      };
    }
    function wrap(t, e, r, n) {
      var i = e && e.prototype instanceof Generator ? e : Generator,
        a = Object.create(i.prototype),
        c = new Context(n || []);
      return o(a, "_invoke", {
        value: makeInvokeMethod(t, r, c)
      }), a;
    }
    function tryCatch(t, e, r) {
      try {
        return {
          type: "normal",
          arg: t.call(e, r)
        };
      } catch (t) {
        return {
          type: "throw",
          arg: t
        };
      }
    }
    e.wrap = wrap;
    var h = "suspendedStart",
      l = "suspendedYield",
      f = "executing",
      s = "completed",
      y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function () {
      return this;
    });
    var d = Object.getPrototypeOf,
      v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
      ["next", "throw", "return"].forEach(function (e) {
        define(t, e, function (t) {
          return this._invoke(e, t);
        });
      });
    }
    function AsyncIterator(t, e) {
      function invoke(r, o, i, a) {
        var c = tryCatch(t[r], t, o);
        if ("throw" !== c.type) {
          var u = c.arg,
            h = u.value;
          return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
            invoke("next", t, i, a);
          }, function (t) {
            invoke("throw", t, i, a);
          }) : e.resolve(h).then(function (t) {
            u.value = t, i(u);
          }, function (t) {
            return invoke("throw", t, i, a);
          });
        }
        a(c.arg);
      }
      var r;
      o(this, "_invoke", {
        value: function value(t, n) {
          function callInvokeWithMethodAndArg() {
            return new e(function (e, r) {
              invoke(t, n, e, r);
            });
          }
          return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
      });
    }
    function makeInvokeMethod(e, r, n) {
      var o = h;
      return function (i, a) {
        if (o === f) throw new Error("Generator is already running");
        if (o === s) {
          if ("throw" === i) throw a;
          return {
            value: t,
            done: !0
          };
        }
        for (n.method = i, n.arg = a;;) {
          var c = n.delegate;
          if (c) {
            var u = maybeInvokeDelegate(c, n);
            if (u) {
              if (u === y) continue;
              return u;
            }
          }
          if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
            if (o === h) throw o = s, n.arg;
            n.dispatchException(n.arg);
          } else "return" === n.method && n.abrupt("return", n.arg);
          o = f;
          var p = tryCatch(e, r, n);
          if ("normal" === p.type) {
            if (o = n.done ? s : l, p.arg === y) continue;
            return {
              value: p.arg,
              done: n.done
            };
          }
          "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
        }
      };
    }
    function maybeInvokeDelegate(e, r) {
      var n = r.method,
        o = e.iterator[n];
      if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
      var i = tryCatch(o, e.iterator, r.arg);
      if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
      var a = i.arg;
      return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
      var e = {
        tryLoc: t[0]
      };
      1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
      var e = t.completion || {};
      e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
      this.tryEntries = [{
        tryLoc: "root"
      }], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
      if (e || "" === e) {
        var r = e[a];
        if (r) return r.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) {
          var o = -1,
            i = function next() {
              for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
              return next.value = t, next.done = !0, next;
            };
          return i.next = i;
        }
      }
      throw new TypeError(_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
      value: GeneratorFunctionPrototype,
      configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
      value: GeneratorFunction,
      configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
      var e = "function" == typeof t && t.constructor;
      return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function (t) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function (t) {
      return {
        __await: t
      };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
      return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
      void 0 === i && (i = Promise);
      var a = new AsyncIterator(wrap(t, r, n, o), i);
      return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
        return t.done ? t.value : a.next();
      });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
      return this;
    }), define(g, "toString", function () {
      return "[object Generator]";
    }), e.keys = function (t) {
      var e = Object(t),
        r = [];
      for (var n in e) r.push(n);
      return r.reverse(), function next() {
        for (; r.length;) {
          var t = r.pop();
          if (t in e) return next.value = t, next.done = !1, next;
        }
        return next.done = !0, next;
      };
    }, e.values = values, Context.prototype = {
      constructor: Context,
      reset: function reset(e) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
      },
      stop: function stop() {
        this.done = !0;
        var t = this.tryEntries[0].completion;
        if ("throw" === t.type) throw t.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(e) {
        if (this.done) throw e;
        var r = this;
        function handle(n, o) {
          return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
        }
        for (var o = this.tryEntries.length - 1; o >= 0; --o) {
          var i = this.tryEntries[o],
            a = i.completion;
          if ("root" === i.tryLoc) return handle("end");
          if (i.tryLoc <= this.prev) {
            var c = n.call(i, "catchLoc"),
              u = n.call(i, "finallyLoc");
            if (c && u) {
              if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
              if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
            } else if (c) {
              if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            } else {
              if (!u) throw new Error("try statement without catch or finally");
              if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
            }
          }
        }
      },
      abrupt: function abrupt(t, e) {
        for (var r = this.tryEntries.length - 1; r >= 0; --r) {
          var o = this.tryEntries[r];
          if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
            var i = o;
            break;
          }
        }
        i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
        var a = i ? i.completion : {};
        return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
      },
      complete: function complete(t, e) {
        if ("throw" === t.type) throw t.arg;
        return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
      },
      finish: function finish(t) {
        for (var e = this.tryEntries.length - 1; e >= 0; --e) {
          var r = this.tryEntries[e];
          if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
        }
      },
      "catch": function _catch(t) {
        for (var e = this.tryEntries.length - 1; e >= 0; --e) {
          var r = this.tryEntries[e];
          if (r.tryLoc === t) {
            var n = r.completion;
            if ("throw" === n.type) {
              var o = n.arg;
              resetTryEntry(r);
            }
            return o;
          }
        }
        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(e, r, n) {
        return this.delegate = {
          iterator: values(e),
          resultName: r,
          nextLoc: n
        }, "next" === this.method && (this.arg = t), y;
      }
    }, e;
  }
  module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(regeneratorRuntime$1);
var regeneratorRuntimeExports = regeneratorRuntime$1.exports;

// TODO(Babel 8): Remove this file.

var runtime = regeneratorRuntimeExports();
var regenerator = runtime;

// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if ((typeof globalThis === "undefined" ? "undefined" : _typeof$1(globalThis)) === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}
var _regeneratorRuntime = /*@__PURE__*/getDefaultExportFromCjs$1(regenerator);

function number$2 (x) {
  return x === null ? NaN : +x;
}

var ascendingBisect = bisector(ascending);
var bisectRight = ascendingBisect.right;
bisector(number$2).center;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof$1(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

var e10 = Math.sqrt(50),
  e5 = Math.sqrt(10),
  e2 = Math.sqrt(2);
function ticks (start, stop, count) {
  var reverse,
    i = -1,
    n,
    ticks,
    step;
  stop = +stop, start = +start, count = +count;
  if (start === stop && count > 0) return [start];
  if (reverse = stop < start) n = start, start = stop, stop = n;
  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
  if (step > 0) {
    var r0 = Math.round(start / step),
      r1 = Math.round(stop / step);
    if (r0 * step < start) ++r0;
    if (r1 * step > stop) --r1;
    ticks = new Array(n = r1 - r0 + 1);
    while (++i < n) ticks[i] = (r0 + i) * step;
  } else {
    step = -step;
    var _r = Math.round(start * step),
      _r2 = Math.round(stop * step);
    if (_r / step < start) ++_r;
    if (_r2 / step > stop) --_r2;
    ticks = new Array(n = _r2 - _r + 1);
    while (++i < n) ticks[i] = (_r + i) / step;
  }
  if (reverse) ticks.reverse();
  return ticks;
}
function tickIncrement(start, stop, count) {
  var step = (stop - start) / Math.max(0, count),
    power = Math.floor(Math.log(step) / Math.LN10),
    error = step / Math.pow(10, power);
  return power >= 0 ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}
function tickStep(start, stop, count) {
  var step0 = Math.abs(stop - start) / Math.max(0, count),
    step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
    error = step0 / step1;
  if (error >= e10) step1 *= 10;else if (error >= e5) step1 *= 5;else if (error >= e2) step1 *= 2;
  return stop < start ? -step1 : step1;
}

function sequence (start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
  var i = -1,
    n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
    range = new Array(n);
  while (++i < n) {
    range[i] = start + i * step;
  }
  return range;
}

function initRange(domain, range) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(domain);
      break;
    default:
      this.range(range).domain(domain);
      break;
  }
  return this;
}

function _createForOfIteratorHelper$2(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$2(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray$2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen); }
function _arrayLikeToArray$2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var implicit = Symbol("implicit");
function ordinal() {
  var index = new Map(),
    domain = [],
    range = [],
    unknown = implicit;
  function scale(d) {
    var key = d + "",
      i = index.get(key);
    if (!i) {
      if (unknown !== implicit) return unknown;
      index.set(key, i = domain.push(d));
    }
    return range[(i - 1) % range.length];
  }
  scale.domain = function (_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = new Map();
    var _iterator = _createForOfIteratorHelper$2(_),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var value = _step.value;
        var key = value + "";
        if (index.has(key)) continue;
        index.set(key, domain.push(value));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return scale;
  };
  scale.range = function (_) {
    return arguments.length ? (range = Array.from(_), scale) : range.slice();
  };
  scale.unknown = function (_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };
  scale.copy = function () {
    return ordinal(domain, range).unknown(unknown);
  };
  initRange.apply(scale, arguments);
  return scale;
}

function band() {
  var scale = ordinal().unknown(undefined),
    domain = scale.domain,
    ordinalRange = scale.range,
    r0 = 0,
    r1 = 1,
    step,
    bandwidth,
    round = false,
    paddingInner = 0,
    paddingOuter = 0,
    align = 0.5;
  delete scale.unknown;
  function rescale() {
    var n = domain().length,
      reverse = r1 < r0,
      start = reverse ? r1 : r0,
      stop = reverse ? r0 : r1;
    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round) step = Math.floor(step);
    start += (stop - start - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values = sequence(n).map(function (i) {
      return start + step * i;
    });
    return ordinalRange(reverse ? values.reverse() : values);
  }
  scale.domain = function (_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };
  scale.range = function (_) {
    var _ref;
    return arguments.length ? ((_ref = _slicedToArray(_, 2), r0 = _ref[0], r1 = _ref[1]), r0 = +r0, r1 = +r1, rescale()) : [r0, r1];
  };
  scale.rangeRound = function (_) {
    var _ref2;
    return (_ref2 = _slicedToArray(_, 2), r0 = _ref2[0], r1 = _ref2[1]), r0 = +r0, r1 = +r1, round = true, rescale();
  };
  scale.bandwidth = function () {
    return bandwidth;
  };
  scale.step = function () {
    return step;
  };
  scale.round = function (_) {
    return arguments.length ? (round = !!_, rescale()) : round;
  };
  scale.padding = function (_) {
    return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
  };
  scale.paddingInner = function (_) {
    return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
  };
  scale.paddingOuter = function (_) {
    return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
  };
  scale.align = function (_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };
  scale.copy = function () {
    return band(domain(), [r0, r1]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
  };
  return initRange.apply(rescale(), arguments);
}
function pointish(scale) {
  var copy = scale.copy;
  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  delete scale.paddingOuter;
  scale.copy = function () {
    return pointish(copy());
  };
  return scale;
}
function point() {
  return pointish(band.apply(null, arguments).paddingInner(1));
}

function define$1 (constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
}
function extend$1(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}

function Color$1() {}
var _darker$1 = 0.7;
var _brighter$1 = 1 / _darker$1;
var reI$1 = "\\s*([+-]?\\d+)\\s*",
  reN$1 = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
  reP$1 = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
  reHex$1 = /^#([0-9a-f]{3,8})$/,
  reRgbInteger$1 = new RegExp("^rgb\\(" + [reI$1, reI$1, reI$1] + "\\)$"),
  reRgbPercent$1 = new RegExp("^rgb\\(" + [reP$1, reP$1, reP$1] + "\\)$"),
  reRgbaInteger$1 = new RegExp("^rgba\\(" + [reI$1, reI$1, reI$1, reN$1] + "\\)$"),
  reRgbaPercent$1 = new RegExp("^rgba\\(" + [reP$1, reP$1, reP$1, reN$1] + "\\)$"),
  reHslPercent$1 = new RegExp("^hsl\\(" + [reN$1, reP$1, reP$1] + "\\)$"),
  reHslaPercent$1 = new RegExp("^hsla\\(" + [reN$1, reP$1, reP$1, reN$1] + "\\)$");
var named$1 = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};
define$1(Color$1, color$1, {
  copy: function copy(channels) {
    return Object.assign(new this.constructor(), this, channels);
  },
  displayable: function displayable() {
    return this.rgb().displayable();
  },
  hex: color_formatHex$1,
  // Deprecated! Use color.formatHex.
  formatHex: color_formatHex$1,
  formatHsl: color_formatHsl$1,
  formatRgb: color_formatRgb$1,
  toString: color_formatRgb$1
});
function color_formatHex$1() {
  return this.rgb().formatHex();
}
function color_formatHsl$1() {
  return hslConvert$1(this).formatHsl();
}
function color_formatRgb$1() {
  return this.rgb().formatRgb();
}
function color$1(format) {
  var m, l;
  format = (format + "").trim().toLowerCase();
  return (m = reHex$1.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn$1(m) // #ff0000
  : l === 3 ? new Rgb$1(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
  : l === 8 ? rgba$1(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
  : l === 4 ? rgba$1(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
  : null // invalid hex
  ) : (m = reRgbInteger$1.exec(format)) ? new Rgb$1(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
  : (m = reRgbPercent$1.exec(format)) ? new Rgb$1(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
  : (m = reRgbaInteger$1.exec(format)) ? rgba$1(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
  : (m = reRgbaPercent$1.exec(format)) ? rgba$1(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
  : (m = reHslPercent$1.exec(format)) ? hsla$1(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
  : (m = reHslaPercent$1.exec(format)) ? hsla$1(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
  : named$1.hasOwnProperty(format) ? rgbn$1(named$1[format]) // eslint-disable-line no-prototype-builtins
  : format === "transparent" ? new Rgb$1(NaN, NaN, NaN, 0) : null;
}
function rgbn$1(n) {
  return new Rgb$1(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba$1(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb$1(r, g, b, a);
}
function rgbConvert$1(o) {
  if (!(o instanceof Color$1)) o = color$1(o);
  if (!o) return new Rgb$1();
  o = o.rgb();
  return new Rgb$1(o.r, o.g, o.b, o.opacity);
}
function rgb$2(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert$1(r) : new Rgb$1(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb$1(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}
define$1(Rgb$1, rgb$2, extend$1(Color$1, {
  brighter: function brighter(k) {
    k = k == null ? _brighter$1 : Math.pow(_brighter$1, k);
    return new Rgb$1(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function darker(k) {
    k = k == null ? _darker$1 : Math.pow(_darker$1, k);
    return new Rgb$1(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function rgb() {
    return this;
  },
  displayable: function displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: rgb_formatHex$1,
  // Deprecated! Use color.formatHex.
  formatHex: rgb_formatHex$1,
  formatRgb: rgb_formatRgb$1,
  toString: rgb_formatRgb$1
}));
function rgb_formatHex$1() {
  return "#" + hex$1(this.r) + hex$1(this.g) + hex$1(this.b);
}
function rgb_formatRgb$1() {
  var a = this.opacity;
  a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
  return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
}
function hex$1(value) {
  value = Math.max(0, Math.min(255, Math.round(value) || 0));
  return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla$1(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;else if (l <= 0 || l >= 1) h = s = NaN;else if (s <= 0) h = NaN;
  return new Hsl$1(h, s, l, a);
}
function hslConvert$1(o) {
  if (o instanceof Hsl$1) return new Hsl$1(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color$1)) o = color$1(o);
  if (!o) return new Hsl$1();
  if (o instanceof Hsl$1) return o;
  o = o.rgb();
  var r = o.r / 255,
    g = o.g / 255,
    b = o.b / 255,
    min = Math.min(r, g, b),
    max = Math.max(r, g, b),
    h = NaN,
    s = max - min,
    l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;else if (g === max) h = (b - r) / s + 2;else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl$1(h, s, l, o.opacity);
}
function hsl$1(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert$1(h) : new Hsl$1(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl$1(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}
define$1(Hsl$1, hsl$1, extend$1(Color$1, {
  brighter: function brighter(k) {
    k = k == null ? _brighter$1 : Math.pow(_brighter$1, k);
    return new Hsl$1(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function darker(k) {
    k = k == null ? _darker$1 : Math.pow(_darker$1, k);
    return new Hsl$1(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function rgb() {
    var h = this.h % 360 + (this.h < 0) * 360,
      s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
      l = this.l,
      m2 = l + (l < 0.5 ? l : 1 - l) * s,
      m1 = 2 * l - m2;
    return new Rgb$1(hsl2rgb$1(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb$1(h, m1, m2), hsl2rgb$1(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
  },
  displayable: function displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl: function formatHsl() {
    var a = this.opacity;
    a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
  }
}));

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb$1(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

var radians$1 = Math.PI / 180;
var degrees$1 = 180 / Math.PI;

var A$3 = -0.14861,
  B$4 = +1.78277,
  C$4 = -0.29227,
  D$5 = -0.90649,
  E$2 = +1.97294,
  ED$1 = E$2 * D$5,
  EB$1 = E$2 * B$4,
  BC_DA$1 = B$4 * C$4 - D$5 * A$3;
function cubehelixConvert$1(o) {
  if (o instanceof Cubehelix$1) return new Cubehelix$1(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Rgb$1)) o = rgbConvert$1(o);
  var r = o.r / 255,
    g = o.g / 255,
    b = o.b / 255,
    l = (BC_DA$1 * b + ED$1 * r - EB$1 * g) / (BC_DA$1 + ED$1 - EB$1),
    bl = b - l,
    k = (E$2 * (g - l) - C$4 * bl) / D$5,
    s = Math.sqrt(k * k + bl * bl) / (E$2 * l * (1 - l)),
    // NaN if l=0 or l=1
    h = s ? Math.atan2(k, bl) * degrees$1 - 120 : NaN;
  return new Cubehelix$1(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function cubehelix$2(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert$1(h) : new Cubehelix$1(h, s, l, opacity == null ? 1 : opacity);
}
function Cubehelix$1(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}
define$1(Cubehelix$1, cubehelix$2, extend$1(Color$1, {
  brighter: function brighter(k) {
    k = k == null ? _brighter$1 : Math.pow(_brighter$1, k);
    return new Cubehelix$1(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function darker(k) {
    k = k == null ? _darker$1 : Math.pow(_darker$1, k);
    return new Cubehelix$1(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function rgb() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * radians$1,
      l = +this.l,
      a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
      cosh = Math.cos(h),
      sinh = Math.sin(h);
    return new Rgb$1(255 * (l + a * (A$3 * cosh + B$4 * sinh)), 255 * (l + a * (C$4 * cosh + D$5 * sinh)), 255 * (l + a * (E$2 * cosh)), this.opacity);
  }
}));

function basis$2(t1, v0, v1, v2, v3) {
  var t2 = t1 * t1,
    t3 = t2 * t1;
  return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function basis$3 (values) {
  var n = values.length - 1;
  return function (t) {
    var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
      v1 = values[i],
      v2 = values[i + 1],
      v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
      v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
    return basis$2((t - i / n) * n, v0, v1, v2, v3);
  };
}

var constant$2 = (function (x) {
  return function () {
    return x;
  };
});

function linear$2(a, d) {
  return function (t) {
    return a + t * d;
  };
}
function exponential$1(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function (t) {
    return Math.pow(a + t * b, y);
  };
}
function hue(a, b) {
  var d = b - a;
  return d ? linear$2(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant$2(isNaN(a) ? b : a);
}
function gamma$1(y) {
  return (y = +y) === 1 ? nogamma$1 : function (a, b) {
    return b - a ? exponential$1(a, b, y) : constant$2(isNaN(a) ? b : a);
  };
}
function nogamma$1(a, b) {
  var d = b - a;
  return d ? linear$2(a, d) : constant$2(isNaN(a) ? b : a);
}

var rgb$1 = (function rgbGamma(y) {
  var color = gamma$1(y);
  function rgb(start, end) {
    var r = color((start = rgb$2(start)).r, (end = rgb$2(end)).r),
      g = color(start.g, end.g),
      b = color(start.b, end.b),
      opacity = nogamma$1(start.opacity, end.opacity);
    return function (t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
  rgb.gamma = rgbGamma;
  return rgb;
})(1);
function rgbSpline$1(spline) {
  return function (colors) {
    var n = colors.length,
      r = new Array(n),
      g = new Array(n),
      b = new Array(n),
      i,
      color;
    for (i = 0; i < n; ++i) {
      color = rgb$2(colors[i]);
      r[i] = color.r || 0;
      g[i] = color.g || 0;
      b[i] = color.b || 0;
    }
    r = spline(r);
    g = spline(g);
    b = spline(b);
    color.opacity = 1;
    return function (t) {
      color.r = r(t);
      color.g = g(t);
      color.b = b(t);
      return color + "";
    };
  };
}
var rgbBasis$1 = rgbSpline$1(basis$3);

function numberArray (a, b) {
  if (!b) b = [];
  var n = a ? Math.min(b.length, a.length) : 0,
    c = b.slice(),
    i;
  return function (t) {
    for (i = 0; i < n; ++i) c[i] = a[i] * (1 - t) + b[i] * t;
    return c;
  };
}
function isNumberArray(x) {
  return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

function genericArray(a, b) {
  var nb = b ? b.length : 0,
    na = a ? Math.min(nb, a.length) : 0,
    x = new Array(na),
    c = new Array(nb),
    i;
  for (i = 0; i < na; ++i) x[i] = interpolate(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];
  return function (t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
}

function date$1 (a, b) {
  var d = new Date();
  return a = +a, b = +b, function (t) {
    return d.setTime(a * (1 - t) + b * t), d;
  };
}

function interpolateNumber (a, b) {
  return a = +a, b = +b, function (t) {
    return a * (1 - t) + b * t;
  };
}

function object (a, b) {
  var i = {},
    c = {},
    k;
  if (a === null || _typeof$1(a) !== "object") a = {};
  if (b === null || _typeof$1(b) !== "object") b = {};
  for (k in b) {
    if (k in a) {
      i[k] = interpolate(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }
  return function (t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
}

var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
  reB = new RegExp(reA.source, "g");
function zero(b) {
  return function () {
    return b;
  };
}
function one(b) {
  return function (t) {
    return b(t) + "";
  };
}
function string (a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0,
    // scan index for next number in b
    am,
    // current match in a
    bm,
    // current match in b
    bs,
    // string preceding current number in b, if any
    i = -1,
    // index in s
    s = [],
    // string constants and placeholders
    q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a)) && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) {
      // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) {
      // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else {
      // interpolate non-matching numbers
      s[++i] = null;
      q.push({
        i: i,
        x: interpolateNumber(am, bm)
      });
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? q[0] ? one(q[0].x) : zero(b) : (b = q.length, function (t) {
    for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
    return s.join("");
  });
}

function interpolate (a, b) {
  var t = _typeof$1(b),
    c;
  return b == null || t === "boolean" ? constant$2(b) : (t === "number" ? interpolateNumber : t === "string" ? (c = color$1(b)) ? (b = c, rgb$1) : string : b instanceof color$1 ? rgb$1 : b instanceof Date ? date$1 : isNumberArray(b) ? numberArray : Array.isArray(b) ? genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object : interpolateNumber)(a, b);
}

function interpolateRound (a, b) {
  return a = +a, b = +b, function (t) {
    return Math.round(a * (1 - t) + b * t);
  };
}

function cubehelix$1(hue) {
  return function cubehelixGamma(y) {
    y = +y;
    function cubehelix(start, end) {
      var h = hue((start = cubehelix$2(start)).h, (end = cubehelix$2(end)).h),
        s = nogamma$1(start.s, end.s),
        l = nogamma$1(start.l, end.l),
        opacity = nogamma$1(start.opacity, end.opacity);
      return function (t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(Math.pow(t, y));
        start.opacity = opacity(t);
        return start + "";
      };
    }
    cubehelix.gamma = cubehelixGamma;
    return cubehelix;
  }(1);
}
cubehelix$1(hue);
var cubehelixLong = cubehelix$1(nogamma$1);

function constants(x) {
  return function () {
    return x;
  };
}

function number$1(x) {
  return +x;
}

var unit = [0, 1];
function identity$5(x) {
  return x;
}
function normalize(a, b) {
  return (b -= a = +a) ? function (x) {
    return (x - a) / b;
  } : constants(isNaN(b) ? NaN : 0.5);
}
function clamper(a, b) {
  var t;
  if (a > b) t = a, a = b, b = t;
  return function (x) {
    return Math.max(a, Math.min(b, x));
  };
}

// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function bimap(domain, range, interpolate) {
  var d0 = domain[0],
    d1 = domain[1],
    r0 = range[0],
    r1 = range[1];
  if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate(r1, r0);else d0 = normalize(d0, d1), r0 = interpolate(r0, r1);
  return function (x) {
    return r0(d0(x));
  };
}
function polymap(domain, range, interpolate) {
  var j = Math.min(domain.length, range.length) - 1,
    d = new Array(j),
    r = new Array(j),
    i = -1;

  // Reverse descending domains.
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }
  while (++i < j) {
    d[i] = normalize(domain[i], domain[i + 1]);
    r[i] = interpolate(range[i], range[i + 1]);
  }
  return function (x) {
    var i = bisectRight(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}
function copy(source, target) {
  return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function transformer() {
  var domain = unit,
    range = unit,
    interpolate$1 = interpolate,
    transform,
    untransform,
    unknown,
    clamp = identity$5,
    piecewise,
    output,
    input;
  function rescale() {
    var n = Math.min(domain.length, range.length);
    if (clamp !== identity$5) clamp = clamper(domain[0], domain[n - 1]);
    piecewise = n > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }
  function scale(x) {
    return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate$1)))(transform(clamp(x)));
  }
  scale.invert = function (y) {
    return clamp(untransform((input || (input = piecewise(range, domain.map(transform), interpolateNumber)))(y)));
  };
  scale.domain = function (_) {
    return arguments.length ? (domain = Array.from(_, number$1), rescale()) : domain.slice();
  };
  scale.range = function (_) {
    return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
  };
  scale.rangeRound = function (_) {
    return range = Array.from(_), interpolate$1 = interpolateRound, rescale();
  };
  scale.clamp = function (_) {
    return arguments.length ? (clamp = _ ? true : identity$5, rescale()) : clamp !== identity$5;
  };
  scale.interpolate = function (_) {
    return arguments.length ? (interpolate$1 = _, rescale()) : interpolate$1;
  };
  scale.unknown = function (_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };
  return function (t, u) {
    transform = t, untransform = u;
    return rescale();
  };
}
function continuous() {
  return transformer()(identity$5, identity$5);
}

function formatDecimal$1 (x) {
  return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}

// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function formatDecimalParts$1(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i,
    coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient, +x.slice(i + 1)];
}

function exponent$1 (x) {
  return x = formatDecimalParts$1(Math.abs(x)), x ? x[1] : NaN;
}

function formatGroup$1 (grouping, thousands) {
  return function (value, width) {
    var i = value.length,
      t = [],
      j = 0,
      g = grouping[0],
      length = 0;
    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }
    return t.reverse().join(thousands);
  };
}

function formatNumerals$1 (numerals) {
  return function (value) {
    return value.replace(/[0-9]/g, function (i) {
      return numerals[+i];
    });
  };
}

// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var re$2 = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function formatSpecifier$1(specifier) {
  if (!(match = re$2.exec(specifier))) throw new Error("invalid format: " + specifier);
  var match;
  return new FormatSpecifier$1({
    fill: match[1],
    align: match[2],
    sign: match[3],
    symbol: match[4],
    zero: match[5],
    width: match[6],
    comma: match[7],
    precision: match[8] && match[8].slice(1),
    trim: match[9],
    type: match[10]
  });
}
formatSpecifier$1.prototype = FormatSpecifier$1.prototype; // instanceof

function FormatSpecifier$1(specifier) {
  this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
  this.align = specifier.align === undefined ? ">" : specifier.align + "";
  this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
  this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
  this.zero = !!specifier.zero;
  this.width = specifier.width === undefined ? undefined : +specifier.width;
  this.comma = !!specifier.comma;
  this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
  this.trim = !!specifier.trim;
  this.type = specifier.type === undefined ? "" : specifier.type + "";
}
FormatSpecifier$1.prototype.toString = function () {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function formatTrim$1 (s) {
  out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (s[i]) {
      case ".":
        i0 = i1 = i;
        break;
      case "0":
        if (i0 === 0) i0 = i;
        i1 = i;
        break;
      default:
        if (!+s[i]) break out;
        if (i0 > 0) i0 = 0;
        break;
    }
  }
  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

var prefixExponent$1;
function formatPrefixAuto$1 (x, p) {
  var d = formatDecimalParts$1(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
    exponent = d[1],
    i = exponent - (prefixExponent$1 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
    n = coefficient.length;
  return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + formatDecimalParts$1(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

function formatRounded$1 (x, p) {
  var d = formatDecimalParts$1(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
    exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

var formatTypes$1 = {
  "%": function _(x, p) {
    return (x * 100).toFixed(p);
  },
  "b": function b(x) {
    return Math.round(x).toString(2);
  },
  "c": function c(x) {
    return x + "";
  },
  "d": formatDecimal$1,
  "e": function e(x, p) {
    return x.toExponential(p);
  },
  "f": function f(x, p) {
    return x.toFixed(p);
  },
  "g": function g(x, p) {
    return x.toPrecision(p);
  },
  "o": function o(x) {
    return Math.round(x).toString(8);
  },
  "p": function p(x, _p) {
    return formatRounded$1(x * 100, _p);
  },
  "r": formatRounded$1,
  "s": formatPrefixAuto$1,
  "X": function X(x) {
    return Math.round(x).toString(16).toUpperCase();
  },
  "x": function x(_x) {
    return Math.round(_x).toString(16);
  }
};

function identity$4 (x) {
  return x;
}

var map$1 = Array.prototype.map,
  prefixes$1 = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function formatLocale$2 (locale) {
  var group = locale.grouping === undefined || locale.thousands === undefined ? identity$4 : formatGroup$1(map$1.call(locale.grouping, Number), locale.thousands + ""),
    currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "",
    currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "",
    decimal = locale.decimal === undefined ? "." : locale.decimal + "",
    numerals = locale.numerals === undefined ? identity$4 : formatNumerals$1(map$1.call(locale.numerals, String)),
    percent = locale.percent === undefined ? "%" : locale.percent + "",
    minus = locale.minus === undefined ? "−" : locale.minus + "",
    nan = locale.nan === undefined ? "NaN" : locale.nan + "";
  function newFormat(specifier) {
    specifier = formatSpecifier$1(specifier);
    var fill = specifier.fill,
      align = specifier.align,
      sign = specifier.sign,
      symbol = specifier.symbol,
      zero = specifier.zero,
      width = specifier.width,
      comma = specifier.comma,
      precision = specifier.precision,
      trim = specifier.trim,
      type = specifier.type;

    // The "n" type is an alias for ",g".
    if (type === "n") comma = true, type = "g";

    // The "" type, and any invalid type, is an alias for ".12~g".
    else if (!formatTypes$1[type]) precision === undefined && (precision = 12), trim = true, type = "g";

    // If zero fill is specified, padding goes after sign and before digits.
    if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
      suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = formatTypes$1[type],
      maybeSuffix = /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
    function format(value) {
      var valuePrefix = prefix,
        valueSuffix = suffix,
        i,
        n,
        c;
      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Determine the sign. -0 is not less than 0, but 1 / -0 is!
        var valueNegative = value < 0 || 1 / value < 0;

        // Perform the initial formatting.
        value = isNaN(value) ? nan : formatType(Math.abs(value), precision);

        // Trim insignificant zeros.
        if (trim) value = formatTrim$1(value);

        // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
        if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = (type === "s" ? prefixes$1[8 + prefixExponent$1 / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
        padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<":
          value = valuePrefix + value + valueSuffix + padding;
          break;
        case "=":
          value = valuePrefix + padding + value + valueSuffix;
          break;
        case "^":
          value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
          break;
        default:
          value = padding + valuePrefix + value + valueSuffix;
          break;
      }
      return numerals(value);
    }
    format.toString = function () {
      return specifier + "";
    };
    return format;
  }
  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = formatSpecifier$1(specifier), specifier.type = "f", specifier)),
      e = Math.max(-8, Math.min(8, Math.floor(exponent$1(value) / 3))) * 3,
      k = Math.pow(10, -e),
      prefix = prefixes$1[8 + e / 3];
    return function (value) {
      return f(k * value) + prefix;
    };
  }
  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
}

var locale$2;
var format$1;
var formatPrefix;
defaultLocale$2({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function defaultLocale$2(definition) {
  locale$2 = formatLocale$2(definition);
  format$1 = locale$2.format;
  formatPrefix = locale$2.formatPrefix;
  return locale$2;
}

function precisionFixed (step) {
  return Math.max(0, -exponent$1(Math.abs(step)));
}

function precisionPrefix (step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent$1(value) / 3))) * 3 - exponent$1(Math.abs(step)));
}

function precisionRound (step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, exponent$1(max) - exponent$1(step)) + 1;
}

function tickFormat(start, stop, count, specifier) {
  var step = tickStep(start, stop, count),
    precision;
  specifier = formatSpecifier$1(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s":
      {
        var value = Math.max(Math.abs(start), Math.abs(stop));
        if (specifier.precision == null && !isNaN(precision = precisionPrefix(step, value))) specifier.precision = precision;
        return formatPrefix(specifier, value);
      }
    case "":
    case "e":
    case "g":
    case "p":
    case "r":
      {
        if (specifier.precision == null && !isNaN(precision = precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
        break;
      }
    case "f":
    case "%":
      {
        if (specifier.precision == null && !isNaN(precision = precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
        break;
      }
  }
  return format$1(specifier);
}

function linearish(scale) {
  var domain = scale.domain;
  scale.ticks = function (count) {
    var d = domain();
    return ticks(d[0], d[d.length - 1], count == null ? 10 : count);
  };
  scale.tickFormat = function (count, specifier) {
    var d = domain();
    return tickFormat(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
  };
  scale.nice = function (count) {
    if (count == null) count = 10;
    var d = domain();
    var i0 = 0;
    var i1 = d.length - 1;
    var start = d[i0];
    var stop = d[i1];
    var prestep;
    var step;
    var maxIter = 10;
    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }
    while (maxIter-- > 0) {
      step = tickIncrement(start, stop, count);
      if (step === prestep) {
        d[i0] = start;
        d[i1] = stop;
        return domain(d);
      } else if (step > 0) {
        start = Math.floor(start / step) * step;
        stop = Math.ceil(stop / step) * step;
      } else if (step < 0) {
        start = Math.ceil(start * step) / step;
        stop = Math.floor(stop * step) / step;
      } else {
        break;
      }
      prestep = step;
    }
    return scale;
  };
  return scale;
}
function linear$1() {
  var scale = continuous();
  scale.copy = function () {
    return copy(scale, linear$1());
  };
  initRange.apply(scale, arguments);
  return linearish(scale);
}

function nice(domain, interval) {
  domain = domain.slice();
  var i0 = 0,
    i1 = domain.length - 1,
    x0 = domain[i0],
    x1 = domain[i1],
    t;
  if (x1 < x0) {
    t = i0, i0 = i1, i1 = t;
    t = x0, x0 = x1, x1 = t;
  }
  domain[i0] = interval.floor(x0);
  domain[i1] = interval.ceil(x1);
  return domain;
}

function transformLog(x) {
  return Math.log(x);
}
function transformExp(x) {
  return Math.exp(x);
}
function transformLogn(x) {
  return -Math.log(-x);
}
function transformExpn(x) {
  return -Math.exp(-x);
}
function pow10(x) {
  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function powp(base) {
  return base === 10 ? pow10 : base === Math.E ? Math.exp : function (x) {
    return Math.pow(base, x);
  };
}
function logp(base) {
  return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), function (x) {
    return Math.log(x) / base;
  });
}
function reflect(f) {
  return function (x) {
    return -f(-x);
  };
}
function loggish(transform) {
  var scale = transform(transformLog, transformExp),
    domain = scale.domain,
    base = 10,
    logs,
    pows;
  function rescale() {
    logs = logp(base), pows = powp(base);
    if (domain()[0] < 0) {
      logs = reflect(logs), pows = reflect(pows);
      transform(transformLogn, transformExpn);
    } else {
      transform(transformLog, transformExp);
    }
    return scale;
  }
  scale.base = function (_) {
    return arguments.length ? (base = +_, rescale()) : base;
  };
  scale.domain = function (_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };
  scale.ticks = function (count) {
    var d = domain(),
      u = d[0],
      v = d[d.length - 1],
      r;
    if (r = v < u) i = u, u = v, v = i;
    var i = logs(u),
      j = logs(v),
      p,
      k,
      t,
      n = count == null ? 10 : +count,
      z = [];
    if (!(base % 1) && j - i < n) {
      i = Math.floor(i), j = Math.ceil(j);
      if (u > 0) for (; i <= j; ++i) {
        for (k = 1, p = pows(i); k < base; ++k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      } else for (; i <= j; ++i) {
        for (k = base - 1, p = pows(i); k >= 1; --k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      }
      if (z.length * 2 < n) z = ticks(u, v, n);
    } else {
      z = ticks(i, j, Math.min(j - i, n)).map(pows);
    }
    return r ? z.reverse() : z;
  };
  scale.tickFormat = function (count, specifier) {
    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
    if (typeof specifier !== "function") specifier = format$1(specifier);
    if (count === Infinity) return specifier;
    if (count == null) count = 10;
    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
    return function (d) {
      var i = d / pows(Math.round(logs(d)));
      if (i * base < base - 0.5) i *= base;
      return i <= k ? specifier(d) : "";
    };
  };
  scale.nice = function () {
    return domain(nice(domain(), {
      floor: function floor(x) {
        return pows(Math.floor(logs(x)));
      },
      ceil: function ceil(x) {
        return pows(Math.ceil(logs(x)));
      }
    }));
  };
  return scale;
}
function log() {
  var scale = loggish(transformer()).domain([1, 10]);
  scale.copy = function () {
    return copy(scale, log()).base(scale.base());
  };
  initRange.apply(scale, arguments);
  return scale;
}

function transformSymlog(c) {
  return function (x) {
    return Math.sign(x) * Math.log1p(Math.abs(x / c));
  };
}
function transformSymexp(c) {
  return function (x) {
    return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
  };
}
function symlogish(transform) {
  var c = 1,
    scale = transform(transformSymlog(c), transformSymexp(c));
  scale.constant = function (_) {
    return arguments.length ? transform(transformSymlog(c = +_), transformSymexp(c)) : c;
  };
  return linearish(scale);
}
function symlog() {
  var scale = symlogish(transformer());
  scale.copy = function () {
    return copy(scale, symlog()).constant(scale.constant());
  };
  return initRange.apply(scale, arguments);
}

var t0$1 = new Date(),
  t1$1 = new Date();
function newInterval$1(floori, offseti, count, field) {
  function interval(date) {
    return floori(date = arguments.length === 0 ? new Date() : new Date(+date)), date;
  }
  interval.floor = function (date) {
    return floori(date = new Date(+date)), date;
  };
  interval.ceil = function (date) {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };
  interval.round = function (date) {
    var d0 = interval(date),
      d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };
  interval.offset = function (date, step) {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };
  interval.range = function (start, stop, step) {
    var range = [],
      previous;
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
    do range.push(previous = new Date(+start)), offseti(start, step), floori(start); while (previous < start && start < stop);
    return range;
  };
  interval.filter = function (test) {
    return newInterval$1(function (date) {
      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
    }, function (date, step) {
      if (date >= date) {
        if (step < 0) while (++step <= 0) {
          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
        } else while (--step >= 0) {
          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
        }
      }
    });
  };
  if (count) {
    interval.count = function (start, end) {
      t0$1.setTime(+start), t1$1.setTime(+end);
      floori(t0$1), floori(t1$1);
      return Math.floor(count(t0$1, t1$1));
    };
    interval.every = function (step) {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function (d) {
        return field(d) % step === 0;
      } : function (d) {
        return interval.count(0, d) % step === 0;
      });
    };
  }
  return interval;
}

var millisecond$1 = newInterval$1(function () {
  // noop
}, function (date, step) {
  date.setTime(+date + step);
}, function (start, end) {
  return end - start;
});

// An optimized implementation for this simple case.
millisecond$1.every = function (k) {
  k = Math.floor(k);
  if (!isFinite(k) || !(k > 0)) return null;
  if (!(k > 1)) return millisecond$1;
  return newInterval$1(function (date) {
    date.setTime(Math.floor(date / k) * k);
  }, function (date, step) {
    date.setTime(+date + step * k);
  }, function (start, end) {
    return (end - start) / k;
  });
};
millisecond$1.range;

var durationSecond$1 = 1000;
var durationMinute$1 = durationSecond$1 * 60;
var durationHour$1 = durationMinute$1 * 60;
var durationDay = durationHour$1 * 24;
var durationWeek$1 = durationDay * 7;
var durationMonth = durationDay * 30;
var durationYear = durationDay * 365;

var second$1 = newInterval$1(function (date) {
  date.setTime(date - date.getMilliseconds());
}, function (date, step) {
  date.setTime(+date + step * durationSecond$1);
}, function (start, end) {
  return (end - start) / durationSecond$1;
}, function (date) {
  return date.getUTCSeconds();
});
var utcSecond = second$1;
second$1.range;

var minute$1 = newInterval$1(function (date) {
  date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond$1);
}, function (date, step) {
  date.setTime(+date + step * durationMinute$1);
}, function (start, end) {
  return (end - start) / durationMinute$1;
}, function (date) {
  return date.getMinutes();
});
var timeMinute = minute$1;
minute$1.range;

var hour$1 = newInterval$1(function (date) {
  date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond$1 - date.getMinutes() * durationMinute$1);
}, function (date, step) {
  date.setTime(+date + step * durationHour$1);
}, function (start, end) {
  return (end - start) / durationHour$1;
}, function (date) {
  return date.getHours();
});
var timeHour = hour$1;
hour$1.range;

var day = newInterval$1(function (date) {
  return date.setHours(0, 0, 0, 0);
}, function (date, step) {
  return date.setDate(date.getDate() + step);
}, function (start, end) {
  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute$1) / durationDay;
}, function (date) {
  return date.getDate() - 1;
});
day.range;

function weekday$1(i) {
  return newInterval$1(function (date) {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, function (date, step) {
    date.setDate(date.getDate() + step * 7);
  }, function (start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute$1) / durationWeek$1;
  });
}
var sunday$1 = weekday$1(0);
var monday$1 = weekday$1(1);
var tuesday$1 = weekday$1(2);
var wednesday$1 = weekday$1(3);
var thursday$1 = weekday$1(4);
var friday$1 = weekday$1(5);
var saturday$1 = weekday$1(6);
sunday$1.range;
monday$1.range;
tuesday$1.range;
wednesday$1.range;
thursday$1.range;
friday$1.range;
saturday$1.range;

var month$1 = newInterval$1(function (date) {
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
}, function (date, step) {
  date.setMonth(date.getMonth() + step);
}, function (start, end) {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function (date) {
  return date.getMonth();
});
var timeMonth = month$1;
month$1.range;

var year$1 = newInterval$1(function (date) {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, function (date, step) {
  date.setFullYear(date.getFullYear() + step);
}, function (start, end) {
  return end.getFullYear() - start.getFullYear();
}, function (date) {
  return date.getFullYear();
});

// An optimized implementation for this simple case.
year$1.every = function (k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval$1(function (date) {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function (date, step) {
    date.setFullYear(date.getFullYear() + step * k);
  });
};
var timeYear = year$1;
year$1.range;

var utcMinute$1 = newInterval$1(function (date) {
  date.setUTCSeconds(0, 0);
}, function (date, step) {
  date.setTime(+date + step * durationMinute$1);
}, function (start, end) {
  return (end - start) / durationMinute$1;
}, function (date) {
  return date.getUTCMinutes();
});
var utcMinute$2 = utcMinute$1;
utcMinute$1.range;

var utcHour$1 = newInterval$1(function (date) {
  date.setUTCMinutes(0, 0, 0);
}, function (date, step) {
  date.setTime(+date + step * durationHour$1);
}, function (start, end) {
  return (end - start) / durationHour$1;
}, function (date) {
  return date.getUTCHours();
});
var utcHour$2 = utcHour$1;
utcHour$1.range;

var utcDay = newInterval$1(function (date) {
  date.setUTCHours(0, 0, 0, 0);
}, function (date, step) {
  date.setUTCDate(date.getUTCDate() + step);
}, function (start, end) {
  return (end - start) / durationDay;
}, function (date) {
  return date.getUTCDate() - 1;
});
utcDay.range;

function utcWeekday$1(i) {
  return newInterval$1(function (date) {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, function (date, step) {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, function (start, end) {
    return (end - start) / durationWeek$1;
  });
}
var utcSunday$1 = utcWeekday$1(0);
var utcMonday$1 = utcWeekday$1(1);
var utcTuesday$1 = utcWeekday$1(2);
var utcWednesday$1 = utcWeekday$1(3);
var utcThursday$1 = utcWeekday$1(4);
var utcFriday$1 = utcWeekday$1(5);
var utcSaturday$1 = utcWeekday$1(6);
utcSunday$1.range;
utcMonday$1.range;
utcTuesday$1.range;
utcWednesday$1.range;
utcThursday$1.range;
utcFriday$1.range;
utcSaturday$1.range;

var utcMonth$1 = newInterval$1(function (date) {
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
}, function (date, step) {
  date.setUTCMonth(date.getUTCMonth() + step);
}, function (start, end) {
  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function (date) {
  return date.getUTCMonth();
});
var utcMonth$2 = utcMonth$1;
utcMonth$1.range;

var utcYear$1 = newInterval$1(function (date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, function (date, step) {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, function (start, end) {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, function (date) {
  return date.getUTCFullYear();
});

// An optimized implementation for this simple case.
utcYear$1.every = function (k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval$1(function (date) {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function (date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};
var utcYear$2 = utcYear$1;
utcYear$1.range;

function ticker(year, month, week, day, hour, minute) {
  var tickIntervals = [[utcSecond, 1, durationSecond$1], [utcSecond, 5, 5 * durationSecond$1], [utcSecond, 15, 15 * durationSecond$1], [utcSecond, 30, 30 * durationSecond$1], [minute, 1, durationMinute$1], [minute, 5, 5 * durationMinute$1], [minute, 15, 15 * durationMinute$1], [minute, 30, 30 * durationMinute$1], [hour, 1, durationHour$1], [hour, 3, 3 * durationHour$1], [hour, 6, 6 * durationHour$1], [hour, 12, 12 * durationHour$1], [day, 1, durationDay], [day, 2, 2 * durationDay], [week, 1, durationWeek$1], [month, 1, durationMonth], [month, 3, 3 * durationMonth], [year, 1, durationYear]];
  function ticks(start, stop, count) {
    var reverse = stop < start;
    if (reverse) {
      var _ref = [stop, start];
      start = _ref[0];
      stop = _ref[1];
    }
    var interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
    var ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
    return reverse ? ticks.reverse() : ticks;
  }
  function tickInterval(start, stop, count) {
    var target = Math.abs(stop - start) / count;
    var i = bisector(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 3),
        step = _ref3[2];
      return step;
    }).right(tickIntervals, target);
    if (i === tickIntervals.length) return year.every(tickStep(start / durationYear, stop / durationYear, count));
    if (i === 0) return millisecond$1.every(Math.max(tickStep(start, stop, count), 1));
    var _tickIntervals = _slicedToArray(tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i], 2),
      t = _tickIntervals[0],
      step = _tickIntervals[1];
    return t.every(step);
  }
  return [ticks, tickInterval];
}
var _ticker = ticker(utcYear$2, utcMonth$2, utcSunday$1, utcDay, utcHour$2, utcMinute$2),
  _ticker2 = _slicedToArray(_ticker, 2),
  utcTicks = _ticker2[0],
  utcTickInterval = _ticker2[1];
var _ticker3 = ticker(timeYear, timeMonth, sunday$1, day, timeHour, timeMinute),
  _ticker4 = _slicedToArray(_ticker3, 2),
  timeTicks = _ticker4[0],
  timeTickInterval = _ticker4[1];

function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function newDate(y, m, d) {
  return {
    y: y,
    m: m,
    d: d,
    H: 0,
    M: 0,
    S: 0,
    L: 0
  };
}
function formatLocale$1(locale) {
  var locale_dateTime = locale.dateTime,
    locale_date = locale.date,
    locale_time = locale.time,
    locale_periods = locale.periods,
    locale_weekdays = locale.days,
    locale_shortWeekdays = locale.shortDays,
    locale_months = locale.months,
    locale_shortMonths = locale.shortMonths;
  var periodRe = formatRe(locale_periods),
    periodLookup = formatLookup(locale_periods),
    weekdayRe = formatRe(locale_weekdays),
    weekdayLookup = formatLookup(locale_weekdays),
    shortWeekdayRe = formatRe(locale_shortWeekdays),
    shortWeekdayLookup = formatLookup(locale_shortWeekdays),
    monthRe = formatRe(locale_months),
    monthLookup = formatLookup(locale_months),
    shortMonthRe = formatRe(locale_shortMonths),
    shortMonthLookup = formatLookup(locale_shortMonths);
  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "f": formatMicroseconds,
    "g": formatYearISO,
    "G": formatFullYearISO,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "q": formatQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatSeconds,
    "u": formatWeekdayNumberMonday,
    "U": formatWeekNumberSunday,
    "V": formatWeekNumberISO,
    "w": formatWeekdayNumberSunday,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };
  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "f": formatUTCMicroseconds,
    "g": formatUTCYearISO,
    "G": formatUTCFullYearISO,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "q": formatUTCQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatUTCSeconds,
    "u": formatUTCWeekdayNumberMonday,
    "U": formatUTCWeekNumberSunday,
    "V": formatUTCWeekNumberISO,
    "w": formatUTCWeekdayNumberSunday,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };
  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "f": parseMicroseconds,
    "g": parseYear,
    "G": parseFullYear,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "q": parseQuarter,
    "Q": parseUnixTimestamp,
    "s": parseUnixTimestampSeconds,
    "S": parseSeconds,
    "u": parseWeekdayNumberMonday,
    "U": parseWeekNumberSunday,
    "V": parseWeekNumberISO,
    "w": parseWeekdayNumberSunday,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };

  // These recursive directive definitions must be deferred.
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);
  function newFormat(specifier, formats) {
    return function (date) {
      var string = [],
        i = -1,
        j = 0,
        n = specifier.length,
        c,
        pad,
        format;
      if (!(date instanceof Date)) date = new Date(+date);
      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);else pad = c === "e" ? " " : "0";
          if (format = formats[c]) c = format(date, pad);
          string.push(c);
          j = i + 1;
        }
      }
      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }
  function newParse(specifier, Z) {
    return function (string) {
      var d = newDate(1900, undefined, 1),
        i = parseSpecifier(d, specifier, string += "", 0),
        week,
        day$1;
      if (i != string.length) return null;

      // If a UNIX timestamp is specified, return it.
      if ("Q" in d) return new Date(d.Q);
      if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));

      // If this is utcParse, never use the local timezone.
      if (Z && !("Z" in d)) d.Z = 0;

      // The am-pm flag is 0 for AM, and 1 for PM.
      if ("p" in d) d.H = d.H % 12 + d.p * 12;

      // If the month was not specified, inherit from the quarter.
      if (d.m === undefined) d.m = "q" in d ? d.q : 0;

      // Convert day-of-week and week-of-year to day-of-year.
      if ("V" in d) {
        if (d.V < 1 || d.V > 53) return null;
        if (!("w" in d)) d.w = 1;
        if ("Z" in d) {
          week = utcDate(newDate(d.y, 0, 1)), day$1 = week.getUTCDay();
          week = day$1 > 4 || day$1 === 0 ? utcMonday$1.ceil(week) : utcMonday$1(week);
          week = utcDay.offset(week, (d.V - 1) * 7);
          d.y = week.getUTCFullYear();
          d.m = week.getUTCMonth();
          d.d = week.getUTCDate() + (d.w + 6) % 7;
        } else {
          week = localDate(newDate(d.y, 0, 1)), day$1 = week.getDay();
          week = day$1 > 4 || day$1 === 0 ? monday$1.ceil(week) : monday$1(week);
          week = day.offset(week, (d.V - 1) * 7);
          d.y = week.getFullYear();
          d.m = week.getMonth();
          d.d = week.getDate() + (d.w + 6) % 7;
        }
      } else if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
        day$1 = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day$1 + 5) % 7 : d.w + d.U * 7 - (day$1 + 6) % 7;
      }

      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }

      // Otherwise, all fields are in local time.
      return localDate(d);
    };
  }
  function parseSpecifier(d, specifier, string, j) {
    var i = 0,
      n = specifier.length,
      m = string.length,
      c,
      parse;
    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse = parses[c in pads ? specifier.charAt(i++) : c];
        if (!parse || (j = parse(d, string, j)) < 0) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }
    return j;
  }
  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }
  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }
  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }
  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }
  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }
  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }
  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }
  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }
  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }
  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }
  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }
  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }
  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }
  function formatQuarter(d) {
    return 1 + ~~(d.getMonth() / 3);
  }
  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }
  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }
  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }
  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }
  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }
  function formatUTCQuarter(d) {
    return 1 + ~~(d.getUTCMonth() / 3);
  }
  return {
    format: function format(specifier) {
      var f = newFormat(specifier += "", formats);
      f.toString = function () {
        return specifier;
      };
      return f;
    },
    parse: function parse(specifier) {
      var p = newParse(specifier += "", false);
      p.toString = function () {
        return specifier;
      };
      return p;
    },
    utcFormat: function utcFormat(specifier) {
      var f = newFormat(specifier += "", utcFormats);
      f.toString = function () {
        return specifier;
      };
      return f;
    },
    utcParse: function utcParse(specifier) {
      var p = newParse(specifier += "", true);
      p.toString = function () {
        return specifier;
      };
      return p;
    }
  };
}
var pads = {
    "-": "",
    "_": " ",
    "0": "0"
  },
  numberRe = /^\s*\d+/,
  // note: ignores next directive
  percentRe = /^%/,
  requoteRe = /[\\^$*+?|[\]().{}]/g;
function pad(value, fill, width) {
  var sign = value < 0 ? "-" : "",
    string = (sign ? -value : value) + "",
    length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function requote(s) {
  return s.replace(requoteRe, "\\$&");
}
function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}
function formatLookup(names) {
  return new Map(names.map(function (name, i) {
    return [name.toLowerCase(), i];
  }));
}
function parseWeekdayNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function parseWeekdayNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberISO(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function parseYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function parseQuarter(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function parseMicroseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 6));
  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}
function parseUnixTimestamp(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function parseUnixTimestampSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function formatDayOfMonth(d, p) {
  return pad(d.getDate(), p, 2);
}
function formatHour24(d, p) {
  return pad(d.getHours(), p, 2);
}
function formatHour12(d, p) {
  return pad(d.getHours() % 12 || 12, p, 2);
}
function formatDayOfYear(d, p) {
  return pad(1 + day.count(timeYear(d), d), p, 3);
}
function formatMilliseconds(d, p) {
  return pad(d.getMilliseconds(), p, 3);
}
function formatMicroseconds(d, p) {
  return formatMilliseconds(d, p) + "000";
}
function formatMonthNumber(d, p) {
  return pad(d.getMonth() + 1, p, 2);
}
function formatMinutes(d, p) {
  return pad(d.getMinutes(), p, 2);
}
function formatSeconds(d, p) {
  return pad(d.getSeconds(), p, 2);
}
function formatWeekdayNumberMonday(d) {
  var day = d.getDay();
  return day === 0 ? 7 : day;
}
function formatWeekNumberSunday(d, p) {
  return pad(sunday$1.count(timeYear(d) - 1, d), p, 2);
}
function dISO(d) {
  var day = d.getDay();
  return day >= 4 || day === 0 ? thursday$1(d) : thursday$1.ceil(d);
}
function formatWeekNumberISO(d, p) {
  d = dISO(d);
  return pad(thursday$1.count(timeYear(d), d) + (timeYear(d).getDay() === 4), p, 2);
}
function formatWeekdayNumberSunday(d) {
  return d.getDay();
}
function formatWeekNumberMonday(d, p) {
  return pad(monday$1.count(timeYear(d) - 1, d), p, 2);
}
function formatYear(d, p) {
  return pad(d.getFullYear() % 100, p, 2);
}
function formatYearISO(d, p) {
  d = dISO(d);
  return pad(d.getFullYear() % 100, p, 2);
}
function formatFullYear(d, p) {
  return pad(d.getFullYear() % 10000, p, 4);
}
function formatFullYearISO(d, p) {
  var day = d.getDay();
  d = day >= 4 || day === 0 ? thursday$1(d) : thursday$1.ceil(d);
  return pad(d.getFullYear() % 10000, p, 4);
}
function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+")) + pad(z / 60 | 0, "0", 2) + pad(z % 60, "0", 2);
}
function formatUTCDayOfMonth(d, p) {
  return pad(d.getUTCDate(), p, 2);
}
function formatUTCHour24(d, p) {
  return pad(d.getUTCHours(), p, 2);
}
function formatUTCHour12(d, p) {
  return pad(d.getUTCHours() % 12 || 12, p, 2);
}
function formatUTCDayOfYear(d, p) {
  return pad(1 + utcDay.count(utcYear$2(d), d), p, 3);
}
function formatUTCMilliseconds(d, p) {
  return pad(d.getUTCMilliseconds(), p, 3);
}
function formatUTCMicroseconds(d, p) {
  return formatUTCMilliseconds(d, p) + "000";
}
function formatUTCMonthNumber(d, p) {
  return pad(d.getUTCMonth() + 1, p, 2);
}
function formatUTCMinutes(d, p) {
  return pad(d.getUTCMinutes(), p, 2);
}
function formatUTCSeconds(d, p) {
  return pad(d.getUTCSeconds(), p, 2);
}
function formatUTCWeekdayNumberMonday(d) {
  var dow = d.getUTCDay();
  return dow === 0 ? 7 : dow;
}
function formatUTCWeekNumberSunday(d, p) {
  return pad(utcSunday$1.count(utcYear$2(d) - 1, d), p, 2);
}
function UTCdISO(d) {
  var day = d.getUTCDay();
  return day >= 4 || day === 0 ? utcThursday$1(d) : utcThursday$1.ceil(d);
}
function formatUTCWeekNumberISO(d, p) {
  d = UTCdISO(d);
  return pad(utcThursday$1.count(utcYear$2(d), d) + (utcYear$2(d).getUTCDay() === 4), p, 2);
}
function formatUTCWeekdayNumberSunday(d) {
  return d.getUTCDay();
}
function formatUTCWeekNumberMonday(d, p) {
  return pad(utcMonday$1.count(utcYear$2(d) - 1, d), p, 2);
}
function formatUTCYear(d, p) {
  return pad(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCYearISO(d, p) {
  d = UTCdISO(d);
  return pad(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCFullYear(d, p) {
  return pad(d.getUTCFullYear() % 10000, p, 4);
}
function formatUTCFullYearISO(d, p) {
  var day = d.getUTCDay();
  d = day >= 4 || day === 0 ? utcThursday$1(d) : utcThursday$1.ceil(d);
  return pad(d.getUTCFullYear() % 10000, p, 4);
}
function formatUTCZone() {
  return "+0000";
}
function formatLiteralPercent() {
  return "%";
}
function formatUnixTimestamp(d) {
  return +d;
}
function formatUnixTimestampSeconds(d) {
  return Math.floor(+d / 1000);
}

var locale$1;
var timeFormat;
var timeParse;
var utcFormat;
var utcParse;
defaultLocale$1({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function defaultLocale$1(definition) {
  locale$1 = formatLocale$1(definition);
  timeFormat = locale$1.format;
  timeParse = locale$1.parse;
  utcFormat = locale$1.utcFormat;
  utcParse = locale$1.utcParse;
  return locale$1;
}

function date(t) {
  return new Date(t);
}
function number(t) {
  return t instanceof Date ? +t : +new Date(+t);
}
function calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
  var scale = continuous(),
    invert = scale.invert,
    domain = scale.domain;
  var formatMillisecond = format(".%L"),
    formatSecond = format(":%S"),
    formatMinute = format("%I:%M"),
    formatHour = format("%I %p"),
    formatDay = format("%a %d"),
    formatWeek = format("%b %d"),
    formatMonth = format("%B"),
    formatYear = format("%Y");
  function tickFormat(date) {
    return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
  }
  scale.invert = function (y) {
    return new Date(invert(y));
  };
  scale.domain = function (_) {
    return arguments.length ? domain(Array.from(_, number)) : domain().map(date);
  };
  scale.ticks = function (interval) {
    var d = domain();
    return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
  };
  scale.tickFormat = function (count, specifier) {
    return specifier == null ? tickFormat : format(specifier);
  };
  scale.nice = function (interval) {
    var d = domain();
    if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
    return interval ? domain(nice(d, interval)) : scale;
  };
  scale.copy = function () {
    return copy(scale, calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
  };
  return scale;
}
function time() {
  return initRange.apply(calendar(timeTicks, timeTickInterval, timeYear, timeMonth, sunday$1, day, timeHour, timeMinute, utcSecond, timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]), arguments);
}

function utcTime() {
  return initRange.apply(calendar(utcTicks, utcTickInterval, utcYear$2, utcMonth$2, utcSunday$1, utcDay, utcHour$2, utcMinute$2, utcSecond, utcFormat).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]), arguments);
}

function colors$1 (specifier) {
  var n = specifier.length / 6 | 0,
    colors = new Array(n),
    i = 0;
  while (i < n) colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
  return colors;
}

var ae$2 = colors$1("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");

var le$2 = colors$1("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666");

var se$2 = colors$1("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666");

var de$2 = colors$1("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928");

var ue$2 = colors$1("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2");

var ce$2 = colors$1("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc");

var fe$2 = colors$1("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999");

var pe$2 = colors$1("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3");

var he$2 = colors$1("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");

function basis(t1, v0, v1, v2, v3) {
  var t2 = t1 * t1,
    t3 = t2 * t1;
  return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function basis$1 (values) {
  var n = values.length - 1;
  return function (t) {
    var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
      v1 = values[i],
      v2 = values[i + 1],
      v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
      v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
}

var constant$1 = (function (x) {
  return function () {
    return x;
  };
});

function linear(a, d) {
  return function (t) {
    return a + t * d;
  };
}
function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function (t) {
    return Math.pow(a + t * b, y);
  };
}
function gamma(y) {
  return (y = +y) === 1 ? nogamma : function (a, b) {
    return b - a ? exponential(a, b, y) : constant$1(isNaN(a) ? b : a);
  };
}
function nogamma(a, b) {
  var d = b - a;
  return d ? linear(a, d) : constant$1(isNaN(a) ? b : a);
}

((function rgbGamma(y) {
  var color = gamma(y);
  function rgb(start, end) {
    var r = color((start = rgb$3(start)).r, (end = rgb$3(end)).r),
      g = color(start.g, end.g),
      b = color(start.b, end.b),
      opacity = nogamma(start.opacity, end.opacity);
    return function (t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
  rgb.gamma = rgbGamma;
  return rgb;
}))(1);
function rgbSpline(spline) {
  return function (colors) {
    var n = colors.length,
      r = new Array(n),
      g = new Array(n),
      b = new Array(n),
      i,
      color;
    for (i = 0; i < n; ++i) {
      color = rgb$3(colors[i]);
      r[i] = color.r || 0;
      g[i] = color.g || 0;
      b[i] = color.b || 0;
    }
    r = spline(r);
    g = spline(g);
    b = spline(b);
    color.opacity = 1;
    return function (t) {
      color.r = r(t);
      color.g = g(t);
      color.b = b(t);
      return color + "";
    };
  };
}
var rgbBasis = rgbSpline(basis$1);

var ramp$2 = (function (scheme) {
  return rgbBasis(scheme[scheme.length - 1]);
});

var scheme$R = new Array(3).concat("d8b365f5f5f55ab4ac", "a6611adfc27d80cdc1018571", "a6611adfc27df5f5f580cdc1018571", "8c510ad8b365f6e8c3c7eae55ab4ac01665e", "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e", "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e", "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e", "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30", "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30").map(colors$1);
ramp$2(scheme$R);

var scheme$Q = new Array(3).concat("af8dc3f7f7f77fbf7b", "7b3294c2a5cfa6dba0008837", "7b3294c2a5cff7f7f7a6dba0008837", "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837", "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837", "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837", "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837", "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b", "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b").map(colors$1);
ramp$2(scheme$Q);

var scheme$P = new Array(3).concat("e9a3c9f7f7f7a1d76a", "d01c8bf1b6dab8e1864dac26", "d01c8bf1b6daf7f7f7b8e1864dac26", "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221", "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221", "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221", "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221", "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419", "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419").map(colors$1);
ramp$2(scheme$P);

var scheme$O = new Array(3).concat("998ec3f7f7f7f1a340", "5e3c99b2abd2fdb863e66101", "5e3c99b2abd2f7f7f7fdb863e66101", "542788998ec3d8daebfee0b6f1a340b35806", "542788998ec3d8daebf7f7f7fee0b6f1a340b35806", "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806", "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806", "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08", "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08").map(colors$1);
ramp$2(scheme$O);

var scheme$N = new Array(3).concat("ef8a62f7f7f767a9cf", "ca0020f4a58292c5de0571b0", "ca0020f4a582f7f7f792c5de0571b0", "b2182bef8a62fddbc7d1e5f067a9cf2166ac", "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac", "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac", "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac", "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061", "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061").map(colors$1);
ramp$2(scheme$N);

var scheme$M = new Array(3).concat("ef8a62ffffff999999", "ca0020f4a582bababa404040", "ca0020f4a582ffffffbababa404040", "b2182bef8a62fddbc7e0e0e09999994d4d4d", "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d", "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d", "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d", "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a", "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a").map(colors$1);
ramp$2(scheme$M);

var scheme$L = new Array(3).concat("fc8d59ffffbf91bfdb", "d7191cfdae61abd9e92c7bb6", "d7191cfdae61ffffbfabd9e92c7bb6", "d73027fc8d59fee090e0f3f891bfdb4575b4", "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4", "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4", "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4", "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695", "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695").map(colors$1);
ramp$2(scheme$L);

var scheme$K = new Array(3).concat("fc8d59ffffbf91cf60", "d7191cfdae61a6d96a1a9641", "d7191cfdae61ffffbfa6d96a1a9641", "d73027fc8d59fee08bd9ef8b91cf601a9850", "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850", "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850", "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850", "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837", "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837").map(colors$1);
ramp$2(scheme$K);

var scheme$J = new Array(3).concat("fc8d59ffffbf99d594", "d7191cfdae61abdda42b83ba", "d7191cfdae61ffffbfabdda42b83ba", "d53e4ffc8d59fee08be6f59899d5943288bd", "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd", "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd", "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd", "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2", "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2").map(colors$1);
ramp$2(scheme$J);

var scheme$I = new Array(3).concat("e5f5f999d8c92ca25f", "edf8fbb2e2e266c2a4238b45", "edf8fbb2e2e266c2a42ca25f006d2c", "edf8fbccece699d8c966c2a42ca25f006d2c", "edf8fbccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b").map(colors$1);
ramp$2(scheme$I);

var scheme$H = new Array(3).concat("e0ecf49ebcda8856a7", "edf8fbb3cde38c96c688419d", "edf8fbb3cde38c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b").map(colors$1);
ramp$2(scheme$H);

var scheme$G = new Array(3).concat("e0f3dba8ddb543a2ca", "f0f9e8bae4bc7bccc42b8cbe", "f0f9e8bae4bc7bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081").map(colors$1);
ramp$2(scheme$G);

var scheme$F = new Array(3).concat("fee8c8fdbb84e34a33", "fef0d9fdcc8afc8d59d7301f", "fef0d9fdcc8afc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000").map(colors$1);
ramp$2(scheme$F);

var scheme$E = new Array(3).concat("ece2f0a6bddb1c9099", "f6eff7bdc9e167a9cf02818a", "f6eff7bdc9e167a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636").map(colors$1);
ramp$2(scheme$E);

var scheme$D = new Array(3).concat("ece7f2a6bddb2b8cbe", "f1eef6bdc9e174a9cf0570b0", "f1eef6bdc9e174a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858").map(colors$1);
ramp$2(scheme$D);

var scheme$C = new Array(3).concat("e7e1efc994c7dd1c77", "f1eef6d7b5d8df65b0ce1256", "f1eef6d7b5d8df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f").map(colors$1);
ramp$2(scheme$C);

var scheme$B = new Array(3).concat("fde0ddfa9fb5c51b8a", "feebe2fbb4b9f768a1ae017e", "feebe2fbb4b9f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a").map(colors$1);
ramp$2(scheme$B);

var scheme$A = new Array(3).concat("edf8b17fcdbb2c7fb8", "ffffcca1dab441b6c4225ea8", "ffffcca1dab441b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58").map(colors$1);
ramp$2(scheme$A);

var scheme$z = new Array(3).concat("f7fcb9addd8e31a354", "ffffccc2e69978c679238443", "ffffccc2e69978c67931a354006837", "ffffccd9f0a3addd8e78c67931a354006837", "ffffccd9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529").map(colors$1);
ramp$2(scheme$z);

var scheme$y = new Array(3).concat("fff7bcfec44fd95f0e", "ffffd4fed98efe9929cc4c02", "ffffd4fed98efe9929d95f0e993404", "ffffd4fee391fec44ffe9929d95f0e993404", "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506").map(colors$1);
ramp$2(scheme$y);

var scheme$x = new Array(3).concat("ffeda0feb24cf03b20", "ffffb2fecc5cfd8d3ce31a1c", "ffffb2fecc5cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026").map(colors$1);
ramp$2(scheme$x);

var scheme$w = new Array(3).concat("deebf79ecae13182bd", "eff3ffbdd7e76baed62171b5", "eff3ffbdd7e76baed63182bd08519c", "eff3ffc6dbef9ecae16baed63182bd08519c", "eff3ffc6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b").map(colors$1);
ramp$2(scheme$w);

var scheme$v = new Array(3).concat("e5f5e0a1d99b31a354", "edf8e9bae4b374c476238b45", "edf8e9bae4b374c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b").map(colors$1);
ramp$2(scheme$v);

var scheme$u = new Array(3).concat("f0f0f0bdbdbd636363", "f7f7f7cccccc969696525252", "f7f7f7cccccc969696636363252525", "f7f7f7d9d9d9bdbdbd969696636363252525", "f7f7f7d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000").map(colors$1);
ramp$2(scheme$u);

var scheme$t = new Array(3).concat("efedf5bcbddc756bb1", "f2f0f7cbc9e29e9ac86a51a3", "f2f0f7cbc9e29e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d").map(colors$1);
ramp$2(scheme$t);

var scheme$s = new Array(3).concat("fee0d2fc9272de2d26", "fee5d9fcae91fb6a4acb181d", "fee5d9fcae91fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d").map(colors$1);
ramp$2(scheme$s);

var scheme$r = new Array(3).concat("fee6cefdae6be6550d", "feeddefdbe85fd8d3cd94701", "feeddefdbe85fd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704").map(colors$1);
ramp$2(scheme$r);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd$1(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}
var _setCacheAdd = setCacheAdd$1;

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas$1(value) {
  return this.__data__.has(value);
}
var _setCacheHas = setCacheHas$1;

var MapCache = _MapCache,
  setCacheAdd = _setCacheAdd,
  setCacheHas = _setCacheHas;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache$3(values) {
  var index = -1,
    length = values == null ? 0 : values.length;
  this.__data__ = new MapCache();
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache$3.prototype.add = SetCache$3.prototype.push = setCacheAdd;
SetCache$3.prototype.has = setCacheHas;
var _SetCache = SetCache$3;

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex$1(array, predicate, fromIndex, fromRight) {
  var length = array.length,
    index = fromIndex + (fromRight ? 1 : -1);
  while (fromRight ? index-- : ++index < length) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}
var _baseFindIndex = baseFindIndex$1;

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN$1(value) {
  return value !== value;
}
var _baseIsNaN = baseIsNaN$1;

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf$1(array, value, fromIndex) {
  var index = fromIndex - 1,
    length = array.length;
  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}
var _strictIndexOf = strictIndexOf$1;

var baseFindIndex = _baseFindIndex,
  baseIsNaN = _baseIsNaN,
  strictIndexOf = _strictIndexOf;

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf$1(array, value, fromIndex) {
  return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
}
var _baseIndexOf = baseIndexOf$1;

var baseIndexOf = _baseIndexOf;

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes$2(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}
var _arrayIncludes = arrayIncludes$2;

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith$2(array, value, comparator) {
  var index = -1,
    length = array == null ? 0 : array.length;
  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}
var _arrayIncludesWith = arrayIncludesWith$2;

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas$3(cache, key) {
  return cache.has(key);
}
var _cacheHas = cacheHas$3;

var SetCache$2 = _SetCache,
  arrayIncludes$1 = _arrayIncludes,
  arrayIncludesWith$1 = _arrayIncludesWith,
  arrayMap$1 = _arrayMap,
  baseUnary$2 = _baseUnary,
  cacheHas$2 = _cacheHas;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE$1 = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference$1(array, values, iteratee, comparator) {
  var index = -1,
    includes = arrayIncludes$1,
    isCommon = true,
    length = array.length,
    result = [],
    valuesLength = values.length;
  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap$1(values, baseUnary$2(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith$1;
    isCommon = false;
  } else if (values.length >= LARGE_ARRAY_SIZE$1) {
    includes = cacheHas$2;
    isCommon = false;
    values = new SetCache$2(values);
  }
  outer: while (++index < length) {
    var value = array[index],
      computed = iteratee == null ? value : iteratee(value);
    value = comparator || value !== 0 ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    } else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}
var _baseDifference = baseDifference$1;

var baseDifference = _baseDifference,
  baseRest$1 = _baseRest,
  isArrayLikeObject = isArrayLikeObject_1;

/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */
var without = baseRest$1(function (array, values) {
  return isArrayLikeObject(array) ? baseDifference(array, values) : [];
});
var without_1 = without;
var Ze = /*@__PURE__*/getDefaultExportFromCjs$1(without_1);

var pi$1 = Math.PI,
  tau$2 = 2 * pi$1,
  epsilon$2 = 1e-6,
  tauEpsilon = tau$2 - epsilon$2;
function Path$1() {
  this._x0 = this._y0 =
  // start of current subpath
  this._x1 = this._y1 = null; // end of current subpath
  this._ = "";
}
function path() {
  return new Path$1();
}
Path$1.prototype = path.prototype = {
  constructor: Path$1,
  moveTo: function moveTo(x, y) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
  },
  closePath: function closePath() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._ += "Z";
    }
  },
  lineTo: function lineTo(x, y) {
    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  quadraticCurveTo: function quadraticCurveTo(x1, y1, x, y) {
    this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  bezierCurveTo: function bezierCurveTo(x1, y1, x2, y2, x, y) {
    this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  arcTo: function arcTo(x1, y1, x2, y2, r) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
    var x0 = this._x1,
      y0 = this._y1,
      x21 = x2 - x1,
      y21 = y2 - y1,
      x01 = x0 - x1,
      y01 = y0 - y1,
      l01_2 = x01 * x01 + y01 * y01;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x1,y1).
    if (this._x1 === null) {
      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
    else if (!(l01_2 > epsilon$2)) ;

    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
    // Equivalently, is (x1,y1) coincident with (x2,y2)?
    // Or, is the radius zero? Line to (x1,y1).
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon$2) || !r) {
      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Otherwise, draw an arc!
    else {
      var x20 = x2 - x0,
        y20 = y2 - y0,
        l21_2 = x21 * x21 + y21 * y21,
        l20_2 = x20 * x20 + y20 * y20,
        l21 = Math.sqrt(l21_2),
        l01 = Math.sqrt(l01_2),
        l = r * Math.tan((pi$1 - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
        t01 = l / l01,
        t21 = l / l21;

      // If the start tangent is not coincident with (x0,y0), line to.
      if (Math.abs(t01 - 1) > epsilon$2) {
        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
      }
      this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
    }
  },
  arc: function arc(x, y, r, a0, a1, ccw) {
    x = +x, y = +y, r = +r, ccw = !!ccw;
    var dx = r * Math.cos(a0),
      dy = r * Math.sin(a0),
      x0 = x + dx,
      y0 = y + dy,
      cw = 1 ^ ccw,
      da = ccw ? a0 - a1 : a1 - a0;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x0,y0).
    if (this._x1 === null) {
      this._ += "M" + x0 + "," + y0;
    }

    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
    else if (Math.abs(this._x1 - x0) > epsilon$2 || Math.abs(this._y1 - y0) > epsilon$2) {
      this._ += "L" + x0 + "," + y0;
    }

    // Is this arc empty? We’re done.
    if (!r) return;

    // Does the angle go the wrong way? Flip the direction.
    if (da < 0) da = da % tau$2 + tau$2;

    // Is this a complete circle? Draw two arcs to complete the circle.
    if (da > tauEpsilon) {
      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
    }

    // Is this arc non-empty? Draw an arc!
    else if (da > epsilon$2) {
      this._ += "A" + r + "," + r + ",0," + +(da >= pi$1) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    }
  },
  rect: function rect(x, y, w, h) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
  },
  toString: function toString() {
    return this._;
  }
};

function constant (x) {
  return function constant() {
    return x;
  };
}

var abs = Math.abs;
var atan2 = Math.atan2;
var cos = Math.cos;
var max = Math.max;
var min = Math.min;
var sin = Math.sin;
var sqrt = Math.sqrt;
var epsilon$1 = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var tau$1 = 2 * pi;
function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}
function asin(x) {
  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
}

function arcInnerRadius(d) {
  return d.innerRadius;
}
function arcOuterRadius(d) {
  return d.outerRadius;
}
function arcStartAngle(d) {
  return d.startAngle;
}
function arcEndAngle(d) {
  return d.endAngle;
}
function arcPadAngle(d) {
  return d && d.padAngle; // Note: optional!
}
function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
  var x10 = x1 - x0,
    y10 = y1 - y0,
    x32 = x3 - x2,
    y32 = y3 - y2,
    t = y32 * x10 - x32 * y10;
  if (t * t < epsilon$1) return;
  t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
  return [x0 + t * x10, y0 + t * y10];
}

// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
  var x01 = x0 - x1,
    y01 = y0 - y1,
    lo = (cw ? rc : -rc) / sqrt(x01 * x01 + y01 * y01),
    ox = lo * y01,
    oy = -lo * x01,
    x11 = x0 + ox,
    y11 = y0 + oy,
    x10 = x1 + ox,
    y10 = y1 + oy,
    x00 = (x11 + x10) / 2,
    y00 = (y11 + y10) / 2,
    dx = x10 - x11,
    dy = y10 - y11,
    d2 = dx * dx + dy * dy,
    r = r1 - rc,
    D = x11 * y10 - x10 * y11,
    d = (dy < 0 ? -1 : 1) * sqrt(max(0, r * r * d2 - D * D)),
    cx0 = (D * dy - dx * d) / d2,
    cy0 = (-D * dx - dy * d) / d2,
    cx1 = (D * dy + dx * d) / d2,
    cy1 = (-D * dx + dy * d) / d2,
    dx0 = cx0 - x00,
    dy0 = cy0 - y00,
    dx1 = cx1 - x00,
    dy1 = cy1 - y00;

  // Pick the closer of the two intersection points.
  // TODO Is there a faster way to determine which intersection to use?
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r - 1),
    y11: cy0 * (r1 / r - 1)
  };
}
function y$2 () {
  var innerRadius = arcInnerRadius,
    outerRadius = arcOuterRadius,
    cornerRadius = constant(0),
    padRadius = null,
    startAngle = arcStartAngle,
    endAngle = arcEndAngle,
    padAngle = arcPadAngle,
    context = null;
  function arc() {
    var buffer,
      r,
      r0 = +innerRadius.apply(this, arguments),
      r1 = +outerRadius.apply(this, arguments),
      a0 = startAngle.apply(this, arguments) - halfPi,
      a1 = endAngle.apply(this, arguments) - halfPi,
      da = abs(a1 - a0),
      cw = a1 > a0;
    if (!context) context = buffer = path();

    // Ensure that the outer radius is always larger than the inner radius.
    if (r1 < r0) r = r1, r1 = r0, r0 = r;

    // Is it a point?
    if (!(r1 > epsilon$1)) context.moveTo(0, 0);

    // Or is it a circle or annulus?
    else if (da > tau$1 - epsilon$1) {
      context.moveTo(r1 * cos(a0), r1 * sin(a0));
      context.arc(0, 0, r1, a0, a1, !cw);
      if (r0 > epsilon$1) {
        context.moveTo(r0 * cos(a1), r0 * sin(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    }

    // Or is it a circular or annular sector?
    else {
      var a01 = a0,
        a11 = a1,
        a00 = a0,
        a10 = a1,
        da0 = da,
        da1 = da,
        ap = padAngle.apply(this, arguments) / 2,
        rp = ap > epsilon$1 && (padRadius ? +padRadius.apply(this, arguments) : sqrt(r0 * r0 + r1 * r1)),
        rc = min(abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
        rc0 = rc,
        rc1 = rc,
        t0,
        t1;

      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
      if (rp > epsilon$1) {
        var p0 = asin(rp / r0 * sin(ap)),
          p1 = asin(rp / r1 * sin(ap));
        if ((da0 -= p0 * 2) > epsilon$1) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;else da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > epsilon$1) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;else da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }
      var x01 = r1 * cos(a01),
        y01 = r1 * sin(a01),
        x10 = r0 * cos(a10),
        y10 = r0 * sin(a10);

      // Apply rounded corners?
      if (rc > epsilon$1) {
        var x11 = r1 * cos(a11),
          y11 = r1 * sin(a11),
          x00 = r0 * cos(a00),
          y00 = r0 * sin(a00),
          oc;

        // Restrict the corner radius according to the sector angle.
        if (da < pi && (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
          var ax = x01 - oc[0],
            ay = y01 - oc[1],
            bx = x11 - oc[0],
            by = y11 - oc[1],
            kc = 1 / sin(acos((ax * bx + ay * by) / (sqrt(ax * ax + ay * ay) * sqrt(bx * bx + by * by))) / 2),
            lc = sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = min(rc, (r0 - lc) / (kc - 1));
          rc1 = min(rc, (r1 - lc) / (kc + 1));
        }
      }

      // Is the sector collapsed to a line?
      if (!(da1 > epsilon$1)) context.moveTo(x01, y01);

      // Does the sector’s outer ring have rounded corners?
      else if (rc1 > epsilon$1) {
        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r1, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
          context.arc(t1.cx, t1.cy, rc1, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the outer ring just a circular arc?
      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);

      // Is there no inner ring, and it’s a circular sector?
      // Or perhaps it’s an annular sector collapsed due to padding?
      if (!(r0 > epsilon$1) || !(da0 > epsilon$1)) context.lineTo(x10, y10);

      // Does the sector’s inner ring (or point) have rounded corners?
      else if (rc0 > epsilon$1) {
        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r0, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
          context.arc(t1.cx, t1.cy, rc0, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the inner ring just a circular arc?
      else context.arc(0, 0, r0, a10, a00, cw);
    }
    context.closePath();
    if (buffer) return context = null, buffer + "" || null;
  }
  arc.centroid = function () {
    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
      a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi / 2;
    return [cos(a) * r, sin(a) * r];
  };
  arc.innerRadius = function (_) {
    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant(+_), arc) : innerRadius;
  };
  arc.outerRadius = function (_) {
    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant(+_), arc) : outerRadius;
  };
  arc.cornerRadius = function (_) {
    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant(+_), arc) : cornerRadius;
  };
  arc.padRadius = function (_) {
    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant(+_), arc) : padRadius;
  };
  arc.startAngle = function (_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), arc) : startAngle;
  };
  arc.endAngle = function (_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), arc) : endAngle;
  };
  arc.padAngle = function (_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), arc) : padAngle;
  };
  arc.context = function (_) {
    return arguments.length ? (context = _ == null ? null : _, arc) : context;
  };
  return arc;
}

function Linear(context) {
  this._context = context;
}
Linear.prototype = {
  areaStart: function areaStart() {
    this._line = 0;
  },
  areaEnd: function areaEnd() {
    this._line = NaN;
  },
  lineStart: function lineStart() {
    this._point = 0;
  },
  lineEnd: function lineEnd() {
    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function point(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
        break;
      case 1:
        this._point = 2;
      // proceed
      default:
        this._context.lineTo(x, y);
        break;
    }
  }
};
function dr (context) {
  return new Linear(context);
}

function x$3(p) {
  return p[0];
}
function y$1(p) {
  return p[1];
}

function H$4 () {
  var x = x$3,
    y = y$1,
    defined = constant(true),
    context = null,
    curve = dr,
    output = null;
  function line(data) {
    var i,
      n = data.length,
      d,
      defined0 = false,
      buffer;
    if (context == null) output = curve(buffer = path());
    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) output.lineStart();else output.lineEnd();
      }
      if (defined0) output.point(+x(d, i, data), +y(d, i, data));
    }
    if (buffer) return output = null, buffer + "" || null;
  }
  line.x = function (_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : constant(+_), line) : x;
  };
  line.y = function (_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : constant(+_), line) : y;
  };
  line.defined = function (_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), line) : defined;
  };
  line.curve = function (_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
  };
  line.context = function (_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
  };
  return line;
}

function I$3 () {
  var x0 = x$3,
    x1 = null,
    y0 = constant(0),
    y1 = y$1,
    defined = constant(true),
    context = null,
    curve = dr,
    output = null;
  function area(data) {
    var i,
      j,
      k,
      n = data.length,
      d,
      defined0 = false,
      buffer,
      x0z = new Array(n),
      y0z = new Array(n);
    if (context == null) output = curve(buffer = path());
    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) {
          j = i;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k = i - 1; k >= j; --k) {
            output.point(x0z[k], y0z[k]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
      }
    }
    if (buffer) return output = null, buffer + "" || null;
  }
  function arealine() {
    return H$4().defined(defined).curve(curve).context(context);
  }
  area.x = function (_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), x1 = null, area) : x0;
  };
  area.x0 = function (_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), area) : x0;
  };
  area.x1 = function (_) {
    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : x1;
  };
  area.y = function (_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), y1 = null, area) : y0;
  };
  area.y0 = function (_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), area) : y0;
  };
  area.y1 = function (_) {
    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : y1;
  };
  area.lineX0 = area.lineY0 = function () {
    return arealine().x(x0).y(y0);
  };
  area.lineY1 = function () {
    return arealine().x(x0).y(y1);
  };
  area.lineX1 = function () {
    return arealine().x(x1).y(y0);
  };
  area.defined = function (_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), area) : defined;
  };
  area.curve = function (_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
  };
  area.context = function (_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
  };
  return area;
}

function descending (a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

function identity$3 (d) {
  return d;
}

function T$4 () {
  var value = identity$3,
    sortValues = descending,
    sort = null,
    startAngle = constant(0),
    endAngle = constant(tau$1),
    padAngle = constant(0);
  function pie(data) {
    var i,
      n = data.length,
      j,
      k,
      sum = 0,
      index = new Array(n),
      arcs = new Array(n),
      a0 = +startAngle.apply(this, arguments),
      da = Math.min(tau$1, Math.max(-tau$1, endAngle.apply(this, arguments) - a0)),
      a1,
      p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
      pa = p * (da < 0 ? -1 : 1),
      v;
    for (i = 0; i < n; ++i) {
      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
        sum += v;
      }
    }

    // Optionally sort the arcs by previously-computed values or by data.
    if (sortValues != null) index.sort(function (i, j) {
      return sortValues(arcs[i], arcs[j]);
    });else if (sort != null) index.sort(function (i, j) {
      return sort(data[i], data[j]);
    });

    // Compute the arcs! They are stored in the original data's order.
    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
        data: data[j],
        index: i,
        value: v,
        startAngle: a0,
        endAngle: a1,
        padAngle: p
      };
    }
    return arcs;
  }
  pie.value = function (_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), pie) : value;
  };
  pie.sortValues = function (_) {
    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
  };
  pie.sort = function (_) {
    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
  };
  pie.startAngle = function (_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), pie) : startAngle;
  };
  pie.endAngle = function (_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), pie) : endAngle;
  };
  pie.padAngle = function (_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), pie) : padAngle;
  };
  return pie;
}

function noop$3 () {}

function _point$3(that, x, y) {
  that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function Basis(context) {
  this._context = context;
}
Basis.prototype = {
  areaStart: function areaStart() {
    this._line = 0;
  },
  areaEnd: function areaEnd() {
    this._line = NaN;
  },
  lineStart: function lineStart() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function lineEnd() {
    switch (this._point) {
      case 3:
        _point$3(this, this._x1, this._y1);
      // proceed
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function point(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      // proceed
      default:
        _point$3(this, x, y);
        break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};
function $e$1 (context) {
  return new Basis(context);
}

function BasisClosed(context) {
  this._context = context;
}
BasisClosed.prototype = {
  areaStart: noop$3,
  areaEnd: noop$3,
  lineStart: function lineStart() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
    this._point = 0;
  },
  lineEnd: function lineEnd() {
    switch (this._point) {
      case 1:
        {
          this._context.moveTo(this._x2, this._y2);
          this._context.closePath();
          break;
        }
      case 2:
        {
          this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
          this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
          this._context.closePath();
          break;
        }
      case 3:
        {
          this.point(this._x2, this._y2);
          this.point(this._x3, this._y3);
          this.point(this._x4, this._y4);
          break;
        }
    }
  },
  point: function point(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._x2 = x, this._y2 = y;
        break;
      case 1:
        this._point = 2;
        this._x3 = x, this._y3 = y;
        break;
      case 2:
        this._point = 3;
        this._x4 = x, this._y4 = y;
        this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
        break;
      default:
        _point$3(this, x, y);
        break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};
function er (context) {
  return new BasisClosed(context);
}

function BasisOpen(context) {
  this._context = context;
}
BasisOpen.prototype = {
  areaStart: function areaStart() {
    this._line = 0;
  },
  areaEnd: function areaEnd() {
    this._line = NaN;
  },
  lineStart: function lineStart() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function lineEnd() {
    if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function point(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var x0 = (this._x0 + 4 * this._x1 + x) / 6,
          y0 = (this._y0 + 4 * this._y1 + y) / 6;
        this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
        break;
      case 3:
        this._point = 4;
      // proceed
      default:
        _point$3(this, x, y);
        break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};
function rr (context) {
  return new BasisOpen(context);
}

function Bundle(context, beta) {
  this._basis = new Basis(context);
  this._beta = beta;
}
Bundle.prototype = {
  lineStart: function lineStart() {
    this._x = [];
    this._y = [];
    this._basis.lineStart();
  },
  lineEnd: function lineEnd() {
    var x = this._x,
      y = this._y,
      j = x.length - 1;
    if (j > 0) {
      var x0 = x[0],
        y0 = y[0],
        dx = x[j] - x0,
        dy = y[j] - y0,
        i = -1,
        t;
      while (++i <= j) {
        t = i / j;
        this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
      }
    }
    this._x = this._y = null;
    this._basis.lineEnd();
  },
  point: function point(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};
var tr = (function custom(beta) {
  function bundle(context) {
    return beta === 1 ? new Basis(context) : new Bundle(context, beta);
  }
  bundle.beta = function (beta) {
    return custom(+beta);
  };
  return bundle;
})(0.85);

function _point$2(that, x, y) {
  that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function Cardinal(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}
Cardinal.prototype = {
  areaStart: function areaStart() {
    this._line = 0;
  },
  areaEnd: function areaEnd() {
    this._line = NaN;
  },
  lineStart: function lineStart() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function lineEnd() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        _point$2(this, this._x1, this._y1);
        break;
    }
    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function point(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
        break;
      case 1:
        this._point = 2;
        this._x1 = x, this._y1 = y;
        break;
      case 2:
        this._point = 3;
      // proceed
      default:
        _point$2(this, x, y);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};
var ir = (function custom(tension) {
  function cardinal(context) {
    return new Cardinal(context, tension);
  }
  cardinal.tension = function (tension) {
    return custom(+tension);
  };
  return cardinal;
})(0);

function CardinalClosed(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}
CardinalClosed.prototype = {
  areaStart: noop$3,
  areaEnd: noop$3,
  lineStart: function lineStart() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._point = 0;
  },
  lineEnd: function lineEnd() {
    switch (this._point) {
      case 1:
        {
          this._context.moveTo(this._x3, this._y3);
          this._context.closePath();
          break;
        }
      case 2:
        {
          this._context.lineTo(this._x3, this._y3);
          this._context.closePath();
          break;
        }
      case 3:
        {
          this.point(this._x3, this._y3);
          this.point(this._x4, this._y4);
          this.point(this._x5, this._y5);
          break;
        }
    }
  },
  point: function point(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._x3 = x, this._y3 = y;
        break;
      case 1:
        this._point = 2;
        this._context.moveTo(this._x4 = x, this._y4 = y);
        break;
      case 2:
        this._point = 3;
        this._x5 = x, this._y5 = y;
        break;
      default:
        _point$2(this, x, y);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};
var nr = (function custom(tension) {
  function cardinal(context) {
    return new CardinalClosed(context, tension);
  }
  cardinal.tension = function (tension) {
    return custom(+tension);
  };
  return cardinal;
})(0);

function CardinalOpen(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}
CardinalOpen.prototype = {
  areaStart: function areaStart() {
    this._line = 0;
  },
  areaEnd: function areaEnd() {
    this._line = NaN;
  },
  lineStart: function lineStart() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function lineEnd() {
    if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function point(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
        break;
      case 3:
        this._point = 4;
      // proceed
      default:
        _point$2(this, x, y);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};
var or = (function custom(tension) {
  function cardinal(context) {
    return new CardinalOpen(context, tension);
  }
  cardinal.tension = function (tension) {
    return custom(+tension);
  };
  return cardinal;
})(0);

function _point$1(that, x, y) {
  var x1 = that._x1,
    y1 = that._y1,
    x2 = that._x2,
    y2 = that._y2;
  if (that._l01_a > epsilon$1) {
    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
      n = 3 * that._l01_a * (that._l01_a + that._l12_a);
    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
  }
  if (that._l23_a > epsilon$1) {
    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
      m = 3 * that._l23_a * (that._l23_a + that._l12_a);
    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
  }
  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}
CatmullRom.prototype = {
  areaStart: function areaStart() {
    this._line = 0;
  },
  areaEnd: function areaEnd() {
    this._line = NaN;
  },
  lineStart: function lineStart() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function lineEnd() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        this.point(this._x2, this._y2);
        break;
    }
    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function point(x, y) {
    x = +x, y = +y;
    if (this._point) {
      var x23 = this._x2 - x,
        y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
      // proceed
      default:
        _point$1(this, x, y);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};
var ar = (function custom(alpha) {
  function catmullRom(context) {
    return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
  }
  catmullRom.alpha = function (alpha) {
    return custom(+alpha);
  };
  return catmullRom;
})(0.5);

function CatmullRomClosed(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}
CatmullRomClosed.prototype = {
  areaStart: noop$3,
  areaEnd: noop$3,
  lineStart: function lineStart() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function lineEnd() {
    switch (this._point) {
      case 1:
        {
          this._context.moveTo(this._x3, this._y3);
          this._context.closePath();
          break;
        }
      case 2:
        {
          this._context.lineTo(this._x3, this._y3);
          this._context.closePath();
          break;
        }
      case 3:
        {
          this.point(this._x3, this._y3);
          this.point(this._x4, this._y4);
          this.point(this._x5, this._y5);
          break;
        }
    }
  },
  point: function point(x, y) {
    x = +x, y = +y;
    if (this._point) {
      var x23 = this._x2 - x,
        y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1;
        this._x3 = x, this._y3 = y;
        break;
      case 1:
        this._point = 2;
        this._context.moveTo(this._x4 = x, this._y4 = y);
        break;
      case 2:
        this._point = 3;
        this._x5 = x, this._y5 = y;
        break;
      default:
        _point$1(this, x, y);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};
var lr = (function custom(alpha) {
  function catmullRom(context) {
    return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
  }
  catmullRom.alpha = function (alpha) {
    return custom(+alpha);
  };
  return catmullRom;
})(0.5);

function CatmullRomOpen(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}
CatmullRomOpen.prototype = {
  areaStart: function areaStart() {
    this._line = 0;
  },
  areaEnd: function areaEnd() {
    this._line = NaN;
  },
  lineStart: function lineStart() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function lineEnd() {
    if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function point(x, y) {
    x = +x, y = +y;
    if (this._point) {
      var x23 = this._x2 - x,
        y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
        break;
      case 3:
        this._point = 4;
      // proceed
      default:
        _point$1(this, x, y);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};
var sr = (function custom(alpha) {
  function catmullRom(context) {
    return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
  }
  catmullRom.alpha = function (alpha) {
    return custom(+alpha);
  };
  return catmullRom;
})(0.5);

function LinearClosed(context) {
  this._context = context;
}
LinearClosed.prototype = {
  areaStart: noop$3,
  areaEnd: noop$3,
  lineStart: function lineStart() {
    this._point = 0;
  },
  lineEnd: function lineEnd() {
    if (this._point) this._context.closePath();
  },
  point: function point(x, y) {
    x = +x, y = +y;
    if (this._point) this._context.lineTo(x, y);else this._point = 1, this._context.moveTo(x, y);
  }
};
function ur (context) {
  return new LinearClosed(context);
}

function sign(x) {
  return x < 0 ? -1 : 1;
}

// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
  var h0 = that._x1 - that._x0,
    h1 = x2 - that._x1,
    s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
    s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
    p = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}

// Calculate a one-sided slope.
function slope2(that, t) {
  var h = that._x1 - that._x0;
  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}

// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function _point(that, t0, t1) {
  var x0 = that._x0,
    y0 = that._y0,
    x1 = that._x1,
    y1 = that._y1,
    dx = (x1 - x0) / 3;
  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function MonotoneX(context) {
  this._context = context;
}
MonotoneX.prototype = {
  areaStart: function areaStart() {
    this._line = 0;
  },
  areaEnd: function areaEnd() {
    this._line = NaN;
  },
  lineStart: function lineStart() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
    this._point = 0;
  },
  lineEnd: function lineEnd() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        _point(this, this._t0, slope2(this, this._t0));
        break;
    }
    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function point(x, y) {
    var t1 = NaN;
    x = +x, y = +y;
    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        _point(this, slope2(this, t1 = slope3(this, x, y)), t1);
        break;
      default:
        _point(this, this._t0, t1 = slope3(this, x, y));
        break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
    this._t0 = t1;
  }
};
function MonotoneY(context) {
  this._context = new ReflectContext(context);
}
(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function (x, y) {
  MonotoneX.prototype.point.call(this, y, x);
};
function ReflectContext(context) {
  this._context = context;
}
ReflectContext.prototype = {
  moveTo: function moveTo(x, y) {
    this._context.moveTo(y, x);
  },
  closePath: function closePath() {
    this._context.closePath();
  },
  lineTo: function lineTo(x, y) {
    this._context.lineTo(y, x);
  },
  bezierCurveTo: function bezierCurveTo(x1, y1, x2, y2, x, y) {
    this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
  }
};
function monotoneX(context) {
  return new MonotoneX(context);
}
function monotoneY(context) {
  return new MonotoneY(context);
}

function Natural(context) {
  this._context = context;
}
Natural.prototype = {
  areaStart: function areaStart() {
    this._line = 0;
  },
  areaEnd: function areaEnd() {
    this._line = NaN;
  },
  lineStart: function lineStart() {
    this._x = [];
    this._y = [];
  },
  lineEnd: function lineEnd() {
    var x = this._x,
      y = this._y,
      n = x.length;
    if (n) {
      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
      if (n === 2) {
        this._context.lineTo(x[1], y[1]);
      } else {
        var px = controlPoints(x),
          py = controlPoints(y);
        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
        }
      }
    }
    if (this._line || this._line !== 0 && n === 1) this._context.closePath();
    this._line = 1 - this._line;
    this._x = this._y = null;
  },
  point: function point(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
  var i,
    n = x.length - 1,
    m,
    a = new Array(n),
    b = new Array(n),
    r = new Array(n);
  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
  a[n - 1] = r[n - 1] / b[n - 1];
  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
  b[n - 1] = (x[n] + a[n - 1]) / 2;
  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
  return [a, b];
}
function pr$1 (context) {
  return new Natural(context);
}

function Step$1(context, t) {
  this._context = context;
  this._t = t;
}
Step$1.prototype = {
  areaStart: function areaStart() {
    this._line = 0;
  },
  areaEnd: function areaEnd() {
    this._line = NaN;
  },
  lineStart: function lineStart() {
    this._x = this._y = NaN;
    this._point = 0;
  },
  lineEnd: function lineEnd() {
    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
  },
  point: function point(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
        break;
      case 1:
        this._point = 2;
      // proceed
      default:
        {
          if (this._t <= 0) {
            this._context.lineTo(this._x, y);
            this._context.lineTo(x, y);
          } else {
            var x1 = this._x * (1 - this._t) + x * this._t;
            this._context.lineTo(x1, this._y);
            this._context.lineTo(x1, y);
          }
          break;
        }
    }
    this._x = x, this._y = y;
  }
};
function hr (context) {
  return new Step$1(context, 0.5);
}
function stepBefore(context) {
  return new Step$1(context, 0);
}
function stepAfter(context) {
  return new Step$1(context, 1);
}

function wr (series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
    s0 = s1, s1 = series[order[i]];
    for (j = 0; j < m; ++j) {
      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
  }
}

function Rr (series) {
  var n = series.length,
    o = new Array(n);
  while (--n >= 0) o[n] = n;
  return o;
}

function kr (series, order) {
  if (!((n = series.length) > 0)) return;
  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
  }
  wr(series, order);
}

function _r (series, order) {
  if (!((n = series.length) > 0)) return;
  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
    for (yp = yn = 0, i = 0; i < n; ++i) {
      if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) {
        d[0] = yp, d[1] = yp += dy;
      } else if (dy < 0) {
        d[1] = yn, d[0] = yn += dy;
      } else {
        d[0] = 0, d[1] = dy;
      }
    }
  }
}

function xr (series, order) {
  if (!((n = series.length) > 0)) return;
  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
    s0[j][1] += s0[j][0] = -y / 2;
  }
  wr(series, order);
}

function Or (series, order) {
  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
      var si = series[order[i]],
        sij0 = si[j][1] || 0,
        sij1 = si[j - 1][1] || 0,
        s3 = (sij0 - sij1) / 2;
      for (var k = 0; k < i; ++k) {
        var sk = series[order[k]],
          skj0 = sk[j][1] || 0,
          skj1 = sk[j - 1][1] || 0;
        s3 += skj0 - skj1;
      }
      s1 += sij0, s2 += s3 * sij0;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    if (s1) y -= s2 / s1;
  }
  s0[j - 1][1] += s0[j - 1][0] = y;
  wr(series, order);
}

function appearance (series) {
  var peaks = series.map(peak);
  return Rr(series).sort(function (a, b) {
    return peaks[a] - peaks[b];
  });
}
function peak(series) {
  var i = -1,
    j = 0,
    n = series.length,
    vi,
    vj = -Infinity;
  while (++i < n) if ((vi = +series[i][1]) > vj) vj = vi, j = i;
  return j;
}

function mr (series) {
  var sums = series.map(sum);
  return Rr(series).sort(function (a, b) {
    return sums[a] - sums[b];
  });
}
function sum(series) {
  var s = 0,
    i = -1,
    n = series.length,
    v;
  while (++i < n) if (v = +series[i][1]) s += v;
  return s;
}

function yr (series) {
  return mr(series).reverse();
}

function vr (series) {
  var n = series.length,
    i,
    j,
    sums = series.map(sum),
    order = appearance(series),
    top = 0,
    bottom = 0,
    tops = [],
    bottoms = [];
  for (i = 0; i < n; ++i) {
    j = order[i];
    if (top < bottom) {
      top += sums[j];
      tops.push(j);
    } else {
      bottom += sums[j];
      bottoms.push(j);
    }
  }
  return bottoms.reverse().concat(tops);
}

function qr (series) {
  return Rr(series).reverse();
}

function formatDecimal (x) {
  return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}

// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function formatDecimalParts(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i,
    coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient, +x.slice(i + 1)];
}

function exponent (x) {
  return x = formatDecimalParts(Math.abs(x)), x ? x[1] : NaN;
}

function formatGroup (grouping, thousands) {
  return function (value, width) {
    var i = value.length,
      t = [],
      j = 0,
      g = grouping[0],
      length = 0;
    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }
    return t.reverse().join(thousands);
  };
}

function formatNumerals (numerals) {
  return function (value) {
    return value.replace(/[0-9]/g, function (i) {
      return numerals[+i];
    });
  };
}

// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var re$1 = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function formatSpecifier(specifier) {
  if (!(match = re$1.exec(specifier))) throw new Error("invalid format: " + specifier);
  var match;
  return new FormatSpecifier({
    fill: match[1],
    align: match[2],
    sign: match[3],
    symbol: match[4],
    zero: match[5],
    width: match[6],
    comma: match[7],
    precision: match[8] && match[8].slice(1),
    trim: match[9],
    type: match[10]
  });
}
formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
  this.align = specifier.align === undefined ? ">" : specifier.align + "";
  this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
  this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
  this.zero = !!specifier.zero;
  this.width = specifier.width === undefined ? undefined : +specifier.width;
  this.comma = !!specifier.comma;
  this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
  this.trim = !!specifier.trim;
  this.type = specifier.type === undefined ? "" : specifier.type + "";
}
FormatSpecifier.prototype.toString = function () {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function formatTrim (s) {
  out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (s[i]) {
      case ".":
        i0 = i1 = i;
        break;
      case "0":
        if (i0 === 0) i0 = i;
        i1 = i;
        break;
      default:
        if (!+s[i]) break out;
        if (i0 > 0) i0 = 0;
        break;
    }
  }
  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

var prefixExponent;
function formatPrefixAuto (x, p) {
  var d = formatDecimalParts(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
    exponent = d[1],
    i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
    n = coefficient.length;
  return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + formatDecimalParts(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

function formatRounded (x, p) {
  var d = formatDecimalParts(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
    exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

var formatTypes = {
  "%": function _(x, p) {
    return (x * 100).toFixed(p);
  },
  "b": function b(x) {
    return Math.round(x).toString(2);
  },
  "c": function c(x) {
    return x + "";
  },
  "d": formatDecimal,
  "e": function e(x, p) {
    return x.toExponential(p);
  },
  "f": function f(x, p) {
    return x.toFixed(p);
  },
  "g": function g(x, p) {
    return x.toPrecision(p);
  },
  "o": function o(x) {
    return Math.round(x).toString(8);
  },
  "p": function p(x, _p) {
    return formatRounded(x * 100, _p);
  },
  "r": formatRounded,
  "s": formatPrefixAuto,
  "X": function X(x) {
    return Math.round(x).toString(16).toUpperCase();
  },
  "x": function x(_x) {
    return Math.round(_x).toString(16);
  }
};

function identity$2 (x) {
  return x;
}

var map = Array.prototype.map,
  prefixes = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function formatLocale (locale) {
  var group = locale.grouping === undefined || locale.thousands === undefined ? identity$2 : formatGroup(map.call(locale.grouping, Number), locale.thousands + ""),
    currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "",
    currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "",
    decimal = locale.decimal === undefined ? "." : locale.decimal + "",
    numerals = locale.numerals === undefined ? identity$2 : formatNumerals(map.call(locale.numerals, String)),
    percent = locale.percent === undefined ? "%" : locale.percent + "",
    minus = locale.minus === undefined ? "-" : locale.minus + "",
    nan = locale.nan === undefined ? "NaN" : locale.nan + "";
  function newFormat(specifier) {
    specifier = formatSpecifier(specifier);
    var fill = specifier.fill,
      align = specifier.align,
      sign = specifier.sign,
      symbol = specifier.symbol,
      zero = specifier.zero,
      width = specifier.width,
      comma = specifier.comma,
      precision = specifier.precision,
      trim = specifier.trim,
      type = specifier.type;

    // The "n" type is an alias for ",g".
    if (type === "n") comma = true, type = "g";

    // The "" type, and any invalid type, is an alias for ".12~g".
    else if (!formatTypes[type]) precision === undefined && (precision = 12), trim = true, type = "g";

    // If zero fill is specified, padding goes after sign and before digits.
    if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
      suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = formatTypes[type],
      maybeSuffix = /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
    function format(value) {
      var valuePrefix = prefix,
        valueSuffix = suffix,
        i,
        n,
        c;
      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Determine the sign. -0 is not less than 0, but 1 / -0 is!
        var valueNegative = value < 0 || 1 / value < 0;

        // Perform the initial formatting.
        value = isNaN(value) ? nan : formatType(Math.abs(value), precision);

        // Trim insignificant zeros.
        if (trim) value = formatTrim(value);

        // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
        if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
        padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<":
          value = valuePrefix + value + valueSuffix + padding;
          break;
        case "=":
          value = valuePrefix + padding + value + valueSuffix;
          break;
        case "^":
          value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
          break;
        default:
          value = padding + valuePrefix + value + valueSuffix;
          break;
      }
      return numerals(value);
    }
    format.toString = function () {
      return specifier + "";
    };
    return format;
  }
  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
      e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
      k = Math.pow(10, -e),
      prefix = prefixes[8 + e / 3];
    return function (value) {
      return f(k * value) + prefix;
    };
  }
  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
}

var locale;
var format;
defaultLocale({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""],
  minus: "-"
});
function defaultLocale(definition) {
  locale = formatLocale(definition);
  format = locale.format;
  locale.formatPrefix;
  return locale;
}

var baseGet$2 = _baseGet,
  baseSet = _baseSet,
  castPath$1 = _castPath;

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy$1(object, paths, predicate) {
  var index = -1,
    length = paths.length,
    result = {};
  while (++index < length) {
    var path = paths[index],
      value = baseGet$2(object, path);
    if (predicate(value, path)) {
      baseSet(result, castPath$1(path, object), value);
    }
  }
  return result;
}
var _basePickBy = basePickBy$1;

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn$1(object, key) {
  return object != null && key in Object(object);
}
var _baseHasIn = baseHasIn$1;

var castPath = _castPath,
  isArguments$1 = isArguments_1,
  isArray$5 = isArray_1,
  isIndex = _isIndex,
  isLength = isLength_1,
  toKey$2 = _toKey;

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath$1(object, path, hasFunc) {
  path = castPath(path, object);
  var index = -1,
    length = path.length,
    result = false;
  while (++index < length) {
    var key = toKey$2(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) && (isArray$5(object) || isArguments$1(object));
}
var _hasPath = hasPath$1;

var baseHasIn = _baseHasIn,
  hasPath = _hasPath;

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn$2(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}
var hasIn_1 = hasIn$2;

var basePickBy = _basePickBy,
  hasIn$1 = hasIn_1;

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick$1(object, paths) {
  return basePickBy(object, paths, function (value, path) {
    return hasIn$1(object, path);
  });
}
var _basePick = basePick$1;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush$2(array, values) {
  var index = -1,
    length = values.length,
    offset = array.length;
  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}
var _arrayPush = arrayPush$2;

var _Symbol$1 = _Symbol$5,
  isArguments = isArguments_1,
  isArray$4 = isArray_1;

/** Built-in value references. */
var spreadableSymbol = _Symbol$1 ? _Symbol$1.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable$1(value) {
  return isArray$4(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}
var _isFlattenable = isFlattenable$1;

var arrayPush$1 = _arrayPush,
  isFlattenable = _isFlattenable;

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten$2(array, depth, predicate, isStrict, result) {
  var index = -1,
    length = array.length;
  predicate || (predicate = isFlattenable);
  result || (result = []);
  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten$2(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush$1(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}
var _baseFlatten = baseFlatten$2;

var baseFlatten$1 = _baseFlatten;

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten$1(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten$1(array, 1) : [];
}
var flatten_1 = flatten$1;

var flatten = flatten_1,
  overRest = _overRest,
  setToString = _setToString;

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest$1(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}
var _flatRest = flatRest$1;

var basePick = _basePick,
  flatRest = _flatRest;

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function (object, paths) {
  return object == null ? {} : basePick(object, paths);
});
var pick_1 = pick;
var Pr = /*@__PURE__*/getDefaultExportFromCjs$1(pick_1);

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome$1(array, predicate) {
  var index = -1,
    length = array == null ? 0 : array.length;
  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}
var _arraySome = arraySome$1;

var SetCache$1 = _SetCache,
  arraySome = _arraySome,
  cacheHas$1 = _cacheHas;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$5 = 1,
  COMPARE_UNORDERED_FLAG$3 = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays$2(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5,
    arrLength = array.length,
    othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
    result = true,
    seen = bitmask & COMPARE_UNORDERED_FLAG$3 ? new SetCache$1() : undefined;
  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
      othValue = other[index];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function (othValue, othIndex) {
        if (!cacheHas$1(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}
var _equalArrays = equalArrays$2;

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray$1(map) {
  var index = -1,
    result = Array(map.size);
  map.forEach(function (value, key) {
    result[++index] = [key, value];
  });
  return result;
}
var _mapToArray = mapToArray$1;

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray$3(set) {
  var index = -1,
    result = Array(set.size);
  set.forEach(function (value) {
    result[++index] = value;
  });
  return result;
}
var _setToArray = setToArray$3;

var _Symbol = _Symbol$5,
  Uint8Array = _Uint8Array,
  eq = eq_1,
  equalArrays$1 = _equalArrays,
  mapToArray = _mapToArray,
  setToArray$2 = _setToArray;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$4 = 1,
  COMPARE_UNORDERED_FLAG$2 = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
  dateTag$1 = '[object Date]',
  errorTag = '[object Error]',
  mapTag$1 = '[object Map]',
  numberTag = '[object Number]',
  regexpTag = '[object RegExp]',
  setTag$1 = '[object Set]',
  stringTag = '[object String]',
  symbolTag = '[object Symbol]';
var arrayBufferTag = '[object ArrayBuffer]',
  dataViewTag$1 = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
  symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag$1(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$1:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;
    case arrayBufferTag:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;
    case boolTag:
    case dateTag$1:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);
    case errorTag:
      return object.name == other.name && object.message == other.message;
    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == other + '';
    case mapTag$1:
      var convert = mapToArray;
    case setTag$1:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert || (convert = setToArray$2);
      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$2;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays$1(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;
    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}
var _equalByTag = equalByTag$1;

var arrayPush = _arrayPush,
  isArray$3 = isArray_1;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys$1(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$3(object) ? result : arrayPush(result, symbolsFunc(object));
}
var _baseGetAllKeys = baseGetAllKeys$1;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter$1(array, predicate) {
  var index = -1,
    length = array == null ? 0 : array.length,
    resIndex = 0,
    result = [];
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}
var _arrayFilter = arrayFilter$1;

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray$1() {
  return [];
}
var stubArray_1 = stubArray$1;

var arrayFilter = _arrayFilter,
  stubArray = stubArray_1;

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$3.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols$1 = !nativeGetSymbols ? stubArray : function (object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function (symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};
var _getSymbols = getSymbols$1;

var overArg = _overArg;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys$1 = overArg(Object.keys, Object);
var _nativeKeys = nativeKeys$1;

var isPrototype = _isPrototype,
  nativeKeys = _nativeKeys;

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys$1(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$2.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}
var _baseKeys = baseKeys$1;

var arrayLikeKeys = _arrayLikeKeys,
  baseKeys = _baseKeys,
  isArrayLike$2 = isArrayLike_1;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys$3(object) {
  return isArrayLike$2(object) ? arrayLikeKeys(object) : baseKeys(object);
}
var keys_1 = keys$3;

var baseGetAllKeys = _baseGetAllKeys,
  getSymbols = _getSymbols,
  keys$2 = keys_1;

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys$1(object) {
  return baseGetAllKeys(object, keys$2, getSymbols);
}
var _getAllKeys = getAllKeys$1;

var getAllKeys = _getAllKeys;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$3 = 1;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects$1(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3,
    objProps = getAllKeys(object),
    objLength = objProps.length,
    othProps = getAllKeys(other),
    othLength = othProps.length;
  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$1.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);
  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
      othValue = other[key];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
      othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}
var _equalObjects = equalObjects$1;

var getNative$3 = _getNative,
  root$3 = _root;

/* Built-in method references that are verified to be native. */
var DataView$2 = getNative$3(root$3, 'DataView');
var _DataView = DataView$2;

var getNative$2 = _getNative,
  root$2 = _root;

/* Built-in method references that are verified to be native. */
var Promise$2 = getNative$2(root$2, 'Promise');
var _Promise = Promise$2;

var getNative$1 = _getNative,
  root$1 = _root;

/* Built-in method references that are verified to be native. */
var Set$3 = getNative$1(root$1, 'Set');
var _Set = Set$3;

var getNative = _getNative,
  root = _root;

/* Built-in method references that are verified to be native. */
var WeakMap$1 = getNative(root, 'WeakMap');
var _WeakMap = WeakMap$1;

var DataView$1 = _DataView,
  Map$1 = _Map,
  Promise$1 = _Promise,
  Set$2 = _Set,
  WeakMap = _WeakMap,
  baseGetTag$1 = _baseGetTag,
  toSource = _toSource;

/** `Object#toString` result references. */
var mapTag = '[object Map]',
  objectTag$1 = '[object Object]',
  promiseTag = '[object Promise]',
  setTag = '[object Set]',
  weakMapTag = '[object WeakMap]';
var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView$1),
  mapCtorString = toSource(Map$1),
  promiseCtorString = toSource(Promise$1),
  setCtorString = toSource(Set$2),
  weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag$1 = baseGetTag$1;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView$1 && getTag$1(new DataView$1(new ArrayBuffer(1))) != dataViewTag || Map$1 && getTag$1(new Map$1()) != mapTag || Promise$1 && getTag$1(Promise$1.resolve()) != promiseTag || Set$2 && getTag$1(new Set$2()) != setTag || WeakMap && getTag$1(new WeakMap()) != weakMapTag) {
  getTag$1 = function getTag(value) {
    var result = baseGetTag$1(value),
      Ctor = result == objectTag$1 ? value.constructor : undefined,
      ctorString = Ctor ? toSource(Ctor) : '';
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag;
        case mapCtorString:
          return mapTag;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag;
        case weakMapCtorString:
          return weakMapTag;
      }
    }
    return result;
  };
}
var _getTag = getTag$1;

var Stack$1 = _Stack,
  equalArrays = _equalArrays,
  equalByTag = _equalByTag,
  equalObjects = _equalObjects,
  getTag = _getTag,
  isArray$2 = isArray_1,
  isBuffer = isBufferExports,
  isTypedArray = isTypedArray_1;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$2 = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
  arrayTag = '[object Array]',
  objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep$1(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$2(object),
    othIsArr = isArray$2(other),
    objTag = objIsArr ? arrayTag : getTag(object),
    othTag = othIsArr ? arrayTag : getTag(other);
  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;
  var objIsObj = objTag == objectTag,
    othIsObj = othTag == objectTag,
    isSameTag = objTag == othTag;
  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack$1());
    return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
      othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
        othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new Stack$1());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack$1());
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
var _baseIsEqualDeep = baseIsEqualDeep$1;

var baseIsEqualDeep = _baseIsEqualDeep,
  isObjectLike$1 = isObjectLike_1;

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual$3(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike$1(value) && !isObjectLike$1(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual$3, stack);
}
var _baseIsEqual = baseIsEqual$3;

var baseIsEqual$2 = _baseIsEqual;

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual$2(value, other);
}
var isEqual_1 = isEqual;
var Tr = /*@__PURE__*/getDefaultExportFromCjs$1(isEqual_1);

function Sr() {
  return Sr = Object.assign ? Object.assign.bind() : function (e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Sr.apply(this, arguments);
}
function Mr(e, r) {
  return Mr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, r) {
    return e.__proto__ = r, e;
  }, Mr(e, r);
}
function jr(e, r) {
  if (null == e) return {};
  var t,
    i,
    n = {},
    o = Object.keys(e);
  for (i = 0; i < o.length; i++) t = o[i], r.indexOf(t) >= 0 || (n[t] = e[t]);
  return n;
}
var Br = {
    fill: PropTypes.string,
    fontSize: PropTypes.number,
    fontFamily: PropTypes.string
  },
  Gr = PropTypes.shape({
    domain: PropTypes.shape({
      line: PropTypes.shape({
        stroke: PropTypes.string.isRequired,
        strokeWidth: PropTypes.number.isRequired,
        strokeDasharray: PropTypes.string
      }).isRequired
    }).isRequired,
    ticks: PropTypes.shape({
      line: PropTypes.shape({
        stroke: PropTypes.string.isRequired,
        strokeWidth: PropTypes.number.isRequired,
        strokeDasharray: PropTypes.string
      }).isRequired,
      text: PropTypes.shape(Sr({}, Br)).isRequired
    }).isRequired,
    legend: PropTypes.shape({
      text: PropTypes.shape(Sr({}, Br)).isRequired
    }).isRequired
  }),
  Lr = PropTypes.shape({
    line: PropTypes.shape({
      stroke: PropTypes.string.isRequired,
      strokeWidth: PropTypes.number.isRequired,
      strokeDasharray: PropTypes.string
    }).isRequired
  }),
  Ir = PropTypes.shape({
    hidden: PropTypes.shape({
      symbol: PropTypes.shape({
        fill: PropTypes.string.isRequired,
        opacity: PropTypes.number
      }).isRequired,
      text: PropTypes.shape(Sr({}, Br, {
        opacity: PropTypes.number
      })).isRequired
    }).isRequired,
    text: PropTypes.shape(Sr({}, Br)).isRequired
  }),
  Dr = PropTypes.shape({
    text: PropTypes.shape(Sr({}, Br)).isRequired
  }),
  Yr = PropTypes.shape({
    text: PropTypes.shape(Sr({}, Br)).isRequired
  }),
  Ar = PropTypes.shape({
    text: PropTypes.shape(Sr({}, Br)).isRequired
  }),
  Fr = PropTypes.shape({
    line: PropTypes.shape({
      stroke: PropTypes.string.isRequired,
      strokeWidth: PropTypes.number.isRequired,
      strokeDasharray: PropTypes.string
    }).isRequired
  }),
  Er = PropTypes.shape({
    text: PropTypes.shape(Sr({}, Br, {
      outlineWidth: PropTypes.number.isRequired,
      outlineColor: PropTypes.string.isRequired
    })).isRequired,
    link: PropTypes.shape({
      stroke: PropTypes.string.isRequired,
      strokeWidth: PropTypes.number.isRequired,
      outlineWidth: PropTypes.number.isRequired,
      outlineColor: PropTypes.string.isRequired
    }).isRequired,
    outline: PropTypes.shape({
      stroke: PropTypes.string.isRequired,
      strokeWidth: PropTypes.number.isRequired,
      outlineWidth: PropTypes.number.isRequired,
      outlineColor: PropTypes.string.isRequired
    }).isRequired,
    symbol: PropTypes.shape({
      fill: PropTypes.string.isRequired,
      outlineWidth: PropTypes.number.isRequired,
      outlineColor: PropTypes.string.isRequired
    }).isRequired
  });
  PropTypes.shape({
    background: PropTypes.string.isRequired,
    fontFamily: PropTypes.string.isRequired,
    fontSize: PropTypes.number.isRequired,
    textColor: PropTypes.string.isRequired,
    axis: Gr.isRequired,
    grid: Lr.isRequired,
    legends: Ir.isRequired,
    labels: Dr.isRequired,
    dots: Yr.isRequired,
    markers: Ar,
    crosshair: Fr.isRequired,
    annotations: Er.isRequired
  });
  var Xr = {
    background: "transparent",
    text: {
      fontFamily: "sans-serif",
      fontSize: 11,
      fill: "#333333",
      outlineWidth: 0,
      outlineColor: "transparent"
    },
    axis: {
      domain: {
        line: {
          stroke: "transparent",
          strokeWidth: 1
        }
      },
      ticks: {
        line: {
          stroke: "#777777",
          strokeWidth: 1
        },
        text: {}
      },
      legend: {
        text: {
          fontSize: 12
        }
      }
    },
    grid: {
      line: {
        stroke: "#dddddd",
        strokeWidth: 1
      }
    },
    legends: {
      hidden: {
        symbol: {
          fill: "#333333",
          opacity: .6
        },
        text: {
          fill: "#333333",
          opacity: .6
        }
      },
      text: {},
      ticks: {
        line: {
          stroke: "#777777",
          strokeWidth: 1
        },
        text: {
          fontSize: 10
        }
      },
      title: {
        text: {}
      }
    },
    labels: {
      text: {}
    },
    markers: {
      lineColor: "#000000",
      lineStrokeWidth: 1,
      text: {}
    },
    dots: {
      text: {}
    },
    tooltip: {
      container: {
        background: "white",
        color: "inherit",
        fontSize: "inherit",
        borderRadius: "2px",
        boxShadow: "0 1px 2px rgba(0, 0, 0, 0.25)",
        padding: "5px 9px"
      },
      basic: {
        whiteSpace: "pre",
        display: "flex",
        alignItems: "center"
      },
      chip: {
        marginRight: 7
      },
      table: {},
      tableCell: {
        padding: "3px 5px"
      },
      tableCellValue: {
        fontWeight: "bold"
      }
    },
    crosshair: {
      line: {
        stroke: "#000000",
        strokeWidth: 1,
        strokeOpacity: .75,
        strokeDasharray: "6 6"
      }
    },
    annotations: {
      text: {
        fontSize: 13,
        outlineWidth: 2,
        outlineColor: "#ffffff",
        outlineOpacity: 1
      },
      link: {
        stroke: "#000000",
        strokeWidth: 1,
        outlineWidth: 2,
        outlineColor: "#ffffff",
        outlineOpacity: 1
      },
      outline: {
        fill: "none",
        stroke: "#000000",
        strokeWidth: 2,
        outlineWidth: 2,
        outlineColor: "#ffffff",
        outlineOpacity: 1
      },
      symbol: {
        fill: "#000000",
        outlineWidth: 2,
        outlineColor: "#ffffff",
        outlineOpacity: 1
      }
    }
  },
  Hr = ["axis.ticks.text", "axis.legend.text", "legends.title.text", "legends.text", "legends.ticks.text", "legends.title.text", "labels.text", "dots.text", "markers.text", "annotations.text"],
  Kr = function Kr(e, r) {
    var t = m$1({}, e, r);
    return Hr.forEach(function (e) {
      void 0 === we$1(t, e + ".fontFamily") && v$3(t, e + ".fontFamily", t.text.fontFamily), void 0 === we$1(t, e + ".fontSize") && v$3(t, e + ".fontSize", t.text.fontSize), void 0 === we$1(t, e + ".fill") && v$3(t, e + ".fill", t.text.fill), void 0 === we$1(t, e + ".outlineWidth") && v$3(t, e + ".outlineWidth", t.text.outlineWidth), void 0 === we$1(t, e + ".outlineColor") && v$3(t, e + ".outlineColor", t.text.outlineColor);
    }), t;
  },
  Nr = /*#__PURE__*/createContext(),
  Vr = function Vr(e) {
    var t = e.children,
      i = e.animate,
      n = e.config,
      o = useMemo(function () {
        var e = x$4(n) ? config[n] : n;
        return {
          animate: i,
          config: e
        };
      }, [i, n]);
    return jsx(Nr.Provider, {
      value: o,
      children: t
    });
  },
  Jr = {
    animate: PropTypes.bool,
    motionConfig: PropTypes.oneOfType([PropTypes.oneOf(Object.keys(config)), PropTypes.shape({
      mass: PropTypes.number,
      tension: PropTypes.number,
      friction: PropTypes.number,
      clamp: PropTypes.bool,
      precision: PropTypes.number,
      velocity: PropTypes.number,
      duration: PropTypes.number,
      easing: PropTypes.func
    })])
  };
Vr.propTypes = {
  children: PropTypes.node.isRequired,
  animate: Jr.animate,
  config: Jr.motionConfig
};
var Qr = {
  animate: !0,
  config: "default"
};
Vr.defaultProps = Qr;
var Zr = function Zr() {
    return useContext(Nr);
  },
  $r = function $r(e) {
    var t = Zr(),
      o = t.animate,
      a = t.config,
      l = function (e) {
        var r = useRef();
        return useEffect(function () {
          r.current = e;
        }, [e]), r.current;
      }(e),
      s = useMemo(function () {
        return R(l, e);
      }, [l, e]),
      d = useSpring({
        from: {
          value: 0
        },
        to: {
          value: 1
        },
        reset: !0,
        config: a,
        immediate: !o
      }).value;
    return to(d, s);
  },
  et$1 = {
    nivo: ["#d76445", "#f47560", "#e8c1a0", "#97e3d5", "#61cdbb", "#00b0a7"],
    BrBG: e$1(scheme$R),
    PRGn: e$1(scheme$Q),
    PiYG: e$1(scheme$P),
    PuOr: e$1(scheme$O),
    RdBu: e$1(scheme$N),
    RdGy: e$1(scheme$M),
    RdYlBu: e$1(scheme$L),
    RdYlGn: e$1(scheme$K),
    spectral: e$1(scheme$J),
    blues: e$1(scheme$w),
    greens: e$1(scheme$v),
    greys: e$1(scheme$u),
    oranges: e$1(scheme$r),
    purples: e$1(scheme$t),
    reds: e$1(scheme$s),
    BuGn: e$1(scheme$I),
    BuPu: e$1(scheme$H),
    GnBu: e$1(scheme$G),
    OrRd: e$1(scheme$F),
    PuBuGn: e$1(scheme$E),
    PuBu: e$1(scheme$D),
    PuRd: e$1(scheme$C),
    RdPu: e$1(scheme$B),
    YlGnBu: e$1(scheme$A),
    YlGn: e$1(scheme$z),
    YlOrBr: e$1(scheme$y),
    YlOrRd: e$1(scheme$x)
  },
  rt$1 = Object.keys(et$1);
  ({
    nivo: ["#e8c1a0", "#f47560", "#f1e15b", "#e8a838", "#61cdbb", "#97e3d5"],
    category10: ae$2,
    accent: le$2,
    dark2: se$2,
    paired: de$2,
    pastel1: ue$2,
    pastel2: ce$2,
    set1: fe$2,
    set2: pe$2,
    set3: he$2,
    brown_blueGreen: e$1(scheme$R),
    purpleRed_green: e$1(scheme$Q),
    pink_yellowGreen: e$1(scheme$P),
    purple_orange: e$1(scheme$O),
    red_blue: e$1(scheme$N),
    red_grey: e$1(scheme$M),
    red_yellow_blue: e$1(scheme$L),
    red_yellow_green: e$1(scheme$K),
    spectral: e$1(scheme$J),
    blues: e$1(scheme$w),
    greens: e$1(scheme$v),
    greys: e$1(scheme$u),
    oranges: e$1(scheme$r),
    purples: e$1(scheme$t),
    reds: e$1(scheme$s),
    blue_green: e$1(scheme$I),
    blue_purple: e$1(scheme$H),
    green_blue: e$1(scheme$G),
    orange_red: e$1(scheme$F),
    purple_blue_green: e$1(scheme$E),
    purple_blue: e$1(scheme$D),
    purple_red: e$1(scheme$C),
    red_purple: e$1(scheme$B),
    yellow_green_blue: e$1(scheme$A),
    yellow_green: e$1(scheme$z),
    yellow_orange_brown: e$1(scheme$y),
    yellow_orange_red: e$1(scheme$x)
  });
  PropTypes.oneOfType([PropTypes.oneOf(rt$1), PropTypes.func, PropTypes.arrayOf(PropTypes.string)]);
  var ut = {
    basis: $e$1,
    basisClosed: er,
    basisOpen: rr,
    bundle: tr,
    cardinal: ir,
    cardinalClosed: nr,
    cardinalOpen: or,
    catmullRom: ar,
    catmullRomClosed: lr,
    catmullRomOpen: sr,
    linear: dr,
    linearClosed: ur,
    monotoneX: monotoneX,
    monotoneY: monotoneY,
    natural: pr$1,
    step: hr,
    stepAfter: stepAfter,
    stepBefore: stepBefore
  },
  ct = Object.keys(ut);
  PropTypes.oneOf(ct);
  ct.filter(function (e) {
    return e.endsWith("Closed");
  });
  Ze(ct, "bundle", "basisClosed", "basisOpen", "cardinalClosed", "cardinalOpen", "catmullRomClosed", "catmullRomOpen", "linearClosed");
  var gt = Ze(ct, "bundle", "basisClosed", "basisOpen", "cardinalClosed", "cardinalOpen", "catmullRomClosed", "catmullRomOpen", "linearClosed"),
  bt = PropTypes.oneOf(gt),
  mt = function mt(e) {
    if (!ut[e]) throw new TypeError("'" + e + "', is not a valid curve interpolator identifier.");
    return ut[e];
  },
  yt = {
    defs: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired
    })).isRequired,
    fill: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      match: PropTypes.oneOfType([PropTypes.oneOf(["*"]), PropTypes.object, PropTypes.func]).isRequired
    })).isRequired
  },
  vt = {
    ascending: mr,
    descending: yr,
    insideOut: vr,
    none: Rr,
    reverse: qr
  },
  Rt = Object.keys(vt);
  PropTypes.oneOf(Rt);
  var _t = {
    expand: kr,
    diverging: _r,
    none: wr,
    silhouette: xr,
    wiggle: Or
  },
  wt = Object.keys(_t);
  PropTypes.oneOf(wt);
  PropTypes.shape({
    top: PropTypes.number,
    right: PropTypes.number,
    bottom: PropTypes.number,
    left: PropTypes.number
  }).isRequired;
  var Ct = ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"],
  zt = PropTypes.oneOf(Ct);
  ordinal(he$2);
  var jt = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  Bt = function Bt(e, t, i) {
    return void 0 === i && (i = {}), useMemo(function () {
      var r = Sr({}, jt, i);
      return {
        margin: r,
        innerWidth: e - r.left - r.right,
        innerHeight: t - r.top - r.bottom,
        outerWidth: e,
        outerHeight: t
      };
    }, [e, t, i.top, i.right, i.bottom, i.left]);
  },
  Gt = function Gt() {
    var e = useRef(null),
      r = useState({
        left: 0,
        top: 0,
        width: 0,
        height: 0
      }),
      t = r[0],
      a = r[1],
      l = useState(function () {
        return "undefined" == typeof ResizeObserver ? null : new ResizeObserver(function (e) {
          var r = e[0];
          return a(r.contentRect);
        });
      })[0];
    return useEffect(function () {
      return e.current && null !== l && l.observe(e.current), function () {
        null !== l && l.disconnect();
      };
    }, []), [e, t];
  },
  Lt = function Lt(e) {
    return useMemo(function () {
      return Kr(Xr, e);
    }, [e]);
  },
  It = function It(e) {
    return "function" == typeof e ? e : "string" == typeof e ? 0 === e.indexOf("time:") ? timeFormat(e.slice("5")) : format(e) : function (e) {
      return "" + e;
    };
  },
  Dt = function Dt(e) {
    return useMemo(function () {
      return It(e);
    }, [e]);
  },
  Yt = /*#__PURE__*/createContext(),
  At = {},
  Ft = function Ft(e) {
    var r = e.theme,
      t = void 0 === r ? At : r,
      i = e.children,
      n = Lt(t);
    return jsx(Yt.Provider, {
      value: n,
      children: i
    });
  };
Ft.propTypes = {
  children: PropTypes.node.isRequired,
  theme: PropTypes.object
};
var Et = function Et() {
    return useContext(Yt);
  },
  Ut = function Ut(e) {
    var r = e.children,
      t = e.condition,
      i = e.wrapper;
    return t ? /*#__PURE__*/cloneElement(i, {}, r) : r;
  };
Ut.propTypes = {
  children: PropTypes.node.isRequired,
  condition: PropTypes.bool.isRequired,
  wrapper: PropTypes.element.isRequired
};
var Xt = {
    position: "relative"
  },
  Ht = function Ht(e) {
    var r = e.children,
      t = e.theme,
      n = e.renderWrapper,
      o = void 0 === n || n,
      a = e.isInteractive,
      l = void 0 === a || a,
      s = e.animate,
      d = e.motionConfig,
      u = useRef(null);
    return jsx(Ft, {
      theme: t,
      children: jsx(Vr, {
        animate: s,
        config: d,
        children: jsx(M$2, {
          container: u,
          children: jsxs(Ut, {
            condition: o,
            wrapper: jsx("div", {
              style: Xt,
              ref: u
            }),
            children: [r, l && jsx(F$1, {})]
          })
        })
      })
    });
  };
Ht.propTypes = {
  children: PropTypes.element.isRequired,
  isInteractive: PropTypes.bool,
  renderWrapper: PropTypes.bool,
  theme: PropTypes.object,
  animate: PropTypes.bool,
  motionConfig: PropTypes.string
};
({
  children: PropTypes.func.isRequired,
  isInteractive: PropTypes.bool,
  renderWrapper: PropTypes.bool,
  theme: PropTypes.object.isRequired,
  animate: PropTypes.bool.isRequired,
  motionConfig: PropTypes.string
});
var Jt = function Jt(e) {
  var r = e.children,
    t = Gt(),
    i = t[0],
    n = t[1],
    o = n.width > 0 && n.height > 0;
  return jsx("div", {
    ref: i,
    style: {
      width: "100%",
      height: "100%"
    },
    children: o && r({
      width: n.width,
      height: n.height
    })
  });
};
Jt.propTypes = {
  children: PropTypes.func.isRequired
};
var Qt = ["id", "colors"],
  Zt = function Zt(e) {
    var r = e.id,
      t = e.colors,
      i = jr(e, Qt);
    return jsx("linearGradient", Sr({
      id: r,
      x1: 0,
      x2: 0,
      y1: 0,
      y2: 1
    }, i, {
      children: t.map(function (e) {
        var r = e.offset,
          t = e.color,
          i = e.opacity;
        return jsx("stop", {
          offset: r + "%",
          stopColor: t,
          stopOpacity: void 0 !== i ? i : 1
        }, r);
      })
    }));
  };
Zt.propTypes = {
  id: PropTypes.string.isRequired,
  colors: PropTypes.arrayOf(PropTypes.shape({
    offset: PropTypes.number.isRequired,
    color: PropTypes.string.isRequired,
    opacity: PropTypes.number
  })).isRequired,
  gradientTransform: PropTypes.string
};
var ei = {
    linearGradient: Zt
  },
  ri = /*#__PURE__*/memo(function (e) {
    var r = e.id,
      t = e.background,
      i = e.color,
      n = e.size,
      o = e.padding,
      a = e.stagger,
      l = n + o,
      s = n / 2,
      d = o / 2;
    return !0 === a && (l = 2 * n + 2 * o), jsxs("pattern", {
      id: r,
      width: l,
      height: l,
      patternUnits: "userSpaceOnUse",
      children: [jsx("rect", {
        width: l,
        height: l,
        fill: t
      }), jsx("circle", {
        cx: d + s,
        cy: d + s,
        r: s,
        fill: i
      }), a && jsx("circle", {
        cx: 1.5 * o + n + s,
        cy: 1.5 * o + n + s,
        r: s,
        fill: i
      })]
    });
  });
ri.displayName = "PatternDots", ri.propTypes = {
  id: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  background: PropTypes.string.isRequired,
  size: PropTypes.number.isRequired,
  padding: PropTypes.number.isRequired,
  stagger: PropTypes.bool.isRequired
}, ri.defaultProps = {
  color: "#000000",
  background: "#ffffff",
  size: 4,
  padding: 4,
  stagger: !1
};
var ni = function ni(e) {
    return e * Math.PI / 180;
  },
  oi = function oi(e) {
    return 180 * e / Math.PI;
  },
  ai = function ai(e) {
    return e.startAngle + (e.endAngle - e.startAngle) / 2;
  },
  li = function li(e, r) {
    return {
      x: Math.cos(e) * r,
      y: Math.sin(e) * r
    };
  },
  fi = {
    svg: {
      align: {
        left: "start",
        center: "middle",
        right: "end",
        start: "start",
        middle: "middle",
        end: "end"
      },
      baseline: {
        top: "text-before-edge",
        center: "central",
        bottom: "alphabetic"
      }
    },
    canvas: {
      align: {
        left: "left",
        center: "center",
        right: "right",
        start: "left",
        middle: "center",
        end: "right"
      },
      baseline: {
        top: "top",
        center: "middle",
        bottom: "bottom"
      }
    }
  },
  hi = /*#__PURE__*/memo(function (e) {
    var r = e.id,
      t = e.spacing,
      i = e.rotation,
      n = e.background,
      o = e.color,
      a = e.lineWidth,
      l = Math.round(i) % 360,
      s = Math.abs(t);
    l > 180 ? l -= 360 : l > 90 ? l -= 180 : l < -180 ? l += 360 : l < -90 && (l += 180);
    var d,
      u = s,
      c = s;
    return 0 === l ? d = "\n                M 0 0 L " + u + " 0\n                M 0 " + c + " L " + u + " " + c + "\n            " : 90 === l ? d = "\n                M 0 0 L 0 " + c + "\n                M " + u + " 0 L " + u + " " + c + "\n            " : (u = Math.abs(s / Math.sin(ni(l))), c = s / Math.sin(ni(90 - l)), d = l > 0 ? "\n                    M 0 " + -c + " L " + 2 * u + " " + c + "\n                    M " + -u + " " + -c + " L " + u + " " + c + "\n                    M " + -u + " 0 L " + u + " " + 2 * c + "\n                " : "\n                    M " + -u + " " + c + " L " + u + " " + -c + "\n                    M " + -u + " " + 2 * c + " L " + 2 * u + " " + -c + "\n                    M 0 " + 2 * c + " L " + 2 * u + " 0\n                "), jsxs("pattern", {
      id: r,
      width: u,
      height: c,
      patternUnits: "userSpaceOnUse",
      children: [jsx("rect", {
        width: u,
        height: c,
        fill: n,
        stroke: "rgba(255, 0, 0, 0.1)",
        strokeWidth: 0
      }), jsx("path", {
        d: d,
        strokeWidth: a,
        stroke: o,
        strokeLinecap: "square"
      })]
    });
  });
hi.displayName = "PatternLines", hi.propTypes = {
  id: PropTypes.string.isRequired,
  spacing: PropTypes.number.isRequired,
  rotation: PropTypes.number.isRequired,
  background: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  lineWidth: PropTypes.number.isRequired
}, hi.defaultProps = {
  spacing: 5,
  rotation: 0,
  color: "#000000",
  background: "#ffffff",
  lineWidth: 2
};
var bi = /*#__PURE__*/memo(function (e) {
    var r = e.id,
      t = e.background,
      i = e.color,
      n = e.size,
      o = e.padding,
      a = e.stagger,
      l = n + o,
      s = o / 2;
    return !0 === a && (l = 2 * n + 2 * o), jsxs("pattern", {
      id: r,
      width: l,
      height: l,
      patternUnits: "userSpaceOnUse",
      children: [jsx("rect", {
        width: l,
        height: l,
        fill: t
      }), jsx("rect", {
        x: s,
        y: s,
        width: n,
        height: n,
        fill: i
      }), a && jsx("rect", {
        x: 1.5 * o + n,
        y: 1.5 * o + n,
        width: n,
        height: n,
        fill: i
      })]
    });
  });
bi.displayName = "PatternSquares", bi.propTypes = {
  id: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  background: PropTypes.string.isRequired,
  size: PropTypes.number.isRequired,
  padding: PropTypes.number.isRequired,
  stagger: PropTypes.bool.isRequired
}, bi.defaultProps = {
  color: "#000000",
  background: "#ffffff",
  size: 4,
  padding: 4,
  stagger: !1
};
var yi = {
    patternDots: ri,
    patternLines: hi,
    patternSquares: bi
  },
  vi = ["type"],
  Ri = Sr({}, ei, yi),
  qi = function qi(e) {
    var r = e.defs;
    return !r || r.length < 1 ? null : jsx("defs", {
      "aria-hidden": !0,
      children: r.map(function (e) {
        var r = e.type,
          t = jr(e, vi);
        return Ri[r] ? /*#__PURE__*/createElement(Ri[r], Sr({
          key: t.id
        }, t)) : null;
      })
    });
  };
qi.propTypes = {
  defs: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.oneOf(Object.keys(Ri)).isRequired,
    id: PropTypes.string.isRequired
  }))
};
var ki = /*#__PURE__*/memo(qi),
  _i = function _i(e) {
    var r = e.width,
      t = e.height,
      i = e.margin,
      n = e.defs,
      o = e.children,
      a = e.role,
      l = e.ariaLabel,
      s = e.ariaLabelledBy,
      d = e.ariaDescribedBy,
      u = e.isFocusable,
      c = Et();
    return jsxs("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: r,
      height: t,
      role: a,
      "aria-label": l,
      "aria-labelledby": s,
      "aria-describedby": d,
      focusable: u,
      tabIndex: u ? 0 : void 0,
      children: [jsx(ki, {
        defs: n
      }), jsx("rect", {
        width: r,
        height: t,
        fill: c.background
      }), jsx("g", {
        transform: "translate(" + i.left + "," + i.top + ")",
        children: o
      })]
    });
  };
_i.propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  margin: PropTypes.shape({
    top: PropTypes.number.isRequired,
    left: PropTypes.number.isRequired
  }).isRequired,
  defs: PropTypes.array,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  role: PropTypes.string,
  isFocusable: PropTypes.bool,
  ariaLabel: PropTypes.string,
  ariaLabelledBy: PropTypes.string,
  ariaDescribedBy: PropTypes.string
};
var wi = function wi(e) {
  var r = e.size,
    t = e.color,
    i = e.borderWidth,
    n = e.borderColor;
  return jsx("circle", {
    r: r / 2,
    fill: t,
    stroke: n,
    strokeWidth: i,
    style: {
      pointerEvents: "none"
    }
  });
};
wi.propTypes = {
  size: PropTypes.number.isRequired,
  color: PropTypes.string.isRequired,
  borderWidth: PropTypes.number.isRequired,
  borderColor: PropTypes.string.isRequired
};
var xi = /*#__PURE__*/memo(wi),
  Oi = function Oi(e) {
    var r = e.x,
      t = e.y,
      i = e.symbol,
      n = void 0 === i ? xi : i,
      o = e.size,
      a = e.datum,
      l = e.color,
      s = e.borderWidth,
      u = e.borderColor,
      c = e.label,
      f = e.labelTextAnchor,
      p = void 0 === f ? "middle" : f,
      h = e.labelYOffset,
      g = void 0 === h ? -12 : h,
      b = Et(),
      m = Zr(),
      y = m.animate,
      v = m.config,
      R = useSpring({
        transform: "translate(" + r + ", " + t + ")",
        config: v,
        immediate: !y
      });
    return jsxs(animated.g, {
      transform: R.transform,
      style: {
        pointerEvents: "none"
      },
      children: [/*#__PURE__*/createElement(n, {
        size: o,
        color: l,
        datum: a,
        borderWidth: s,
        borderColor: u
      }), c && jsx("text", {
        textAnchor: p,
        y: g,
        style: b.dots.text,
        children: c
      })]
    });
  };
Oi.propTypes = {
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  datum: PropTypes.object.isRequired,
  size: PropTypes.number.isRequired,
  color: PropTypes.string.isRequired,
  borderWidth: PropTypes.number.isRequired,
  borderColor: PropTypes.string.isRequired,
  symbol: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  labelTextAnchor: PropTypes.oneOf(["start", "middle", "end"]),
  labelYOffset: PropTypes.number
};
var Wi = /*#__PURE__*/memo(Oi),
  Ci = function Ci(e) {
    var r = e.width,
      t = e.height,
      i = e.axis,
      n = e.scale,
      o = e.value,
      a = e.lineStyle,
      l = e.textStyle,
      s = e.legend,
      d = e.legendPosition,
      u = e.legendOffsetX,
      c = e.legendOffsetY,
      f = e.legendOrientation,
      p = Et(),
      h = 0,
      g = 0,
      b = 0,
      m = 0;
    "y" === i ? (b = n(o), g = r) : (h = n(o), m = t);
    var y = null;
    if (s) {
      var v = function (e) {
        var r = e.axis,
          t = e.width,
          i = e.height,
          n = e.position,
          o = e.offsetX,
          a = e.offsetY,
          l = e.orientation,
          s = 0,
          d = 0,
          u = "vertical" === l ? -90 : 0,
          c = "start";
        if ("x" === r) switch (n) {
          case "top-left":
            s = -o, d = a, c = "end";
            break;
          case "top":
            d = -a, c = "horizontal" === l ? "middle" : "start";
            break;
          case "top-right":
            s = o, d = a, c = "horizontal" === l ? "start" : "end";
            break;
          case "right":
            s = o, d = i / 2, c = "horizontal" === l ? "start" : "middle";
            break;
          case "bottom-right":
            s = o, d = i - a, c = "start";
            break;
          case "bottom":
            d = i + a, c = "horizontal" === l ? "middle" : "end";
            break;
          case "bottom-left":
            d = i - a, s = -o, c = "horizontal" === l ? "end" : "start";
            break;
          case "left":
            s = -o, d = i / 2, c = "horizontal" === l ? "end" : "middle";
        } else switch (n) {
          case "top-left":
            s = o, d = -a, c = "start";
            break;
          case "top":
            s = t / 2, d = -a, c = "horizontal" === l ? "middle" : "start";
            break;
          case "top-right":
            s = t - o, d = -a, c = "horizontal" === l ? "end" : "start";
            break;
          case "right":
            s = t + o, c = "horizontal" === l ? "start" : "middle";
            break;
          case "bottom-right":
            s = t - o, d = a, c = "end";
            break;
          case "bottom":
            s = t / 2, d = a, c = "horizontal" === l ? "middle" : "end";
            break;
          case "bottom-left":
            s = o, d = a, c = "horizontal" === l ? "start" : "end";
            break;
          case "left":
            s = -o, c = "horizontal" === l ? "end" : "middle";
        }
        return {
          x: s,
          y: d,
          rotation: u,
          textAnchor: c
        };
      }({
        axis: i,
        width: r,
        height: t,
        position: d,
        offsetX: u,
        offsetY: c,
        orientation: f
      });
      y = jsx("text", {
        transform: "translate(" + v.x + ", " + v.y + ") rotate(" + v.rotation + ")",
        textAnchor: v.textAnchor,
        dominantBaseline: "central",
        style: l,
        children: s
      });
    }
    return jsxs("g", {
      transform: "translate(" + h + ", " + b + ")",
      children: [jsx("line", {
        x1: 0,
        x2: g,
        y1: 0,
        y2: m,
        stroke: p.markers.lineColor,
        strokeWidth: p.markers.lineStrokeWidth,
        style: a
      }), y]
    });
  };
Ci.propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  axis: PropTypes.oneOf(["x", "y"]).isRequired,
  scale: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
  lineStyle: PropTypes.object,
  textStyle: PropTypes.object,
  legend: PropTypes.string,
  legendPosition: PropTypes.oneOf(["top-left", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left"]),
  legendOffsetX: PropTypes.number.isRequired,
  legendOffsetY: PropTypes.number.isRequired,
  legendOrientation: PropTypes.oneOf(["horizontal", "vertical"]).isRequired
}, Ci.defaultProps = {
  legendPosition: "top-right",
  legendOffsetX: 14,
  legendOffsetY: 14,
  legendOrientation: "horizontal"
};
var zi = /*#__PURE__*/memo(Ci),
  Pi = function Pi(e) {
    var r = e.markers,
      t = e.width,
      i = e.height,
      n = e.xScale,
      o = e.yScale;
    return r && 0 !== r.length ? r.map(function (e, r) {
      return jsx(zi, Sr({}, e, {
        width: t,
        height: i,
        scale: "y" === e.axis ? o : n
      }), r);
    }) : null;
  };
Pi.propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  xScale: PropTypes.func.isRequired,
  yScale: PropTypes.func.isRequired,
  markers: PropTypes.arrayOf(PropTypes.shape({
    axis: PropTypes.oneOf(["x", "y"]).isRequired,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
    lineStyle: PropTypes.object,
    textStyle: PropTypes.object
  }))
};
var Ti = /*#__PURE__*/memo(Pi),
  Si = ["theme", "renderWrapper", "animate", "motionConfig"],
  Mi = function Mi(e) {
    return function (r) {
      var t, i;
      function n() {
        return r.apply(this, arguments) || this;
      }
      return i = r, (t = n).prototype = Object.create(i.prototype), t.prototype.constructor = t, Mr(t, i), n.prototype.render = function () {
        var r = this.props,
          t = r.theme,
          i = r.renderWrapper,
          n = r.animate,
          o = r.motionConfig,
          a = jr(r, Si);
        return jsx(Ht, {
          theme: t,
          renderWrapper: i,
          isInteractive: a.isInteractive,
          animate: n,
          motionConfig: o,
          children: jsx(e, Sr({}, a))
        });
      }, n;
    }(Component);
  },
  ji = function ji(e, r) {
    var t,
      i = Qe$1(e) ? e : function (r) {
        return we$1(r, e);
      };
    return r && (t = Qe$1(r) ? r : format(r)), t ? function (e) {
      return t(i(e));
    } : i;
  },
  Bi = function Bi(e) {
    return Qe$1(e) ? e : function (r) {
      return we$1(r, e);
    };
  },
  Gi = function Gi(e) {
    return useMemo(function () {
      return Bi(e);
    }, [e]);
  },
  Ai = function Ai(e, r, t, i, n, o) {
    return e <= n && n <= e + t && r <= o && o <= r + i;
  },
  Fi = function Fi(e, r) {
    var t,
      i = r.clientX,
      n = r.clientY,
      o = e.getBoundingClientRect(),
      a = (t = void 0 !== e.getBBox ? e.getBBox() : {
        width: e.offsetWidth,
        height: e.offsetHeight
      }).width === o.width ? 1 : t.width / o.width;
    return [(i - o.left) * a, (n - o.top) * a];
  },
  Ei = Object.keys(ei),
  Ui = Object.keys(yi),
  Xi = function Xi(e, r, t) {
    if ("*" === e) return !0;
    if (Qe$1(e)) return e(r);
    if (Oe$1(e)) {
      var i = t ? we$1(r, t) : r;
      return Tr(Pr(i, Object.keys(e)), e);
    }
    return !1;
  },
  Hi = function Hi(e, r, t, i) {
    var n = void 0 === i ? {} : i,
      o = n.dataKey,
      a = n.colorKey,
      l = void 0 === a ? "color" : a,
      s = n.targetKey,
      d = void 0 === s ? "fill" : s,
      u = [],
      c = {};
    return e.length && r.length && (u = [].concat(e), r.forEach(function (r) {
      for (var i = function i() {
          var i = t[n],
            a = i.id,
            s = i.match;
          if (Xi(s, r, o)) {
            var f = e.find(function (e) {
              return e.id === a;
            });
            if (f) if (Ui.includes(f.type)) {
              if ("inherit" === f.background || "inherit" === f.color) {
                var p = we$1(r, l),
                  h = f.background,
                  g = f.color,
                  b = a;
                "inherit" === f.background && (b = b + ".bg." + p, h = p), "inherit" === f.color && (b = b + ".fg." + p, g = p), v$3(r, d, "url(#" + b + ")"), c[b] || (u.push(Sr({}, f, {
                  id: b,
                  background: h,
                  color: g
                })), c[b] = 1);
              } else v$3(r, d, "url(#" + a + ")");
            } else if (Ei.includes(f.type)) {
              if (f.colors.map(function (e) {
                return e.color;
              }).includes("inherit")) {
                var m = we$1(r, l),
                  R = a,
                  q = Sr({}, f, {
                    colors: f.colors.map(function (e, r) {
                      return "inherit" !== e.color ? e : (R = R + "." + r + "." + m, Sr({}, e, {
                        color: "inherit" === e.color ? m : e.color
                      }));
                    })
                  });
                q.id = R, v$3(r, d, "url(#" + R + ")"), c[R] || (u.push(q), c[R] = 1);
              } else v$3(r, d, "url(#" + a + ")");
            }
            return "break";
          }
        }, n = 0; n < t.length; n++) {
        if ("break" === i()) break;
      }
    })), u;
  };

function colors (specifier) {
  var n = specifier.length / 6 | 0,
    colors = new Array(n),
    i = 0;
  while (i < n) colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
  return colors;
}

var e = colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");

var r$1 = colors("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666");

var n$1 = colors("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666");

var t$1 = colors("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928");

var o = colors("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2");

var i = colors("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc");

var u$1 = colors("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999");

var a$1 = colors("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3");

var l = colors("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");

var ramp$1 = (function (scheme) {
  return rgbBasis$1(scheme[scheme.length - 1]);
});

var scheme$q = new Array(3).concat("d8b365f5f5f55ab4ac", "a6611adfc27d80cdc1018571", "a6611adfc27df5f5f580cdc1018571", "8c510ad8b365f6e8c3c7eae55ab4ac01665e", "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e", "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e", "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e", "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30", "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30").map(colors);
var b$6 = ramp$1(scheme$q);

var scheme$p = new Array(3).concat("af8dc3f7f7f77fbf7b", "7b3294c2a5cfa6dba0008837", "7b3294c2a5cff7f7f7a6dba0008837", "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837", "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837", "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837", "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837", "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b", "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b").map(colors);
var v$2 = ramp$1(scheme$p);

var scheme$o = new Array(3).concat("e9a3c9f7f7f7a1d76a", "d01c8bf1b6dab8e1864dac26", "d01c8bf1b6daf7f7f7b8e1864dac26", "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221", "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221", "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221", "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221", "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419", "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419").map(colors);
var _$1 = ramp$1(scheme$o);

var scheme$n = new Array(3).concat("998ec3f7f7f7f1a340", "5e3c99b2abd2fdb863e66101", "5e3c99b2abd2f7f7f7fdb863e66101", "542788998ec3d8daebfee0b6f1a340b35806", "542788998ec3d8daebf7f7f7fee0b6f1a340b35806", "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806", "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806", "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08", "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08").map(colors);
var w$2 = ramp$1(scheme$n);

var scheme$m = new Array(3).concat("ef8a62f7f7f767a9cf", "ca0020f4a58292c5de0571b0", "ca0020f4a582f7f7f792c5de0571b0", "b2182bef8a62fddbc7d1e5f067a9cf2166ac", "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac", "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac", "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac", "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061", "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061").map(colors);
var O$2 = ramp$1(scheme$m);

var scheme$l = new Array(3).concat("ef8a62ffffff999999", "ca0020f4a582bababa404040", "ca0020f4a582ffffffbababa404040", "b2182bef8a62fddbc7e0e0e09999994d4d4d", "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d", "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d", "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d", "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a", "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a").map(colors);
var k$4 = ramp$1(scheme$l);

var scheme$k = new Array(3).concat("fc8d59ffffbf91bfdb", "d7191cfdae61abd9e92c7bb6", "d7191cfdae61ffffbfabd9e92c7bb6", "d73027fc8d59fee090e0f3f891bfdb4575b4", "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4", "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4", "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4", "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695", "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695").map(colors);
var j$4 = ramp$1(scheme$k);

var scheme$j = new Array(3).concat("fc8d59ffffbf91cf60", "d7191cfdae61a6d96a1a9641", "d7191cfdae61ffffbfa6d96a1a9641", "d73027fc8d59fee08bd9ef8b91cf601a9850", "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850", "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850", "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850", "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837", "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837").map(colors);
var z$2 = ramp$1(scheme$j);

var scheme$i = new Array(3).concat("fc8d59ffffbf99d594", "d7191cfdae61abdda42b83ba", "d7191cfdae61ffffbfabdda42b83ba", "d53e4ffc8d59fee08be6f59899d5943288bd", "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd", "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd", "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd", "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2", "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2").map(colors);
var A$2 = ramp$1(scheme$i);

var scheme$h = new Array(3).concat("e5f5f999d8c92ca25f", "edf8fbb2e2e266c2a4238b45", "edf8fbb2e2e266c2a42ca25f006d2c", "edf8fbccece699d8c966c2a42ca25f006d2c", "edf8fbccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b").map(colors);
var ue$1 = ramp$1(scheme$h);

var scheme$g = new Array(3).concat("e0ecf49ebcda8856a7", "edf8fbb3cde38c96c688419d", "edf8fbb3cde38c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b").map(colors);
var ae$1 = ramp$1(scheme$g);

var scheme$f = new Array(3).concat("e0f3dba8ddb543a2ca", "f0f9e8bae4bc7bccc42b8cbe", "f0f9e8bae4bc7bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081").map(colors);
var le$1 = ramp$1(scheme$f);

var scheme$e = new Array(3).concat("fee8c8fdbb84e34a33", "fef0d9fdcc8afc8d59d7301f", "fef0d9fdcc8afc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000").map(colors);
var se$1 = ramp$1(scheme$e);

var scheme$d = new Array(3).concat("ece2f0a6bddb1c9099", "f6eff7bdc9e167a9cf02818a", "f6eff7bdc9e167a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636").map(colors);
var ce$1 = ramp$1(scheme$d);

var scheme$c = new Array(3).concat("ece7f2a6bddb2b8cbe", "f1eef6bdc9e174a9cf0570b0", "f1eef6bdc9e174a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858").map(colors);
var fe$1 = ramp$1(scheme$c);

var scheme$b = new Array(3).concat("e7e1efc994c7dd1c77", "f1eef6d7b5d8df65b0ce1256", "f1eef6d7b5d8df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f").map(colors);
var pe$1 = ramp$1(scheme$b);

var scheme$a = new Array(3).concat("fde0ddfa9fb5c51b8a", "feebe2fbb4b9f768a1ae017e", "feebe2fbb4b9f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a").map(colors);
var de$1 = ramp$1(scheme$a);

var scheme$9 = new Array(3).concat("edf8b17fcdbb2c7fb8", "ffffcca1dab441b6c4225ea8", "ffffcca1dab441b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58").map(colors);
var me$1 = ramp$1(scheme$9);

var scheme$8 = new Array(3).concat("f7fcb9addd8e31a354", "ffffccc2e69978c679238443", "ffffccc2e69978c67931a354006837", "ffffccd9f0a3addd8e78c67931a354006837", "ffffccd9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529").map(colors);
var he$1 = ramp$1(scheme$8);

var scheme$7 = new Array(3).concat("fff7bcfec44fd95f0e", "ffffd4fed98efe9929cc4c02", "ffffd4fed98efe9929d95f0e993404", "ffffd4fee391fec44ffe9929d95f0e993404", "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506").map(colors);
var ge$1 = ramp$1(scheme$7);

var scheme$6 = new Array(3).concat("ffeda0feb24cf03b20", "ffffb2fecc5cfd8d3ce31a1c", "ffffb2fecc5cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026").map(colors);
var ye$1 = ramp$1(scheme$6);

var scheme$5 = new Array(3).concat("deebf79ecae13182bd", "eff3ffbdd7e76baed62171b5", "eff3ffbdd7e76baed63182bd08519c", "eff3ffc6dbef9ecae16baed63182bd08519c", "eff3ffc6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b").map(colors);
var J$3 = ramp$1(scheme$5);

var scheme$4 = new Array(3).concat("e5f5e0a1d99b31a354", "edf8e9bae4b374c476238b45", "edf8e9bae4b374c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b").map(colors);
var K$4 = ramp$1(scheme$4);

var scheme$3 = new Array(3).concat("f0f0f0bdbdbd636363", "f7f7f7cccccc969696525252", "f7f7f7cccccc969696636363252525", "f7f7f7d9d9d9bdbdbd969696636363252525", "f7f7f7d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000").map(colors);
var L$2 = ramp$1(scheme$3);

var scheme$2 = new Array(3).concat("efedf5bcbddc756bb1", "f2f0f7cbc9e29e9ac86a51a3", "f2f0f7cbc9e29e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d").map(colors);
var Q$3 = ramp$1(scheme$2);

var scheme$1 = new Array(3).concat("fee0d2fc9272de2d26", "fee5d9fcae91fb6a4acb181d", "fee5d9fcae91fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d").map(colors);
var W$3 = ramp$1(scheme$1);

var scheme = new Array(3).concat("fee6cefdae6be6550d", "feeddefdbe85fd8d3cd94701", "feeddefdbe85fd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704").map(colors);
var N$4 = ramp$1(scheme);

function ne$1 (t) {
  t = Math.max(0, Math.min(1, t));
  return "rgb(" + Math.max(0, Math.min(255, Math.round(-4.54 - t * (35.34 - t * (2381.73 - t * (6402.7 - t * (7024.72 - t * 2710.57))))))) + ", " + Math.max(0, Math.min(255, Math.round(32.49 + t * (170.73 + t * (52.82 - t * (131.46 - t * (176.58 - t * 67.37))))))) + ", " + Math.max(0, Math.min(255, Math.round(81.24 + t * (442.36 - t * (2482.43 - t * (6167.24 - t * (6614.94 - t * 2475.67))))))) + ")";
}

function define (constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
}
function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}

function Color() {}
var _darker = 0.7;
var _brighter = 1 / _darker;
var reI = "\\s*([+-]?\\d+)\\s*",
  reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
  reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
  reHex = /^#([0-9a-f]{3,8})$/,
  reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
  reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
  reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
  reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
  reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
  reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");
var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};
define(Color, color, {
  copy: function copy(channels) {
    return Object.assign(new this.constructor(), this, channels);
  },
  displayable: function displayable() {
    return this.rgb().displayable();
  },
  hex: color_formatHex,
  // Deprecated! Use color.formatHex.
  formatHex: color_formatHex,
  formatHsl: color_formatHsl,
  formatRgb: color_formatRgb,
  toString: color_formatRgb
});
function color_formatHex() {
  return this.rgb().formatHex();
}
function color_formatHsl() {
  return hslConvert(this).formatHsl();
}
function color_formatRgb() {
  return this.rgb().formatRgb();
}
function color(format) {
  var m, l;
  format = (format + "").trim().toLowerCase();
  return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
  : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
  : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
  : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
  : null // invalid hex
  ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
  : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
  : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
  : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
  : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
  : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
  : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
  : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb();
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}
define(Rgb, rgb, extend(Color, {
  brighter: function brighter(k) {
    k = k == null ? _brighter : Math.pow(_brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function darker(k) {
    k = k == null ? _darker : Math.pow(_darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function rgb() {
    return this;
  },
  displayable: function displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: rgb_formatHex,
  // Deprecated! Use color.formatHex.
  formatHex: rgb_formatHex,
  formatRgb: rgb_formatRgb,
  toString: rgb_formatRgb
}));
function rgb_formatHex() {
  return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}
function rgb_formatRgb() {
  var a = this.opacity;
  a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
  return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
}
function hex(value) {
  value = Math.max(0, Math.min(255, Math.round(value) || 0));
  return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;else if (l <= 0 || l >= 1) h = s = NaN;else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}
function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl();
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
    g = o.g / 255,
    b = o.b / 255,
    min = Math.min(r, g, b),
    max = Math.max(r, g, b),
    h = NaN,
    s = max - min,
    l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;else if (g === max) h = (b - r) / s + 2;else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}
define(Hsl, hsl, extend(Color, {
  brighter: function brighter(k) {
    k = k == null ? _brighter : Math.pow(_brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function darker(k) {
    k = k == null ? _darker : Math.pow(_darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function rgb() {
    var h = this.h % 360 + (this.h < 0) * 360,
      s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
      l = this.l,
      m2 = l + (l < 0.5 ? l : 1 - l) * s,
      m1 = 2 * l - m2;
    return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
  },
  displayable: function displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl: function formatHsl() {
    var a = this.opacity;
    a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
  }
}));

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

var radians = Math.PI / 180;
var degrees = 180 / Math.PI;

var A$1 = -0.14861,
  B$3 = +1.78277,
  C$3 = -0.29227,
  D$4 = -0.90649,
  E$1 = +1.97294,
  ED = E$1 * D$4,
  EB = E$1 * B$3,
  BC_DA = B$3 * C$3 - D$4 * A$1;
function cubehelixConvert(o) {
  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Rgb)) o = rgbConvert(o);
  var r = o.r / 255,
    g = o.g / 255,
    b = o.b / 255,
    l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
    bl = b - l,
    k = (E$1 * (g - l) - C$3 * bl) / D$4,
    s = Math.sqrt(k * k + bl * bl) / (E$1 * l * (1 - l)),
    // NaN if l=0 or l=1
    h = s ? Math.atan2(k, bl) * degrees - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function cubehelix(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function Cubehelix(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}
define(Cubehelix, cubehelix, extend(Color, {
  brighter: function brighter(k) {
    k = k == null ? _brighter : Math.pow(_brighter, k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function darker(k) {
    k = k == null ? _darker : Math.pow(_darker, k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function rgb() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * radians,
      l = +this.l,
      a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
      cosh = Math.cos(h),
      sinh = Math.sin(h);
    return new Rgb(255 * (l + a * (A$1 * cosh + B$3 * sinh)), 255 * (l + a * (C$3 * cosh + D$4 * sinh)), 255 * (l + a * (E$1 * cosh)), this.opacity);
  }
}));

var ie = cubehelixLong(cubehelix(300, 0.5, 0.0), cubehelix(-240, 0.5, 1.0));

var warm = cubehelixLong(cubehelix(-100, 0.75, 0.35), cubehelix(80, 1.50, 0.8));
var cool = cubehelixLong(cubehelix(260, 0.75, 0.35), cubehelix(80, 1.50, 0.8));
var c$1 = cubehelix();
function be$1 (t) {
  if (t < 0 || t > 1) t -= Math.floor(t);
  var ts = Math.abs(t - 0.5);
  c$1.h = 360 * t - 100;
  c$1.s = 1.5 - 1.5 * ts;
  c$1.l = 0.8 - 0.9 * ts;
  return c$1 + "";
}

var c = rgb(),
  pi_1_3 = Math.PI / 3,
  pi_2_3 = Math.PI * 2 / 3;
function ve$1 (t) {
  var x;
  t = (0.5 - t) * Math.PI;
  c.r = 255 * (x = Math.sin(t)) * x;
  c.g = 255 * (x = Math.sin(t + pi_1_3)) * x;
  c.b = 255 * (x = Math.sin(t + pi_2_3)) * x;
  return c + "";
}

function X$5 (t) {
  t = Math.max(0, Math.min(1, t));
  return "rgb(" + Math.max(0, Math.min(255, Math.round(34.61 + t * (1172.33 - t * (10793.56 - t * (33300.12 - t * (38394.49 - t * 14825.05))))))) + ", " + Math.max(0, Math.min(255, Math.round(23.31 + t * (557.33 + t * (1225.33 - t * (3574.96 - t * (1073.77 + t * 707.56))))))) + ", " + Math.max(0, Math.min(255, Math.round(27.2 + t * (3211.1 - t * (15327.97 - t * (27814 - t * (22569.18 - t * 6838.66))))))) + ")";
}

function ramp(range) {
  var n = range.length;
  return function (t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
}
var Y$4 = ramp(colors("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
var magma = ramp(colors("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
var inferno = ramp(colors("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
var plasma = ramp(colors("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));

function qe$1() {
  return qe$1 = Object.assign ? Object.assign.bind() : function (e) {
    for (var r = 1; r < arguments.length; r++) {
      var n = arguments[r];
      for (var t in n) Object.prototype.hasOwnProperty.call(n, t) && (e[t] = n[t]);
    }
    return e;
  }, qe$1.apply(this, arguments);
}
function Se$1(e, r) {
  (null == r || r > e.length) && (r = e.length);
  for (var n = 0, t = new Array(r); n < r; n++) t[n] = e[n];
  return t;
}
function Re$1(e, r) {
  var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = function (e, r) {
    if (e) {
      if ("string" == typeof e) return Se$1(e, r);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Se$1(e, r) : void 0;
    }
  }(e)) || r && e && "number" == typeof e.length) {
    n && (e = n);
    var t = 0;
    return function () {
      return t >= e.length ? {
        done: !0
      } : {
        done: !1,
        value: e[t++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var Ce$1 = {
    nivo: ["#e8c1a0", "#f47560", "#f1e15b", "#e8a838", "#61cdbb", "#97e3d5"],
    category10: e,
    accent: r$1,
    dark2: n$1,
    paired: t$1,
    pastel1: o,
    pastel2: i,
    set1: u$1,
    set2: a$1,
    set3: l
  },
  Ge$1 = Object.keys(Ce$1),
  Ve = {
    brown_blueGreen: scheme$q,
    purpleRed_green: scheme$p,
    pink_yellowGreen: scheme$o,
    purple_orange: scheme$n,
    red_blue: scheme$m,
    red_grey: scheme$l,
    red_yellow_blue: scheme$k,
    red_yellow_green: scheme$j,
    spectral: scheme$i
  },
  Te$1 = Object.keys(Ve),
  Pe$1 = {
    brown_blueGreen: b$6,
    purpleRed_green: v$2,
    pink_yellowGreen: _$1,
    purple_orange: w$2,
    red_blue: O$2,
    red_grey: k$4,
    red_yellow_blue: j$4,
    red_yellow_green: z$2,
    spectral: A$2
  },
  Ue = {
    blues: scheme$5,
    greens: scheme$4,
    greys: scheme$3,
    oranges: scheme,
    purples: scheme$2,
    reds: scheme$1,
    blue_green: scheme$h,
    blue_purple: scheme$g,
    green_blue: scheme$f,
    orange_red: scheme$e,
    purple_blue_green: scheme$d,
    purple_blue: scheme$c,
    purple_red: scheme$b,
    red_purple: scheme$a,
    yellow_green_blue: scheme$9,
    yellow_green: scheme$8,
    yellow_orange_brown: scheme$7,
    yellow_orange_red: scheme$6
  },
  De = Object.keys(Ue),
  Me$1 = {
    blues: J$3,
    greens: K$4,
    greys: L$2,
    oranges: N$4,
    purples: Q$3,
    reds: W$3,
    turbo: X$5,
    viridis: Y$4,
    inferno: inferno,
    magma: magma,
    plasma: plasma,
    cividis: ne$1,
    warm: warm,
    cool: cool,
    cubehelixDefault: ie,
    blue_green: ue$1,
    blue_purple: ae$1,
    green_blue: le$1,
    orange_red: se$1,
    purple_blue_green: ce$1,
    purple_blue: fe$1,
    purple_red: pe$1,
    red_purple: de$1,
    yellow_green_blue: me$1,
    yellow_green: he$1,
    yellow_orange_brown: ge$1,
    yellow_orange_red: ye$1
  },
  $e = qe$1({}, Ce$1, Ve, Ue),
  Be$1 = Object.keys($e),
  Fe = function Fe(e) {
    return Ge$1.includes(e);
  },
  He = function He(e) {
    return Te$1.includes(e);
  },
  Je = function Je(e) {
    return De.includes(e);
  },
  Ke = {
    rainbow: be$1,
    sinebow: ve$1
  };
  qe$1({}, Pe$1, Me$1, Ke);
  var Qe = function Qe(e, r) {
    if ("function" == typeof e) return e;
    if (Oe$1(e)) {
      if (function (e) {
        return void 0 !== e.theme;
      }(e)) {
        if (void 0 === r) throw new Error("Unable to use color from theme as no theme was provided");
        var n = we$1(r, e.theme);
        if (void 0 === n) throw new Error("Color from theme is undefined at path: '" + e.theme + "'");
        return function () {
          return n;
        };
      }
      if (function (e) {
        return void 0 !== e.from;
      }(e)) {
        var t = function t(r) {
          return we$1(r, e.from);
        };
        if (Array.isArray(e.modifiers)) {
          for (var o, i = [], u = function u() {
              var e = o.value,
                r = e[0],
                n = e[1];
              if ("brighter" === r) i.push(function (e) {
                return e.brighter(n);
              });else if ("darker" === r) i.push(function (e) {
                return e.darker(n);
              });else {
                if ("opacity" !== r) throw new Error("Invalid color modifier: '" + r + "', must be one of: 'brighter', 'darker', 'opacity'");
                i.push(function (e) {
                  return e.opacity = n, e;
                });
              }
            }, a = Re$1(e.modifiers); !(o = a()).done;) u();
          return 0 === i.length ? t : function (e) {
            return i.reduce(function (e, r) {
              return r(e);
            }, rgb$3(t(e))).toString();
          };
        }
        return t;
      }
      throw new Error("Invalid color spec, you should either specify 'theme' or 'from' when using a config object");
    }
    return function () {
      return e;
    };
  },
  We$1 = function We(e, r) {
    return useMemo(function () {
      return Qe(e, r);
    }, [e, r]);
  },
  Xe = PropTypes.oneOfType([PropTypes.func, PropTypes.arrayOf(PropTypes.string), PropTypes.shape({
    scheme: PropTypes.oneOf(Be$1).isRequired,
    size: PropTypes.number
  }), PropTypes.shape({
    datum: PropTypes.string.isRequired
  }), PropTypes.string]);
  PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.shape({
    theme: PropTypes.string.isRequired
  }), PropTypes.shape({
    from: PropTypes.string.isRequired,
    modifiers: PropTypes.arrayOf(PropTypes.array)
  })]);
  var fr = function fr(e, r) {
    if ("function" == typeof e) return e;
    var n = "function" == typeof r ? r : function (e) {
      return we$1(e, r);
    };
    if (Array.isArray(e)) {
      var t = ordinal(e),
        o = function o(e) {
          return t(n(e));
        };
      return o.scale = t, o;
    }
    if (Oe$1(e)) {
      if (function (e) {
        return void 0 !== e.datum;
      }(e)) return function (r) {
        return we$1(r, e.datum);
      };
      if (function (e) {
        return void 0 !== e.scheme;
      }(e)) {
        if (Fe(e.scheme)) {
          var i = ordinal($e[e.scheme]),
            u = function u(e) {
              return i(n(e));
            };
          return u.scale = i, u;
        }
        if (He(e.scheme)) {
          if (void 0 !== e.size && (e.size < 3 || e.size > 11)) throw new Error("Invalid size '" + e.size + "' for diverging color scheme '" + e.scheme + "', must be between 3~11");
          var a = ordinal($e[e.scheme][e.size || 11]),
            l = function l(e) {
              return a(n(e));
            };
          return l.scale = a, l;
        }
        if (Je(e.scheme)) {
          if (void 0 !== e.size && (e.size < 3 || e.size > 9)) throw new Error("Invalid size '" + e.size + "' for sequential color scheme '" + e.scheme + "', must be between 3~9");
          var s = ordinal($e[e.scheme][e.size || 9]),
            c = function c(e) {
              return s(n(e));
            };
          return c.scale = s, c;
        }
      }
      throw new Error("Invalid colors, when using an object, you should either pass a 'datum' or a 'scheme' property");
    }
    return function () {
      return e;
    };
  },
  pr = function pr(e, r) {
    return useMemo(function () {
      return fr(e, r);
    }, [e, r]);
  };

function M$1() {
  return M$1 = Object.assign ? Object.assign.bind() : function (t) {
    for (var n = 1; n < arguments.length; n++) {
      var e = arguments[n];
      for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
    }
    return t;
  }, M$1.apply(this, arguments);
}
var k$3 = {
    pointerEvents: "none"
  },
  b$5 = function b(n) {
    var e = n.label,
      r = n.style,
      a = Et();
    return jsx(animated.g, {
      transform: r.transform,
      opacity: r.progress,
      style: k$3,
      children: jsx(animated.text, {
        textAnchor: "middle",
        dominantBaseline: "central",
        style: M$1({}, a.labels.text, {
          fill: r.textColor
        }),
        children: e
      })
    });
  },
  C$2 = function C(t) {
    var n = t % (2 * Math.PI);
    return n < 0 && (n += 2 * Math.PI), n;
  },
  L$1 = function L(t, n) {
    return t.filter(function (t) {
      return Math.abs(oi(t.arc.endAngle - t.arc.startAngle)) >= n;
    });
  },
  E = {
    startAngle: {
      enter: function enter(t) {
        return M$1({}, t, {
          endAngle: t.startAngle
        });
      },
      update: function update(t) {
        return t;
      },
      leave: function leave(t) {
        return M$1({}, t, {
          startAngle: t.endAngle
        });
      }
    },
    middleAngle: {
      enter: function enter(t) {
        var n = t.startAngle + (t.endAngle - t.startAngle) / 2;
        return M$1({}, t, {
          startAngle: n,
          endAngle: n
        });
      },
      update: function update(t) {
        return t;
      },
      leave: function leave(t) {
        var n = t.startAngle + (t.endAngle - t.startAngle) / 2;
        return M$1({}, t, {
          startAngle: n,
          endAngle: n
        });
      }
    },
    endAngle: {
      enter: function enter(t) {
        return M$1({}, t, {
          startAngle: t.endAngle
        });
      },
      update: function update(t) {
        return t;
      },
      leave: function leave(t) {
        return M$1({}, t, {
          endAngle: t.startAngle
        });
      }
    },
    innerRadius: {
      enter: function enter(t) {
        return M$1({}, t, {
          outerRadius: t.innerRadius
        });
      },
      update: function update(t) {
        return t;
      },
      leave: function leave(t) {
        return M$1({}, t, {
          innerRadius: t.outerRadius
        });
      }
    },
    centerRadius: {
      enter: function enter(t) {
        var n = t.innerRadius + (t.outerRadius - t.innerRadius) / 2;
        return M$1({}, t, {
          innerRadius: n,
          outerRadius: n
        });
      },
      update: function update(t) {
        return t;
      },
      leave: function leave(t) {
        var n = t.innerRadius + (t.outerRadius - t.innerRadius) / 2;
        return M$1({}, t, {
          innerRadius: n,
          outerRadius: n
        });
      }
    },
    outerRadius: {
      enter: function enter(t) {
        return M$1({}, t, {
          innerRadius: t.outerRadius
        });
      },
      update: function update(t) {
        return t;
      },
      leave: function leave(t) {
        return M$1({}, t, {
          outerRadius: t.innerRadius
        });
      }
    },
    pushIn: {
      enter: function enter(t) {
        return M$1({}, t, {
          innerRadius: t.innerRadius - t.outerRadius + t.innerRadius,
          outerRadius: t.innerRadius
        });
      },
      update: function update(t) {
        return t;
      },
      leave: function leave(t) {
        return M$1({}, t, {
          innerRadius: t.outerRadius,
          outerRadius: t.outerRadius + t.outerRadius - t.innerRadius
        });
      }
    },
    pushOut: {
      enter: function enter(t) {
        return M$1({}, t, {
          innerRadius: t.outerRadius,
          outerRadius: t.outerRadius + t.outerRadius - t.innerRadius
        });
      },
      update: function update(t) {
        return t;
      },
      leave: function leave(t) {
        return M$1({}, t, {
          innerRadius: t.innerRadius - t.outerRadius + t.innerRadius,
          outerRadius: t.innerRadius
        });
      }
    }
  },
  I$2 = function I(t, n) {
    return useMemo(function () {
      var e = E[t];
      return {
        enter: function enter(t) {
          return M$1({
            progress: 0
          }, e.enter(t.arc), n ? n.enter(t) : {});
        },
        update: function update(t) {
          return M$1({
            progress: 1
          }, e.update(t.arc), n ? n.update(t) : {});
        },
        leave: function leave(t) {
          return M$1({
            progress: 0
          }, e.leave(t.arc), n ? n.leave(t) : {});
        }
      };
    }, [t, n]);
  },
  T$3 = function T(t, n) {
    var e = ai(t) - Math.PI / 2,
      r = t.innerRadius + (t.outerRadius - t.innerRadius) * n;
    return li(e, r);
  },
  j$3 = function j(t) {
    return function (e, r, i, a) {
      return to([e, r, i, a], function (n, e, r, i) {
        var a = T$3({
          startAngle: n,
          endAngle: e,
          innerRadius: r,
          outerRadius: i
        }, t);
        return "translate(" + a.x + "," + a.y + ")";
      });
    };
  },
  W$2 = function W(t, n, r, i) {
    void 0 === n && (n = .5), void 0 === r && (r = "innerRadius");
    var a = Zr(),
      o = a.animate,
      u = a.config,
      l = I$2(r, i);
    return {
      transition: useTransition(t, {
        keys: function keys(t) {
          return t.id;
        },
        initial: l.update,
        from: l.enter,
        enter: l.update,
        update: l.update,
        leave: l.leave,
        config: u,
        immediate: !o
      }),
      interpolate: j$3(n)
    };
  },
  B$2 = function B(t) {
    var n = t.center,
      e = t.data,
      r = t.transitionMode,
      o = t.label,
      u = t.radiusOffset,
      l = t.skipAngle,
      s = t.textColor,
      f = t.component,
      c = void 0 === f ? b$5 : f,
      g = Gi(o),
      h = Et(),
      x = We$1(s, h),
      m = useMemo(function () {
        return e.filter(function (t) {
          return Math.abs(oi(t.arc.endAngle - t.arc.startAngle)) >= l;
        });
      }, [e, l]),
      y = W$2(m, u, r),
      k = y.transition,
      C = y.interpolate,
      L = c;
    return jsx("g", {
      transform: "translate(" + n[0] + "," + n[1] + ")",
      children: k(function (t, n) {
        return /*#__PURE__*/createElement(L, {
          key: n.id,
          datum: n,
          label: g(n),
          style: M$1({}, t, {
            transform: C(t.startAngle, t.endAngle, t.innerRadius, t.outerRadius),
            textColor: x(n)
          })
        });
      })
    });
  },
  G = function G(n) {
    var e = n.label,
      r = n.style,
      a = Et();
    return jsxs(animated.g, {
      opacity: r.opacity,
      children: [jsx(animated.path, {
        fill: "none",
        stroke: r.linkColor,
        strokeWidth: r.thickness,
        d: r.path
      }), jsx(animated.text, {
        transform: r.textPosition,
        textAnchor: r.textAnchor,
        dominantBaseline: "central",
        style: M$1({}, a.labels.text, {
          fill: r.textColor
        }),
        children: e
      })]
    });
  },
  q$1 = function q(t) {
    var n = C$2(t.startAngle + (t.endAngle - t.startAngle) / 2 - Math.PI / 2);
    return n < Math.PI / 2 || n > 1.5 * Math.PI ? "start" : "end";
  },
  D$3 = function D(t, n, e, r) {
    var i,
      a,
      u = C$2(t.startAngle + (t.endAngle - t.startAngle) / 2 - Math.PI / 2),
      l = li(u, t.outerRadius + n),
      s = li(u, t.outerRadius + n + e);
    return u < Math.PI / 2 || u > 1.5 * Math.PI ? (i = "after", a = {
      x: s.x + r,
      y: s.y
    }) : (i = "before", a = {
      x: s.x - r,
      y: s.y
    }), {
      side: i,
      points: [l, s, a]
    };
  },
  H$3 = H$4().x(function (t) {
    return t.x;
  }).y(function (t) {
    return t.y;
  }),
  J$2 = function J(t, e, r, i, a, o, u) {
    return to([t, e, r, i, a, o, u], function (t, n, e, r, i, a, o) {
      var u = D$3({
        startAngle: t,
        endAngle: n,
        innerRadius: e,
        outerRadius: r
      }, i, a, o).points;
      return H$3(u);
    });
  },
  K$3 = function K(t, e, r, i) {
    return to([t, e, r, i], function (t, n, e, r) {
      return q$1({
        startAngle: t,
        endAngle: n,
        innerRadius: e,
        outerRadius: r
      });
    });
  },
  N$3 = function N(t, e, r, i, a, o, u, l) {
    return to([t, e, r, i, a, o, u, l], function (t, n, e, r, i, a, o, u) {
      var l = D$3({
          startAngle: t,
          endAngle: n,
          innerRadius: e,
          outerRadius: r
        }, i, a, o),
        s = l.points,
        d = l.side,
        f = s[2];
      return "before" === d ? f.x -= u : f.x += u, "translate(" + f.x + "," + f.y + ")";
    });
  },
  Q$2 = function Q(t) {
    var n = t.data,
      r = t.offset,
      a = void 0 === r ? 0 : r,
      o = t.diagonalLength,
      u = t.straightLength,
      l = t.skipAngle,
      d = void 0 === l ? 0 : l,
      f = t.textOffset,
      c = t.linkColor,
      g = t.textColor,
      p = Zr(),
      h = p.animate,
      A = p.config,
      x = Et(),
      m = We$1(c, x),
      y = We$1(g, x),
      M = function (t, n) {
        return useMemo(function () {
          return L$1(t, n);
        }, [t, n]);
      }(n, d),
      k = function (t) {
        var n = t.offset,
          e = t.diagonalLength,
          r = t.straightLength,
          i = t.textOffset,
          a = t.getLinkColor,
          o = t.getTextColor;
        return useMemo(function () {
          return {
            enter: function enter(t) {
              return {
                startAngle: t.arc.startAngle,
                endAngle: t.arc.endAngle,
                innerRadius: t.arc.innerRadius,
                outerRadius: t.arc.outerRadius,
                offset: n,
                diagonalLength: 0,
                straightLength: 0,
                textOffset: i,
                linkColor: a(t),
                textColor: o(t),
                opacity: 0
              };
            },
            update: function update(t) {
              return {
                startAngle: t.arc.startAngle,
                endAngle: t.arc.endAngle,
                innerRadius: t.arc.innerRadius,
                outerRadius: t.arc.outerRadius,
                offset: n,
                diagonalLength: e,
                straightLength: r,
                textOffset: i,
                linkColor: a(t),
                textColor: o(t),
                opacity: 1
              };
            },
            leave: function leave(t) {
              return {
                startAngle: t.arc.startAngle,
                endAngle: t.arc.endAngle,
                innerRadius: t.arc.innerRadius,
                outerRadius: t.arc.outerRadius,
                offset: n,
                diagonalLength: 0,
                straightLength: 0,
                textOffset: i,
                linkColor: a(t),
                textColor: o(t),
                opacity: 0
              };
            }
          };
        }, [e, r, i, a, o, n]);
      }({
        offset: a,
        diagonalLength: o,
        straightLength: u,
        textOffset: f,
        getLinkColor: m,
        getTextColor: y
      });
    return {
      transition: useTransition(M, {
        keys: function keys(t) {
          return t.id;
        },
        initial: k.update,
        from: k.enter,
        enter: k.update,
        update: k.update,
        leave: k.leave,
        config: A,
        immediate: !h
      }),
      interpolateLink: J$2,
      interpolateTextAnchor: K$3,
      interpolateTextPosition: N$3
    };
  },
  U$1 = function U(t) {
    var n = t.center,
      e = t.data,
      r = t.label,
      i = t.skipAngle,
      a = t.offset,
      o = t.diagonalLength,
      u = t.straightLength,
      l = t.strokeWidth,
      s = t.textOffset,
      f = t.textColor,
      c = t.linkColor,
      g = t.component,
      h = void 0 === g ? G : g,
      v = Gi(r),
      x = Q$2({
        data: e,
        skipAngle: i,
        offset: a,
        diagonalLength: o,
        straightLength: u,
        textOffset: s,
        linkColor: c,
        textColor: f
      }),
      R = x.transition,
      m = x.interpolateLink,
      y = x.interpolateTextAnchor,
      k = x.interpolateTextPosition,
      b = h;
    return jsx("g", {
      transform: "translate(" + n[0] + "," + n[1] + ")",
      children: R(function (t, n) {
        return /*#__PURE__*/createElement(b, {
          key: n.id,
          datum: n,
          label: v(n),
          style: M$1({}, t, {
            thickness: l,
            path: m(t.startAngle, t.endAngle, t.innerRadius, t.outerRadius, t.offset, t.diagonalLength, t.straightLength),
            textAnchor: y(t.startAngle, t.endAngle, t.innerRadius, t.outerRadius),
            textPosition: k(t.startAngle, t.endAngle, t.innerRadius, t.outerRadius, t.offset, t.diagonalLength, t.straightLength, t.textOffset)
          })
        });
      })
    });
  },
  tt = function tt(n) {
    var e = n.datum,
      r = n.style,
      i = n.onClick,
      a = n.onMouseEnter,
      o = n.onMouseMove,
      u = n.onMouseLeave,
      l = useCallback(function (t) {
        return null == i ? void 0 : i(e, t);
      }, [i, e]),
      s = useCallback(function (t) {
        return null == a ? void 0 : a(e, t);
      }, [a, e]),
      d = useCallback(function (t) {
        return null == o ? void 0 : o(e, t);
      }, [o, e]),
      f = useCallback(function (t) {
        return null == u ? void 0 : u(e, t);
      }, [u, e]);
    return jsx(animated.path, {
      d: r.path,
      opacity: r.opacity,
      fill: e.fill || r.color,
      stroke: r.borderColor,
      strokeWidth: r.borderWidth,
      onClick: i ? l : void 0,
      onMouseEnter: a ? s : void 0,
      onMouseMove: o ? d : void 0,
      onMouseLeave: u ? f : void 0
    });
  },
  nt = function nt(t, e, r, i, a) {
    return to([t, e, r, i], function (t, n, e, r) {
      return a({
        startAngle: t,
        endAngle: n,
        innerRadius: Math.max(0, e),
        outerRadius: Math.max(0, r)
      });
    });
  },
  et = function et(t, n, r) {
    void 0 === n && (n = "innerRadius");
    var i = Zr(),
      a = i.animate,
      o = i.config,
      u = I$2(n, r);
    return {
      transition: useTransition(t, {
        keys: function keys(t) {
          return t.id;
        },
        initial: u.update,
        from: u.enter,
        enter: u.update,
        update: u.update,
        leave: u.leave,
        config: o,
        immediate: !a
      }),
      interpolate: nt
    };
  },
  rt = function rt(t) {
    var n = t.center,
      e = t.data,
      r = t.arcGenerator,
      a = t.borderWidth,
      o = t.borderColor,
      u = t.onClick,
      l = t.onMouseEnter,
      s = t.onMouseMove,
      d = t.onMouseLeave,
      f = t.transitionMode,
      c = t.component,
      g = void 0 === c ? tt : c,
      h = Et(),
      v = We$1(o, h),
      x = et(e, f, {
        enter: function enter(t) {
          return {
            opacity: 0,
            color: t.color,
            borderColor: v(t)
          };
        },
        update: function update(t) {
          return {
            opacity: 1,
            color: t.color,
            borderColor: v(t)
          };
        },
        leave: function leave(t) {
          return {
            opacity: 0,
            color: t.color,
            borderColor: v(t)
          };
        }
      }),
      m = x.transition,
      y = x.interpolate,
      k = g;
    return jsx("g", {
      transform: "translate(" + n[0] + "," + n[1] + ")",
      children: m(function (t, n) {
        return /*#__PURE__*/createElement(k, {
          key: n.id,
          datum: n,
          style: M$1({}, t, {
            borderWidth: a,
            path: y(t.startAngle, t.endAngle, t.innerRadius, t.outerRadius, r)
          }),
          onClick: u,
          onMouseEnter: l,
          onMouseMove: s,
          onMouseLeave: d
        });
      })
    });
  },
  it = function it(t, n, e, r, i, a) {
    void 0 === a && (a = !0);
    var l = [],
      s = li(ni(r), e);
    l.push([s.x, s.y]);
    var d = li(ni(i), e);
    l.push([d.x, d.y]);
    for (var f = Math.round(Math.min(r, i)); f <= Math.round(Math.max(r, i)); f++) if (f % 90 == 0) {
      var c = li(ni(f), e);
      l.push([c.x, c.y]);
    }
    l = l.map(function (e) {
      var r = e[0],
        i = e[1];
      return [t + r, n + i];
    }), a && l.push([t, n]);
    var g = l.map(function (t) {
        return t[0];
      }),
      p = l.map(function (t) {
        return t[1];
      }),
      h = Math.min.apply(Math, g),
      v = Math.max.apply(Math, g),
      A = Math.min.apply(Math, p);
    return {
      points: l,
      x: h,
      y: A,
      width: v - h,
      height: Math.max.apply(Math, p) - A
    };
  },
  lt = function lt(t) {
    var n = void 0 === t ? {} : t,
      e = n.cornerRadius,
      r = void 0 === e ? 0 : e,
      i = n.padAngle,
      a = void 0 === i ? 0 : i;
    return useMemo(function () {
      return y$2().innerRadius(function (t) {
        return t.innerRadius;
      }).outerRadius(function (t) {
        return t.outerRadius;
      }).cornerRadius(r).padAngle(a);
    }, [r, a]);
  };

var m = function m(e) {
    var i = e.x,
      n = e.y,
      o = e.size,
      r = e.fill,
      l = e.opacity,
      a = void 0 === l ? 1 : l,
      c = e.borderWidth,
      s = void 0 === c ? 0 : c,
      d = e.borderColor;
    return jsx("circle", {
      r: o / 2,
      cx: i + o / 2,
      cy: n + o / 2,
      fill: r,
      opacity: a,
      strokeWidth: s,
      stroke: void 0 === d ? "transparent" : d,
      style: {
        pointerEvents: "none"
      }
    });
  },
  f$1 = function f(e) {
    var i = e.x,
      n = e.y,
      o = e.size,
      r = e.fill,
      l = e.opacity,
      a = void 0 === l ? 1 : l,
      c = e.borderWidth,
      s = void 0 === c ? 0 : c,
      d = e.borderColor;
    return jsx("g", {
      transform: "translate(" + i + "," + n + ")",
      children: jsx("path", {
        d: "\n                    M" + o / 2 + " 0\n                    L" + .8 * o + " " + o / 2 + "\n                    L" + o / 2 + " " + o + "\n                    L" + .2 * o + " " + o / 2 + "\n                    L" + o / 2 + " 0\n                ",
        fill: r,
        opacity: a,
        strokeWidth: s,
        stroke: void 0 === d ? "transparent" : d,
        style: {
          pointerEvents: "none"
        }
      })
    });
  },
  u = function u(e) {
    var i = e.x,
      n = e.y,
      o = e.size,
      r = e.fill,
      l = e.opacity,
      a = void 0 === l ? 1 : l,
      c = e.borderWidth,
      s = void 0 === c ? 0 : c,
      d = e.borderColor;
    return jsx("rect", {
      x: i,
      y: n,
      fill: r,
      opacity: a,
      strokeWidth: s,
      stroke: void 0 === d ? "transparent" : d,
      width: o,
      height: o,
      style: {
        pointerEvents: "none"
      }
    });
  },
  v$1 = function v(e) {
    var i = e.x,
      n = e.y,
      o = e.size,
      r = e.fill,
      l = e.opacity,
      a = void 0 === l ? 1 : l,
      c = e.borderWidth,
      s = void 0 === c ? 0 : c,
      d = e.borderColor;
    return jsx("g", {
      transform: "translate(" + i + "," + n + ")",
      children: jsx("path", {
        d: "\n                M" + o / 2 + " 0\n                L" + o + " " + o + "\n                L0 " + o + "\n                L" + o / 2 + " 0\n            ",
        fill: r,
        opacity: a,
        strokeWidth: s,
        stroke: void 0 === d ? "transparent" : d,
        style: {
          pointerEvents: "none"
        }
      })
    });
  };
function p$2() {
  return p$2 = Object.assign ? Object.assign.bind() : function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var i = arguments[e];
      for (var n in i) Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n]);
    }
    return t;
  }, p$2.apply(this, arguments);
}
var b$4 = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  k$2 = function k(t) {
    var e,
      i = t.direction,
      n = t.itemsSpacing,
      o = t.padding,
      r = t.itemCount,
      l = t.itemWidth,
      a = t.itemHeight;
    if ("number" != typeof o && ("object" != _typeof$1(e = o) || Array.isArray(e) || null === e)) throw new Error("Invalid property padding, must be one of: number, object");
    var c = "number" == typeof o ? {
        top: o,
        right: o,
        bottom: o,
        left: o
      } : p$2({}, b$4, o),
      s = c.left + c.right,
      d = c.top + c.bottom,
      h = l + s,
      g = a + d,
      m = (r - 1) * n;
    return "row" === i ? h = l * r + m + s : "column" === i && (g = a * r + m + d), {
      width: h,
      height: g,
      padding: c
    };
  },
  x$2 = function x(t) {
    var e = t.anchor,
      i = t.translateX,
      n = t.translateY,
      o = t.containerWidth,
      r = t.containerHeight,
      l = t.width,
      a = t.height,
      c = i,
      s = n;
    switch (e) {
      case "top":
        c += (o - l) / 2;
        break;
      case "top-right":
        c += o - l;
        break;
      case "right":
        c += o - l, s += (r - a) / 2;
        break;
      case "bottom-right":
        c += o - l, s += r - a;
        break;
      case "bottom":
        c += (o - l) / 2, s += r - a;
        break;
      case "bottom-left":
        s += r - a;
        break;
      case "left":
        s += (r - a) / 2;
        break;
      case "center":
        c += (o - l) / 2, s += (r - a) / 2;
    }
    return {
      x: c,
      y: s
    };
  },
  S$2 = function S(t) {
    var e,
      i,
      n,
      o,
      r,
      l,
      a = t.direction,
      c = t.justify,
      s = t.symbolSize,
      d = t.symbolSpacing,
      h = t.width,
      g = t.height;
    switch (a) {
      case "left-to-right":
        e = 0, i = (g - s) / 2, o = g / 2, l = "central", c ? (n = h, r = "end") : (n = s + d, r = "start");
        break;
      case "right-to-left":
        e = h - s, i = (g - s) / 2, o = g / 2, l = "central", c ? (n = 0, r = "start") : (n = h - s - d, r = "end");
        break;
      case "top-to-bottom":
        e = (h - s) / 2, i = 0, n = h / 2, r = "middle", c ? (o = g, l = "alphabetic") : (o = s + d, l = "text-before-edge");
        break;
      case "bottom-to-top":
        e = (h - s) / 2, i = g - s, n = h / 2, r = "middle", c ? (o = 0, l = "text-before-edge") : (o = g - s - d, l = "alphabetic");
    }
    return {
      symbolX: e,
      symbolY: i,
      labelX: n,
      labelY: o,
      labelAnchor: r,
      labelAlignment: l
    };
  },
  C$1 = {
    circle: m,
    diamond: f$1,
    square: u,
    triangle: v$1
  },
  B$1 = function B(i) {
    var n,
      r,
      l,
      c,
      h,
      g,
      m,
      f,
      u,
      v,
      y,
      b = i.x,
      k = i.y,
      x = i.width,
      A = i.height,
      W = i.data,
      O = i.direction,
      z = void 0 === O ? "left-to-right" : O,
      B = i.justify,
      w = void 0 !== B && B,
      X = i.textColor,
      Y = i.background,
      H = void 0 === Y ? "transparent" : Y,
      E = i.opacity,
      j = void 0 === E ? 1 : E,
      T = i.symbolShape,
      L = void 0 === T ? "square" : T,
      M = i.symbolSize,
      F = void 0 === M ? 16 : M,
      P = i.symbolSpacing,
      R = void 0 === P ? 8 : P,
      q = i.symbolBorderWidth,
      V = void 0 === q ? 0 : q,
      D = i.symbolBorderColor,
      G = void 0 === D ? "transparent" : D,
      I = i.onClick,
      N = i.onMouseEnter,
      _ = i.onMouseLeave,
      J = i.toggleSerie,
      K = i.effects,
      Q = useState({}),
      U = Q[0],
      Z = Q[1],
      $ = Et(),
      tt = useCallback(function (t) {
        if (K) {
          var e = K.filter(function (t) {
            return "hover" === t.on;
          }).reduce(function (t, e) {
            return p$2({}, t, e.style);
          }, {});
          Z(e);
        }
        null == N || N(W, t);
      }, [N, W, K]),
      et = useCallback(function (t) {
        if (K) {
          var e = K.filter(function (t) {
            return "hover" !== t.on;
          }).reduce(function (t, e) {
            return p$2({}, t, e.style);
          }, {});
          Z(e);
        }
        null == _ || _(W, t);
      }, [_, W, K]),
      it = S$2({
        direction: z,
        justify: w,
        symbolSize: null != (n = U.symbolSize) ? n : F,
        symbolSpacing: R,
        width: x,
        height: A
      }),
      nt = it.symbolX,
      ot = it.symbolY,
      rt = it.labelX,
      lt = it.labelY,
      at = it.labelAnchor,
      ct = it.labelAlignment,
      st = [I, N, _, J].some(function (t) {
        return void 0 !== t;
      }),
      dt = "function" == typeof L ? L : C$1[L];
    return jsxs("g", {
      transform: "translate(" + b + "," + k + ")",
      style: {
        opacity: null != (r = U.itemOpacity) ? r : j
      },
      children: [jsx("rect", {
        width: x,
        height: A,
        fill: null != (l = U.itemBackground) ? l : H,
        style: {
          cursor: st ? "pointer" : "auto"
        },
        onClick: function onClick(t) {
          null == I || I(W, t), null == J || J(W.id);
        },
        onMouseEnter: tt,
        onMouseLeave: et
      }), /*#__PURE__*/React.createElement(dt, p$2({
        id: W.id,
        x: nt,
        y: ot,
        size: null != (c = U.symbolSize) ? c : F,
        fill: null != (h = null != (g = W.fill) ? g : W.color) ? h : "black",
        borderWidth: null != (m = U.symbolBorderWidth) ? m : V,
        borderColor: null != (f = U.symbolBorderColor) ? f : G
      }, W.hidden ? $.legends.hidden.symbol : void 0)), jsx("text", {
        textAnchor: at,
        style: p$2({}, $.legends.text, {
          fill: null != (u = null != (v = null != (y = U.itemTextColor) ? y : X) ? v : $.legends.text.fill) ? u : "black",
          dominantBaseline: ct,
          pointerEvents: "none",
          userSelect: "none"
        }, W.hidden ? $.legends.hidden.text : void 0),
        x: rt,
        y: lt,
        children: W.label
      })]
    });
  },
  w$1 = function w(e) {
    var i = e.data,
      n = e.x,
      o = e.y,
      r = e.direction,
      l = e.padding,
      a = void 0 === l ? 0 : l,
      c = e.justify,
      s = e.effects,
      d = e.itemWidth,
      h = e.itemHeight,
      g = e.itemDirection,
      m = void 0 === g ? "left-to-right" : g,
      f = e.itemsSpacing,
      u = void 0 === f ? 0 : f,
      v = e.itemTextColor,
      p = e.itemBackground,
      y = void 0 === p ? "transparent" : p,
      b = e.itemOpacity,
      x = void 0 === b ? 1 : b,
      S = e.symbolShape,
      A = e.symbolSize,
      W = e.symbolSpacing,
      O = e.symbolBorderWidth,
      z = e.symbolBorderColor,
      C = e.onClick,
      w = e.onMouseEnter,
      X = e.onMouseLeave,
      Y = e.toggleSerie,
      H = k$2({
        itemCount: i.length,
        itemWidth: d,
        itemHeight: h,
        itemsSpacing: u,
        direction: r,
        padding: a
      }).padding,
      E = "row" === r ? d + u : 0,
      j = "column" === r ? h + u : 0;
    return jsx("g", {
      transform: "translate(" + n + "," + o + ")",
      children: i.map(function (e, i) {
        return jsx(B$1, {
          data: e,
          x: i * E + H.left,
          y: i * j + H.top,
          width: d,
          height: h,
          direction: m,
          justify: c,
          effects: s,
          textColor: v,
          background: y,
          opacity: x,
          symbolShape: S,
          symbolSize: A,
          symbolSpacing: W,
          symbolBorderWidth: O,
          symbolBorderColor: z,
          onClick: C,
          onMouseEnter: w,
          onMouseLeave: X,
          toggleSerie: Y
        }, i);
      })
    });
  },
  X$4 = function X(e) {
    var i = e.data,
      n = e.containerWidth,
      o = e.containerHeight,
      r = e.translateX,
      l = void 0 === r ? 0 : r,
      a = e.translateY,
      c = void 0 === a ? 0 : a,
      s = e.anchor,
      d = e.direction,
      h = e.padding,
      g = void 0 === h ? 0 : h,
      m = e.justify,
      f = e.itemsSpacing,
      u = void 0 === f ? 0 : f,
      v = e.itemWidth,
      p = e.itemHeight,
      y = e.itemDirection,
      b = e.itemTextColor,
      S = e.itemBackground,
      A = e.itemOpacity,
      W = e.symbolShape,
      O = e.symbolSize,
      z = e.symbolSpacing,
      C = e.symbolBorderWidth,
      B = e.symbolBorderColor,
      X = e.onClick,
      Y = e.onMouseEnter,
      H = e.onMouseLeave,
      E = e.toggleSerie,
      j = e.effects,
      T = k$2({
        itemCount: i.length,
        itemsSpacing: u,
        itemWidth: v,
        itemHeight: p,
        direction: d,
        padding: g
      }),
      L = T.width,
      M = T.height,
      F = x$2({
        anchor: s,
        translateX: l,
        translateY: c,
        containerWidth: n,
        containerHeight: o,
        width: L,
        height: M
      }),
      P = F.x,
      R = F.y;
    return jsx(w$1, {
      data: i,
      x: P,
      y: R,
      direction: d,
      padding: g,
      justify: m,
      effects: j,
      itemsSpacing: u,
      itemWidth: v,
      itemHeight: p,
      itemDirection: y,
      itemTextColor: b,
      itemBackground: S,
      itemOpacity: A,
      symbolShape: W,
      symbolSize: O,
      symbolSpacing: z,
      symbolBorderWidth: C,
      symbolBorderColor: B,
      onClick: X,
      onMouseEnter: Y,
      onMouseLeave: H,
      toggleSerie: "boolean" == typeof E ? void 0 : E
    });
  },
  Y$3 = {
    start: "left",
    middle: "center",
    end: "right"
  },
  H$2 = function H(t, e) {
    var i = e.data,
      n = e.containerWidth,
      o = e.containerHeight,
      r = e.translateX,
      l = void 0 === r ? 0 : r,
      a = e.translateY,
      c = void 0 === a ? 0 : a,
      s = e.anchor,
      d = e.direction,
      h = e.padding,
      g = void 0 === h ? 0 : h,
      m = e.justify,
      f = void 0 !== m && m,
      u = e.itemsSpacing,
      v = void 0 === u ? 0 : u,
      p = e.itemWidth,
      y = e.itemHeight,
      b = e.itemDirection,
      A = void 0 === b ? "left-to-right" : b,
      W = e.itemTextColor,
      O = e.symbolSize,
      z = void 0 === O ? 16 : O,
      C = e.symbolSpacing,
      B = void 0 === C ? 8 : C,
      w = e.theme,
      X = k$2({
        itemCount: i.length,
        itemWidth: p,
        itemHeight: y,
        itemsSpacing: v,
        direction: d,
        padding: g
      }),
      H = X.width,
      E = X.height,
      j = X.padding,
      T = x$2({
        anchor: s,
        translateX: l,
        translateY: c,
        containerWidth: n,
        containerHeight: o,
        width: H,
        height: E
      }),
      L = T.x,
      M = T.y,
      F = "row" === d ? p + v : 0,
      P = "column" === d ? y + v : 0;
    t.save(), t.translate(L, M), t.font = w.legends.text.fontSize + "px " + (w.legends.text.fontFamily || "sans-serif"), i.forEach(function (e, i) {
      var n,
        o,
        r = i * F + j.left,
        l = i * P + j.top,
        a = S$2({
          direction: A,
          justify: f,
          symbolSize: z,
          symbolSpacing: B,
          width: p,
          height: y
        }),
        c = a.symbolX,
        s = a.symbolY,
        d = a.labelX,
        h = a.labelY,
        g = a.labelAnchor,
        m = a.labelAlignment;
      t.fillStyle = null != (n = e.color) ? n : "black", t.fillRect(r + c, l + s, z, z), t.textAlign = Y$3[g], "central" === m && (t.textBaseline = "middle"), t.fillStyle = null != (o = null != W ? W : w.legends.text.fill) ? o : "black", t.fillText(String(e.label), r + d, l + h);
    }), t.restore();
  },
  T$2 = {
    data: PropTypes.arrayOf(PropTypes.object),
    anchor: PropTypes.oneOf(["top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", "center"]).isRequired,
    translateX: PropTypes.number,
    translateY: PropTypes.number,
    direction: PropTypes.oneOf(["row", "column"]).isRequired,
    itemsSpacing: PropTypes.number,
    itemWidth: PropTypes.number.isRequired,
    itemHeight: PropTypes.number.isRequired,
    itemDirection: PropTypes.oneOf(["left-to-right", "right-to-left", "top-to-bottom", "bottom-to-top"]),
    itemTextColor: PropTypes.string,
    itemBackground: PropTypes.string,
    itemOpacity: PropTypes.number,
    symbolShape: PropTypes.oneOfType([PropTypes.oneOf(["circle", "diamond", "square", "triangle"]), PropTypes.func]),
    symbolSize: PropTypes.number,
    symbolSpacing: PropTypes.number,
    symbolBorderWidth: PropTypes.number,
    symbolBorderColor: PropTypes.string,
    onClick: PropTypes.func,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    effects: PropTypes.arrayOf(PropTypes.shape({
      on: PropTypes.oneOfType([PropTypes.oneOf(["hover"])]).isRequired,
      style: PropTypes.shape({
        itemTextColor: PropTypes.string,
        itemBackground: PropTypes.string,
        itemOpacity: PropTypes.number,
        symbolSize: PropTypes.number,
        symbolBorderWidth: PropTypes.number,
        symbolBorderColor: PropTypes.string
      }).isRequired
    }))
  };

function D$2() {
  return D$2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var i = 1; i < arguments.length; i++) {
      var n = arguments[i];
      for (var t in n) Object.prototype.hasOwnProperty.call(n, t) && (e[t] = n[t]);
    }
    return e;
  }, D$2.apply(this, arguments);
}
function F(e, i) {
  if (null == e) return {};
  var n,
    t,
    r = {},
    a = Object.keys(e);
  for (t = 0; t < a.length; t++) n = a[t], i.indexOf(n) >= 0 || (r[n] = e[n]);
  return r;
}
var H$1,
  X$3 = function X(e) {
    var i = e.width,
      n = e.height,
      t = e.legends,
      r = e.data,
      a = e.toggleSerie;
    return jsx(Fragment$1, {
      children: t.map(function (e, t) {
        var o;
        return jsx(X$4, D$2({}, e, {
          containerWidth: i,
          containerHeight: n,
          data: null != (o = e.data) ? o : r,
          toggleSerie: e.toggleSerie ? a : void 0
        }), t);
      })
    });
  },
  Y$2 = {
    id: "id",
    value: "value",
    sortByValue: !1,
    innerRadius: 0,
    padAngle: 0,
    cornerRadius: 0,
    layers: ["arcs", "arcLinkLabels", "arcLabels", "legends"],
    startAngle: 0,
    endAngle: 360,
    fit: !0,
    activeInnerRadiusOffset: 0,
    activeOuterRadiusOffset: 0,
    borderWidth: 0,
    borderColor: {
      from: "color",
      modifiers: [["darker", 1]]
    },
    enableArcLabels: !0,
    arcLabel: "formattedValue",
    arcLabelsSkipAngle: 0,
    arcLabelsRadiusOffset: .5,
    arcLabelsTextColor: {
      theme: "labels.text.fill"
    },
    enableArcLinkLabels: !0,
    arcLinkLabel: "id",
    arcLinkLabelsSkipAngle: 0,
    arcLinkLabelsOffset: 0,
    arcLinkLabelsDiagonalLength: 16,
    arcLinkLabelsStraightLength: 24,
    arcLinkLabelsThickness: 1,
    arcLinkLabelsTextOffset: 6,
    arcLinkLabelsTextColor: {
      theme: "labels.text.fill"
    },
    arcLinkLabelsColor: {
      theme: "axis.ticks.line.stroke"
    },
    colors: {
      scheme: "nivo"
    },
    defs: [],
    fill: [],
    isInteractive: !0,
    animate: !0,
    motionConfig: "gentle",
    transitionMode: "innerRadius",
    tooltip: function tooltip(e) {
      var i = e.datum;
      return jsx(w$3, {
        id: i.id,
        value: i.formattedValue,
        enableChip: !0,
        color: i.color
      });
    },
    legends: [],
    role: "img",
    pixelRatio: "undefined" != typeof window && null != (H$1 = window.devicePixelRatio) ? H$1 : 1
  },
  j$2 = ["points"],
  P$4 = function P(i) {
    var n = i.data,
      t = i.id,
      r = void 0 === t ? Y$2.id : t,
      a = i.value,
      o = void 0 === a ? Y$2.value : a,
      s = i.valueFormat,
      c = i.colors,
      u = void 0 === c ? Y$2.colors : c,
      v = Gi(r),
      f = Gi(o),
      g = Dt(s),
      L = pr(u, "id");
    return useMemo(function () {
      return n.map(function (e) {
        var i,
          n = v(e),
          t = f(e),
          r = {
            id: n,
            label: null != (i = e.label) ? i : n,
            hidden: !1,
            value: t,
            formattedValue: g(t),
            data: e
          };
        return D$2({}, r, {
          color: L(r)
        });
      });
    }, [n, v, f, g, L]);
  },
  q = function q(i) {
    var n = i.data,
      t = i.startAngle,
      r = i.endAngle,
      a = i.innerRadius,
      o = i.outerRadius,
      d = i.padAngle,
      l = i.sortByValue,
      u = i.activeId,
      v = i.activeInnerRadiusOffset,
      f = i.activeOuterRadiusOffset,
      g = i.hiddenIds,
      L = useMemo(function () {
        var e = T$4().value(function (e) {
          return e.value;
        }).startAngle(ni(t)).endAngle(ni(r)).padAngle(ni(d));
        return l || e.sortValues(null), e;
      }, [t, r, d, l]);
    return useMemo(function () {
      var e = n.filter(function (e) {
        return !g.includes(e.id);
      });
      return {
        dataWithArc: L(e).map(function (e) {
          var i = Math.abs(e.endAngle - e.startAngle);
          return D$2({}, e.data, {
            arc: {
              index: e.index,
              startAngle: e.startAngle,
              endAngle: e.endAngle,
              innerRadius: u === e.data.id ? a - v : a,
              outerRadius: u === e.data.id ? o + f : o,
              thickness: o - a,
              padAngle: e.padAngle,
              angle: i,
              angleDeg: oi(i)
            }
          });
        }),
        legendData: n.map(function (e) {
          return D$2({}, e, {
            hidden: g.includes(e.id)
          });
        })
      };
    }, [L, n, g, u, a, v, o, f]);
  },
  J$1 = function J(t) {
    var r = t.data,
      a = t.width,
      o = t.height,
      d = t.innerRadius,
      l = void 0 === d ? Y$2.innerRadius : d,
      c = t.startAngle,
      u = void 0 === c ? Y$2.startAngle : c,
      v = t.endAngle,
      f = void 0 === v ? Y$2.endAngle : v,
      g = t.padAngle,
      L = void 0 === g ? Y$2.padAngle : g,
      h = t.sortByValue,
      b = void 0 === h ? Y$2.sortByValue : h,
      A = t.cornerRadius,
      R = void 0 === A ? Y$2.cornerRadius : A,
      m = t.fit,
      O = void 0 === m ? Y$2.fit : m,
      C = t.activeInnerRadiusOffset,
      I = void 0 === C ? Y$2.activeInnerRadiusOffset : C,
      x = t.activeOuterRadiusOffset,
      M = void 0 === x ? Y$2.activeOuterRadiusOffset : x,
      y = useState(null),
      w = y[0],
      W = y[1],
      S = useState([]),
      T = S[0],
      V = S[1],
      B = useMemo(function () {
        var e,
          i = Math.min(a, o) / 2,
          n = i * Math.min(l, 1),
          t = a / 2,
          r = o / 2;
        if (O) {
          var d = it(t, r, i, u - 90, f - 90),
            s = d.points,
            c = F(d, j$2),
            v = Math.min(a / c.width, o / c.height),
            g = {
              width: c.width * v,
              height: c.height * v
            };
          g.x = (a - g.width) / 2, g.y = (o - g.height) / 2, t = (t - c.x) / c.width * c.width * v + g.x, r = (r - c.y) / c.height * c.height * v + g.y, e = {
            box: c,
            ratio: v,
            points: s
          }, i *= v, n *= v;
        }
        return {
          centerX: t,
          centerY: r,
          radius: i,
          innerRadius: n,
          debug: e
        };
      }, [a, o, l, u, f, O, R]),
      G = q({
        data: r,
        startAngle: u,
        endAngle: f,
        innerRadius: B.innerRadius,
        outerRadius: B.radius,
        padAngle: L,
        sortByValue: b,
        activeId: w,
        activeInnerRadiusOffset: I,
        activeOuterRadiusOffset: M,
        hiddenIds: T
      }),
      E = useCallback(function (e) {
        V(function (i) {
          return i.indexOf(e) > -1 ? i.filter(function (i) {
            return i !== e;
          }) : [].concat(i, [e]);
        });
      }, []);
    return D$2({
      arcGenerator: lt({
        cornerRadius: R,
        padAngle: ni(L)
      }),
      setActiveId: W,
      toggleSerie: E
    }, G, B);
  },
  K$2 = function K(i) {
    var n = i.dataWithArc,
      t = i.arcGenerator,
      r = i.centerX,
      a = i.centerY,
      o = i.radius,
      d = i.innerRadius;
    return useMemo(function () {
      return {
        dataWithArc: n,
        arcGenerator: t,
        centerX: r,
        centerY: a,
        radius: o,
        innerRadius: d
      };
    }, [n, t, r, a, o, d]);
  },
  N$2 = function N(i) {
    var n = i.center,
      r = i.data,
      a = i.arcGenerator,
      o = i.borderWidth,
      d = i.borderColor,
      l = i.isInteractive,
      s = i.onClick,
      c = i.onMouseEnter,
      u = i.onMouseMove,
      v = i.onMouseLeave,
      f = i.setActiveId,
      g = i.tooltip,
      L = i.transitionMode,
      h = k$5(),
      b = h.showTooltipFromEvent,
      p = h.hideTooltip,
      k = useMemo(function () {
        if (l) return function (e, i) {
          null == s || s(e, i);
        };
      }, [l, s]),
      R = useMemo(function () {
        if (l) return function (e, i) {
          b( /*#__PURE__*/createElement(g, {
            datum: e
          }), i), f(e.id), null == c || c(e, i);
        };
      }, [l, b, f, c, g]),
      m = useMemo(function () {
        if (l) return function (e, i) {
          b( /*#__PURE__*/createElement(g, {
            datum: e
          }), i), null == u || u(e, i);
        };
      }, [l, b, u, g]),
      O = useMemo(function () {
        if (l) return function (e, i) {
          p(), f(null), null == v || v(e, i);
        };
      }, [l, p, f, v]);
    return jsx(rt, {
      center: n,
      data: r,
      arcGenerator: a,
      borderWidth: o,
      borderColor: d,
      transitionMode: L,
      onClick: k,
      onMouseEnter: R,
      onMouseMove: m,
      onMouseLeave: O
    });
  },
  Q$1 = ["isInteractive", "animate", "motionConfig", "theme", "renderWrapper"],
  U = function U(e) {
    var i = e.data,
      n = e.id,
      a = void 0 === n ? Y$2.id : n,
      o = e.value,
      d = void 0 === o ? Y$2.value : o,
      l = e.valueFormat,
      s = e.sortByValue,
      c = void 0 === s ? Y$2.sortByValue : s,
      u = e.layers,
      L = void 0 === u ? Y$2.layers : u,
      h = e.startAngle,
      b = void 0 === h ? Y$2.startAngle : h,
      p = e.endAngle,
      k = void 0 === p ? Y$2.endAngle : p,
      A = e.padAngle,
      O = void 0 === A ? Y$2.padAngle : A,
      C = e.fit,
      I = void 0 === C ? Y$2.fit : C,
      x = e.innerRadius,
      M = void 0 === x ? Y$2.innerRadius : x,
      y = e.cornerRadius,
      w = void 0 === y ? Y$2.cornerRadius : y,
      S = e.activeInnerRadiusOffset,
      T = void 0 === S ? Y$2.activeInnerRadiusOffset : S,
      V = e.activeOuterRadiusOffset,
      B = void 0 === V ? Y$2.activeOuterRadiusOffset : V,
      G = e.width,
      E = e.height,
      D = e.margin,
      F = e.colors,
      H = void 0 === F ? Y$2.colors : F,
      j = e.borderWidth,
      q = void 0 === j ? Y$2.borderWidth : j,
      z = e.borderColor,
      Q = void 0 === z ? Y$2.borderColor : z,
      U = e.enableArcLabels,
      Z = void 0 === U ? Y$2.enableArcLabels : U,
      $ = e.arcLabel,
      _ = void 0 === $ ? Y$2.arcLabel : $,
      ee = e.arcLabelsSkipAngle,
      ie = void 0 === ee ? Y$2.arcLabelsSkipAngle : ee,
      ne = e.arcLabelsTextColor,
      te = void 0 === ne ? Y$2.arcLabelsTextColor : ne,
      re = e.arcLabelsRadiusOffset,
      ae = void 0 === re ? Y$2.arcLabelsRadiusOffset : re,
      oe = e.arcLabelsComponent,
      de = e.enableArcLinkLabels,
      le = void 0 === de ? Y$2.enableArcLinkLabels : de,
      se = e.arcLinkLabel,
      ce = void 0 === se ? Y$2.arcLinkLabel : se,
      ue = e.arcLinkLabelsSkipAngle,
      ve = void 0 === ue ? Y$2.arcLinkLabelsSkipAngle : ue,
      fe = e.arcLinkLabelsOffset,
      ge = void 0 === fe ? Y$2.arcLinkLabelsOffset : fe,
      Le = e.arcLinkLabelsDiagonalLength,
      he = void 0 === Le ? Y$2.arcLinkLabelsDiagonalLength : Le,
      be = e.arcLinkLabelsStraightLength,
      pe = void 0 === be ? Y$2.arcLinkLabelsStraightLength : be,
      ke = e.arcLinkLabelsThickness,
      Ae = void 0 === ke ? Y$2.arcLinkLabelsThickness : ke,
      Re = e.arcLinkLabelsTextOffset,
      me = void 0 === Re ? Y$2.arcLinkLabelsTextOffset : Re,
      Oe = e.arcLinkLabelsTextColor,
      Ce = void 0 === Oe ? Y$2.arcLinkLabelsTextColor : Oe,
      Ie = e.arcLinkLabelsColor,
      xe = void 0 === Ie ? Y$2.arcLinkLabelsColor : Ie,
      Me = e.arcLinkLabelComponent,
      ye = e.defs,
      we = void 0 === ye ? Y$2.defs : ye,
      We = e.fill,
      Se = void 0 === We ? Y$2.fill : We,
      Te = e.isInteractive,
      Ve = void 0 === Te ? Y$2.isInteractive : Te,
      Be = e.onClick,
      Ge = e.onMouseEnter,
      Ee = e.onMouseMove,
      De = e.onMouseLeave,
      Fe = e.tooltip,
      He = void 0 === Fe ? Y$2.tooltip : Fe,
      Xe = e.transitionMode,
      Ye = void 0 === Xe ? Y$2.transitionMode : Xe,
      je = e.legends,
      Pe = void 0 === je ? Y$2.legends : je,
      qe = e.role,
      ze = void 0 === qe ? Y$2.role : qe,
      Je = Bt(G, E, D),
      Ke = Je.outerWidth,
      Ne = Je.outerHeight,
      Qe = Je.margin,
      Ue = Je.innerWidth,
      Ze = Je.innerHeight,
      $e = P$4({
        data: i,
        id: a,
        value: d,
        valueFormat: l,
        colors: H
      }),
      _e = J$1({
        data: $e,
        width: Ue,
        height: Ze,
        fit: I,
        innerRadius: M,
        startAngle: b,
        endAngle: k,
        padAngle: O,
        sortByValue: c,
        cornerRadius: w,
        activeInnerRadiusOffset: T,
        activeOuterRadiusOffset: B
      }),
      ei = _e.dataWithArc,
      ii = _e.legendData,
      ni = _e.arcGenerator,
      ti = _e.centerX,
      ri = _e.centerY,
      ai = _e.radius,
      oi = _e.innerRadius,
      di = _e.setActiveId,
      li = _e.toggleSerie,
      si = Hi(we, ei, Se),
      ci = {
        arcs: null,
        arcLinkLabels: null,
        arcLabels: null,
        legends: null
      };
    L.includes("arcs") && (ci.arcs = jsx(N$2, {
      center: [ti, ri],
      data: ei,
      arcGenerator: ni,
      borderWidth: q,
      borderColor: Q,
      isInteractive: Ve,
      onClick: Be,
      onMouseEnter: Ge,
      onMouseMove: Ee,
      onMouseLeave: De,
      setActiveId: di,
      tooltip: He,
      transitionMode: Ye
    }, "arcs")), le && L.includes("arcLinkLabels") && (ci.arcLinkLabels = jsx(U$1, {
      center: [ti, ri],
      data: ei,
      label: ce,
      skipAngle: ve,
      offset: ge,
      diagonalLength: he,
      straightLength: pe,
      strokeWidth: Ae,
      textOffset: me,
      textColor: Ce,
      linkColor: xe,
      component: Me
    }, "arcLinkLabels")), Z && L.includes("arcLabels") && (ci.arcLabels = jsx(B$2, {
      center: [ti, ri],
      data: ei,
      label: _,
      radiusOffset: ae,
      skipAngle: ie,
      textColor: te,
      transitionMode: Ye,
      component: oe
    }, "arcLabels")), Pe.length > 0 && L.includes("legends") && (ci.legends = jsx(X$3, {
      width: Ue,
      height: Ze,
      data: ii,
      legends: Pe,
      toggleSerie: li
    }, "legends"));
    var ui = K$2({
      dataWithArc: ei,
      arcGenerator: ni,
      centerX: ti,
      centerY: ri,
      radius: ai,
      innerRadius: oi
    });
    return jsx(_i, {
      width: Ke,
      height: Ne,
      margin: Qe,
      defs: si,
      role: ze,
      children: L.map(function (e, i) {
        return void 0 !== ci[e] ? ci[e] : "function" == typeof e ? jsx(Fragment, {
          children: /*#__PURE__*/createElement(e, ui)
        }, i) : null;
      })
    });
  },
  Z = function Z(e) {
    var i = e.isInteractive,
      n = void 0 === i ? Y$2.isInteractive : i,
      t = e.animate,
      r = void 0 === t ? Y$2.animate : t,
      a = e.motionConfig,
      o = void 0 === a ? Y$2.motionConfig : a,
      d = e.theme,
      l = e.renderWrapper,
      s = F(e, Q$1);
    return jsx(Ht, {
      animate: r,
      isInteractive: n,
      motionConfig: o,
      renderWrapper: l,
      theme: d,
      children: jsx(U, D$2({
        isInteractive: n
      }, s))
    });
  },
  $$1 = function $(e) {
    return jsx(Jt, {
      children: function children(i) {
        var n = i.width,
          t = i.height;
        return jsx(Z, D$2({
          width: n,
          height: t
        }, e));
      }
    });
  };

var _templateObject$u;
var DonutChartWrapper = styled.div(_templateObject$u || (_templateObject$u = _taggedTemplateLiteral(["\n  ", ";\n\n  height: ", ";\n  width: 100%;\n\n  > div {\n    svg {\n      g {\n        > text {\n          color: ", " !important;\n          font-size: ", " !important;\n        }\n      }\n    }\n  }\n\n  @media (max-width: ", "px) {\n    height: ", ";\n  }\n\n  @media (max-width: ", "px) {\n    height: ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.typography.font();
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.spacing(43);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.grayG;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.toRem(14);
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.medium;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.spacing(35);
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.breakpoints.small;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.spacing(29);
});

var _templateObject$t, _templateObject2$f;
var TextCentered = styled.text(_templateObject$t || (_templateObject$t = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: ", ";\n  fill: ", ";\n\n  @media (max-width: ", "px) {\n    font-size: ", ";\n  }\n\n  @media (max-width: ", "px) {\n    font-size: ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.toRem(24);
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.typography.title.h2.fontWeight;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.grayI;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.medium;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.toRem(20);
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints.small;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.toRem(16);
});
var TitleCentered = styled.text(_templateObject2$f || (_templateObject2$f = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: ", ";;\n  fill: ", ";\n"])), function (_ref8) {
  var theme = _ref8.theme;
  return theme.toRem(14);
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.typography.title.h1.fontWeight;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.palette.grayG;
});

var DonutCenterData = function DonutCenterData(props) {
  var centerX = props.centerX,
    centerY = props.centerY,
    title = props.title,
    text = props.text;
  return /*#__PURE__*/React__default.createElement("svg", null, /*#__PURE__*/React__default.createElement(TitleCentered, {
    x: centerX,
    y: centerY - centerY * 0.13,
    textAnchor: "middle",
    dominantBaseline: "central"
  }, title), /*#__PURE__*/React__default.createElement(TextCentered, {
    x: centerX,
    y: centerY + centerY * 0.13,
    textAnchor: "middle",
    dominantBaseline: "central"
  }, text));
};
DonutCenterData.propTypes = {
  /**
   * The location of horizontally centered text
   */
  centerX: PropTypes.number,
  /**
   * The location of vertically centered text
   */
  centerY: PropTypes.number,
  /**
   * Title of the information represented within the donut chart
   */
  title: PropTypes.string,
  /**
   * Text of the information represented within the donut chart
   */
  text: PropTypes.string
};
DonutCenterData.defaultProps = {
  centerX: 0,
  centerY: 0,
  title: '',
  text: ''
};

var DonutChart = function DonutChart(props) {
  var donutChartData = props.donutChartData,
    title = props.title,
    text = props.text,
    margin = props.margin,
    borderRadius = props.borderRadius,
    width = props.width;
  var hasData = function hasData() {
    return donutChartData && donutChartData.length > 0;
  };
  var hasPercentage = useMemo(function () {
    var _donutChartData$;
    return hasData() && ((_donutChartData$ = donutChartData[0]) === null || _donutChartData$ === void 0 ? void 0 : _donutChartData$.label) !== '';
  }, [donutChartData]);
  var hasTotalData = useMemo(function () {
    return Boolean(title) || Boolean(text);
  }, [title, text]);
  var linePercentageSize = hasPercentage ? 16 : 0;
  var getDonutChartMargins = function getDonutChartMargins() {
    var donutChartMargin = hasPercentage ? 16 : 8;
    return {
      top: donutChartMargin,
      right: donutChartMargin,
      bottom: donutChartMargin,
      left: donutChartMargin
    };
  };
  var totalData = function totalData(_ref) {
    var centerX = _ref.centerX,
      centerY = _ref.centerY;
    if (hasTotalData) {
      return /*#__PURE__*/React__default.createElement(DonutCenterData, {
        centerX: centerX,
        centerY: centerY,
        title: title,
        text: text
      });
    }
    return null;
  };
  return /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: Boolean(hasData())
  }, /*#__PURE__*/React__default.createElement(DonutChartWrapper, null, /*#__PURE__*/React__default.createElement($$1, {
    data: donutChartData,
    colors: {
      datum: 'data.color'
    },
    margin: getDonutChartMargins(),
    animate: true,
    padAngle: margin,
    cornerRadius: borderRadius,
    innerRadius: width,
    startAngle: 0,
    endAngle: 360,
    borderWidth: 0,
    activeOuterRadiusOffset: 4,
    enableArcLabels: false,
    arcLinkLabel: "label",
    arcLinkLabelsDiagonalLength: 0,
    arcLinkLabelsStraightLength: linePercentageSize,
    arcLinkLabelsColor: {
      from: 'color'
    },
    layers: ['arcLinkLabels', 'arcs', 'arcLabels', 'legends', totalData]
  })));
};
DonutChart.propTypes = {
  /**
   * Provider of information that is used to fill out the donut chart,
   * which must arrive in the following way:
   *
   * - The `id` is the title of each element, a `string` value
   * - The `label` is the percentage of the value, a `string` value,
   *   if this value is empty, the graph will not display percentages
   * - The `value` is the value of the element, a `numerical` value
   * - The `color` is the fill color of each element, a `string` value
   */
  donutChartData: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string
  })),
  /**
   * Title of the information represented within the donut chart
   */
  title: PropTypes.string,
  /**
   * Text of the information represented within the donut chart
   */
  text: PropTypes.string,
  /**
   * The margin between the elements of the donut chart
   */
  margin: PropTypes.number,
  /**
   * The radial border between the elements of the donut chart
   */
  borderRadius: PropTypes.number,
  /**
   * The width of the donut chart
   */
  width: PropTypes.number
};
DonutChart.defaultProps = {
  donutChartData: null,
  title: '',
  text: '',
  margin: 0,
  borderRadius: 0,
  width: 0
};

var _templateObject$s, _templateObject2$e;
var StyledHorizontalCard = styled.div(_templateObject$s || (_templateObject$s = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  box-sizing: border-box;\n  box-shadow: 0 0 6px 0 rgba(", ", 0.05);\n  max-width: 100%;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  height: auto;\n\n  @media ", " {\n    flex-direction: row;\n\n    ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.background.hbBackgroundA;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.grayC;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.borderRadius();
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.getRgbColor(theme.palette.grayB);
}, device.tablet, function (_ref5) {
  var height = _ref5.height;
  return height && css(_templateObject2$e || (_templateObject2$e = _taggedTemplateLiteral(["\n      height: ", "px;\n    "])), height);
});

var _excluded$j = ["children"];
var HorizontalCard = function HorizontalCard(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$j);
  return /*#__PURE__*/React__default.createElement(StyledHorizontalCard, _extends$3({
    "data-testid": "horizontal-card"
  }, props), children);
};
HorizontalCard.propTypes = {
  /**
   *The content of the component
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
  /**
   * height of the component
   */
  height: PropTypes.number
};
HorizontalCard.defaultProps = {
  height: 264
};

var _templateObject$r, _templateObject2$d, _templateObject3$b;
var slideLeft = keyframes(_templateObject$r || (_templateObject$r = _taggedTemplateLiteral(["\n  from {\n    left: 100%;\n  }\n  to {\n    left: 0;\n  }\n"])));
var slideRight = keyframes(_templateObject2$d || (_templateObject2$d = _taggedTemplateLiteral(["\n  from {\n    left: -100%;\n  }\n\n  to {\n    left: 0;\n  }\n"])));
var SlidesStyled = styled.div(_templateObject3$b || (_templateObject3$b = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  padding: 24px 0;\n  box-sizing: border-box;\n  transition: all 0.5s ease;\n  z-index: 199;\n\n  &::after,\n  &::before {\n    position: absolute;\n    background-color: rgba(", ", 0.95);\n    content: \"\";\n    left: 0;\n    top: 0;\n    bottom: 0;\n    right: 0;\n  }\n\n  &::before {\n    background-color: transparent;\n    z-index: 20\n  }\n\n  .lightbox-container {\n    position: relative;\n    height: 100%;\n    box-sizing: border-box;\n  }\n\n  .ligthbox-inner {\n    padding: 0;\n    height: calc(100% - 48px);\n    box-sizing: border-box;\n    user-select: none;\n  }\n\n  .slides {\n    position: relative;\n    height: 100%;\n    padding: 0px;\n    margin: 0px;\n    overflow: hidden;\n    box-sizing: border-box;\n  }\n\n  .slide {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    opacity: 0;\n    z-index: 1;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    justify-content: center;\n  }\n\n  .showing-left {\n    opacity: 1;\n    animation: ", " 0.6s\n  }\n\n  .showing-right {\n    opacity: 1;\n    animation: ", " 0.6s\n  }\n\n  .arrows {\n    display: none;\n    position: absolute;\n    top: 50%;\n    left: 0;\n    right: 0;\n    z-index: 3;\n    justify-content: space-between;\n    z-index: 22;\n  }\n\n  .img {\n    object-fit: contain;\n    width: 100%;\n  }\n\n  .lightbox-close {\n    display: flex;\n    justify-content: flex-end;\n    position: relative;\n    right: 0;\n    z-index: 22;\n    padding-right: 24px;\n  }\n\n  .ligthbox-progress {\n    ", ";\n    font-size: ", "rem;\n    color: ", ";\n    margin: 0;\n    padding: 0;\n    position: absolute;\n    left: 0;\n    top: 60px;\n    width: 100%;\n    z-index: 22;\n    display: grid;\n    grid-gap: 8px;\n    grid-template-columns: repeat(3, max-content);\n    justify-content: center;\n  }\n\n  @media ", " {\n    padding: 49px;\n\n    .ligthbox-progress {\n      ", ";\n      font-size: ", "rem;\n      color: ", ";\n      bottom: 0;\n      top: unset;\n    }\n\n    .lightbox-close {\n      padding-right: 0;\n    }\n\n    .arrows {\n      display: flex;\n    }\n  }\n\n  @media (orientation: landscape) and (max-height:769px) {\n    .ligthbox-progress {\n      display: none;\n    }\n  }\n\n  @media (min-height: 769px) {\n    .ligthbox-inner {\n      padding: 9%;\n    }\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.getRgbColor(theme.palette.grayJ);
}, slideLeft, slideRight, function (_ref2) {
  var theme = _ref2.theme;
  return theme.typography.title.h3;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.typography.title.h3.fontSize;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.palette.primary.contrastText;
}, device.tablet, function (_ref5) {
  var theme = _ref5.theme;
  return theme.typography.title.h1;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.typography.title.h1.fontSize;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.palette.primary.contrastText;
});

var _excluded$i = ["children", "autoPlay", "displayArrows", "displayProgress", "slides", "enableKeyboard", "onClose", "intervalTime", "isOpen"];
var KEY_CODES = {
  ARROW_LEFT: 'ArrowLeft',
  ARROW_RIGHT: 'ArrowRight',
  ESCAPE: 'Escape'
};
var Lightbox = function Lightbox(props) {
  var children = props.children,
    autoPlay = props.autoPlay,
    displayArrows = props.displayArrows,
    displayProgress = props.displayProgress,
    slides = props.slides,
    enableKeyboard = props.enableKeyboard,
    onClose = props.onClose,
    intervalTime = props.intervalTime,
    isOpen = props.isOpen,
    rest = _objectWithoutProperties(props, _excluded$i);
  var _useState = useState('left'),
    _useState2 = _slicedToArray(_useState, 2),
    direction = _useState2[0],
    setDirection = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDragging = _useState4[0],
    setDragging = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    startClientX = _useState6[0],
    setStartX = _useState6[1];
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    distanceSwiped = _useState8[0],
    setDistanceSwiped = _useState8[1];
  var _useState9 = useState(0),
    _useState10 = _slicedToArray(_useState9, 2),
    currentSlide = _useState10[0],
    setCurrentSlide = _useState10[1];
  var wrapper = useRef();
  var totalSlides = slides.length > 0 ? slides.length : React__default.Children.count(children);
  var carouselTotalSlides = totalSlides - 1;
  var hasNextSlide = currentSlide < carouselTotalSlides;
  var hasPreviousSlide = currentSlide > 0;
  var handleClose = function handleClose() {
    setCurrentSlide(0);
    onClose();
  };
  var nextSlide = function nextSlide() {
    if (hasNextSlide) {
      setCurrentSlide(function (current) {
        return current + 1;
      });
    }
  };
  var loopSlides = function loopSlides() {
    setCurrentSlide(function (current) {
      return (current + 1) % carouselTotalSlides;
    });
  };
  var previousSlide = function previousSlide() {
    if (hasPreviousSlide) {
      setCurrentSlide(function (current) {
        return current - 1;
      });
    }
  };
  var next = function next() {
    nextSlide();
    setDirection('left');
  };
  var prev = function prev() {
    previousSlide();
    setDirection('right');
  };
  var handleKeydown = useCallback(function (event) {
    var key = event.key;
    if (key === KEY_CODES.ESCAPE) {
      handleClose();
    }
  }, []);
  useEffect(function () {
    var interval = null;
    if (autoPlay) {
      interval = setInterval(loopSlides, intervalTime);
    }
    return function () {
      clearInterval(interval);
    };
  }, []);
  useEffect(function () {
    if (enableKeyboard) {
      document.addEventListener('keydown', handleKeydown);
    }
    return function () {
      return document.addEventListener('keydown', handleKeydown);
    };
  }, [handleKeydown, enableKeyboard]);
  var startSwipe = function startSwipe(event) {
    var startingClientX = event.touches ? event.touches[0].pageX : event.clientX;
    setStartX(startingClientX);
    setDragging(true);
  };
  var endSwipe = function endSwipe() {
    var width = (wrapper && wrapper.current.clientWidth || 0) / slides.length;
    if (Math.abs(distanceSwiped) / width > 0.2) {
      if (distanceSwiped < 0) {
        next();
      } else {
        prev();
      }
    }
    setDragging(false);
    setStartX(0);
  };
  var swipe = function swipe(event) {
    var clientX = event.touches ? event.touches[0].pageX : event.clientX;
    if (!isDragging) {
      return;
    }
    var distance = clientX - startClientX;
    if (!autoPlay && !hasNextSlide && distance < 0) {
      return;
    }
    if (!autoPlay && !hasPreviousSlide && distance > 0) {
      return;
    }
    setDistanceSwiped(distance);
  };
  var classSlide = "showing-".concat(direction);
  var renderChildrens = function renderChildrens() {
    return React__default.Children.map(children, function (child, i) {
      var className = "slide ".concat(currentSlide === i ? classSlide : '');
      if ( /*#__PURE__*/React__default.isValidElement(child)) {
        return /*#__PURE__*/React__default.cloneElement( /*#__PURE__*/React__default.createElement("div", null), {
          className: className
        }, child);
      }
      return child;
    });
  };
  return isOpen && /*#__PURE__*/ReactDOM__default.createPortal( /*#__PURE__*/React__default.createElement(SlidesStyled, _extends$3({}, rest, {
    dir: "ltr",
    onMouseDown: startSwipe,
    onMouseMove: swipe,
    onMouseUp: endSwipe,
    onTouchStart: startSwipe,
    onTouchMove: swipe,
    onTouchEnd: endSwipe,
    onTouchCancel: endSwipe,
    ref: wrapper,
    role: "dialog",
    "aria-label": "Visor de fotos"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "lightbox-container"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "lightbox-close"
  }, /*#__PURE__*/React__default.createElement(IconButton, {
    disableFocus: true,
    onClick: handleClose,
    "aria-label": "Cerrar"
  }, /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(CrossIcon, {
    color: "white"
  })))), /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: displayArrows
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "arrows"
  }, /*#__PURE__*/React__default.createElement(IconButton, {
    disableFocus: true,
    onClick: prev,
    "aria-label": "Anterior"
  }, /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: hasPreviousSlide
  }, /*#__PURE__*/React__default.createElement(LeftArrowIcon, {
    color: "white",
    "aria-hidden": "true",
    role: "img"
  }))), /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: hasNextSlide
  }, /*#__PURE__*/React__default.createElement(IconButton, {
    disableFocus: true,
    onClick: next,
    "aria-label": "Siguiente"
  }, /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(RightArrowIcon, {
    color: "white",
    "aria-hidden": "true",
    role: "img"
  })))))), /*#__PURE__*/React__default.createElement("div", {
    className: "ligthbox-inner"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "slides"
  }, /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: totalSlides
  }, slides === null || slides === void 0 ? void 0 : slides.map(function (slide, i) {
    return /*#__PURE__*/React__default.createElement("figure", {
      key: slide.id,
      className: "slide ".concat(currentSlide === i ? classSlide : '')
    }, /*#__PURE__*/React__default.createElement("img", {
      className: "img",
      src: slide,
      alt: "Imagen de propiedad"
    }));
  })), /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: Boolean(children)
  }, renderChildrens()))), /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: displayProgress
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "ligthbox-progress",
    tabIndex: "-1",
    "aria-live": "polite",
    "aria-atomic": "true"
  }, /*#__PURE__*/React__default.createElement("span", {
    "aria-label": "Actual"
  }, currentSlide + 1), "/", /*#__PURE__*/React__default.createElement("span", {
    "aria-label": "Total"
  }, totalSlides))))), document.body);
};
Lightbox.propTypes = {
  /**
   * To indicate if arrows of navitagion is displayed
   */
  displayArrows: PropTypes.bool,
  /**
   * To display current slide of total slides
   */
  displayProgress: PropTypes.bool,
  /**
   * Change the slide automatically and going after the last item will move back to the first slide.
   */
  autoPlay: PropTypes.bool,
  /**
   * Allow use keyboard to close Carousel
   */
  enableKeyboard: PropTypes.bool,
  /**
   * Set to true for open lightbox
   */
  isOpen: PropTypes.bool,
  /**
   * Array of images to display on carousel
   */
  slides: PropTypes.arrayOf(PropTypes.string),
  /**
   * Function to close lightbox
   */
  onClose: PropTypes.func,
  /**
   * Time interval to change slides automatically if in autoplay
   */
  intervalTime: PropTypes.number,
  /**
   * The content of component
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)])
};
Lightbox.defaultProps = {
  autoPlay: false,
  displayArrows: true,
  displayProgress: false,
  slides: [],
  enableKeyboard: false,
  onClose: function onClose() {},
  children: null,
  intervalTime: 2000,
  isOpen: false
};

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop$2() {
  // No operation performed.
}
var noop_1 = noop$2;

var Set$1 = _Set,
  noop$1 = noop_1,
  setToArray$1 = _setToArray;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet$1 = !(Set$1 && 1 / setToArray$1(new Set$1([, -0]))[1] == INFINITY) ? noop$1 : function (values) {
  return new Set$1(values);
};
var _createSet = createSet$1;

var SetCache = _SetCache,
  arrayIncludes = _arrayIncludes,
  arrayIncludesWith = _arrayIncludesWith,
  cacheHas = _cacheHas,
  createSet = _createSet,
  setToArray = _setToArray;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq$2(array, iteratee, comparator) {
  var index = -1,
    includes = arrayIncludes,
    length = array.length,
    isCommon = true,
    result = [],
    seen = result;
  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  } else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache();
  } else {
    seen = iteratee ? [] : result;
  }
  outer: while (++index < length) {
    var value = array[index],
      computed = iteratee ? iteratee(value) : value;
    value = comparator || value !== 0 ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    } else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}
var _baseUniq = baseUniq$2;

var baseUniq$1 = _baseUniq;

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return array && array.length ? baseUniq$1(array) : [];
}
var uniq_1 = uniq;
var n = /*@__PURE__*/getDefaultExportFromCjs$1(uniq_1);

var Stack = _Stack,
  baseIsEqual$1 = _baseIsEqual;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$1 = 1,
  COMPARE_UNORDERED_FLAG$1 = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch$1(object, source, matchData, customizer) {
  var index = matchData.length,
    length = index,
    noCustomizer = !customizer;
  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
      objValue = object[key],
      srcValue = data[1];
    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack();
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined ? baseIsEqual$1(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack) : result)) {
        return false;
      }
    }
  }
  return true;
}
var _baseIsMatch = baseIsMatch$1;

var isObject = isObject_1;

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable$2(value) {
  return value === value && !isObject(value);
}
var _isStrictComparable = isStrictComparable$2;

var isStrictComparable$1 = _isStrictComparable,
  keys$1 = keys_1;

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData$1(object) {
  var result = keys$1(object),
    length = result.length;
  while (length--) {
    var key = result[length],
      value = object[key];
    result[length] = [key, value, isStrictComparable$1(value)];
  }
  return result;
}
var _getMatchData = getMatchData$1;

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable$2(key, srcValue) {
  return function (object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
  };
}
var _matchesStrictComparable = matchesStrictComparable$2;

var baseIsMatch = _baseIsMatch,
  getMatchData = _getMatchData,
  matchesStrictComparable$1 = _matchesStrictComparable;

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches$1(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable$1(matchData[0][0], matchData[0][1]);
  }
  return function (object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}
var _baseMatches = baseMatches$1;

var baseIsEqual = _baseIsEqual,
  get = get_1,
  hasIn = hasIn_1,
  isKey$1 = _isKey,
  isStrictComparable = _isStrictComparable,
  matchesStrictComparable = _matchesStrictComparable,
  toKey$1 = _toKey;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
  COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty$1(path, srcValue) {
  if (isKey$1(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey$1(path), srcValue);
  }
  return function (object) {
    var objValue = get(object, path);
    return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}
var _baseMatchesProperty = baseMatchesProperty$1;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty$1(key) {
  return function (object) {
    return object == null ? undefined : object[key];
  };
}
var _baseProperty = baseProperty$1;

var baseGet$1 = _baseGet;

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep$1(path) {
  return function (object) {
    return baseGet$1(object, path);
  };
}
var _basePropertyDeep = basePropertyDeep$1;

var baseProperty = _baseProperty,
  basePropertyDeep = _basePropertyDeep,
  isKey = _isKey,
  toKey = _toKey;

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property$1(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
var property_1 = property$1;

var baseMatches = _baseMatches,
  baseMatchesProperty = _baseMatchesProperty,
  identity$1 = identity_1,
  isArray$1 = isArray_1,
  property = property_1;

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee$2(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity$1;
  }
  if (_typeof$1(value) == 'object') {
    return isArray$1(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
  }
  return property(value);
}
var _baseIteratee = baseIteratee$2;

var baseIteratee$1 = _baseIteratee,
  baseUniq = _baseUniq;

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return array && array.length ? baseUniq(array, baseIteratee$1(iteratee)) : [];
}
var uniqBy_1 = uniqBy;
var t = /*@__PURE__*/getDefaultExportFromCjs$1(uniqBy_1);

var baseFor = _baseFor,
  keys = keys_1;

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn$1(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}
var _baseForOwn = baseForOwn$1;

var isArrayLike$1 = isArrayLike_1;

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach$1(eachFunc, fromRight) {
  return function (collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike$1(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
      index = fromRight ? length : -1,
      iterable = Object(collection);
    while (fromRight ? index-- : ++index < length) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}
var _createBaseEach = createBaseEach$1;

var baseForOwn = _baseForOwn,
  createBaseEach = _createBaseEach;

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach$1 = createBaseEach(baseForOwn);
var _baseEach = baseEach$1;

var baseEach = _baseEach,
  isArrayLike = isArrayLike_1;

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap$1(collection, iteratee) {
  var index = -1,
    result = isArrayLike(collection) ? Array(collection.length) : [];
  baseEach(collection, function (value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}
var _baseMap = baseMap$1;

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy$1(array, comparer) {
  var length = array.length;
  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}
var _baseSortBy = baseSortBy$1;

var isSymbol = isSymbol_1;

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending$1(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
      valIsNull = value === null,
      valIsReflexive = value === value,
      valIsSymbol = isSymbol(value);
    var othIsDefined = other !== undefined,
      othIsNull = other === null,
      othIsReflexive = other === other,
      othIsSymbol = isSymbol(other);
    if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
      return 1;
    }
    if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}
var _compareAscending = compareAscending$1;

var compareAscending = _compareAscending;

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple$1(object, other, orders) {
  var index = -1,
    objCriteria = object.criteria,
    othCriteria = other.criteria,
    length = objCriteria.length,
    ordersLength = orders.length;
  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}
var _compareMultiple = compareMultiple$1;

var arrayMap = _arrayMap,
  baseGet = _baseGet,
  baseIteratee = _baseIteratee,
  baseMap = _baseMap,
  baseSortBy = _baseSortBy,
  baseUnary$1 = _baseUnary,
  compareMultiple = _compareMultiple,
  identity = identity_1,
  isArray = isArray_1;

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy$1(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap(iteratees, function (iteratee) {
      if (isArray(iteratee)) {
        return function (value) {
          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
      }
      return iteratee;
    });
  } else {
    iteratees = [identity];
  }
  var index = -1;
  iteratees = arrayMap(iteratees, baseUnary$1(baseIteratee));
  var result = baseMap(collection, function (value, key, collection) {
    var criteria = arrayMap(iteratees, function (iteratee) {
      return iteratee(value);
    });
    return {
      'criteria': criteria,
      'index': ++index,
      'value': value
    };
  });
  return baseSortBy(result, function (object, other) {
    return compareMultiple(object, other, orders);
  });
}
var _baseOrderBy = baseOrderBy$1;

var baseFlatten = _baseFlatten,
  baseOrderBy = _baseOrderBy,
  baseRest = _baseRest,
  isIterateeCall = _isIterateeCall;

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */
var sortBy = baseRest(function (collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});
var sortBy_1 = sortBy;
var r = /*@__PURE__*/getDefaultExportFromCjs$1(sortBy_1);

var baseGetTag = _baseGetTag,
  isObjectLike = isObjectLike_1;

/** `Object#toString` result references. */
var dateTag = '[object Date]';

/**
 * The base implementation of `_.isDate` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 */
function baseIsDate$1(value) {
  return isObjectLike(value) && baseGetTag(value) == dateTag;
}
var _baseIsDate = baseIsDate$1;

var baseIsDate = _baseIsDate,
  baseUnary = _baseUnary,
  nodeUtil = _nodeUtilExports;

/* Node.js helper references. */
var nodeIsDate = nodeUtil && nodeUtil.isDate;

/**
 * Checks if `value` is classified as a `Date` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 * @example
 *
 * _.isDate(new Date);
 * // => true
 *
 * _.isDate('Mon April 23 2012');
 * // => false
 */
var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
var isDate_1 = isDate;
var a = /*@__PURE__*/getDefaultExportFromCjs$1(isDate_1);

var t0 = new Date(),
  t1 = new Date();
function newInterval(floori, offseti, count, field) {
  function interval(date) {
    return floori(date = arguments.length === 0 ? new Date() : new Date(+date)), date;
  }
  interval.floor = function (date) {
    return floori(date = new Date(+date)), date;
  };
  interval.ceil = function (date) {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };
  interval.round = function (date) {
    var d0 = interval(date),
      d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };
  interval.offset = function (date, step) {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };
  interval.range = function (start, stop, step) {
    var range = [],
      previous;
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
    do range.push(previous = new Date(+start)), offseti(start, step), floori(start); while (previous < start && start < stop);
    return range;
  };
  interval.filter = function (test) {
    return newInterval(function (date) {
      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
    }, function (date, step) {
      if (date >= date) {
        if (step < 0) while (++step <= 0) {
          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
        } else while (--step >= 0) {
          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
        }
      }
    });
  };
  if (count) {
    interval.count = function (start, end) {
      t0.setTime(+start), t1.setTime(+end);
      floori(t0), floori(t1);
      return Math.floor(count(t0, t1));
    };
    interval.every = function (step) {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function (d) {
        return field(d) % step === 0;
      } : function (d) {
        return interval.count(0, d) % step === 0;
      });
    };
  }
  return interval;
}

var millisecond = newInterval(function () {
  // noop
}, function (date, step) {
  date.setTime(+date + step);
}, function (start, end) {
  return end - start;
});

// An optimized implementation for this simple case.
millisecond.every = function (k) {
  k = Math.floor(k);
  if (!isFinite(k) || !(k > 0)) return null;
  if (!(k > 1)) return millisecond;
  return newInterval(function (date) {
    date.setTime(Math.floor(date / k) * k);
  }, function (date, step) {
    date.setTime(+date + step * k);
  }, function (start, end) {
    return (end - start) / k;
  });
};
var p$1 = millisecond;
millisecond.range;

var durationSecond = 1e3;
var durationMinute = 6e4;
var durationHour = 36e5;
var durationWeek = 6048e5;

var second = newInterval(function (date) {
  date.setTime(date - date.getMilliseconds());
}, function (date, step) {
  date.setTime(+date + step * durationSecond);
}, function (start, end) {
  return (end - start) / durationSecond;
}, function (date) {
  return date.getUTCSeconds();
});
var g$1 = second;
second.range;

var minute = newInterval(function (date) {
  date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond);
}, function (date, step) {
  date.setTime(+date + step * durationMinute);
}, function (start, end) {
  return (end - start) / durationMinute;
}, function (date) {
  return date.getMinutes();
});
var x$1 = minute;
minute.range;

var hour = newInterval(function (date) {
  date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond - date.getMinutes() * durationMinute);
}, function (date, step) {
  date.setTime(+date + step * durationHour);
}, function (start, end) {
  return (end - start) / durationHour;
}, function (date) {
  return date.getHours();
});
var T$1 = hour;
hour.range;

function weekday(i) {
  return newInterval(function (date) {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, function (date, step) {
    date.setDate(date.getDate() + step * 7);
  }, function (start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
  });
}
var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);
sunday.range;
monday.range;
tuesday.range;
wednesday.range;
thursday.range;
friday.range;
saturday.range;

var month = newInterval(function (date) {
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
}, function (date, step) {
  date.setMonth(date.getMonth() + step);
}, function (start, end) {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function (date) {
  return date.getMonth();
});
var N$1 = month;
month.range;

var year = newInterval(function (date) {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, function (date, step) {
  date.setFullYear(date.getFullYear() + step);
}, function (start, end) {
  return end.getFullYear() - start.getFullYear();
}, function (date) {
  return date.getFullYear();
});

// An optimized implementation for this simple case.
year.every = function (k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function (date) {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function (date, step) {
    date.setFullYear(date.getFullYear() + step * k);
  });
};
var I$1 = year;
year.range;

var utcMinute = newInterval(function (date) {
  date.setUTCSeconds(0, 0);
}, function (date, step) {
  date.setTime(+date + step * durationMinute);
}, function (start, end) {
  return (end - start) / durationMinute;
}, function (date) {
  return date.getUTCMinutes();
});
var k$1 = utcMinute;
utcMinute.range;

var utcHour = newInterval(function (date) {
  date.setUTCMinutes(0, 0, 0);
}, function (date, step) {
  date.setTime(+date + step * durationHour);
}, function (start, end) {
  return (end - start) / durationHour;
}, function (date) {
  return date.getUTCHours();
});
var b$3 = utcHour;
utcHour.range;

function utcWeekday(i) {
  return newInterval(function (date) {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, function (date, step) {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, function (start, end) {
    return (end - start) / durationWeek;
  });
}
var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);
utcSunday.range;
utcMonday.range;
utcTuesday.range;
utcWednesday.range;
utcThursday.range;
utcFriday.range;
utcSaturday.range;

var utcMonth = newInterval(function (date) {
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
}, function (date, step) {
  date.setUTCMonth(date.getUTCMonth() + step);
}, function (start, end) {
  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function (date) {
  return date.getUTCMonth();
});
var z$1 = utcMonth;
utcMonth.range;

var utcYear = newInterval(function (date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, function (date, step) {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, function (start, end) {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, function (date) {
  return date.getUTCFullYear();
});

// An optimized implementation for this simple case.
utcYear.every = function (k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function (date) {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function (date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};
var P$3 = utcYear;
utcYear.range;

function $() {
  return $ = Object.assign ? Object.assign.bind() : function (n) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var e in r) Object.prototype.hasOwnProperty.call(r, e) && (n[e] = r[e]);
    }
    return n;
  }, $.apply(this, arguments);
}
var J = [function (n) {
    return n.setMilliseconds(0);
  }, function (n) {
    return n.setSeconds(0);
  }, function (n) {
    return n.setMinutes(0);
  }, function (n) {
    return n.setHours(0);
  }, function (n) {
    return n.setDate(1);
  }, function (n) {
    return n.setMonth(0);
  }],
  K$1 = {
    millisecond: [],
    second: J.slice(0, 1),
    minute: J.slice(0, 2),
    hour: J.slice(0, 3),
    day: J.slice(0, 4),
    month: J.slice(0, 5),
    year: J.slice(0, 6)
  },
  L = function L(n) {
    return function (t) {
      return K$1[n].forEach(function (n) {
        n(t);
      }), t;
    };
  },
  Q = function Q(n) {
    var t = n.format,
      r = void 0 === t ? "native" : t,
      e = n.precision,
      a = void 0 === e ? "millisecond" : e,
      u = n.useUTC,
      c = void 0 === u || u,
      s = L(a);
    return function (n) {
      if (void 0 === n) return n;
      if ("native" === r || n instanceof Date) return s(n);
      var t = c ? utcParse(r) : timeParse(r);
      return s(t(n));
    };
  },
  W$1 = function W(n, t, r, e) {
    var a,
      i,
      o,
      c,
      s = n.min,
      d = void 0 === s ? 0 : s,
      f = n.max,
      l = void 0 === f ? "auto" : f,
      m = n.stacked,
      v = void 0 !== m && m,
      y = n.reverse,
      p = void 0 !== y && y,
      h = n.clamp,
      g = void 0 !== h && h,
      x = n.nice,
      k = void 0 !== x && x;
    "auto" === d ? a = !0 === v ? null != (i = t.minStacked) ? i : 0 : t.min : a = d;
    "auto" === l ? o = !0 === v ? null != (c = t.maxStacked) ? c : 0 : t.max : o = l;
    var T = linear$1().rangeRound("x" === e ? [0, r] : [r, 0]).domain(p ? [o, a] : [a, o]).clamp(g);
    return !0 === k ? T.nice() : "number" == typeof k && T.nice(k), X$2(T, v);
  },
  X$2 = function X(n, t) {
    void 0 === t && (t = !1);
    var r = n;
    return r.type = "linear", r.stacked = t, r;
  },
  Y$1 = function Y(n, t, r) {
    var e = point().range([0, r]).domain(t.all);
    return e.type = "point", e;
  },
  _ = function _(n, t, r, e) {
    var a = n.round,
      i = void 0 === a || a,
      o = band().range("x" === e ? [0, r] : [r, 0]).domain(t.all).round(i);
    return nn(o);
  },
  nn = function nn(n) {
    var t = n;
    return t.type = "band", t;
  },
  tn = function tn(n, t, r) {
    var e,
      a,
      i = n.format,
      o = void 0 === i ? "native" : i,
      u = n.precision,
      c = void 0 === u ? "millisecond" : u,
      s = n.min,
      l = void 0 === s ? "auto" : s,
      m = n.max,
      v = void 0 === m ? "auto" : m,
      y = n.useUTC,
      p = void 0 === y || y,
      h = n.nice,
      g = void 0 !== h && h,
      x = Q({
        format: o,
        precision: c,
        useUTC: p
      });
    e = "auto" === l ? x(t.min) : "native" !== o ? x(l) : l, a = "auto" === v ? x(t.max) : "native" !== o ? x(v) : v;
    var k = p ? utcTime() : time();
    k.range([0, r]), e && a && k.domain([e, a]), !0 === g ? k.nice() : "object" != _typeof$1(g) && "number" != typeof g || k.nice(g);
    var T = k;
    return T.type = "time", T.useUTC = p, T;
  },
  rn = function rn(n, t, r, e) {
    var a,
      i = n.base,
      o = void 0 === i ? 10 : i,
      u = n.min,
      c = void 0 === u ? "auto" : u,
      s = n.max,
      d = void 0 === s ? "auto" : s;
    if (t.all.some(function (n) {
      return 0 === n;
    })) throw new Error("a log scale domain must not include or cross zero");
    var f,
      m,
      v = !1;
    if (t.all.filter(function (n) {
      return null != n;
    }).forEach(function (n) {
      v || (void 0 === a ? a = Math.sign(n) : Math.sign(n) !== a && (v = !0));
    }), v) throw new Error("a log scale domain must be strictly-positive or strictly-negative");
    f = "auto" === c ? t.min : c, m = "auto" === d ? t.max : d;
    var y = log().domain([f, m]).rangeRound("x" === e ? [0, r] : [r, 0]).base(o).nice();
    return y.type = "log", y;
  },
  en = function en(n, t, r, e) {
    var a,
      i,
      o = n.constant,
      u = void 0 === o ? 1 : o,
      c = n.min,
      s = void 0 === c ? "auto" : c,
      d = n.max,
      f = void 0 === d ? "auto" : d,
      l = n.reverse,
      v = void 0 !== l && l;
    a = "auto" === s ? t.min : s, i = "auto" === f ? t.max : f;
    var y = symlog().constant(u).rangeRound("x" === e ? [0, r] : [r, 0]).nice();
    !0 === v ? y.domain([i, a]) : y.domain([a, i]);
    var p = y;
    return p.type = "symlog", p;
  },
  an = function an(n) {
    return "x" === n ? "y" : "x";
  },
  on = function on(n, t) {
    return n === t;
  },
  un = function un(n, t) {
    return n.getTime() === t.getTime();
  };
function cn(n, t, r, e) {
  switch (n.type) {
    case "linear":
      return W$1(n, t, r, e);
    case "point":
      return Y$1(n, t, r);
    case "band":
      return _(n, t, r, e);
    case "time":
      return tn(n, t, r);
    case "log":
      return rn(n, t, r, e);
    case "symlog":
      return en(n, t, r, e);
    default:
      throw new Error("invalid scale spec");
  }
}
var sn = function sn(n, t, r) {
    var e;
    if ("stacked" in r && r.stacked) {
      var a = n.data["x" === t ? "xStacked" : "yStacked"];
      return null == a ? null : r(a);
    }
    return null != (e = r(n.data[t])) ? e : null;
  },
  dn = function dn(n, t, r, e, a) {
    var i = n.map(function (n) {
        return function (n) {
          return $({}, n, {
            data: n.data.map(function (n) {
              return {
                data: $({}, n)
              };
            })
          });
        }(n);
      }),
      o = fn(i, t, r);
    "stacked" in t && !0 === t.stacked && vn(o, i), "stacked" in r && !0 === r.stacked && yn(o, i);
    var u = cn(t, o.x, e, "x"),
      c = cn(r, o.y, a, "y"),
      s = i.map(function (n) {
        return $({}, n, {
          data: n.data.map(function (n) {
            return $({}, n, {
              position: {
                x: sn(n, "x", u),
                y: sn(n, "y", c)
              }
            });
          })
        });
      });
    return $({}, o, {
      series: s,
      xScale: u,
      yScale: c
    });
  },
  fn = function fn(n, t, r) {
    return {
      x: ln(n, "x", t),
      y: ln(n, "y", r)
    };
  },
  ln = function ln(a, i, o, u) {
    var c = void 0 === u ? {} : u,
      s = c.getValue,
      d = void 0 === s ? function (n) {
        return n.data[i];
      } : s,
      f = c.setValue,
      l = void 0 === f ? function (n, t) {
        n.data[i] = t;
      } : f;
    if ("linear" === o.type) a.forEach(function (n) {
      n.data.forEach(function (n) {
        var t = d(n);
        t && l(n, parseFloat(String(t)));
      });
    });else if ("time" === o.type && "native" !== o.format) {
      var m = Q(o);
      a.forEach(function (n) {
        n.data.forEach(function (n) {
          var t = d(n);
          t && l(n, m(t));
        });
      });
    }
    var v = [];
    switch (a.forEach(function (n) {
      n.data.forEach(function (n) {
        v.push(d(n));
      });
    }), o.type) {
      case "linear":
        var y = r(n(v).filter(function (n) {
          return null !== n;
        }), function (n) {
          return n;
        });
        return {
          all: y,
          min: Math.min.apply(Math, y),
          max: Math.max.apply(Math, y)
        };
      case "time":
        var p = t(v, function (n) {
          return n.getTime();
        }).slice(0).sort(function (n, t) {
          return t.getTime() - n.getTime();
        }).reverse();
        return {
          all: p,
          min: p[0],
          max: e$1(p)
        };
      default:
        var h = n(v);
        return {
          all: h,
          min: h[0],
          max: e$1(h)
        };
    }
  },
  mn = function mn(n, t, r) {
    var i = an(n),
      o = [];
    t[i].all.forEach(function (t) {
      var u = a(t) ? un : on,
        c = [];
      r.forEach(function (r) {
        var a = r.data.find(function (n) {
            return u(n.data[i], t);
          }),
          s = null,
          d = null;
        if (void 0 !== a) {
          if (null !== (s = a.data[n])) {
            var f = e$1(c);
            void 0 === f ? d = s : null !== f && (d = f + s);
          }
          a.data["x" === n ? "xStacked" : "yStacked"] = d;
        }
        c.push(d), null !== d && o.push(d);
      });
    }), t[n].minStacked = Math.min.apply(Math, o), t[n].maxStacked = Math.max.apply(Math, o);
  },
  vn = function vn(n, t) {
    return mn("x", n, t);
  },
  yn = function yn(n, t) {
    return mn("y", n, t);
  },
  pn = function pn(n) {
    var t = n.bandwidth();
    if (0 === t) return n;
    var r = t / 2;
    return n.round() && (r = Math.round(r)), function (t) {
      var e;
      return (null != (e = n(t)) ? e : 0) + r;
    };
  },
  hn = {
    millisecond: [p$1, p$1],
    second: [g$1, g$1],
    minute: [x$1, k$1],
    hour: [T$1, b$3],
    day: [newInterval(function (n) {
      return n.setHours(0, 0, 0, 0);
    }, function (n, t) {
      return n.setDate(n.getDate() + t);
    }, function (n, t) {
      return (t.getTime() - n.getTime()) / 864e5;
    }, function (n) {
      return Math.floor(n.getTime() / 864e5);
    }), newInterval(function (n) {
      return n.setUTCHours(0, 0, 0, 0);
    }, function (n, t) {
      return n.setUTCDate(n.getUTCDate() + t);
    }, function (n, t) {
      return (t.getTime() - n.getTime()) / 864e5;
    }, function (n) {
      return Math.floor(n.getTime() / 864e5);
    })],
    week: [sunday, utcSunday],
    sunday: [sunday, utcSunday],
    monday: [monday, utcMonday],
    tuesday: [tuesday, utcTuesday],
    wednesday: [wednesday, utcWednesday],
    thursday: [thursday, utcThursday],
    friday: [friday, utcFriday],
    saturday: [saturday, utcSaturday],
    month: [N$1, z$1],
    year: [I$1, P$3]
  },
  gn = Object.keys(hn),
  xn = new RegExp("^every\\s*(\\d+)?\\s*(" + gn.join("|") + ")s?$", "i"),
  kn = function kn(n, t) {
    if (Array.isArray(t)) return t;
    if ("string" == typeof t && "useUTC" in n) {
      var r = t.match(xn);
      if (r) {
        var e = r[1],
          a = r[2],
          i = hn[a][n.useUTC ? 1 : 0];
        if ("day" === a) {
          var o,
            u,
            c = n.domain(),
            s = c[0],
            d = c[1],
            f = new Date(d);
          return f.setDate(f.getDate() + 1), null != (o = null == (u = i.every(Number(null != e ? e : 1))) ? void 0 : u.range(s, f)) ? o : [];
        }
        if (void 0 === e) return n.ticks(i);
        var l = i.every(Number(e));
        if (l) return n.ticks(l);
      }
      throw new Error("Invalid tickValues: " + t);
    }
    if ("ticks" in n) {
      if (void 0 === t) return n.ticks();
      if ("number" == typeof (m = t) && isFinite(m) && Math.floor(m) === m) return n.ticks(t);
    }
    var m;
    return n.domain();
  };

function p() {
  return p = Object.assign ? Object.assign.bind() : function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var i = arguments[e];
      for (var n in i) Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n]);
    }
    return t;
  }, p.apply(this, arguments);
}
var b$2 = function b(t) {
    var e,
      i = t.axis,
      n = t.scale,
      r = t.ticksPosition,
      a = t.tickValues,
      l = t.tickSize,
      s = t.tickPadding,
      c = t.tickRotation,
      f = t.truncateTickAt,
      u = t.engine,
      d = void 0 === u ? "svg" : u,
      x = kn(n, a),
      h = fi[d],
      g = "bandwidth" in n ? pn(n) : n,
      k = {
        lineX: 0,
        lineY: 0
      },
      v = {
        textX: 0,
        textY: 0
      },
      b = "object" == (typeof document === "undefined" ? "undefined" : _typeof$1(document)) && "rtl" === document.dir,
      T = h.align.center,
      P = h.baseline.center;
    "x" === i ? (e = function e(t) {
      var e;
      return {
        x: null != (e = g(t)) ? e : 0,
        y: 0
      };
    }, k.lineY = l * ("after" === r ? 1 : -1), v.textY = (l + s) * ("after" === r ? 1 : -1), P = "after" === r ? h.baseline.top : h.baseline.bottom, 0 === c ? T = h.align.center : "after" === r && c < 0 || "before" === r && c > 0 ? (T = h.align[b ? "left" : "right"], P = h.baseline.center) : ("after" === r && c > 0 || "before" === r && c < 0) && (T = h.align[b ? "right" : "left"], P = h.baseline.center)) : (e = function e(t) {
      var e;
      return {
        x: 0,
        y: null != (e = g(t)) ? e : 0
      };
    }, k.lineX = l * ("after" === r ? 1 : -1), v.textX = (l + s) * ("after" === r ? 1 : -1), T = "after" === r ? h.align.left : h.align.right);
    return {
      ticks: x.map(function (t) {
        var i = "string" == typeof t ? function (t) {
          var e = String(t).length;
          return f && f > 0 && e > f ? "" + String(t).slice(0, f).concat("...") : "" + t;
        }(t) : t;
        return p({
          key: t instanceof Date ? "" + t.valueOf() : "" + t,
          value: i
        }, e(t), k, v);
      }),
      textAlign: T,
      textBaseline: P
    };
  },
  T = function T(t, e) {
    if (void 0 === t || "function" == typeof t) return t;
    if ("time" === e.type) {
      var i = timeFormat(t);
      return function (t) {
        return i(t instanceof Date ? t : new Date(t));
      };
    }
    return format(t);
  },
  P$2 = function P(t) {
    var e,
      i = t.width,
      n = t.height,
      r = t.scale,
      o = t.axis,
      a = t.values,
      l = (e = a, Array.isArray(e) ? a : void 0) || kn(r, a),
      s = "bandwidth" in r ? pn(r) : r,
      c = "x" === o ? l.map(function (t) {
        var e, i;
        return {
          key: t instanceof Date ? "" + t.valueOf() : "" + t,
          x1: null != (e = s(t)) ? e : 0,
          x2: null != (i = s(t)) ? i : 0,
          y1: 0,
          y2: n
        };
      }) : l.map(function (t) {
        var e, n;
        return {
          key: t instanceof Date ? "" + t.valueOf() : "" + t,
          x1: 0,
          x2: i,
          y1: null != (e = s(t)) ? e : 0,
          y2: null != (n = s(t)) ? n : 0
        };
      });
    return c;
  },
  S$1 = /*#__PURE__*/memo(function (t) {
    var e,
      n = t.value,
      r = t.format,
      o = t.lineX,
      l = t.lineY,
      s = t.onClick,
      f = t.textBaseline,
      u = t.textAnchor,
      d = t.animatedProps,
      x = Et(),
      m = x.axis.ticks.line,
      y = x.axis.ticks.text,
      k = null != (e = null == r ? void 0 : r(n)) ? e : n,
      v = useMemo(function () {
        var t = {
          opacity: d.opacity
        };
        return s ? {
          style: p({}, t, {
            cursor: "pointer"
          }),
          onClick: function onClick(t) {
            return s(t, k);
          }
        } : {
          style: t
        };
      }, [d.opacity, s, k]);
    return jsxs(animated.g, p({
      transform: d.transform
    }, v, {
      children: [jsx("line", {
        x1: 0,
        x2: o,
        y1: 0,
        y2: l,
        style: m
      }), y.outlineWidth > 0 && jsx(animated.text, {
        dominantBaseline: f,
        textAnchor: u,
        transform: d.textTransform,
        style: y,
        strokeWidth: 2 * y.outlineWidth,
        stroke: y.outlineColor,
        strokeLinejoin: "round",
        children: "" + k
      }), jsx(animated.text, {
        dominantBaseline: f,
        textAnchor: u,
        transform: d.textTransform,
        style: y,
        children: "" + k
      })]
    }));
  }),
  A = function A(e) {
    var r = e.axis,
      o = e.scale,
      s = e.x,
      d = void 0 === s ? 0 : s,
      x = e.y,
      m = void 0 === x ? 0 : x,
      y = e.length,
      v = e.ticksPosition,
      P = e.tickValues,
      A = e.tickSize,
      W = void 0 === A ? 5 : A,
      O = e.tickPadding,
      w = void 0 === O ? 5 : O,
      B = e.tickRotation,
      X = void 0 === B ? 0 : B,
      Y = e.format,
      C = e.renderTick,
      z = void 0 === C ? S$1 : C,
      V = e.truncateTickAt,
      j = e.legend,
      D = e.legendPosition,
      R = void 0 === D ? "end" : D,
      E = e.legendOffset,
      L = void 0 === E ? 0 : E,
      q = e.onClick,
      F = e.ariaHidden,
      H = Et(),
      N = H.axis.legend.text,
      I = useMemo(function () {
        return T(Y, o);
      }, [Y, o]),
      J = b$2({
        axis: r,
        scale: o,
        ticksPosition: v,
        tickValues: P,
        tickSize: W,
        tickPadding: w,
        tickRotation: X,
        truncateTickAt: V
      }),
      G = J.ticks,
      K = J.textAlign,
      M = J.textBaseline,
      Q = null;
    if (void 0 !== j) {
      var U,
        Z = 0,
        $ = 0,
        _ = 0;
      "y" === r ? (_ = -90, Z = L, "start" === R ? (U = "start", $ = y) : "middle" === R ? (U = "middle", $ = y / 2) : "end" === R && (U = "end")) : ($ = L, "start" === R ? U = "start" : "middle" === R ? (U = "middle", Z = y / 2) : "end" === R && (U = "end", Z = y)), Q = jsxs(Fragment$1, {
        children: [N.outlineWidth > 0 && jsx("text", {
          transform: "translate(" + Z + ", " + $ + ") rotate(" + _ + ")",
          textAnchor: U,
          style: p({
            dominantBaseline: "central"
          }, N),
          strokeWidth: 2 * N.outlineWidth,
          stroke: N.outlineColor,
          strokeLinejoin: "round",
          children: j
        }), jsx("text", {
          transform: "translate(" + Z + ", " + $ + ") rotate(" + _ + ")",
          textAnchor: U,
          style: p({
            dominantBaseline: "central"
          }, N),
          children: j
        })]
      });
    }
    var tt = Zr(),
      et = tt.animate,
      it = tt.config,
      nt = useSpring({
        transform: "translate(" + d + "," + m + ")",
        lineX2: "x" === r ? y : 0,
        lineY2: "x" === r ? 0 : y,
        config: it,
        immediate: !et
      }),
      rt = useCallback(function (t) {
        return {
          opacity: 1,
          transform: "translate(" + t.x + "," + t.y + ")",
          textTransform: "translate(" + t.textX + "," + t.textY + ") rotate(" + X + ")"
        };
      }, [X]),
      ot = useCallback(function (t) {
        return {
          opacity: 0,
          transform: "translate(" + t.x + "," + t.y + ")",
          textTransform: "translate(" + t.textX + "," + t.textY + ") rotate(" + X + ")"
        };
      }, [X]),
      at = useTransition(G, {
        keys: function keys(t) {
          return t.key;
        },
        initial: rt,
        from: ot,
        enter: rt,
        update: rt,
        leave: {
          opacity: 0
        },
        config: it,
        immediate: !et
      });
    return jsxs(animated.g, {
      transform: nt.transform,
      "aria-hidden": F,
      children: [at(function (e, i, n, r) {
        return /*#__PURE__*/React.createElement(z, p({
          tickIndex: r,
          format: I,
          rotate: X,
          textBaseline: M,
          textAnchor: K,
          truncateTickAt: V,
          animatedProps: e
        }, i, q ? {
          onClick: q
        } : {}));
      }), jsx(animated.line, {
        style: H.axis.domain.line,
        x1: 0,
        x2: nt.lineX2,
        y1: 0,
        y2: nt.lineY2
      }), Q]
    });
  },
  W = /*#__PURE__*/memo(A),
  O$1 = {
    ticksPosition: PropTypes.oneOf(["before", "after"]),
    tickValues: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.instanceOf(Date)])), PropTypes.string]),
    rotateOnTickLength: PropTypes.shape({
      angle: PropTypes.number,
      length: PropTypes.number
    }),
    tickSize: PropTypes.number,
    tickPadding: PropTypes.number,
    tickRotation: PropTypes.number,
    format: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    renderTick: PropTypes.func,
    legend: PropTypes.node,
    legendPosition: PropTypes.oneOf(["start", "middle", "end"]),
    legendOffset: PropTypes.number,
    ariaHidden: PropTypes.bool
  },
  w = PropTypes.shape(O$1),
  B = ["top", "right", "bottom", "left"],
  X$1 = /*#__PURE__*/memo(function (t) {
    var e = t.xScale,
      i = t.yScale,
      n = t.width,
      r = t.height,
      o = {
        top: t.top,
        right: t.right,
        bottom: t.bottom,
        left: t.left
      };
    return jsx(Fragment$1, {
      children: B.map(function (t) {
        var a = o[t];
        if (!a) return null;
        var l = "top" === t || "bottom" === t;
        return jsx(W, p({}, a, {
          axis: l ? "x" : "y",
          x: "right" === t ? n : 0,
          y: "bottom" === t ? r : 0,
          scale: l ? e : i,
          length: l ? n : r,
          ticksPosition: "top" === t || "left" === t ? "before" : "after",
          truncateTickAt: a.truncateTickAt
        }), t);
      })
    });
  }),
  Y = /*#__PURE__*/memo(function (t) {
    var e = t.animatedProps,
      i = Et();
    return jsx(animated.line, p({}, e, i.grid.line));
  }),
  C = /*#__PURE__*/memo(function (t) {
    var e = t.lines,
      i = Zr(),
      n = i.animate,
      o = i.config,
      a = useTransition(e, {
        keys: function keys(t) {
          return t.key;
        },
        initial: function initial(t) {
          return {
            opacity: 1,
            x1: t.x1,
            x2: t.x2,
            y1: t.y1,
            y2: t.y2
          };
        },
        from: function from(t) {
          return {
            opacity: 0,
            x1: t.x1,
            x2: t.x2,
            y1: t.y1,
            y2: t.y2
          };
        },
        enter: function enter(t) {
          return {
            opacity: 1,
            x1: t.x1,
            x2: t.x2,
            y1: t.y1,
            y2: t.y2
          };
        },
        update: function update(t) {
          return {
            opacity: 1,
            x1: t.x1,
            x2: t.x2,
            y1: t.y1,
            y2: t.y2
          };
        },
        leave: {
          opacity: 0
        },
        config: o,
        immediate: !n
      });
    return jsx("g", {
      children: a(function (t, e) {
        return /*#__PURE__*/createElement(Y, p({}, e, {
          key: e.key,
          animatedProps: t
        }));
      })
    });
  }),
  z = /*#__PURE__*/memo(function (t) {
    var e = t.width,
      n = t.height,
      r = t.xScale,
      o = t.yScale,
      a = t.xValues,
      l = t.yValues,
      s = useMemo(function () {
        return !!r && P$2({
          width: e,
          height: n,
          scale: r,
          axis: "x",
          values: a
        });
      }, [r, a, e, n]),
      c = useMemo(function () {
        return !!o && P$2({
          width: e,
          height: n,
          scale: o,
          axis: "y",
          values: l
        });
      }, [n, e, o, l]);
    return jsxs(Fragment$1, {
      children: [s && jsx(C, {
        lines: s
      }), c && jsx(C, {
        lines: c
      })]
    });
  }),
  V = function V(t, e) {
    var i,
      n = e.axis,
      r = e.scale,
      o = e.x,
      a = void 0 === o ? 0 : o,
      l = e.y,
      c = void 0 === l ? 0 : l,
      f = e.length,
      u = e.ticksPosition,
      d = e.tickValues,
      x = e.tickSize,
      m = void 0 === x ? 5 : x,
      y = e.tickPadding,
      h = void 0 === y ? 5 : y,
      g = e.tickRotation,
      k = void 0 === g ? 0 : g,
      v = e.format,
      p = e.legend,
      T = e.legendPosition,
      P = void 0 === T ? "end" : T,
      S = e.legendOffset,
      A = void 0 === S ? 0 : S,
      W = e.theme,
      O = b$2({
        axis: n,
        scale: r,
        ticksPosition: u,
        tickValues: d,
        tickSize: m,
        tickPadding: h,
        tickRotation: k,
        engine: "canvas"
      }),
      w = O.ticks,
      B = O.textAlign,
      X = O.textBaseline;
    t.save(), t.translate(a, c), t.textAlign = B, t.textBaseline = X;
    var Y = W.axis.ticks.text;
    t.font = (Y.fontWeight ? Y.fontWeight + " " : "") + Y.fontSize + "px " + Y.fontFamily, (null != (i = W.axis.domain.line.strokeWidth) ? i : 0) > 0 && (t.lineWidth = Number(W.axis.domain.line.strokeWidth), t.lineCap = "square", W.axis.domain.line.stroke && (t.strokeStyle = W.axis.domain.line.stroke), t.beginPath(), t.moveTo(0, 0), t.lineTo("x" === n ? f : 0, "x" === n ? 0 : f), t.stroke());
    var C = "function" == typeof v ? v : function (t) {
      return "" + t;
    };
    if (w.forEach(function (e) {
      var i;
      (null != (i = W.axis.ticks.line.strokeWidth) ? i : 0) > 0 && (t.lineWidth = Number(W.axis.ticks.line.strokeWidth), t.lineCap = "square", W.axis.ticks.line.stroke && (t.strokeStyle = W.axis.ticks.line.stroke), t.beginPath(), t.moveTo(e.x, e.y), t.lineTo(e.x + e.lineX, e.y + e.lineY), t.stroke());
      var n = C(e.value);
      t.save(), t.translate(e.x + e.textX, e.y + e.textY), t.rotate(ni(k)), Y.outlineWidth > 0 && (t.strokeStyle = Y.outlineColor, t.lineWidth = 2 * Y.outlineWidth, t.lineJoin = "round", t.strokeText("" + n, 0, 0)), W.axis.ticks.text.fill && (t.fillStyle = Y.fill), t.fillText("" + n, 0, 0), t.restore();
    }), void 0 !== p) {
      var z = 0,
        V = 0,
        j = 0,
        D = "center";
      "y" === n ? (j = -90, z = A, "start" === P ? (D = "start", V = f) : "middle" === P ? (D = "center", V = f / 2) : "end" === P && (D = "end")) : (V = A, "start" === P ? D = "start" : "middle" === P ? (D = "center", z = f / 2) : "end" === P && (D = "end", z = f)), t.translate(z, V), t.rotate(ni(j)), t.font = (W.axis.legend.text.fontWeight ? W.axis.legend.text.fontWeight + " " : "") + W.axis.legend.text.fontSize + "px " + W.axis.legend.text.fontFamily, W.axis.legend.text.fill && (t.fillStyle = W.axis.legend.text.fill), t.textAlign = D, t.textBaseline = "middle", t.fillText(p, 0, 0);
    }
    t.restore();
  },
  j$1 = function j(t, e) {
    var i = e.xScale,
      n = e.yScale,
      r = e.width,
      o = e.height,
      a = e.top,
      l = e.right,
      s = e.bottom,
      c = e.left,
      f = e.theme,
      u = {
        top: a,
        right: l,
        bottom: s,
        left: c
      };
    B.forEach(function (e) {
      var a = u[e];
      if (!a) return null;
      var l = "top" === e || "bottom" === e,
        s = "top" === e || "left" === e ? "before" : "after",
        c = l ? i : n,
        d = T(a.format, c);
      V(t, p({}, a, {
        axis: l ? "x" : "y",
        x: "right" === e ? r : 0,
        y: "bottom" === e ? o : 0,
        scale: c,
        format: d,
        length: l ? r : o,
        ticksPosition: s,
        theme: f
      }));
    });
  },
  D$1 = function D(t, e) {
    var i = e.width,
      n = e.height,
      r = e.scale,
      o = e.axis,
      a = e.values;
    P$2({
      width: i,
      height: n,
      scale: r,
      axis: o,
      values: a
    }).forEach(function (e) {
      t.beginPath(), t.moveTo(e.x1, e.y1), t.lineTo(e.x2, e.y2), t.stroke();
    });
  };

var EPSILON = Math.pow(2, -52);
var EDGE_STACK = new Uint32Array(512);
var Delaunator = /*#__PURE__*/function () {
  function Delaunator(coords) {
    _classCallCheck(this, Delaunator);
    var n = coords.length >> 1;
    if (n > 0 && typeof coords[0] !== 'number') throw new Error('Expected coords to contain numbers.');
    this.coords = coords;

    // arrays that will store the triangulation graph
    var maxTriangles = Math.max(2 * n - 5, 0);
    this._triangles = new Uint32Array(maxTriangles * 3);
    this._halfedges = new Int32Array(maxTriangles * 3);

    // temporary arrays for tracking the edges of the advancing convex hull
    this._hashSize = Math.ceil(Math.sqrt(n));
    this._hullPrev = new Uint32Array(n); // edge to prev edge
    this._hullNext = new Uint32Array(n); // edge to next edge
    this._hullTri = new Uint32Array(n); // edge to adjacent triangle
    this._hullHash = new Int32Array(this._hashSize).fill(-1); // angular edge hash

    // temporary arrays for sorting points
    this._ids = new Uint32Array(n);
    this._dists = new Float64Array(n);
    this.update();
  }
  _createClass(Delaunator, [{
    key: "update",
    value: function update() {
      var coords = this.coords,
        hullPrev = this._hullPrev,
        hullNext = this._hullNext,
        hullTri = this._hullTri,
        hullHash = this._hullHash;
      var n = coords.length >> 1;

      // populate an array of point indices; calculate input data bbox
      var minX = Infinity;
      var minY = Infinity;
      var maxX = -Infinity;
      var maxY = -Infinity;
      for (var i = 0; i < n; i++) {
        var x = coords[2 * i];
        var y = coords[2 * i + 1];
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        this._ids[i] = i;
      }
      var cx = (minX + maxX) / 2;
      var cy = (minY + maxY) / 2;
      var minDist = Infinity;
      var i0, i1, i2;

      // pick a seed point close to the center
      for (var _i = 0; _i < n; _i++) {
        var d = dist(cx, cy, coords[2 * _i], coords[2 * _i + 1]);
        if (d < minDist) {
          i0 = _i;
          minDist = d;
        }
      }
      var i0x = coords[2 * i0];
      var i0y = coords[2 * i0 + 1];
      minDist = Infinity;

      // find the point closest to the seed
      for (var _i2 = 0; _i2 < n; _i2++) {
        if (_i2 === i0) continue;
        var _d = dist(i0x, i0y, coords[2 * _i2], coords[2 * _i2 + 1]);
        if (_d < minDist && _d > 0) {
          i1 = _i2;
          minDist = _d;
        }
      }
      var i1x = coords[2 * i1];
      var i1y = coords[2 * i1 + 1];
      var minRadius = Infinity;

      // find the third point which forms the smallest circumcircle with the first two
      for (var _i3 = 0; _i3 < n; _i3++) {
        if (_i3 === i0 || _i3 === i1) continue;
        var r = circumradius(i0x, i0y, i1x, i1y, coords[2 * _i3], coords[2 * _i3 + 1]);
        if (r < minRadius) {
          i2 = _i3;
          minRadius = r;
        }
      }
      var i2x = coords[2 * i2];
      var i2y = coords[2 * i2 + 1];
      if (minRadius === Infinity) {
        // order collinear points by dx (or dy if all x are identical)
        // and return the list as a hull
        for (var _i4 = 0; _i4 < n; _i4++) {
          this._dists[_i4] = coords[2 * _i4] - coords[0] || coords[2 * _i4 + 1] - coords[1];
        }
        quicksort(this._ids, this._dists, 0, n - 1);
        var hull = new Uint32Array(n);
        var j = 0;
        for (var _i5 = 0, d0 = -Infinity; _i5 < n; _i5++) {
          var id = this._ids[_i5];
          if (this._dists[id] > d0) {
            hull[j++] = id;
            d0 = this._dists[id];
          }
        }
        this.hull = hull.subarray(0, j);
        this.triangles = new Uint32Array(0);
        this.halfedges = new Uint32Array(0);
        return;
      }

      // swap the order of the seed points for counter-clockwise orientation
      if (orient(i0x, i0y, i1x, i1y, i2x, i2y)) {
        var _i6 = i1;
        var _x = i1x;
        var _y = i1y;
        i1 = i2;
        i1x = i2x;
        i1y = i2y;
        i2 = _i6;
        i2x = _x;
        i2y = _y;
      }
      var center = circumcenter(i0x, i0y, i1x, i1y, i2x, i2y);
      this._cx = center.x;
      this._cy = center.y;
      for (var _i7 = 0; _i7 < n; _i7++) {
        this._dists[_i7] = dist(coords[2 * _i7], coords[2 * _i7 + 1], center.x, center.y);
      }

      // sort the points by distance from the seed triangle circumcenter
      quicksort(this._ids, this._dists, 0, n - 1);

      // set up the seed triangle as the starting hull
      this._hullStart = i0;
      var hullSize = 3;
      hullNext[i0] = hullPrev[i2] = i1;
      hullNext[i1] = hullPrev[i0] = i2;
      hullNext[i2] = hullPrev[i1] = i0;
      hullTri[i0] = 0;
      hullTri[i1] = 1;
      hullTri[i2] = 2;
      hullHash.fill(-1);
      hullHash[this._hashKey(i0x, i0y)] = i0;
      hullHash[this._hashKey(i1x, i1y)] = i1;
      hullHash[this._hashKey(i2x, i2y)] = i2;
      this.trianglesLen = 0;
      this._addTriangle(i0, i1, i2, -1, -1, -1);
      for (var k = 0, xp, yp; k < this._ids.length; k++) {
        var _i8 = this._ids[k];
        var _x2 = coords[2 * _i8];
        var _y2 = coords[2 * _i8 + 1];

        // skip near-duplicate points
        if (k > 0 && Math.abs(_x2 - xp) <= EPSILON && Math.abs(_y2 - yp) <= EPSILON) continue;
        xp = _x2;
        yp = _y2;

        // skip seed triangle points
        if (_i8 === i0 || _i8 === i1 || _i8 === i2) continue;

        // find a visible edge on the convex hull using edge hash
        var start = 0;
        for (var _j = 0, key = this._hashKey(_x2, _y2); _j < this._hashSize; _j++) {
          start = hullHash[(key + _j) % this._hashSize];
          if (start !== -1 && start !== hullNext[start]) break;
        }
        start = hullPrev[start];
        var e = start,
          q = void 0;
        while (q = hullNext[e], !orient(_x2, _y2, coords[2 * e], coords[2 * e + 1], coords[2 * q], coords[2 * q + 1])) {
          e = q;
          if (e === start) {
            e = -1;
            break;
          }
        }
        if (e === -1) continue; // likely a near-duplicate point; skip it

        // add the first triangle from the point
        var t = this._addTriangle(e, _i8, hullNext[e], -1, -1, hullTri[e]);

        // recursively flip triangles from the point until they satisfy the Delaunay condition
        hullTri[_i8] = this._legalize(t + 2);
        hullTri[e] = t; // keep track of boundary triangles on the hull
        hullSize++;

        // walk forward through the hull, adding more triangles and flipping recursively
        var _n = hullNext[e];
        while (q = hullNext[_n], orient(_x2, _y2, coords[2 * _n], coords[2 * _n + 1], coords[2 * q], coords[2 * q + 1])) {
          t = this._addTriangle(_n, _i8, q, hullTri[_i8], -1, hullTri[_n]);
          hullTri[_i8] = this._legalize(t + 2);
          hullNext[_n] = _n; // mark as removed
          hullSize--;
          _n = q;
        }

        // walk backward from the other side, adding more triangles and flipping
        if (e === start) {
          while (q = hullPrev[e], orient(_x2, _y2, coords[2 * q], coords[2 * q + 1], coords[2 * e], coords[2 * e + 1])) {
            t = this._addTriangle(q, _i8, e, -1, hullTri[e], hullTri[q]);
            this._legalize(t + 2);
            hullTri[q] = t;
            hullNext[e] = e; // mark as removed
            hullSize--;
            e = q;
          }
        }

        // update the hull indices
        this._hullStart = hullPrev[_i8] = e;
        hullNext[e] = hullPrev[_n] = _i8;
        hullNext[_i8] = _n;

        // save the two new edges in the hash table
        hullHash[this._hashKey(_x2, _y2)] = _i8;
        hullHash[this._hashKey(coords[2 * e], coords[2 * e + 1])] = e;
      }
      this.hull = new Uint32Array(hullSize);
      for (var _i9 = 0, _e = this._hullStart; _i9 < hullSize; _i9++) {
        this.hull[_i9] = _e;
        _e = hullNext[_e];
      }

      // trim typed triangle mesh arrays
      this.triangles = this._triangles.subarray(0, this.trianglesLen);
      this.halfedges = this._halfedges.subarray(0, this.trianglesLen);
    }
  }, {
    key: "_hashKey",
    value: function _hashKey(x, y) {
      return Math.floor(pseudoAngle(x - this._cx, y - this._cy) * this._hashSize) % this._hashSize;
    }
  }, {
    key: "_legalize",
    value: function _legalize(a) {
      var triangles = this._triangles,
        halfedges = this._halfedges,
        coords = this.coords;
      var i = 0;
      var ar = 0;

      // recursion eliminated with a fixed-size stack
      while (true) {
        var b = halfedges[a];

        /* if the pair of triangles doesn't satisfy the Delaunay condition
         * (p1 is inside the circumcircle of [p0, pl, pr]), flip them,
         * then do the same check/flip recursively for the new pair of triangles
         *
         *           pl                    pl
         *          /||\                  /  \
         *       al/ || \bl            al/    \a
         *        /  ||  \              /      \
         *       /  a||b  \    flip    /___ar___\
         *     p0\   ||   /p1   =>   p0\---bl---/p1
         *        \  ||  /              \      /
         *       ar\ || /br             b\    /br
         *          \||/                  \  /
         *           pr                    pr
         */
        var a0 = a - a % 3;
        ar = a0 + (a + 2) % 3;
        if (b === -1) {
          // convex hull edge
          if (i === 0) break;
          a = EDGE_STACK[--i];
          continue;
        }
        var b0 = b - b % 3;
        var al = a0 + (a + 1) % 3;
        var bl = b0 + (b + 2) % 3;
        var p0 = triangles[ar];
        var pr = triangles[a];
        var pl = triangles[al];
        var p1 = triangles[bl];
        var illegal = inCircle(coords[2 * p0], coords[2 * p0 + 1], coords[2 * pr], coords[2 * pr + 1], coords[2 * pl], coords[2 * pl + 1], coords[2 * p1], coords[2 * p1 + 1]);
        if (illegal) {
          triangles[a] = p1;
          triangles[b] = p0;
          var hbl = halfedges[bl];

          // edge swapped on the other side of the hull (rare); fix the halfedge reference
          if (hbl === -1) {
            var e = this._hullStart;
            do {
              if (this._hullTri[e] === bl) {
                this._hullTri[e] = a;
                break;
              }
              e = this._hullPrev[e];
            } while (e !== this._hullStart);
          }
          this._link(a, hbl);
          this._link(b, halfedges[ar]);
          this._link(ar, bl);
          var br = b0 + (b + 1) % 3;

          // don't worry about hitting the cap: it can only happen on extremely degenerate input
          if (i < EDGE_STACK.length) {
            EDGE_STACK[i++] = br;
          }
        } else {
          if (i === 0) break;
          a = EDGE_STACK[--i];
        }
      }
      return ar;
    }
  }, {
    key: "_link",
    value: function _link(a, b) {
      this._halfedges[a] = b;
      if (b !== -1) this._halfedges[b] = a;
    }

    // add a new triangle given vertex indices and adjacent half-edge ids
  }, {
    key: "_addTriangle",
    value: function _addTriangle(i0, i1, i2, a, b, c) {
      var t = this.trianglesLen;
      this._triangles[t] = i0;
      this._triangles[t + 1] = i1;
      this._triangles[t + 2] = i2;
      this._link(t, a);
      this._link(t + 1, b);
      this._link(t + 2, c);
      this.trianglesLen += 3;
      return t;
    }
  }], [{
    key: "from",
    value: function from(points) {
      var getX = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultGetX;
      var getY = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultGetY;
      var n = points.length;
      var coords = new Float64Array(n * 2);
      for (var i = 0; i < n; i++) {
        var p = points[i];
        coords[2 * i] = getX(p);
        coords[2 * i + 1] = getY(p);
      }
      return new Delaunator(coords);
    }
  }]);
  return Delaunator;
}(); // monotonically increases with real angle, but doesn't need expensive trigonometry
function pseudoAngle(dx, dy) {
  var p = dx / (Math.abs(dx) + Math.abs(dy));
  return (dy > 0 ? 3 - p : 1 + p) / 4; // [0..1]
}
function dist(ax, ay, bx, by) {
  var dx = ax - bx;
  var dy = ay - by;
  return dx * dx + dy * dy;
}

// return 2d orientation sign if we're confident in it through J. Shewchuk's error bound check
function orientIfSure(px, py, rx, ry, qx, qy) {
  var l = (ry - py) * (qx - px);
  var r = (rx - px) * (qy - py);
  return Math.abs(l - r) >= 3.3306690738754716e-16 * Math.abs(l + r) ? l - r : 0;
}

// a more robust orientation test that's stable in a given triangle (to fix robustness issues)
function orient(rx, ry, qx, qy, px, py) {
  var sign = orientIfSure(px, py, rx, ry, qx, qy) || orientIfSure(rx, ry, qx, qy, px, py) || orientIfSure(qx, qy, px, py, rx, ry);
  return sign < 0;
}
function inCircle(ax, ay, bx, by, cx, cy, px, py) {
  var dx = ax - px;
  var dy = ay - py;
  var ex = bx - px;
  var ey = by - py;
  var fx = cx - px;
  var fy = cy - py;
  var ap = dx * dx + dy * dy;
  var bp = ex * ex + ey * ey;
  var cp = fx * fx + fy * fy;
  return dx * (ey * cp - bp * fy) - dy * (ex * cp - bp * fx) + ap * (ex * fy - ey * fx) < 0;
}
function circumradius(ax, ay, bx, by, cx, cy) {
  var dx = bx - ax;
  var dy = by - ay;
  var ex = cx - ax;
  var ey = cy - ay;
  var bl = dx * dx + dy * dy;
  var cl = ex * ex + ey * ey;
  var d = 0.5 / (dx * ey - dy * ex);
  var x = (ey * bl - dy * cl) * d;
  var y = (dx * cl - ex * bl) * d;
  return x * x + y * y;
}
function circumcenter(ax, ay, bx, by, cx, cy) {
  var dx = bx - ax;
  var dy = by - ay;
  var ex = cx - ax;
  var ey = cy - ay;
  var bl = dx * dx + dy * dy;
  var cl = ex * ex + ey * ey;
  var d = 0.5 / (dx * ey - dy * ex);
  var x = ax + (ey * bl - dy * cl) * d;
  var y = ay + (dx * cl - ex * bl) * d;
  return {
    x: x,
    y: y
  };
}
function quicksort(ids, dists, left, right) {
  if (right - left <= 20) {
    for (var i = left + 1; i <= right; i++) {
      var temp = ids[i];
      var tempDist = dists[temp];
      var j = i - 1;
      while (j >= left && dists[ids[j]] > tempDist) ids[j + 1] = ids[j--];
      ids[j + 1] = temp;
    }
  } else {
    var median = left + right >> 1;
    var _i10 = left + 1;
    var _j2 = right;
    swap(ids, median, _i10);
    if (dists[ids[left]] > dists[ids[right]]) swap(ids, left, right);
    if (dists[ids[_i10]] > dists[ids[right]]) swap(ids, _i10, right);
    if (dists[ids[left]] > dists[ids[_i10]]) swap(ids, left, _i10);
    var _temp = ids[_i10];
    var _tempDist = dists[_temp];
    while (true) {
      do _i10++; while (dists[ids[_i10]] < _tempDist);
      do _j2--; while (dists[ids[_j2]] > _tempDist);
      if (_j2 < _i10) break;
      swap(ids, _i10, _j2);
    }
    ids[left + 1] = ids[_j2];
    ids[_j2] = _temp;
    if (right - _i10 + 1 >= _j2 - left) {
      quicksort(ids, dists, _i10, right);
      quicksort(ids, dists, left, _j2 - 1);
    } else {
      quicksort(ids, dists, left, _j2 - 1);
      quicksort(ids, dists, _i10, right);
    }
  }
}
function swap(arr, i, j) {
  var tmp = arr[i];
  arr[i] = arr[j];
  arr[j] = tmp;
}
function defaultGetX(p) {
  return p[0];
}
function defaultGetY(p) {
  return p[1];
}

var epsilon = 1e-6;
var Path = /*#__PURE__*/function () {
  function Path() {
    _classCallCheck(this, Path);
    this._x0 = this._y0 =
    // start of current subpath
    this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
  }
  _createClass(Path, [{
    key: "moveTo",
    value: function moveTo(x, y) {
      this._ += "M".concat(this._x0 = this._x1 = +x, ",").concat(this._y0 = this._y1 = +y);
    }
  }, {
    key: "closePath",
    value: function closePath() {
      if (this._x1 !== null) {
        this._x1 = this._x0, this._y1 = this._y0;
        this._ += "Z";
      }
    }
  }, {
    key: "lineTo",
    value: function lineTo(x, y) {
      this._ += "L".concat(this._x1 = +x, ",").concat(this._y1 = +y);
    }
  }, {
    key: "arc",
    value: function arc(x, y, r) {
      x = +x, y = +y, r = +r;
      var x0 = x + r;
      var y0 = y;
      if (r < 0) throw new Error("negative radius");
      if (this._x1 === null) this._ += "M".concat(x0, ",").concat(y0);else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) this._ += "L" + x0 + "," + y0;
      if (!r) return;
      this._ += "A".concat(r, ",").concat(r, ",0,1,1,").concat(x - r, ",").concat(y, "A").concat(r, ",").concat(r, ",0,1,1,").concat(this._x1 = x0, ",").concat(this._y1 = y0);
    }
  }, {
    key: "rect",
    value: function rect(x, y, w, h) {
      this._ += "M".concat(this._x0 = this._x1 = +x, ",").concat(this._y0 = this._y1 = +y, "h").concat(+w, "v").concat(+h, "h").concat(-w, "Z");
    }
  }, {
    key: "value",
    value: function value() {
      return this._ || null;
    }
  }]);
  return Path;
}();

var Polygon = /*#__PURE__*/function () {
  function Polygon() {
    _classCallCheck(this, Polygon);
    this._ = [];
  }
  _createClass(Polygon, [{
    key: "moveTo",
    value: function moveTo(x, y) {
      this._.push([x, y]);
    }
  }, {
    key: "closePath",
    value: function closePath() {
      this._.push(this._[0].slice());
    }
  }, {
    key: "lineTo",
    value: function lineTo(x, y) {
      this._.push([x, y]);
    }
  }, {
    key: "value",
    value: function value() {
      return this._.length ? this._ : null;
    }
  }]);
  return Polygon;
}();

function _createForOfIteratorHelper$1(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }
function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var Voronoi = /*#__PURE__*/function () {
  function Voronoi(delaunay) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [0, 0, 960, 500],
      _ref2 = _slicedToArray(_ref, 4),
      xmin = _ref2[0],
      ymin = _ref2[1],
      xmax = _ref2[2],
      ymax = _ref2[3];
    _classCallCheck(this, Voronoi);
    if (!((xmax = +xmax) >= (xmin = +xmin)) || !((ymax = +ymax) >= (ymin = +ymin))) throw new Error("invalid bounds");
    this.delaunay = delaunay;
    this._circumcenters = new Float64Array(delaunay.points.length * 2);
    this.vectors = new Float64Array(delaunay.points.length * 2);
    this.xmax = xmax, this.xmin = xmin;
    this.ymax = ymax, this.ymin = ymin;
    this._init();
  }
  _createClass(Voronoi, [{
    key: "update",
    value: function update() {
      this.delaunay.update();
      this._init();
      return this;
    }
  }, {
    key: "_init",
    value: function _init() {
      var _this$delaunay = this.delaunay,
        points = _this$delaunay.points,
        hull = _this$delaunay.hull,
        triangles = _this$delaunay.triangles,
        vectors = this.vectors;

      // Compute circumcenters.
      var circumcenters = this.circumcenters = this._circumcenters.subarray(0, triangles.length / 3 * 2);
      for (var i = 0, j = 0, n = triangles.length, x, y; i < n; i += 3, j += 2) {
        var t1 = triangles[i] * 2;
        var t2 = triangles[i + 1] * 2;
        var t3 = triangles[i + 2] * 2;
        var _x = points[t1];
        var _y = points[t1 + 1];
        var x2 = points[t2];
        var y2 = points[t2 + 1];
        var x3 = points[t3];
        var y3 = points[t3 + 1];
        var dx = x2 - _x;
        var dy = y2 - _y;
        var ex = x3 - _x;
        var ey = y3 - _y;
        var bl = dx * dx + dy * dy;
        var cl = ex * ex + ey * ey;
        var ab = (dx * ey - dy * ex) * 2;
        if (!ab) {
          // degenerate case (collinear diagram)
          x = (_x + x3) / 2 - 1e8 * ey;
          y = (_y + y3) / 2 + 1e8 * ex;
        } else if (Math.abs(ab) < 1e-8) {
          // almost equal points (degenerate triangle)
          x = (_x + x3) / 2;
          y = (_y + y3) / 2;
        } else {
          var d = 1 / ab;
          x = _x + (ey * bl - dy * cl) * d;
          y = _y + (dx * cl - ex * bl) * d;
        }
        circumcenters[j] = x;
        circumcenters[j + 1] = y;
      }

      // Compute exterior cell rays.
      var h = hull[hull.length - 1];
      var p0,
        p1 = h * 4;
      var x0,
        x1 = points[2 * h];
      var y0,
        y1 = points[2 * h + 1];
      vectors.fill(0);
      for (var _i = 0; _i < hull.length; ++_i) {
        h = hull[_i];
        p0 = p1, x0 = x1, y0 = y1;
        p1 = h * 4, x1 = points[2 * h], y1 = points[2 * h + 1];
        vectors[p0 + 2] = vectors[p1] = y0 - y1;
        vectors[p0 + 3] = vectors[p1 + 1] = x1 - x0;
      }
    }
  }, {
    key: "render",
    value: function render(context) {
      var buffer = context == null ? context = new Path() : undefined;
      var _this$delaunay2 = this.delaunay,
        halfedges = _this$delaunay2.halfedges,
        inedges = _this$delaunay2.inedges,
        hull = _this$delaunay2.hull,
        circumcenters = this.circumcenters,
        vectors = this.vectors;
      if (hull.length <= 1) return null;
      for (var i = 0, n = halfedges.length; i < n; ++i) {
        var j = halfedges[i];
        if (j < i) continue;
        var ti = Math.floor(i / 3) * 2;
        var tj = Math.floor(j / 3) * 2;
        var xi = circumcenters[ti];
        var yi = circumcenters[ti + 1];
        var xj = circumcenters[tj];
        var yj = circumcenters[tj + 1];
        this._renderSegment(xi, yi, xj, yj, context);
      }
      var h0,
        h1 = hull[hull.length - 1];
      for (var _i2 = 0; _i2 < hull.length; ++_i2) {
        h0 = h1, h1 = hull[_i2];
        var t = Math.floor(inedges[h1] / 3) * 2;
        var x = circumcenters[t];
        var y = circumcenters[t + 1];
        var v = h0 * 4;
        var p = this._project(x, y, vectors[v + 2], vectors[v + 3]);
        if (p) this._renderSegment(x, y, p[0], p[1], context);
      }
      return buffer && buffer.value();
    }
  }, {
    key: "renderBounds",
    value: function renderBounds(context) {
      var buffer = context == null ? context = new Path() : undefined;
      context.rect(this.xmin, this.ymin, this.xmax - this.xmin, this.ymax - this.ymin);
      return buffer && buffer.value();
    }
  }, {
    key: "renderCell",
    value: function renderCell(i, context) {
      var buffer = context == null ? context = new Path() : undefined;
      var points = this._clip(i);
      if (points === null || !points.length) return;
      context.moveTo(points[0], points[1]);
      var n = points.length;
      while (points[0] === points[n - 2] && points[1] === points[n - 1] && n > 1) n -= 2;
      for (var _i3 = 2; _i3 < n; _i3 += 2) {
        if (points[_i3] !== points[_i3 - 2] || points[_i3 + 1] !== points[_i3 - 1]) context.lineTo(points[_i3], points[_i3 + 1]);
      }
      context.closePath();
      return buffer && buffer.value();
    }
  }, {
    key: "cellPolygons",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function cellPolygons() {
      var points, i, n, cell;
      return _regeneratorRuntime.wrap(function cellPolygons$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            points = this.delaunay.points;
            i = 0, n = points.length / 2;
          case 2:
            if (!(i < n)) {
              _context.next = 11;
              break;
            }
            cell = this.cellPolygon(i);
            if (!cell) {
              _context.next = 8;
              break;
            }
            cell.index = i;
            _context.next = 8;
            return cell;
          case 8:
            ++i;
            _context.next = 2;
            break;
          case 11:
          case "end":
            return _context.stop();
        }
      }, cellPolygons, this);
    })
  }, {
    key: "cellPolygon",
    value: function cellPolygon(i) {
      var polygon = new Polygon();
      this.renderCell(i, polygon);
      return polygon.value();
    }
  }, {
    key: "_renderSegment",
    value: function _renderSegment(x0, y0, x1, y1, context) {
      var S;
      var c0 = this._regioncode(x0, y0);
      var c1 = this._regioncode(x1, y1);
      if (c0 === 0 && c1 === 0) {
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
      } else if (S = this._clipSegment(x0, y0, x1, y1, c0, c1)) {
        context.moveTo(S[0], S[1]);
        context.lineTo(S[2], S[3]);
      }
    }
  }, {
    key: "contains",
    value: function contains(i, x, y) {
      if ((x = +x, x !== x) || (y = +y, y !== y)) return false;
      return this.delaunay._step(i, x, y) === i;
    }
  }, {
    key: "neighbors",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function neighbors(i) {
      var ci, _iterator, _step, j, cj, ai, li, aj, lj;
      return _regeneratorRuntime.wrap(function neighbors$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            ci = this._clip(i);
            if (!ci) {
              _context2.next = 33;
              break;
            }
            _iterator = _createForOfIteratorHelper$1(this.delaunay.neighbors(i));
            _context2.prev = 3;
            _iterator.s();
          case 5:
            if ((_step = _iterator.n()).done) {
              _context2.next = 25;
              break;
            }
            j = _step.value;
            cj = this._clip(j); // find the common edge
            if (!cj) {
              _context2.next = 23;
              break;
            }
            ai = 0, li = ci.length;
          case 10:
            if (!(ai < li)) {
              _context2.next = 23;
              break;
            }
            aj = 0, lj = cj.length;
          case 12:
            if (!(aj < lj)) {
              _context2.next = 20;
              break;
            }
            if (!(ci[ai] == cj[aj] && ci[ai + 1] == cj[aj + 1] && ci[(ai + 2) % li] == cj[(aj + lj - 2) % lj] && ci[(ai + 3) % li] == cj[(aj + lj - 1) % lj])) {
              _context2.next = 17;
              break;
            }
            _context2.next = 16;
            return j;
          case 16:
            return _context2.abrupt("break", 23);
          case 17:
            aj += 2;
            _context2.next = 12;
            break;
          case 20:
            ai += 2;
            _context2.next = 10;
            break;
          case 23:
            _context2.next = 5;
            break;
          case 25:
            _context2.next = 30;
            break;
          case 27:
            _context2.prev = 27;
            _context2.t0 = _context2["catch"](3);
            _iterator.e(_context2.t0);
          case 30:
            _context2.prev = 30;
            _iterator.f();
            return _context2.finish(30);
          case 33:
          case "end":
            return _context2.stop();
        }
      }, neighbors, this, [[3, 27, 30, 33]]);
    })
  }, {
    key: "_cell",
    value: function _cell(i) {
      var circumcenters = this.circumcenters,
        _this$delaunay3 = this.delaunay,
        inedges = _this$delaunay3.inedges,
        halfedges = _this$delaunay3.halfedges,
        triangles = _this$delaunay3.triangles;
      var e0 = inedges[i];
      if (e0 === -1) return null; // coincident point
      var points = [];
      var e = e0;
      do {
        var t = Math.floor(e / 3);
        points.push(circumcenters[t * 2], circumcenters[t * 2 + 1]);
        e = e % 3 === 2 ? e - 2 : e + 1;
        if (triangles[e] !== i) break; // bad triangulation
        e = halfedges[e];
      } while (e !== e0 && e !== -1);
      return points;
    }
  }, {
    key: "_clip",
    value: function _clip(i) {
      // degenerate case (1 valid point: return the box)
      if (i === 0 && this.delaunay.hull.length === 1) {
        return [this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax, this.xmin, this.ymin];
      }
      var points = this._cell(i);
      if (points === null) return null;
      var V = this.vectors;
      var v = i * 4;
      return V[v] || V[v + 1] ? this._clipInfinite(i, points, V[v], V[v + 1], V[v + 2], V[v + 3]) : this._clipFinite(i, points);
    }
  }, {
    key: "_clipFinite",
    value: function _clipFinite(i, points) {
      var n = points.length;
      var P = null;
      var x0,
        y0,
        x1 = points[n - 2],
        y1 = points[n - 1];
      var c0,
        c1 = this._regioncode(x1, y1);
      var e0, e1;
      for (var j = 0; j < n; j += 2) {
        x0 = x1, y0 = y1, x1 = points[j], y1 = points[j + 1];
        c0 = c1, c1 = this._regioncode(x1, y1);
        if (c0 === 0 && c1 === 0) {
          e0 = e1, e1 = 0;
          if (P) P.push(x1, y1);else P = [x1, y1];
        } else {
          var S = void 0,
            sx0 = void 0,
            sy0 = void 0,
            sx1 = void 0,
            sy1 = void 0;
          if (c0 === 0) {
            if ((S = this._clipSegment(x0, y0, x1, y1, c0, c1)) === null) continue;
            var _S = S;
            var _S2 = _slicedToArray(_S, 4);
            sx0 = _S2[0];
            sy0 = _S2[1];
            sx1 = _S2[2];
            sy1 = _S2[3];
          } else {
            if ((S = this._clipSegment(x1, y1, x0, y0, c1, c0)) === null) continue;
            var _S3 = S;
            var _S4 = _slicedToArray(_S3, 4);
            sx1 = _S4[0];
            sy1 = _S4[1];
            sx0 = _S4[2];
            sy0 = _S4[3];
            e0 = e1, e1 = this._edgecode(sx0, sy0);
            if (e0 && e1) this._edge(i, e0, e1, P, P.length);
            if (P) P.push(sx0, sy0);else P = [sx0, sy0];
          }
          e0 = e1, e1 = this._edgecode(sx1, sy1);
          if (e0 && e1) this._edge(i, e0, e1, P, P.length);
          if (P) P.push(sx1, sy1);else P = [sx1, sy1];
        }
      }
      if (P) {
        e0 = e1, e1 = this._edgecode(P[0], P[1]);
        if (e0 && e1) this._edge(i, e0, e1, P, P.length);
      } else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) {
        return [this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax, this.xmin, this.ymin];
      }
      return P;
    }
  }, {
    key: "_clipSegment",
    value: function _clipSegment(x0, y0, x1, y1, c0, c1) {
      while (true) {
        if (c0 === 0 && c1 === 0) return [x0, y0, x1, y1];
        if (c0 & c1) return null;
        var x = void 0,
          y = void 0,
          c = c0 || c1;
        if (c & 8) x = x0 + (x1 - x0) * (this.ymax - y0) / (y1 - y0), y = this.ymax;else if (c & 4) x = x0 + (x1 - x0) * (this.ymin - y0) / (y1 - y0), y = this.ymin;else if (c & 2) y = y0 + (y1 - y0) * (this.xmax - x0) / (x1 - x0), x = this.xmax;else y = y0 + (y1 - y0) * (this.xmin - x0) / (x1 - x0), x = this.xmin;
        if (c0) x0 = x, y0 = y, c0 = this._regioncode(x0, y0);else x1 = x, y1 = y, c1 = this._regioncode(x1, y1);
      }
    }
  }, {
    key: "_clipInfinite",
    value: function _clipInfinite(i, points, vx0, vy0, vxn, vyn) {
      var P = Array.from(points),
        p;
      if (p = this._project(P[0], P[1], vx0, vy0)) P.unshift(p[0], p[1]);
      if (p = this._project(P[P.length - 2], P[P.length - 1], vxn, vyn)) P.push(p[0], p[1]);
      if (P = this._clipFinite(i, P)) {
        for (var j = 0, n = P.length, c0, c1 = this._edgecode(P[n - 2], P[n - 1]); j < n; j += 2) {
          c0 = c1, c1 = this._edgecode(P[j], P[j + 1]);
          if (c0 && c1) j = this._edge(i, c0, c1, P, j), n = P.length;
        }
      } else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) {
        P = [this.xmin, this.ymin, this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax];
      }
      return P;
    }
  }, {
    key: "_edge",
    value: function _edge(i, e0, e1, P, j) {
      while (e0 !== e1) {
        var x = void 0,
          y = void 0;
        switch (e0) {
          case 5:
            e0 = 4;
            continue;
          // top-left
          case 4:
            e0 = 6, x = this.xmax, y = this.ymin;
            break;
          // top
          case 6:
            e0 = 2;
            continue;
          // top-right
          case 2:
            e0 = 10, x = this.xmax, y = this.ymax;
            break;
          // right
          case 10:
            e0 = 8;
            continue;
          // bottom-right
          case 8:
            e0 = 9, x = this.xmin, y = this.ymax;
            break;
          // bottom
          case 9:
            e0 = 1;
            continue;
          // bottom-left
          case 1:
            e0 = 5, x = this.xmin, y = this.ymin;
            break;
          // left
        }
        if ((P[j] !== x || P[j + 1] !== y) && this.contains(i, x, y)) {
          P.splice(j, 0, x, y), j += 2;
        }
      }
      if (P.length > 4) {
        for (var _i4 = 0; _i4 < P.length; _i4 += 2) {
          var _j = (_i4 + 2) % P.length,
            k = (_i4 + 4) % P.length;
          if (P[_i4] === P[_j] && P[_j] === P[k] || P[_i4 + 1] === P[_j + 1] && P[_j + 1] === P[k + 1]) P.splice(_j, 2), _i4 -= 2;
        }
      }
      return j;
    }
  }, {
    key: "_project",
    value: function _project(x0, y0, vx, vy) {
      var t = Infinity,
        c,
        x,
        y;
      if (vy < 0) {
        // top
        if (y0 <= this.ymin) return null;
        if ((c = (this.ymin - y0) / vy) < t) y = this.ymin, x = x0 + (t = c) * vx;
      } else if (vy > 0) {
        // bottom
        if (y0 >= this.ymax) return null;
        if ((c = (this.ymax - y0) / vy) < t) y = this.ymax, x = x0 + (t = c) * vx;
      }
      if (vx > 0) {
        // right
        if (x0 >= this.xmax) return null;
        if ((c = (this.xmax - x0) / vx) < t) x = this.xmax, y = y0 + (t = c) * vy;
      } else if (vx < 0) {
        // left
        if (x0 <= this.xmin) return null;
        if ((c = (this.xmin - x0) / vx) < t) x = this.xmin, y = y0 + (t = c) * vy;
      }
      return [x, y];
    }
  }, {
    key: "_edgecode",
    value: function _edgecode(x, y) {
      return (x === this.xmin ? 1 : x === this.xmax ? 2 : 0) | (y === this.ymin ? 4 : y === this.ymax ? 8 : 0);
    }
  }, {
    key: "_regioncode",
    value: function _regioncode(x, y) {
      return (x < this.xmin ? 1 : x > this.xmax ? 2 : 0) | (y < this.ymin ? 4 : y > this.ymax ? 8 : 0);
    }
  }]);
  return Voronoi;
}();

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(flatIterable);
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var tau = 2 * Math.PI,
  pow = Math.pow;
function pointX(p) {
  return p[0];
}
function pointY(p) {
  return p[1];
}

// A triangulation is collinear if all its triangles have a non-null area
function collinear(d) {
  var triangles = d.triangles,
    coords = d.coords;
  for (var i = 0; i < triangles.length; i += 3) {
    var a = 2 * triangles[i],
      b = 2 * triangles[i + 1],
      c = 2 * triangles[i + 2],
      cross = (coords[c] - coords[a]) * (coords[b + 1] - coords[a + 1]) - (coords[b] - coords[a]) * (coords[c + 1] - coords[a + 1]);
    if (cross > 1e-10) return false;
  }
  return true;
}
function jitter(x, y, r) {
  return [x + Math.sin(x + y) * r, y + Math.cos(x - y) * r];
}
var Delaunay = /*#__PURE__*/function () {
  function Delaunay(points) {
    _classCallCheck(this, Delaunay);
    this._delaunator = new Delaunator(points);
    this.inedges = new Int32Array(points.length / 2);
    this._hullIndex = new Int32Array(points.length / 2);
    this.points = this._delaunator.coords;
    this._init();
  }
  _createClass(Delaunay, [{
    key: "update",
    value: function update() {
      this._delaunator.update();
      this._init();
      return this;
    }
  }, {
    key: "_init",
    value: function _init() {
      var d = this._delaunator,
        points = this.points;

      // check for collinear
      if (d.hull && d.hull.length > 2 && collinear(d)) {
        this.collinear = Int32Array.from({
          length: points.length / 2
        }, function (_, i) {
          return i;
        }).sort(function (i, j) {
          return points[2 * i] - points[2 * j] || points[2 * i + 1] - points[2 * j + 1];
        }); // for exact neighbors
        var e = this.collinear[0],
          f = this.collinear[this.collinear.length - 1],
          bounds = [points[2 * e], points[2 * e + 1], points[2 * f], points[2 * f + 1]],
          r = 1e-8 * Math.hypot(bounds[3] - bounds[1], bounds[2] - bounds[0]);
        for (var i = 0, n = points.length / 2; i < n; ++i) {
          var p = jitter(points[2 * i], points[2 * i + 1], r);
          points[2 * i] = p[0];
          points[2 * i + 1] = p[1];
        }
        this._delaunator = new Delaunator(points);
      } else {
        delete this.collinear;
      }
      var halfedges = this.halfedges = this._delaunator.halfedges;
      var hull = this.hull = this._delaunator.hull;
      var triangles = this.triangles = this._delaunator.triangles;
      var inedges = this.inedges.fill(-1);
      var hullIndex = this._hullIndex.fill(-1);

      // Compute an index from each point to an (arbitrary) incoming halfedge
      // Used to give the first neighbor of each point; for this reason,
      // on the hull we give priority to exterior halfedges
      for (var _e = 0, _n = halfedges.length; _e < _n; ++_e) {
        var _p = triangles[_e % 3 === 2 ? _e - 2 : _e + 1];
        if (halfedges[_e] === -1 || inedges[_p] === -1) inedges[_p] = _e;
      }
      for (var _i = 0, _n2 = hull.length; _i < _n2; ++_i) {
        hullIndex[hull[_i]] = _i;
      }

      // degenerate case: 1 or 2 (distinct) points
      if (hull.length <= 2 && hull.length > 0) {
        this.triangles = new Int32Array(3).fill(-1);
        this.halfedges = new Int32Array(3).fill(-1);
        this.triangles[0] = hull[0];
        this.triangles[1] = hull[1];
        this.triangles[2] = hull[1];
        inedges[hull[0]] = 1;
        if (hull.length === 2) inedges[hull[1]] = 0;
      }
    }
  }, {
    key: "voronoi",
    value: function voronoi(bounds) {
      return new Voronoi(this, bounds);
    }
  }, {
    key: "neighbors",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function neighbors(i) {
      var inedges, hull, _hullIndex, halfedges, triangles, collinear, l, e0, e, p0, p;
      return _regeneratorRuntime.wrap(function neighbors$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            inedges = this.inedges, hull = this.hull, _hullIndex = this._hullIndex, halfedges = this.halfedges, triangles = this.triangles, collinear = this.collinear; // degenerate case with several collinear points
            if (!collinear) {
              _context.next = 10;
              break;
            }
            l = collinear.indexOf(i);
            if (!(l > 0)) {
              _context.next = 6;
              break;
            }
            _context.next = 6;
            return collinear[l - 1];
          case 6:
            if (!(l < collinear.length - 1)) {
              _context.next = 9;
              break;
            }
            _context.next = 9;
            return collinear[l + 1];
          case 9:
            return _context.abrupt("return");
          case 10:
            e0 = inedges[i];
            if (!(e0 === -1)) {
              _context.next = 13;
              break;
            }
            return _context.abrupt("return");
          case 13:
            // coincident point
            e = e0, p0 = -1;
          case 14:
            _context.next = 16;
            return p0 = triangles[e];
          case 16:
            e = e % 3 === 2 ? e - 2 : e + 1;
            if (!(triangles[e] !== i)) {
              _context.next = 19;
              break;
            }
            return _context.abrupt("return");
          case 19:
            // bad triangulation
            e = halfedges[e];
            if (!(e === -1)) {
              _context.next = 26;
              break;
            }
            p = hull[(_hullIndex[i] + 1) % hull.length];
            if (!(p !== p0)) {
              _context.next = 25;
              break;
            }
            _context.next = 25;
            return p;
          case 25:
            return _context.abrupt("return");
          case 26:
            if (e !== e0) {
              _context.next = 14;
              break;
            }
          case 27:
          case "end":
            return _context.stop();
        }
      }, neighbors, this);
    })
  }, {
    key: "find",
    value: function find(x, y) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      if ((x = +x, x !== x) || (y = +y, y !== y)) return -1;
      var i0 = i;
      var c;
      while ((c = this._step(i, x, y)) >= 0 && c !== i && c !== i0) i = c;
      return c;
    }
  }, {
    key: "_step",
    value: function _step(i, x, y) {
      var inedges = this.inedges,
        hull = this.hull,
        _hullIndex = this._hullIndex,
        halfedges = this.halfedges,
        triangles = this.triangles,
        points = this.points;
      if (inedges[i] === -1 || !points.length) return (i + 1) % (points.length >> 1);
      var c = i;
      var dc = pow(x - points[i * 2], 2) + pow(y - points[i * 2 + 1], 2);
      var e0 = inedges[i];
      var e = e0;
      do {
        var t = triangles[e];
        var dt = pow(x - points[t * 2], 2) + pow(y - points[t * 2 + 1], 2);
        if (dt < dc) dc = dt, c = t;
        e = e % 3 === 2 ? e - 2 : e + 1;
        if (triangles[e] !== i) break; // bad triangulation
        e = halfedges[e];
        if (e === -1) {
          e = hull[(_hullIndex[i] + 1) % hull.length];
          if (e !== t) {
            if (pow(x - points[e * 2], 2) + pow(y - points[e * 2 + 1], 2) < dc) return e;
          }
          break;
        }
      } while (e !== e0);
      return c;
    }
  }, {
    key: "render",
    value: function render(context) {
      var buffer = context == null ? context = new Path() : undefined;
      var points = this.points,
        halfedges = this.halfedges,
        triangles = this.triangles;
      for (var i = 0, n = halfedges.length; i < n; ++i) {
        var j = halfedges[i];
        if (j < i) continue;
        var ti = triangles[i] * 2;
        var tj = triangles[j] * 2;
        context.moveTo(points[ti], points[ti + 1]);
        context.lineTo(points[tj], points[tj + 1]);
      }
      this.renderHull(context);
      return buffer && buffer.value();
    }
  }, {
    key: "renderPoints",
    value: function renderPoints(context) {
      var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
      var buffer = context == null ? context = new Path() : undefined;
      var points = this.points;
      for (var i = 0, n = points.length; i < n; i += 2) {
        var x = points[i],
          y = points[i + 1];
        context.moveTo(x + r, y);
        context.arc(x, y, r, 0, tau);
      }
      return buffer && buffer.value();
    }
  }, {
    key: "renderHull",
    value: function renderHull(context) {
      var buffer = context == null ? context = new Path() : undefined;
      var hull = this.hull,
        points = this.points;
      var h = hull[0] * 2,
        n = hull.length;
      context.moveTo(points[h], points[h + 1]);
      for (var i = 1; i < n; ++i) {
        var _h = 2 * hull[i];
        context.lineTo(points[_h], points[_h + 1]);
      }
      context.closePath();
      return buffer && buffer.value();
    }
  }, {
    key: "hullPolygon",
    value: function hullPolygon() {
      var polygon = new Polygon();
      this.renderHull(polygon);
      return polygon.value();
    }
  }, {
    key: "renderTriangle",
    value: function renderTriangle(i, context) {
      var buffer = context == null ? context = new Path() : undefined;
      var points = this.points,
        triangles = this.triangles;
      var t0 = triangles[i *= 3] * 2;
      var t1 = triangles[i + 1] * 2;
      var t2 = triangles[i + 2] * 2;
      context.moveTo(points[t0], points[t0 + 1]);
      context.lineTo(points[t1], points[t1 + 1]);
      context.lineTo(points[t2], points[t2 + 1]);
      context.closePath();
      return buffer && buffer.value();
    }
  }, {
    key: "trianglePolygons",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function trianglePolygons() {
      var triangles, i, n;
      return _regeneratorRuntime.wrap(function trianglePolygons$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            triangles = this.triangles;
            i = 0, n = triangles.length / 3;
          case 2:
            if (!(i < n)) {
              _context2.next = 8;
              break;
            }
            _context2.next = 5;
            return this.trianglePolygon(i);
          case 5:
            ++i;
            _context2.next = 2;
            break;
          case 8:
          case "end":
            return _context2.stop();
        }
      }, trianglePolygons, this);
    })
  }, {
    key: "trianglePolygon",
    value: function trianglePolygon(i) {
      var polygon = new Polygon();
      this.renderTriangle(i, polygon);
      return polygon.value();
    }
  }], [{
    key: "from",
    value: function from(points) {
      var fx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : pointX;
      var fy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : pointY;
      var that = arguments.length > 3 ? arguments[3] : undefined;
      return new Delaunay("length" in points ? flatArray(points, fx, fy, that) : Float64Array.from(flatIterable(points, fx, fy, that)));
    }
  }]);
  return Delaunay;
}();
function flatArray(points, fx, fy, that) {
  var n = points.length;
  var array = new Float64Array(n * 2);
  for (var i = 0; i < n; ++i) {
    var p = points[i];
    array[i * 2] = fx.call(that, p, i, points);
    array[i * 2 + 1] = fy.call(that, p, i, points);
  }
  return array;
}
function flatIterable(points, fx, fy, that) {
  var i, _iterator, _step2, p;
  return _regeneratorRuntime.wrap(function flatIterable$(_context3) {
    while (1) switch (_context3.prev = _context3.next) {
      case 0:
        i = 0;
        _iterator = _createForOfIteratorHelper(points);
        _context3.prev = 2;
        _iterator.s();
      case 4:
        if ((_step2 = _iterator.n()).done) {
          _context3.next = 13;
          break;
        }
        p = _step2.value;
        _context3.next = 8;
        return fx.call(that, p, i, points);
      case 8:
        _context3.next = 10;
        return fy.call(that, p, i, points);
      case 10:
        ++i;
      case 11:
        _context3.next = 4;
        break;
      case 13:
        _context3.next = 18;
        break;
      case 15:
        _context3.prev = 15;
        _context3.t0 = _context3["catch"](2);
        _iterator.e(_context3.t0);
      case 18:
        _context3.prev = 18;
        _iterator.f();
        return _context3.finish(18);
      case 21:
      case "end":
        return _context3.stop();
    }
  }, _marked, null, [[2, 15, 18, 21]]);
}

var g = function g(n) {
    return "function" == typeof n ? n : function (e) {
      return e[n];
    };
  },
  b$1 = function b(n) {
    var e = n.points,
      i = n.x,
      o = void 0 === i ? "x" : i,
      t = n.y,
      r = void 0 === t ? "y" : t,
      l = g(o),
      u = g(r);
    return e.map(function (n) {
      return [l(n), u(n)];
    });
  },
  k = function k(n) {
    var e = n.points,
      i = n.width,
      o = n.height,
      t = n.debug,
      r = Delaunay.from(e),
      l = t ? r.voronoi([0, 0, i, o]) : void 0;
    return {
      delaunay: r,
      voronoi: l
    };
  },
  x = function x(e) {
    var i = e.points,
      o = e.x,
      t = e.y,
      r = e.width,
      l = e.height,
      u = e.debug,
      a = useMemo(function () {
        return b$1({
          points: i,
          x: o,
          y: t
        });
      }, [i, o, t]);
    return useMemo(function () {
      return k({
        points: a,
        width: r,
        height: l,
        debug: u
      });
    }, [a, r, l, u]);
  },
  O = function O(e) {
    var i = e.nodes,
      l = e.width,
      u = e.height,
      a = e.x,
      d = e.y,
      c = e.onMouseEnter,
      h = e.onMouseMove,
      m = e.onMouseLeave,
      y = e.onClick,
      g = e.debug,
      b = useRef(null),
      k = useState(null),
      C = k[0],
      L = k[1],
      w = x({
        points: i,
        x: a,
        y: d,
        width: l,
        height: u,
        debug: g
      }),
      W = w.delaunay,
      D = w.voronoi,
      M = useMemo(function () {
        if (g && D) return D.render();
      }, [g, D]),
      O = useCallback(function (n) {
        if (!b.current) return [null, null];
        var e = Fi(b.current, n),
          o = e[0],
          t = e[1],
          r = W.find(o, t);
        return [r, void 0 !== r ? i[r] : null];
      }, [b, W]),
      P = useCallback(function (n) {
        var e = O(n),
          i = e[0],
          o = e[1];
        L(i), o && (null == c || c(o, n));
      }, [O, L, c]),
      j = useCallback(function (n) {
        var e = O(n),
          i = e[0],
          o = e[1];
        L(i), o && (null == h || h(o, n));
      }, [O, L, h]),
      S = useCallback(function (n) {
        if (L(null), m) {
          var e = void 0;
          null !== C && (e = i[C]), e && m(e, n);
        }
      }, [L, C, m, i]),
      z = useCallback(function (n) {
        var e = O(n),
          i = e[0],
          o = e[1];
        L(i), o && (null == y || y(o, n));
      }, [O, L, y]);
    return jsxs("g", {
      ref: b,
      children: [g && D && jsxs(Fragment$1, {
        children: [jsx("path", {
          d: M,
          stroke: "red",
          strokeWidth: 1,
          opacity: .75
        }), null !== C && jsx("path", {
          fill: "pink",
          opacity: .35,
          d: D.renderCell(C)
        })]
      }), jsx("rect", {
        width: l,
        height: u,
        fill: "red",
        opacity: 0,
        style: {
          cursor: "auto"
        },
        onMouseEnter: P,
        onMouseMove: j,
        onMouseLeave: S,
        onClick: z
      })]
    });
  },
  P$1 = function P(n, e) {
    n.save(), n.globalAlpha = .75, n.beginPath(), e.render(n), n.strokeStyle = "red", n.lineWidth = 1, n.stroke(), n.restore();
  },
  j = function j(n, e, i) {
    n.save(), n.globalAlpha = .35, n.beginPath(), e.renderCell(i, n), n.fillStyle = "red", n.fill(), n.restore();
  };

function re() {
  return re = Object.assign ? Object.assign.bind() : function (e) {
    for (var i = 1; i < arguments.length; i++) {
      var r = arguments[i];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, re.apply(this, arguments);
}
var ne = function ne(e) {
  var i = e.point;
  return jsx(w$3, {
    id: jsxs("span", {
      children: ["x: ", jsx("strong", {
        children: i.data.xFormatted
      }), ", y:", " ", jsx("strong", {
        children: i.data.yFormatted
      })]
    }),
    enableChip: !0,
    color: i.serieColor
  });
};
ne.propTypes = {
  point: PropTypes.object.isRequired
};
var oe = /*#__PURE__*/memo(ne),
  te = function te(e) {
    var i = e.slice,
      r = e.axis,
      n = Et(),
      o = "x" === r ? "y" : "x";
    return jsx(C$5, {
      rows: i.points.map(function (e) {
        return [jsx(g$2, {
          color: e.serieColor,
          style: n.tooltip.chip
        }, "chip"), e.serieId, jsx("span", {
          style: n.tooltip.tableCellValue,
          children: e.data[o + "Formatted"]
        }, "value")];
      })
    });
  };
te.propTypes = {
  slice: PropTypes.object.isRequired,
  axis: PropTypes.oneOf(["x", "y"]).isRequired
};
var ae = /*#__PURE__*/memo(te),
  se = {
    data: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      data: PropTypes.arrayOf(PropTypes.shape({
        x: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.instanceOf(Date)]),
        y: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.instanceOf(Date)])
      })).isRequired
    })).isRequired,
    xScale: PropTypes.object.isRequired,
    xFormat: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    yScale: PropTypes.object.isRequired,
    yFormat: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    layers: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf(["grid", "markers", "axes", "areas", "crosshair", "lines", "slices", "points", "mesh", "legends"]), PropTypes.func])).isRequired,
    curve: bt.isRequired,
    axisTop: w,
    axisRight: w,
    axisBottom: w,
    axisLeft: w,
    enableGridX: PropTypes.bool.isRequired,
    enableGridY: PropTypes.bool.isRequired,
    gridXValues: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.instanceOf(Date)]))]),
    gridYValues: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.instanceOf(Date)]))]),
    enablePoints: PropTypes.bool.isRequired,
    pointSymbol: PropTypes.func,
    pointSize: PropTypes.number.isRequired,
    pointColor: PropTypes.any.isRequired,
    pointBorderWidth: PropTypes.number.isRequired,
    pointBorderColor: PropTypes.any.isRequired,
    enablePointLabel: PropTypes.bool.isRequired,
    pointLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
    markers: PropTypes.arrayOf(PropTypes.shape({
      axis: PropTypes.oneOf(["x", "y"]).isRequired,
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
      style: PropTypes.object
    })),
    colors: Xe.isRequired,
    enableArea: PropTypes.bool.isRequired,
    areaOpacity: PropTypes.number.isRequired,
    areaBlendMode: zt.isRequired,
    areaBaselineValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
    lineWidth: PropTypes.number.isRequired,
    legends: PropTypes.arrayOf(PropTypes.shape(T$2)).isRequired,
    isInteractive: PropTypes.bool.isRequired,
    debugMesh: PropTypes.bool.isRequired,
    tooltip: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
    enableSlices: PropTypes.oneOf(["x", "y", !1]).isRequired,
    debugSlices: PropTypes.bool.isRequired,
    sliceTooltip: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
    enableCrosshair: PropTypes.bool.isRequired,
    crosshairType: PropTypes.string.isRequired
  },
  le = re({}, se, {
    enablePointLabel: PropTypes.bool.isRequired,
    role: PropTypes.string.isRequired,
    useMesh: PropTypes.bool.isRequired
  }, Jr, yt),
  ue = re({
    pixelRatio: PropTypes.number.isRequired
  }, se),
  de = {
    curve: "linear",
    xScale: {
      type: "point"
    },
    yScale: {
      type: "linear",
      min: 0,
      max: "auto"
    },
    layers: ["grid", "markers", "axes", "areas", "crosshair", "lines", "points", "slices", "mesh", "legends"],
    axisBottom: {},
    axisLeft: {},
    enableGridX: !0,
    enableGridY: !0,
    enablePoints: !0,
    pointSize: 6,
    pointColor: {
      from: "color"
    },
    pointBorderWidth: 0,
    pointBorderColor: {
      theme: "background"
    },
    enablePointLabel: !1,
    pointLabel: "yFormatted",
    colors: {
      scheme: "nivo"
    },
    enableArea: !1,
    areaBaselineValue: 0,
    areaOpacity: .2,
    areaBlendMode: "normal",
    lineWidth: 2,
    legends: [],
    isInteractive: !0,
    tooltip: oe,
    enableSlices: !1,
    debugSlices: !1,
    sliceTooltip: ae,
    debugMesh: !1,
    enableCrosshair: !0,
    crosshairType: "bottom-left"
  },
  ce = re({}, de, {
    enablePointLabel: !1,
    useMesh: !1,
    animate: !0,
    motionConfig: "gentle",
    defs: [],
    fill: [],
    role: "img"
  }),
  fe = re({}, de, {
    pixelRatio: "undefined" != typeof window && window.devicePixelRatio || 1
  }),
  pe = function pe(e) {
    var r = e.curve;
    return useMemo(function () {
      return H$4().defined(function (e) {
        return null !== e.x && null !== e.y;
      }).x(function (e) {
        return e.x;
      }).y(function (e) {
        return e.y;
      }).curve(mt(r));
    }, [r]);
  },
  he = function he(e) {
    var r = e.curve,
      n = e.yScale,
      o = e.areaBaselineValue;
    return useMemo(function () {
      return I$3().defined(function (e) {
        return null !== e.x && null !== e.y;
      }).x(function (e) {
        return e.x;
      }).y1(function (e) {
        return e.y;
      }).curve(mt(r)).y0(n(o));
    }, [r, n, o]);
  },
  ye = function ye(e) {
    var r = e.enableSlices,
      n = e.points,
      o = e.width,
      t = e.height;
    return useMemo(function () {
      if (!1 === r) return [];
      if ("x" === r) {
        var e = new Map();
        return n.forEach(function (i) {
          null !== i.data.x && null !== i.data.y && (e.has(i.x) ? e.get(i.x).push(i) : e.set(i.x, [i]));
        }), Array.from(e.entries()).sort(function (e, i) {
          return e[0] - i[0];
        }).map(function (e, i, r) {
          var n,
            a = e[0],
            s = e[1],
            l = r[i - 1],
            u = r[i + 1];
          return {
            id: a,
            x0: n = l ? a - (a - l[0]) / 2 : a,
            x: a,
            y0: 0,
            y: 0,
            width: u ? a - n + (u[0] - a) / 2 : o - n,
            height: t,
            points: s.reverse()
          };
        });
      }
      if ("y" === r) {
        var i = new Map();
        return n.forEach(function (e) {
          null !== e.data.x && null !== e.data.y && (i.has(e.y) ? i.get(e.y).push(e) : i.set(e.y, [e]));
        }), Array.from(i.entries()).sort(function (e, i) {
          return e[0] - i[0];
        }).map(function (e, i, r) {
          var n,
            a,
            s = e[0],
            l = e[1],
            u = r[i - 1],
            d = r[i + 1];
          return n = u ? s - (s - u[0]) / 2 : s, a = d ? s - n + (d[0] - s) / 2 : t - n, {
            id: s,
            x0: 0,
            x: 0,
            y0: n,
            y: s,
            width: o,
            height: a,
            points: l.reverse()
          };
        });
      }
    }, [r, n]);
  },
  be = function be(e) {
    var o = e.data,
      t = e.xScale,
      a = void 0 === t ? ce.xScale : t,
      s = e.xFormat,
      l = e.yScale,
      d = void 0 === l ? ce.yScale : l,
      c = e.yFormat,
      f = e.width,
      p = e.height,
      h = e.colors,
      b = void 0 === h ? ce.colors : h,
      g = e.curve,
      m = void 0 === g ? ce.curve : g,
      v = e.areaBaselineValue,
      x = void 0 === v ? ce.areaBaselineValue : v,
      R = e.pointColor,
      q = void 0 === R ? ce.pointColor : R,
      O = e.pointBorderColor,
      M = void 0 === O ? ce.pointBorderColor : O,
      C = e.enableSlices,
      S = void 0 === C ? ce.enableSlicesTooltip : C,
      T = Dt(s),
      w = Dt(c),
      L = pr(b, "id"),
      W = Et(),
      G = We$1(q, W),
      P = We$1(M, W),
      E = useState([]),
      j = E[0],
      F = E[1],
      V = useMemo(function () {
        return dn(o.filter(function (e) {
          return -1 === j.indexOf(e.id);
        }), a, d, f, p);
      }, [o, j, a, d, f, p]),
      Y = V.xScale,
      D = V.yScale,
      X = V.series,
      z = useMemo(function () {
        var e = o.map(function (e) {
            return {
              id: e.id,
              label: e.id,
              color: L(e)
            };
          }),
          i = e.map(function (e) {
            return re({}, X.find(function (i) {
              return i.id === e.id;
            }), {
              color: e.color
            });
          }).filter(function (e) {
            return Boolean(e.id);
          });
        return {
          legendData: e.map(function (e) {
            return re({}, e, {
              hidden: !i.find(function (i) {
                return i.id === e.id;
              })
            });
          }).reverse(),
          series: i
        };
      }, [o, X, L]),
      A = z.legendData,
      H = z.series,
      I = useCallback(function (e) {
        F(function (i) {
          return i.indexOf(e) > -1 ? i.filter(function (i) {
            return i !== e;
          }) : [].concat(i, [e]);
        });
      }, []),
      K = function (e) {
        var r = e.series,
          n = e.getPointColor,
          o = e.getPointBorderColor,
          t = e.formatX,
          a = e.formatY;
        return useMemo(function () {
          return r.reduce(function (e, i) {
            return [].concat(e, i.data.filter(function (e) {
              return null !== e.position.x && null !== e.position.y;
            }).map(function (r, s) {
              var l = {
                id: i.id + "." + s,
                index: e.length + s,
                serieId: i.id,
                serieColor: i.color,
                x: r.position.x,
                y: r.position.y
              };
              return l.color = n(i), l.borderColor = o(l), l.data = re({}, r.data, {
                xFormatted: t(r.data.x),
                yFormatted: a(r.data.y)
              }), l;
            }));
          }, []);
        }, [r, n, o, t, a]);
      }({
        series: H,
        getPointColor: G,
        getPointBorderColor: P,
        formatX: T,
        formatY: w
      }),
      N = ye({
        enableSlices: S,
        points: K,
        width: f,
        height: p
      });
    return {
      legendData: A,
      toggleSerie: I,
      lineGenerator: pe({
        curve: m
      }),
      areaGenerator: he({
        curve: m,
        yScale: D,
        areaBaselineValue: x
      }),
      getColor: L,
      series: H,
      xScale: Y,
      yScale: D,
      slices: N,
      points: K
    };
  },
  ge = function ge(e) {
    var i = e.areaBlendMode,
      r = e.areaOpacity,
      n = e.color,
      o = e.fill,
      t = e.path,
      a = Zr(),
      s = a.animate,
      l = a.config,
      u = $r(t),
      d = useSpring({
        color: n,
        config: l,
        immediate: !s
      });
    return jsx(animated.path, {
      d: u,
      fill: o || d.color,
      fillOpacity: r,
      strokeWidth: 0,
      style: {
        mixBlendMode: i
      }
    });
  };
ge.propTypes = {
  areaBlendMode: zt.isRequired,
  areaOpacity: PropTypes.number.isRequired,
  color: PropTypes.string,
  fill: PropTypes.string,
  path: PropTypes.string.isRequired
};
var me = function me(e) {
  var i = e.areaGenerator,
    r = e.areaOpacity,
    n = e.areaBlendMode,
    o = e.lines.slice(0).reverse();
  return jsx("g", {
    children: o.map(function (e) {
      return jsx(ge, re({
        path: i(e.data.map(function (e) {
          return e.position;
        }))
      }, re({
        areaOpacity: r,
        areaBlendMode: n
      }, e)), e.id);
    })
  });
};
me.propTypes = {
  areaGenerator: PropTypes.func.isRequired,
  areaOpacity: PropTypes.number.isRequired,
  areaBlendMode: zt.isRequired,
  lines: PropTypes.arrayOf(PropTypes.object).isRequired
};
var ve = /*#__PURE__*/memo(me),
  xe = function xe(e) {
    var r = e.lineGenerator,
      n = e.points,
      o = e.color,
      t = e.thickness,
      a = useMemo(function () {
        return r(n);
      }, [r, n]),
      s = $r(a);
    return jsx(animated.path, {
      d: s,
      fill: "none",
      strokeWidth: t,
      stroke: o
    });
  };
xe.propTypes = {
  points: PropTypes.arrayOf(PropTypes.shape({
    x: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    y: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })),
  lineGenerator: PropTypes.func.isRequired,
  color: PropTypes.string.isRequired,
  thickness: PropTypes.number.isRequired
};
var Re = /*#__PURE__*/memo(xe),
  qe = function qe(e) {
    var i = e.lines,
      r = e.lineGenerator,
      n = e.lineWidth;
    return i.slice(0).reverse().map(function (e) {
      var i = e.id,
        o = e.data,
        t = e.color;
      return jsx(Re, {
        id: i,
        points: o.map(function (e) {
          return e.position;
        }),
        lineGenerator: r,
        color: t,
        thickness: n
      }, i);
    });
  };
qe.propTypes = {
  lines: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    color: PropTypes.string.isRequired,
    data: PropTypes.arrayOf(PropTypes.shape({
      data: PropTypes.shape({
        x: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(Date)]),
        y: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(Date)])
      }).isRequired,
      position: PropTypes.shape({
        x: PropTypes.number,
        y: PropTypes.number
      }).isRequired
    })).isRequired
  })).isRequired,
  lineWidth: PropTypes.number.isRequired,
  lineGenerator: PropTypes.func.isRequired
};
var Oe = /*#__PURE__*/memo(qe),
  Me = function Me(e) {
    var i = e.slice,
      r = e.axis,
      t = e.debug,
      a = e.tooltip,
      s = e.isCurrent,
      l = e.setCurrent,
      u = e.onMouseEnter,
      d = e.onMouseMove,
      c = e.onMouseLeave,
      f = e.onClick,
      p = k$5(),
      h = p.showTooltipFromEvent,
      y = p.hideTooltip,
      b = useCallback(function (e) {
        h( /*#__PURE__*/createElement(a, {
          slice: i,
          axis: r
        }), e, "right"), l(i), u && u(i, e);
      }, [h, a, i, u]),
      g = useCallback(function (e) {
        h( /*#__PURE__*/createElement(a, {
          slice: i,
          axis: r
        }), e, "right"), d && d(i, e);
      }, [h, a, i, d]),
      m = useCallback(function (e) {
        y(), l(null), c && c(i, e);
      }, [y, i, c]),
      v = useCallback(function (e) {
        f && f(i, e);
      }, [i, f]);
    return jsx("rect", {
      x: i.x0,
      y: i.y0,
      width: i.width,
      height: i.height,
      stroke: "red",
      strokeWidth: t ? 1 : 0,
      strokeOpacity: .75,
      fill: "red",
      fillOpacity: s && t ? .35 : 0,
      onMouseEnter: b,
      onMouseMove: g,
      onMouseLeave: m,
      onClick: v,
      "data-testid": "slice-" + i.id
    });
  };
Me.propTypes = {
  slice: PropTypes.object.isRequired,
  axis: PropTypes.oneOf(["x", "y"]).isRequired,
  debug: PropTypes.bool.isRequired,
  height: PropTypes.number.isRequired,
  tooltip: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  isCurrent: PropTypes.bool.isRequired,
  setCurrent: PropTypes.func.isRequired,
  onMouseEnter: PropTypes.func,
  onMouseMove: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onClick: PropTypes.func
};
var Ce = /*#__PURE__*/memo(Me),
  Se = function Se(e) {
    var i = e.slices,
      r = e.axis,
      n = e.debug,
      o = e.height,
      t = e.tooltip,
      a = e.current,
      s = e.setCurrent,
      l = e.onMouseEnter,
      u = e.onMouseMove,
      d = e.onMouseLeave,
      c = e.onClick;
    return i.map(function (e) {
      return jsx(Ce, {
        slice: e,
        axis: r,
        debug: n,
        height: o,
        tooltip: t,
        setCurrent: s,
        isCurrent: null !== a && a.id === e.id,
        onMouseEnter: l,
        onMouseMove: u,
        onMouseLeave: d,
        onClick: c
      }, e.id);
    });
  };
Se.propTypes = {
  slices: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    points: PropTypes.arrayOf(PropTypes.object).isRequired
  })).isRequired,
  axis: PropTypes.oneOf(["x", "y"]).isRequired,
  debug: PropTypes.bool.isRequired,
  height: PropTypes.number.isRequired,
  tooltip: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  current: PropTypes.object,
  setCurrent: PropTypes.func.isRequired,
  onMouseEnter: PropTypes.func,
  onMouseMove: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onClick: PropTypes.func
};
var Te = /*#__PURE__*/memo(Se),
  we = function we(e) {
    var i = e.points,
      r = e.symbol,
      n = e.size,
      o = e.borderWidth,
      t = e.enableLabel,
      a = e.label,
      s = e.labelYOffset,
      l = Et(),
      d = ji(a),
      c = i.slice(0).reverse().map(function (e) {
        return {
          id: e.id,
          x: e.x,
          y: e.y,
          datum: e.data,
          fill: e.color,
          stroke: e.borderColor,
          label: t ? d(e.data) : null
        };
      });
    return jsx("g", {
      children: c.map(function (e) {
        return jsx(Wi, {
          x: e.x,
          y: e.y,
          datum: e.datum,
          symbol: r,
          size: n,
          color: e.fill,
          borderWidth: o,
          borderColor: e.stroke,
          label: e.label,
          labelYOffset: s,
          theme: l
        }, e.id);
      })
    });
  };
we.propTypes = {
  points: PropTypes.arrayOf(PropTypes.object),
  symbol: PropTypes.func,
  size: PropTypes.number.isRequired,
  color: PropTypes.func.isRequired,
  borderWidth: PropTypes.number.isRequired,
  borderColor: PropTypes.func.isRequired,
  enableLabel: PropTypes.bool.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
  labelYOffset: PropTypes.number
};
var ke = /*#__PURE__*/memo(we),
  Be = function Be(e) {
    var i = e.points,
      r = e.width,
      t = e.height,
      a = e.margin,
      s = e.setCurrent,
      l = e.onMouseEnter,
      u = e.onMouseMove,
      d = e.onMouseLeave,
      c = e.onClick,
      f = e.tooltip,
      p = e.debug,
      h = k$5(),
      y = h.showTooltipAt,
      b = h.hideTooltip,
      g = useCallback(function (e, i) {
        y( /*#__PURE__*/createElement(f, {
          point: e
        }), [e.x + a.left, e.y + a.top], "top"), s(e), l && l(e, i);
      }, [s, y, f, l, a]),
      m = useCallback(function (e, i) {
        y( /*#__PURE__*/createElement(f, {
          point: e
        }), [e.x + a.left, e.y + a.top], "top"), s(e), u && u(e, i);
      }, [s, y, f, u]),
      v = useCallback(function (e, i) {
        b(), s(null), d && d(e, i);
      }, [b, s, d]),
      x = useCallback(function (e, i) {
        c && c(e, i);
      }, [c]);
    return jsx(O, {
      nodes: i,
      width: r,
      height: t,
      onMouseEnter: g,
      onMouseMove: m,
      onMouseLeave: v,
      onClick: x,
      debug: p
    });
  };
Be.propTypes = {
  points: PropTypes.arrayOf(PropTypes.object).isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  margin: PropTypes.object.isRequired,
  setCurrent: PropTypes.func.isRequired,
  onMouseEnter: PropTypes.func,
  onMouseMove: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onClick: PropTypes.func,
  tooltip: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  debug: PropTypes.bool.isRequired
};
var Le = /*#__PURE__*/memo(Be),
  We = function We(e) {
    var i = e.data,
      n = e.xScale,
      o = e.xFormat,
      a = e.yScale,
      s = e.yFormat,
      l = e.layers,
      d = e.curve,
      c = e.areaBaselineValue,
      f = e.colors,
      p = e.margin,
      h = e.width,
      y = e.height,
      b = e.axisTop,
      g = e.axisRight,
      m = e.axisBottom,
      v = e.axisLeft,
      x = e.enableGridX,
      C = e.enableGridY,
      S = e.gridXValues,
      T = e.gridYValues,
      w = e.lineWidth,
      k = e.enableArea,
      L = e.areaOpacity,
      P = e.areaBlendMode,
      E = e.enablePoints,
      j = e.pointSymbol,
      V = e.pointSize,
      Y = e.pointColor,
      D = e.pointBorderWidth,
      X = e.pointBorderColor,
      z$1 = e.enablePointLabel,
      H = e.pointLabel,
      I = e.pointLabelYOffset,
      J = e.defs,
      K = e.fill,
      Q = e.markers,
      U = e.legends,
      Z = e.isInteractive,
      $ = e.useMesh,
      _ = e.debugMesh,
      ee = e.onMouseEnter,
      ie = e.onMouseMove,
      ne = e.onMouseLeave,
      oe = e.onClick,
      te = e.tooltip,
      ae = e.enableSlices,
      se = e.debugSlices,
      le = e.sliceTooltip,
      ue = e.enableCrosshair,
      de = e.crosshairType,
      ce = e.role,
      fe = Bt(h, y, p),
      pe = fe.margin,
      he = fe.innerWidth,
      ye = fe.innerHeight,
      ge = fe.outerWidth,
      me = fe.outerHeight,
      xe = be({
        data: i,
        xScale: n,
        xFormat: o,
        yScale: a,
        yFormat: s,
        width: he,
        height: ye,
        colors: f,
        curve: d,
        areaBaselineValue: c,
        pointColor: Y,
        pointBorderColor: X,
        enableSlices: ae
      }),
      Re = xe.legendData,
      qe = xe.toggleSerie,
      Me = xe.lineGenerator,
      Ce = xe.areaGenerator,
      Se = xe.series,
      we = xe.xScale,
      Be = xe.yScale,
      We = xe.slices,
      Ge = xe.points,
      Pe = Et(),
      Ee = We$1(Y, Pe),
      je = We$1(X, Pe),
      Fe = useState(null),
      Ve = Fe[0],
      Ye = Fe[1],
      De = useState(null),
      Xe = De[0],
      ze = De[1],
      Ae = {
        grid: jsx(z, {
          theme: Pe,
          width: he,
          height: ye,
          xScale: x ? we : null,
          yScale: C ? Be : null,
          xValues: S,
          yValues: T
        }, "grid"),
        markers: jsx(Ti, {
          markers: Q,
          width: he,
          height: ye,
          xScale: we,
          yScale: Be,
          theme: Pe
        }, "markers"),
        axes: jsx(X$1, {
          xScale: we,
          yScale: Be,
          width: he,
          height: ye,
          theme: Pe,
          top: b,
          right: g,
          bottom: m,
          left: v
        }, "axes"),
        areas: null,
        lines: jsx(Oe, {
          lines: Se,
          lineGenerator: Me,
          lineWidth: w
        }, "lines"),
        slices: null,
        points: null,
        crosshair: null,
        mesh: null,
        legends: U.map(function (e, i) {
          return jsx(X$4, re({}, e, {
            containerWidth: he,
            containerHeight: ye,
            data: e.data || Re,
            theme: Pe,
            toggleSerie: e.toggleSerie ? qe : void 0
          }), "legend." + i);
        })
      },
      He = Hi(J, Se, K);
    return k && (Ae.areas = jsx(ve, {
      areaGenerator: Ce,
      areaOpacity: L,
      areaBlendMode: P,
      lines: Se
    }, "areas")), Z && !1 !== ae && (Ae.slices = jsx(Te, {
      slices: We,
      axis: ae,
      debug: se,
      height: ye,
      tooltip: le,
      current: Xe,
      setCurrent: ze,
      onMouseEnter: ee,
      onMouseMove: ie,
      onMouseLeave: ne,
      onClick: oe
    }, "slices")), E && (Ae.points = jsx(ke, {
      points: Ge,
      symbol: j,
      size: V,
      color: Ee,
      borderWidth: D,
      borderColor: je,
      enableLabel: z$1,
      label: H,
      labelYOffset: I
    }, "points")), Z && ue && (null !== Ve && (Ae.crosshair = jsx(P$5, {
      width: he,
      height: ye,
      x: Ve.x,
      y: Ve.y,
      type: de
    }, "crosshair")), null !== Xe && (Ae.crosshair = jsx(P$5, {
      width: he,
      height: ye,
      x: Xe.x,
      y: Xe.y,
      type: ae
    }, "crosshair"))), Z && $ && !1 === ae && (Ae.mesh = jsx(Le, {
      points: Ge,
      width: he,
      height: ye,
      margin: pe,
      current: Ve,
      setCurrent: Ye,
      onMouseEnter: ee,
      onMouseMove: ie,
      onMouseLeave: ne,
      onClick: oe,
      tooltip: te,
      debug: _
    }, "mesh")), jsx(_i, {
      defs: He,
      width: ge,
      height: me,
      margin: pe,
      role: ce,
      children: l.map(function (i, r) {
        return "function" == typeof i ? jsx(Fragment, {
          children: i(re({}, e, {
            innerWidth: he,
            innerHeight: ye,
            series: Se,
            slices: We,
            points: Ge,
            xScale: we,
            yScale: Be,
            lineGenerator: Me,
            areaGenerator: Ce,
            currentPoint: Ve,
            setCurrentPoint: Ye,
            currentSlice: Xe,
            setCurrentSlice: ze
          }))
        }, r) : Ae[i];
      })
    });
  };
We.propTypes = le, We.defaultProps = ce;
var Ge = Mi(We),
  Pe = function Pe(e) {
    return jsx(Jt, {
      children: function children(i) {
        var r = i.width,
          n = i.height;
        return jsx(Ge, re({
          width: r,
          height: n
        }, e));
      }
    });
  },
  Ee = function Ee(e) {
    var i = e.width,
      t = e.height,
      a = e.margin,
      d = e.pixelRatio,
      c = e.data,
      f = e.xScale,
      p = e.xFormat,
      h = e.yScale,
      y = e.yFormat,
      b = e.curve,
      g = e.layers,
      m = e.colors,
      v = e.lineWidth,
      x$1 = e.enableArea,
      q = e.areaBaselineValue,
      O = e.areaOpacity,
      M = e.enablePoints,
      C = e.pointSize,
      w = e.pointColor,
      k = e.pointBorderWidth,
      B = e.pointBorderColor,
      L = e.enableGridX,
      W = e.gridXValues,
      G = e.enableGridY,
      j$2 = e.gridYValues,
      F = e.axisTop,
      Y = e.axisRight,
      D = e.axisBottom,
      X = e.axisLeft,
      A = e.legends,
      H = e.isInteractive,
      I = e.debugMesh,
      J = e.onMouseLeave,
      K = e.onClick,
      Q = e.tooltip,
      U = e.canvasRef,
      Z = useRef(null),
      $ = Bt(i, t, a),
      ne = $.margin,
      oe = $.innerWidth,
      te = $.innerHeight,
      ae = $.outerWidth,
      se = $.outerHeight,
      le = Et(),
      ue = useState(null),
      de = ue[0],
      ce = ue[1],
      fe = be({
        data: c,
        xScale: f,
        xFormat: p,
        yScale: h,
        yFormat: y,
        width: oe,
        height: te,
        colors: m,
        curve: b,
        areaBaselineValue: q,
        pointColor: w,
        pointBorderColor: B
      }),
      pe = fe.lineGenerator,
      he = fe.areaGenerator,
      ye = fe.series,
      ge = fe.xScale,
      me = fe.yScale,
      ve = fe.points,
      xe = x({
        points: ve,
        width: oe,
        height: te,
        debug: I
      }),
      Re = xe.delaunay,
      qe = xe.voronoi;
    useEffect(function () {
      U && (U.current = Z.current), Z.current.width = ae * d, Z.current.height = se * d;
      var e = Z.current.getContext("2d");
      e.scale(d, d), e.fillStyle = le.background, e.fillRect(0, 0, ae, se), e.translate(ne.left, ne.top), g.forEach(function (i) {
        if ("function" == typeof i && i({
          ctx: e,
          innerWidth: oe,
          innerHeight: te,
          series: ye,
          points: ve,
          xScale: ge,
          yScale: me,
          lineWidth: v,
          lineGenerator: pe,
          areaGenerator: he,
          currentPoint: de,
          setCurrentPoint: ce
        }), "grid" === i && le.grid.line.strokeWidth > 0 && (e.lineWidth = le.grid.line.strokeWidth, e.strokeStyle = le.grid.line.stroke, L && D$1(e, {
          width: oe,
          height: te,
          scale: ge,
          axis: "x",
          values: W
        }), G && D$1(e, {
          width: oe,
          height: te,
          scale: me,
          axis: "y",
          values: j$2
        })), "axes" === i && j$1(e, {
          xScale: ge,
          yScale: me,
          width: oe,
          height: te,
          top: F,
          right: Y,
          bottom: D,
          left: X,
          theme: le
        }), "areas" === i && !0 === x$1 && (e.save(), e.globalAlpha = O, he.context(e), ye.forEach(function (i) {
          e.fillStyle = i.color, e.beginPath(), he(i.data.map(function (e) {
            return e.position;
          })), e.fill();
        }), e.restore()), "lines" === i && (pe.context(e), ye.forEach(function (i) {
          e.strokeStyle = i.color, e.lineWidth = v, e.beginPath(), pe(i.data.map(function (e) {
            return e.position;
          })), e.stroke();
        })), "points" === i && !0 === M && C > 0 && ve.forEach(function (i) {
          e.fillStyle = i.color, e.beginPath(), e.arc(i.x, i.y, C / 2, 0, 2 * Math.PI), e.fill(), k > 0 && (e.strokeStyle = i.borderColor, e.lineWidth = k, e.stroke());
        }), "mesh" === i && !0 === I && (P$1(e, qe), de && j(e, qe, de.index)), "legends" === i) {
          var r = ye.map(function (e) {
            return {
              id: e.id,
              label: e.id,
              color: e.color
            };
          }).reverse();
          A.forEach(function (i) {
            H$2(e, re({}, i, {
              data: i.data || r,
              containerWidth: oe,
              containerHeight: te,
              theme: le
            }));
          });
        }
      });
    }, [Z, ae, se, g, le, pe, ye, ge, me, L, W, G, j$2, F, Y, D, X, A, ve, M, C, de]);
    var Oe = useCallback(function (e) {
        var i = Fi(Z.current, e),
          r = i[0],
          n = i[1];
        if (!Ai(ne.left, ne.top, oe, te, r, n)) return null;
        var o = Re.find(r - ne.left, n - ne.top);
        return ve[o];
      }, [Z, ne, oe, te, Re]),
      Me = k$5(),
      Ce = Me.showTooltipFromEvent,
      Se = Me.hideTooltip,
      Te = useCallback(function (e) {
        var i = Oe(e);
        ce(i), i ? Ce( /*#__PURE__*/createElement(Q, {
          point: i
        }), e) : Se();
      }, [Oe, ce, Ce, Se, Q]),
      we = useCallback(function (e) {
        Se(), ce(null), de && J && J(de, e);
      }, [Se, ce, J]),
      ke = useCallback(function (e) {
        if (K) {
          var i = Oe(e);
          i && K(i, e);
        }
      }, [Oe, K]);
    return jsx("canvas", {
      ref: Z,
      width: ae * d,
      height: se * d,
      style: {
        width: ae,
        height: se,
        cursor: H ? "auto" : "normal"
      },
      onMouseEnter: H ? Te : void 0,
      onMouseMove: H ? Te : void 0,
      onMouseLeave: H ? we : void 0,
      onClick: H ? ke : void 0
    });
  };
Ee.propTypes = ue, Ee.defaultProps = fe;
Mi(Ee);

var LineRenderPoints = function LineRenderPoints(props) {
  var points = props.points,
    lineRender = props.lineRender,
    pointSize = props.pointSize,
    pointBorderWidth = props.pointBorderWidth;
  var shownPoints = points.filter(function (item) {
    if (item.serieId === lineRender) {
      return item;
    }
    return null;
  });
  return /*#__PURE__*/React__default.createElement("g", null, shownPoints.map(function (point) {
    return /*#__PURE__*/React__default.createElement(Wi, {
      key: point.id,
      x: point.x,
      y: point.y,
      size: pointSize,
      color: point.color,
      borderWidth: pointBorderWidth,
      borderColor: point.borderColor
    });
  }));
};
LineRenderPoints.propTypes = {
  /**
   * Indicates which line is to be rendered with the dots
   */
  lineRender: PropTypes.string.isRequired,
  /**
   * Indicates all points on the graph
   */
  points: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  /**
   * Indicates the size of the dots to be displayed
   */
  pointSize: PropTypes.number.isRequired,
  /**
   * indicates the size of the border of the dots to be shown
   */
  pointBorderWidth: PropTypes.number.isRequired
};

var _templateObject$q, _templateObject2$c, _templateObject3$a, _templateObject4$9, _templateObject5$7;
var LineChartWrapper = styled.div(_templateObject$q || (_templateObject$q = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  height: ", ";\n  margin: 0 auto;\n  width: 100%;\n  max-width: ", ";\n\n  @media ", " {\n    aspect-ratio: 16 / 9;\n    height: 100%;\n    max-height: ", ";\n  }\n  > div {\n    > div {\n      > svg {\n        > g {\n          > g:nth-child(2), g:nth-child(3) {\n            line {\n              display: none;\n            }\n          }\n\n          > g:nth-child(4) {\n            opacity: 0.55;\n          }\n\n          > path {\n            display: none;\n          }\n\n          > path:nth-of-type(", ") {\n            display: block;\n          }\n        }\n      }\n    }\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.spacing(29.5);
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.spacing(140);
}, device.mobile, function (_ref3) {
  var theme = _ref3.theme;
  return theme.spacing(57.5);
}, function (props) {
  return props.lineRenderPoint;
});
var LineChartLegend = styled.div(_templateObject2$c || (_templateObject2$c = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  margin: 0 auto;\n  width: 100%;\n  max-width: ", ";\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.spacing(62.5);
});
var LineChartLegendItem = styled.div(_templateObject3$a || (_templateObject3$a = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  margin-top: ", ";\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.spacing(2);
});
var LineChartLegendIcon = styled.span(_templateObject4$9 || (_templateObject4$9 = _taggedTemplateLiteral(["\n  background-color:  ", ";\n  border-radius: ", ";\n  display: block;\n  height: ", ";\n  margin-right: ", ";\n  width: ", ";\n"])), function (props) {
  return props.backgroundColor;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.borderRadius();
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.spacing(2);
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.spacing(1);
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.spacing(0.5);
});
var LineChartLegendText = styled.p(_templateObject5$7 || (_templateObject5$7 = _taggedTemplateLiteral(["\n  ", "\n\n  margin: 0;\n  color: ", ";\n"])), function (_ref10) {
  var theme = _ref10.theme;
  return theme.typography.font();
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.palette.grayI;
});

function ownKeys$5(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$5(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$5(Object(t), !0).forEach(function (r) { _defineProperty$1(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$5(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getWindowDimension = function getWindowDimension() {
  return window.innerWidth;
};
var LineChart = function LineChart(props) {
  var dataToRender = props.dataToRender,
    lineRender = props.lineRender;
  var _useState = useState(dataToRender || null),
    _useState2 = _slicedToArray(_useState, 2),
    lineChartData = _useState2[0],
    setLineChartData = _useState2[1];
  var _useState3 = useState(getWindowDimension()),
    _useState4 = _slicedToArray(_useState3, 2),
    windowDimensions = _useState4[0],
    setWindowDimensions = _useState4[1];
  var isSmallScreen = windowDimensions < 769;
  var dataRenderMobil = function dataRenderMobil(data) {
    return data.filter(function (dataToFilter, index) {
      if (index % 2 === 0) {
        return dataToFilter;
      }
      return null;
    });
  };
  var formatAmount = function formatAmount(value) {
    return new Intl.NumberFormat('en-US', {
      notation: 'compact'
    }).format(value);
  };
  var getLinePointRender = function getLinePointRender() {
    return dataToRender.length - dataToRender.findIndex(function (item) {
      return item.id === lineRender;
    });
  };
  useMemo(function () {
    var recalculateLineChartData = function recalculateLineChartData() {
      if (isSmallScreen) {
        var dataMobil = dataToRender.map(function (item) {
          var data = dataRenderMobil(item.data);
          return _objectSpread$5(_objectSpread$5({}, item), {}, {
            data: data
          });
        });
        setLineChartData(dataMobil);
        return;
      }
      setLineChartData(dataToRender);
    };
    recalculateLineChartData();
  }, [dataToRender, isSmallScreen]);
  useEffect(function () {
    var handleResize = function handleResize() {
      setWindowDimensions(getWindowDimension());
    };
    window.addEventListener('resize', handleResize);
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, []);
  return /*#__PURE__*/React__default.createElement(LineChartWrapper, {
    lineRenderPoint: getLinePointRender()
  }, /*#__PURE__*/React__default.createElement(Pe, {
    curve: "monotoneX",
    data: lineChartData,
    xScale: {
      type: 'point'
    },
    yScale: {
      type: 'linear',
      stacked: true
    },
    yFormat: function yFormat(values) {
      return formatAmount(values);
    },
    margin: {
      top: 15,
      right: 15,
      bottom: 40,
      left: 60
    },
    areaOpacity: 1,
    colorBy: "color",
    colors: {
      datum: 'color'
    },
    enableArea: true,
    enableGridX: false,
    enableSlices: "x",
    pointBorderColor: {
      from: 'serieColor'
    },
    pointColor: "#fff",
    pointSize: 10,
    gridYValues: 4,
    pointBorderWidth: 2,
    useMesh: true,
    axisLeft: {
      tickValues: 4,
      format: function format(values) {
        return formatAmount(values);
      },
      legend: 'Monto ($)',
      legendPosition: 'middle',
      legendOffset: -46
    },
    axisBottom: {
      legend: 'Años',
      legendOffset: 36,
      legendPosition: 'middle'
    },
    layers: ['grid', 'axes', 'areas', 'lines', 'crosshair', 'slices', 'mesh', 'legends', LineRenderPoints],
    lineRender: lineRender
  }), /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: Boolean(lineChartData)
  }, /*#__PURE__*/React__default.createElement(LineChartLegend, null, lineChartData.map(function (item) {
    return /*#__PURE__*/React__default.createElement(LineChartLegendItem, {
      key: item.id.toString()
    }, /*#__PURE__*/React__default.createElement(LineChartLegendIcon, {
      id: item.id,
      backgroundColor: item.color
    }), /*#__PURE__*/React__default.createElement(LineChartLegendText, null, item.id));
  }))));
};
LineChart.propTypes = {
  /**
   * To indicate if arrows of navitagion is displayed
   */
  dataToRender: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  /**
   * Indicates which line of the legend graphic is to be rendered with points
   */
  lineRender: PropTypes.string.isRequired
};

var _templateObject$p;
var StyledLink = styled.a(_templateObject$p || (_templateObject$p = _taggedTemplateLiteral(["\n  color: ", ";\n  cursor: pointer;\n  display: inline-block;\n  outline: none;\n  position: relative;\n  text-decoration: none;\n\n  &:hover, &:active, &:focus {\n    text-decoration: underline;\n  }\n\n  &:visited {\n    color: ", ";\n  }\n\n  &:active {\n    color: ", ";\n    text-decoration: underline;\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.alternative5.light;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.alternative5.dark;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.alternative5.main;
});

var Link$1 = function Link(props) {
  var children = props.children,
    _props$id = props.id,
    id = _props$id === void 0 ? '' : _props$id,
    href = props.href,
    downloadName = props.downloadName,
    className = props.className,
    target = props.target,
    rel = props.rel;
  return /*#__PURE__*/React__default.createElement(StyledLink, {
    id: id,
    href: href,
    download: downloadName,
    className: className,
    target: target,
    rel: rel
  }, children);
};
Link$1.propTypes = {
  /**
  * This is the content to be displayed inside Link
  */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
  /**
   * Id assigned to Link.
   */
  id: PropTypes.string,
  /**
   * Define where the link will redirect to
  */
  href: PropTypes.string.isRequired,
  /**
   * Defines the name under which the file will be downloaded
  */
  downloadName: PropTypes.string,
  /**
   * Class to apply on link container
   */
  className: PropTypes.string,
  /**
   * Target defines if you want to open in another tab
   */
  target: PropTypes.string,
  /**
   * Rel avoids attacks from pages we link to
   */
  rel: PropTypes.string
};
Link$1.defaultProps = {
  className: '',
  downloadName: null,
  id: '',
  rel: '',
  target: ''
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
  };
  return _extendStatics(d, b);
};
function __extends(d, b) {
  if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  _extendStatics(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return _assign.apply(this, arguments);
};
function __rest$1(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __awaiter$1(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var NODE_ENV = process.env.NODE_ENV;
var invariant$1 = function invariant(condition, format, a, b, c, d, e, f) {
  if (NODE_ENV !== 'production') {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }
  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }
    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};
var invariant_1 = invariant$1;
var invariant$1$1 = /*@__PURE__*/getDefaultExportFromCjs(invariant_1);
var MapContext = /*#__PURE__*/createContext(null);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function reduce(obj, fn, acc) {
  return Object.keys(obj).reduce(function reducer(newAcc, key) {
    return fn(newAcc, obj[key], key);
  }, acc);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function forEach(obj, fn) {
  Object.keys(obj).forEach(function (key) {
    return fn(obj[key], key);
  });
}

/* global google */
function applyUpdaterToNextProps(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
updaterMap,
// eslint-disable-next-line @typescript-eslint/no-explicit-any
prevProps,
// eslint-disable-next-line @typescript-eslint/no-explicit-any
nextProps,
// eslint-disable-next-line @typescript-eslint/no-explicit-any
instance
// eslint-disable-next-line @typescript-eslint/no-explicit-any
) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var map = {};
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var iter = function iter(fn, key) {
    var nextValue = nextProps[key];
    if (nextValue !== prevProps[key]) {
      map[key] = nextValue;
      fn(instance, nextValue);
    }
  };
  forEach(updaterMap, iter);
  return map;
}
function registerEvents(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
props,
// eslint-disable-next-line @typescript-eslint/no-explicit-any
instance, eventMap) {
  var registeredList = reduce(eventMap, function reducer(acc, googleEventName,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onEventName) {
    if (typeof props[onEventName] === 'function') {
      acc.push(google.maps.event.addListener(instance, googleEventName, props[onEventName]));
    }
    return acc;
  }, []);
  return registeredList;
}
function unregisterEvent(registered) {
  google.maps.event.removeListener(registered);
}
function unregisterEvents(events) {
  if (events === void 0) {
    events = [];
  }
  events.forEach(unregisterEvent);
}
function applyUpdatersToPropsAndRegisterEvents(_a) {
  var updaterMap = _a.updaterMap,
    eventMap = _a.eventMap,
    prevProps = _a.prevProps,
    nextProps = _a.nextProps,
    instance = _a.instance;
  var registeredEvents = registerEvents(nextProps, instance, eventMap);
  applyUpdaterToNextProps(updaterMap, prevProps, nextProps, instance);
  return registeredEvents;
}
var eventMap$i = {
  onDblClick: 'dblclick',
  onDragEnd: 'dragend',
  onDragStart: 'dragstart',
  onMapTypeIdChanged: 'maptypeid_changed',
  onMouseMove: 'mousemove',
  onMouseOut: 'mouseout',
  onMouseOver: 'mouseover',
  onMouseDown: 'mousedown',
  onMouseUp: 'mouseup',
  onRightClick: 'rightclick',
  onTilesLoaded: 'tilesloaded',
  onBoundsChanged: 'bounds_changed',
  onCenterChanged: 'center_changed',
  onClick: 'click',
  onDrag: 'drag',
  onHeadingChanged: 'heading_changed',
  onIdle: 'idle',
  onProjectionChanged: 'projection_changed',
  onResize: 'resize',
  onTiltChanged: 'tilt_changed',
  onZoomChanged: 'zoom_changed'
};
var updaterMap$i = {
  extraMapTypes: function extraMapTypes(map, extra) {
    extra.forEach(function forEachExtra(it, i) {
      map.mapTypes.set(String(i), it);
    });
  },
  center: function center(map, _center) {
    map.setCenter(_center);
  },
  clickableIcons: function clickableIcons(map, clickable) {
    map.setClickableIcons(clickable);
  },
  heading: function heading(map, _heading) {
    map.setHeading(_heading);
  },
  mapTypeId: function mapTypeId(map, _mapTypeId) {
    map.setMapTypeId(_mapTypeId);
  },
  options: function options(map, _options) {
    map.setOptions(_options);
  },
  streetView: function streetView(map, _streetView) {
    map.setStreetView(_streetView);
  },
  tilt: function tilt(map, _tilt) {
    map.setTilt(_tilt);
  },
  zoom: function zoom(map, _zoom) {
    map.setZoom(_zoom);
  }
};
var GoogleMap = /** @class */function (_super) {
  __extends(GoogleMap, _super);
  function GoogleMap() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      map: null
    };
    _this.registeredEvents = [];
    _this.mapRef = null;
    _this.getInstance = function () {
      if (_this.mapRef === null) {
        return null;
      }
      return new google.maps.Map(_this.mapRef, _this.props.options);
    };
    _this.panTo = function (latLng) {
      var map = _this.getInstance();
      if (map) {
        map.panTo(latLng);
      }
    };
    _this.setMapCallback = function () {
      if (_this.state.map !== null) {
        if (_this.props.onLoad) {
          _this.props.onLoad(_this.state.map);
        }
      }
    };
    _this.getRef = function (ref) {
      _this.mapRef = ref;
    };
    return _this;
  }
  GoogleMap.prototype.componentDidMount = function () {
    var map = this.getInstance();
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$i,
      eventMap: eventMap$i,
      prevProps: {},
      nextProps: this.props,
      instance: map
    });
    this.setState(function setMap() {
      return {
        map: map
      };
    }, this.setMapCallback);
  };
  GoogleMap.prototype.componentDidUpdate = function (prevProps) {
    if (this.state.map !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$i,
        eventMap: eventMap$i,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.map
      });
    }
  };
  GoogleMap.prototype.componentWillUnmount = function () {
    if (this.state.map !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.map);
      }
      unregisterEvents(this.registeredEvents);
    }
  };
  GoogleMap.prototype.render = function () {
    return jsx("div", {
      id: this.props.id,
      ref: this.getRef,
      style: this.props.mapContainerStyle,
      className: this.props.mapContainerClassName,
      children: jsx(MapContext.Provider, {
        value: this.state.map,
        children: this.state.map !== null ? this.props.children : null
      })
    });
  };
  return GoogleMap;
}(PureComponent);
var isBrowser$1 = typeof document !== 'undefined';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function injectScript(_a) {
  var url = _a.url,
    id = _a.id,
    nonce = _a.nonce;
  if (!isBrowser$1) {
    return Promise.reject(new Error('document is undefined'));
  }
  return new Promise(function injectScriptCallback(resolve, reject) {
    var existingScript = document.getElementById(id);
    var windowWithGoogleMap = window;
    if (existingScript) {
      // Same script id/url: keep same script
      var dataStateAttribute = existingScript.getAttribute('data-state');
      if (existingScript.src === url && dataStateAttribute !== 'error') {
        if (dataStateAttribute === 'ready') {
          return resolve(id);
        } else {
          var originalInitMap_1 = windowWithGoogleMap.initMap;
          var originalErrorCallback_1 = existingScript.onerror;
          windowWithGoogleMap.initMap = function initMap() {
            if (originalInitMap_1) {
              originalInitMap_1();
            }
            resolve(id);
          };
          existingScript.onerror = function (err) {
            if (originalErrorCallback_1) {
              originalErrorCallback_1(err);
            }
            reject(err);
          };
          return;
        }
      }
      // Same script id, but either
      // 1. requested URL is different
      // 2. script failed to load
      else {
        existingScript.remove();
      }
    }
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    script.id = id;
    script.async = true;
    script.nonce = nonce || '';
    script.onerror = function onerror(err) {
      script.setAttribute('data-state', 'error');
      reject(err);
    };
    windowWithGoogleMap.initMap = function onload() {
      script.setAttribute('data-state', 'ready');
      resolve(id);
    };
    document.head.appendChild(script);
  })["catch"](function (err) {
    console.error('injectScript error: ', err);
    throw err;
  });
}
function isGoogleFontStyle(element) {
  // 'Roboto' or 'Google Sans Text' font download
  var href = element.href;
  if (href && (href.indexOf('https://fonts.googleapis.com/css?family=Roboto') === 0 || href.indexOf('https://fonts.googleapis.com/css?family=Google+Sans+Text') === 0)) {
    return true;
  }
  // font style elements
  if (
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  element.tagName.toLowerCase() === 'style' &&
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  element.styleSheet &&
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  element.styleSheet.cssText &&
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  element.styleSheet.cssText.replace('\r\n', '').indexOf('.gm-style') === 0) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    element.styleSheet.cssText = '';
    return true;
  }
  // font style elements for other browsers
  if (
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  element.tagName.toLowerCase() === 'style' &&
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  element.innerHTML &&
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  element.innerHTML.replace('\r\n', '').indexOf('.gm-style') === 0) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    element.innerHTML = '';
    return true;
  }
  // when google tries to add empty style
  if (
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  element.tagName.toLowerCase() === 'style' &&
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  !element.styleSheet &&
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  !element.innerHTML) {
    return true;
  }
  return false;
}
// Preventing the Google Maps library from downloading an extra font
function preventGoogleFonts() {
  // we override these methods only for one particular head element
  // default methods for other elements are not affected
  var head = document.getElementsByTagName('head')[0];
  if (head) {
    var trueInsertBefore_1 = head.insertBefore.bind(head);
    // TODO: adding return before reflect solves the TS issue
    head.insertBefore = function insertBefore(newElement, referenceElement) {
      if (!isGoogleFontStyle(newElement)) {
        Reflect.apply(trueInsertBefore_1, head, [newElement, referenceElement]);
      }
      return newElement;
    };
    var trueAppend_1 = head.appendChild.bind(head);
    // TODO: adding return before reflect solves the TS issue
    head.appendChild = function appendChild(textNode) {
      if (!isGoogleFontStyle(textNode)) {
        Reflect.apply(trueAppend_1, head, [textNode]);
      }
      return textNode;
    };
  }
}
function makeLoadScriptUrl(_a) {
  var googleMapsApiKey = _a.googleMapsApiKey,
    googleMapsClientId = _a.googleMapsClientId,
    _b = _a.version,
    version = _b === void 0 ? 'weekly' : _b,
    language = _a.language,
    region = _a.region,
    libraries = _a.libraries,
    channel = _a.channel,
    mapIds = _a.mapIds,
    authReferrerPolicy = _a.authReferrerPolicy;
  var params = [];
  invariant$1$1(googleMapsApiKey && googleMapsClientId || !(googleMapsApiKey && googleMapsClientId), 'You need to specify either googleMapsApiKey or googleMapsClientId for @react-google-maps/api load script to work. You cannot use both at the same time.');
  if (googleMapsApiKey) {
    params.push("key=".concat(googleMapsApiKey));
  } else if (googleMapsClientId) {
    params.push("client=".concat(googleMapsClientId));
  }
  if (version) {
    params.push("v=".concat(version));
  }
  if (language) {
    params.push("language=".concat(language));
  }
  if (region) {
    params.push("region=".concat(region));
  }
  if (libraries && libraries.length) {
    params.push("libraries=".concat(libraries.sort().join(',')));
  }
  if (channel) {
    params.push("channel=".concat(channel));
  }
  if (mapIds && mapIds.length) {
    params.push("map_ids=".concat(mapIds.join(',')));
  }
  if (authReferrerPolicy) {
    params.push("auth_referrer_policy=".concat(authReferrerPolicy));
  }
  params.push('callback=initMap');
  return "https://maps.googleapis.com/maps/api/js?".concat(params.join('&'));
}
var cleaningUp = false;
function DefaultLoadingElement() {
  return jsx("div", {
    children: "Loading..."
  });
}
var defaultLoadScriptProps = {
  id: 'script-loader',
  version: 'weekly'
};
var LoadScript = /** @class */function (_super) {
  __extends(LoadScript, _super);
  function LoadScript() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.check = /*#__PURE__*/createRef();
    _this.state = {
      loaded: false
    };
    _this.cleanupCallback = function () {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      delete window.google.maps;
      _this.injectScript();
    };
    _this.isCleaningUp = function () {
      return __awaiter$1(_this, void 0, void 0, function () {
        function promiseCallback(resolve) {
          if (!cleaningUp) {
            resolve();
          } else {
            if (isBrowser$1) {
              var timer_1 = window.setInterval(function interval() {
                if (!cleaningUp) {
                  window.clearInterval(timer_1);
                  resolve();
                }
              }, 1);
            }
          }
          return;
        }
        return __generator(this, function (_a) {
          return [2 /*return*/, new Promise(promiseCallback)];
        });
      });
    };
    _this.cleanup = function () {
      cleaningUp = true;
      var script = document.getElementById(_this.props.id);
      if (script && script.parentNode) {
        script.parentNode.removeChild(script);
      }
      Array.prototype.slice.call(document.getElementsByTagName('script')).filter(function filter(script) {
        return typeof script.src === 'string' && script.src.includes('maps.googleapis');
      }).forEach(function forEach(script) {
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      });
      Array.prototype.slice.call(document.getElementsByTagName('link')).filter(function filter(link) {
        return link.href === 'https://fonts.googleapis.com/css?family=Roboto:300,400,500,700|Google+Sans';
      }).forEach(function forEach(link) {
        if (link.parentNode) {
          link.parentNode.removeChild(link);
        }
      });
      Array.prototype.slice.call(document.getElementsByTagName('style')).filter(function filter(style) {
        return style.innerText !== undefined && style.innerText.length > 0 && style.innerText.includes('.gm-');
      }).forEach(function forEach(style) {
        if (style.parentNode) {
          style.parentNode.removeChild(style);
        }
      });
    };
    _this.injectScript = function () {
      if (_this.props.preventGoogleFontsLoading) {
        preventGoogleFonts();
      }
      invariant$1$1(!!_this.props.id, 'LoadScript requires "id" prop to be a string: %s', _this.props.id);
      var injectScriptOptions = {
        id: _this.props.id,
        nonce: _this.props.nonce,
        url: makeLoadScriptUrl(_this.props)
      };
      injectScript(injectScriptOptions).then(function () {
        if (_this.props.onLoad) {
          _this.props.onLoad();
        }
        _this.setState(function setLoaded() {
          return {
            loaded: true
          };
        });
        return;
      })["catch"](function (err) {
        if (_this.props.onError) {
          _this.props.onError(err);
        }
        console.error("\n          There has been an Error with loading Google Maps API script, please check that you provided correct google API key (".concat(_this.props.googleMapsApiKey || '-', ") or Client ID (").concat(_this.props.googleMapsClientId || '-', ") to <LoadScript />\n          Otherwise it is a Network issue.\n        "));
      });
    };
    return _this;
  }
  LoadScript.prototype.componentDidMount = function () {
    if (isBrowser$1) {
      if (window.google && window.google.maps && !cleaningUp) {
        console.error('google api is already presented');
        return;
      }
      this.isCleaningUp().then(this.injectScript)["catch"](function error(err) {
        console.error('Error at injecting script after cleaning up: ', err);
      });
    }
  };
  LoadScript.prototype.componentDidUpdate = function (prevProps) {
    if (this.props.libraries !== prevProps.libraries) {
      console.warn('Performance warning! LoadScript has been reloaded unintentionally! You should not pass `libraries` prop as new array. Please keep an array of libraries as static class property for Components and PureComponents, or just a const variable outside of component, or somewhere in config files or ENV variables');
    }
    if (isBrowser$1 && prevProps.language !== this.props.language) {
      this.cleanup();
      // TODO: refactor to use gDSFP maybe... wait for hooks refactoring.
      this.setState(function setLoaded() {
        return {
          loaded: false
        };
      }, this.cleanupCallback);
    }
  };
  LoadScript.prototype.componentWillUnmount = function () {
    var _this = this;
    if (isBrowser$1) {
      this.cleanup();
      var timeoutCallback = function timeoutCallback() {
        if (!_this.check.current) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          delete window.google;
          cleaningUp = false;
        }
      };
      window.setTimeout(timeoutCallback, 1);
      if (this.props.onUnmount) {
        this.props.onUnmount();
      }
    }
  };
  LoadScript.prototype.render = function () {
    return jsxs(Fragment$1, {
      children: [jsx("div", {
        ref: this.check
      }), this.state.loaded ? this.props.children : this.props.loadingElement || jsx(DefaultLoadingElement, {})]
    });
  };
  LoadScript.defaultProps = defaultLoadScriptProps;
  return LoadScript;
}(PureComponent);
jsx(DefaultLoadingElement, {});
/**
 * The status of the [[Loader]].
 */
var LoaderStatus;
(function (LoaderStatus) {
  LoaderStatus[LoaderStatus["INITIALIZED"] = 0] = "INITIALIZED";
  LoaderStatus[LoaderStatus["LOADING"] = 1] = "LOADING";
  LoaderStatus[LoaderStatus["SUCCESS"] = 2] = "SUCCESS";
  LoaderStatus[LoaderStatus["FAILURE"] = 3] = "FAILURE";
})(LoaderStatus || (LoaderStatus = {}));
var eventMap$h = {};
var updaterMap$h = {
  options: function options(instance, _options2) {
    instance.setOptions(_options2);
  }
};
/** @class */(function (_super) {
  __extends(TrafficLayer, _super);
  function TrafficLayer() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      trafficLayer: null
    };
    _this.setTrafficLayerCallback = function () {
      if (_this.state.trafficLayer !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.trafficLayer);
      }
    };
    _this.registeredEvents = [];
    return _this;
  }
  TrafficLayer.prototype.componentDidMount = function () {
    var trafficLayer = new google.maps.TrafficLayer(_assign(_assign({}, this.props.options || {}), {
      map: this.context
    }));
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$h,
      eventMap: eventMap$h,
      prevProps: {},
      nextProps: this.props,
      instance: trafficLayer
    });
    this.setState(function setTrafficLayer() {
      return {
        trafficLayer: trafficLayer
      };
    }, this.setTrafficLayerCallback);
  };
  TrafficLayer.prototype.componentDidUpdate = function (prevProps) {
    if (this.state.trafficLayer !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$h,
        eventMap: eventMap$h,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.trafficLayer
      });
    }
  };
  TrafficLayer.prototype.componentWillUnmount = function () {
    if (this.state.trafficLayer !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.trafficLayer);
      }
      unregisterEvents(this.registeredEvents);
      this.state.trafficLayer.setMap(null);
    }
  };
  TrafficLayer.prototype.render = function () {
    return null;
  };
  TrafficLayer.contextType = MapContext;
  return TrafficLayer;
})(PureComponent);
/** @class */(function (_super) {
  __extends(BicyclingLayer, _super);
  function BicyclingLayer() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      bicyclingLayer: null
    };
    _this.setBicyclingLayerCallback = function () {
      if (_this.state.bicyclingLayer !== null) {
        _this.state.bicyclingLayer.setMap(_this.context);
        if (_this.props.onLoad) {
          _this.props.onLoad(_this.state.bicyclingLayer);
        }
      }
    };
    return _this;
  }
  BicyclingLayer.prototype.componentDidMount = function () {
    var bicyclingLayer = new google.maps.BicyclingLayer();
    this.setState(function () {
      return {
        bicyclingLayer: bicyclingLayer
      };
    }, this.setBicyclingLayerCallback);
  };
  BicyclingLayer.prototype.componentWillUnmount = function () {
    if (this.state.bicyclingLayer !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.bicyclingLayer);
      }
      this.state.bicyclingLayer.setMap(null);
    }
  };
  BicyclingLayer.prototype.render = function () {
    return null;
  };
  BicyclingLayer.contextType = MapContext;
  return BicyclingLayer;
})(PureComponent);
/** @class */(function (_super) {
  __extends(TransitLayer, _super);
  function TransitLayer() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      transitLayer: null
    };
    _this.setTransitLayerCallback = function () {
      if (_this.state.transitLayer !== null) {
        _this.state.transitLayer.setMap(_this.context);
        if (_this.props.onLoad) {
          _this.props.onLoad(_this.state.transitLayer);
        }
      }
    };
    return _this;
  }
  TransitLayer.prototype.componentDidMount = function () {
    var transitLayer = new google.maps.TransitLayer();
    this.setState(function setTransitLayer() {
      return {
        transitLayer: transitLayer
      };
    }, this.setTransitLayerCallback);
  };
  TransitLayer.prototype.componentWillUnmount = function () {
    if (this.state.transitLayer !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.transitLayer);
      }
      this.state.transitLayer.setMap(null);
    }
  };
  TransitLayer.prototype.render = function () {
    return null;
  };
  TransitLayer.contextType = MapContext;
  return TransitLayer;
})(PureComponent);
var eventMap$g = {
  onCircleComplete: 'circlecomplete',
  onMarkerComplete: 'markercomplete',
  onOverlayComplete: 'overlaycomplete',
  onPolygonComplete: 'polygoncomplete',
  onPolylineComplete: 'polylinecomplete',
  onRectangleComplete: 'rectanglecomplete'
};
var updaterMap$g = {
  drawingMode: function drawingMode(instance, _drawingMode) {
    instance.setDrawingMode(_drawingMode);
  },
  options: function options(instance, _options3) {
    instance.setOptions(_options3);
  }
};
/** @class */(function (_super) {
  __extends(DrawingManager, _super);
  function DrawingManager(props) {
    var _this = _super.call(this, props) || this;
    _this.registeredEvents = [];
    _this.state = {
      drawingManager: null
    };
    _this.setDrawingManagerCallback = function () {
      if (_this.state.drawingManager !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.drawingManager);
      }
    };
    invariant$1$1(!!google.maps.drawing, "Did you include prop libraries={['drawing']} in the URL? %s", google.maps.drawing);
    return _this;
  }
  DrawingManager.prototype.componentDidMount = function () {
    var drawingManager = new google.maps.drawing.DrawingManager(_assign(_assign({}, this.props.options || {}), {
      map: this.context
    }));
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$g,
      eventMap: eventMap$g,
      prevProps: {},
      nextProps: this.props,
      instance: drawingManager
    });
    this.setState(function setDrawingManager() {
      return {
        drawingManager: drawingManager
      };
    }, this.setDrawingManagerCallback);
  };
  DrawingManager.prototype.componentDidUpdate = function (prevProps) {
    if (this.state.drawingManager !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$g,
        eventMap: eventMap$g,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.drawingManager
      });
    }
  };
  DrawingManager.prototype.componentWillUnmount = function () {
    if (this.state.drawingManager !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.drawingManager);
      }
      unregisterEvents(this.registeredEvents);
      this.state.drawingManager.setMap(null);
    }
  };
  DrawingManager.prototype.render = function () {
    return null;
  };
  DrawingManager.contextType = MapContext;
  return DrawingManager;
})(PureComponent);
var eventMap$f = {
  onAnimationChanged: 'animation_changed',
  onClick: 'click',
  onClickableChanged: 'clickable_changed',
  onCursorChanged: 'cursor_changed',
  onDblClick: 'dblclick',
  onDrag: 'drag',
  onDragEnd: 'dragend',
  onDraggableChanged: 'draggable_changed',
  onDragStart: 'dragstart',
  onFlatChanged: 'flat_changed',
  onIconChanged: 'icon_changed',
  onMouseDown: 'mousedown',
  onMouseOut: 'mouseout',
  onMouseOver: 'mouseover',
  onMouseUp: 'mouseup',
  onPositionChanged: 'position_changed',
  onRightClick: 'rightclick',
  onShapeChanged: 'shape_changed',
  onTitleChanged: 'title_changed',
  onVisibleChanged: 'visible_changed',
  onZindexChanged: 'zindex_changed'
};
var updaterMap$f = {
  animation: function animation(instance, _animation) {
    instance.setAnimation(_animation);
  },
  clickable: function clickable(instance, _clickable) {
    instance.setClickable(_clickable);
  },
  cursor: function cursor(instance, _cursor) {
    instance.setCursor(_cursor);
  },
  draggable: function draggable(instance, _draggable) {
    instance.setDraggable(_draggable);
  },
  icon: function icon(instance, _icon) {
    instance.setIcon(_icon);
  },
  label: function label(instance, _label) {
    instance.setLabel(_label);
  },
  map: function map(instance, _map) {
    instance.setMap(_map);
  },
  opacity: function opacity(instance, _opacity) {
    instance.setOpacity(_opacity);
  },
  options: function options(instance, _options4) {
    instance.setOptions(_options4);
  },
  position: function position(instance, _position) {
    instance.setPosition(_position);
  },
  shape: function shape(instance, _shape) {
    instance.setShape(_shape);
  },
  title: function title(instance, _title) {
    instance.setTitle(_title);
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible);
  },
  zIndex: function zIndex(instance, _zIndex) {
    instance.setZIndex(_zIndex);
  }
};
var defaultOptions$5 = {};
var Marker = /** @class */function (_super) {
  __extends(Marker, _super);
  function Marker() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.registeredEvents = [];
    return _this;
  }
  Marker.prototype.componentDidMount = function () {
    var markerOptions = _assign(_assign(_assign({}, this.props.options || defaultOptions$5), this.props.clusterer ? defaultOptions$5 : {
      map: this.context
    }), {
      position: this.props.position
    });
    // Unfortunately we can't just do this in the contstructor, because the
    // `MapContext` might not be filled in yet.
    this.marker = new google.maps.Marker(markerOptions);
    if (this.props.clusterer) {
      this.props.clusterer.addMarker(this.marker, !!this.props.noClustererRedraw);
    } else {
      this.marker.setMap(this.context);
    }
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$f,
      eventMap: eventMap$f,
      prevProps: {},
      nextProps: this.props,
      instance: this.marker
    });
    if (this.props.onLoad) {
      this.props.onLoad(this.marker);
    }
  };
  Marker.prototype.componentDidUpdate = function (prevProps) {
    if (this.marker) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$f,
        eventMap: eventMap$f,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.marker
      });
    }
  };
  Marker.prototype.componentWillUnmount = function () {
    if (this.marker) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.marker);
      }
      unregisterEvents(this.registeredEvents);
      if (this.props.clusterer) {
        this.props.clusterer.removeMarker(this.marker, !!this.props.noClustererRedraw);
      } else {
        this.marker && this.marker.setMap(null);
      }
    }
  };
  Marker.prototype.render = function () {
    var _this = this;
    var children = null;
    if (this.props.children) {
      children = Children.map(this.props.children, function (child) {
        if (! /*#__PURE__*/isValidElement(child)) {
          return child;
        }
        var elementChild = child;
        return /*#__PURE__*/cloneElement(elementChild, {
          anchor: _this.marker
        });
      });
    }
    return children || null;
  };
  Marker.contextType = MapContext;
  return Marker;
}(PureComponent);
var ClusterIcon = /** @class */function () {
  function ClusterIcon(cluster, styles) {
    cluster.getClusterer().extend(ClusterIcon, google.maps.OverlayView);
    this.cluster = cluster;
    this.clusterClassName = this.cluster.getClusterer().getClusterClass();
    this.className = this.clusterClassName;
    this.styles = styles;
    this.center = undefined;
    this.div = null;
    this.sums = null;
    this.visible = false;
    this.boundsChangedListener = null;
    this.url = '';
    this.height = 0;
    this.width = 0;
    this.anchorText = [0, 0];
    this.anchorIcon = [0, 0];
    this.textColor = 'black';
    this.textSize = 11;
    this.textDecoration = 'none';
    this.fontWeight = 'bold';
    this.fontStyle = 'normal';
    this.fontFamily = 'Arial,sans-serif';
    this.backgroundPosition = '0 0';
    this.cMouseDownInCluster = null;
    this.cDraggingMapByCluster = null;
    this.timeOut = null;
    this.setMap(cluster.getMap()); // Note: this causes onAdd to be called
    this.onBoundsChanged = this.onBoundsChanged.bind(this);
    this.onMouseDown = this.onMouseDown.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onMouseOver = this.onMouseOver.bind(this);
    this.onMouseOut = this.onMouseOut.bind(this);
    this.onAdd = this.onAdd.bind(this);
    this.onRemove = this.onRemove.bind(this);
    this.draw = this.draw.bind(this);
    this.hide = this.hide.bind(this);
    this.show = this.show.bind(this);
    this.useStyle = this.useStyle.bind(this);
    this.setCenter = this.setCenter.bind(this);
    this.getPosFromLatLng = this.getPosFromLatLng.bind(this);
  }
  ClusterIcon.prototype.onBoundsChanged = function () {
    this.cDraggingMapByCluster = this.cMouseDownInCluster;
  };
  ClusterIcon.prototype.onMouseDown = function () {
    this.cMouseDownInCluster = true;
    this.cDraggingMapByCluster = false;
  };
  ClusterIcon.prototype.onClick = function (event) {
    this.cMouseDownInCluster = false;
    if (!this.cDraggingMapByCluster) {
      var markerClusterer_1 = this.cluster.getClusterer();
      /**
       * This event is fired when a cluster marker is clicked.
       * @name MarkerClusterer#click
       * @param {Cluster} c The cluster that was clicked.
       * @event
       */
      google.maps.event.trigger(markerClusterer_1, 'click', this.cluster);
      google.maps.event.trigger(markerClusterer_1, 'clusterclick', this.cluster); // deprecated name
      // The default click handler follows. Disable it by setting
      // the zoomOnClick property to false.
      if (markerClusterer_1.getZoomOnClick()) {
        // Zoom into the cluster.
        var maxZoom_1 = markerClusterer_1.getMaxZoom();
        var bounds_1 = this.cluster.getBounds();
        var map = markerClusterer_1.getMap();
        if (map !== null && 'fitBounds' in map) {
          map.fitBounds(bounds_1);
        }
        // There is a fix for Issue 170 here:
        this.timeOut = window.setTimeout(function () {
          var map = markerClusterer_1.getMap();
          if (map !== null) {
            if ('fitBounds' in map) {
              map.fitBounds(bounds_1);
            }
            var zoom = map.getZoom() || 0;
            // Don't zoom beyond the max zoom level
            if (maxZoom_1 !== null && zoom > maxZoom_1) {
              map.setZoom(maxZoom_1 + 1);
            }
          }
        }, 100);
      }
      // Prevent event propagation to the map:
      event.cancelBubble = true;
      if (event.stopPropagation) {
        event.stopPropagation();
      }
    }
  };
  ClusterIcon.prototype.onMouseOver = function () {
    /**
     * This event is fired when the mouse moves over a cluster marker.
     * @name MarkerClusterer#mouseover
     * @param {Cluster} c The cluster that the mouse moved over.
     * @event
     */
    google.maps.event.trigger(this.cluster.getClusterer(), 'mouseover', this.cluster);
  };
  ClusterIcon.prototype.onMouseOut = function () {
    /**
     * This event is fired when the mouse moves out of a cluster marker.
     * @name MarkerClusterer#mouseout
     * @param {Cluster} c The cluster that the mouse moved out of.
     * @event
     */
    google.maps.event.trigger(this.cluster.getClusterer(), 'mouseout', this.cluster);
  };
  ClusterIcon.prototype.onAdd = function () {
    var _a;
    this.div = document.createElement('div');
    this.div.className = this.className;
    if (this.visible) {
      this.show();
    }
    (_a = this.getPanes()) === null || _a === void 0 ? void 0 : _a.overlayMouseTarget.appendChild(this.div);
    var map = this.getMap();
    if (map !== null) {
      // Fix for Issue 157
      this.boundsChangedListener = google.maps.event.addListener(map, 'bounds_changed', this.onBoundsChanged);
      this.div.addEventListener('mousedown', this.onMouseDown);
      this.div.addEventListener('click', this.onClick);
      this.div.addEventListener('mouseover', this.onMouseOver);
      this.div.addEventListener('mouseout', this.onMouseOut);
    }
  };
  ClusterIcon.prototype.onRemove = function () {
    if (this.div && this.div.parentNode) {
      this.hide();
      if (this.boundsChangedListener !== null) {
        google.maps.event.removeListener(this.boundsChangedListener);
      }
      this.div.removeEventListener('mousedown', this.onMouseDown);
      this.div.removeEventListener('click', this.onClick);
      this.div.removeEventListener('mouseover', this.onMouseOver);
      this.div.removeEventListener('mouseout', this.onMouseOut);
      this.div.parentNode.removeChild(this.div);
      if (this.timeOut !== null) {
        window.clearTimeout(this.timeOut);
        this.timeOut = null;
      }
      this.div = null;
    }
  };
  ClusterIcon.prototype.draw = function () {
    if (this.visible && this.div !== null && this.center) {
      var pos = this.getPosFromLatLng(this.center);
      this.div.style.top = pos !== null ? "".concat(pos.y, "px") : '0';
      this.div.style.left = pos !== null ? "".concat(pos.x, "px") : '0';
    }
  };
  ClusterIcon.prototype.hide = function () {
    if (this.div) {
      this.div.style.display = 'none';
    }
    this.visible = false;
  };
  ClusterIcon.prototype.show = function () {
    var _a, _b, _c, _d, _e, _f;
    if (this.div && this.center) {
      var divTitle = this.sums === null || typeof this.sums.title === 'undefined' || this.sums.title === '' ? this.cluster.getClusterer().getTitle() : this.sums.title;
      // NOTE: values must be specified in px units
      var bp = this.backgroundPosition.split(' ');
      var spriteH = parseInt(((_a = bp[0]) === null || _a === void 0 ? void 0 : _a.replace(/^\s+|\s+$/g, '')) || '0', 10);
      var spriteV = parseInt(((_b = bp[1]) === null || _b === void 0 ? void 0 : _b.replace(/^\s+|\s+$/g, '')) || '0', 10);
      var pos = this.getPosFromLatLng(this.center);
      this.div.className = this.className;
      this.div.setAttribute('style', "cursor: pointer; position: absolute; top: ".concat(pos !== null ? "".concat(pos.y, "px") : '0', "; left: ").concat(pos !== null ? "".concat(pos.x, "px") : '0', "; width: ").concat(this.width, "px; height: ").concat(this.height, "px; "));
      var img = document.createElement('img');
      img.alt = divTitle;
      img.src = this.url;
      img.width = this.width;
      img.height = this.height;
      img.setAttribute('style', "position: absolute; top: ".concat(spriteV, "px; left: ").concat(spriteH, "px"));
      if (!this.cluster.getClusterer().enableRetinaIcons) {
        img.style.clip = "rect(-".concat(spriteV, "px, -").concat(spriteH + this.width, "px, -").concat(spriteV + this.height, ", -").concat(spriteH, ")");
      }
      var textElm = document.createElement('div');
      textElm.setAttribute('style', "position: absolute; top: ".concat(this.anchorText[0], "px; left: ").concat(this.anchorText[1], "px; color: ").concat(this.textColor, "; font-size: ").concat(this.textSize, "px; font-family: ").concat(this.fontFamily, "; font-weight: ").concat(this.fontWeight, "; fontStyle: ").concat(this.fontStyle, "; text-decoration: ").concat(this.textDecoration, "; text-align: center; width: ").concat(this.width, "px; line-height: ").concat(this.height, "px"));
      if ((_c = this.sums) === null || _c === void 0 ? void 0 : _c.text) textElm.innerText = "".concat((_d = this.sums) === null || _d === void 0 ? void 0 : _d.text);
      if ((_e = this.sums) === null || _e === void 0 ? void 0 : _e.html) textElm.innerHTML = "".concat((_f = this.sums) === null || _f === void 0 ? void 0 : _f.html);
      this.div.innerHTML = '';
      this.div.appendChild(img);
      this.div.appendChild(textElm);
      this.div.title = divTitle;
      this.div.style.display = '';
    }
    this.visible = true;
  };
  ClusterIcon.prototype.useStyle = function (sums) {
    this.sums = sums;
    var styles = this.cluster.getClusterer().getStyles();
    var style = styles[Math.min(styles.length - 1, Math.max(0, sums.index - 1))];
    if (style) {
      this.url = style.url;
      this.height = style.height;
      this.width = style.width;
      if (style.className) {
        this.className = "".concat(this.clusterClassName, " ").concat(style.className);
      }
      this.anchorText = style.anchorText || [0, 0];
      this.anchorIcon = style.anchorIcon || [this.height / 2, this.width / 2];
      this.textColor = style.textColor || 'black';
      this.textSize = style.textSize || 11;
      this.textDecoration = style.textDecoration || 'none';
      this.fontWeight = style.fontWeight || 'bold';
      this.fontStyle = style.fontStyle || 'normal';
      this.fontFamily = style.fontFamily || 'Arial,sans-serif';
      this.backgroundPosition = style.backgroundPosition || '0 0';
    }
  };
  ClusterIcon.prototype.setCenter = function (center) {
    this.center = center;
  };
  ClusterIcon.prototype.getPosFromLatLng = function (latlng) {
    var pos = this.getProjection().fromLatLngToDivPixel(latlng);
    if (pos !== null) {
      pos.x -= this.anchorIcon[1];
      pos.y -= this.anchorIcon[0];
    }
    return pos;
  };
  return ClusterIcon;
}();

/* global google */
var Cluster$1 = /** @class */function () {
  function Cluster(markerClusterer) {
    this.markerClusterer = markerClusterer;
    this.map = this.markerClusterer.getMap();
    this.gridSize = this.markerClusterer.getGridSize();
    this.minClusterSize = this.markerClusterer.getMinimumClusterSize();
    this.averageCenter = this.markerClusterer.getAverageCenter();
    this.markers = [];
    this.center = undefined;
    this.bounds = null;
    this.clusterIcon = new ClusterIcon(this, this.markerClusterer.getStyles());
    this.getSize = this.getSize.bind(this);
    this.getMarkers = this.getMarkers.bind(this);
    this.getCenter = this.getCenter.bind(this);
    this.getMap = this.getMap.bind(this);
    this.getClusterer = this.getClusterer.bind(this);
    this.getBounds = this.getBounds.bind(this);
    this.remove = this.remove.bind(this);
    this.addMarker = this.addMarker.bind(this);
    this.isMarkerInClusterBounds = this.isMarkerInClusterBounds.bind(this);
    this.calculateBounds = this.calculateBounds.bind(this);
    this.updateIcon = this.updateIcon.bind(this);
    this.isMarkerAlreadyAdded = this.isMarkerAlreadyAdded.bind(this);
  }
  Cluster.prototype.getSize = function () {
    return this.markers.length;
  };
  Cluster.prototype.getMarkers = function () {
    return this.markers;
  };
  Cluster.prototype.getCenter = function () {
    return this.center;
  };
  Cluster.prototype.getMap = function () {
    return this.map;
  };
  Cluster.prototype.getClusterer = function () {
    return this.markerClusterer;
  };
  Cluster.prototype.getBounds = function () {
    var bounds = new google.maps.LatLngBounds(this.center, this.center);
    var markers = this.getMarkers();
    for (var _i = 0, markers_1 = markers; _i < markers_1.length; _i++) {
      var marker = markers_1[_i];
      var position = marker.getPosition();
      if (position) {
        bounds.extend(position);
      }
    }
    return bounds;
  };
  Cluster.prototype.remove = function () {
    this.clusterIcon.setMap(null);
    this.markers = [];
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    delete this.markers;
  };
  Cluster.prototype.addMarker = function (marker) {
    var _a;
    if (this.isMarkerAlreadyAdded(marker)) {
      return false;
    }
    if (!this.center) {
      var position = marker.getPosition();
      if (position) {
        this.center = position;
        this.calculateBounds();
      }
    } else {
      if (this.averageCenter) {
        var position = marker.getPosition();
        if (position) {
          var length_1 = this.markers.length + 1;
          this.center = new google.maps.LatLng((this.center.lat() * (length_1 - 1) + position.lat()) / length_1, (this.center.lng() * (length_1 - 1) + position.lng()) / length_1);
          this.calculateBounds();
        }
      }
    }
    marker.isAdded = true;
    this.markers.push(marker);
    var mCount = this.markers.length;
    var maxZoom = this.markerClusterer.getMaxZoom();
    var zoom = (_a = this.map) === null || _a === void 0 ? void 0 : _a.getZoom();
    if (maxZoom !== null && typeof zoom !== 'undefined' && zoom > maxZoom) {
      // Zoomed in past max zoom, so show the marker.
      if (marker.getMap() !== this.map) {
        marker.setMap(this.map);
      }
    } else if (mCount < this.minClusterSize) {
      // Min cluster size not reached so show the marker.
      if (marker.getMap() !== this.map) {
        marker.setMap(this.map);
      }
    } else if (mCount === this.minClusterSize) {
      // Hide the markers that were showing.
      for (var _i = 0, _b = this.markers; _i < _b.length; _i++) {
        var markerElement = _b[_i];
        markerElement.setMap(null);
      }
    } else {
      marker.setMap(null);
    }
    return true;
  };
  Cluster.prototype.isMarkerInClusterBounds = function (marker) {
    if (this.bounds !== null) {
      var position = marker.getPosition();
      if (position) {
        return this.bounds.contains(position);
      }
    }
    return false;
  };
  Cluster.prototype.calculateBounds = function () {
    this.bounds = this.markerClusterer.getExtendedBounds(new google.maps.LatLngBounds(this.center, this.center));
  };
  Cluster.prototype.updateIcon = function () {
    var _a;
    var mCount = this.markers.length;
    var maxZoom = this.markerClusterer.getMaxZoom();
    var zoom = (_a = this.map) === null || _a === void 0 ? void 0 : _a.getZoom();
    if (maxZoom !== null && typeof zoom !== 'undefined' && zoom > maxZoom) {
      this.clusterIcon.hide();
      return;
    }
    if (mCount < this.minClusterSize) {
      // Min cluster size not yet reached.
      this.clusterIcon.hide();
      return;
    }
    if (this.center) {
      this.clusterIcon.setCenter(this.center);
    }
    this.clusterIcon.useStyle(this.markerClusterer.getCalculator()(this.markers, this.markerClusterer.getStyles().length));
    this.clusterIcon.show();
  };
  Cluster.prototype.isMarkerAlreadyAdded = function (marker) {
    if (this.markers.includes) {
      return this.markers.includes(marker);
    }
    for (var i = 0; i < this.markers.length; i++) {
      if (marker === this.markers[i]) {
        return true;
      }
    }
    return false;
  };
  return Cluster;
}();

/* global google */
/**
 * Supports up to 9007199254740991 (Number.MAX_SAFE_INTEGER) markers
 * which is not a problem as max array length is 4294967296 (2**32)
 */
function CALCULATOR(markers, numStyles) {
  var count = markers.length;
  var numberOfDigits = count.toString().length;
  var index = Math.min(numberOfDigits, numStyles);
  return {
    text: count.toString(),
    index: index,
    title: ''
  };
}
var BATCH_SIZE = 2000;
var BATCH_SIZE_IE = 500;
var IMAGE_PATH = 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m';
var IMAGE_EXTENSION = 'png';
var IMAGE_SIZES = [53, 56, 66, 78, 90];
var CLUSTERER_CLASS = 'cluster';
var Clusterer = /** @class */function () {
  function Clusterer(map, optMarkers, optOptions) {
    if (optMarkers === void 0) {
      optMarkers = [];
    }
    if (optOptions === void 0) {
      optOptions = {};
    }
    this.getMinimumClusterSize = this.getMinimumClusterSize.bind(this);
    this.setMinimumClusterSize = this.setMinimumClusterSize.bind(this);
    this.getEnableRetinaIcons = this.getEnableRetinaIcons.bind(this);
    this.setEnableRetinaIcons = this.setEnableRetinaIcons.bind(this);
    this.addToClosestCluster = this.addToClosestCluster.bind(this);
    this.getImageExtension = this.getImageExtension.bind(this);
    this.setImageExtension = this.setImageExtension.bind(this);
    this.getExtendedBounds = this.getExtendedBounds.bind(this);
    this.getAverageCenter = this.getAverageCenter.bind(this);
    this.setAverageCenter = this.setAverageCenter.bind(this);
    this.getTotalClusters = this.getTotalClusters.bind(this);
    this.fitMapToMarkers = this.fitMapToMarkers.bind(this);
    this.getIgnoreHidden = this.getIgnoreHidden.bind(this);
    this.setIgnoreHidden = this.setIgnoreHidden.bind(this);
    this.getClusterClass = this.getClusterClass.bind(this);
    this.setClusterClass = this.setClusterClass.bind(this);
    this.getTotalMarkers = this.getTotalMarkers.bind(this);
    this.getZoomOnClick = this.getZoomOnClick.bind(this);
    this.setZoomOnClick = this.setZoomOnClick.bind(this);
    this.getBatchSizeIE = this.getBatchSizeIE.bind(this);
    this.setBatchSizeIE = this.setBatchSizeIE.bind(this);
    this.createClusters = this.createClusters.bind(this);
    this.onZoomChanged = this.onZoomChanged.bind(this);
    this.getImageSizes = this.getImageSizes.bind(this);
    this.setImageSizes = this.setImageSizes.bind(this);
    this.getCalculator = this.getCalculator.bind(this);
    this.setCalculator = this.setCalculator.bind(this);
    this.removeMarkers = this.removeMarkers.bind(this);
    this.resetViewport = this.resetViewport.bind(this);
    this.getImagePath = this.getImagePath.bind(this);
    this.setImagePath = this.setImagePath.bind(this);
    this.pushMarkerTo = this.pushMarkerTo.bind(this);
    this.removeMarker = this.removeMarker.bind(this);
    this.clearMarkers = this.clearMarkers.bind(this);
    this.setupStyles = this.setupStyles.bind(this);
    this.getGridSize = this.getGridSize.bind(this);
    this.setGridSize = this.setGridSize.bind(this);
    this.getClusters = this.getClusters.bind(this);
    this.getMaxZoom = this.getMaxZoom.bind(this);
    this.setMaxZoom = this.setMaxZoom.bind(this);
    this.getMarkers = this.getMarkers.bind(this);
    this.addMarkers = this.addMarkers.bind(this);
    this.getStyles = this.getStyles.bind(this);
    this.setStyles = this.setStyles.bind(this);
    this.addMarker = this.addMarker.bind(this);
    this.onRemove = this.onRemove.bind(this);
    this.getTitle = this.getTitle.bind(this);
    this.setTitle = this.setTitle.bind(this);
    this.repaint = this.repaint.bind(this);
    this.onIdle = this.onIdle.bind(this);
    this.redraw = this.redraw.bind(this);
    this.onAdd = this.onAdd.bind(this);
    this.draw = this.draw.bind(this);
    this.extend = this.extend.bind(this);
    this.extend(Clusterer, google.maps.OverlayView);
    this.markers = [];
    this.clusters = [];
    this.listeners = [];
    this.activeMap = null;
    this.ready = false;
    this.gridSize = optOptions.gridSize || 60;
    this.minClusterSize = optOptions.minimumClusterSize || 2;
    this.maxZoom = optOptions.maxZoom || null;
    this.styles = optOptions.styles || [];
    this.title = optOptions.title || '';
    this.zoomOnClick = true;
    if (optOptions.zoomOnClick !== undefined) {
      this.zoomOnClick = optOptions.zoomOnClick;
    }
    this.averageCenter = false;
    if (optOptions.averageCenter !== undefined) {
      this.averageCenter = optOptions.averageCenter;
    }
    this.ignoreHidden = false;
    if (optOptions.ignoreHidden !== undefined) {
      this.ignoreHidden = optOptions.ignoreHidden;
    }
    this.enableRetinaIcons = false;
    if (optOptions.enableRetinaIcons !== undefined) {
      this.enableRetinaIcons = optOptions.enableRetinaIcons;
    }
    this.imagePath = optOptions.imagePath || IMAGE_PATH;
    this.imageExtension = optOptions.imageExtension || IMAGE_EXTENSION;
    this.imageSizes = optOptions.imageSizes || IMAGE_SIZES;
    this.calculator = optOptions.calculator || CALCULATOR;
    this.batchSize = optOptions.batchSize || BATCH_SIZE;
    this.batchSizeIE = optOptions.batchSizeIE || BATCH_SIZE_IE;
    this.clusterClass = optOptions.clusterClass || CLUSTERER_CLASS;
    if (navigator.userAgent.toLowerCase().indexOf('msie') !== -1) {
      // Try to avoid IE timeout when processing a huge number of markers:
      this.batchSize = this.batchSizeIE;
    }
    this.timerRefStatic = null;
    this.setupStyles();
    this.addMarkers(optMarkers, true);
    this.setMap(map); // Note: this causes onAdd to be called
  }
  Clusterer.prototype.onZoomChanged = function () {
    var _a, _b;
    this.resetViewport(false);
    // Workaround for this Google bug: when map is at level 0 and "-" of
    // zoom slider is clicked, a "zoom_changed" event is fired even though
    // the map doesn't zoom out any further. In this situation, no "idle"
    // event is triggered so the cluster markers that have been removed
    // do not get redrawn. Same goes for a zoom in at maxZoom.
    if (((_a = this.getMap()) === null || _a === void 0 ? void 0 : _a.getZoom()) === (this.get('minZoom') || 0) || ((_b = this.getMap()) === null || _b === void 0 ? void 0 : _b.getZoom()) === this.get('maxZoom')) {
      google.maps.event.trigger(this, 'idle');
    }
  };
  Clusterer.prototype.onIdle = function () {
    this.redraw();
  };
  Clusterer.prototype.onAdd = function () {
    var map = this.getMap();
    this.activeMap = map;
    this.ready = true;
    this.repaint();
    if (map !== null) {
      // Add the map event listeners
      this.listeners = [google.maps.event.addListener(map, 'zoom_changed', this.onZoomChanged), google.maps.event.addListener(map, 'idle', this.onIdle)];
    }
  };
  Clusterer.prototype.onRemove = function () {
    // Put all the managed markers back on the map:
    for (var _i = 0, _a = this.markers; _i < _a.length; _i++) {
      var marker = _a[_i];
      if (marker.getMap() !== this.activeMap) {
        marker.setMap(this.activeMap);
      }
    }
    // Remove all clusters:
    for (var _b = 0, _c = this.clusters; _b < _c.length; _b++) {
      var cluster = _c[_b];
      cluster.remove();
    }
    this.clusters = [];
    // Remove map event listeners:
    for (var _d = 0, _e = this.listeners; _d < _e.length; _d++) {
      var listener = _e[_d];
      google.maps.event.removeListener(listener);
    }
    this.listeners = [];
    this.activeMap = null;
    this.ready = false;
  };
  Clusterer.prototype.draw = function () {
    return;
  };
  Clusterer.prototype.getMap = function () {
    return null;
  };
  Clusterer.prototype.getPanes = function () {
    return null;
  };
  Clusterer.prototype.getProjection = function () {
    return {
      fromContainerPixelToLatLng: function fromContainerPixelToLatLng() {
        return null;
      },
      fromDivPixelToLatLng: function fromDivPixelToLatLng() {
        return null;
      },
      fromLatLngToContainerPixel: function fromLatLngToContainerPixel() {
        return null;
      },
      fromLatLngToDivPixel: function fromLatLngToDivPixel() {
        return null;
      },
      getVisibleRegion: function getVisibleRegion() {
        return null;
      },
      getWorldWidth: function getWorldWidth() {
        return 0;
      }
    };
  };
  Clusterer.prototype.setMap = function () {
    return;
  };
  Clusterer.prototype.addListener = function () {
    return {
      remove: function remove() {
        return;
      }
    };
  };
  Clusterer.prototype.bindTo = function () {
    return;
  };
  Clusterer.prototype.get = function () {
    return;
  };
  Clusterer.prototype.notify = function () {
    return;
  };
  Clusterer.prototype.set = function () {
    return;
  };
  Clusterer.prototype.setValues = function () {
    return;
  };
  Clusterer.prototype.unbind = function () {
    return;
  };
  Clusterer.prototype.unbindAll = function () {
    return;
  };
  Clusterer.prototype.setupStyles = function () {
    if (this.styles.length > 0) {
      return;
    }
    for (var i = 0; i < this.imageSizes.length; i++) {
      this.styles.push({
        url: "".concat(this.imagePath + (i + 1), ".").concat(this.imageExtension),
        height: this.imageSizes[i] || 0,
        width: this.imageSizes[i] || 0
      });
    }
  };
  Clusterer.prototype.fitMapToMarkers = function () {
    var markers = this.getMarkers();
    var bounds = new google.maps.LatLngBounds();
    for (var _i = 0, markers_1 = markers; _i < markers_1.length; _i++) {
      var marker = markers_1[_i];
      var position = marker.getPosition();
      if (position) {
        bounds.extend(position);
      }
    }
    var map = this.getMap();
    if (map !== null && 'fitBounds' in map) {
      map.fitBounds(bounds);
    }
  };
  Clusterer.prototype.getGridSize = function () {
    return this.gridSize;
  };
  Clusterer.prototype.setGridSize = function (gridSize) {
    this.gridSize = gridSize;
  };
  Clusterer.prototype.getMinimumClusterSize = function () {
    return this.minClusterSize;
  };
  Clusterer.prototype.setMinimumClusterSize = function (minimumClusterSize) {
    this.minClusterSize = minimumClusterSize;
  };
  Clusterer.prototype.getMaxZoom = function () {
    return this.maxZoom;
  };
  Clusterer.prototype.setMaxZoom = function (maxZoom) {
    this.maxZoom = maxZoom;
  };
  Clusterer.prototype.getStyles = function () {
    return this.styles;
  };
  Clusterer.prototype.setStyles = function (styles) {
    this.styles = styles;
  };
  Clusterer.prototype.getTitle = function () {
    return this.title;
  };
  Clusterer.prototype.setTitle = function (title) {
    this.title = title;
  };
  Clusterer.prototype.getZoomOnClick = function () {
    return this.zoomOnClick;
  };
  Clusterer.prototype.setZoomOnClick = function (zoomOnClick) {
    this.zoomOnClick = zoomOnClick;
  };
  Clusterer.prototype.getAverageCenter = function () {
    return this.averageCenter;
  };
  Clusterer.prototype.setAverageCenter = function (averageCenter) {
    this.averageCenter = averageCenter;
  };
  Clusterer.prototype.getIgnoreHidden = function () {
    return this.ignoreHidden;
  };
  Clusterer.prototype.setIgnoreHidden = function (ignoreHidden) {
    this.ignoreHidden = ignoreHidden;
  };
  Clusterer.prototype.getEnableRetinaIcons = function () {
    return this.enableRetinaIcons;
  };
  Clusterer.prototype.setEnableRetinaIcons = function (enableRetinaIcons) {
    this.enableRetinaIcons = enableRetinaIcons;
  };
  Clusterer.prototype.getImageExtension = function () {
    return this.imageExtension;
  };
  Clusterer.prototype.setImageExtension = function (imageExtension) {
    this.imageExtension = imageExtension;
  };
  Clusterer.prototype.getImagePath = function () {
    return this.imagePath;
  };
  Clusterer.prototype.setImagePath = function (imagePath) {
    this.imagePath = imagePath;
  };
  Clusterer.prototype.getImageSizes = function () {
    return this.imageSizes;
  };
  Clusterer.prototype.setImageSizes = function (imageSizes) {
    this.imageSizes = imageSizes;
  };
  Clusterer.prototype.getCalculator = function () {
    return this.calculator;
  };
  Clusterer.prototype.setCalculator = function (calculator) {
    this.calculator = calculator;
  };
  Clusterer.prototype.getBatchSizeIE = function () {
    return this.batchSizeIE;
  };
  Clusterer.prototype.setBatchSizeIE = function (batchSizeIE) {
    this.batchSizeIE = batchSizeIE;
  };
  Clusterer.prototype.getClusterClass = function () {
    return this.clusterClass;
  };
  Clusterer.prototype.setClusterClass = function (clusterClass) {
    this.clusterClass = clusterClass;
  };
  Clusterer.prototype.getMarkers = function () {
    return this.markers;
  };
  Clusterer.prototype.getTotalMarkers = function () {
    return this.markers.length;
  };
  Clusterer.prototype.getClusters = function () {
    return this.clusters;
  };
  Clusterer.prototype.getTotalClusters = function () {
    return this.clusters.length;
  };
  Clusterer.prototype.addMarker = function (marker, optNoDraw) {
    this.pushMarkerTo(marker);
    if (!optNoDraw) {
      this.redraw();
    }
  };
  Clusterer.prototype.addMarkers = function (markers, optNoDraw) {
    for (var key in markers) {
      if (Object.prototype.hasOwnProperty.call(markers, key)) {
        var marker = markers[key];
        if (marker) {
          this.pushMarkerTo(marker);
        }
      }
    }
    if (!optNoDraw) {
      this.redraw();
    }
  };
  Clusterer.prototype.pushMarkerTo = function (marker) {
    var _this = this;
    // If the marker is draggable add a listener so we can update the clusters on the dragend:
    if (marker.getDraggable()) {
      google.maps.event.addListener(marker, 'dragend', function () {
        if (_this.ready) {
          marker.isAdded = false;
          _this.repaint();
        }
      });
    }
    marker.isAdded = false;
    this.markers.push(marker);
  };
  Clusterer.prototype.removeMarker_ = function (marker) {
    var index = -1;
    if (this.markers.indexOf) {
      index = this.markers.indexOf(marker);
    } else {
      for (var i = 0; i < this.markers.length; i++) {
        if (marker === this.markers[i]) {
          index = i;
          break;
        }
      }
    }
    if (index === -1) {
      // Marker is not in our list of markers, so do nothing:
      return false;
    }
    marker.setMap(null);
    this.markers.splice(index, 1); // Remove the marker from the list of managed markers
    return true;
  };
  Clusterer.prototype.removeMarker = function (marker, optNoDraw) {
    var removed = this.removeMarker_(marker);
    if (!optNoDraw && removed) {
      this.repaint();
    }
    return removed;
  };
  Clusterer.prototype.removeMarkers = function (markers, optNoDraw) {
    var removed = false;
    for (var _i = 0, markers_2 = markers; _i < markers_2.length; _i++) {
      var marker = markers_2[_i];
      removed = removed || this.removeMarker_(marker);
    }
    if (!optNoDraw && removed) {
      this.repaint();
    }
    return removed;
  };
  Clusterer.prototype.clearMarkers = function () {
    this.resetViewport(true);
    this.markers = [];
  };
  Clusterer.prototype.repaint = function () {
    var oldClusters = this.clusters.slice();
    this.clusters = [];
    this.resetViewport(false);
    this.redraw();
    // Remove the old clusters.
    // Do it in a timeout to prevent blinking effect.
    setTimeout(function timeout() {
      for (var _i = 0, oldClusters_1 = oldClusters; _i < oldClusters_1.length; _i++) {
        var oldCluster = oldClusters_1[_i];
        oldCluster.remove();
      }
    }, 0);
  };
  Clusterer.prototype.getExtendedBounds = function (bounds) {
    var projection = this.getProjection();
    // Convert the points to pixels and the extend out by the grid size.
    var trPix = projection.fromLatLngToDivPixel(
    // Turn the bounds into latlng.
    new google.maps.LatLng(bounds.getNorthEast().lat(), bounds.getNorthEast().lng()));
    if (trPix !== null) {
      trPix.x += this.gridSize;
      trPix.y -= this.gridSize;
    }
    var blPix = projection.fromLatLngToDivPixel(
    // Turn the bounds into latlng.
    new google.maps.LatLng(bounds.getSouthWest().lat(), bounds.getSouthWest().lng()));
    if (blPix !== null) {
      blPix.x -= this.gridSize;
      blPix.y += this.gridSize;
    }
    // Extend the bounds to contain the new bounds.
    if (trPix !== null) {
      // Convert the pixel points back to LatLng nw
      var point1 = projection.fromDivPixelToLatLng(trPix);
      if (point1 !== null) {
        bounds.extend(point1);
      }
    }
    if (blPix !== null) {
      // Convert the pixel points back to LatLng sw
      var point2 = projection.fromDivPixelToLatLng(blPix);
      if (point2 !== null) {
        bounds.extend(point2);
      }
    }
    return bounds;
  };
  Clusterer.prototype.redraw = function () {
    // Redraws all the clusters.
    this.createClusters(0);
  };
  Clusterer.prototype.resetViewport = function (optHide) {
    // Remove all the clusters
    for (var _i = 0, _a = this.clusters; _i < _a.length; _i++) {
      var cluster = _a[_i];
      cluster.remove();
    }
    this.clusters = [];
    // Reset the markers to not be added and to be removed from the map.
    for (var _b = 0, _c = this.markers; _b < _c.length; _b++) {
      var marker = _c[_b];
      marker.isAdded = false;
      if (optHide) {
        marker.setMap(null);
      }
    }
  };
  Clusterer.prototype.distanceBetweenPoints = function (p1, p2) {
    var R = 6371; // Radius of the Earth in km
    var dLat = (p2.lat() - p1.lat()) * Math.PI / 180;
    var dLon = (p2.lng() - p1.lng()) * Math.PI / 180;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(p1.lat() * Math.PI / 180) * Math.cos(p2.lat() * Math.PI / 180) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return R * (2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)));
  };
  Clusterer.prototype.isMarkerInBounds = function (marker, bounds) {
    var position = marker.getPosition();
    if (position) {
      return bounds.contains(position);
    }
    return false;
  };
  Clusterer.prototype.addToClosestCluster = function (marker) {
    var cluster;
    var distance = 40000; // Some large number
    var clusterToAddTo = null;
    for (var _i = 0, _a = this.clusters; _i < _a.length; _i++) {
      var clusterElement = _a[_i];
      cluster = clusterElement;
      var center = cluster.getCenter();
      var position = marker.getPosition();
      if (center && position) {
        var d = this.distanceBetweenPoints(center, position);
        if (d < distance) {
          distance = d;
          clusterToAddTo = cluster;
        }
      }
    }
    if (clusterToAddTo && clusterToAddTo.isMarkerInClusterBounds(marker)) {
      clusterToAddTo.addMarker(marker);
    } else {
      cluster = new Cluster$1(this);
      cluster.addMarker(marker);
      this.clusters.push(cluster);
    }
  };
  Clusterer.prototype.createClusters = function (iFirst) {
    var _this = this;
    if (!this.ready) {
      return;
    }
    // Cancel previous batch processing if we're working on the first batch:
    if (iFirst === 0) {
      /**
       * This event is fired when the <code>Clusterer</code> begins
       *  clustering markers.
       * @name Clusterer#clusteringbegin
       * @param {Clusterer} mc The Clusterer whose markers are being clustered.
       * @event
       */
      google.maps.event.trigger(this, 'clusteringbegin', this);
      if (this.timerRefStatic !== null) {
        window.clearTimeout(this.timerRefStatic);
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        delete this.timerRefStatic;
      }
    }
    var map = this.getMap();
    var bounds = map !== null && 'getBounds' in map ? map.getBounds() : null;
    var zoom = (map === null || map === void 0 ? void 0 : map.getZoom()) || 0;
    // Get our current map view bounds.
    // Create a new bounds object so we don't affect the map.
    //
    // See Comments 9 & 11 on Issue 3651 relating to this workaround for a Google Maps bug:
    var mapBounds = zoom > 3 ? new google.maps.LatLngBounds(bounds === null || bounds === void 0 ? void 0 : bounds.getSouthWest(), bounds === null || bounds === void 0 ? void 0 : bounds.getNorthEast()) : new google.maps.LatLngBounds(new google.maps.LatLng(85.02070771743472, -178.48388434375), new google.maps.LatLng(-85.08136444384544, 178.00048865625));
    var extendedMapBounds = this.getExtendedBounds(mapBounds);
    var iLast = Math.min(iFirst + this.batchSize, this.markers.length);
    for (var i = iFirst; i < iLast; i++) {
      var marker = this.markers[i];
      if (marker && !marker.isAdded && this.isMarkerInBounds(marker, extendedMapBounds) && (!this.ignoreHidden || this.ignoreHidden && marker.getVisible())) {
        this.addToClosestCluster(marker);
      }
    }
    if (iLast < this.markers.length) {
      this.timerRefStatic = window.setTimeout(function () {
        _this.createClusters(iLast);
      }, 0);
    } else {
      this.timerRefStatic = null;
      /**
       * This event is fired when the <code>Clusterer</code> stops
       *  clustering markers.
       * @name Clusterer#clusteringend
       * @param {Clusterer} mc The Clusterer whose markers are being clustered.
       * @event
       */
      google.maps.event.trigger(this, 'clusteringend', this);
      for (var _i = 0, _a = this.clusters; _i < _a.length; _i++) {
        var cluster = _a[_i];
        cluster.updateIcon();
      }
    }
  };
  Clusterer.prototype.extend = function (obj1, obj2) {
    return function applyExtend(object) {
      for (var property in object.prototype) {
        // eslint-disable-next-line @typescript-eslint/ban-types
        var prop = property;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.prototype[prop] = object.prototype[prop];
      }
      return this;
    }.apply(obj1, [obj2]);
  };
  return Clusterer;
}();
var eventMap$e = {
  onClick: 'click',
  onClusteringBegin: 'clusteringbegin',
  onClusteringEnd: 'clusteringend',
  onMouseOut: 'mouseout',
  onMouseOver: 'mouseover'
};
var updaterMap$e = {
  averageCenter: function averageCenter(instance, _averageCenter) {
    instance.setAverageCenter(_averageCenter);
  },
  batchSizeIE: function batchSizeIE(instance, _batchSizeIE) {
    instance.setBatchSizeIE(_batchSizeIE);
  },
  calculator: function calculator(instance, _calculator) {
    instance.setCalculator(_calculator);
  },
  clusterClass: function clusterClass(instance, _clusterClass) {
    instance.setClusterClass(_clusterClass);
  },
  enableRetinaIcons: function enableRetinaIcons(instance, _enableRetinaIcons) {
    instance.setEnableRetinaIcons(_enableRetinaIcons);
  },
  gridSize: function gridSize(instance, _gridSize) {
    instance.setGridSize(_gridSize);
  },
  ignoreHidden: function ignoreHidden(instance, _ignoreHidden) {
    instance.setIgnoreHidden(_ignoreHidden);
  },
  imageExtension: function imageExtension(instance, _imageExtension) {
    instance.setImageExtension(_imageExtension);
  },
  imagePath: function imagePath(instance, _imagePath) {
    instance.setImagePath(_imagePath);
  },
  imageSizes: function imageSizes(instance, _imageSizes) {
    instance.setImageSizes(_imageSizes);
  },
  maxZoom: function maxZoom(instance, _maxZoom) {
    instance.setMaxZoom(_maxZoom);
  },
  minimumClusterSize: function minimumClusterSize(instance, _minimumClusterSize) {
    instance.setMinimumClusterSize(_minimumClusterSize);
  },
  styles: function styles(instance, _styles) {
    instance.setStyles(_styles);
  },
  title: function title(instance, _title2) {
    instance.setTitle(_title2);
  },
  zoomOnClick: function zoomOnClick(instance, _zoomOnClick) {
    instance.setZoomOnClick(_zoomOnClick);
  }
};
/** @class */(function (_super) {
  __extends(ClustererComponent, _super);
  function ClustererComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.state = {
      markerClusterer: null
    };
    _this.setClustererCallback = function () {
      if (_this.state.markerClusterer !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.markerClusterer);
      }
    };
    return _this;
  }
  ClustererComponent.prototype.componentDidMount = function () {
    if (this.context) {
      var markerClusterer_1 = new Clusterer(this.context, [], this.props.options);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$e,
        eventMap: eventMap$e,
        prevProps: {},
        nextProps: this.props,
        instance: markerClusterer_1
      });
      this.setState(function () {
        return {
          markerClusterer: markerClusterer_1
        };
      }, this.setClustererCallback);
    }
  };
  ClustererComponent.prototype.componentDidUpdate = function (prevProps) {
    if (this.state.markerClusterer) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$e,
        eventMap: eventMap$e,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.markerClusterer
      });
    }
  };
  ClustererComponent.prototype.componentWillUnmount = function () {
    if (this.state.markerClusterer !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.markerClusterer);
      }
      unregisterEvents(this.registeredEvents);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      this.state.markerClusterer.setMap(null);
    }
  };
  ClustererComponent.prototype.render = function () {
    return this.state.markerClusterer !== null ? this.props.children(this.state.markerClusterer) : null;
  };
  ClustererComponent.contextType = MapContext;
  return ClustererComponent;
})(PureComponent);

// This handler prevents an event in the InfoBox from being passed on to the map.
function cancelHandler(event) {
  event.cancelBubble = true;
  if (event.stopPropagation) {
    event.stopPropagation();
  }
}
var InfoBox = /** @class */function () {
  function InfoBox(options) {
    if (options === void 0) {
      options = {};
    }
    this.getCloseClickHandler = this.getCloseClickHandler.bind(this);
    this.closeClickHandler = this.closeClickHandler.bind(this);
    this.createInfoBoxDiv = this.createInfoBoxDiv.bind(this);
    this.addClickHandler = this.addClickHandler.bind(this);
    this.getCloseBoxImg = this.getCloseBoxImg.bind(this);
    this.getBoxWidths = this.getBoxWidths.bind(this);
    this.setBoxStyle = this.setBoxStyle.bind(this);
    this.setPosition = this.setPosition.bind(this);
    this.getPosition = this.getPosition.bind(this);
    this.setOptions = this.setOptions.bind(this);
    this.setContent = this.setContent.bind(this);
    this.setVisible = this.setVisible.bind(this);
    this.getContent = this.getContent.bind(this);
    this.getVisible = this.getVisible.bind(this);
    this.setZIndex = this.setZIndex.bind(this);
    this.getZIndex = this.getZIndex.bind(this);
    this.onRemove = this.onRemove.bind(this);
    this.panBox = this.panBox.bind(this);
    this.extend = this.extend.bind(this);
    this.close = this.close.bind(this);
    this.draw = this.draw.bind(this);
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
    this.open = this.open.bind(this);
    this.extend(InfoBox, google.maps.OverlayView);
    // Standard options (in common with google.maps.InfoWindow):
    this.content = options.content || '';
    this.disableAutoPan = options.disableAutoPan || false;
    this.maxWidth = options.maxWidth || 0;
    this.pixelOffset = options.pixelOffset || new google.maps.Size(0, 0);
    this.position = options.position || new google.maps.LatLng(0, 0);
    this.zIndex = options.zIndex || null;
    // Additional options (unique to InfoBox):
    this.boxClass = options.boxClass || 'infoBox';
    this.boxStyle = options.boxStyle || {};
    this.closeBoxMargin = options.closeBoxMargin || '2px';
    this.closeBoxURL = options.closeBoxURL || 'http://www.google.com/intl/en_us/mapfiles/close.gif';
    if (options.closeBoxURL === '') {
      this.closeBoxURL = '';
    }
    this.infoBoxClearance = options.infoBoxClearance || new google.maps.Size(1, 1);
    if (typeof options.visible === 'undefined') {
      if (typeof options.isHidden === 'undefined') {
        options.visible = true;
      } else {
        options.visible = !options.isHidden;
      }
    }
    this.isHidden = !options.visible;
    this.alignBottom = options.alignBottom || false;
    this.pane = options.pane || 'floatPane';
    this.enableEventPropagation = options.enableEventPropagation || false;
    this.div = null;
    this.closeListener = null;
    this.moveListener = null;
    this.mapListener = null;
    this.contextListener = null;
    this.eventListeners = null;
    this.fixedWidthSet = null;
  }
  InfoBox.prototype.createInfoBoxDiv = function () {
    var _this = this;
    // This handler ignores the current event in the InfoBox and conditionally prevents
    // the event from being passed on to the map. It is used for the contextmenu event.
    var ignoreHandler = function ignoreHandler(event) {
      event.returnValue = false;
      if (event.preventDefault) {
        event.preventDefault();
      }
      if (!_this.enableEventPropagation) {
        cancelHandler(event);
      }
    };
    if (!this.div) {
      this.div = document.createElement('div');
      this.setBoxStyle();
      if (typeof this.content === 'string') {
        this.div.innerHTML = this.getCloseBoxImg() + this.content;
      } else {
        this.div.innerHTML = this.getCloseBoxImg();
        this.div.appendChild(this.content);
      }
      var panes = this.getPanes();
      if (panes !== null) {
        panes[this.pane].appendChild(this.div); // Add the InfoBox div to the DOM
      }
      this.addClickHandler();
      if (this.div.style.width) {
        this.fixedWidthSet = true;
      } else {
        if (this.maxWidth !== 0 && this.div.offsetWidth > this.maxWidth) {
          this.div.style.width = this.maxWidth + 'px';
          this.fixedWidthSet = true;
        } else {
          // The following code is needed to overcome problems with MSIE
          var bw = this.getBoxWidths();
          this.div.style.width = this.div.offsetWidth - bw.left - bw.right + 'px';
          this.fixedWidthSet = false;
        }
      }
      this.panBox(this.disableAutoPan);
      if (!this.enableEventPropagation) {
        this.eventListeners = [];
        // Cancel event propagation.
        // Note: mousemove not included (to resolve Issue 152)
        var events = ['mousedown', 'mouseover', 'mouseout', 'mouseup', 'click', 'dblclick', 'touchstart', 'touchend', 'touchmove'];
        for (var _i = 0, events_1 = events; _i < events_1.length; _i++) {
          var event_1 = events_1[_i];
          this.eventListeners.push(google.maps.event.addListener(this.div, event_1, cancelHandler));
        }
        // Workaround for Google bug that causes the cursor to change to a pointer
        // when the mouse moves over a marker underneath InfoBox.
        this.eventListeners.push(google.maps.event.addListener(this.div, 'mouseover', function () {
          if (_this.div) {
            _this.div.style.cursor = 'default';
          }
        }));
      }
      this.contextListener = google.maps.event.addListener(this.div, 'contextmenu', ignoreHandler);
      /**
       * This event is fired when the DIV containing the InfoBox's content is attached to the DOM.
       * @name InfoBox#domready
       * @event
       */
      google.maps.event.trigger(this, 'domready');
    }
  };
  InfoBox.prototype.getCloseBoxImg = function () {
    var img = '';
    if (this.closeBoxURL !== '') {
      img = '<img alt=""';
      img += ' aria-hidden="true"';
      img += " src='" + this.closeBoxURL + "'";
      img += ' align=right'; // Do this because Opera chokes on style='float: right;'
      img += " style='";
      img += ' position: relative;'; // Required by MSIE
      img += ' cursor: pointer;';
      img += ' margin: ' + this.closeBoxMargin + ';';
      img += "'>";
    }
    return img;
  };
  InfoBox.prototype.addClickHandler = function () {
    this.closeListener = this.div && this.div.firstChild && this.closeBoxURL !== '' ? google.maps.event.addListener(this.div.firstChild, 'click', this.getCloseClickHandler()) : null;
  };
  InfoBox.prototype.closeClickHandler = function (event) {
    // 1.0.3 fix: Always prevent propagation of a close box click to the map:
    event.cancelBubble = true;
    if (event.stopPropagation) {
      event.stopPropagation();
    }
    /**
     * This event is fired when the InfoBox's close box is clicked.
     * @name InfoBox#closeclick
     * @event
     */
    google.maps.event.trigger(this, 'closeclick');
    this.close();
  };
  InfoBox.prototype.getCloseClickHandler = function () {
    return this.closeClickHandler;
  };
  InfoBox.prototype.panBox = function (disablePan) {
    if (this.div && !disablePan) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      var map = this.getMap();
      // Only pan if attached to map, not panorama
      if (map instanceof google.maps.Map) {
        var xOffset = 0;
        var yOffset = 0;
        var bounds = map.getBounds();
        if (bounds && !bounds.contains(this.position)) {
          // Marker not in visible area of map, so set center
          // of map to the marker position first.
          map.setCenter(this.position);
        }
        var mapDiv = map.getDiv();
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        var mapWidth = mapDiv.offsetWidth;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        var mapHeight = mapDiv.offsetHeight;
        var iwOffsetX = this.pixelOffset.width;
        var iwOffsetY = this.pixelOffset.height;
        var iwWidth = this.div.offsetWidth;
        var iwHeight = this.div.offsetHeight;
        var padX = this.infoBoxClearance.width;
        var padY = this.infoBoxClearance.height;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        var projection = this.getProjection();
        var pixPosition = projection.fromLatLngToContainerPixel(this.position);
        if (pixPosition !== null) {
          if (pixPosition.x < -iwOffsetX + padX) {
            xOffset = pixPosition.x + iwOffsetX - padX;
          } else if (pixPosition.x + iwWidth + iwOffsetX + padX > mapWidth) {
            xOffset = pixPosition.x + iwWidth + iwOffsetX + padX - mapWidth;
          }
          if (this.alignBottom) {
            if (pixPosition.y < -iwOffsetY + padY + iwHeight) {
              yOffset = pixPosition.y + iwOffsetY - padY - iwHeight;
            } else if (pixPosition.y + iwOffsetY + padY > mapHeight) {
              yOffset = pixPosition.y + iwOffsetY + padY - mapHeight;
            }
          } else {
            if (pixPosition.y < -iwOffsetY + padY) {
              yOffset = pixPosition.y + iwOffsetY - padY;
            } else if (pixPosition.y + iwHeight + iwOffsetY + padY > mapHeight) {
              yOffset = pixPosition.y + iwHeight + iwOffsetY + padY - mapHeight;
            }
          }
        }
        if (!(xOffset === 0 && yOffset === 0)) {
          // Move the map to the shifted center.
          map.panBy(xOffset, yOffset);
        }
      }
    }
  };
  InfoBox.prototype.setBoxStyle = function () {
    if (this.div) {
      // Apply style values from the style sheet defined in the boxClass parameter:
      this.div.className = this.boxClass;
      // Clear existing inline style values:
      this.div.style.cssText = '';
      // Apply style values defined in the boxStyle parameter:
      var boxStyle = this.boxStyle;
      for (var i in boxStyle) {
        if (Object.prototype.hasOwnProperty.call(boxStyle, i)) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          this.div.style[i] = boxStyle[i];
        }
      }
      // Fix for iOS disappearing InfoBox problem
      // See http://stackoverflow.com/questions/9229535/google-maps-markers-disappear-at-certain-zoom-level-only-on-iphone-ipad
      this.div.style.webkitTransform = 'translateZ(0)';
      // Fix up opacity style for benefit of MSIE
      if (typeof this.div.style.opacity !== 'undefined' && this.div.style.opacity !== '') {
        // See http://www.quirksmode.org/css/opacity.html
        var opacity = parseFloat(this.div.style.opacity || '');
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.div.style.msFilter = '"progid:DXImageTransform.Microsoft.Alpha(Opacity=' + opacity * 100 + ')"';
        this.div.style.filter = 'alpha(opacity=' + opacity * 100 + ')';
      }
      // Apply required styles
      this.div.style.position = 'absolute';
      this.div.style.visibility = 'hidden';
      if (this.zIndex !== null) {
        this.div.style.zIndex = this.zIndex + '';
      }
      if (!this.div.style.overflow) {
        this.div.style.overflow = 'auto';
      }
    }
  };
  InfoBox.prototype.getBoxWidths = function () {
    var bw = {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0
    };
    if (!this.div) {
      return bw;
    }
    if (document.defaultView) {
      var ownerDocument = this.div.ownerDocument;
      var computedStyle = ownerDocument && ownerDocument.defaultView ? ownerDocument.defaultView.getComputedStyle(this.div, '') : null;
      if (computedStyle) {
        // The computed styles are always in pixel units (good!)
        bw.top = parseInt(computedStyle.borderTopWidth || '', 10) || 0;
        bw.bottom = parseInt(computedStyle.borderBottomWidth || '', 10) || 0;
        bw.left = parseInt(computedStyle.borderLeftWidth || '', 10) || 0;
        bw.right = parseInt(computedStyle.borderRightWidth || '', 10) || 0;
      }
    } else if (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    document.documentElement.currentStyle // MSIE
    ) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      var currentStyle = this.div.currentStyle;
      if (currentStyle) {
        // The current styles may not be in pixel units, but assume they are (bad!)
        bw.top = parseInt(currentStyle.borderTopWidth || '', 10) || 0;
        bw.bottom = parseInt(currentStyle.borderBottomWidth || '', 10) || 0;
        bw.left = parseInt(currentStyle.borderLeftWidth || '', 10) || 0;
        bw.right = parseInt(currentStyle.borderRightWidth || '', 10) || 0;
      }
    }
    return bw;
  };
  InfoBox.prototype.onRemove = function () {
    if (this.div && this.div.parentNode) {
      this.div.parentNode.removeChild(this.div);
      this.div = null;
    }
  };
  InfoBox.prototype.draw = function () {
    this.createInfoBoxDiv();
    if (this.div) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      var projection = this.getProjection();
      var pixPosition = projection.fromLatLngToDivPixel(this.position);
      if (pixPosition !== null) {
        this.div.style.left = pixPosition.x + this.pixelOffset.width + 'px';
        if (this.alignBottom) {
          this.div.style.bottom = -(pixPosition.y + this.pixelOffset.height) + 'px';
        } else {
          this.div.style.top = pixPosition.y + this.pixelOffset.height + 'px';
        }
      }
      if (this.isHidden) {
        this.div.style.visibility = 'hidden';
      } else {
        this.div.style.visibility = 'visible';
      }
    }
  };
  InfoBox.prototype.setOptions = function (options) {
    if (options === void 0) {
      options = {};
    }
    if (typeof options.boxClass !== 'undefined') {
      // Must be first
      this.boxClass = options.boxClass;
      this.setBoxStyle();
    }
    if (typeof options.boxStyle !== 'undefined') {
      // Must be second
      this.boxStyle = options.boxStyle;
      this.setBoxStyle();
    }
    if (typeof options.content !== 'undefined') {
      this.setContent(options.content);
    }
    if (typeof options.disableAutoPan !== 'undefined') {
      this.disableAutoPan = options.disableAutoPan;
    }
    if (typeof options.maxWidth !== 'undefined') {
      this.maxWidth = options.maxWidth;
    }
    if (typeof options.pixelOffset !== 'undefined') {
      this.pixelOffset = options.pixelOffset;
    }
    if (typeof options.alignBottom !== 'undefined') {
      this.alignBottom = options.alignBottom;
    }
    if (typeof options.position !== 'undefined') {
      this.setPosition(options.position);
    }
    if (typeof options.zIndex !== 'undefined') {
      this.setZIndex(options.zIndex);
    }
    if (typeof options.closeBoxMargin !== 'undefined') {
      this.closeBoxMargin = options.closeBoxMargin;
    }
    if (typeof options.closeBoxURL !== 'undefined') {
      this.closeBoxURL = options.closeBoxURL;
    }
    if (typeof options.infoBoxClearance !== 'undefined') {
      this.infoBoxClearance = options.infoBoxClearance;
    }
    if (typeof options.isHidden !== 'undefined') {
      this.isHidden = options.isHidden;
    }
    if (typeof options.visible !== 'undefined') {
      this.isHidden = !options.visible;
    }
    if (typeof options.enableEventPropagation !== 'undefined') {
      this.enableEventPropagation = options.enableEventPropagation;
    }
    if (this.div) {
      this.draw();
    }
  };
  InfoBox.prototype.setContent = function (content) {
    this.content = content;
    if (this.div) {
      if (this.closeListener) {
        google.maps.event.removeListener(this.closeListener);
        this.closeListener = null;
      }
      // Odd code required to make things work with MSIE.
      if (!this.fixedWidthSet) {
        this.div.style.width = '';
      }
      if (typeof content === 'string') {
        this.div.innerHTML = this.getCloseBoxImg() + content;
      } else {
        this.div.innerHTML = this.getCloseBoxImg();
        this.div.appendChild(content);
      }
      // Perverse code required to make things work with MSIE.
      // (Ensures the close box does, in fact, float to the right.)
      if (!this.fixedWidthSet) {
        this.div.style.width = this.div.offsetWidth + 'px';
        if (typeof content === 'string') {
          this.div.innerHTML = this.getCloseBoxImg() + content;
        } else {
          this.div.innerHTML = this.getCloseBoxImg();
          this.div.appendChild(content);
        }
      }
      this.addClickHandler();
    }
    /**
     * This event is fired when the content of the InfoBox changes.
     * @name InfoBox#content_changed
     * @event
     */
    google.maps.event.trigger(this, 'content_changed');
  };
  InfoBox.prototype.setPosition = function (latLng) {
    this.position = latLng;
    if (this.div) {
      this.draw();
    }
    /**
     * This event is fired when the position of the InfoBox changes.
     * @name InfoBox#position_changed
     * @event
     */
    google.maps.event.trigger(this, 'position_changed');
  };
  InfoBox.prototype.setVisible = function (isVisible) {
    this.isHidden = !isVisible;
    if (this.div) {
      this.div.style.visibility = this.isHidden ? 'hidden' : 'visible';
    }
  };
  InfoBox.prototype.setZIndex = function (index) {
    this.zIndex = index;
    if (this.div) {
      this.div.style.zIndex = index + '';
    }
    /**
     * This event is fired when the zIndex of the InfoBox changes.
     * @name InfoBox#zindex_changed
     * @event
     */
    google.maps.event.trigger(this, 'zindex_changed');
  };
  InfoBox.prototype.getContent = function () {
    return this.content;
  };
  InfoBox.prototype.getPosition = function () {
    return this.position;
  };
  InfoBox.prototype.getZIndex = function () {
    return this.zIndex;
  };
  InfoBox.prototype.getVisible = function () {
    var map = this.getMap();
    return typeof map === 'undefined' || map === null ? false : !this.isHidden;
  };
  InfoBox.prototype.show = function () {
    this.isHidden = false;
    if (this.div) {
      this.div.style.visibility = 'visible';
    }
  };
  InfoBox.prototype.hide = function () {
    this.isHidden = true;
    if (this.div) {
      this.div.style.visibility = 'hidden';
    }
  };
  InfoBox.prototype.open = function (map, anchor) {
    var _this = this;
    if (anchor) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      this.position = anchor.getPosition();
      this.moveListener = google.maps.event.addListener(anchor, 'position_changed', function () {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        var position = anchor.getPosition();
        _this.setPosition(position);
      });
      this.mapListener = google.maps.event.addListener(anchor, 'map_changed', function () {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        _this.setMap(anchor.map);
      });
    }
    this.setMap(map);
    if (this.div) {
      this.panBox();
    }
  };
  InfoBox.prototype.close = function () {
    if (this.closeListener) {
      google.maps.event.removeListener(this.closeListener);
      this.closeListener = null;
    }
    if (this.eventListeners) {
      for (var _i = 0, _a = this.eventListeners; _i < _a.length; _i++) {
        var eventListener = _a[_i];
        google.maps.event.removeListener(eventListener);
      }
      this.eventListeners = null;
    }
    if (this.moveListener) {
      google.maps.event.removeListener(this.moveListener);
      this.moveListener = null;
    }
    if (this.mapListener) {
      google.maps.event.removeListener(this.mapListener);
      this.mapListener = null;
    }
    if (this.contextListener) {
      google.maps.event.removeListener(this.contextListener);
      this.contextListener = null;
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    this.setMap(null);
  };
  InfoBox.prototype.extend = function (obj1, obj2) {
    return function applyExtend(object) {
      for (var property in object.prototype) {
        if (!Object.prototype.hasOwnProperty.call(this, property)) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          this.prototype[property] = object.prototype[property];
        }
      }
      return this;
    }.apply(obj1, [obj2]);
  };
  return InfoBox;
}();
var eventMap$d = {
  onCloseClick: 'closeclick',
  onContentChanged: 'content_changed',
  onDomReady: 'domready',
  onPositionChanged: 'position_changed',
  onZindexChanged: 'zindex_changed'
};
var updaterMap$d = {
  options: function options(instance, _options5) {
    instance.setOptions(_options5);
  },
  position: function position(instance, _position2) {
    if (_position2 instanceof google.maps.LatLng) {
      instance.setPosition(_position2);
    } else {
      instance.setPosition(new google.maps.LatLng(_position2.lat, _position2.lng));
    }
  },
  visible: function visible(instance, _visible2) {
    instance.setVisible(_visible2);
  },
  zIndex: function zIndex(instance, _zIndex2) {
    instance.setZIndex(_zIndex2);
  }
};
/** @class */(function (_super) {
  __extends(InfoBoxComponent, _super);
  function InfoBoxComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.containerElement = null;
    _this.state = {
      infoBox: null
    };
    _this.open = function (infoBox, anchor) {
      if (anchor) {
        if (_this.context !== null) {
          infoBox.open(_this.context, anchor);
        }
      } else if (infoBox.getPosition()) {
        if (_this.context !== null) {
          infoBox.open(_this.context);
        }
      } else {
        invariant$1$1(false, 'You must provide either an anchor or a position prop for <InfoBox>.');
      }
    };
    _this.setInfoBoxCallback = function () {
      if (_this.state.infoBox !== null && _this.containerElement !== null) {
        _this.state.infoBox.setContent(_this.containerElement);
        _this.open(_this.state.infoBox, _this.props.anchor);
        if (_this.props.onLoad) {
          _this.props.onLoad(_this.state.infoBox);
        }
      }
    };
    return _this;
  }
  InfoBoxComponent.prototype.componentDidMount = function () {
    var _a = this.props.options || {},
      position = _a.position,
      infoBoxOptions = __rest$1(_a, ["position"]);
    var positionLatLng;
    if (position && !(position instanceof google.maps.LatLng)) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      positionLatLng = new google.maps.LatLng(position.lat, position.lng);
    }
    var infoBox = new InfoBox(_assign(_assign({}, infoBoxOptions), positionLatLng ? {
      position: positionLatLng
    } : {}));
    this.containerElement = document.createElement('div');
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$d,
      eventMap: eventMap$d,
      prevProps: {},
      nextProps: this.props,
      instance: infoBox
    });
    this.setState({
      infoBox: infoBox
    }, this.setInfoBoxCallback);
  };
  InfoBoxComponent.prototype.componentDidUpdate = function (prevProps) {
    var infoBox = this.state.infoBox;
    if (infoBox !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$d,
        eventMap: eventMap$d,
        prevProps: prevProps,
        nextProps: this.props,
        instance: infoBox
      });
    }
  };
  InfoBoxComponent.prototype.componentWillUnmount = function () {
    var onUnmount = this.props.onUnmount;
    var infoBox = this.state.infoBox;
    if (infoBox !== null) {
      if (onUnmount) {
        onUnmount(infoBox);
      }
      unregisterEvents(this.registeredEvents);
      infoBox.close();
    }
  };
  InfoBoxComponent.prototype.render = function () {
    return this.containerElement ? /*#__PURE__*/createPortal(Children.only(this.props.children), this.containerElement) : null;
  };
  InfoBoxComponent.contextType = MapContext;
  return InfoBoxComponent;
})(PureComponent);
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var MarkerClustererEvents;
(function (MarkerClustererEvents) {
  MarkerClustererEvents["CLUSTERING_BEGIN"] = "clusteringbegin";
  MarkerClustererEvents["CLUSTERING_END"] = "clusteringend";
  MarkerClustererEvents["CLUSTER_CLICK"] = "click";
})(MarkerClustererEvents || (MarkerClustererEvents = {}));
var eventMap$c = {
  onCloseClick: 'closeclick',
  onContentChanged: 'content_changed',
  onDomReady: 'domready',
  onPositionChanged: 'position_changed',
  onZindexChanged: 'zindex_changed'
};
var updaterMap$c = {
  options: function options(instance, _options6) {
    instance.setOptions(_options6);
  },
  position: function position(instance, _position3) {
    instance.setPosition(_position3);
  },
  zIndex: function zIndex(instance, _zIndex3) {
    instance.setZIndex(_zIndex3);
  }
};
/** @class */(function (_super) {
  __extends(InfoWindow, _super);
  function InfoWindow() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.containerElement = null;
    _this.state = {
      infoWindow: null
    };
    _this.open = function (infoWindow, anchor) {
      if (anchor) {
        infoWindow.open(_this.context, anchor);
      } else if (infoWindow.getPosition()) {
        infoWindow.open(_this.context);
      } else {
        invariant$1$1(false, "You must provide either an anchor (typically render it inside a <Marker>) or a position props for <InfoWindow>.");
      }
    };
    _this.setInfoWindowCallback = function () {
      if (_this.state.infoWindow !== null && _this.containerElement !== null) {
        _this.state.infoWindow.setContent(_this.containerElement);
        _this.open(_this.state.infoWindow, _this.props.anchor);
        if (_this.props.onLoad) {
          _this.props.onLoad(_this.state.infoWindow);
        }
      }
    };
    return _this;
  }
  InfoWindow.prototype.componentDidMount = function () {
    var infoWindow = new google.maps.InfoWindow(_assign({}, this.props.options || {}));
    this.containerElement = document.createElement('div');
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$c,
      eventMap: eventMap$c,
      prevProps: {},
      nextProps: this.props,
      instance: infoWindow
    });
    this.setState(function () {
      return {
        infoWindow: infoWindow
      };
    }, this.setInfoWindowCallback);
  };
  InfoWindow.prototype.componentDidUpdate = function (prevProps) {
    if (this.state.infoWindow !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$c,
        eventMap: eventMap$c,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.infoWindow
      });
    }
  };
  InfoWindow.prototype.componentWillUnmount = function () {
    if (this.state.infoWindow !== null) {
      unregisterEvents(this.registeredEvents);
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.infoWindow);
      }
      this.state.infoWindow.close();
    }
  };
  InfoWindow.prototype.render = function () {
    return this.containerElement ? ( /*#__PURE__*/createPortal(Children.only(this.props.children), this.containerElement)) : null;
  };
  InfoWindow.contextType = MapContext;
  return InfoWindow;
})(PureComponent);
var eventMap$b = {
  onClick: 'click',
  onDblClick: 'dblclick',
  onDrag: 'drag',
  onDragEnd: 'dragend',
  onDragStart: 'dragstart',
  onMouseDown: 'mousedown',
  onMouseMove: 'mousemove',
  onMouseOut: 'mouseout',
  onMouseOver: 'mouseover',
  onMouseUp: 'mouseup',
  onRightClick: 'rightclick'
};
var updaterMap$b = {
  draggable: function draggable(instance, _draggable2) {
    instance.setDraggable(_draggable2);
  },
  editable: function editable(instance, _editable) {
    instance.setEditable(_editable);
  },
  map: function map(instance, _map2) {
    instance.setMap(_map2);
  },
  options: function options(instance, _options7) {
    instance.setOptions(_options7);
  },
  path: function path(instance, _path) {
    instance.setPath(_path);
  },
  visible: function visible(instance, _visible3) {
    instance.setVisible(_visible3);
  }
};
/** @class */(function (_super) {
  __extends(Polyline, _super);
  function Polyline() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.state = {
      polyline: null
    };
    _this.setPolylineCallback = function () {
      if (_this.state.polyline !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.polyline);
      }
    };
    return _this;
  }
  Polyline.prototype.componentDidMount = function () {
    var polyline = new google.maps.Polyline(_assign(_assign({}, this.props.options || {}), {
      map: this.context
    }));
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$b,
      eventMap: eventMap$b,
      prevProps: {},
      nextProps: this.props,
      instance: polyline
    });
    this.setState(function setPolyline() {
      return {
        polyline: polyline
      };
    }, this.setPolylineCallback);
  };
  Polyline.prototype.componentDidUpdate = function (prevProps) {
    if (this.state.polyline !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$b,
        eventMap: eventMap$b,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.polyline
      });
    }
  };
  Polyline.prototype.componentWillUnmount = function () {
    if (this.state.polyline !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.polyline);
      }
      unregisterEvents(this.registeredEvents);
      this.state.polyline.setMap(null);
    }
  };
  Polyline.prototype.render = function () {
    return null;
  };
  Polyline.contextType = MapContext;
  return Polyline;
})(PureComponent);
var eventMap$a = {
  onClick: 'click',
  onDblClick: 'dblclick',
  onDrag: 'drag',
  onDragEnd: 'dragend',
  onDragStart: 'dragstart',
  onMouseDown: 'mousedown',
  onMouseMove: 'mousemove',
  onMouseOut: 'mouseout',
  onMouseOver: 'mouseover',
  onMouseUp: 'mouseup',
  onRightClick: 'rightclick'
};
var updaterMap$a = {
  draggable: function draggable(instance, _draggable3) {
    instance.setDraggable(_draggable3);
  },
  editable: function editable(instance, _editable2) {
    instance.setEditable(_editable2);
  },
  map: function map(instance, _map3) {
    instance.setMap(_map3);
  },
  options: function options(instance, _options8) {
    instance.setOptions(_options8);
  },
  path: function path(instance, _path2) {
    instance.setPath(_path2);
  },
  paths: function paths(instance, _paths) {
    instance.setPaths(_paths);
  },
  visible: function visible(instance, _visible4) {
    instance.setVisible(_visible4);
  }
};
/** @class */(function (_super) {
  __extends(Polygon, _super);
  function Polygon() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.state = {
      polygon: null
    };
    _this.setPolygonCallback = function () {
      if (_this.state.polygon !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.polygon);
      }
    };
    return _this;
  }
  Polygon.prototype.componentDidMount = function () {
    var polygon = new google.maps.Polygon(_assign(_assign({}, this.props.options || {}), {
      map: this.context
    }));
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$a,
      eventMap: eventMap$a,
      prevProps: {},
      nextProps: this.props,
      instance: polygon
    });
    this.setState(function setPolygon() {
      return {
        polygon: polygon
      };
    }, this.setPolygonCallback);
  };
  Polygon.prototype.componentDidUpdate = function (prevProps) {
    if (this.state.polygon !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$a,
        eventMap: eventMap$a,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.polygon
      });
    }
  };
  Polygon.prototype.componentWillUnmount = function () {
    if (this.state.polygon !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.polygon);
      }
      unregisterEvents(this.registeredEvents);
      this.state.polygon && this.state.polygon.setMap(null);
    }
  };
  Polygon.prototype.render = function () {
    return null;
  };
  Polygon.contextType = MapContext;
  return Polygon;
})(PureComponent);
var eventMap$9 = {
  onBoundsChanged: 'bounds_changed',
  onClick: 'click',
  onDblClick: 'dblclick',
  onDrag: 'drag',
  onDragEnd: 'dragend',
  onDragStart: 'dragstart',
  onMouseDown: 'mousedown',
  onMouseMove: 'mousemove',
  onMouseOut: 'mouseout',
  onMouseOver: 'mouseover',
  onMouseUp: 'mouseup',
  onRightClick: 'rightclick'
};
var updaterMap$9 = {
  bounds: function bounds(instance, _bounds) {
    instance.setBounds(_bounds);
  },
  draggable: function draggable(instance, _draggable4) {
    instance.setDraggable(_draggable4);
  },
  editable: function editable(instance, _editable3) {
    instance.setEditable(_editable3);
  },
  map: function map(instance, _map4) {
    instance.setMap(_map4);
  },
  options: function options(instance, _options9) {
    instance.setOptions(_options9);
  },
  visible: function visible(instance, _visible5) {
    instance.setVisible(_visible5);
  }
};
/** @class */(function (_super) {
  __extends(Rectangle, _super);
  function Rectangle() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.state = {
      rectangle: null
    };
    _this.setRectangleCallback = function () {
      if (_this.state.rectangle !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.rectangle);
      }
    };
    return _this;
  }
  Rectangle.prototype.componentDidMount = function () {
    var rectangle = new google.maps.Rectangle(_assign(_assign({}, this.props.options || {}), {
      map: this.context
    }));
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$9,
      eventMap: eventMap$9,
      prevProps: {},
      nextProps: this.props,
      instance: rectangle
    });
    this.setState(function setRectangle() {
      return {
        rectangle: rectangle
      };
    }, this.setRectangleCallback);
  };
  Rectangle.prototype.componentDidUpdate = function (prevProps) {
    if (this.state.rectangle !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$9,
        eventMap: eventMap$9,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.rectangle
      });
    }
  };
  Rectangle.prototype.componentWillUnmount = function () {
    if (this.state.rectangle !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.rectangle);
      }
      unregisterEvents(this.registeredEvents);
      this.state.rectangle.setMap(null);
    }
  };
  Rectangle.prototype.render = function () {
    return null;
  };
  Rectangle.contextType = MapContext;
  return Rectangle;
})(PureComponent);
var eventMap$8 = {
  onCenterChanged: 'center_changed',
  onRadiusChanged: 'radius_changed',
  onClick: 'click',
  onDblClick: 'dblclick',
  onDrag: 'drag',
  onDragEnd: 'dragend',
  onDragStart: 'dragstart',
  onMouseDown: 'mousedown',
  onMouseMove: 'mousemove',
  onMouseOut: 'mouseout',
  onMouseOver: 'mouseover',
  onMouseUp: 'mouseup',
  onRightClick: 'rightclick'
};
var updaterMap$8 = {
  center: function center(instance, _center2) {
    instance.setCenter(_center2);
  },
  draggable: function draggable(instance, _draggable5) {
    instance.setDraggable(_draggable5);
  },
  editable: function editable(instance, _editable4) {
    instance.setEditable(_editable4);
  },
  map: function map(instance, _map5) {
    instance.setMap(_map5);
  },
  options: function options(instance, _options10) {
    instance.setOptions(_options10);
  },
  radius: function radius(instance, _radius) {
    instance.setRadius(_radius);
  },
  visible: function visible(instance, _visible6) {
    instance.setVisible(_visible6);
  }
};
/** @class */(function (_super) {
  __extends(Circle, _super);
  function Circle() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.state = {
      circle: null
    };
    _this.setCircleCallback = function () {
      if (_this.state.circle !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.circle);
      }
    };
    return _this;
  }
  Circle.prototype.componentDidMount = function () {
    var circle = new google.maps.Circle(_assign(_assign({}, this.props.options || {}), {
      map: this.context
    }));
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$8,
      eventMap: eventMap$8,
      prevProps: {},
      nextProps: this.props,
      instance: circle
    });
    this.setState(function setCircle() {
      return {
        circle: circle
      };
    }, this.setCircleCallback);
  };
  Circle.prototype.componentDidUpdate = function (prevProps) {
    if (this.state.circle !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$8,
        eventMap: eventMap$8,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.circle
      });
    }
  };
  Circle.prototype.componentWillUnmount = function () {
    var _a;
    if (this.state.circle !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.circle);
      }
      unregisterEvents(this.registeredEvents);
      (_a = this.state.circle) === null || _a === void 0 ? void 0 : _a.setMap(null);
    }
  };
  Circle.prototype.render = function () {
    return null;
  };
  Circle.contextType = MapContext;
  return Circle;
})(PureComponent);
var eventMap$7 = {
  onClick: 'click',
  onDblClick: 'dblclick',
  onMouseDown: 'mousedown',
  onMouseOut: 'mouseout',
  onMouseOver: 'mouseover',
  onMouseUp: 'mouseup',
  onRightClick: 'rightclick',
  onAddFeature: 'addfeature',
  onRemoveFeature: 'removefeature',
  onRemoveProperty: 'removeproperty',
  onSetGeometry: 'setgeometry',
  onSetProperty: 'setproperty'
};
var updaterMap$7 = {
  add: function add(instance, feature) {
    instance.add(feature);
  },
  addgeojson: function addgeojson(instance, geojson, options) {
    instance.addGeoJson(geojson, options);
  },
  contains: function contains(instance, feature) {
    instance.contains(feature);
  },
  foreach: function foreach(instance, callback) {
    instance.forEach(callback);
  },
  loadgeojson: function loadgeojson(instance, url, options, callback) {
    instance.loadGeoJson(url, options, callback);
  },
  overridestyle: function overridestyle(instance, feature, style) {
    instance.overrideStyle(feature, style);
  },
  remove: function remove(instance, feature) {
    instance.remove(feature);
  },
  revertstyle: function revertstyle(instance, feature) {
    instance.revertStyle(feature);
  },
  controlposition: function controlposition(instance, controlPosition) {
    instance.setControlPosition(controlPosition);
  },
  controls: function controls(instance, _controls) {
    instance.setControls(_controls);
  },
  drawingmode: function drawingmode(instance, mode) {
    instance.setDrawingMode(mode);
  },
  map: function map(instance, _map6) {
    instance.setMap(_map6);
  },
  style: function style(instance, _style) {
    instance.setStyle(_style);
  },
  togeojson: function togeojson(instance, callback) {
    instance.toGeoJson(callback);
  }
};
/** @class */(function (_super) {
  __extends(Data, _super);
  function Data() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.state = {
      data: null
    };
    _this.setDataCallback = function () {
      if (_this.state.data !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.data);
      }
    };
    return _this;
  }
  Data.prototype.componentDidMount = function () {
    if (this.context !== null) {
      var data_1 = new google.maps.Data(_assign(_assign({}, this.props.options || {}), {
        map: this.context
      }));
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$7,
        eventMap: eventMap$7,
        prevProps: {},
        nextProps: this.props,
        instance: data_1
      });
      this.setState(function () {
        return {
          data: data_1
        };
      }, this.setDataCallback);
    }
  };
  Data.prototype.componentDidUpdate = function (prevProps) {
    if (this.state.data !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$7,
        eventMap: eventMap$7,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.data
      });
    }
  };
  Data.prototype.componentWillUnmount = function () {
    if (this.state.data !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.data);
      }
      unregisterEvents(this.registeredEvents);
      if (this.state.data) {
        this.state.data.setMap(null);
      }
    }
  };
  Data.prototype.render = function () {
    return null;
  };
  Data.contextType = MapContext;
  return Data;
})(PureComponent);
var eventMap$6 = {
  onClick: 'click',
  onDefaultViewportChanged: 'defaultviewport_changed',
  onStatusChanged: 'status_changed'
};
var updaterMap$6 = {
  options: function options(instance, _options11) {
    instance.setOptions(_options11);
  },
  url: function url(instance, _url) {
    instance.setUrl(_url);
  },
  zIndex: function zIndex(instance, _zIndex4) {
    instance.setZIndex(_zIndex4);
  }
};
/** @class */(function (_super) {
  __extends(KmlLayer, _super);
  function KmlLayer() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.state = {
      kmlLayer: null
    };
    _this.setKmlLayerCallback = function () {
      if (_this.state.kmlLayer !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.kmlLayer);
      }
    };
    return _this;
  }
  KmlLayer.prototype.componentDidMount = function () {
    var kmlLayer = new google.maps.KmlLayer(_assign(_assign({}, this.props.options), {
      map: this.context
    }));
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$6,
      eventMap: eventMap$6,
      prevProps: {},
      nextProps: this.props,
      instance: kmlLayer
    });
    this.setState(function setLmlLayer() {
      return {
        kmlLayer: kmlLayer
      };
    }, this.setKmlLayerCallback);
  };
  KmlLayer.prototype.componentDidUpdate = function (prevProps) {
    if (this.state.kmlLayer !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$6,
        eventMap: eventMap$6,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.kmlLayer
      });
    }
  };
  KmlLayer.prototype.componentWillUnmount = function () {
    if (this.state.kmlLayer !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.kmlLayer);
      }
      unregisterEvents(this.registeredEvents);
      this.state.kmlLayer.setMap(null);
    }
  };
  KmlLayer.prototype.render = function () {
    return null;
  };
  KmlLayer.contextType = MapContext;
  return KmlLayer;
})(PureComponent);
function getOffsetOverride(containerElement, getPixelPositionOffset) {
  return typeof getPixelPositionOffset === 'function' ? getPixelPositionOffset(containerElement.offsetWidth, containerElement.offsetHeight) : {
    x: 0,
    y: 0
  };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function createLatLng(inst, Type) {
  return new Type(inst.lat, inst.lng);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function createLatLngBounds(inst, Type) {
  return new Type(new google.maps.LatLng(inst.ne.lat, inst.ne.lng), new google.maps.LatLng(inst.sw.lat, inst.sw.lng));
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function ensureOfType(inst,
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type,
// eslint-disable-next-line @typescript-eslint/no-explicit-any
factory
// eslint-disable-next-line @typescript-eslint/no-explicit-any
) {
  return inst instanceof type ? inst : factory(inst, type);
}
function ensureOfTypeBounds(inst,
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type,
// eslint-disable-next-line @typescript-eslint/no-explicit-any
factory
// eslint-disable-next-line @typescript-eslint/no-explicit-any
) {
  return inst instanceof type ? inst : factory(inst, type);
}
function getLayoutStylesByBounds(mapCanvasProjection, offset, bounds) {
  var ne = mapCanvasProjection && mapCanvasProjection.fromLatLngToDivPixel(bounds.getNorthEast());
  var sw = mapCanvasProjection && mapCanvasProjection.fromLatLngToDivPixel(bounds.getSouthWest());
  if (ne && sw) {
    return {
      left: "".concat(sw.x + offset.x, "px"),
      top: "".concat(ne.y + offset.y, "px"),
      width: "".concat(ne.x - sw.x - offset.x, "px"),
      height: "".concat(sw.y - ne.y - offset.y, "px")
    };
  }
  return {
    left: '-9999px',
    top: '-9999px'
  };
}
function getLayoutStylesByPosition(mapCanvasProjection, offset, position) {
  var point = mapCanvasProjection && mapCanvasProjection.fromLatLngToDivPixel(position);
  if (point) {
    var x = point.x,
      y = point.y;
    return {
      left: "".concat(x + offset.x, "px"),
      top: "".concat(y + offset.y, "px")
    };
  }
  return {
    left: '-9999px',
    top: '-9999px'
  };
}
function getLayoutStyles(mapCanvasProjection, offset, bounds, position) {
  return bounds !== undefined ? getLayoutStylesByBounds(mapCanvasProjection, offset, ensureOfTypeBounds(bounds, google.maps.LatLngBounds, createLatLngBounds)) : getLayoutStylesByPosition(mapCanvasProjection, offset, ensureOfType(position, google.maps.LatLng, createLatLng));
}
function arePositionsEqual(currentPosition, previousPosition) {
  return currentPosition.left === previousPosition.left && currentPosition.top === previousPosition.top && currentPosition.width === previousPosition.height && currentPosition.height === previousPosition.height;
}
function convertToLatLngString(latLngLike) {
  if (!latLngLike) {
    return '';
  }
  var latLng = latLngLike instanceof google.maps.LatLng ? latLngLike : new google.maps.LatLng(latLngLike.lat, latLngLike.lng);
  return latLng + '';
}
function convertToLatLngBoundsString(latLngBoundsLike) {
  if (!latLngBoundsLike) {
    return '';
  }
  var latLngBounds = latLngBoundsLike instanceof google.maps.LatLngBounds ? latLngBoundsLike : new google.maps.LatLngBounds(new google.maps.LatLng(latLngBoundsLike.south, latLngBoundsLike.east), new google.maps.LatLng(latLngBoundsLike.north, latLngBoundsLike.west));
  return latLngBounds + '';
}
/** @class */(function (_super) {
  __extends(OverlayView, _super);
  function OverlayView(props) {
    var _this = _super.call(this, props) || this;
    _this.state = {
      paneEl: null,
      containerStyle: {
        // set initial position
        position: 'absolute'
      }
    };
    _this.updatePane = function () {
      var mapPaneName = _this.props.mapPaneName;
      // https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapPanes
      var mapPanes = _this.overlayView.getPanes();
      invariant$1$1(!!mapPaneName, "OverlayView requires props.mapPaneName but got %s", mapPaneName);
      if (mapPanes) {
        _this.setState({
          paneEl: mapPanes[mapPaneName]
        });
      } else {
        _this.setState({
          paneEl: null
        });
      }
    };
    _this.onAdd = function () {
      var _a, _b;
      _this.updatePane();
      (_b = (_a = _this.props).onLoad) === null || _b === void 0 ? void 0 : _b.call(_a, _this.overlayView);
    };
    _this.onPositionElement = function () {
      var mapCanvasProjection = _this.overlayView.getProjection();
      var offset = _assign({
        x: 0,
        y: 0
      }, _this.containerRef.current ? getOffsetOverride(_this.containerRef.current, _this.props.getPixelPositionOffset) : {});
      var layoutStyles = getLayoutStyles(mapCanvasProjection, offset, _this.props.bounds, _this.props.position);
      var _a = _this.state.containerStyle,
        left = _a.left,
        top = _a.top,
        width = _a.width,
        height = _a.height;
      if (!arePositionsEqual(layoutStyles, {
        left: left,
        top: top,
        width: width,
        height: height
      })) {
        _this.setState({
          containerStyle: {
            top: layoutStyles.top || 0,
            left: layoutStyles.left || 0,
            width: layoutStyles.width || 0,
            height: layoutStyles.height || 0,
            position: 'absolute'
          }
        });
      }
    };
    _this.draw = function () {
      _this.onPositionElement();
    };
    _this.onRemove = function () {
      var _a, _b;
      _this.setState(function () {
        return {
          paneEl: null
        };
      });
      (_b = (_a = _this.props).onUnmount) === null || _b === void 0 ? void 0 : _b.call(_a, _this.overlayView);
    };
    _this.containerRef = /*#__PURE__*/createRef();
    // You must implement three methods: onAdd(), draw(), and onRemove().
    var overlayView = new google.maps.OverlayView();
    overlayView.onAdd = _this.onAdd;
    overlayView.draw = _this.draw;
    overlayView.onRemove = _this.onRemove;
    _this.overlayView = overlayView;
    return _this;
  }
  OverlayView.prototype.componentDidMount = function () {
    this.overlayView.setMap(this.context);
  };
  OverlayView.prototype.componentDidUpdate = function (prevProps) {
    var prevPositionString = convertToLatLngString(prevProps.position);
    var positionString = convertToLatLngString(this.props.position);
    var prevBoundsString = convertToLatLngBoundsString(prevProps.bounds);
    var boundsString = convertToLatLngBoundsString(this.props.bounds);
    if (prevPositionString !== positionString || prevBoundsString !== boundsString) {
      this.overlayView.draw();
    }
    if (prevProps.mapPaneName !== this.props.mapPaneName) {
      this.updatePane();
    }
  };
  OverlayView.prototype.componentWillUnmount = function () {
    this.overlayView.setMap(null);
  };
  OverlayView.prototype.render = function () {
    var paneEl = this.state.paneEl;
    if (paneEl) {
      return /*#__PURE__*/ReactDOM.createPortal(jsx("div", {
        ref: this.containerRef,
        style: this.state.containerStyle,
        children: Children.only(this.props.children)
      }), paneEl);
    } else {
      return null;
    }
  };
  OverlayView.FLOAT_PANE = "floatPane";
  OverlayView.MAP_PANE = "mapPane";
  OverlayView.MARKER_LAYER = "markerLayer";
  OverlayView.OVERLAY_LAYER = "overlayLayer";
  OverlayView.OVERLAY_MOUSE_TARGET = "overlayMouseTarget";
  OverlayView.contextType = MapContext;
  return OverlayView;
})(PureComponent);
function noop() {
  return;
}
var eventMap$5 = {
  onDblClick: 'dblclick',
  onClick: 'click'
};
var updaterMap$5 = {
  opacity: function opacity(instance, _opacity2) {
    instance.setOpacity(_opacity2);
  }
};
/** @class */(function (_super) {
  __extends(GroundOverlay, _super);
  function GroundOverlay() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.state = {
      groundOverlay: null
    };
    _this.setGroundOverlayCallback = function () {
      if (_this.state.groundOverlay !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.groundOverlay);
      }
    };
    return _this;
  }
  GroundOverlay.prototype.componentDidMount = function () {
    invariant$1$1(!!this.props.url || !!this.props.bounds, "For GroundOverlay, url and bounds are passed in to constructor and are immutable after instantiated. This is the behavior of Google Maps JavaScript API v3 ( See https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay) Hence, use the corresponding two props provided by `react-google-maps-api`, url and bounds. In some cases, you'll need the GroundOverlay component to reflect the changes of url and bounds. You can leverage the React's key property to remount the component. Typically, just `key={url}` would serve your need. See https://github.com/tomchentw/react-google-maps/issues/655");
    var groundOverlay = new google.maps.GroundOverlay(this.props.url, this.props.bounds, _assign(_assign({}, this.props.options), {
      map: this.context
    }));
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$5,
      eventMap: eventMap$5,
      prevProps: {},
      nextProps: this.props,
      instance: groundOverlay
    });
    this.setState(function setGroundOverlay() {
      return {
        groundOverlay: groundOverlay
      };
    }, this.setGroundOverlayCallback);
  };
  GroundOverlay.prototype.componentDidUpdate = function (prevProps) {
    if (this.state.groundOverlay !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$5,
        eventMap: eventMap$5,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.groundOverlay
      });
    }
  };
  GroundOverlay.prototype.componentWillUnmount = function () {
    if (this.state.groundOverlay) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.groundOverlay);
      }
      this.state.groundOverlay.setMap(null);
    }
  };
  GroundOverlay.prototype.render = function () {
    return null;
  };
  GroundOverlay.defaultProps = {
    onLoad: noop
  };
  GroundOverlay.contextType = MapContext;
  return GroundOverlay;
})(PureComponent);
var eventMap$4 = {};
var updaterMap$4 = {
  data: function data(instance, _data) {
    instance.setData(_data);
  },
  map: function map(instance, _map7) {
    instance.setMap(_map7);
  },
  options: function options(instance, _options12) {
    instance.setOptions(_options12);
  }
};
/** @class */(function (_super) {
  __extends(HeatmapLayer, _super);
  function HeatmapLayer() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.state = {
      heatmapLayer: null
    };
    _this.setHeatmapLayerCallback = function () {
      if (_this.state.heatmapLayer !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.heatmapLayer);
      }
    };
    return _this;
  }
  HeatmapLayer.prototype.componentDidMount = function () {
    invariant$1$1(!!google.maps.visualization, 'Did you include prop libraries={["visualization"]} to <LoadScript />? %s', google.maps.visualization);
    invariant$1$1(!!this.props.data, 'data property is required in HeatmapLayer %s', this.props.data);
    var heatmapLayer = new google.maps.visualization.HeatmapLayer(_assign(_assign({}, this.props.options || {}), {
      data: this.props.data,
      map: this.context
    }));
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$4,
      eventMap: eventMap$4,
      prevProps: {},
      nextProps: this.props,
      instance: heatmapLayer
    });
    this.setState(function setHeatmapLayer() {
      return {
        heatmapLayer: heatmapLayer
      };
    }, this.setHeatmapLayerCallback);
  };
  HeatmapLayer.prototype.componentDidUpdate = function (prevProps) {
    unregisterEvents(this.registeredEvents);
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$4,
      eventMap: eventMap$4,
      prevProps: prevProps,
      nextProps: this.props,
      instance: this.state.heatmapLayer
    });
  };
  HeatmapLayer.prototype.componentWillUnmount = function () {
    if (this.state.heatmapLayer !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.heatmapLayer);
      }
      unregisterEvents(this.registeredEvents);
      this.state.heatmapLayer.setMap(null);
    }
  };
  HeatmapLayer.prototype.render = function () {
    return null;
  };
  HeatmapLayer.contextType = MapContext;
  return HeatmapLayer;
})(PureComponent);
var eventMap$3 = {
  onCloseClick: 'closeclick',
  onPanoChanged: 'pano_changed',
  onPositionChanged: 'position_changed',
  onPovChanged: 'pov_changed',
  onResize: 'resize',
  onStatusChanged: 'status_changed',
  onVisibleChanged: 'visible_changed',
  onZoomChanged: 'zoom_changed'
};
var updaterMap$3 = {
  register: function register(instance, provider, options) {
    instance.registerPanoProvider(provider, options);
  },
  links: function links(instance, _links) {
    instance.setLinks(_links);
  },
  motionTracking: function motionTracking(instance, _motionTracking) {
    instance.setMotionTracking(_motionTracking);
  },
  options: function options(instance, _options13) {
    instance.setOptions(_options13);
  },
  pano: function pano(instance, _pano) {
    instance.setPano(_pano);
  },
  position: function position(instance, _position4) {
    instance.setPosition(_position4);
  },
  pov: function pov(instance, _pov) {
    instance.setPov(_pov);
  },
  visible: function visible(instance, _visible7) {
    instance.setVisible(_visible7);
  },
  zoom: function zoom(instance, _zoom2) {
    instance.setZoom(_zoom2);
  }
};
/** @class */(function (_super) {
  __extends(StreetViewPanorama, _super);
  function StreetViewPanorama() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.state = {
      streetViewPanorama: null
    };
    _this.setStreetViewPanoramaCallback = function () {
      if (_this.state.streetViewPanorama !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.streetViewPanorama);
      }
    };
    return _this;
  }
  StreetViewPanorama.prototype.componentDidMount = function () {
    var _a, _b;
    var streetViewPanorama = (_b = (_a = this.context) === null || _a === void 0 ? void 0 : _a.getStreetView()) !== null && _b !== void 0 ? _b : null;
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$3,
      eventMap: eventMap$3,
      prevProps: {},
      nextProps: this.props,
      instance: streetViewPanorama
    });
    this.setState(function () {
      return {
        streetViewPanorama: streetViewPanorama
      };
    }, this.setStreetViewPanoramaCallback);
  };
  StreetViewPanorama.prototype.componentDidUpdate = function (prevProps) {
    if (this.state.streetViewPanorama !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$3,
        eventMap: eventMap$3,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.streetViewPanorama
      });
    }
  };
  StreetViewPanorama.prototype.componentWillUnmount = function () {
    if (this.state.streetViewPanorama !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.streetViewPanorama);
      }
      unregisterEvents(this.registeredEvents);
      this.state.streetViewPanorama.setVisible(false);
    }
  };
  StreetViewPanorama.prototype.render = function () {
    return null;
  };
  StreetViewPanorama.contextType = MapContext;
  return StreetViewPanorama;
})(PureComponent);
/** @class */(function (_super) {
  __extends(StreetViewService, _super);
  function StreetViewService() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      streetViewService: null
    };
    _this.setStreetViewServiceCallback = function () {
      if (_this.state.streetViewService !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.streetViewService);
      }
    };
    return _this;
  }
  StreetViewService.prototype.componentDidMount = function () {
    var streetViewService = new google.maps.StreetViewService();
    this.setState(function setStreetViewService() {
      return {
        streetViewService: streetViewService
      };
    }, this.setStreetViewServiceCallback);
  };
  StreetViewService.prototype.componentWillUnmount = function () {
    if (this.state.streetViewService !== null && this.props.onUnmount) {
      this.props.onUnmount(this.state.streetViewService);
    }
  };
  StreetViewService.prototype.render = function () {
    return null;
  };
  StreetViewService.contextType = MapContext;
  return StreetViewService;
})(PureComponent);
/** @class */(function (_super) {
  __extends(DirectionsService, _super);
  function DirectionsService() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      directionsService: null
    };
    _this.setDirectionsServiceCallback = function () {
      if (_this.state.directionsService !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.directionsService);
      }
    };
    return _this;
  }
  DirectionsService.prototype.componentDidMount = function () {
    invariant$1$1(!!this.props.options, 'DirectionsService expected options object as parameter, but got %s', this.props.options);
    var directionsService = new google.maps.DirectionsService();
    this.setState(function setDirectionsService() {
      return {
        directionsService: directionsService
      };
    }, this.setDirectionsServiceCallback);
  };
  DirectionsService.prototype.componentDidUpdate = function () {
    if (this.state.directionsService !== null) {
      this.state.directionsService.route(this.props.options, this.props.callback);
    }
  };
  DirectionsService.prototype.componentWillUnmount = function () {
    if (this.state.directionsService !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.directionsService);
      }
    }
  };
  DirectionsService.prototype.render = function () {
    return null;
  };
  return DirectionsService;
})(PureComponent);
var eventMap$2 = {
  onDirectionsChanged: 'directions_changed'
};
var updaterMap$2 = {
  directions: function directions(instance, _directions) {
    instance.setDirections(_directions);
  },
  map: function map(instance, _map8) {
    instance.setMap(_map8);
  },
  options: function options(instance, _options14) {
    instance.setOptions(_options14);
  },
  panel: function panel(instance, _panel) {
    instance.setPanel(_panel);
  },
  routeIndex: function routeIndex(instance, _routeIndex) {
    instance.setRouteIndex(_routeIndex);
  }
};
/** @class */(function (_super) {
  __extends(DirectionsRenderer, _super);
  function DirectionsRenderer() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.state = {
      directionsRenderer: null
    };
    _this.setDirectionsRendererCallback = function () {
      if (_this.state.directionsRenderer !== null) {
        _this.state.directionsRenderer.setMap(_this.context);
        if (_this.props.onLoad) {
          _this.props.onLoad(_this.state.directionsRenderer);
        }
      }
    };
    return _this;
  }
  DirectionsRenderer.prototype.componentDidMount = function () {
    var directionsRenderer = new google.maps.DirectionsRenderer(this.props.options);
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$2,
      eventMap: eventMap$2,
      prevProps: {},
      nextProps: this.props,
      instance: directionsRenderer
    });
    this.setState(function setDirectionsRenderer() {
      return {
        directionsRenderer: directionsRenderer
      };
    }, this.setDirectionsRendererCallback);
  };
  DirectionsRenderer.prototype.componentDidUpdate = function (prevProps) {
    if (this.state.directionsRenderer !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$2,
        eventMap: eventMap$2,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.directionsRenderer
      });
    }
  };
  DirectionsRenderer.prototype.componentWillUnmount = function () {
    if (this.state.directionsRenderer !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.directionsRenderer);
      }
      unregisterEvents(this.registeredEvents);
      if (this.state.directionsRenderer) {
        this.state.directionsRenderer.setMap(null);
      }
    }
  };
  DirectionsRenderer.prototype.render = function () {
    return jsx(Fragment$1, {});
  };
  DirectionsRenderer.contextType = MapContext;
  return DirectionsRenderer;
})(PureComponent);
/** @class */(function (_super) {
  __extends(DistanceMatrixService, _super);
  function DistanceMatrixService() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      distanceMatrixService: null
    };
    _this.setDistanceMatrixServiceCallback = function () {
      if (_this.state.distanceMatrixService !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.distanceMatrixService);
      }
    };
    return _this;
  }
  DistanceMatrixService.prototype.componentDidMount = function () {
    invariant$1$1(!!this.props.options, 'DistanceMatrixService expected options object as parameter, but go %s', this.props.options);
    var distanceMatrixService = new google.maps.DistanceMatrixService();
    this.setState(function setDistanceMatrixService() {
      return {
        distanceMatrixService: distanceMatrixService
      };
    }, this.setDistanceMatrixServiceCallback);
  };
  DistanceMatrixService.prototype.componentDidUpdate = function () {
    if (this.state.distanceMatrixService !== null) {
      this.state.distanceMatrixService.getDistanceMatrix(this.props.options, this.props.callback);
    }
  };
  DistanceMatrixService.prototype.componentWillUnmount = function () {
    if (this.state.distanceMatrixService !== null && this.props.onUnmount) {
      this.props.onUnmount(this.state.distanceMatrixService);
    }
  };
  DistanceMatrixService.prototype.render = function () {
    return null;
  };
  return DistanceMatrixService;
})(PureComponent);
var eventMap$1 = {
  onPlacesChanged: 'places_changed'
};
var updaterMap$1 = {
  bounds: function bounds(instance, _bounds2) {
    instance.setBounds(_bounds2);
  }
};
/** @class */(function (_super) {
  __extends(StandaloneSearchBox, _super);
  function StandaloneSearchBox() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.containerElement = /*#__PURE__*/createRef();
    _this.state = {
      searchBox: null
    };
    _this.setSearchBoxCallback = function () {
      if (_this.state.searchBox !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.searchBox);
      }
    };
    return _this;
  }
  StandaloneSearchBox.prototype.componentDidMount = function () {
    invariant$1$1(!!google.maps.places, 'You need to provide libraries={["places"]} prop to <LoadScript /> component %s', google.maps.places);
    if (this.containerElement !== null && this.containerElement.current !== null) {
      var input = this.containerElement.current.querySelector('input');
      if (input !== null) {
        var searchBox_1 = new google.maps.places.SearchBox(input, this.props.options);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$1,
          eventMap: eventMap$1,
          prevProps: {},
          nextProps: this.props,
          instance: searchBox_1
        });
        this.setState(function setSearchBox() {
          return {
            searchBox: searchBox_1
          };
        }, this.setSearchBoxCallback);
      }
    }
  };
  StandaloneSearchBox.prototype.componentDidUpdate = function (prevProps) {
    if (this.state.searchBox !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$1,
        eventMap: eventMap$1,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.searchBox
      });
    }
  };
  StandaloneSearchBox.prototype.componentWillUnmount = function () {
    if (this.state.searchBox !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.searchBox);
      }
      unregisterEvents(this.registeredEvents);
    }
  };
  StandaloneSearchBox.prototype.render = function () {
    return jsx("div", {
      ref: this.containerElement,
      children: Children.only(this.props.children)
    });
  };
  StandaloneSearchBox.contextType = MapContext;
  return StandaloneSearchBox;
})(PureComponent);
var eventMap = {
  onPlaceChanged: 'place_changed'
};
var updaterMap = {
  bounds: function bounds(instance, _bounds3) {
    instance.setBounds(_bounds3);
  },
  restrictions: function restrictions(instance, _restrictions) {
    instance.setComponentRestrictions(_restrictions);
  },
  fields: function fields(instance, _fields) {
    instance.setFields(_fields);
  },
  options: function options(instance, _options15) {
    instance.setOptions(_options15);
  },
  types: function types(instance, _types) {
    instance.setTypes(_types);
  }
};
/** @class */(function (_super) {
  __extends(Autocomplete, _super);
  function Autocomplete() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.containerElement = /*#__PURE__*/createRef();
    _this.state = {
      autocomplete: null
    };
    _this.setAutocompleteCallback = function () {
      if (_this.state.autocomplete !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.autocomplete);
      }
    };
    return _this;
  }
  Autocomplete.prototype.componentDidMount = function () {
    var _a;
    invariant$1$1(!!google.maps.places, 'You need to provide libraries={["places"]} prop to <LoadScript /> component %s', google.maps.places);
    // TODO: why current could be equal null?
    var input = (_a = this.containerElement.current) === null || _a === void 0 ? void 0 : _a.querySelector('input');
    if (input) {
      var autocomplete_1 = new google.maps.places.Autocomplete(input, this.props.options);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap,
        eventMap: eventMap,
        prevProps: {},
        nextProps: this.props,
        instance: autocomplete_1
      });
      this.setState(function () {
        return {
          autocomplete: autocomplete_1
        };
      }, this.setAutocompleteCallback);
    }
  };
  Autocomplete.prototype.componentDidUpdate = function (prevProps) {
    unregisterEvents(this.registeredEvents);
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap,
      eventMap: eventMap,
      prevProps: prevProps,
      nextProps: this.props,
      instance: this.state.autocomplete
    });
  };
  Autocomplete.prototype.componentWillUnmount = function () {
    if (this.state.autocomplete !== null) {
      unregisterEvents(this.registeredEvents);
    }
  };
  Autocomplete.prototype.render = function () {
    return jsx("div", {
      ref: this.containerElement,
      className: this.props.className,
      children: Children.only(this.props.children)
    });
  };
  Autocomplete.defaultProps = {
    className: ''
  };
  Autocomplete.contextType = MapContext;
  return Autocomplete;
})(PureComponent);

var _templateObject$o;
var StyledGoogleMap = styled.div(_templateObject$o || (_templateObject$o = _taggedTemplateLiteral(["\n  .loadingElement {\n    height: 100%;\n  }\n\n  .containerElement {\n    width: 100%;\n    height: 195px;\n  }\n"])));

var _excluded$h = ["lat", "lng", "apiKey"];
var MapGoogle = function MapGoogle(_ref) {
  var lat = _ref.lat,
    lng = _ref.lng,
    apiKey = _ref.apiKey,
    props = _objectWithoutProperties(_ref, _excluded$h);
  var center = {
    lat: lat,
    lng: lng
  };
  var loadingElement = /*#__PURE__*/React__default.createElement("div", {
    className: "loadingElement"
  });
  return /*#__PURE__*/React__default.createElement(StyledGoogleMap, _extends$3({
    "data-testid": "google-map"
  }, props), /*#__PURE__*/React__default.createElement(LoadScript, {
    googleMapsApiKey: apiKey,
    loadingElement: loadingElement
  }, /*#__PURE__*/React__default.createElement(GoogleMap, {
    mapContainerClassName: "containerElement",
    center: center,
    zoom: 17
  }, /*#__PURE__*/React__default.createElement(Marker, {
    position: center
  }))));
};
MapGoogle.propTypes = {
  /**
   * Latitud: number between -90 to 90
   */
  lat: PropTypes.number.isRequired,
  /**
   * Longitude: number between -180 to 180
   */
  lng: PropTypes.number.isRequired,
  /**
   * Api Key given by google
   */
  apiKey: PropTypes.string.isRequired
};

var _templateObject$n;
var MobileStep$1 = styled.div(_templateObject$n || (_templateObject$n = _taggedTemplateLiteral(["\n  flex: 1;\n  flex-direction: column;\n  justify-content: space-between;\n\n  background-color: ", ";\n  display: flex;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.background.hbBackgroundA;
});

var _excluded$g = ["children"];
var MobileStep = function MobileStep(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$g);
  return /*#__PURE__*/React__default.createElement(MobileStep$1, props, children);
};
MobileStep.propTypes = {
  /**
   * The content of the component
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired
};

var _templateObject$m;
var MobileStepActions = styled.div(_templateObject$m || (_templateObject$m = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  position: fixed;\n\n  left: 0;\n  bottom: 0;\n  background: ", ";\n  box-sizing: border-box;\n  padding: ", ";\n  width: 100%;\n\n  & * {\n    box-sizing: border-box;\n  }\n\n  & > * {\n    width: calc((100% - ", ") / 2);\n  }\n\n  @media ", " {\n    justify-content: center;\n\n    & > * {\n      width: auto;\n\n      &:not(:first-child) {\n        margin-left: ", ";\n      }\n    }\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.background.hbBackgroundA;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.spacing(2);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.spacing(2);
}, device.tablet, function (_ref4) {
  var theme = _ref4.theme;
  return theme.spacing(2);
});

var _templateObject$l;
var StyledMobileStepContent = styled.div(_templateObject$l || (_templateObject$l = _taggedTemplateLiteral(["\n  padding: 0;\n  flex: 1;\n"])));

var _excluded$f = ["children"];
var MobileStepContent = function MobileStepContent(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$f);
  return /*#__PURE__*/React__default.createElement(StyledMobileStepContent, props, children);
};
MobileStepContent.propTypes = {
  /**
   * The content of the component
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired
};

var _templateObject$k, _templateObject2$b;
var StyledMobileStepHeader = styled.div(_templateObject$k || (_templateObject$k = _taggedTemplateLiteral(["\n  padding: 0;\n"])));
var StyledStepTitle$1 = styled.h3(_templateObject2$b || (_templateObject2$b = _taggedTemplateLiteral(["\n  ", "\n\n  display: block;\n  margin: 0;\n  padding: 0;\n  text-align: ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.typography.heading(3);
}, function (_ref2) {
  var titleAlignment = _ref2.titleAlignment;
  return titleAlignment;
});

var _excluded$e = ["children", "titleText", "titleAlignment", "titleElement"];
var ALIGNMENTS$1 = ['left', 'center', 'right'];
var MobileStepHeader = function MobileStepHeader(props) {
  var children = props.children,
    titleText = props.titleText,
    titleAlignment = props.titleAlignment,
    titleElement = props.titleElement,
    restProps = _objectWithoutProperties(props, _excluded$e);
  return /*#__PURE__*/React__default.createElement(StyledMobileStepHeader, _extends$3({}, restProps, {
    "data-testid": "step-header"
  }), /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: Boolean(titleText)
  }, /*#__PURE__*/React__default.createElement(StyledStepTitle$1, {
    titleAlignment: titleAlignment,
    as: titleElement,
    "data-testid": "step-header-title"
  }, titleText)), children);
};
MobileStepHeader.propTypes = {
  /**
   * The content of the component
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  /**
   * The title of the step
   */
  titleText: PropTypes.string,
  /**
   * Set title alignment
   */
  titleAlignment: PropTypes.oneOf(ALIGNMENTS$1),
  /**
   * The html element that would be used in the title
   */
  titleElement: PropTypes.string
};
MobileStepHeader.defaultProps = {
  titleText: '',
  children: null,
  titleAlignment: 'left',
  titleElement: 'h2'
};

var _templateObject$j;
var StyledMobileStepper = styled.div(_templateObject$j || (_templateObject$j = _taggedTemplateLiteral(["\n  display: flex;\n\n  background-color: ", ";\n  border-radius: ", ";\n  box-sizing: border-box;\n  padding: ", ";\n  width: 100%;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.background.hbBackgroundA;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.borderRadius();
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.spacing(2);
});

var _excluded$d = ["children"];
var MobileStepper = function MobileStepper(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$d);
  return /*#__PURE__*/React__default.createElement(StyledMobileStepper, props, children);
};
MobileStepper.propTypes = {
  /**
   * The content of the component
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired
};

var _templateObject$i;
var MobileStepperIndicator$1 = styled.div(_templateObject$i || (_templateObject$i = _taggedTemplateLiteral(["\n  ", ";\n\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.typography.font();
}, function (_ref2) {
  var theme = _ref2.theme;
  return "".concat(theme.palette.alternative1.darker);
});

var _excluded$c = ["activeStepIndex", "numberOfSteps"];
var MobileStepperIndicator = function MobileStepperIndicator(_ref) {
  var activeStepIndex = _ref.activeStepIndex,
    numberOfSteps = _ref.numberOfSteps,
    props = _objectWithoutProperties(_ref, _excluded$c);
  var stepNumber = activeStepIndex + 1;
  return /*#__PURE__*/React__default.createElement(MobileStepperIndicator$1, _extends$3({}, props, {
    "data-testid": "stepper-indicator"
  }), "Paso ".concat(stepNumber, " de ").concat(numberOfSteps));
};
MobileStepperIndicator.defaultProps = {
  activeStepIndex: 0,
  numberOfSteps: 0
};
MobileStepperIndicator.propTypes = {
  /**
   * Index of step being displayed
   */
  activeStepIndex: PropTypes.number,
  /**
   * Total number of steps
   */
  numberOfSteps: PropTypes.number
};

var getFocusableElements = function getFocusableElements(container) {
  var isNotDisableOrHidden = function isNotDisableOrHidden(element) {
    return !element.hasAttribute('disabled') && !element.getAttribute('aria-hidden');
  };
  var FOCUSABLE_ELEMENTS = ['[tabindex]:not([tabindex="-1"])', 'a[href]', 'button', 'details', 'input', 'select', 'textarea'];
  return Array.from(container.querySelectorAll(FOCUSABLE_ELEMENTS)).filter(isNotDisableOrHidden);
};
var nextFocusableElement = function nextFocusableElement(container, backwards) {
  var focusableElements = getFocusableElements(container);
  var firstElement = focusableElements.at(0);
  var lastElement = focusableElements.at(-1);
  if (backwards && document.activeElement === firstElement) {
    return lastElement;
  }
  if (!backwards && document.activeElement === lastElement) {
    return firstElement;
  }
  return null;
};
var focusFirstElement = function focusFirstElement(container) {
  var firstFocusableElement = getFocusableElements(container)[0];
  firstFocusableElement === null || firstFocusableElement === void 0 || firstFocusableElement.focus();
};
var FocusKeeper = function FocusKeeper(_ref) {
  var children = _ref.children,
    onEscape = _ref.onEscape;
  var wrapper = useRef();
  var handleTab = function handleTab(event) {
    var backwards = event.shiftKey;
    var nextFocus = nextFocusableElement(wrapper.current, backwards);
    if (nextFocus) {
      event.preventDefault();
      nextFocus.focus();
    }
  };

  // eslint-disable-next-line consistent-return
  var keyDownHandler = function keyDownHandler(event) {
    var key = event.key,
      keyCode = event.keyCode;
    var isEscapePressed = key === 'Escape' || keyCode === 27;
    var isTabPressed = key === 'Tab' || keyCode === 9;
    if (isTabPressed) {
      return handleTab(event);
    }
    if (isEscapePressed) {
      return onEscape();
    }
  };
  useEffect(function () {
    if (wrapper.current) {
      focusFirstElement(wrapper.current);
    }
  }, []);
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/cloneElement(children, {
    onKeyDown: keyDownHandler,
    ref: wrapper
  }));
};
FocusKeeper.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
  onEscape: PropTypes.func
};
FocusKeeper.defaultProps = {
  onEscape: null
};

var _templateObject$h, _templateObject2$a, _templateObject3$9, _templateObject4$8, _templateObject5$6, _templateObject6$3, _templateObject7$2, _templateObject8$2;
var AVAILABLE_SIZES = {
  sm: 32,
  // 16rem
  md: 48,
  // 24rem
  lg: 72,
  // 36rem
  xl: 96 // 48rem
};
var fadeInAnimation = keyframes(_templateObject$h || (_templateObject$h = _taggedTemplateLiteral(["\n  from { opacity: 0; }\n  to { opacity: 1; }\n"])));
var fadeOutAnimation = keyframes(_templateObject2$a || (_templateObject2$a = _taggedTemplateLiteral(["\n  from { opacity: 1; }\n  to { opacity: 0; }\n"])));
var scaleInAnimation = keyframes(_templateObject3$9 || (_templateObject3$9 = _taggedTemplateLiteral(["\n  from { scale: 0.25; }\n  to { scale: 1; }\n"])));
var Backdrop = styled.div(_templateObject4$8 || (_templateObject4$8 = _taggedTemplateLiteral(["\n  align-items: center;\n  animation: 300ms ", ";\n  background-color: rgba(", ", 0.5);\n  display: flex;\n  inset: 0;\n  justify-content: center;\n  min-height: 100vh;\n  padding: ", ";\n  position: fixed;\n  z-index: ", ";\n"])), function (_ref) {
  var isClosing = _ref.isClosing;
  return isClosing ? fadeOutAnimation : fadeInAnimation;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.getRgbColor(theme.palette.grayJ);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.spacing(2);
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.zIndex.modal;
});
var ModalWrapper = styled.div(_templateObject5$6 || (_templateObject5$6 = _taggedTemplateLiteral(["\n  animation: 300ms ", ";\n  height: auto;\n  max-height: 90vh;\n  overflow-y: scroll;\n  position: relative;\n  transition: all 300ms ease;\n  width: auto;\n\n  ", ";\n\n  ::-webkit-scrollbar {\n    display: none;\n  }\n"])), scaleInAnimation, function (_ref5) {
  var theme = _ref5.theme,
    size = _ref5.size;
  return css(_templateObject6$3 || (_templateObject6$3 = _taggedTemplateLiteral(["\n    ", ";\n\n    background-color: ", ";\n    border-radius: ", ";\n    box-shadow: ", "\n      rgba(", ", 0.1);\n    max-width: ", ";\n    min-height: ", ";\n    padding: ", ";\n  "])), theme.typography.font(), theme.palette.white, theme.borderRadius(3), "0 ".concat(theme.spacing(1), " ").concat(theme.spacing(4), " ").concat(theme.spacing(1)), theme.getRgbColor(theme.palette.grayJ), theme.spacing(AVAILABLE_SIZES[size]), theme.spacing(10), theme.spacing(3));
});
var CloseButton = styled.button(_templateObject7$2 || (_templateObject7$2 = _taggedTemplateLiteral(["\n  align-items: center;\n  aspect-ratio: 1;\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  height: ", ";\n  justify-content: center;\n  position: absolute;\n  right: ", ";\n  top: ", ";\n  transition: all 300ms ease;\n  width: ", ";\n\n  &:hover {\n    transform: scale(1.1);\n  }\n"])), function (_ref6) {
  var theme = _ref6.theme;
  return theme.spacing(4);
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.spacing(0.5);
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.spacing(0.5);
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.spacing(4);
});
var ChildrenWrapper = styled.div(_templateObject8$2 || (_templateObject8$2 = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n"])), function (_ref10) {
  var theme = _ref10.theme;
  return theme.spacing(4);
});

var Modal = function Modal(props) {
  var children = props.children,
    className = props.className,
    isOpen = props.isOpen,
    onClose = props.onClose,
    preventClose = props.preventClose,
    size = props.size;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isClosing = _useState2[0],
    setIsClosing = _useState2[1];
  var handleClose = function handleClose() {
    if (preventClose) {
      return;
    }
    if (onClose && isClosing) {
      setIsClosing(false);
      onClose();
    }
  };
  var handleClosingAnimation = function handleClosingAnimation() {
    if (preventClose) {
      return;
    }
    setIsClosing(true);
  };
  if (!isOpen) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement(Backdrop, {
    isClosing: Boolean(isClosing),
    onAnimationEnd: handleClose,
    onClick: handleClosingAnimation,
    role: "dialog",
    "aria-label": "dialog"
  }, /*#__PURE__*/React__default.createElement(FocusKeeper, {
    onEscape: handleClosingAnimation
  }, /*#__PURE__*/React__default.createElement(ModalWrapper, {
    className: className,
    onClick: function onClick(event) {
      return event.stopPropagation();
    },
    "aria-modal": true,
    "aria-label": "content",
    size: size
  }, /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: Boolean(!preventClose)
  }, /*#__PURE__*/React__default.createElement(CloseButton, {
    "aria-label": "Cerrar",
    type: "button",
    onClick: handleClosingAnimation
  }, /*#__PURE__*/React__default.createElement(CrossIcon, {
    size: "medium",
    titleAccess: "Cerrar"
  }))), /*#__PURE__*/React__default.createElement(ChildrenWrapper, null, children))));
};
Modal.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  preventClose: PropTypes.bool,
  size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
  className: PropTypes.string
};
Modal.defaultProps = {
  onClose: function onClose() {},
  preventClose: false,
  size: 'md',
  className: ''
};

var _templateObject$g, _templateObject2$9, _templateObject3$8, _templateObject4$7, _templateObject5$5;
var RadioButtonStyled = styled.label(_templateObject$g || (_templateObject$g = _taggedTemplateLiteral(["\n  ", "\n\n  cursor: pointer;\n  display: flex;\n  position: relative;\n  align-items: center;\n  width: max-content;\n  height: 1.1428em;\n\n  ", "\n\n  input {\n    transform: scale(0);\n    position: absolute;\n\n    &:focus {\n      & ~ .radio-button {\n        ", ";\n      }\n    }\n\n    &:checked {\n      & ~ .radio-button .radio-button-inner {\n        visibility: visible;\n        opacity: 1;\n        transform: scale(1);\n      }\n    }\n  }\n\n  .radio-button {\n    box-sizing: border-box;\n    position: relative;\n    z-index: 1;\n    display: grid;\n    place-items: center;\n    border-radius: 50%;\n    height: 1.1428em;\n    width: 1.1428em;\n    padding: 0.2143em;\n    border: 1px solid ", ";\n    background-color: ", ";\n\n    ", "\n\n    &:hover {\n      ", ";\n    }\n  }\n\n  .radio-button-inner {\n    display: block;\n    position: relative;\n    z-index: 2;\n    height: 100%;\n    width: 100%;\n    border-radius: 50%;\n    background-color: ", ";\n    visibility: hidden;\n    opacity: 0;\n\n    ", "\n  }\n\n  .radio-label {\n    margin-left: ", ";\n\n    ", "\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.form.label.font();
}, function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled && css(_templateObject2$9 || (_templateObject2$9 = _taggedTemplateLiteral(["\n    cursor: not-allowed;\n    pointer-events: none;\n  "])));
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.form.focus();
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.palette.grayE;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.palette.primary.contrastText;
}, function (_ref6) {
  var theme = _ref6.theme,
    disabled = _ref6.disabled;
  return disabled && css(_templateObject3$8 || (_templateObject3$8 = _taggedTemplateLiteral(["\n      background-color: ", ";\n    "])), theme.palette.grayC);
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.form.focus(theme.palette.grayC, theme.palette.grayC);
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.palette.info.main;
}, function (_ref9) {
  var theme = _ref9.theme,
    disabled = _ref9.disabled;
  return disabled && css(_templateObject4$7 || (_templateObject4$7 = _taggedTemplateLiteral(["\n      background-color: ", ";\n    "])), theme.palette.grayG);
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.spacing(1);
}, function (_ref11) {
  var theme = _ref11.theme,
    disabled = _ref11.disabled;
  return disabled && css(_templateObject5$5 || (_templateObject5$5 = _taggedTemplateLiteral(["\n      color: ", ";\n    "])), theme.palette.grayG);
});

var _excluded$b = ["id", "name", "label", "required", "disabled", "checked", "value", "tabIndex", "className", "onChange", "onFocus", "onBlur", "focus"];
var RadioButton = function RadioButton(props) {
  var id = props.id,
    name = props.name,
    label = props.label,
    required = props.required,
    disabled = props.disabled,
    checked = props.checked,
    value = props.value,
    tabIndex = props.tabIndex,
    className = props.className,
    onChange = props.onChange,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    focus = props.focus,
    rest = _objectWithoutProperties(props, _excluded$b);
  var computeTabIndex = function computeTabIndex() {
    return disabled ? -1 : tabIndex;
  };
  var handleChange = function handleChange(event) {
    if (event.nativeEvent.defaultPrevented) {
      return;
    }
    onChange(event);
  };
  return /*#__PURE__*/React__default.createElement(RadioButtonStyled, _extends$3({}, rest, {
    disabled: disabled,
    className: className
  }), /*#__PURE__*/React__default.createElement("input", {
    id: id,
    name: name,
    type: "radio",
    required: required,
    disabled: disabled,
    checked: checked,
    value: value,
    className: "radio",
    onChange: handleChange,
    onBlur: onBlur
    // eslint-disable-next-line jsx-a11y/no-autofocus
    ,
    autoFocus: focus,
    onFocus: onFocus,
    tabIndex: computeTabIndex()
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "radio-button"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "radio-button-inner"
  })), /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: Boolean(label)
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "radio-label"
  }, label)));
};
RadioButton.propTypes = {
  /**
   * A unique identifier of the `input` element.
   */
  id: PropTypes.string,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
    * The text of the associated label element.
    */
  label: PropTypes.string,
  /**
   * If `true`, the input element is required.
   */
  required: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,
  /**
   * The value of the component. The DOM API casts this to a string.
   */
  value: PropTypes.string,
  /**
    * @ignore
    */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Class to apply on input container
   */
  className: PropTypes.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,
  /**
   * Function to execute when input is blurred
   */
  onBlur: PropTypes.func,
  /**
   * Function to execute when input is focused
   */
  onFocus: PropTypes.func,
  /**
   * Function to execute when input was required initial focus
   */
  focus: PropTypes.bool
};
RadioButton.defaultProps = {
  id: '',
  name: '',
  label: '',
  required: false,
  disabled: false,
  checked: undefined,
  value: '',
  tabIndex: 0,
  className: '',
  onChange: function onChange() {},
  onBlur: function onBlur() {},
  onFocus: function onFocus() {},
  focus: false
};

var _templateObject$f, _templateObject2$8, _templateObject3$7, _templateObject4$6, _templateObject5$4;
var RadioGroupWrapper = styled.div(_templateObject$f || (_templateObject$f = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"])));
var RadioGroupStyled = styled.div(_templateObject2$8 || (_templateObject2$8 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-gap: ", ";\n  grid-template-columns: 1fr;\n  ", "\n\n  @media ", " {\n    grid-template-columns: repeat(", ", max-content);\n\n    ", "\n\n    ", "\n  }\n\n  @media ", " {\n    grid-gap: ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.spacing(3);
}, function (_ref2) {
  var childrens = _ref2.childrens;
  return childrens === 2 && css(_templateObject3$7 || (_templateObject3$7 = _taggedTemplateLiteral(["\n    grid-template-columns: 1fr 1fr;\n  "])));
}, device.tablet, function (_ref3) {
  var childrens = _ref3.childrens;
  return childrens;
}, function (_ref4) {
  var _ref4$column = _ref4.column,
    column = _ref4$column === void 0 ? false : _ref4$column;
  return column && css(_templateObject4$6 || (_templateObject4$6 = _taggedTemplateLiteral(["\n      grid-template-columns: 1fr;\n    "])));
}, function (_ref5) {
  var childrens = _ref5.childrens;
  return childrens === 2 && css(_templateObject5$4 || (_templateObject5$4 = _taggedTemplateLiteral(["\n      grid-template-columns: repeat(", ", max-content);\n    "])), function (_ref6) {
    var child = _ref6.child;
    return child;
  });
}, device.desktop, function (_ref7) {
  var theme = _ref7.theme;
  return theme.spacing(5);
});

var _excluded$a = ["id", "name", "label", "value", "required", "className", "styles", "disabled", "error", "column", "helperText", "defaultValue", "children", "onChange", "onBlur", "InputLabelProps", "FormFieldHelperTextProps", "focus"],
  _excluded2$1 = ["groupName"];
function ownKeys$4(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$4(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$4(Object(t), !0).forEach(function (r) { _defineProperty$1(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$4(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var areChildrenRadioButton = function areChildrenRadioButton(children) {
  var childrenAsArray = React__default.Children.toArray(children);
  return childrenAsArray.every(function (child) {
    return child.type.name === RadioButton.name;
  });
};
var RadioGroup = function RadioGroup(props) {
  var id = props.id,
    name = props.name,
    label = props.label,
    controlledValue = props.value,
    required = props.required,
    className = props.className,
    styles = props.styles,
    disabled = props.disabled,
    error = props.error,
    column = props.column,
    helperText = props.helperText,
    defaultValue = props.defaultValue,
    children = props.children,
    onChange = props.onChange,
    onBlur = props.onBlur,
    InputLabelProps = props.InputLabelProps,
    FormFieldHelperTextProps = props.FormFieldHelperTextProps,
    focus = props.focus,
    rest = _objectWithoutProperties(props, _excluded$a);
  if (!areChildrenRadioButton(children)) {
    throw new Error('`RadioGroup` only accepts children of type `radio`.');
  }
  var _useControlled = useControlled({
      controlled: controlledValue,
      "default": defaultValue,
      name: name
    }),
    _useControlled2 = _slicedToArray(_useControlled, 2),
    value = _useControlled2[0],
    setValue = _useControlled2[1];
  var createEvent = function createEvent(event) {
    var nativeEvent = event.nativeEvent || event;
    var clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
    Object.defineProperty(clonedEvent, 'target', {
      writable: true,
      value: {
        value: event.target.getAttribute('value'),
        name: name
      }
    });
    return clonedEvent;
  };
  var handleChange = function handleChange(event) {
    setValue(event.target.value);
    onChange(createEvent(event), event.target.value);
  };
  var handleBlur = function handleBlur(event) {
    onBlur(createEvent(event), event.target.value);
  };
  var addInitialFocusToRadioButton = function addInitialFocusToRadioButton(radioButton) {
    if (focus && defaultValue === radioButton.props.value) {
      return true;
    }
    if (focus && children[0].props.value === radioButton.props.value) {
      return true;
    }
    return false;
  };
  var getGroupControl = function getGroupControl(component) {
    var _component$props = component.props,
      groupName = _component$props.groupName,
      restProps = _objectWithoutProperties(_component$props, _excluded2$1);
    return _objectSpread$4(_objectSpread$4({}, restProps), {}, {
      groupName: groupName,
      checked: value === component.props.value || false,
      focus: addInitialFocusToRadioButton(component),
      disabled: disabled,
      onBlur: handleBlur,
      onChange: handleChange
    });
  };
  var childrenWithProps = React__default.Children.map(children, function (child) {
    if ( /*#__PURE__*/React__default.isValidElement(child)) {
      return /*#__PURE__*/React__default.cloneElement(child, getGroupControl(child));
    }
    return child;
  });
  return /*#__PURE__*/React__default.createElement(RadioGroupWrapper, null, /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: Boolean(label)
  }, /*#__PURE__*/React__default.createElement(InputLabel, _extends$3({
    htmlFor: id,
    required: required
  }, InputLabelProps), label)), /*#__PURE__*/React__default.createElement(RadioGroupStyled, _extends$3({
    id: id,
    childrens: children.length,
    className: className,
    column: column,
    role: "radiogroup",
    style: styles
  }, rest), childrenWithProps), /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: Boolean(helperText)
  }, /*#__PURE__*/React__default.createElement(FormFieldHelperText, _extends$3({
    error: error
  }, FormFieldHelperTextProps), helperText)));
};
RadioGroup.propTypes = {
  /**
  * Id assigned to input. This id is also used to make accessible the label and helperText.
  */
  id: PropTypes.string,
  /**
  * Name attribute of the `input` element.
  */
  name: PropTypes.string,
  /**
  * The text to display as the label associated with input control
  */
  label: PropTypes.string,
  /**
  * Value of the selected radio button.
  */
  value: PropTypes.string,
  /**
   * If true the input element would be required
   */
  required: PropTypes.bool,
  /**
  * Override or extend the styles applied to the component
  */
  className: PropTypes.string,
  /**
  * The system prop that allows defining system overrides as well as additional CSS styles
  */
  // eslint-disable-next-line react/forbid-prop-types
  styles: PropTypes.objectOf(PropTypes.object),
  /**
  * Whether this field should be displayed in error state
  */
  error: PropTypes.bool,
  /**
  * To layout the buttons vertically
  */
  column: PropTypes.bool,
  /**
  * Provides additional information about the field
  */
  helperText: PropTypes.string,
  /**
  * The default input value. Use when the component is not controlled.
  */
  defaultValue: PropTypes.string,
  /**
  *The content of the component
  */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
  /**
  * Callback fired when the state is changed.
  *
  * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
  * You can pull out the new value by accessing `event.target.value` (string).
  */
  onChange: PropTypes.func,
  /**
   * Function to execute when input is blurred
   */
  onBlur: PropTypes.func,
  /**
   * Function to execute when input was required initial focus
   */
  focus: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: PropTypes.bool,
  /**
  * Props applied on InputLabel component
  */
  InputLabelProps: PropTypes.shape({}),
  /**
  * Props applied on InputLabel component
  */
  FormFieldHelperTextProps: PropTypes.shape({})
};
RadioGroup.defaultProps = {
  id: undefined,
  name: undefined,
  label: '',
  value: undefined,
  required: false,
  disabled: false,
  className: '',
  styles: {},
  error: false,
  column: false,
  helperText: '',
  defaultValue: undefined,
  onChange: function onChange() {},
  onBlur: function onBlur() {},
  focus: false,
  InputLabelProps: {},
  FormFieldHelperTextProps: {}
};

var _templateObject$e;
var SiderMenuStyled = styled.ul(_templateObject$e || (_templateObject$e = _taggedTemplateLiteral(["\n  background-color: ", ";\n  margin: 0;\n  padding: 0;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.background.hbBackgroundA;
});

var _excluded$9 = ["children"];
var SiderMenu = function SiderMenu(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$9);
  var renderChildrenWithProps = function renderChildrenWithProps() {
    return React__default.Children.map(children, function (child) {
      if ( /*#__PURE__*/React__default.isValidElement(child)) {
        return /*#__PURE__*/React__default.cloneElement(child, props);
      }
      return child;
    });
  };
  return /*#__PURE__*/React__default.createElement(SiderMenuStyled, null, renderChildrenWithProps());
};
SiderMenu.propTypes = {
  /**
   * The content of the component
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired
};

/**
 * @remix-run/router v1.15.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function _extends$2() {
  _extends$2 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$2.apply(this, arguments);
}

////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */
var Action;
(function (Action) {
  /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */
  Action["Pop"] = "POP";
  /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */
  Action["Push"] = "PUSH";
  /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */
  Action["Replace"] = "REPLACE";
})(Action || (Action = {}));
function invariant(value, message) {
  if (value === false || value === null || typeof value === "undefined") {
    throw new Error(message);
  }
}
function warning(cond, message) {
  if (!cond) {
    // eslint-disable-next-line no-console
    if (typeof console !== "undefined") console.warn(message);
    try {
      // Welcome to debugging history!
      //
      // This error is thrown as a convenience, so you can more easily
      // find the source for a warning that appears in the console by
      // enabling "pause on exceptions" in your JavaScript debugger.
      throw new Error(message);
      // eslint-disable-next-line no-empty
    } catch (e) {}
  }
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */
function createPath(_ref) {
  var _ref$pathname = _ref.pathname,
    pathname = _ref$pathname === void 0 ? "/" : _ref$pathname,
    _ref$search = _ref.search,
    search = _ref$search === void 0 ? "" : _ref$search,
    _ref$hash = _ref.hash,
    hash = _ref$hash === void 0 ? "" : _ref$hash;
  if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
  if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
  return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */
function parsePath(path) {
  var parsedPath = {};
  if (path) {
    var hashIndex = path.indexOf("#");
    if (hashIndex >= 0) {
      parsedPath.hash = path.substr(hashIndex);
      path = path.substr(0, hashIndex);
    }
    var searchIndex = path.indexOf("?");
    if (searchIndex >= 0) {
      parsedPath.search = path.substr(searchIndex);
      path = path.substr(0, searchIndex);
    }
    if (path) {
      parsedPath.pathname = path;
    }
  }
  return parsedPath;
}
//#endregion

var ResultType;
(function (ResultType) {
  ResultType["data"] = "data";
  ResultType["deferred"] = "deferred";
  ResultType["redirect"] = "redirect";
  ResultType["error"] = "error";
})(ResultType || (ResultType = {}));
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */
function matchPath(pattern, pathname) {
  if (typeof pattern === "string") {
    pattern = {
      path: pattern,
      caseSensitive: false,
      end: true
    };
  }
  var _compilePath = compilePath(pattern.path, pattern.caseSensitive, pattern.end),
    _compilePath2 = _slicedToArray(_compilePath, 2),
    matcher = _compilePath2[0],
    compiledParams = _compilePath2[1];
  var match = pathname.match(matcher);
  if (!match) return null;
  var matchedPathname = match[0];
  var pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
  var captureGroups = match.slice(1);
  var params = compiledParams.reduce(function (memo, _ref, index) {
    var paramName = _ref.paramName,
      isOptional = _ref.isOptional;
    // We need to compute the pathnameBase here using the raw splat value
    // instead of using params["*"] later because it will be decoded then
    if (paramName === "*") {
      var splatValue = captureGroups[index] || "";
      pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
    }
    var value = captureGroups[index];
    if (isOptional && !value) {
      memo[paramName] = undefined;
    } else {
      memo[paramName] = (value || "").replace(/%2F/g, "/");
    }
    return memo;
  }, {});
  return {
    params: params,
    pathname: matchedPathname,
    pathnameBase: pathnameBase,
    pattern: pattern
  };
}
function compilePath(path, caseSensitive, end) {
  if (caseSensitive === void 0) {
    caseSensitive = false;
  }
  if (end === void 0) {
    end = true;
  }
  warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
  var params = [];
  var regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
  .replace(/^\/*/, "/") // Make sure it has a leading /
  .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
  .replace(/\/:([\w-]+)(\?)?/g, function (_, paramName, isOptional) {
    params.push({
      paramName: paramName,
      isOptional: isOptional != null
    });
    return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
  });
  if (path.endsWith("*")) {
    params.push({
      paramName: "*"
    });
    regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
    : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
  } else if (end) {
    // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
  } else if (path !== "" && path !== "/") {
    // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
  } else ;
  var matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
  return [matcher, params];
}
/**
 * @private
 */
function stripBasename(pathname, basename) {
  if (basename === "/") return pathname;
  if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) {
    return null;
  }
  // We want to leave trailing slash behavior in the user's control, so if they
  // specify a basename with a trailing slash, we should support it
  var startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
  var nextChar = pathname.charAt(startIndex);
  if (nextChar && nextChar !== "/") {
    // pathname does not start with basename/
    return null;
  }
  return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */
function resolvePath(to, fromPathname) {
  if (fromPathname === void 0) {
    fromPathname = "/";
  }
  var _ref4 = typeof to === "string" ? parsePath(to) : to,
    toPathname = _ref4.pathname,
    _ref4$search = _ref4.search,
    search = _ref4$search === void 0 ? "" : _ref4$search,
    _ref4$hash = _ref4.hash,
    hash = _ref4$hash === void 0 ? "" : _ref4$hash;
  var pathname = toPathname ? toPathname.startsWith("/") ? toPathname : resolvePathname(toPathname, fromPathname) : fromPathname;
  return {
    pathname: pathname,
    search: normalizeSearch(search),
    hash: normalizeHash(hash)
  };
}
function resolvePathname(relativePath, fromPathname) {
  var segments = fromPathname.replace(/\/+$/, "").split("/");
  var relativeSegments = relativePath.split("/");
  relativeSegments.forEach(function (segment) {
    if (segment === "..") {
      // Keep the root "" segment so the pathname starts at /
      if (segments.length > 1) segments.pop();
    } else if (segment !== ".") {
      segments.push(segment);
    }
  });
  return segments.length > 1 ? segments.join("/") : "/";
}
function getInvalidPathError(_char, field, dest, path) {
  return "Cannot include a '" + _char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */
function getPathContributingMatches(matches) {
  return matches.filter(function (match, index) {
    return index === 0 || match.route.path && match.route.path.length > 0;
  });
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function getResolveToMatches(matches, v7_relativeSplatPath) {
  var pathMatches = getPathContributingMatches(matches);
  // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
  // match so we include splat values for "." links.  See:
  // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
  if (v7_relativeSplatPath) {
    return pathMatches.map(function (match, idx) {
      return idx === matches.length - 1 ? match.pathname : match.pathnameBase;
    });
  }
  return pathMatches.map(function (match) {
    return match.pathnameBase;
  });
}
/**
 * @private
 */
function resolveTo(toArg, routePathnames, locationPathname, isPathRelative) {
  if (isPathRelative === void 0) {
    isPathRelative = false;
  }
  var to;
  if (typeof toArg === "string") {
    to = parsePath(toArg);
  } else {
    to = _extends$2({}, toArg);
    invariant(!to.pathname || !to.pathname.includes("?"), getInvalidPathError("?", "pathname", "search", to));
    invariant(!to.pathname || !to.pathname.includes("#"), getInvalidPathError("#", "pathname", "hash", to));
    invariant(!to.search || !to.search.includes("#"), getInvalidPathError("#", "search", "hash", to));
  }
  var isEmptyPath = toArg === "" || to.pathname === "";
  var toPathname = isEmptyPath ? "/" : to.pathname;
  var from;
  // Routing is relative to the current pathname if explicitly requested.
  //
  // If a pathname is explicitly provided in `to`, it should be relative to the
  // route context. This is explained in `Note on `<Link to>` values` in our
  // migration guide from v5 as a means of disambiguation between `to` values
  // that begin with `/` and those that do not. However, this is problematic for
  // `to` values that do not provide a pathname. `to` can simply be a search or
  // hash string, in which case we should assume that the navigation is relative
  // to the current location's pathname and *not* the route pathname.
  if (toPathname == null) {
    from = locationPathname;
  } else {
    var routePathnameIndex = routePathnames.length - 1;
    // With relative="route" (the default), each leading .. segment means
    // "go up one route" instead of "go up one URL segment".  This is a key
    // difference from how <a href> works and a major reason we call this a
    // "to" value instead of a "href".
    if (!isPathRelative && toPathname.startsWith("..")) {
      var toSegments = toPathname.split("/");
      while (toSegments[0] === "..") {
        toSegments.shift();
        routePathnameIndex -= 1;
      }
      to.pathname = toSegments.join("/");
    }
    from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
  }
  var path = resolvePath(to, from);
  // Ensure the pathname has a trailing slash if the original "to" had one
  var hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
  // Or if this was a link to the current path which has a trailing slash
  var hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
  if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) {
    path.pathname += "/";
  }
  return path;
}
/**
 * @private
 */
var joinPaths = function joinPaths(paths) {
  return paths.join("/").replace(/\/\/+/g, "/");
};
/**
 * @private
 */
var normalizeSearch = function normalizeSearch(search) {
  return !search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
};
/**
 * @private
 */
var normalizeHash = function normalizeHash(hash) {
  return !hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
};
var validMutationMethodsArr = ["post", "put", "patch", "delete"];
new Set(validMutationMethodsArr);
var validRequestMethodsArr = ["get"].concat(validMutationMethodsArr);
new Set(validRequestMethodsArr);

function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}

// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
var DataRouterContext = /*#__PURE__*/React.createContext(null);
if (process.env.NODE_ENV !== "production") {
  DataRouterContext.displayName = "DataRouter";
}
var DataRouterStateContext = /*#__PURE__*/React.createContext(null);
if (process.env.NODE_ENV !== "production") {
  DataRouterStateContext.displayName = "DataRouterState";
}
var AwaitContext = /*#__PURE__*/React.createContext(null);
if (process.env.NODE_ENV !== "production") {
  AwaitContext.displayName = "Await";
}

/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */

var NavigationContext = /*#__PURE__*/React.createContext(null);
if (process.env.NODE_ENV !== "production") {
  NavigationContext.displayName = "Navigation";
}
var LocationContext = /*#__PURE__*/React.createContext(null);
if (process.env.NODE_ENV !== "production") {
  LocationContext.displayName = "Location";
}
var RouteContext = /*#__PURE__*/React.createContext({
  outlet: null,
  matches: [],
  isDataRoute: false
});
if (process.env.NODE_ENV !== "production") {
  RouteContext.displayName = "Route";
}
var RouteErrorContext = /*#__PURE__*/React.createContext(null);
if (process.env.NODE_ENV !== "production") {
  RouteErrorContext.displayName = "RouteError";
}

/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */
function useHref(to, _temp) {
  var _ref9 = _temp === void 0 ? {} : _temp,
    relative = _ref9.relative;
  !useInRouterContext() ? process.env.NODE_ENV !== "production" ? invariant(false,
  // TODO: This error is probably because they somehow have 2 versions of the
  // router loaded. We can help them understand how to avoid that.
  "useHref() may be used only in the context of a <Router> component.") : invariant(false) : void 0;
  var _React$useContext = React.useContext(NavigationContext),
    basename = _React$useContext.basename,
    navigator = _React$useContext.navigator;
  var _useResolvedPath = useResolvedPath(to, {
      relative: relative
    }),
    hash = _useResolvedPath.hash,
    pathname = _useResolvedPath.pathname,
    search = _useResolvedPath.search;
  var joinedPathname = pathname;

  // If we're operating within a basename, prepend it to the pathname prior
  // to creating the href.  If this is a root navigation, then just use the raw
  // basename which allows the basename to have full control over the presence
  // of a trailing slash on root links
  if (basename !== "/") {
    joinedPathname = pathname === "/" ? basename : joinPaths([basename, pathname]);
  }
  return navigator.createHref({
    pathname: joinedPathname,
    search: search,
    hash: hash
  });
}

/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */
function useInRouterContext() {
  return React.useContext(LocationContext) != null;
}

/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */
function useLocation() {
  !useInRouterContext() ? process.env.NODE_ENV !== "production" ? invariant(false,
  // TODO: This error is probably because they somehow have 2 versions of the
  // router loaded. We can help them understand how to avoid that.
  "useLocation() may be used only in the context of a <Router> component.") : invariant(false) : void 0;
  return React.useContext(LocationContext).location;
}

/**
 * The interface for the navigate() function returned from useNavigate().
 */

var navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when " + "your component is first rendered.";

// Mute warnings for calls to useNavigate in SSR environments
function useIsomorphicLayoutEffect(cb) {
  var isStatic = React.useContext(NavigationContext)["static"];
  if (!isStatic) {
    // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useLayoutEffect(cb);
  }
}

/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */
function useNavigate() {
  var _React$useContext2 = React.useContext(RouteContext),
    isDataRoute = _React$useContext2.isDataRoute;
  // Conditional usage is OK here because the usage of a data router is static
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return isDataRoute ? useNavigateStable() : useNavigateUnstable();
}
function useNavigateUnstable() {
  !useInRouterContext() ? process.env.NODE_ENV !== "production" ? invariant(false,
  // TODO: This error is probably because they somehow have 2 versions of the
  // router loaded. We can help them understand how to avoid that.
  "useNavigate() may be used only in the context of a <Router> component.") : invariant(false) : void 0;
  var dataRouterContext = React.useContext(DataRouterContext);
  var _React$useContext3 = React.useContext(NavigationContext),
    basename = _React$useContext3.basename,
    future = _React$useContext3.future,
    navigator = _React$useContext3.navigator;
  var _React$useContext4 = React.useContext(RouteContext),
    matches = _React$useContext4.matches;
  var _useLocation2 = useLocation(),
    locationPathname = _useLocation2.pathname;
  var routePathnamesJson = JSON.stringify(getResolveToMatches(matches, future.v7_relativeSplatPath));
  var activeRef = React.useRef(false);
  useIsomorphicLayoutEffect(function () {
    activeRef.current = true;
  });
  var navigate = React.useCallback(function (to, options) {
    if (options === void 0) {
      options = {};
    }
    process.env.NODE_ENV !== "production" ? warning(activeRef.current, navigateEffectWarning) : void 0;

    // Short circuit here since if this happens on first render the navigate
    // is useless because we haven't wired up our history listener yet
    if (!activeRef.current) return;
    if (typeof to === "number") {
      navigator.go(to);
      return;
    }
    var path = resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");

    // If we're operating within a basename, prepend it to the pathname prior
    // to handing off to history (but only if we're not in a data router,
    // otherwise it'll prepend the basename inside of the router).
    // If this is a root navigation, then we navigate to the raw basename
    // which allows the basename to have full control over the presence of a
    // trailing slash on root links
    if (dataRouterContext == null && basename !== "/") {
      path.pathname = path.pathname === "/" ? basename : joinPaths([basename, path.pathname]);
    }
    (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
  }, [basename, navigator, routePathnamesJson, locationPathname, dataRouterContext]);
  return navigate;
}

/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */
function useResolvedPath(to, _temp2) {
  var _ref10 = _temp2 === void 0 ? {} : _temp2,
    relative = _ref10.relative;
  var _React$useContext6 = React.useContext(NavigationContext),
    future = _React$useContext6.future;
  var _React$useContext7 = React.useContext(RouteContext),
    matches = _React$useContext7.matches;
  var _useLocation3 = useLocation(),
    locationPathname = _useLocation3.pathname;
  var routePathnamesJson = JSON.stringify(getResolveToMatches(matches, future.v7_relativeSplatPath));
  return React.useMemo(function () {
    return resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path");
  }, [to, routePathnamesJson, locationPathname, relative]);
}
var DataRouterHook$1 = /*#__PURE__*/function (DataRouterHook) {
  DataRouterHook["UseBlocker"] = "useBlocker";
  DataRouterHook["UseRevalidator"] = "useRevalidator";
  DataRouterHook["UseNavigateStable"] = "useNavigate";
  return DataRouterHook;
}(DataRouterHook$1 || {});
var DataRouterStateHook$1 = /*#__PURE__*/function (DataRouterStateHook) {
  DataRouterStateHook["UseBlocker"] = "useBlocker";
  DataRouterStateHook["UseLoaderData"] = "useLoaderData";
  DataRouterStateHook["UseActionData"] = "useActionData";
  DataRouterStateHook["UseRouteError"] = "useRouteError";
  DataRouterStateHook["UseNavigation"] = "useNavigation";
  DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
  DataRouterStateHook["UseMatches"] = "useMatches";
  DataRouterStateHook["UseRevalidator"] = "useRevalidator";
  DataRouterStateHook["UseNavigateStable"] = "useNavigate";
  DataRouterStateHook["UseRouteId"] = "useRouteId";
  return DataRouterStateHook;
}(DataRouterStateHook$1 || {});
function getDataRouterConsoleError$1(hookName) {
  return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function useDataRouterContext$1(hookName) {
  var ctx = React.useContext(DataRouterContext);
  !ctx ? process.env.NODE_ENV !== "production" ? invariant(false, getDataRouterConsoleError$1(hookName)) : invariant(false) : void 0;
  return ctx;
}
function useRouteContext(hookName) {
  var route = React.useContext(RouteContext);
  !route ? process.env.NODE_ENV !== "production" ? invariant(false, getDataRouterConsoleError$1(hookName)) : invariant(false) : void 0;
  return route;
}

// Internal version with hookName-aware debugging
function useCurrentRouteId(hookName) {
  var route = useRouteContext(hookName);
  var thisRoute = route.matches[route.matches.length - 1];
  !thisRoute.route.id ? process.env.NODE_ENV !== "production" ? invariant(false, hookName + " can only be used on routes that contain a unique \"id\"") : invariant(false) : void 0;
  return thisRoute.route.id;
}

/**
 * Returns the ID for the nearest contextual route
 */
function useRouteId() {
  return useCurrentRouteId(DataRouterStateHook$1.UseRouteId);
}

/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */
function useNavigateStable() {
  var _useDataRouterContext2 = useDataRouterContext$1(DataRouterHook$1.UseNavigateStable),
    router = _useDataRouterContext2.router;
  var id = useCurrentRouteId(DataRouterStateHook$1.UseNavigateStable);
  var activeRef = React.useRef(false);
  useIsomorphicLayoutEffect(function () {
    activeRef.current = true;
  });
  var navigate = React.useCallback(function (to, options) {
    if (options === void 0) {
      options = {};
    }
    process.env.NODE_ENV !== "production" ? warning(activeRef.current, navigateEffectWarning) : void 0;

    // Short circuit here since if this happens on first render the navigate
    // is useless because we haven't wired up our router subscriber yet
    if (!activeRef.current) return;
    if (typeof to === "number") {
      router.navigate(to);
    } else {
      router.navigate(to, _extends$1({
        fromRouteId: id
      }, options));
    }
  }, [router, id]);
  return navigate;
}
new Promise(function () {});

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var defaultMethod = "get";
var defaultEncType = "application/x-www-form-urlencoded";
function isHtmlElement(object) {
  return object != null && typeof object.tagName === "string";
}
function isButtonElement(object) {
  return isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function isFormElement(object) {
  return isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function isInputElement(object) {
  return isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function shouldProcessLinkClick(event, target) {
  return event.button === 0 && (
  // Ignore everything but left clicks
  !target || target === "_self") &&
  // Let browser handle "target=_blank" etc.
  !isModifiedEvent(event) // Ignore clicks with modifier keys
  ;
}
// One-time check for submitter support
var _formDataSupportsSubmitter = null;
function isFormDataSubmitterSupported() {
  if (_formDataSupportsSubmitter === null) {
    try {
      new FormData(document.createElement("form"),
      // @ts-expect-error if FormData supports the submitter parameter, this will throw
      0);
      _formDataSupportsSubmitter = false;
    } catch (e) {
      _formDataSupportsSubmitter = true;
    }
  }
  return _formDataSupportsSubmitter;
}
var supportedFormEncTypes = new Set(["application/x-www-form-urlencoded", "multipart/form-data", "text/plain"]);
function getFormEncType(encType) {
  if (encType != null && !supportedFormEncTypes.has(encType)) {
    process.env.NODE_ENV !== "production" ? warning(false, "\"" + encType + "\" is not a valid `encType` for `<Form>`/`<fetcher.Form>` " + ("and will default to \"" + defaultEncType + "\"")) : void 0;
    return null;
  }
  return encType;
}
function getFormSubmissionInfo(target, basename) {
  var method;
  var action;
  var encType;
  var formData;
  var body;
  if (isFormElement(target)) {
    // When grabbing the action from the element, it will have had the basename
    // prefixed to ensure non-JS scenarios work, so strip it since we'll
    // re-prefix in the router
    var attr = target.getAttribute("action");
    action = attr ? stripBasename(attr, basename) : null;
    method = target.getAttribute("method") || defaultMethod;
    encType = getFormEncType(target.getAttribute("enctype")) || defaultEncType;
    formData = new FormData(target);
  } else if (isButtonElement(target) || isInputElement(target) && (target.type === "submit" || target.type === "image")) {
    var form = target.form;
    if (form == null) {
      throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
    }
    // <button>/<input type="submit"> may override attributes of <form>
    // When grabbing the action from the element, it will have had the basename
    // prefixed to ensure non-JS scenarios work, so strip it since we'll
    // re-prefix in the router
    var _attr = target.getAttribute("formaction") || form.getAttribute("action");
    action = _attr ? stripBasename(_attr, basename) : null;
    method = target.getAttribute("formmethod") || form.getAttribute("method") || defaultMethod;
    encType = getFormEncType(target.getAttribute("formenctype")) || getFormEncType(form.getAttribute("enctype")) || defaultEncType;
    // Build a FormData object populated from a form and submitter
    formData = new FormData(form, target);
    // If this browser doesn't support the `FormData(el, submitter)` format,
    // then tack on the submitter value at the end.  This is a lightweight
    // solution that is not 100% spec compliant.  For complete support in older
    // browsers, consider using the `formdata-submitter-polyfill` package
    if (!isFormDataSubmitterSupported()) {
      var name = target.name,
        type = target.type,
        value = target.value;
      if (type === "image") {
        var prefix = name ? name + "." : "";
        formData.append(prefix + "x", "0");
        formData.append(prefix + "y", "0");
      } else if (name) {
        formData.append(name, value);
      }
    }
  } else if (isHtmlElement(target)) {
    throw new Error("Cannot submit element that is not <form>, <button>, or " + "<input type=\"submit|image\">");
  } else {
    method = defaultMethod;
    action = null;
    encType = defaultEncType;
    body = target;
  }
  // Send body for <Form encType="text/plain" so we encode it into text
  if (formData && encType === "text/plain") {
    body = formData;
    formData = undefined;
  }
  return {
    action: action,
    method: method.toLowerCase(),
    encType: encType,
    formData: formData,
    body: body
  };
}
var _excluded$8 = ["onClick", "relative", "reloadDocument", "replace", "state", "target", "to", "preventScrollReset", "unstable_viewTransition"],
  _excluded2 = ["aria-current", "caseSensitive", "className", "end", "style", "to", "unstable_viewTransition", "children"],
  _excluded3 = ["fetcherKey", "navigate", "reloadDocument", "replace", "state", "method", "action", "onSubmit", "relative", "preventScrollReset", "unstable_viewTransition"];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
var REACT_ROUTER_VERSION = "6";
try {
  window.__reactRouterVersion = REACT_ROUTER_VERSION;
} catch (e) {
  // no-op
}
var ViewTransitionContext = /*#__PURE__*/React.createContext({
  isTransitioning: false
});
if (process.env.NODE_ENV !== "production") {
  ViewTransitionContext.displayName = "ViewTransition";
}
var FetchersContext = /*#__PURE__*/React.createContext(new Map());
if (process.env.NODE_ENV !== "production") {
  FetchersContext.displayName = "Fetchers";
}
if (process.env.NODE_ENV !== "production") ;
var isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
var ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */
var Link = /*#__PURE__*/React.forwardRef(function LinkWithRef(_ref7, ref) {
  var onClick = _ref7.onClick,
    relative = _ref7.relative,
    reloadDocument = _ref7.reloadDocument,
    replace = _ref7.replace,
    state = _ref7.state,
    target = _ref7.target,
    to = _ref7.to,
    preventScrollReset = _ref7.preventScrollReset,
    unstable_viewTransition = _ref7.unstable_viewTransition,
    rest = _objectWithoutPropertiesLoose(_ref7, _excluded$8);
  var _React$useContext = React.useContext(NavigationContext),
    basename = _React$useContext.basename;
  // Rendered into <a href> for absolute URLs
  var absoluteHref;
  var isExternal = false;
  if (typeof to === "string" && ABSOLUTE_URL_REGEX.test(to)) {
    // Render the absolute href server- and client-side
    absoluteHref = to;
    // Only check for external origins client-side
    if (isBrowser) {
      try {
        var currentUrl = new URL(window.location.href);
        var targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
        var path = stripBasename(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) {
          // Strip the protocol/origin/basename for same-origin absolute URLs
          to = path + targetUrl.search + targetUrl.hash;
        } else {
          isExternal = true;
        }
      } catch (e) {
        // We can't do external URL detection without a valid URL
        process.env.NODE_ENV !== "production" ? warning(false, "<Link to=\"" + to + "\"> contains an invalid URL which will probably break " + "when clicked - please update to a valid URL path.") : void 0;
      }
    }
  }
  // Rendered into <a href> for relative URLs
  var href = useHref(to, {
    relative: relative
  });
  var internalOnClick = useLinkClickHandler(to, {
    replace: replace,
    state: state,
    target: target,
    preventScrollReset: preventScrollReset,
    relative: relative,
    unstable_viewTransition: unstable_viewTransition
  });
  function handleClick(event) {
    if (onClick) onClick(event);
    if (!event.defaultPrevented) {
      internalOnClick(event);
    }
  }
  return /*#__PURE__*/(
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    React.createElement("a", _extends({}, rest, {
      href: absoluteHref || href,
      onClick: isExternal || reloadDocument ? onClick : handleClick,
      ref: ref,
      target: target
    }))
  );
});
if (process.env.NODE_ENV !== "production") {
  Link.displayName = "Link";
}
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */
var NavLink = /*#__PURE__*/React.forwardRef(function NavLinkWithRef(_ref8, ref) {
  var _ref8$ariaCurrent = _ref8["aria-current"],
    ariaCurrentProp = _ref8$ariaCurrent === void 0 ? "page" : _ref8$ariaCurrent,
    _ref8$caseSensitive = _ref8.caseSensitive,
    caseSensitive = _ref8$caseSensitive === void 0 ? false : _ref8$caseSensitive,
    _ref8$className = _ref8.className,
    classNameProp = _ref8$className === void 0 ? "" : _ref8$className,
    _ref8$end = _ref8.end,
    end = _ref8$end === void 0 ? false : _ref8$end,
    styleProp = _ref8.style,
    to = _ref8.to,
    unstable_viewTransition = _ref8.unstable_viewTransition,
    children = _ref8.children,
    rest = _objectWithoutPropertiesLoose(_ref8, _excluded2);
  var path = useResolvedPath(to, {
    relative: rest.relative
  });
  var location = useLocation();
  var routerState = React.useContext(DataRouterStateContext);
  var _React$useContext2 = React.useContext(NavigationContext),
    navigator = _React$useContext2.navigator,
    basename = _React$useContext2.basename;
  var isTransitioning = routerState != null &&
  // Conditional usage is OK here because the usage of a data router is static
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useViewTransitionState(path) && unstable_viewTransition === true;
  var toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
  var locationPathname = location.pathname;
  var nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
  if (!caseSensitive) {
    locationPathname = locationPathname.toLowerCase();
    nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
    toPathname = toPathname.toLowerCase();
  }
  if (nextLocationPathname && basename) {
    nextLocationPathname = stripBasename(nextLocationPathname, basename) || nextLocationPathname;
  }
  // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
  // we're looking for a slash _after_ what's in `to`.  For example:
  //
  // <NavLink to="/users"> and <NavLink to="/users/">
  // both want to look for a / at index 6 to match URL `/users/matt`
  var endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
  var isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
  var isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
  var renderProps = {
    isActive: isActive,
    isPending: isPending,
    isTransitioning: isTransitioning
  };
  var ariaCurrent = isActive ? ariaCurrentProp : undefined;
  var className;
  if (typeof classNameProp === "function") {
    className = classNameProp(renderProps);
  } else {
    // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [classNameProp, isActive ? "active" : null, isPending ? "pending" : null, isTransitioning ? "transitioning" : null].filter(Boolean).join(" ");
  }
  var style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
  return /*#__PURE__*/React.createElement(Link, _extends({}, rest, {
    "aria-current": ariaCurrent,
    className: className,
    ref: ref,
    style: style,
    to: to,
    unstable_viewTransition: unstable_viewTransition
  }), typeof children === "function" ? children(renderProps) : children);
});
if (process.env.NODE_ENV !== "production") {
  NavLink.displayName = "NavLink";
}
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */
var Form = /*#__PURE__*/React.forwardRef(function (_ref9, forwardedRef) {
  var fetcherKey = _ref9.fetcherKey,
    navigate = _ref9.navigate,
    reloadDocument = _ref9.reloadDocument,
    replace = _ref9.replace,
    state = _ref9.state,
    _ref9$method = _ref9.method,
    method = _ref9$method === void 0 ? defaultMethod : _ref9$method,
    action = _ref9.action,
    onSubmit = _ref9.onSubmit,
    relative = _ref9.relative,
    preventScrollReset = _ref9.preventScrollReset,
    unstable_viewTransition = _ref9.unstable_viewTransition,
    props = _objectWithoutPropertiesLoose(_ref9, _excluded3);
  var submit = useSubmit();
  var formAction = useFormAction(action, {
    relative: relative
  });
  var formMethod = method.toLowerCase() === "get" ? "get" : "post";
  var submitHandler = function submitHandler(event) {
    onSubmit && onSubmit(event);
    if (event.defaultPrevented) return;
    event.preventDefault();
    var submitter = event.nativeEvent.submitter;
    var submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
    submit(submitter || event.currentTarget, {
      fetcherKey: fetcherKey,
      method: submitMethod,
      navigate: navigate,
      replace: replace,
      state: state,
      relative: relative,
      preventScrollReset: preventScrollReset,
      unstable_viewTransition: unstable_viewTransition
    });
  };
  return /*#__PURE__*/React.createElement("form", _extends({
    ref: forwardedRef,
    method: formMethod,
    action: formAction,
    onSubmit: reloadDocument ? onSubmit : submitHandler
  }, props));
});
if (process.env.NODE_ENV !== "production") {
  Form.displayName = "Form";
}
if (process.env.NODE_ENV !== "production") ;
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var DataRouterHook;
(function (DataRouterHook) {
  DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
  DataRouterHook["UseSubmit"] = "useSubmit";
  DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
  DataRouterHook["UseFetcher"] = "useFetcher";
  DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})(DataRouterHook || (DataRouterHook = {}));
var DataRouterStateHook;
(function (DataRouterStateHook) {
  DataRouterStateHook["UseFetcher"] = "useFetcher";
  DataRouterStateHook["UseFetchers"] = "useFetchers";
  DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})(DataRouterStateHook || (DataRouterStateHook = {}));
// Internal hooks
function getDataRouterConsoleError(hookName) {
  return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function useDataRouterContext(hookName) {
  var ctx = React.useContext(DataRouterContext);
  !ctx ? process.env.NODE_ENV !== "production" ? invariant(false, getDataRouterConsoleError(hookName)) : invariant(false) : void 0;
  return ctx;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */
function useLinkClickHandler(to, _temp) {
  var _ref18 = _temp === void 0 ? {} : _temp,
    target = _ref18.target,
    replaceProp = _ref18.replace,
    state = _ref18.state,
    preventScrollReset = _ref18.preventScrollReset,
    relative = _ref18.relative,
    unstable_viewTransition = _ref18.unstable_viewTransition;
  var navigate = useNavigate();
  var location = useLocation();
  var path = useResolvedPath(to, {
    relative: relative
  });
  return React.useCallback(function (event) {
    if (shouldProcessLinkClick(event, target)) {
      event.preventDefault();
      // If the URL hasn't changed, a regular <a> will do a replace instead of
      // a push, so do the same here unless the replace prop is explicitly set
      var replace = replaceProp !== undefined ? replaceProp : createPath(location) === createPath(path);
      navigate(to, {
        replace: replace,
        state: state,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
      });
    }
  }, [location, navigate, path, replaceProp, state, target, to, preventScrollReset, relative, unstable_viewTransition]);
}
function validateClientSideSubmission() {
  if (typeof document === "undefined") {
    throw new Error("You are calling submit during the server render. " + "Try calling submit within a `useEffect` or callback instead.");
  }
}
var fetcherId = 0;
var getUniqueFetcherId = function getUniqueFetcherId() {
  return "__" + String(++fetcherId) + "__";
};
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */
function useSubmit() {
  var _useDataRouterContext = useDataRouterContext(DataRouterHook.UseSubmit),
    router = _useDataRouterContext.router;
  var _React$useContext3 = React.useContext(NavigationContext),
    basename = _React$useContext3.basename;
  var currentRouteId = useRouteId();
  return React.useCallback(function (target, options) {
    if (options === void 0) {
      options = {};
    }
    validateClientSideSubmission();
    var _getFormSubmissionInf = getFormSubmissionInfo(target, basename),
      action = _getFormSubmissionInf.action,
      method = _getFormSubmissionInf.method,
      encType = _getFormSubmissionInf.encType,
      formData = _getFormSubmissionInf.formData,
      body = _getFormSubmissionInf.body;
    if (options.navigate === false) {
      var key = options.fetcherKey || getUniqueFetcherId();
      router.fetch(key, currentRouteId, options.action || action, {
        preventScrollReset: options.preventScrollReset,
        formData: formData,
        body: body,
        formMethod: options.method || method,
        formEncType: options.encType || encType,
        unstable_flushSync: options.unstable_flushSync
      });
    } else {
      router.navigate(options.action || action, {
        preventScrollReset: options.preventScrollReset,
        formData: formData,
        body: body,
        formMethod: options.method || method,
        formEncType: options.encType || encType,
        replace: options.replace,
        state: options.state,
        fromRouteId: currentRouteId,
        unstable_flushSync: options.unstable_flushSync,
        unstable_viewTransition: options.unstable_viewTransition
      });
    }
  }, [router, basename, currentRouteId]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function useFormAction(action, _temp2) {
  var _ref19 = _temp2 === void 0 ? {} : _temp2,
    relative = _ref19.relative;
  var _React$useContext4 = React.useContext(NavigationContext),
    basename = _React$useContext4.basename;
  var routeContext = React.useContext(RouteContext);
  !routeContext ? process.env.NODE_ENV !== "production" ? invariant(false, "useFormAction must be used inside a RouteContext") : invariant(false) : void 0;
  var _routeContext$matches = routeContext.matches.slice(-1),
    _routeContext$matches2 = _slicedToArray(_routeContext$matches, 1),
    match = _routeContext$matches2[0];
  // Shallow clone path so we can modify it below, otherwise we modify the
  // object referenced by useMemo inside useResolvedPath
  var path = _extends({}, useResolvedPath(action ? action : ".", {
    relative: relative
  }));
  // If no action was specified, browsers will persist current search params
  // when determining the path, so match that behavior
  // https://github.com/remix-run/remix/issues/927
  var location = useLocation();
  if (action == null) {
    // Safe to write to this directly here since if action was undefined, we
    // would have called useResolvedPath(".") which will never include a search
    path.search = location.search;
    // When grabbing search params from the URL, remove any included ?index param
    // since it might not apply to our contextual route.  We add it back based
    // on match.route.index below
    var params = new URLSearchParams(path.search);
    if (params.has("index") && params.get("index") === "") {
      params["delete"]("index");
      path.search = params.toString() ? "?" + params.toString() : "";
    }
  }
  if ((!action || action === ".") && match.route.index) {
    path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
  }
  // If we're operating within a basename, prepend it to the pathname prior
  // to creating the form action.  If this is a root navigation, then just use
  // the raw basename which allows the basename to have full control over the
  // presence of a trailing slash on root actions
  if (basename !== "/") {
    path.pathname = path.pathname === "/" ? basename : joinPaths([basename, path.pathname]);
  }
  return createPath(path);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */
function useViewTransitionState(to, opts) {
  if (opts === void 0) {
    opts = {};
  }
  var vtContext = React.useContext(ViewTransitionContext);
  !(vtContext != null) ? process.env.NODE_ENV !== "production" ? invariant(false, "`unstable_useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  " + "Did you accidentally import `RouterProvider` from `react-router`?") : invariant(false) : void 0;
  var _useDataRouterContext4 = useDataRouterContext(DataRouterHook.useViewTransitionState),
    basename = _useDataRouterContext4.basename;
  var path = useResolvedPath(to, {
    relative: opts.relative
  });
  if (!vtContext.isTransitioning) {
    return false;
  }
  var currentPath = stripBasename(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
  var nextPath = stripBasename(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
  // Transition is active if we're going to or coming from the indicated
  // destination.  This ensures that other PUSH navigations that reverse
  // an indicated transition apply.  I.e., on the list view you have:
  //
  //   <NavLink to="/details/1" unstable_viewTransition>
  //
  // If you click the breadcrumb back to the list view:
  //
  //   <NavLink to="/list" unstable_viewTransition>
  //
  // We should apply the transition because it's indicated as active going
  // from /list -> /details/1 and therefore should be active on the reverse
  // (even though this isn't strictly a POP reverse)
  return matchPath(path.pathname, nextPath) != null || matchPath(path.pathname, currentPath) != null;
}

var _templateObject$d, _templateObject2$7, _templateObject3$6;

// TODO: Change to RobotoBold
var commonLinkStyle = css(_templateObject$d || (_templateObject$d = _taggedTemplateLiteral(["\n  ", ";\n\n  background-color: ", ";\n  color: ", ";\n  font-weight: 800;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.typography.font();
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.grayB;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.primary.main;
});
var SiderMenuItemStyled = styled.li(_templateObject2$7 || (_templateObject2$7 = _taggedTemplateLiteral(["\n  ", ";\n\n  height: 3em;\n  background-color: transparent;\n  list-style: none;\n  margin: 0;\n\n  .link {\n    color: inherit;\n    align-items: center;\n    border-radius: ", ";\n    display: flex;\n    height: 100%;\n    padding: 0 0 0 ", ";\n    text-decoration: none;\n\n    ", ";\n\n    &:hover {\n      ", "\n    }\n  }\n\n  @media ", " {\n    height: 2.3em;\n  }\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.typography.font();
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.borderRadius();
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.spacing(3);
}, function (_ref7) {
  var isActive = _ref7.isActive;
  return isActive && css(_templateObject3$6 || (_templateObject3$6 = _taggedTemplateLiteral(["", ""])), commonLinkStyle);
}, commonLinkStyle, device.tablet);

function ownKeys$3(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$3(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$3(Object(t), !0).forEach(function (r) { _defineProperty$1(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$3(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var SiderMenuItem = function SiderMenuItem(props) {
  var to = props.to,
    label = props.label,
    isExternal = props.isExternal,
    isActive = props.isActive,
    hideMenu = props.hideMenu;
  var propsLink = {
    className: 'link',
    to: to
  };
  if (isExternal) {
    propsLink = _objectSpread$3(_objectSpread$3({}, propsLink), {}, {
      target: '_blank'
    });
  }
  if (hideMenu) {
    propsLink = _objectSpread$3(_objectSpread$3({}, propsLink), {}, {
      onClick: function onClick() {
        hideMenu();
      }
    });
  }
  return /*#__PURE__*/React__default.createElement(SiderMenuItemStyled, {
    isActive: isActive
  }, /*#__PURE__*/React__default.createElement(Link, propsLink, label));
};
SiderMenuItem.propTypes = {
  /**
   * To open page in another tab
   */
  isExternal: PropTypes.bool,
  /**
   * The link of navigation item
   */
  to: PropTypes.string.isRequired,
  /**
   * The text of navigation item
   */
  label: PropTypes.string.isRequired,
  /**
   * Show as selected
   */
  isActive: PropTypes.bool,
  /**
   * Callback when the item has toggle hide
   */
  hideMenu: PropTypes.func
};
SiderMenuItem.defaultProps = {
  isExternal: false,
  isActive: false,
  hideMenu: function hideMenu() {}
};

var _templateObject$c, _templateObject2$6, _templateObject3$5, _templateObject4$5, _templateObject5$3;

// TODO: Change typography
var SiderNavTitleStyled = styled.h3(_templateObject$c || (_templateObject$c = _taggedTemplateLiteral(["\n  ", "\n\n  font-size: ", ";\n  font-weight: 400;\n\n  margin: 0;\n  padding: 0;\n  width: 100%;\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  @media ", " {\n    ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.typography.font();
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.toRem(18);
}, function (_ref3) {
  var level = _ref3.level;
  return level === 'title' && css(_templateObject2$6 || (_templateObject2$6 = _taggedTemplateLiteral(["\n    text-align: center;\n  "])));
}, function (_ref4) {
  var level = _ref4.level,
    theme = _ref4.theme;
  return level === 'subtitle1' && css(_templateObject3$5 || (_templateObject3$5 = _taggedTemplateLiteral(["\n    font-size: ", ";\n    text-align: center;\n    padding: 0;\n  "])), theme.toRem(16));
}, function (_ref5) {
  var level = _ref5.level,
    theme = _ref5.theme;
  return level === 'subtitle2' && css(_templateObject4$5 || (_templateObject4$5 = _taggedTemplateLiteral(["\n    color: ", ";\n    font-size: ", ";\n    display: flex;\n    letter-spacing: 0.34px;\n    align-items: center;\n    text-transform: uppercase;\n    padding: 0 0 0 ", ";\n    height: ", ";\n  "])), theme.palette.grayH, theme.toRem(14), theme.spacing(1), theme.spacing(4));
}, device.tablet, function (_ref6) {
  var level = _ref6.level;
  return level === 'title' && css(_templateObject5$3 || (_templateObject5$3 = _taggedTemplateLiteral(["\n      text-align: left;\n  "])));
});

var SiderNavTitle = function SiderNavTitle(_ref) {
  var label = _ref.label,
    level = _ref.level;
  return /*#__PURE__*/React__default.createElement(SiderNavTitleStyled, {
    level: level
  }, label);
};
SiderNavTitle.propTypes = {
  /**
  * The text of title
  */
  label: PropTypes.string.isRequired,
  /**
   * To especify the level of the title
   */
  level: PropTypes.oneOf(['title', 'subtitle1', 'subtitle2'])
};
SiderNavTitle.defaultProps = {
  level: 'title'
};

var _templateObject$b;
var NavItemDividerStyled = styled.hr(_templateObject$b || (_templateObject$b = _taggedTemplateLiteral(["\n  height: 1px;\n  width: 100%;\n\n  background-color: ", ";\n  border: 0;\n  margin: ", " 0;\n  padding: 0;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.grayC;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.spacing(2);
});

var _templateObject$a, _templateObject2$5, _templateObject3$4, _templateObject4$4;
var SiderNavStyled = styled.nav(_templateObject$a || (_templateObject$a = _taggedTemplateLiteral(["\n  background-color: ", ";\n  box-shadow: inset 0px -1px ", ";\n  border-radius: ", ";\n  padding: ", " 0;\n  border: none;\n  height: auto;\n  max-width: 100%;\n  padding-bottom: ", ";\n  margin-bottom: ", ";\n\n  ", "\n\n  .nav-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 ", ";\n\n    ", "\n\n    .sider-nav-title {\n      text-align: left;\n    }\n  }\n\n  .nav-menu {\n    position: relative;\n  }\n\n  .nav-menu-container {\n    opacity: 0;\n    transition: all 0.5s ease;\n    position: absolute;\n    background: white;\n    left: -100%;\n    right: 0;\n    top: 0;\n\n    ", "\n  }\n\n  .active {\n    left: 0;\n    opacity: 1;\n    z-index: 99;\n    height: 90vh;\n  }\n\n  .kebab-menu {\n    background-color: transparent;\n    min-width: ", ";\n    display: flex;\n    cursor: pointer;\n    padding: 0;\n    margin: 0;\n    border: 0;\n    outline: 0;\n    align-self: flex-end;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n\n    &:hover,\n    &:focus {\n      background: inherit;\n      border: 0;\n      outline: 0;\n      box-shadow: none;\n    }\n  }\n\n@media ", " {\n  background-color: ", ";\n  padding: ", ";\n  border: 1px solid ", ";\n  max-width: 224px;\n\n  .kebab-menu {\n    display: none;\n  }\n\n  .nav-header {\n    padding: 0;\n  }\n\n  .nav-menu-container {\n    left: 0;\n    opacity: 1;\n    position: relative;\n    top: 0;\n  }\n\n  .nav-subheader {\n    display: none;\n  }\n\n  .nav-brand {\n    .sider-nav-title {\n      text-align: left;\n    }\n  }\n}\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.background.hbBackgroundB;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.grayC;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.borderRadius();
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.spacing(2);
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.spacing(2);
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.spacing(2);
}, function (_ref7) {
  var isOpenedMenu = _ref7.isOpenedMenu;
  return isOpenedMenu && css(_templateObject2$5 || (_templateObject2$5 = _taggedTemplateLiteral(["\n    box-shadow: none;\n    background-color: ", ";\n  "])), function (_ref8) {
    var theme = _ref8.theme;
    return theme.palette.background.hbBackgroundA;
  });
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.spacing(2);
}, function (_ref10) {
  var hasTitle = _ref10.hasTitle;
  return !hasTitle && css(_templateObject3$4 || (_templateObject3$4 = _taggedTemplateLiteral(["\n      justify-content: flex-end;\n    "])));
}, function (_ref11) {
  var hasSubtitle = _ref11.hasSubtitle;
  return hasSubtitle && css(_templateObject4$4 || (_templateObject4$4 = _taggedTemplateLiteral(["\n      top: -48px;\n    "])));
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.spacing(3);
}, device.tablet, function (_ref13) {
  var theme = _ref13.theme;
  return theme.palette.background.hbBackgroundA;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.spacing(2);
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.palette.grayC;
});

var SiderNav = function SiderNav(_ref) {
  var children = _ref.children,
    style = _ref.style,
    title = _ref.title,
    subtitle = _ref.subtitle;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpenedMenu = _useState2[0],
    setIsOpenedMenu = _useState2[1];
  var toggleMenu = function toggleMenu() {
    return setIsOpenedMenu(!isOpenedMenu);
  };
  var hideMenu = function hideMenu() {
    return setIsOpenedMenu(false);
  };
  var renderChildrenWithProps = function renderChildrenWithProps() {
    return React__default.Children.map(children, function (child) {
      if ( /*#__PURE__*/React__default.isValidElement(child)) {
        return /*#__PURE__*/React__default.cloneElement(child, {
          hideMenu: hideMenu
        });
      }
      return child;
    });
  };
  var styleMenu = 'nav-menu-container';
  if (isOpenedMenu) {
    styleMenu += ' active';
  }
  return /*#__PURE__*/React__default.createElement(SiderNavStyled, {
    style: style,
    isOpenedMenu: isOpenedMenu,
    hasTitle: Boolean(title),
    hasSubtitle: Boolean(subtitle)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "nav-header"
  }, /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: Boolean(title)
  }, /*#__PURE__*/React__default.createElement(SiderNavTitle, {
    label: title
  })), /*#__PURE__*/React__default.createElement(Button, {
    variant: "text",
    className: "kebab-menu",
    "aria-label": "open/close menu",
    onClick: toggleMenu
  }, /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: !isOpenedMenu
  }, /*#__PURE__*/React__default.createElement(KebabMenuIcon, null)), /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: isOpenedMenu
  }, /*#__PURE__*/React__default.createElement(CrossIcon, {
    small: "size"
  })))), /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: Boolean(subtitle)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "nav-subheader"
  }, /*#__PURE__*/React__default.createElement(NavItemDividerStyled, null), /*#__PURE__*/React__default.createElement(SiderNavTitle, {
    label: subtitle,
    level: "subtitle1"
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "nav-menu"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styleMenu
  }, renderChildrenWithProps())));
};
SiderNav.propTypes = {
  /**
  * The content of the component
  */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
  /**
   * To display navigation title
   */
  title: PropTypes.string,
  /**
   * To display navigation subtitle only on mobile devices
   */
  subtitle: PropTypes.string,
  /**
  * To add custom CSS styles
  */
  style: PropTypes.shape()
};
SiderNav.defaultProps = {
  style: {},
  title: '',
  subtitle: ''
};

var _templateObject$9;
var StyledStep = styled.div(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteral(["\n  flex: 1;\n  background-color: ", ";\n  padding: 0  0 0 ", ";\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.background.hbBackgroundA;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.spacing(3);
});

var _excluded$7 = ["children"];
var Step = function Step(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$7);
  return /*#__PURE__*/React__default.createElement(StyledStep, _extends$3({}, props, {
    "data-testid": "step"
  }), children);
};
Step.propTypes = {
  /**
   * The content of the component
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired
};

var _templateObject$8;
var ACTIONS_ALIGNMENT = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end',
  between: 'space-between'
};
var StyledStepActions = styled.div(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: ", ";\n  padding: 0;\n\n  & > * {\n    &:not(:first-child) {\n      margin-left: ", ";\n    }\n  }\n"])), function (_ref) {
  var alignment = _ref.alignment;
  return ACTIONS_ALIGNMENT[alignment];
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.spacing(2);
});

var _excluded$6 = ["children"];
var AVAILABLE_ACTIONS_ALIGNMENTS = ['left', 'right', 'center', 'between'];
var StepActions = function StepActions(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$6);
  return /*#__PURE__*/React__default.createElement(StyledStepActions, _extends$3({}, props, {
    "data-testid": "step-actions"
  }), children);
};
StepActions.propTypes = {
  /**
   * The content of the component
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
  /**
   * To especify alignment of the actions
   */
  alignment: PropTypes.oneOf(AVAILABLE_ACTIONS_ALIGNMENTS)
};
StepActions.defaultProps = {
  alignment: 'right'
};

var _templateObject$7;
var StyledStepContent = styled.div(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteral(["\n  padding: 0;\n  flex: 1;\n"])));

var _excluded$5 = ["children"];
var StepContent = function StepContent(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$5);
  return /*#__PURE__*/React__default.createElement(StyledStepContent, _extends$3({}, props, {
    "data-testid": "step-content"
  }), children);
};
StepContent.propTypes = {
  /**
   * The content of the component
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired
};

var _templateObject$6, _templateObject2$4;
var StyledStepHeader = styled.div(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteral(["\n  padding: 0;\n"])));
var StyledStepTitle = styled.h3(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteral(["\n  ", ";\n\n  display: block;\n  margin: 0;\n  padding: 0;\n  text-align: ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.typography.heading(3);
}, function (_ref2) {
  var titleAlignment = _ref2.titleAlignment;
  return titleAlignment;
});

var _excluded$4 = ["children", "titleText", "titleAlignment", "titleElement"];
var ALIGNMENTS = ['left', 'center', 'right'];
var StepHeader = function StepHeader(props) {
  var children = props.children,
    titleText = props.titleText,
    titleAlignment = props.titleAlignment,
    titleElement = props.titleElement,
    restProps = _objectWithoutProperties(props, _excluded$4);
  return /*#__PURE__*/React__default.createElement(StyledStepHeader, _extends$3({}, restProps, {
    "data-testid": "step-header"
  }), /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: Boolean(titleText)
  }, /*#__PURE__*/React__default.createElement(StyledStepTitle, {
    titleAlignment: titleAlignment,
    as: titleElement,
    "data-testid": "step-header-title"
  }, titleText)), children);
};
StepHeader.propTypes = {
  /**
   * The content of the component
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  /**
   * The title of the step
   */
  titleText: PropTypes.string,
  /**
   * Set title alignment
   */
  titleAlignment: PropTypes.oneOf(ALIGNMENTS),
  /**
   * The html element that would be used in the title
   */
  titleElement: PropTypes.string
};
StepHeader.defaultProps = {
  titleText: '',
  children: null,
  titleAlignment: 'left',
  titleElement: 'h2'
};

var _templateObject$5, _templateObject2$3, _templateObject3$3, _templateObject4$3;
var StyledStepperIndicator = styled.div(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteral(["\n  position: relative;\n  box-sizing: border-box;\n  min-height: 1.7em;\n\n  & * {\n    box-sizing: border-box;\n  }\n\n  .step-number,\n  .indicator-content {\n    transition: border-color 0.4s ease-in-out, color 0.4s ease-in-out;\n  }\n\n  .step-number {\n    ", "\n\n    position: absolute;\n    left: 0;\n    top: 0;\n\n    align-items: center;\n    background-color: ", ";\n    display: flex;\n    justify-content: center;\n    width: 1.7em;\n    height: 1.7em;\n    border-radius: 50%;\n    border: 2px solid ", ";\n  }\n\n  .indicator-content {\n    ", ";\n\n    color: ", ";\n    word-break: break-word;\n    margin-left: calc(((1.7em / 2) - 1px));\n    border-left: 2px solid ", ";\n    padding: ", "\n  }\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.typography.font();
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.background.hbBackgroundA;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.grayC;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.typography.font();
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.palette.disabled.contrast;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.palette.grayC;
}, function (_ref7) {
  var theme = _ref7.theme;
  return " ".concat(theme.spacing(0.5), " ").concat(theme.spacing(1), " 40px ").concat(theme.spacing(3));
}, function (_ref8) {
  var isLastStepIndicator = _ref8.isLastStepIndicator;
  return isLastStepIndicator && css(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteral(["\n    .indicator-content {\n      border: none;\n      padding-bottom: 0;\n    }\n  "])));
}, function (_ref9) {
  var isCompleted = _ref9.isCompleted;
  return isCompleted && css(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteral(["\n    .step-number {\n      border-color: ", ";\n    }\n  "])), function (_ref10) {
    var theme = _ref10.theme;
    return theme.palette.alternative1.darker;
  });
}, function (_ref11) {
  var isActive = _ref11.isActive;
  return isActive && css(_templateObject4$3 || (_templateObject4$3 = _taggedTemplateLiteral(["\n    .step-number {\n      border-color: ", ";\n    }\n\n    .indicator-content {\n      ", ";\n\n      font-weight: 700;\n    }\n  "])), function (_ref12) {
    var theme = _ref12.theme;
    return theme.palette.alternative1.darker;
  }, function (_ref13) {
    var theme = _ref13.theme;
    return theme.typography.font();
  });
});

var _excluded$3 = ["children", "step"];
var StepperIndicator = function StepperIndicator(_ref) {
  var children = _ref.children,
    step = _ref.step,
    props = _objectWithoutProperties(_ref, _excluded$3);
  var stepNumber = step.index + 1;
  return /*#__PURE__*/React__default.createElement(StyledStepperIndicator, _extends$3({}, props, {
    "data-testid": "stepper-indicator"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "step-number"
  }, stepNumber), /*#__PURE__*/React__default.createElement("div", {
    className: "indicator-content"
  }, children));
};
StepperIndicator.defaultProps = {
  isActive: false,
  step: {},
  isCompleted: false,
  isLastStepIndicator: false
};
StepperIndicator.propTypes = {
  /**
   * The content of the component
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
  /**
   * Whether this indicator represents the active step
   */
  isActive: PropTypes.bool,
  /**
   * Whether this indicator represents if step has been completed
   */
  isCompleted: PropTypes.bool,
  /**
  * Whether this indicator represents the last step
  */
  isLastStepIndicator: PropTypes.bool,
  /**
   * Object that specifies the step configuration
   */
  step: PropTypes.shape({
    index: PropTypes.number,
    id: PropTypes.string,
    name: PropTypes.string,
    content: PropTypes.node
  })
};

var _templateObject$4;
var StyledStepper = styled.div(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  box-shadow: 0 0 6px 0 rgba(", ", 0.05);\n  box-sizing: border-box;\n  display: flex;\n  min-height: 520px;\n  max-width: ", "px;\n  padding: ", ";\n  width: 100%;\n\n  & * {\n    box-sizing: border-box;\n  }\n\n  .stepper-indicator-list {\n    width: 208px;\n    border-right: 1px solid ", ";\n  }\n\n  .indicators-wrapper {\n    position: relative;\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.background.hbBackgroundA;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.grayC;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.borderRadius();
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.getRgbColor(theme.palette.grayB);
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.extraLarge;
}, function (_ref6) {
  var theme = _ref6.theme;
  return "".concat(theme.spacing(4), " ").concat(theme.spacing(3));
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.palette.grayC;
});

var _excluded$2 = ["activeStepId", "children", "steps"];
var Stepper = function Stepper(props) {
  var activeStepId = props.activeStepId,
    children = props.children,
    steps = props.steps,
    restProps = _objectWithoutProperties(props, _excluded$2);
  var activeStep = steps.find(function (step) {
    return step.id === activeStepId;
  }) || steps[0];
  return /*#__PURE__*/React__default.createElement(StyledStepper, _extends$3({}, restProps, {
    "data-testid": "stepper"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "stepper-indicator-list"
  }, steps.map(function (step) {
    var isLastStep = step.index === steps.length - 1;
    return /*#__PURE__*/React__default.createElement(Fragment, {
      key: step.id
    }, /*#__PURE__*/React__default.createElement(StepperIndicator, {
      step: step,
      isActive: activeStep.id === step.id,
      isCompleted: step.index < activeStep.index,
      isLastStepIndicator: isLastStep
    }, step.name));
  })), children);
};
Stepper.defaultProps = {
  steps: [],
  activeStepId: ''
};
Stepper.propTypes = {
  /**
   * The content of the component
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
  /**
   * Array with objects that specify the step configuration
   */
  steps: PropTypes.arrayOf(PropTypes.shape({
    index: PropTypes.number,
    id: PropTypes.string,
    name: PropTypes.string,
    content: PropTypes.node
  })),
  /**
   * Id of the active step.
   */
  activeStepId: PropTypes.string
};

var _templateObject$3;
var StyledTextField = styled.div(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n\n  & * {\n    box-sizing: border-box;\n  }\n"])));

var _excluded$1 = ["id", "name", "value", "type", "disabled", "label", "placeholder", "helperText", "required", "error", "className", "inputClassName", "onChange", "onBlur", "focus", "startAdornment", "endAdornment", "InputLabelProps", "InputProps", "inputProps", "FormFieldHelperTextProps"];
var TextField = function TextField(props) {
  var id = props.id,
    name = props.name,
    value = props.value,
    type = props.type,
    disabled = props.disabled,
    label = props.label,
    placeholder = props.placeholder,
    helperText = props.helperText,
    required = props.required,
    error = props.error,
    className = props.className,
    inputClassName = props.inputClassName,
    onChange = props.onChange,
    onBlur = props.onBlur,
    focus = props.focus,
    startAdornment = props.startAdornment,
    endAdornment = props.endAdornment,
    InputLabelProps = props.InputLabelProps,
    InputProps = props.InputProps,
    inputProps = props.inputProps,
    FormFieldHelperTextProps = props.FormFieldHelperTextProps,
    restProps = _objectWithoutProperties(props, _excluded$1);
  var accessibleInputProps = {};
  var helperTextId = error ? "".concat(id, "-error-text") : "".concat(id, "-helper-text");
  if (helperText) {
    accessibleInputProps['aria-describedby'] = helperTextId;
  }
  return /*#__PURE__*/React__default.createElement(StyledTextField, _extends$3({}, restProps, {
    className: className
  }), /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: Boolean(label)
  }, /*#__PURE__*/React__default.createElement(InputLabel, _extends$3({
    htmlFor: id,
    required: required
  }, InputLabelProps), label)), /*#__PURE__*/React__default.createElement(Input, _extends$3({
    id: id,
    name: name,
    value: value,
    type: type,
    disabled: disabled,
    placeholder: placeholder,
    required: required,
    error: error,
    className: inputClassName,
    onChange: onChange,
    onBlur: onBlur,
    focus: focus,
    startAdornment: startAdornment,
    endAdornment: endAdornment,
    inputProps: inputProps
  }, InputProps, accessibleInputProps)), /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: Boolean(helperText)
  }, /*#__PURE__*/React__default.createElement(FormFieldHelperText, _extends$3({
    error: error
  }, FormFieldHelperTextProps, {
    id: helperTextId
  }), helperText)));
};
TextField.defaultProps = {
  id: '',
  name: '',
  value: undefined,
  type: 'text',
  disabled: false,
  label: '',
  placeholder: '',
  helperText: '',
  required: false,
  error: false,
  className: '',
  inputClassName: '',
  onChange: function onChange() {},
  onBlur: function onBlur() {},
  focus: false,
  startAdornment: null,
  endAdornment: null,
  InputLabelProps: {},
  InputProps: {},
  inputProps: {},
  FormFieldHelperTextProps: {}
};
TextField.propTypes = {
  /**
   * Id assigned to input. This id is also used to make accessible the label and helperText.
   */
  id: PropTypes.string,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * The value of the input
   */
  value: PropTypes.string,
  /**
   * This is any valid HTML input type
   */
  type: PropTypes.string,
  /**
   * Apply styles to the field to display it as unusable and unclickable
   */
  disabled: PropTypes.bool,
  /**
   * The text to display as the label associated with input control
   */
  label: PropTypes.string,
  /**
   * Brief description about the expected value
   */
  placeholder: PropTypes.string,
  /**
   * Provides additional information about the field
   */
  helperText: PropTypes.string,
  /**
   * If true the input element would be required
   */
  required: PropTypes.bool,
  /**
   * Whether this field should be displayed in error state
   */
  error: PropTypes.bool,
  /**
   * Class to apply on text field container
   */
  className: PropTypes.string,
  /**
   * Class to apply on input container
   */
  inputClassName: PropTypes.string,
  /**
   * Function to execute when the value has changed
   */
  onChange: PropTypes.func,
  /**
   * Function to execute when input is blurred
   */
  onBlur: PropTypes.func,
  /**
   * Function to execute when input was required initial focus
   */
  focus: PropTypes.bool,
  /**
   * This will be display at the left side of the input.
   */
  startAdornment: PropTypes.node,
  /**
   * This will be display at the right side of the input.
   */
  endAdornment: PropTypes.node,
  /**
   * Props applied on InputLabel component
   */
  InputLabelProps: PropTypes.shape({}),
  /**
   * Props applied on Input component
   */
  InputProps: PropTypes.shape({}),
  /**
   * Props applied on HTML input element
   */
  inputProps: PropTypes.shape({}),
  /**
   * Props applied on InputLabel component
   */
  FormFieldHelperTextProps: PropTypes.shape({})
};

function ownKeys$2(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$2(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2(Object(t), !0).forEach(function (r) { _defineProperty$1(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var DEFAULT_THEME = styles.marketplace;
var ThemeProvider = function ThemeProvider(_ref) {
  var theme = _ref.theme,
    children = _ref.children;
  return /*#__PURE__*/React__default.createElement(ThemeProvider$1, {
    theme: _objectSpread$2(_objectSpread$2({}, DEFAULT_THEME), styles[theme])
  }, children);
};
ThemeProvider.propTypes = {
  theme: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired
};
ThemeProvider.defaultProps = {
  theme: ''
};

var _templateObject$2, _templateObject2$2, _templateObject3$2, _templateObject4$2, _templateObject5$2, _templateObject6$2, _templateObject7$1, _templateObject8$1, _templateObject9$1, _templateObject10$1;
var AVAILABLE_SWITCH_SIZES = {
  small: {
    container: css(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n      height: ", ";\n      width: ", ";\n    "])), function (_ref) {
      var theme = _ref.theme;
      return theme.spacing(2);
    }, function (_ref2) {
      var theme = _ref2.theme;
      return theme.spacing(3.5);
    }),
    toggler: css(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral(["\n      height: ", ";\n      width: ", ";\n    "])), function (_ref3) {
      var theme = _ref3.theme;
      return theme.spacing(1);
    }, function (_ref4) {
      var theme = _ref4.theme;
      return theme.spacing(1);
    })
  },
  regular: {
    container: css(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteral(["\n      height: ", ";\n      width: ", ";\n    "])), function (_ref5) {
      var theme = _ref5.theme;
      return theme.spacing(2.5);
    }, function (_ref6) {
      var theme = _ref6.theme;
      return theme.toRem(38);
    }),
    toggler: css(_templateObject4$2 || (_templateObject4$2 = _taggedTemplateLiteral(["\n      height: ", ";\n      width: ", ";\n    "])), function (_ref7) {
      var theme = _ref7.theme;
      return theme.spacing(1.5);
    }, function (_ref8) {
      var theme = _ref8.theme;
      return theme.spacing(1.5);
    })
  },
  big: {
    container: css(_templateObject5$2 || (_templateObject5$2 = _taggedTemplateLiteral(["\n      height: ", ";\n      width: ", ";\n    "])), function (_ref9) {
      var theme = _ref9.theme;
      return theme.spacing(3);
    }, function (_ref10) {
      var theme = _ref10.theme;
      return theme.spacing(6);
    }),
    toggler: css(_templateObject6$2 || (_templateObject6$2 = _taggedTemplateLiteral(["\n      height: ", ";\n      width: ", ";\n    "])), function (_ref11) {
      var theme = _ref11.theme;
      return theme.spacing(2);
    }, function (_ref12) {
      var theme = _ref12.theme;
      return theme.spacing(2);
    })
  }
};
var AVAILABLE_LABEL_POSITIONS = {
  top: 'column',
  bottom: 'column-reverse',
  left: 'row',
  right: 'row-reverse'
};
var StyledToggle = styled.div(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  flex-direction: ", ";\n  gap: ", ";\n  width: fit-content;\n\n  > label:first-of-type {\n    ", "\n    white-space: nowrap;\n\n    &:hover {\n      + label > input:disabled + span {\n        box-shadow: none;\n      }\n    }\n  }\n"])), function (_ref13) {
  var labelPosition = _ref13.labelPosition;
  return AVAILABLE_LABEL_POSITIONS[labelPosition];
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.spacing(1);
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.typography.font();
});
var SwitchContainer = styled.label(_templateObject8$1 || (_templateObject8$1 = _taggedTemplateLiteral(["\n  ", ";\n  display: inline-block;\n  flex-shrink: 0;\n  position: relative;\n\n  input {\n    transform: scale(0);\n\n    &:active + span {\n      box-shadow: 0 0 0 0.25rem rgba(", ",\n      0.5);\n    }\n\n    &:checked + span {\n      background-color: ", ";\n    }\n\n    &:disabled + span {\n      background-color: rgba(", ", 0.5);\n\n      &:hover {\n        cursor: default;\n        box-shadow: none;\n      }\n\n      ", "\n    }\n\n    &:focus + span {\n      &::before {\n        box-shadow: inset 0 0 0 0.15rem ", ";\n        border: none;\n      }\n    }\n\n    &:hover + span {\n      box-shadow: 0 0 0 0.25rem rgba(", ", 0.5);\n    }\n\n    & + span:before {\n      ", ";\n    }\n\n    &:checked + span::before {\n      transform: translateX(150%);\n    }\n  }\n"])), function (_ref16) {
  var size = _ref16.size;
  return AVAILABLE_SWITCH_SIZES[size].container;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.getRgbColor(theme.palette.info.main);
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.palette.info.main;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.getRgbColor(theme.palette.grayD);
}, function (_ref20) {
  var disabledChecked = _ref20.disabledChecked;
  return disabledChecked && css(_templateObject9$1 || (_templateObject9$1 = _taggedTemplateLiteral(["\n        background-color: rgba(", ", 0.5);\n      "])), function (_ref21) {
    var theme = _ref21.theme;
    return theme.getRgbColor(theme.palette.info.main);
  });
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.palette.info.light;
}, function (_ref23) {
  var theme = _ref23.theme;
  return theme.getRgbColor(theme.palette.grayD);
}, function (_ref24) {
  var size = _ref24.size;
  return AVAILABLE_SWITCH_SIZES[size].toggler;
});
var Switch = styled.span(_templateObject10$1 || (_templateObject10$1 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: ", ";\n  cursor: pointer;\n  inset: 0;\n  padding: ", ";\n\n  &, &::before {\n    position: absolute;\n    transition: 0.4s;\n  }\n\n  &::before {\n    background-color: white;\n    border-radius: 50%;\n    content: '';\n  }\n"])), function (_ref25) {
  var theme = _ref25.theme;
  return theme.palette.grayE;
}, function (_ref26) {
  var theme = _ref26.theme;
  return theme.spacing(2);
}, function (_ref27) {
  var theme = _ref27.theme;
  return theme.spacing(0.5);
});

var Toggle = function Toggle(props) {
  var checked = props.checked,
    disabled = props.disabled,
    id = props.id,
    inputProps = props.inputProps,
    label = props.label,
    labelPosition = props.labelPosition,
    name = props.name,
    onBlur = props.onBlur,
    onChange = props.onChange,
    required = props.required,
    size = props.size;
  return /*#__PURE__*/React__default.createElement(StyledToggle, {
    labelPosition: labelPosition
  }, /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: Boolean(label)
  }, /*#__PURE__*/React__default.createElement("label", {
    htmlFor: id
  }, label)), /*#__PURE__*/React__default.createElement(SwitchContainer, {
    size: size,
    disabledChecked: disabled && checked
  }, /*#__PURE__*/React__default.createElement("input", _extends$3({
    type: "checkbox",
    id: id,
    name: name,
    required: required,
    disabled: disabled,
    checked: checked,
    onChange: onChange,
    onBlur: onBlur
  }, inputProps)), /*#__PURE__*/React__default.createElement(Switch, {
    size: size
  })));
};
Toggle.defaultProps = {
  checked: null,
  disabled: false,
  id: 'toggle-id',
  inputProps: {},
  label: null,
  labelPosition: 'left',
  name: '',
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  required: false,
  size: 'regular'
};
Toggle.propTypes = {
  /**
   * Define the dimensions of the toggle
   */
  size: PropTypes.oneOf(['small', 'regular', 'big']),
  /**
   * Id assigned to toggle. This id is also used to make accessible the label and helperText.
   */
  id: PropTypes.string,
  /**
   * The name of the toggle
   */
  name: PropTypes.string,
  /**
   * The label text of the toggle
   */
  label: PropTypes.string,
  /**
   * The label position for the toggle text
   */
  labelPosition: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
  /**
   * If true the toggle element would be required
   */
  required: PropTypes.bool,
  /**
   * Apply styles to the toggle to display it as unusable
   */
  disabled: PropTypes.bool,
  /**
   *  The checked is use when element is controlled
   */
  checked: PropTypes.bool,
  /**
   * Function to execute when the value has changed
   */
  onChange: PropTypes.func,
  /**
   * Function to execute when input is blurred
   */
  onBlur: PropTypes.func,
  /**
   * Props applied on HTML input element
   */
  inputProps: PropTypes.shape({})
};

function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) { _defineProperty$1(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var M = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    unit: "px"
  },
  f = function f(s, t, e) {
    return Math.min(Math.max(s, t), e);
  },
  S = function S() {
    for (var _len = arguments.length, s = new Array(_len), _key = 0; _key < _len; _key++) {
      s[_key] = arguments[_key];
    }
    return s.filter(function (t) {
      return t && typeof t == "string";
    }).join(" ");
  },
  P = function P(s, t) {
    return s === t || s.width === t.width && s.height === t.height && s.x === t.x && s.y === t.y && s.unit === t.unit;
  };
function H(s, t, e, o) {
  var i = y(s, e, o);
  return s.width && (i.height = i.width / t), s.height && (i.width = i.height * t), i.y + i.height > o && (i.height = o - i.y, i.width = i.height * t), i.x + i.width > e && (i.width = e - i.x, i.height = i.width / t), s.unit === "%" ? D(i, e, o) : i;
}
function N(s, t, e) {
  var o = y(s, t, e);
  return o.x = (t - o.width) / 2, o.y = (e - o.height) / 2, s.unit === "%" ? D(o, t, e) : o;
}
function D(s, t, e) {
  return s.unit === "%" ? _objectSpread$1(_objectSpread$1(_objectSpread$1({}, M), s), {}, {
    unit: "%"
  }) : {
    unit: "%",
    x: s.x ? s.x / t * 100 : 0,
    y: s.y ? s.y / e * 100 : 0,
    width: s.width ? s.width / t * 100 : 0,
    height: s.height ? s.height / e * 100 : 0
  };
}
function y(s, t, e) {
  return s.unit ? s.unit === "px" ? _objectSpread$1(_objectSpread$1(_objectSpread$1({}, M), s), {}, {
    unit: "px"
  }) : {
    unit: "px",
    x: s.x ? s.x * t / 100 : 0,
    y: s.y ? s.y * e / 100 : 0,
    width: s.width ? s.width * t / 100 : 0,
    height: s.height ? s.height * e / 100 : 0
  } : _objectSpread$1(_objectSpread$1(_objectSpread$1({}, M), s), {}, {
    unit: "px"
  });
}
function X(s, t, e, o, i) {
  var n = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
  var a = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
  var w = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : o;
  var h = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : i;
  var r = _objectSpread$1({}, s);
  var c = Math.min(n, o),
    d = Math.min(a, i),
    p = Math.min(w, o),
    l = Math.min(h, i);
  t && (t > 1 ? (c = a ? a * t : c, d = c / t, p = w * t) : (d = n ? n / t : d, c = d * t, l = h / t)), r.y < 0 && (r.height = Math.max(r.height + r.y, d), r.y = 0), r.x < 0 && (r.width = Math.max(r.width + r.x, c), r.x = 0);
  var u = o - (r.x + r.width);
  u < 0 && (r.x = Math.min(r.x, o - c), r.width += u);
  var C = i - (r.y + r.height);
  if (C < 0 && (r.y = Math.min(r.y, i - d), r.height += C), r.width < c && ((e === "sw" || e == "nw") && (r.x -= c - r.width), r.width = c), r.height < d && ((e === "nw" || e == "ne") && (r.y -= d - r.height), r.height = d), r.width > p && ((e === "sw" || e == "nw") && (r.x -= p - r.width), r.width = p), r.height > l && ((e === "nw" || e == "ne") && (r.y -= l - r.height), r.height = l), t) {
    var R = r.width / r.height;
    if (R < t) {
      var x = Math.max(r.width / t, d);
      (e === "nw" || e == "ne") && (r.y -= x - r.height), r.height = x;
    } else if (R > t) {
      var _x = Math.max(r.height * t, c);
      (e === "sw" || e == "nw") && (r.x -= _x - r.width), r.width = _x;
    }
  }
  return r;
}
function K(s, t, e, o) {
  var i = _objectSpread$1({}, s);
  return t === "ArrowLeft" ? o === "nw" ? (i.x -= e, i.y -= e, i.width += e, i.height += e) : o === "w" ? (i.x -= e, i.width += e) : o === "sw" ? (i.x -= e, i.width += e, i.height += e) : o === "ne" ? (i.y += e, i.width -= e, i.height -= e) : o === "e" ? i.width -= e : o === "se" && (i.width -= e, i.height -= e) : t === "ArrowRight" && (o === "nw" ? (i.x += e, i.y += e, i.width -= e, i.height -= e) : o === "w" ? (i.x += e, i.width -= e) : o === "sw" ? (i.x += e, i.width -= e, i.height -= e) : o === "ne" ? (i.y -= e, i.width += e, i.height += e) : o === "e" ? i.width += e : o === "se" && (i.width += e, i.height += e)), t === "ArrowUp" ? o === "nw" ? (i.x -= e, i.y -= e, i.width += e, i.height += e) : o === "n" ? (i.y -= e, i.height += e) : o === "ne" ? (i.y -= e, i.width += e, i.height += e) : o === "sw" ? (i.x += e, i.width -= e, i.height -= e) : o === "s" ? i.height -= e : o === "se" && (i.width -= e, i.height -= e) : t === "ArrowDown" && (o === "nw" ? (i.x += e, i.y += e, i.width -= e, i.height -= e) : o === "n" ? (i.y += e, i.height -= e) : o === "ne" ? (i.y += e, i.width -= e, i.height -= e) : o === "sw" ? (i.x -= e, i.width += e, i.height += e) : o === "s" ? i.height += e : o === "se" && (i.width += e, i.height += e)), i;
}
var b = {
    capture: !0,
    passive: !1
  },
  v = /*#__PURE__*/function (_E) {
    _inherits(m, _E);
    function m() {
      var _this;
      _classCallCheck(this, m);
      _this = _callSuper(this, m, arguments), _this.docMoveBound = !1, _this.mouseDownOnCrop = !1, _this.dragStarted = !1, _this.evData = {
        startClientX: 0,
        startClientY: 0,
        startCropX: 0,
        startCropY: 0,
        clientX: 0,
        clientY: 0,
        isResize: !0
      }, _this.componentRef = /*#__PURE__*/createRef(), _this.mediaRef = /*#__PURE__*/createRef(), _this.initChangeCalled = !1, _this.state = {
        cropIsActive: !1,
        newCropIsBeingDrawn: !1
      }, _this.onCropPointerDown = function (t) {
        var _this$props = _this.props,
          e = _this$props.crop,
          o = _this$props.disabled,
          i = _this.getBox();
        if (!e) return;
        var n = y(e, i.width, i.height);
        if (o) return;
        t.cancelable && t.preventDefault(), _this.bindDocMove(), _this.componentRef.current.focus({
          preventScroll: !0
        });
        var a = t.target.dataset.ord,
          w = !!a;
        var h = t.clientX,
          r = t.clientY,
          c = n.x,
          d = n.y;
        if (a) {
          var p = t.clientX - i.x,
            l = t.clientY - i.y;
          var u = 0,
            C = 0;
          a === "ne" || a == "e" ? (u = p - (n.x + n.width), C = l - n.y, c = n.x, d = n.y + n.height) : a === "se" || a === "s" ? (u = p - (n.x + n.width), C = l - (n.y + n.height), c = n.x, d = n.y) : a === "sw" || a == "w" ? (u = p - n.x, C = l - (n.y + n.height), c = n.x + n.width, d = n.y) : (a === "nw" || a == "n") && (u = p - n.x, C = l - n.y, c = n.x + n.width, d = n.y + n.height), h = c + i.x + u, r = d + i.y + C;
        }
        _this.evData = {
          startClientX: h,
          startClientY: r,
          startCropX: c,
          startCropY: d,
          clientX: t.clientX,
          clientY: t.clientY,
          isResize: w,
          ord: a
        }, _this.mouseDownOnCrop = !0, _this.setState({
          cropIsActive: !0
        });
      }, _this.onComponentPointerDown = function (t) {
        var _this$props2 = _this.props,
          e = _this$props2.crop,
          o = _this$props2.disabled,
          i = _this$props2.locked,
          n = _this$props2.keepSelection,
          a = _this$props2.onChange,
          w = _this.getBox();
        if (o || i || n && e) return;
        t.cancelable && t.preventDefault(), _this.bindDocMove(), _this.componentRef.current.focus({
          preventScroll: !0
        });
        var h = t.clientX - w.x,
          r = t.clientY - w.y,
          c = {
            unit: "px",
            x: h,
            y: r,
            width: 0,
            height: 0
          };
        _this.evData = {
          startClientX: t.clientX,
          startClientY: t.clientY,
          startCropX: h,
          startCropY: r,
          clientX: t.clientX,
          clientY: t.clientY,
          isResize: !0
        }, _this.mouseDownOnCrop = !0, a(y(c, w.width, w.height), D(c, w.width, w.height)), _this.setState({
          cropIsActive: !0,
          newCropIsBeingDrawn: !0
        });
      }, _this.onDocPointerMove = function (t) {
        var _this$props3 = _this.props,
          e = _this$props3.crop,
          o = _this$props3.disabled,
          i = _this$props3.onChange,
          n = _this$props3.onDragStart,
          a = _this.getBox();
        if (o || !e || !_this.mouseDownOnCrop) return;
        t.cancelable && t.preventDefault(), _this.dragStarted || (_this.dragStarted = !0, n && n(t));
        var _assertThisInitialize = _assertThisInitialized(_this),
          w = _assertThisInitialize.evData;
        w.clientX = t.clientX, w.clientY = t.clientY;
        var h;
        w.isResize ? h = _this.resizeCrop() : h = _this.dragCrop(), P(e, h) || i(y(h, a.width, a.height), D(h, a.width, a.height));
      }, _this.onComponentKeyDown = function (t) {
        var _this$props4 = _this.props,
          e = _this$props4.crop,
          o = _this$props4.disabled,
          i = _this$props4.onChange,
          n = _this$props4.onComplete;
        if (o) return;
        var a = t.key;
        var w = !1;
        if (!e) return;
        var h = _this.getBox(),
          r = _this.makePixelCrop(h),
          d = (navigator.platform.match("Mac") ? t.metaKey : t.ctrlKey) ? m.nudgeStepLarge : t.shiftKey ? m.nudgeStepMedium : m.nudgeStep;
        if (a === "ArrowLeft" ? (r.x -= d, w = !0) : a === "ArrowRight" ? (r.x += d, w = !0) : a === "ArrowUp" ? (r.y -= d, w = !0) : a === "ArrowDown" && (r.y += d, w = !0), w) {
          t.cancelable && t.preventDefault(), r.x = f(r.x, 0, h.width - r.width), r.y = f(r.y, 0, h.height - r.height);
          var p = y(r, h.width, h.height),
            l = D(r, h.width, h.height);
          i(p, l), n && n(p, l);
        }
      }, _this.onHandlerKeyDown = function (t, e) {
        var _this$props5 = _this.props,
          _this$props5$aspect = _this$props5.aspect,
          o = _this$props5$aspect === void 0 ? 0 : _this$props5$aspect,
          i = _this$props5.crop,
          n = _this$props5.disabled,
          _this$props5$minWidth = _this$props5.minWidth,
          a = _this$props5$minWidth === void 0 ? 0 : _this$props5$minWidth,
          _this$props5$minHeigh = _this$props5.minHeight,
          w = _this$props5$minHeigh === void 0 ? 0 : _this$props5$minHeigh,
          h = _this$props5.maxWidth,
          r = _this$props5.maxHeight,
          c = _this$props5.onChange,
          d = _this$props5.onComplete,
          p = _this.getBox();
        if (n || !i) return;
        if (t.key === "ArrowUp" || t.key === "ArrowDown" || t.key === "ArrowLeft" || t.key === "ArrowRight") t.stopPropagation(), t.preventDefault();else return;
        var u = (navigator.platform.match("Mac") ? t.metaKey : t.ctrlKey) ? m.nudgeStepLarge : t.shiftKey ? m.nudgeStepMedium : m.nudgeStep,
          C = y(i, p.width, p.height),
          R = K(C, t.key, u, e),
          x = X(R, o, e, p.width, p.height, a, w, h, r);
        if (!P(i, x)) {
          var Y = D(x, p.width, p.height);
          c(x, Y), d && d(x, Y);
        }
      }, _this.onDocPointerDone = function (t) {
        var _this$props6 = _this.props,
          e = _this$props6.crop,
          o = _this$props6.disabled,
          i = _this$props6.onComplete,
          n = _this$props6.onDragEnd,
          a = _this.getBox();
        _this.unbindDocMove(), !(o || !e) && _this.mouseDownOnCrop && (_this.mouseDownOnCrop = !1, _this.dragStarted = !1, n && n(t), i && i(y(e, a.width, a.height), D(e, a.width, a.height)), _this.setState({
          cropIsActive: !1,
          newCropIsBeingDrawn: !1
        }));
      }, _this.onDragFocus = function (t) {
        var e;
        (e = _this.componentRef.current) == null || e.scrollTo(0, 0);
      };
      return _this;
    }
    _createClass(m, [{
      key: "document",
      get: function get() {
        return document;
      }
      // We unfortunately get the bounding box every time as x+y changes
      // due to scrolling.
    }, {
      key: "getBox",
      value: function getBox() {
        var t = this.mediaRef.current;
        if (!t) return {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
        var _t$getBoundingClientR = t.getBoundingClientRect(),
          e = _t$getBoundingClientR.x,
          o = _t$getBoundingClientR.y,
          i = _t$getBoundingClientR.width,
          n = _t$getBoundingClientR.height;
        return {
          x: e,
          y: o,
          width: i,
          height: n
        };
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(t) {
        var _this$props7 = this.props,
          e = _this$props7.crop,
          o = _this$props7.onComplete;
        if (o && !t.crop && e) {
          var _this$getBox = this.getBox(),
            i = _this$getBox.width,
            n = _this$getBox.height;
          i && n && o(y(e, i, n), D(e, i, n));
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.resizeObserver && this.resizeObserver.disconnect();
      }
    }, {
      key: "bindDocMove",
      value: function bindDocMove() {
        this.docMoveBound || (this.document.addEventListener("pointermove", this.onDocPointerMove, b), this.document.addEventListener("pointerup", this.onDocPointerDone, b), this.document.addEventListener("pointercancel", this.onDocPointerDone, b), this.docMoveBound = !0);
      }
    }, {
      key: "unbindDocMove",
      value: function unbindDocMove() {
        this.docMoveBound && (this.document.removeEventListener("pointermove", this.onDocPointerMove, b), this.document.removeEventListener("pointerup", this.onDocPointerDone, b), this.document.removeEventListener("pointercancel", this.onDocPointerDone, b), this.docMoveBound = !1);
      }
    }, {
      key: "getCropStyle",
      value: function getCropStyle() {
        var t = this.props.crop;
        if (t) return {
          top: "".concat(t.y).concat(t.unit),
          left: "".concat(t.x).concat(t.unit),
          width: "".concat(t.width).concat(t.unit),
          height: "".concat(t.height).concat(t.unit)
        };
      }
    }, {
      key: "dragCrop",
      value: function dragCrop() {
        var t = this.evData,
          e = this.getBox(),
          o = this.makePixelCrop(e),
          i = t.clientX - t.startClientX,
          n = t.clientY - t.startClientY;
        return o.x = f(t.startCropX + i, 0, e.width - o.width), o.y = f(t.startCropY + n, 0, e.height - o.height), o;
      }
    }, {
      key: "getPointRegion",
      value: function getPointRegion(t, e, o, i) {
        var n = this.evData,
          a = n.clientX - t.x,
          w = n.clientY - t.y;
        var h;
        i && e ? h = e === "nw" || e === "n" || e === "ne" : h = w < n.startCropY;
        var r;
        return o && e ? r = e === "nw" || e === "w" || e === "sw" : r = a < n.startCropX, r ? h ? "nw" : "sw" : h ? "ne" : "se";
      }
    }, {
      key: "resolveMinDimensions",
      value: function resolveMinDimensions(t, e) {
        var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        var n = Math.min(o, t.width),
          a = Math.min(i, t.height);
        return !e || !n && !a ? [n, a] : e > 1 ? n ? [n, n / e] : [a * e, a] : a ? [a * e, a] : [n, n / e];
      }
    }, {
      key: "resizeCrop",
      value: function resizeCrop() {
        var t = this.evData,
          _this$props8 = this.props,
          _this$props8$aspect = _this$props8.aspect,
          e = _this$props8$aspect === void 0 ? 0 : _this$props8$aspect,
          o = _this$props8.maxWidth,
          i = _this$props8.maxHeight,
          n = this.getBox(),
          _this$resolveMinDimen = this.resolveMinDimensions(n, e, this.props.minWidth, this.props.minHeight),
          _this$resolveMinDimen2 = _slicedToArray(_this$resolveMinDimen, 2),
          a = _this$resolveMinDimen2[0],
          w = _this$resolveMinDimen2[1];
        var h = this.makePixelCrop(n),
          r = this.getPointRegion(n, t.ord, a, w);
        var c = t.ord || r;
        var d = t.clientX - t.startClientX,
          p = t.clientY - t.startClientY;
        (a && c === "nw" || c === "w" || c === "sw") && (d = Math.min(d, -a)), (w && c === "nw" || c === "n" || c === "ne") && (p = Math.min(p, -w));
        var l = {
          unit: "px",
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
        r === "ne" ? (l.x = t.startCropX, l.width = d, e ? (l.height = l.width / e, l.y = t.startCropY - l.height) : (l.height = Math.abs(p), l.y = t.startCropY - l.height)) : r === "se" ? (l.x = t.startCropX, l.y = t.startCropY, l.width = d, e ? l.height = l.width / e : l.height = p) : r === "sw" ? (l.x = t.startCropX + d, l.y = t.startCropY, l.width = Math.abs(d), e ? l.height = l.width / e : l.height = p) : r === "nw" && (l.x = t.startCropX + d, l.width = Math.abs(d), e ? (l.height = l.width / e, l.y = t.startCropY - l.height) : (l.height = Math.abs(p), l.y = t.startCropY + p));
        var u = X(l, e, r, n.width, n.height, a, w, o, i);
        return e || m.xyOrds.indexOf(c) > -1 ? h = u : m.xOrds.indexOf(c) > -1 ? (h.x = u.x, h.width = u.width) : m.yOrds.indexOf(c) > -1 && (h.y = u.y, h.height = u.height), h.x = f(h.x, 0, n.width - h.width), h.y = f(h.y, 0, n.height - h.height), h;
      }
    }, {
      key: "createCropSelection",
      value: function createCropSelection() {
        var _this2 = this;
        var _this$props9 = this.props,
          _this$props9$ariaLabe = _this$props9.ariaLabels,
          t = _this$props9$ariaLabe === void 0 ? m.defaultProps.ariaLabels : _this$props9$ariaLabe,
          e = _this$props9.disabled,
          o = _this$props9.locked,
          i = _this$props9.renderSelectionAddon,
          n = _this$props9.ruleOfThirds,
          a = _this$props9.crop,
          w = this.getCropStyle();
        if (a) return /* @__PURE__ */React__default.createElement("div", {
          style: w,
          className: "ReactCrop__crop-selection",
          onPointerDown: this.onCropPointerDown,
          "aria-label": t.cropArea,
          tabIndex: 0,
          onKeyDown: this.onComponentKeyDown,
          role: "group"
        }, !e && !o && /* @__PURE__ */React__default.createElement("div", {
          className: "ReactCrop__drag-elements",
          onFocus: this.onDragFocus
        }, /* @__PURE__ */React__default.createElement("div", {
          className: "ReactCrop__drag-bar ord-n",
          "data-ord": "n"
        }), /* @__PURE__ */React__default.createElement("div", {
          className: "ReactCrop__drag-bar ord-e",
          "data-ord": "e"
        }), /* @__PURE__ */React__default.createElement("div", {
          className: "ReactCrop__drag-bar ord-s",
          "data-ord": "s"
        }), /* @__PURE__ */React__default.createElement("div", {
          className: "ReactCrop__drag-bar ord-w",
          "data-ord": "w"
        }), /* @__PURE__ */React__default.createElement("div", {
          className: "ReactCrop__drag-handle ord-nw",
          "data-ord": "nw",
          tabIndex: 0,
          "aria-label": t.nwDragHandle,
          onKeyDown: function onKeyDown(h) {
            return _this2.onHandlerKeyDown(h, "nw");
          },
          role: "button"
        }), /* @__PURE__ */React__default.createElement("div", {
          className: "ReactCrop__drag-handle ord-n",
          "data-ord": "n",
          tabIndex: 0,
          "aria-label": t.nDragHandle,
          onKeyDown: function onKeyDown(h) {
            return _this2.onHandlerKeyDown(h, "n");
          },
          role: "button"
        }), /* @__PURE__ */React__default.createElement("div", {
          className: "ReactCrop__drag-handle ord-ne",
          "data-ord": "ne",
          tabIndex: 0,
          "aria-label": t.neDragHandle,
          onKeyDown: function onKeyDown(h) {
            return _this2.onHandlerKeyDown(h, "ne");
          },
          role: "button"
        }), /* @__PURE__ */React__default.createElement("div", {
          className: "ReactCrop__drag-handle ord-e",
          "data-ord": "e",
          tabIndex: 0,
          "aria-label": t.eDragHandle,
          onKeyDown: function onKeyDown(h) {
            return _this2.onHandlerKeyDown(h, "e");
          },
          role: "button"
        }), /* @__PURE__ */React__default.createElement("div", {
          className: "ReactCrop__drag-handle ord-se",
          "data-ord": "se",
          tabIndex: 0,
          "aria-label": t.seDragHandle,
          onKeyDown: function onKeyDown(h) {
            return _this2.onHandlerKeyDown(h, "se");
          },
          role: "button"
        }), /* @__PURE__ */React__default.createElement("div", {
          className: "ReactCrop__drag-handle ord-s",
          "data-ord": "s",
          tabIndex: 0,
          "aria-label": t.sDragHandle,
          onKeyDown: function onKeyDown(h) {
            return _this2.onHandlerKeyDown(h, "s");
          },
          role: "button"
        }), /* @__PURE__ */React__default.createElement("div", {
          className: "ReactCrop__drag-handle ord-sw",
          "data-ord": "sw",
          tabIndex: 0,
          "aria-label": t.swDragHandle,
          onKeyDown: function onKeyDown(h) {
            return _this2.onHandlerKeyDown(h, "sw");
          },
          role: "button"
        }), /* @__PURE__ */React__default.createElement("div", {
          className: "ReactCrop__drag-handle ord-w",
          "data-ord": "w",
          tabIndex: 0,
          "aria-label": t.wDragHandle,
          onKeyDown: function onKeyDown(h) {
            return _this2.onHandlerKeyDown(h, "w");
          },
          role: "button"
        })), i && /* @__PURE__ */React__default.createElement("div", {
          className: "ReactCrop__selection-addon",
          onMouseDown: function onMouseDown(h) {
            return h.stopPropagation();
          }
        }, i(this.state)), n && /* @__PURE__ */React__default.createElement(React__default.Fragment, null, /* @__PURE__ */React__default.createElement("div", {
          className: "ReactCrop__rule-of-thirds-hz"
        }), /* @__PURE__ */React__default.createElement("div", {
          className: "ReactCrop__rule-of-thirds-vt"
        })));
      }
    }, {
      key: "makePixelCrop",
      value: function makePixelCrop(t) {
        var e = _objectSpread$1(_objectSpread$1({}, M), this.props.crop || {});
        return y(e, t.width, t.height);
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props10 = this.props,
          t = _this$props10.aspect,
          e = _this$props10.children,
          o = _this$props10.circularCrop,
          i = _this$props10.className,
          n = _this$props10.crop,
          a = _this$props10.disabled,
          w = _this$props10.locked,
          h = _this$props10.style,
          r = _this$props10.ruleOfThirds,
          _this$state = this.state,
          c = _this$state.cropIsActive,
          d = _this$state.newCropIsBeingDrawn,
          p = n ? this.createCropSelection() : null,
          l = S("ReactCrop", i, c && "ReactCrop--active", a && "ReactCrop--disabled", w && "ReactCrop--locked", d && "ReactCrop--new-crop", n && t && "ReactCrop--fixed-aspect", n && o && "ReactCrop--circular-crop", n && r && "ReactCrop--rule-of-thirds", !this.dragStarted && n && !n.width && !n.height && "ReactCrop--invisible-crop", o && "ReactCrop--no-animate");
        return /* @__PURE__ */React__default.createElement("div", {
          ref: this.componentRef,
          className: l,
          style: h
        }, /* @__PURE__ */React__default.createElement("div", {
          ref: this.mediaRef,
          className: "ReactCrop__child-wrapper",
          onPointerDown: this.onComponentPointerDown
        }, e), p);
      }
    }]);
    return m;
  }(PureComponent);
v.xOrds = ["e", "w"];
v.yOrds = ["n", "s"];
v.xyOrds = ["nw", "ne", "se", "sw"];
v.nudgeStep = 1;
v.nudgeStepMedium = 10;
v.nudgeStepLarge = 100;
v.defaultProps = {
  ariaLabels: {
    cropArea: "Use the arrow keys to move the crop selection area",
    nwDragHandle: "Use the arrow keys to move the north west drag handle to change the crop selection area",
    nDragHandle: "Use the up and down arrow keys to move the north drag handle to change the crop selection area",
    neDragHandle: "Use the arrow keys to move the north east drag handle to change the crop selection area",
    eDragHandle: "Use the up and down arrow keys to move the east drag handle to change the crop selection area",
    seDragHandle: "Use the arrow keys to move the south east drag handle to change the crop selection area",
    sDragHandle: "Use the up and down arrow keys to move the south drag handle to change the crop selection area",
    swDragHandle: "Use the arrow keys to move the south west drag handle to change the crop selection area",
    wDragHandle: "Use the up and down arrow keys to move the west drag handle to change the crop selection area"
  }
};
var I = v;

/* eslint-disable no-param-reassign */
var TO_RADIANS = Math.PI / 180;
var canvasPreview = function canvasPreview(image, canvas, crop) {
  var rotate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var scale = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
  var ctx = canvas.getContext('2d');
  if (!ctx) {
    throw new Error('No 2d context');
  }
  var scaleX = image.naturalWidth / image.width;
  var scaleY = image.naturalHeight / image.height;
  // devicePixelRatio slightly increases sharpness on retina devices
  // at the expense of slightly slower render times and needing to
  // size the image back down if you want to download/upload and be
  // true to the images natural size.
  var pixelRatio = window.devicePixelRatio;
  // const pixelRatio = 1

  canvas.width = Math.floor(crop.width * scaleX * pixelRatio);
  canvas.height = Math.floor(crop.height * scaleY * pixelRatio);
  ctx.scale(pixelRatio, pixelRatio);
  ctx.imageSmoothingQuality = 'high';
  var cropX = crop.x * scaleX;
  var cropY = crop.y * scaleY;
  var rotateRads = rotate * TO_RADIANS;
  var centerX = image.naturalWidth / 2;
  var centerY = image.naturalHeight / 2;
  ctx.save();

  // 5) Move the crop origin to the canvas origin (0,0)
  ctx.translate(-cropX, -cropY);
  // 4) Move the origin to the center of the original position
  ctx.translate(centerX, centerY);
  // 3) Rotate around the origin
  ctx.rotate(rotateRads);
  // 2) Scale the image
  ctx.scale(scale, scale);
  // 1) Move the center of the image to the origin (0,0)
  ctx.translate(-centerX, -centerY);
  ctx.drawImage(image, 0, 0, image.naturalWidth, image.naturalHeight, 0, 0, image.naturalWidth, image.naturalHeight);
  ctx.restore();
};

var _templateObject$1, _templateObject2$1, _templateObject3$1, _templateObject4$1, _templateObject5$1, _templateObject6$1;
var RotateButtonsContainer = styled.div(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: ", ";\n  position: fixed;\n  top: ", ";\n\n  @media screen and (min-width: ", "px){\n    position: static;\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.spacing(5);
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.spacing(4);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.small;
});
var RotateButton = styled.button(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  transition: all 300ms ease;\n\n  &:active {\n    transform: scale(0.9);\n  }\n\n  > svg {\n    transform: scale(1.4);\n    fill: ", ";\n  }\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.palette.white;
});
var StyledImageCropper = styled.div(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n  align-items: center;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n  height: 100%;\n  inset: 0;\n  justify-content: center;\n  padding: ", ";\n  position: fixed;\n  z-index: ", ";\n\n  canvas {\n    display: none;\n  }\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.spacing(4);
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.spacing(2);
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.zIndex.modal;
});
var StyledImage = styled.img(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral(["\n  transition: all 300ms ease;\n\n  ", ";\n"])), function (_ref8) {
  var rotation = _ref8.rotation,
    aspect = _ref8.aspect;
  return css(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteral(["\n      transform: rotate(", "deg) scale(", ");\n    "])), rotation, aspect);
});
var StyledReactCrop = styled(I)(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteral(["\n  cursor: crosshair;\n  display: inline-block;\n  max-height: 60vh;\n  max-width: 100%;\n  overflow: hidden;\n  position: relative;\n  touch-action: none;\n\n  & *,\n  & *::before,\n  & *::after {\n    box-sizing: border-box;\n  }\n\n  .ReactCrop--disabled,\n  .ReactCrop--locked {\n    cursor: inherit;\n  }\n\n  .ReactCrop__child-wrapper {\n    max-height: inherit;\n  }\n\n  .ReactCrop__child-wrapper>img,\n  .ReactCrop__child-wrapper>video {\n    display: block;\n    max-width: 100%;\n    max-height: inherit;\n  }\n\n  .ReactCrop:not(.ReactCrop--disabled) .ReactCrop__child-wrapper>img,\n  .ReactCrop:not(.ReactCrop--disabled) .ReactCrop__child-wrapper>video {\n    touch-action: none;\n  }\n\n  .ReactCrop:not(.ReactCrop--disabled) .ReactCrop__crop-selection {\n    touch-action: none;\n  }\n\n  .ReactCrop__crop-selection {\n    position: absolute;\n    top: 0;\n    left: 0;\n    transform: translate3d(0, 0, 0);\n    cursor: move;\n    box-shadow: 0 0 0 9999em rgba(0, 0, 0, .5);\n    border: 3px dashed rgba(54, 204, 132, 1);\n  }\n\n  .ReactCrop--disabled .ReactCrop__crop-selection {\n    cursor: inherit;\n  }\n\n  .ReactCrop--circular-crop .ReactCrop__crop-selection {\n    border-radius: 50%;\n    box-shadow: 0px 0px 1px 1px #fff, 0 0 0 9999em rgba(0, 0, 0, .5);\n  }\n\n  .ReactCrop__crop-selection:focus {\n    outline: none;\n    border-color: blue;\n    border-style: solid;\n  }\n\n  .ReactCrop--invisible-crop .ReactCrop__crop-selection {\n    display: none;\n  }\n\n  .ReactCrop__rule-of-thirds-vt::before,\n  .ReactCrop__rule-of-thirds-vt::after,\n  .ReactCrop__rule-of-thirds-hz::before,\n  .ReactCrop__rule-of-thirds-hz::after {\n    content: \"\";\n    display: block;\n    position: absolute;\n    background-color: rgba(255, 255, 255, .4);\n  }\n\n  .ReactCrop__rule-of-thirds-vt::before,\n  .ReactCrop__rule-of-thirds-vt::after {\n    width: 1px;\n    height: 100%\n  }\n\n  .ReactCrop__rule-of-thirds-vt::before {\n    left: 33.3333%;\n    left: 33.3333333333%;\n  }\n\n  .ReactCrop__rule-of-thirds-vt::after {\n    left: 66.6666%;\n    left: 66.6666666667%;\n  }\n\n  .ReactCrop__rule-of-thirds-hz::before,\n  .ReactCrop__rule-of-thirds-hz::after {\n    width: 100%;\n    height: 1px;\n  }\n\n  .ReactCrop__rule-of-thirds-hz::before {\n    top: 33.3333%;\n    top: 33.3333333333%;\n  }\n\n  .ReactCrop__rule-of-thirds-hz::after {\n    top: 66.6666%;\n    top: 66.6666666667%;\n  }\n\n  .ReactCrop__drag-handle {\n    position: absolute;\n  }\n\n  .ReactCrop__drag-handle::after {\n    position: absolute;\n    content: \"\";\n    display: block;\n    width: 10px;\n    height: 10px;\n    background-color: white;\n    border: none;\n  }\n\n  .ReactCrop__drag-handle:focus::after {\n    border-color: blue;\n    background: #2dbfff;\n  }\n\n  .ord-nw {\n    top: 0;\n    left: 0;\n    margin-top: -5px;\n    margin-left: -5px;\n    cursor: nw-resize;\n  }\n\n  .ord-nw::after {\n    top: 0;\n    left: 0;\n  }\n\n  .ord-n {\n    top: 0;\n    left: 50%;\n    margin-top: -5px;\n    margin-left: -5px;\n    cursor: n-resize;\n  }\n\n  .ord-n::after {\n    top: 0;\n  }\n\n  .ord-ne {\n    top: 0;\n    right: 0;\n    margin-top: -5px;\n    margin-right: -5px;\n    cursor: ne-resize;\n  }\n\n  .ord-ne::after {\n    top: 0;\n    right: 0;\n  }\n\n  .ord-e {\n    top: 50%;\n    right: 0;\n    margin-top: -5px;\n    margin-right: -5px;\n    cursor: e-resize;\n  }\n\n  .ord-e::after {\n    right: 0;\n  }\n\n  .ord-se {\n    bottom: 0;\n    right: 0;\n    margin-bottom: -5px;\n    margin-right: -5px;\n    cursor: se-resize;\n  }\n\n  .ord-se::after {\n    bottom: 0;\n    right: 0\n  }\n\n  .ord-s {\n    bottom: 0;\n    left: 50%;\n    margin-bottom: -5px;\n    margin-left: -5px;\n    cursor: s-resize;\n  }\n\n  .ord-s::after {\n    bottom: 0;\n  }\n\n  .ord-sw {\n    bottom: 0;\n    left: 0;\n    margin-bottom: -5px;\n    margin-left: -5px;\n    cursor: sw-resize;\n  }\n\n  .ord-sw::after {\n    bottom: 0;\n    left: 0;\n  }\n\n  .ord-w {\n    top: 50%;\n    left: 0;\n    margin-top: -5px;\n    margin-left: -5px;\n    cursor: w-resize;\n  }\n\n  .ord-w::after {\n    left: 0;\n  }\n\n  .ReactCrop__disabled .ReactCrop__drag-handle {\n    cursor: inherit;\n  }\n\n  .ReactCrop__drag-bar {\n    position: absolute;\n  }\n\n  .ReactCrop__drag-bar.ord-n {\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 6px;\n    margin-top: -3px;\n  }\n\n  .ReactCrop__drag-bar.ord-e {\n    right: 0;\n    top: 0;\n    width: 6px;\n    height: 100%;\n    margin-right: -3px;\n  }\n\n  .ReactCrop__drag-bar.ord-s {\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 6px;\n    margin-bottom: -3px;\n  }\n\n  .ReactCrop__drag-bar.ord-w {\n    top: 0;\n    left: 0;\n    width: 6px;\n    height: 100%;\n    margin-left: -3px;\n  }\n\n  .ReactCrop--new-crop .ReactCrop__drag-bar,\n  .ReactCrop--new-crop .ReactCrop__drag-handle,\n  .ReactCrop--fixed-aspect .ReactCrop__drag-bar {\n    display: none;\n  }\n\n  .ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-n,\n  .ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-e,\n  .ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-s,\n  .ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-w {\n    display: none;\n  }\n\n  @media(pointer: coarse) {\n    .ord-n,\n    .ord-e,\n    .ord-s,\n    .ord-w {\n      display: none;\n    }\n\n    .ReactCrop__drag-handle {\n      width: 24px;\n      height: 24px;\n    }\n  }\n"])));

function centerAspectCrop(mediaWidth, mediaHeight, aspect) {
  return N(H({
    unit: '%',
    width: 90
  }, aspect, mediaWidth, mediaHeight), mediaWidth, mediaHeight);
}
var ImageCropper = function ImageCropper(props) {
  var _ref2, _imgRef$current2, _ref3, _imgRef$current3;
  var imgSource = props.imgSource,
    initialCrop = props.initialCrop,
    initialRotation = props.initialRotation,
    onClose = props.onClose,
    onFinish = props.onFinish;
  var canvasRefPreview = useRef(null);
  var imgRef = useRef(null);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    completedCrop = _useState2[0],
    setCompletedCrop = _useState2[1];
  var _useState3 = useState(initialCrop),
    _useState4 = _slicedToArray(_useState3, 2),
    crop = _useState4[0],
    setCrop = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    loading = _useState6[0],
    setLoading = _useState6[1];
  var _useState7 = useState(initialRotation),
    _useState8 = _slicedToArray(_useState7, 2),
    rotation = _useState8[0],
    setRotation = _useState8[1];
  var getCanvasAsImg = function getCanvasAsImg() {
    setLoading(true);
    var canvas = canvasRefPreview.current;
    canvas.toBlob(function (blob) {
      var data = new File([blob], 'cropped-img.jpg', {
        type: 'image/jpg'
      });
      setLoading(false);
      onFinish({
        area: crop,
        data: data,
        rotation: rotation
      });
    }, 'image/jpg', 1.0);
  };
  var handleAspectRatio = useMemo(function () {
    if (!imgRef.current) {
      return 1;
    }
    var _imgRef$current = imgRef.current,
      height = _imgRef$current.height,
      width = _imgRef$current.width;
    var fixedAxisRotation = Math.abs(rotation % 360);
    var isFlipped = fixedAxisRotation === 90 || fixedAxisRotation === 270;
    var aspectRatio = height > width ? width / height : height / width;
    return isFlipped ? aspectRatio : 1;
  }, [imgRef.current, rotation]);
  var onImageLoad = function onImageLoad(_ref) {
    var currentTarget = _ref.currentTarget;
    if (initialCrop) {
      return;
    }
    var width = currentTarget.width,
      height = currentTarget.height;
    setCrop(centerAspectCrop(width, height, 3 / 2));
  };
  useEffect(function () {
    if (completedCrop !== null && completedCrop !== void 0 && completedCrop.width && completedCrop !== null && completedCrop !== void 0 && completedCrop.height && imgRef.current && canvasRefPreview.current) {
      canvasPreview(imgRef.current, canvasRefPreview.current, completedCrop, rotation);
    }
  }, [completedCrop, rotation]);
  return /*#__PURE__*/React__default.createElement(StyledImageCropper, null, /*#__PURE__*/React__default.createElement(RotateButtonsContainer, null, /*#__PURE__*/React__default.createElement(RotateButton, {
    type: "button",
    onClick: function onClick() {
      return setRotation(function (prevAngle) {
        return prevAngle - 90;
      });
    }
  }, /*#__PURE__*/React__default.createElement(TurnLeftIcon$1, null)), /*#__PURE__*/React__default.createElement(RotateButton, {
    type: "button",
    onClick: function onClick() {
      return setRotation(function (prevAngle) {
        return prevAngle + 90;
      });
    }
  }, /*#__PURE__*/React__default.createElement(TurnLeftIcon, null))), /*#__PURE__*/React__default.createElement(StyledReactCrop, {
    crop: crop,
    minHeight: (_ref2 = (imgRef === null || imgRef === void 0 || (_imgRef$current2 = imgRef.current) === null || _imgRef$current2 === void 0 ? void 0 : _imgRef$current2.height) * 0.25) !== null && _ref2 !== void 0 ? _ref2 : 0,
    minWidth: (_ref3 = (imgRef === null || imgRef === void 0 || (_imgRef$current3 = imgRef.current) === null || _imgRef$current3 === void 0 ? void 0 : _imgRef$current3.width) * 0.25) !== null && _ref3 !== void 0 ? _ref3 : 0,
    onChange: function onChange(c) {
      return setCrop(c);
    },
    onComplete: function onComplete(c) {
      return setCompletedCrop(c);
    }
  }, /*#__PURE__*/React__default.createElement(StyledImage, {
    alt: "Imagen original",
    aspect: handleAspectRatio,
    onLoad: onImageLoad,
    ref: imgRef,
    rotation: rotation,
    src: imgSource
  })), /*#__PURE__*/React__default.createElement("canvas", {
    ref: canvasRefPreview
  }), /*#__PURE__*/React__default.createElement(AdaptiveArea, null, /*#__PURE__*/React__default.createElement(Button, {
    color: "secondary",
    disabled: loading,
    onClick: onClose
  }, "Cancelar"), /*#__PURE__*/React__default.createElement(Button, {
    disabled: !completedCrop || loading,
    isLoading: loading,
    onClick: getCanvasAsImg
  }, "Guardar")));
};
ImageCropper.propTypes = {
  imgSource: PropTypes.string.isRequired,
  initialCrop: PropTypes.shape({
    height: PropTypes.number.isRequired,
    unit: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired
  }),
  initialRotation: PropTypes.number,
  onClose: PropTypes.func.isRequired,
  onFinish: PropTypes.func.isRequired
};
ImageCropper.defaultProps = {
  initialCrop: null,
  initialRotation: 0
};

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;
var StyleUploader = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n  width: 100%;\n\n  input {\n    display: none;\n  }\n\n  @media screen and (min-width: ", "px) {\n    max-width: ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.form.font();
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.typography.font.color;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.spacing(0.5);
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.small;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.spacing(36);
});
var UploaderTitle = styled.p(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin: 0;\n  padding-bottom: ", ";\n"])), function (_ref6) {
  var theme = _ref6.theme;
  return theme.spacing(1);
});
var ButtonContent = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  align-content: center;\n  display: flex;\n\n  p {\n    margin: 0;\n    margin-left: ", ";\n  }\n\n  svg {\n    fill:", ";\n  }\n"])), function (_ref7) {
  var theme = _ref7.theme;
  return theme.spacing(1);
}, function (_ref8) {
  var disabled = _ref8.disabled,
    theme = _ref8.theme;
  return disabled ? theme.palette.grayG : theme.palette.white;
});
var FileDescription = styled.p(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n  margin-bottom: 0;\n"])), function (_ref9) {
  var theme = _ref9.theme;
  return theme.palette.grayG;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.spacing(1.5);
});
var FileName = styled.p(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  overflow: hidden;\n  width: 100%;\n\n  > span {\n    max-width: ", ";\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    width: min-content;\n  }\n"])), function (_ref11) {
  var theme = _ref11.theme;
  return theme.spacing(10);
});
var FileSummaryArea = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  align-items: center;\n  display: inline-flex;\n  gap: ", ";\n  justify-content: space-between;\n\n  > button {\n    min-width: auto;\n  }\n"])), function (_ref12) {
  var theme = _ref12.theme;
  return theme.spacing(2);
});
var FilePreview = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: ", ";\n  flex-shrink: 0;\n  height: ", ";\n  overflow: hidden;\n  width: ", ";\n\n  img {\n    cursor: pointer;\n    height: 100%;\n    object-fit: cover;\n    transition: all 300ms ease;\n    width: 100%;\n\n    &:hover {\n      transform: scale(1.2);\n    }\n  }\n"])), function (_ref13) {
  var theme = _ref13.theme;
  return theme.palette.grayC;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.borderRadius();
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.spacing(5);
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.spacing(5);
});
var ExtensionPlaceholder = styled.span(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  align-items: center;\n  background-color: ", ";\n  color: white;\n  display: flex;\n  flex-shrink: 0;\n  height: ", ";\n  justify-content: center;\n  text-transform: uppercase;\n  width: ", ";\n"])), function (_ref17) {
  var theme = _ref17.theme;
  return theme.palette.grayF;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.spacing(5);
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.spacing(5);
});
var CaptureFileButton = styled.button(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  height: ", ";\n  width:", ";\n\n  &:active {\n    transform: scale(0.9);\n  }\n\n  &:disabled {\n    pointer-events: none;\n  }\n\n  svg {\n    transform: scale(1.4);\n    stroke:  ", ";\n  }\n\n  @media screen and (min-width: ", "px) {\n    display: none;\n  }\n"])), function (_ref20) {
  var theme = _ref20.theme;
  return theme.spacing(5);
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.spacing(5);
}, function (_ref22) {
  var disabled = _ref22.disabled,
    theme = _ref22.theme;
  return disabled ? theme.palette.grayG : theme.palette.grayI;
}, function (_ref23) {
  var theme = _ref23.theme;
  return theme.breakpoints.small;
});
var UploadActionsArea = styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  gap: ", ";\n\n  &, > * {\n    transition: all 300ms ease;\n  }\n"])), function (_ref24) {
  var theme = _ref24.theme;
  return theme.spacing(1);
});

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty$1(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var FileSummary = function FileSummary(props) {
  var _currentFile$capture, _cropped$data;
  var currentFile = props.currentFile,
    disabled = props.disabled,
    focus = props.focus,
    handleSelectFile = props.handleSelectFile,
    setCurrentFile = props.setCurrentFile;
  var file = currentFile.file,
    cropped = currentFile.cropped;
  var _useState = useState((_currentFile$capture = currentFile.capture) !== null && _currentFile$capture !== void 0 ? _currentFile$capture : false),
    _useState2 = _slicedToArray(_useState, 2),
    resize = _useState2[0],
    setResize = _useState2[1];
  var lastIndexOfDot = file.name.lastIndexOf('.');
  var _ref = [file.name.slice(0, lastIndexOfDot), file.name.slice(lastIndexOfDot + 1)],
    fileName = _ref[0],
    extension = _ref[1];
  var isImage = file.type.includes('image');
  var handleCroppedImage = function handleCroppedImage(currentCropped) {
    setCurrentFile(function (previousFile) {
      return _objectSpread(_objectSpread({}, previousFile), {}, {
        currentCropped: currentCropped
      });
    });
    setResize(false);
  };
  var handleResize = function handleResize() {
    if (disabled) {
      return;
    }
    setResize(true);
  };
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(FileSummaryArea, null, /*#__PURE__*/React__default.createElement(FilePreview, null, /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: isImage
  }, /*#__PURE__*/React__default.createElement("img", {
    alt: "Vista previa de imagen",
    onClick: handleResize,
    src: URL.createObjectURL((_cropped$data = cropped === null || cropped === void 0 ? void 0 : cropped.data) !== null && _cropped$data !== void 0 ? _cropped$data : file)
  })), /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: !isImage
  }, /*#__PURE__*/React__default.createElement(ExtensionPlaceholder, {
    "aria-label": "file-extension"
  }, extension))), /*#__PURE__*/React__default.createElement(FileName, null, /*#__PURE__*/React__default.createElement("span", null, fileName), /*#__PURE__*/React__default.createElement("span", null, ".", extension)), /*#__PURE__*/React__default.createElement(Button, {
    autoFocus: focus,
    color: "secondary",
    disabled: disabled,
    onClick: handleSelectFile
  }, "Cambiar")), /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: Boolean(resize)
  }, /*#__PURE__*/React__default.createElement(ImageCropper, {
    imgSource: URL.createObjectURL(file),
    initialCrop: cropped === null || cropped === void 0 ? void 0 : cropped.area,
    initialRotation: cropped === null || cropped === void 0 ? void 0 : cropped.rotation,
    onClose: function onClose() {
      return setResize(false);
    },
    onFinish: handleCroppedImage
  })));
};
FileSummary.propTypes = {
  currentFile: PropTypes.shape({
    capture: PropTypes.bool,
    cropped: PropTypes.shape({
      area: PropTypes.shape({
        height: PropTypes.number.isRequired,
        unit: PropTypes.string.isRequired,
        width: PropTypes.number.isRequired,
        x: PropTypes.number.isRequired,
        y: PropTypes.number.isRequired
      }),
      data: PropTypes.instanceOf(File).isRequired,
      rotation: PropTypes.number
    }),
    file: PropTypes.instanceOf(File)
  }).isRequired,
  disabled: PropTypes.bool.isRequired,
  focus: PropTypes.bool.isRequired,
  handleSelectFile: PropTypes.func.isRequired,
  setCurrentFile: PropTypes.func.isRequired
};

var CameraIcon = function CameraIcon(props) {
  return /*#__PURE__*/React__default.createElement(SvgIcon, props, /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M16.9997 6.78596L15.5919 4.56163C15.2952 4.21577 14.8886 4 14.4327 4H9.56731C9.11144 4 8.70476 4.21577 8.40808 4.56163L7.00029 6.78596C6.70361 7.13236 6.32125 7.38462 5.86538 7.38462H2.69231C2.24348 7.38462 1.81303 7.56291 1.49567 7.88028C1.1783 8.19765 1 8.6281 1 9.07692V19.2308C1 19.6796 1.1783 20.11 1.49567 20.4274C1.81303 20.7448 2.24348 20.9231 2.69231 20.9231H21.3077C21.7565 20.9231 22.187 20.7448 22.5043 20.4274C22.8217 20.11 23 19.6796 23 19.2308V9.07692C23 8.6281 22.8217 8.19765 22.5043 7.88028C22.187 7.56291 21.7565 7.38462 21.3077 7.38462H18.1875C17.73 7.38462 17.2964 7.13236 16.9997 6.78596Z",
    strokeWidth: "1.5"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M12 17.5385C14.3366 17.5385 16.2308 15.6443 16.2308 13.3077C16.2308 10.9711 14.3366 9.07692 12 9.07692C9.66341 9.07692 7.76923 10.9711 7.76923 13.3077C7.76923 15.6443 9.66341 17.5385 12 17.5385Z",
    strokeWidth: "1.5"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M5.01923 7.27885V6.11539H3.75V7.27885",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var UploadActions = function UploadActions(props) {
  var disabled = props.disabled,
    focus = props.focus,
    handleCameraAccess = props.handleCameraAccess,
    handleSelectFile = props.handleSelectFile;
  return /*#__PURE__*/React__default.createElement(UploadActionsArea, null, /*#__PURE__*/React__default.createElement(Button, {
    autoFocus: focus,
    color: "info",
    disabled: disabled,
    onClick: handleSelectFile
  }, /*#__PURE__*/React__default.createElement(ButtonContent, {
    disabled: disabled
  }, /*#__PURE__*/React__default.createElement(UploadIcon, {
    padding: false,
    size: "small"
  }), /*#__PURE__*/React__default.createElement("p", null, "Selecciona un archivo"))), /*#__PURE__*/React__default.createElement(CaptureFileButton, {
    "aria-label": "capture",
    disabled: disabled,
    onClick: handleCameraAccess
  }, /*#__PURE__*/React__default.createElement(CameraIcon, {
    padding: false,
    size: "medium",
    fill: "black"
  })));
};
UploadActions.propTypes = {
  disabled: PropTypes.bool.isRequired,
  focus: PropTypes.bool.isRequired,
  handleCameraAccess: PropTypes.func.isRequired,
  handleSelectFile: PropTypes.func.isRequired
};

var _excluded = ["defaultValue", "disabled", "extensions", "focus", "id", "maxFileSize", "name", "onChange", "title"];
var MIN_FILE_SIZE = 0.000001;
var bytesToMegaBytes = function bytesToMegaBytes(bytes) {
  return bytes / Math.pow(1024, 2);
};
var Uploader = function Uploader(uploaderProps) {
  var defaultValue = uploaderProps.defaultValue,
    disabled = uploaderProps.disabled,
    extensions = uploaderProps.extensions,
    focus = uploaderProps.focus,
    id = uploaderProps.id,
    maxFileSize = uploaderProps.maxFileSize,
    name = uploaderProps.name,
    onChange = uploaderProps.onChange,
    title = uploaderProps.title,
    inputProps = _objectWithoutProperties(uploaderProps, _excluded);
  var inputFile = useRef(null);
  var _useState = useState({
      file: defaultValue,
      cropped: null
    }),
    _useState2 = _slicedToArray(_useState, 2),
    currentFile = _useState2[0],
    setCurrentFile = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    uploaderError = _useState4[0],
    setUploaderError = _useState4[1];
  var availableExtensions = "".concat(extensions.slice(0, -1).join(', '), " o ").concat(extensions.slice(-1));
  var handleChange = function handleChange(_ref) {
    var _inputFile$current$ca;
    var target = _ref.target;
    var files = target.files;
    var captured = (_inputFile$current$ca = inputFile.current.capture) !== null && _inputFile$current$ca !== void 0 ? _inputFile$current$ca : false;
    if (files.length > 0) {
      var file = files[0];
      setCurrentFile({
        file: file,
        cropped: null,
        captured: captured
      });
    }
  };
  var handleUploaderErrors = function handleUploaderErrors() {
    var _currentFile$file = currentFile.file,
      size = _currentFile$file.size,
      fileName = _currentFile$file.name;
    var lastIndexOfDot = fileName === null || fileName === void 0 ? void 0 : fileName.lastIndexOf('.');
    var _ref2 = [fileName.slice(0, lastIndexOfDot), fileName.slice(lastIndexOfDot + 1)],
      fileExtension = _ref2[1];
    var fileSize = bytesToMegaBytes(size);
    var errorMessage = null;
    if (!extensions.includes(".".concat(fileExtension))) {
      errorMessage = 'El formato del archivo es inválido';
    } else if (fileSize > maxFileSize) {
      errorMessage = 'El tamaño del archivo excede el máximo permitido';
    } else if (fileSize < MIN_FILE_SIZE) {
      errorMessage = 'No se pudo leer el contenido del archivo';
    }
    setUploaderError(errorMessage);
  };
  var handleSelectFile = function handleSelectFile() {
    inputFile.current.accept = extensions;
    inputFile.current.removeAttribute('capture');
    inputFile.current.click();
  };
  var handleCameraAccess = function handleCameraAccess() {
    inputFile.current.accept = 'image/*';
    inputFile.current.capture = true;
    inputFile.current.click();
  };
  var withUploaderProps = function withUploaderProps(Component, props) {
    return /*#__PURE__*/React__default.createElement(Component, _extends$3({
      disabled: disabled,
      focus: focus,
      handleSelectFile: handleSelectFile
    }, props));
  };
  useEffect(function () {
    if (currentFile.file) {
      handleUploaderErrors();
    }
    var cropped = currentFile.cropped,
      file = currentFile.file;
    var fileValue = cropped ? cropped.data : file;
    onChange({
      target: {
        value: uploaderError ? null : fileValue,
        name: name
      }
    });
  }, [currentFile, uploaderError]);
  return /*#__PURE__*/React__default.createElement(StyleUploader, null, /*#__PURE__*/React__default.createElement(UploaderTitle, null, title), /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: Boolean(currentFile.file)
  }, withUploaderProps(FileSummary, {
    currentFile: currentFile,
    setCurrentFile: setCurrentFile
  })), /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: Boolean(!currentFile.file)
  }, withUploaderProps(UploadActions, {
    handleCameraAccess: handleCameraAccess
  })), /*#__PURE__*/React__default.createElement("input", _extends$3({
    accept: extensions.join(', '),
    "aria-label": "file-input",
    id: id,
    name: name,
    onChange: handleChange,
    ref: inputFile,
    type: "file"
  }, inputProps)), /*#__PURE__*/React__default.createElement(FileDescription, null, "Archivos ".concat(availableExtensions, " (tama\xF1o m\xE1x. ").concat(maxFileSize, "MB)")), /*#__PURE__*/React__default.createElement(RenderIf, {
    condition: Boolean(uploaderError)
  }, /*#__PURE__*/React__default.createElement(FormFieldHelperText, {
    error: true
  }, uploaderError)));
};
Uploader.propTypes = {
  /**
   * File set as default value
   */
  defaultValue: PropTypes.instanceOf(File),
  /**
   * Apply styles to the button to display it as unusable and not clickable
   */
  disabled: PropTypes.bool,
  /**
   * Array of elements to be read
   */
  extensions: PropTypes.arrayOf(PropTypes.string),
  /**
   * Function to execute when input was required initial focus
   */
  focus: PropTypes.bool,
  /**
   * Id assigned to `Uploader`. This id is also used to make accessible the label and helperText.
  */
  id: PropTypes.string,
  /**
   * Max size of file to be upload
   */
  maxFileSize: PropTypes.number,
  /**
   * Name attribute of the `Uploader` element.
   */
  name: PropTypes.string,
  /**
   * Function to execute when input is blurred
   */
  onBlur: PropTypes.func,
  /**
   * Function to execute when the value has changed
   */
  onChange: PropTypes.func,
  /**
   * Name attribute of the `uploader` element.
    */
  title: PropTypes.string.isRequired
};
Uploader.defaultProps = {
  defaultValue: null,
  disabled: false,
  extensions: ['.png', '.jpg', '.jpeg', '.pdf'],
  focus: false,
  id: 'uploader-id',
  maxFileSize: 5,
  name: null,
  onBlur: function onBlur() {},
  onChange: function onChange() {}
};

export { ActionText, AdaptiveArea, Button, Callout, Card, CardActions, CardContent, CardHeader, CardImage, CardLeftContent, CheckBox, Chip, ChipGroup, CodeField, DataTable, DatePicker, DonutChart, HorizontalCard, IconButton, InputAdornment, InputLabel, Lightbox, LineChart, Link$1 as Link, MapGoogle, MobileStep, MobileStepActions, MobileStepContent, MobileStepHeader, MobileStepper, MobileStepperIndicator, Modal, OutsideClickHandler, RadioButton, RadioGroup, SelectField, SiderMenu, SiderMenuItem, SiderNav, NavItemDividerStyled as SiderNavDivider, SiderNavTitle, Step, StepActions, StepContent, StepHeader, Stepper, StepperIndicator, TextField, ThemeProvider, Toggle, Uploader };
//# sourceMappingURL=bricks-ui.esm.js.map
